
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3487"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3487"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2Qwp0", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $2129928c0bdc1efe$export$ffb0004e005737fa; }, function (v) { return $2129928c0bdc1efe$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $2129928c0bdc1efe$export$34b9dba7ce09269b; }, function (v) { return $2129928c0bdc1efe$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $2129928c0bdc1efe$export$25062201e9e25d76; }, function (v) { return $2129928c0bdc1efe$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2129928c0bdc1efe$export$ffb0004e005737fa;
var $2129928c0bdc1efe$export$34b9dba7ce09269b;
var $2129928c0bdc1efe$export$25062201e9e25d76;
"use strict";

var $gIfym = parcelRequire("gIfym");
var $2129928c0bdc1efe$var$k = Symbol.for("react.element"), $2129928c0bdc1efe$var$l = Symbol.for("react.fragment"), $2129928c0bdc1efe$var$m = Object.prototype.hasOwnProperty, $2129928c0bdc1efe$var$n = $gIfym.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $2129928c0bdc1efe$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $2129928c0bdc1efe$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$2129928c0bdc1efe$var$m.call(a, b) && !$2129928c0bdc1efe$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $2129928c0bdc1efe$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $2129928c0bdc1efe$var$n.current
    };
}
$2129928c0bdc1efe$export$ffb0004e005737fa = $2129928c0bdc1efe$var$l;
$2129928c0bdc1efe$export$34b9dba7ce09269b = $2129928c0bdc1efe$var$q;
$2129928c0bdc1efe$export$25062201e9e25d76 = $2129928c0bdc1efe$var$q;

});
parcelRegister("gIfym", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ga9lV"));

});
parcelRegister("ga9lV", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $bc44d5c582efa5c9$export$dca3b0875bd9a954; }, function (v) { return $bc44d5c582efa5c9$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $bc44d5c582efa5c9$export$16fa2f45be04daa8; }, function (v) { return $bc44d5c582efa5c9$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $bc44d5c582efa5c9$export$ffb0004e005737fa; }, function (v) { return $bc44d5c582efa5c9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $bc44d5c582efa5c9$export$e2c29f18771995cb; }, function (v) { return $bc44d5c582efa5c9$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $bc44d5c582efa5c9$export$221d75b3f55bb0bd; }, function (v) { return $bc44d5c582efa5c9$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bc44d5c582efa5c9$export$5f8d39834fd61797; }, function (v) { return $bc44d5c582efa5c9$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $bc44d5c582efa5c9$export$74bf444e3cd11ea5; }, function (v) { return $bc44d5c582efa5c9$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $bc44d5c582efa5c9$export$ae55be85d98224ed; }, function (v) { return $bc44d5c582efa5c9$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $bc44d5c582efa5c9$export$e530037191fcd5d7; }, function (v) { return $bc44d5c582efa5c9$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $bc44d5c582efa5c9$export$fd42f52fd3ae1109; }, function (v) { return $bc44d5c582efa5c9$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $bc44d5c582efa5c9$export$c8a8987d4410bf2d; }, function (v) { return $bc44d5c582efa5c9$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $bc44d5c582efa5c9$export$d38cd72104c1f0e9; }, function (v) { return $bc44d5c582efa5c9$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $bc44d5c582efa5c9$export$7d1e3a5e95ceca43; }, function (v) { return $bc44d5c582efa5c9$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $bc44d5c582efa5c9$export$257a8862b851cb5b; }, function (v) { return $bc44d5c582efa5c9$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $bc44d5c582efa5c9$export$a8257692ac88316c; }, function (v) { return $bc44d5c582efa5c9$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $bc44d5c582efa5c9$export$488013bae63b21da; }, function (v) { return $bc44d5c582efa5c9$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $bc44d5c582efa5c9$export$7c73462e0d25e514; }, function (v) { return $bc44d5c582efa5c9$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $bc44d5c582efa5c9$export$7568632d0d33d16d; }, function (v) { return $bc44d5c582efa5c9$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $bc44d5c582efa5c9$export$88948ce120ea2619; }, function (v) { return $bc44d5c582efa5c9$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $bc44d5c582efa5c9$export$35808ee640e87ca7; }, function (v) { return $bc44d5c582efa5c9$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $bc44d5c582efa5c9$export$fae74005e78b1a27; }, function (v) { return $bc44d5c582efa5c9$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $bc44d5c582efa5c9$export$dc8fbce3eb94dc1e; }, function (v) { return $bc44d5c582efa5c9$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $bc44d5c582efa5c9$export$6a7bc4e911dc01cf; }, function (v) { return $bc44d5c582efa5c9$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $bc44d5c582efa5c9$export$6d9c69b0de29b591; }, function (v) { return $bc44d5c582efa5c9$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $bc44d5c582efa5c9$export$f680877a34711e37; }, function (v) { return $bc44d5c582efa5c9$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $bc44d5c582efa5c9$export$d5a552a76deda3c2; }, function (v) { return $bc44d5c582efa5c9$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $bc44d5c582efa5c9$export$aaabe4eda9ed9969; }, function (v) { return $bc44d5c582efa5c9$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $bc44d5c582efa5c9$export$e5c5a5f917a5871c; }, function (v) { return $bc44d5c582efa5c9$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $bc44d5c582efa5c9$export$1538c33de8887b59; }, function (v) { return $bc44d5c582efa5c9$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $bc44d5c582efa5c9$export$13e3392192263954; }, function (v) { return $bc44d5c582efa5c9$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $bc44d5c582efa5c9$export$b8f5890fc79d6aca; }, function (v) { return $bc44d5c582efa5c9$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $bc44d5c582efa5c9$export$60241385465d0a34; }, function (v) { return $bc44d5c582efa5c9$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $bc44d5c582efa5c9$export$306c0aa65ff9ec16; }, function (v) { return $bc44d5c582efa5c9$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $bc44d5c582efa5c9$export$7b286972b8d8ccbf; }, function (v) { return $bc44d5c582efa5c9$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $bc44d5c582efa5c9$export$83d89fbfd8236492; }, function (v) { return $bc44d5c582efa5c9$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bc44d5c582efa5c9$export$dca3b0875bd9a954;
var $bc44d5c582efa5c9$export$16fa2f45be04daa8;
var $bc44d5c582efa5c9$export$ffb0004e005737fa;
var $bc44d5c582efa5c9$export$e2c29f18771995cb;
var $bc44d5c582efa5c9$export$221d75b3f55bb0bd;
var $bc44d5c582efa5c9$export$5f8d39834fd61797;
var $bc44d5c582efa5c9$export$74bf444e3cd11ea5;
var $bc44d5c582efa5c9$export$ae55be85d98224ed;
var $bc44d5c582efa5c9$export$e530037191fcd5d7;
var $bc44d5c582efa5c9$export$fd42f52fd3ae1109;
var $bc44d5c582efa5c9$export$c8a8987d4410bf2d;
var $bc44d5c582efa5c9$export$d38cd72104c1f0e9;
var $bc44d5c582efa5c9$export$7d1e3a5e95ceca43;
var $bc44d5c582efa5c9$export$257a8862b851cb5b;
var $bc44d5c582efa5c9$export$a8257692ac88316c;
var $bc44d5c582efa5c9$export$488013bae63b21da;
var $bc44d5c582efa5c9$export$7c73462e0d25e514;
var $bc44d5c582efa5c9$export$7568632d0d33d16d;
var $bc44d5c582efa5c9$export$88948ce120ea2619;
var $bc44d5c582efa5c9$export$35808ee640e87ca7;
var $bc44d5c582efa5c9$export$fae74005e78b1a27;
var $bc44d5c582efa5c9$export$dc8fbce3eb94dc1e;
var $bc44d5c582efa5c9$export$6a7bc4e911dc01cf;
var $bc44d5c582efa5c9$export$6d9c69b0de29b591;
var $bc44d5c582efa5c9$export$f680877a34711e37;
var $bc44d5c582efa5c9$export$d5a552a76deda3c2;
var $bc44d5c582efa5c9$export$aaabe4eda9ed9969;
var $bc44d5c582efa5c9$export$e5c5a5f917a5871c;
var $bc44d5c582efa5c9$export$1538c33de8887b59;
var $bc44d5c582efa5c9$export$13e3392192263954;
var $bc44d5c582efa5c9$export$b8f5890fc79d6aca;
var $bc44d5c582efa5c9$export$60241385465d0a34;
var $bc44d5c582efa5c9$export$306c0aa65ff9ec16;
var $bc44d5c582efa5c9$export$7b286972b8d8ccbf;
var $bc44d5c582efa5c9$export$83d89fbfd8236492;
"use strict";
var $bc44d5c582efa5c9$var$l = Symbol.for("react.element"), $bc44d5c582efa5c9$var$n = Symbol.for("react.portal"), $bc44d5c582efa5c9$var$p = Symbol.for("react.fragment"), $bc44d5c582efa5c9$var$q = Symbol.for("react.strict_mode"), $bc44d5c582efa5c9$var$r = Symbol.for("react.profiler"), $bc44d5c582efa5c9$var$t = Symbol.for("react.provider"), $bc44d5c582efa5c9$var$u = Symbol.for("react.context"), $bc44d5c582efa5c9$var$v = Symbol.for("react.forward_ref"), $bc44d5c582efa5c9$var$w = Symbol.for("react.suspense"), $bc44d5c582efa5c9$var$x = Symbol.for("react.memo"), $bc44d5c582efa5c9$var$y = Symbol.for("react.lazy"), $bc44d5c582efa5c9$var$z = Symbol.iterator;
function $bc44d5c582efa5c9$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $bc44d5c582efa5c9$var$z && a[$bc44d5c582efa5c9$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $bc44d5c582efa5c9$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $bc44d5c582efa5c9$var$C = Object.assign, $bc44d5c582efa5c9$var$D = {};
function $bc44d5c582efa5c9$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $bc44d5c582efa5c9$var$D;
    this.updater = e || $bc44d5c582efa5c9$var$B;
}
$bc44d5c582efa5c9$var$E.prototype.isReactComponent = {};
$bc44d5c582efa5c9$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$bc44d5c582efa5c9$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $bc44d5c582efa5c9$var$F() {}
$bc44d5c582efa5c9$var$F.prototype = $bc44d5c582efa5c9$var$E.prototype;
function $bc44d5c582efa5c9$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $bc44d5c582efa5c9$var$D;
    this.updater = e || $bc44d5c582efa5c9$var$B;
}
var $bc44d5c582efa5c9$var$H = $bc44d5c582efa5c9$var$G.prototype = new $bc44d5c582efa5c9$var$F;
$bc44d5c582efa5c9$var$H.constructor = $bc44d5c582efa5c9$var$G;
$bc44d5c582efa5c9$var$C($bc44d5c582efa5c9$var$H, $bc44d5c582efa5c9$var$E.prototype);
$bc44d5c582efa5c9$var$H.isPureReactComponent = !0;
var $bc44d5c582efa5c9$var$I = Array.isArray, $bc44d5c582efa5c9$var$J = Object.prototype.hasOwnProperty, $bc44d5c582efa5c9$var$K = {
    current: null
}, $bc44d5c582efa5c9$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $bc44d5c582efa5c9$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$bc44d5c582efa5c9$var$J.call(b, d) && !$bc44d5c582efa5c9$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $bc44d5c582efa5c9$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $bc44d5c582efa5c9$var$K.current
    };
}
function $bc44d5c582efa5c9$var$N(a, b) {
    return {
        $$typeof: $bc44d5c582efa5c9$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $bc44d5c582efa5c9$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bc44d5c582efa5c9$var$l;
}
function $bc44d5c582efa5c9$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $bc44d5c582efa5c9$var$P = /\/+/g;
function $bc44d5c582efa5c9$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $bc44d5c582efa5c9$var$escape("" + a.key) : b.toString(36);
}
function $bc44d5c582efa5c9$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $bc44d5c582efa5c9$var$l:
                case $bc44d5c582efa5c9$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $bc44d5c582efa5c9$var$Q(h, 0) : d, $bc44d5c582efa5c9$var$I(c) ? (e = "", null != a && (e = a.replace($bc44d5c582efa5c9$var$P, "$&/") + "/"), $bc44d5c582efa5c9$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($bc44d5c582efa5c9$var$O(c) && (c = $bc44d5c582efa5c9$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($bc44d5c582efa5c9$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($bc44d5c582efa5c9$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $bc44d5c582efa5c9$var$Q(k, g);
        h += $bc44d5c582efa5c9$var$R(k, b, e, f, c);
    }
    else if (f = $bc44d5c582efa5c9$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $bc44d5c582efa5c9$var$Q(k, g++), h += $bc44d5c582efa5c9$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $bc44d5c582efa5c9$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $bc44d5c582efa5c9$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $bc44d5c582efa5c9$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $bc44d5c582efa5c9$var$U = {
    current: null
}, $bc44d5c582efa5c9$var$V = {
    transition: null
}, $bc44d5c582efa5c9$var$W = {
    ReactCurrentDispatcher: $bc44d5c582efa5c9$var$U,
    ReactCurrentBatchConfig: $bc44d5c582efa5c9$var$V,
    ReactCurrentOwner: $bc44d5c582efa5c9$var$K
};
$bc44d5c582efa5c9$export$dca3b0875bd9a954 = {
    map: $bc44d5c582efa5c9$var$S,
    forEach: function(a, b, e) {
        $bc44d5c582efa5c9$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $bc44d5c582efa5c9$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $bc44d5c582efa5c9$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$bc44d5c582efa5c9$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$bc44d5c582efa5c9$export$16fa2f45be04daa8 = $bc44d5c582efa5c9$var$E;
$bc44d5c582efa5c9$export$ffb0004e005737fa = $bc44d5c582efa5c9$var$p;
$bc44d5c582efa5c9$export$e2c29f18771995cb = $bc44d5c582efa5c9$var$r;
$bc44d5c582efa5c9$export$221d75b3f55bb0bd = $bc44d5c582efa5c9$var$G;
$bc44d5c582efa5c9$export$5f8d39834fd61797 = $bc44d5c582efa5c9$var$q;
$bc44d5c582efa5c9$export$74bf444e3cd11ea5 = $bc44d5c582efa5c9$var$w;
$bc44d5c582efa5c9$export$ae55be85d98224ed = $bc44d5c582efa5c9$var$W;
$bc44d5c582efa5c9$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $bc44d5c582efa5c9$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $bc44d5c582efa5c9$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$bc44d5c582efa5c9$var$J.call(b, f) && !$bc44d5c582efa5c9$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $bc44d5c582efa5c9$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$bc44d5c582efa5c9$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $bc44d5c582efa5c9$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $bc44d5c582efa5c9$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$bc44d5c582efa5c9$export$c8a8987d4410bf2d = $bc44d5c582efa5c9$var$M;
$bc44d5c582efa5c9$export$d38cd72104c1f0e9 = function(a) {
    var b = $bc44d5c582efa5c9$var$M.bind(null, a);
    b.type = a;
    return b;
};
$bc44d5c582efa5c9$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$bc44d5c582efa5c9$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $bc44d5c582efa5c9$var$v,
        render: a
    };
};
$bc44d5c582efa5c9$export$a8257692ac88316c = $bc44d5c582efa5c9$var$O;
$bc44d5c582efa5c9$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $bc44d5c582efa5c9$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $bc44d5c582efa5c9$var$T
    };
};
$bc44d5c582efa5c9$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $bc44d5c582efa5c9$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$bc44d5c582efa5c9$export$7568632d0d33d16d = function(a) {
    var b = $bc44d5c582efa5c9$var$V.transition;
    $bc44d5c582efa5c9$var$V.transition = {};
    try {
        a();
    } finally{
        $bc44d5c582efa5c9$var$V.transition = b;
    }
};
$bc44d5c582efa5c9$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$bc44d5c582efa5c9$export$35808ee640e87ca7 = function(a, b) {
    return $bc44d5c582efa5c9$var$U.current.useCallback(a, b);
};
$bc44d5c582efa5c9$export$fae74005e78b1a27 = function(a) {
    return $bc44d5c582efa5c9$var$U.current.useContext(a);
};
$bc44d5c582efa5c9$export$dc8fbce3eb94dc1e = function() {};
$bc44d5c582efa5c9$export$6a7bc4e911dc01cf = function(a) {
    return $bc44d5c582efa5c9$var$U.current.useDeferredValue(a);
};
$bc44d5c582efa5c9$export$6d9c69b0de29b591 = function(a, b) {
    return $bc44d5c582efa5c9$var$U.current.useEffect(a, b);
};
$bc44d5c582efa5c9$export$f680877a34711e37 = function() {
    return $bc44d5c582efa5c9$var$U.current.useId();
};
$bc44d5c582efa5c9$export$d5a552a76deda3c2 = function(a, b, e) {
    return $bc44d5c582efa5c9$var$U.current.useImperativeHandle(a, b, e);
};
$bc44d5c582efa5c9$export$aaabe4eda9ed9969 = function(a, b) {
    return $bc44d5c582efa5c9$var$U.current.useInsertionEffect(a, b);
};
$bc44d5c582efa5c9$export$e5c5a5f917a5871c = function(a, b) {
    return $bc44d5c582efa5c9$var$U.current.useLayoutEffect(a, b);
};
$bc44d5c582efa5c9$export$1538c33de8887b59 = function(a, b) {
    return $bc44d5c582efa5c9$var$U.current.useMemo(a, b);
};
$bc44d5c582efa5c9$export$13e3392192263954 = function(a, b, e) {
    return $bc44d5c582efa5c9$var$U.current.useReducer(a, b, e);
};
$bc44d5c582efa5c9$export$b8f5890fc79d6aca = function(a) {
    return $bc44d5c582efa5c9$var$U.current.useRef(a);
};
$bc44d5c582efa5c9$export$60241385465d0a34 = function(a) {
    return $bc44d5c582efa5c9$var$U.current.useState(a);
};
$bc44d5c582efa5c9$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $bc44d5c582efa5c9$var$U.current.useSyncExternalStore(a, b, e);
};
$bc44d5c582efa5c9$export$7b286972b8d8ccbf = function() {
    return $bc44d5c582efa5c9$var$U.current.useTransition();
};
$bc44d5c582efa5c9$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("eN6q3", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $ac4a9effa24fe7be$export$ae55be85d98224ed; }, function (v) { return $ac4a9effa24fe7be$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $ac4a9effa24fe7be$export$d39a5bbd09211389; }, function (v) { return $ac4a9effa24fe7be$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $ac4a9effa24fe7be$export$882461b6382ed46c; }, function (v) { return $ac4a9effa24fe7be$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $ac4a9effa24fe7be$export$466bfc07425424d5; }, function (v) { return $ac4a9effa24fe7be$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $ac4a9effa24fe7be$export$cd75ccfd720a3cd4; }, function (v) { return $ac4a9effa24fe7be$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $ac4a9effa24fe7be$export$fa8d919ba61d84db; }, function (v) { return $ac4a9effa24fe7be$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $ac4a9effa24fe7be$export$757ceba2d55c277e; }, function (v) { return $ac4a9effa24fe7be$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $ac4a9effa24fe7be$export$b3890eb0ae9dca99; }, function (v) { return $ac4a9effa24fe7be$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $ac4a9effa24fe7be$export$502457920280e6be; }, function (v) { return $ac4a9effa24fe7be$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $ac4a9effa24fe7be$export$c78a37762a8d58e1; }, function (v) { return $ac4a9effa24fe7be$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $ac4a9effa24fe7be$export$dc54d992c10e8a18; }, function (v) { return $ac4a9effa24fe7be$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $ac4a9effa24fe7be$export$83d89fbfd8236492; }, function (v) { return $ac4a9effa24fe7be$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $ac4a9effa24fe7be$export$ae55be85d98224ed;
var $ac4a9effa24fe7be$export$d39a5bbd09211389;
var $ac4a9effa24fe7be$export$882461b6382ed46c;
var $ac4a9effa24fe7be$export$466bfc07425424d5;
var $ac4a9effa24fe7be$export$cd75ccfd720a3cd4;
var $ac4a9effa24fe7be$export$fa8d919ba61d84db;
var $ac4a9effa24fe7be$export$757ceba2d55c277e;
var $ac4a9effa24fe7be$export$b3890eb0ae9dca99;
var $ac4a9effa24fe7be$export$502457920280e6be;
var $ac4a9effa24fe7be$export$c78a37762a8d58e1;
var $ac4a9effa24fe7be$export$dc54d992c10e8a18;
var $ac4a9effa24fe7be$export$83d89fbfd8236492;
"use strict";

var $gIfym = parcelRequire("gIfym");

var $Qw0kg = parcelRequire("Qw0kg");
function $ac4a9effa24fe7be$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $ac4a9effa24fe7be$var$da = new Set, $ac4a9effa24fe7be$var$ea = {};
function $ac4a9effa24fe7be$var$fa(a, b) {
    $ac4a9effa24fe7be$var$ha(a, b);
    $ac4a9effa24fe7be$var$ha(a + "Capture", b);
}
function $ac4a9effa24fe7be$var$ha(a, b) {
    $ac4a9effa24fe7be$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$ac4a9effa24fe7be$var$da.add(b[a]);
}
var $ac4a9effa24fe7be$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $ac4a9effa24fe7be$var$ja = Object.prototype.hasOwnProperty, $ac4a9effa24fe7be$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $ac4a9effa24fe7be$var$la = {}, $ac4a9effa24fe7be$var$ma = {};
function $ac4a9effa24fe7be$var$oa(a) {
    if ($ac4a9effa24fe7be$var$ja.call($ac4a9effa24fe7be$var$ma, a)) return !0;
    if ($ac4a9effa24fe7be$var$ja.call($ac4a9effa24fe7be$var$la, a)) return !1;
    if ($ac4a9effa24fe7be$var$ka.test(a)) return $ac4a9effa24fe7be$var$ma[a] = !0;
    $ac4a9effa24fe7be$var$la[a] = !0;
    return !1;
}
function $ac4a9effa24fe7be$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $ac4a9effa24fe7be$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $ac4a9effa24fe7be$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $ac4a9effa24fe7be$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $ac4a9effa24fe7be$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $ac4a9effa24fe7be$var$z[a] = new $ac4a9effa24fe7be$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $ac4a9effa24fe7be$var$z[b] = new $ac4a9effa24fe7be$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $ac4a9effa24fe7be$var$z[a] = new $ac4a9effa24fe7be$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $ac4a9effa24fe7be$var$z[a] = new $ac4a9effa24fe7be$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $ac4a9effa24fe7be$var$z[a] = new $ac4a9effa24fe7be$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $ac4a9effa24fe7be$var$z[a] = new $ac4a9effa24fe7be$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $ac4a9effa24fe7be$var$z[a] = new $ac4a9effa24fe7be$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $ac4a9effa24fe7be$var$z[a] = new $ac4a9effa24fe7be$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $ac4a9effa24fe7be$var$z[a] = new $ac4a9effa24fe7be$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $ac4a9effa24fe7be$var$ra = /[\-:]([a-z])/g;
function $ac4a9effa24fe7be$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($ac4a9effa24fe7be$var$ra, $ac4a9effa24fe7be$var$sa);
    $ac4a9effa24fe7be$var$z[b] = new $ac4a9effa24fe7be$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($ac4a9effa24fe7be$var$ra, $ac4a9effa24fe7be$var$sa);
    $ac4a9effa24fe7be$var$z[b] = new $ac4a9effa24fe7be$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($ac4a9effa24fe7be$var$ra, $ac4a9effa24fe7be$var$sa);
    $ac4a9effa24fe7be$var$z[b] = new $ac4a9effa24fe7be$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $ac4a9effa24fe7be$var$z[a] = new $ac4a9effa24fe7be$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$ac4a9effa24fe7be$var$z.xlinkHref = new $ac4a9effa24fe7be$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $ac4a9effa24fe7be$var$z[a] = new $ac4a9effa24fe7be$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $ac4a9effa24fe7be$var$ta(a, b, c, d) {
    var e = $ac4a9effa24fe7be$var$z.hasOwnProperty(b) ? $ac4a9effa24fe7be$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $ac4a9effa24fe7be$var$qa(b, c, e, d) && (c = null), d || null === e ? $ac4a9effa24fe7be$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $ac4a9effa24fe7be$var$ua = $gIfym.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $ac4a9effa24fe7be$var$va = Symbol.for("react.element"), $ac4a9effa24fe7be$var$wa = Symbol.for("react.portal"), $ac4a9effa24fe7be$var$ya = Symbol.for("react.fragment"), $ac4a9effa24fe7be$var$za = Symbol.for("react.strict_mode"), $ac4a9effa24fe7be$var$Aa = Symbol.for("react.profiler"), $ac4a9effa24fe7be$var$Ba = Symbol.for("react.provider"), $ac4a9effa24fe7be$var$Ca = Symbol.for("react.context"), $ac4a9effa24fe7be$var$Da = Symbol.for("react.forward_ref"), $ac4a9effa24fe7be$var$Ea = Symbol.for("react.suspense"), $ac4a9effa24fe7be$var$Fa = Symbol.for("react.suspense_list"), $ac4a9effa24fe7be$var$Ga = Symbol.for("react.memo"), $ac4a9effa24fe7be$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $ac4a9effa24fe7be$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $ac4a9effa24fe7be$var$Ja = Symbol.iterator;
function $ac4a9effa24fe7be$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $ac4a9effa24fe7be$var$Ja && a[$ac4a9effa24fe7be$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $ac4a9effa24fe7be$var$A = Object.assign, $ac4a9effa24fe7be$var$La;
function $ac4a9effa24fe7be$var$Ma(a) {
    if (void 0 === $ac4a9effa24fe7be$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $ac4a9effa24fe7be$var$La = b && b[1] || "";
    }
    return "\n" + $ac4a9effa24fe7be$var$La + a;
}
var $ac4a9effa24fe7be$var$Na = !1;
function $ac4a9effa24fe7be$var$Oa(a, b) {
    if (!a || $ac4a9effa24fe7be$var$Na) return "";
    $ac4a9effa24fe7be$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $ac4a9effa24fe7be$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $ac4a9effa24fe7be$var$Ma(a) : "";
}
function $ac4a9effa24fe7be$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $ac4a9effa24fe7be$var$Ma(a.type);
        case 16:
            return $ac4a9effa24fe7be$var$Ma("Lazy");
        case 13:
            return $ac4a9effa24fe7be$var$Ma("Suspense");
        case 19:
            return $ac4a9effa24fe7be$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $ac4a9effa24fe7be$var$Oa(a.type, !1), a;
        case 11:
            return a = $ac4a9effa24fe7be$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $ac4a9effa24fe7be$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $ac4a9effa24fe7be$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $ac4a9effa24fe7be$var$ya:
            return "Fragment";
        case $ac4a9effa24fe7be$var$wa:
            return "Portal";
        case $ac4a9effa24fe7be$var$Aa:
            return "Profiler";
        case $ac4a9effa24fe7be$var$za:
            return "StrictMode";
        case $ac4a9effa24fe7be$var$Ea:
            return "Suspense";
        case $ac4a9effa24fe7be$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $ac4a9effa24fe7be$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $ac4a9effa24fe7be$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $ac4a9effa24fe7be$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $ac4a9effa24fe7be$var$Ga:
            return b = a.displayName || null, null !== b ? b : $ac4a9effa24fe7be$var$Qa(a.type) || "Memo";
        case $ac4a9effa24fe7be$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $ac4a9effa24fe7be$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $ac4a9effa24fe7be$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $ac4a9effa24fe7be$var$Qa(b);
        case 8:
            return b === $ac4a9effa24fe7be$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $ac4a9effa24fe7be$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $ac4a9effa24fe7be$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $ac4a9effa24fe7be$var$Ua(a) {
    var b = $ac4a9effa24fe7be$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $ac4a9effa24fe7be$var$Va(a) {
    a._valueTracker || (a._valueTracker = $ac4a9effa24fe7be$var$Ua(a));
}
function $ac4a9effa24fe7be$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $ac4a9effa24fe7be$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $ac4a9effa24fe7be$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $ac4a9effa24fe7be$var$Ya(a, b) {
    var c = b.checked;
    return $ac4a9effa24fe7be$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $ac4a9effa24fe7be$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $ac4a9effa24fe7be$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $ac4a9effa24fe7be$var$ab(a, b) {
    b = b.checked;
    null != b && $ac4a9effa24fe7be$var$ta(a, "checked", b, !1);
}
function $ac4a9effa24fe7be$var$bb(a, b) {
    $ac4a9effa24fe7be$var$ab(a, b);
    var c = $ac4a9effa24fe7be$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $ac4a9effa24fe7be$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $ac4a9effa24fe7be$var$cb(a, b.type, $ac4a9effa24fe7be$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $ac4a9effa24fe7be$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $ac4a9effa24fe7be$var$cb(a, b, c) {
    if ("number" !== b || $ac4a9effa24fe7be$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $ac4a9effa24fe7be$var$eb = Array.isArray;
function $ac4a9effa24fe7be$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $ac4a9effa24fe7be$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $ac4a9effa24fe7be$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($ac4a9effa24fe7be$var$p(91));
    return $ac4a9effa24fe7be$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $ac4a9effa24fe7be$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($ac4a9effa24fe7be$var$p(92));
            if ($ac4a9effa24fe7be$var$eb(c)) {
                if (1 < c.length) throw Error($ac4a9effa24fe7be$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $ac4a9effa24fe7be$var$Sa(c)
    };
}
function $ac4a9effa24fe7be$var$ib(a, b) {
    var c = $ac4a9effa24fe7be$var$Sa(b.value), d = $ac4a9effa24fe7be$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $ac4a9effa24fe7be$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $ac4a9effa24fe7be$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $ac4a9effa24fe7be$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $ac4a9effa24fe7be$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $ac4a9effa24fe7be$var$mb, $ac4a9effa24fe7be$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $ac4a9effa24fe7be$var$mb = $ac4a9effa24fe7be$var$mb || document.createElement("div");
        $ac4a9effa24fe7be$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $ac4a9effa24fe7be$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $ac4a9effa24fe7be$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $ac4a9effa24fe7be$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $ac4a9effa24fe7be$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($ac4a9effa24fe7be$var$pb).forEach(function(a) {
    $ac4a9effa24fe7be$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $ac4a9effa24fe7be$var$pb[b] = $ac4a9effa24fe7be$var$pb[a];
    });
});
function $ac4a9effa24fe7be$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $ac4a9effa24fe7be$var$pb.hasOwnProperty(a) && $ac4a9effa24fe7be$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $ac4a9effa24fe7be$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $ac4a9effa24fe7be$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $ac4a9effa24fe7be$var$tb = $ac4a9effa24fe7be$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $ac4a9effa24fe7be$var$ub(a, b) {
    if (b) {
        if ($ac4a9effa24fe7be$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($ac4a9effa24fe7be$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($ac4a9effa24fe7be$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($ac4a9effa24fe7be$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($ac4a9effa24fe7be$var$p(62));
    }
}
function $ac4a9effa24fe7be$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $ac4a9effa24fe7be$var$wb = null;
function $ac4a9effa24fe7be$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $ac4a9effa24fe7be$var$yb = null, $ac4a9effa24fe7be$var$zb = null, $ac4a9effa24fe7be$var$Ab = null;
function $ac4a9effa24fe7be$var$Bb(a) {
    if (a = $ac4a9effa24fe7be$var$Cb(a)) {
        if ("function" !== typeof $ac4a9effa24fe7be$var$yb) throw Error($ac4a9effa24fe7be$var$p(280));
        var b = a.stateNode;
        b && (b = $ac4a9effa24fe7be$var$Db(b), $ac4a9effa24fe7be$var$yb(a.stateNode, a.type, b));
    }
}
function $ac4a9effa24fe7be$var$Eb(a) {
    $ac4a9effa24fe7be$var$zb ? $ac4a9effa24fe7be$var$Ab ? $ac4a9effa24fe7be$var$Ab.push(a) : $ac4a9effa24fe7be$var$Ab = [
        a
    ] : $ac4a9effa24fe7be$var$zb = a;
}
function $ac4a9effa24fe7be$var$Fb() {
    if ($ac4a9effa24fe7be$var$zb) {
        var a = $ac4a9effa24fe7be$var$zb, b = $ac4a9effa24fe7be$var$Ab;
        $ac4a9effa24fe7be$var$Ab = $ac4a9effa24fe7be$var$zb = null;
        $ac4a9effa24fe7be$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$ac4a9effa24fe7be$var$Bb(b[a]);
    }
}
function $ac4a9effa24fe7be$var$Gb(a, b) {
    return a(b);
}
function $ac4a9effa24fe7be$var$Hb() {}
var $ac4a9effa24fe7be$var$Ib = !1;
function $ac4a9effa24fe7be$var$Jb(a, b, c) {
    if ($ac4a9effa24fe7be$var$Ib) return a(b, c);
    $ac4a9effa24fe7be$var$Ib = !0;
    try {
        return $ac4a9effa24fe7be$var$Gb(a, b, c);
    } finally{
        if ($ac4a9effa24fe7be$var$Ib = !1, null !== $ac4a9effa24fe7be$var$zb || null !== $ac4a9effa24fe7be$var$Ab) $ac4a9effa24fe7be$var$Hb(), $ac4a9effa24fe7be$var$Fb();
    }
}
function $ac4a9effa24fe7be$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $ac4a9effa24fe7be$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($ac4a9effa24fe7be$var$p(231, b, typeof c));
    return c;
}
var $ac4a9effa24fe7be$var$Lb = !1;
if ($ac4a9effa24fe7be$var$ia) try {
    var $ac4a9effa24fe7be$var$Mb = {};
    Object.defineProperty($ac4a9effa24fe7be$var$Mb, "passive", {
        get: function() {
            $ac4a9effa24fe7be$var$Lb = !0;
        }
    });
    window.addEventListener("test", $ac4a9effa24fe7be$var$Mb, $ac4a9effa24fe7be$var$Mb);
    window.removeEventListener("test", $ac4a9effa24fe7be$var$Mb, $ac4a9effa24fe7be$var$Mb);
} catch (a) {
    $ac4a9effa24fe7be$var$Lb = !1;
}
function $ac4a9effa24fe7be$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $ac4a9effa24fe7be$var$Ob = !1, $ac4a9effa24fe7be$var$Pb = null, $ac4a9effa24fe7be$var$Qb = !1, $ac4a9effa24fe7be$var$Rb = null, $ac4a9effa24fe7be$var$Sb = {
    onError: function(a) {
        $ac4a9effa24fe7be$var$Ob = !0;
        $ac4a9effa24fe7be$var$Pb = a;
    }
};
function $ac4a9effa24fe7be$var$Tb(a, b, c, d, e, f, g, h, k) {
    $ac4a9effa24fe7be$var$Ob = !1;
    $ac4a9effa24fe7be$var$Pb = null;
    $ac4a9effa24fe7be$var$Nb.apply($ac4a9effa24fe7be$var$Sb, arguments);
}
function $ac4a9effa24fe7be$var$Ub(a, b, c, d, e, f, g, h, k) {
    $ac4a9effa24fe7be$var$Tb.apply(this, arguments);
    if ($ac4a9effa24fe7be$var$Ob) {
        if ($ac4a9effa24fe7be$var$Ob) {
            var l = $ac4a9effa24fe7be$var$Pb;
            $ac4a9effa24fe7be$var$Ob = !1;
            $ac4a9effa24fe7be$var$Pb = null;
        } else throw Error($ac4a9effa24fe7be$var$p(198));
        $ac4a9effa24fe7be$var$Qb || ($ac4a9effa24fe7be$var$Qb = !0, $ac4a9effa24fe7be$var$Rb = l);
    }
}
function $ac4a9effa24fe7be$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $ac4a9effa24fe7be$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $ac4a9effa24fe7be$var$Xb(a) {
    if ($ac4a9effa24fe7be$var$Vb(a) !== a) throw Error($ac4a9effa24fe7be$var$p(188));
}
function $ac4a9effa24fe7be$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $ac4a9effa24fe7be$var$Vb(a);
        if (null === b) throw Error($ac4a9effa24fe7be$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $ac4a9effa24fe7be$var$Xb(e), a;
                if (f === d) return $ac4a9effa24fe7be$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($ac4a9effa24fe7be$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($ac4a9effa24fe7be$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($ac4a9effa24fe7be$var$p(190));
    }
    if (3 !== c.tag) throw Error($ac4a9effa24fe7be$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $ac4a9effa24fe7be$var$Zb(a) {
    a = $ac4a9effa24fe7be$var$Yb(a);
    return null !== a ? $ac4a9effa24fe7be$var$$b(a) : null;
}
function $ac4a9effa24fe7be$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $ac4a9effa24fe7be$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $ac4a9effa24fe7be$var$ac = $Qw0kg.unstable_scheduleCallback, $ac4a9effa24fe7be$var$bc = $Qw0kg.unstable_cancelCallback, $ac4a9effa24fe7be$var$cc = $Qw0kg.unstable_shouldYield, $ac4a9effa24fe7be$var$dc = $Qw0kg.unstable_requestPaint, $ac4a9effa24fe7be$var$B = $Qw0kg.unstable_now, $ac4a9effa24fe7be$var$ec = $Qw0kg.unstable_getCurrentPriorityLevel, $ac4a9effa24fe7be$var$fc = $Qw0kg.unstable_ImmediatePriority, $ac4a9effa24fe7be$var$gc = $Qw0kg.unstable_UserBlockingPriority, $ac4a9effa24fe7be$var$hc = $Qw0kg.unstable_NormalPriority, $ac4a9effa24fe7be$var$ic = $Qw0kg.unstable_LowPriority, $ac4a9effa24fe7be$var$jc = $Qw0kg.unstable_IdlePriority, $ac4a9effa24fe7be$var$kc = null, $ac4a9effa24fe7be$var$lc = null;
function $ac4a9effa24fe7be$var$mc(a) {
    if ($ac4a9effa24fe7be$var$lc && "function" === typeof $ac4a9effa24fe7be$var$lc.onCommitFiberRoot) try {
        $ac4a9effa24fe7be$var$lc.onCommitFiberRoot($ac4a9effa24fe7be$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $ac4a9effa24fe7be$var$oc = Math.clz32 ? Math.clz32 : $ac4a9effa24fe7be$var$nc, $ac4a9effa24fe7be$var$pc = Math.log, $ac4a9effa24fe7be$var$qc = Math.LN2;
function $ac4a9effa24fe7be$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($ac4a9effa24fe7be$var$pc(a) / $ac4a9effa24fe7be$var$qc | 0) | 0;
}
var $ac4a9effa24fe7be$var$rc = 64, $ac4a9effa24fe7be$var$sc = 4194304;
function $ac4a9effa24fe7be$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $ac4a9effa24fe7be$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $ac4a9effa24fe7be$var$tc(h) : (f &= g, 0 !== f && (d = $ac4a9effa24fe7be$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $ac4a9effa24fe7be$var$tc(g) : 0 !== f && (d = $ac4a9effa24fe7be$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $ac4a9effa24fe7be$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $ac4a9effa24fe7be$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $ac4a9effa24fe7be$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $ac4a9effa24fe7be$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $ac4a9effa24fe7be$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $ac4a9effa24fe7be$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $ac4a9effa24fe7be$var$yc() {
    var a = $ac4a9effa24fe7be$var$rc;
    $ac4a9effa24fe7be$var$rc <<= 1;
    0 === ($ac4a9effa24fe7be$var$rc & 4194240) && ($ac4a9effa24fe7be$var$rc = 64);
    return a;
}
function $ac4a9effa24fe7be$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $ac4a9effa24fe7be$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $ac4a9effa24fe7be$var$oc(b);
    a[b] = c;
}
function $ac4a9effa24fe7be$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $ac4a9effa24fe7be$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $ac4a9effa24fe7be$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $ac4a9effa24fe7be$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $ac4a9effa24fe7be$var$C = 0;
function $ac4a9effa24fe7be$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $ac4a9effa24fe7be$var$Ec, $ac4a9effa24fe7be$var$Fc, $ac4a9effa24fe7be$var$Gc, $ac4a9effa24fe7be$var$Hc, $ac4a9effa24fe7be$var$Ic, $ac4a9effa24fe7be$var$Jc = !1, $ac4a9effa24fe7be$var$Kc = [], $ac4a9effa24fe7be$var$Lc = null, $ac4a9effa24fe7be$var$Mc = null, $ac4a9effa24fe7be$var$Nc = null, $ac4a9effa24fe7be$var$Oc = new Map, $ac4a9effa24fe7be$var$Pc = new Map, $ac4a9effa24fe7be$var$Qc = [], $ac4a9effa24fe7be$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $ac4a9effa24fe7be$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $ac4a9effa24fe7be$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $ac4a9effa24fe7be$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $ac4a9effa24fe7be$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $ac4a9effa24fe7be$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $ac4a9effa24fe7be$var$Pc.delete(b.pointerId);
    }
}
function $ac4a9effa24fe7be$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $ac4a9effa24fe7be$var$Cb(b), null !== b && $ac4a9effa24fe7be$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $ac4a9effa24fe7be$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $ac4a9effa24fe7be$var$Lc = $ac4a9effa24fe7be$var$Tc($ac4a9effa24fe7be$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $ac4a9effa24fe7be$var$Mc = $ac4a9effa24fe7be$var$Tc($ac4a9effa24fe7be$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $ac4a9effa24fe7be$var$Nc = $ac4a9effa24fe7be$var$Tc($ac4a9effa24fe7be$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $ac4a9effa24fe7be$var$Oc.set(f, $ac4a9effa24fe7be$var$Tc($ac4a9effa24fe7be$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $ac4a9effa24fe7be$var$Pc.set(f, $ac4a9effa24fe7be$var$Tc($ac4a9effa24fe7be$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $ac4a9effa24fe7be$var$Vc(a) {
    var b = $ac4a9effa24fe7be$var$Wc(a.target);
    if (null !== b) {
        var c = $ac4a9effa24fe7be$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $ac4a9effa24fe7be$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $ac4a9effa24fe7be$var$Ic(a.priority, function() {
                        $ac4a9effa24fe7be$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $ac4a9effa24fe7be$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $ac4a9effa24fe7be$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $ac4a9effa24fe7be$var$wb = d;
            c.target.dispatchEvent(d);
            $ac4a9effa24fe7be$var$wb = null;
        } else return b = $ac4a9effa24fe7be$var$Cb(c), null !== b && $ac4a9effa24fe7be$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $ac4a9effa24fe7be$var$Zc(a, b, c) {
    $ac4a9effa24fe7be$var$Xc(a) && c.delete(b);
}
function $ac4a9effa24fe7be$var$$c() {
    $ac4a9effa24fe7be$var$Jc = !1;
    null !== $ac4a9effa24fe7be$var$Lc && $ac4a9effa24fe7be$var$Xc($ac4a9effa24fe7be$var$Lc) && ($ac4a9effa24fe7be$var$Lc = null);
    null !== $ac4a9effa24fe7be$var$Mc && $ac4a9effa24fe7be$var$Xc($ac4a9effa24fe7be$var$Mc) && ($ac4a9effa24fe7be$var$Mc = null);
    null !== $ac4a9effa24fe7be$var$Nc && $ac4a9effa24fe7be$var$Xc($ac4a9effa24fe7be$var$Nc) && ($ac4a9effa24fe7be$var$Nc = null);
    $ac4a9effa24fe7be$var$Oc.forEach($ac4a9effa24fe7be$var$Zc);
    $ac4a9effa24fe7be$var$Pc.forEach($ac4a9effa24fe7be$var$Zc);
}
function $ac4a9effa24fe7be$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $ac4a9effa24fe7be$var$Jc || ($ac4a9effa24fe7be$var$Jc = !0, $Qw0kg.unstable_scheduleCallback($Qw0kg.unstable_NormalPriority, $ac4a9effa24fe7be$var$$c)));
}
function $ac4a9effa24fe7be$var$bd(a) {
    function b(b) {
        return $ac4a9effa24fe7be$var$ad(b, a);
    }
    if (0 < $ac4a9effa24fe7be$var$Kc.length) {
        $ac4a9effa24fe7be$var$ad($ac4a9effa24fe7be$var$Kc[0], a);
        for(var c = 1; c < $ac4a9effa24fe7be$var$Kc.length; c++){
            var d = $ac4a9effa24fe7be$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $ac4a9effa24fe7be$var$Lc && $ac4a9effa24fe7be$var$ad($ac4a9effa24fe7be$var$Lc, a);
    null !== $ac4a9effa24fe7be$var$Mc && $ac4a9effa24fe7be$var$ad($ac4a9effa24fe7be$var$Mc, a);
    null !== $ac4a9effa24fe7be$var$Nc && $ac4a9effa24fe7be$var$ad($ac4a9effa24fe7be$var$Nc, a);
    $ac4a9effa24fe7be$var$Oc.forEach(b);
    $ac4a9effa24fe7be$var$Pc.forEach(b);
    for(c = 0; c < $ac4a9effa24fe7be$var$Qc.length; c++)d = $ac4a9effa24fe7be$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $ac4a9effa24fe7be$var$Qc.length && (c = $ac4a9effa24fe7be$var$Qc[0], null === c.blockedOn);)$ac4a9effa24fe7be$var$Vc(c), null === c.blockedOn && $ac4a9effa24fe7be$var$Qc.shift();
}
var $ac4a9effa24fe7be$var$cd = $ac4a9effa24fe7be$var$ua.ReactCurrentBatchConfig, $ac4a9effa24fe7be$var$dd = !0;
function $ac4a9effa24fe7be$var$ed(a, b, c, d) {
    var e = $ac4a9effa24fe7be$var$C, f = $ac4a9effa24fe7be$var$cd.transition;
    $ac4a9effa24fe7be$var$cd.transition = null;
    try {
        $ac4a9effa24fe7be$var$C = 1, $ac4a9effa24fe7be$var$fd(a, b, c, d);
    } finally{
        $ac4a9effa24fe7be$var$C = e, $ac4a9effa24fe7be$var$cd.transition = f;
    }
}
function $ac4a9effa24fe7be$var$gd(a, b, c, d) {
    var e = $ac4a9effa24fe7be$var$C, f = $ac4a9effa24fe7be$var$cd.transition;
    $ac4a9effa24fe7be$var$cd.transition = null;
    try {
        $ac4a9effa24fe7be$var$C = 4, $ac4a9effa24fe7be$var$fd(a, b, c, d);
    } finally{
        $ac4a9effa24fe7be$var$C = e, $ac4a9effa24fe7be$var$cd.transition = f;
    }
}
function $ac4a9effa24fe7be$var$fd(a, b, c, d) {
    if ($ac4a9effa24fe7be$var$dd) {
        var e = $ac4a9effa24fe7be$var$Yc(a, b, c, d);
        if (null === e) $ac4a9effa24fe7be$var$hd(a, b, d, $ac4a9effa24fe7be$var$id, c), $ac4a9effa24fe7be$var$Sc(a, d);
        else if ($ac4a9effa24fe7be$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($ac4a9effa24fe7be$var$Sc(a, d), b & 4 && -1 < $ac4a9effa24fe7be$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $ac4a9effa24fe7be$var$Cb(e);
                null !== f && $ac4a9effa24fe7be$var$Ec(f);
                f = $ac4a9effa24fe7be$var$Yc(a, b, c, d);
                null === f && $ac4a9effa24fe7be$var$hd(a, b, d, $ac4a9effa24fe7be$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $ac4a9effa24fe7be$var$hd(a, b, d, null, c);
    }
}
var $ac4a9effa24fe7be$var$id = null;
function $ac4a9effa24fe7be$var$Yc(a, b, c, d) {
    $ac4a9effa24fe7be$var$id = null;
    a = $ac4a9effa24fe7be$var$xb(d);
    a = $ac4a9effa24fe7be$var$Wc(a);
    if (null !== a) {
        if (b = $ac4a9effa24fe7be$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $ac4a9effa24fe7be$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $ac4a9effa24fe7be$var$id = a;
    return null;
}
function $ac4a9effa24fe7be$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($ac4a9effa24fe7be$var$ec()){
                case $ac4a9effa24fe7be$var$fc:
                    return 1;
                case $ac4a9effa24fe7be$var$gc:
                    return 4;
                case $ac4a9effa24fe7be$var$hc:
                case $ac4a9effa24fe7be$var$ic:
                    return 16;
                case $ac4a9effa24fe7be$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $ac4a9effa24fe7be$var$kd = null, $ac4a9effa24fe7be$var$ld = null, $ac4a9effa24fe7be$var$md = null;
function $ac4a9effa24fe7be$var$nd() {
    if ($ac4a9effa24fe7be$var$md) return $ac4a9effa24fe7be$var$md;
    var a, b = $ac4a9effa24fe7be$var$ld, c = b.length, d, e = "value" in $ac4a9effa24fe7be$var$kd ? $ac4a9effa24fe7be$var$kd.value : $ac4a9effa24fe7be$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $ac4a9effa24fe7be$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $ac4a9effa24fe7be$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $ac4a9effa24fe7be$var$pd() {
    return !0;
}
function $ac4a9effa24fe7be$var$qd() {
    return !1;
}
function $ac4a9effa24fe7be$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $ac4a9effa24fe7be$var$pd : $ac4a9effa24fe7be$var$qd;
        this.isPropagationStopped = $ac4a9effa24fe7be$var$qd;
        return this;
    }
    $ac4a9effa24fe7be$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $ac4a9effa24fe7be$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $ac4a9effa24fe7be$var$pd);
        },
        persist: function() {},
        isPersistent: $ac4a9effa24fe7be$var$pd
    });
    return b;
}
var $ac4a9effa24fe7be$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $ac4a9effa24fe7be$var$td = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$sd), $ac4a9effa24fe7be$var$ud = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$sd, {
    view: 0,
    detail: 0
}), $ac4a9effa24fe7be$var$vd = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$ud), $ac4a9effa24fe7be$var$wd, $ac4a9effa24fe7be$var$xd, $ac4a9effa24fe7be$var$yd, $ac4a9effa24fe7be$var$Ad = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $ac4a9effa24fe7be$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $ac4a9effa24fe7be$var$yd && ($ac4a9effa24fe7be$var$yd && "mousemove" === a.type ? ($ac4a9effa24fe7be$var$wd = a.screenX - $ac4a9effa24fe7be$var$yd.screenX, $ac4a9effa24fe7be$var$xd = a.screenY - $ac4a9effa24fe7be$var$yd.screenY) : $ac4a9effa24fe7be$var$xd = $ac4a9effa24fe7be$var$wd = 0, $ac4a9effa24fe7be$var$yd = a);
        return $ac4a9effa24fe7be$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $ac4a9effa24fe7be$var$xd;
    }
}), $ac4a9effa24fe7be$var$Bd = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Ad), $ac4a9effa24fe7be$var$Cd = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$Ad, {
    dataTransfer: 0
}), $ac4a9effa24fe7be$var$Dd = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Cd), $ac4a9effa24fe7be$var$Ed = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$ud, {
    relatedTarget: 0
}), $ac4a9effa24fe7be$var$Fd = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Ed), $ac4a9effa24fe7be$var$Gd = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $ac4a9effa24fe7be$var$Hd = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Gd), $ac4a9effa24fe7be$var$Id = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $ac4a9effa24fe7be$var$Jd = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Id), $ac4a9effa24fe7be$var$Kd = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$sd, {
    data: 0
}), $ac4a9effa24fe7be$var$Ld = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Kd), $ac4a9effa24fe7be$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $ac4a9effa24fe7be$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $ac4a9effa24fe7be$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $ac4a9effa24fe7be$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $ac4a9effa24fe7be$var$Od[a]) ? !!b[a] : !1;
}
function $ac4a9effa24fe7be$var$zd() {
    return $ac4a9effa24fe7be$var$Pd;
}
var $ac4a9effa24fe7be$var$Qd = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $ac4a9effa24fe7be$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $ac4a9effa24fe7be$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $ac4a9effa24fe7be$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $ac4a9effa24fe7be$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $ac4a9effa24fe7be$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $ac4a9effa24fe7be$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $ac4a9effa24fe7be$var$Rd = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Qd), $ac4a9effa24fe7be$var$Sd = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $ac4a9effa24fe7be$var$Td = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Sd), $ac4a9effa24fe7be$var$Ud = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $ac4a9effa24fe7be$var$zd
}), $ac4a9effa24fe7be$var$Vd = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Ud), $ac4a9effa24fe7be$var$Wd = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $ac4a9effa24fe7be$var$Xd = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Wd), $ac4a9effa24fe7be$var$Yd = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $ac4a9effa24fe7be$var$Zd = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Yd), $ac4a9effa24fe7be$var$$d = [
    9,
    13,
    27,
    32
], $ac4a9effa24fe7be$var$ae = $ac4a9effa24fe7be$var$ia && "CompositionEvent" in window, $ac4a9effa24fe7be$var$be = null;
$ac4a9effa24fe7be$var$ia && "documentMode" in document && ($ac4a9effa24fe7be$var$be = document.documentMode);
var $ac4a9effa24fe7be$var$ce = $ac4a9effa24fe7be$var$ia && "TextEvent" in window && !$ac4a9effa24fe7be$var$be, $ac4a9effa24fe7be$var$de = $ac4a9effa24fe7be$var$ia && (!$ac4a9effa24fe7be$var$ae || $ac4a9effa24fe7be$var$be && 8 < $ac4a9effa24fe7be$var$be && 11 >= $ac4a9effa24fe7be$var$be), $ac4a9effa24fe7be$var$ee = String.fromCharCode(32), $ac4a9effa24fe7be$var$fe = !1;
function $ac4a9effa24fe7be$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $ac4a9effa24fe7be$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $ac4a9effa24fe7be$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $ac4a9effa24fe7be$var$ie = !1;
function $ac4a9effa24fe7be$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $ac4a9effa24fe7be$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $ac4a9effa24fe7be$var$fe = !0;
            return $ac4a9effa24fe7be$var$ee;
        case "textInput":
            return a = b.data, a === $ac4a9effa24fe7be$var$ee && $ac4a9effa24fe7be$var$fe ? null : a;
        default:
            return null;
    }
}
function $ac4a9effa24fe7be$var$ke(a, b) {
    if ($ac4a9effa24fe7be$var$ie) return "compositionend" === a || !$ac4a9effa24fe7be$var$ae && $ac4a9effa24fe7be$var$ge(a, b) ? (a = $ac4a9effa24fe7be$var$nd(), $ac4a9effa24fe7be$var$md = $ac4a9effa24fe7be$var$ld = $ac4a9effa24fe7be$var$kd = null, $ac4a9effa24fe7be$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $ac4a9effa24fe7be$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $ac4a9effa24fe7be$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $ac4a9effa24fe7be$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$ac4a9effa24fe7be$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $ac4a9effa24fe7be$var$ne(a, b, c, d) {
    $ac4a9effa24fe7be$var$Eb(d);
    b = $ac4a9effa24fe7be$var$oe(b, "onChange");
    0 < b.length && (c = new $ac4a9effa24fe7be$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $ac4a9effa24fe7be$var$pe = null, $ac4a9effa24fe7be$var$qe = null;
function $ac4a9effa24fe7be$var$re(a) {
    $ac4a9effa24fe7be$var$se(a, 0);
}
function $ac4a9effa24fe7be$var$te(a) {
    var b = $ac4a9effa24fe7be$var$ue(a);
    if ($ac4a9effa24fe7be$var$Wa(b)) return a;
}
function $ac4a9effa24fe7be$var$ve(a, b) {
    if ("change" === a) return b;
}
var $ac4a9effa24fe7be$var$we = !1;
if ($ac4a9effa24fe7be$var$ia) {
    var $ac4a9effa24fe7be$var$xe;
    if ($ac4a9effa24fe7be$var$ia) {
        var $ac4a9effa24fe7be$var$ye = "oninput" in document;
        if (!$ac4a9effa24fe7be$var$ye) {
            var $ac4a9effa24fe7be$var$ze = document.createElement("div");
            $ac4a9effa24fe7be$var$ze.setAttribute("oninput", "return;");
            $ac4a9effa24fe7be$var$ye = "function" === typeof $ac4a9effa24fe7be$var$ze.oninput;
        }
        $ac4a9effa24fe7be$var$xe = $ac4a9effa24fe7be$var$ye;
    } else $ac4a9effa24fe7be$var$xe = !1;
    $ac4a9effa24fe7be$var$we = $ac4a9effa24fe7be$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $ac4a9effa24fe7be$var$Ae() {
    $ac4a9effa24fe7be$var$pe && ($ac4a9effa24fe7be$var$pe.detachEvent("onpropertychange", $ac4a9effa24fe7be$var$Be), $ac4a9effa24fe7be$var$qe = $ac4a9effa24fe7be$var$pe = null);
}
function $ac4a9effa24fe7be$var$Be(a) {
    if ("value" === a.propertyName && $ac4a9effa24fe7be$var$te($ac4a9effa24fe7be$var$qe)) {
        var b = [];
        $ac4a9effa24fe7be$var$ne(b, $ac4a9effa24fe7be$var$qe, a, $ac4a9effa24fe7be$var$xb(a));
        $ac4a9effa24fe7be$var$Jb($ac4a9effa24fe7be$var$re, b);
    }
}
function $ac4a9effa24fe7be$var$Ce(a, b, c) {
    "focusin" === a ? ($ac4a9effa24fe7be$var$Ae(), $ac4a9effa24fe7be$var$pe = b, $ac4a9effa24fe7be$var$qe = c, $ac4a9effa24fe7be$var$pe.attachEvent("onpropertychange", $ac4a9effa24fe7be$var$Be)) : "focusout" === a && $ac4a9effa24fe7be$var$Ae();
}
function $ac4a9effa24fe7be$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $ac4a9effa24fe7be$var$te($ac4a9effa24fe7be$var$qe);
}
function $ac4a9effa24fe7be$var$Ee(a, b) {
    if ("click" === a) return $ac4a9effa24fe7be$var$te(b);
}
function $ac4a9effa24fe7be$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $ac4a9effa24fe7be$var$te(b);
}
function $ac4a9effa24fe7be$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $ac4a9effa24fe7be$var$He = "function" === typeof Object.is ? Object.is : $ac4a9effa24fe7be$var$Ge;
function $ac4a9effa24fe7be$var$Ie(a, b) {
    if ($ac4a9effa24fe7be$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$ac4a9effa24fe7be$var$ja.call(b, e) || !$ac4a9effa24fe7be$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $ac4a9effa24fe7be$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $ac4a9effa24fe7be$var$Ke(a, b) {
    var c = $ac4a9effa24fe7be$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $ac4a9effa24fe7be$var$Je(c);
    }
}
function $ac4a9effa24fe7be$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $ac4a9effa24fe7be$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $ac4a9effa24fe7be$var$Me() {
    for(var a = window, b = $ac4a9effa24fe7be$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $ac4a9effa24fe7be$var$Xa(a.document);
    }
    return b;
}
function $ac4a9effa24fe7be$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $ac4a9effa24fe7be$var$Oe(a) {
    var b = $ac4a9effa24fe7be$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $ac4a9effa24fe7be$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $ac4a9effa24fe7be$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $ac4a9effa24fe7be$var$Ke(c, f);
                var g = $ac4a9effa24fe7be$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $ac4a9effa24fe7be$var$Pe = $ac4a9effa24fe7be$var$ia && "documentMode" in document && 11 >= document.documentMode, $ac4a9effa24fe7be$var$Qe = null, $ac4a9effa24fe7be$var$Re = null, $ac4a9effa24fe7be$var$Se = null, $ac4a9effa24fe7be$var$Te = !1;
function $ac4a9effa24fe7be$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $ac4a9effa24fe7be$var$Te || null == $ac4a9effa24fe7be$var$Qe || $ac4a9effa24fe7be$var$Qe !== $ac4a9effa24fe7be$var$Xa(d) || (d = $ac4a9effa24fe7be$var$Qe, "selectionStart" in d && $ac4a9effa24fe7be$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $ac4a9effa24fe7be$var$Se && $ac4a9effa24fe7be$var$Ie($ac4a9effa24fe7be$var$Se, d) || ($ac4a9effa24fe7be$var$Se = d, d = $ac4a9effa24fe7be$var$oe($ac4a9effa24fe7be$var$Re, "onSelect"), 0 < d.length && (b = new $ac4a9effa24fe7be$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $ac4a9effa24fe7be$var$Qe)));
}
function $ac4a9effa24fe7be$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $ac4a9effa24fe7be$var$We = {
    animationend: $ac4a9effa24fe7be$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $ac4a9effa24fe7be$var$Ve("Animation", "AnimationIteration"),
    animationstart: $ac4a9effa24fe7be$var$Ve("Animation", "AnimationStart"),
    transitionend: $ac4a9effa24fe7be$var$Ve("Transition", "TransitionEnd")
}, $ac4a9effa24fe7be$var$Xe = {}, $ac4a9effa24fe7be$var$Ye = {};
$ac4a9effa24fe7be$var$ia && ($ac4a9effa24fe7be$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $ac4a9effa24fe7be$var$We.animationend.animation, delete $ac4a9effa24fe7be$var$We.animationiteration.animation, delete $ac4a9effa24fe7be$var$We.animationstart.animation), "TransitionEvent" in window || delete $ac4a9effa24fe7be$var$We.transitionend.transition);
function $ac4a9effa24fe7be$var$Ze(a) {
    if ($ac4a9effa24fe7be$var$Xe[a]) return $ac4a9effa24fe7be$var$Xe[a];
    if (!$ac4a9effa24fe7be$var$We[a]) return a;
    var b = $ac4a9effa24fe7be$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $ac4a9effa24fe7be$var$Ye) return $ac4a9effa24fe7be$var$Xe[a] = b[c];
    return a;
}
var $ac4a9effa24fe7be$var$$e = $ac4a9effa24fe7be$var$Ze("animationend"), $ac4a9effa24fe7be$var$af = $ac4a9effa24fe7be$var$Ze("animationiteration"), $ac4a9effa24fe7be$var$bf = $ac4a9effa24fe7be$var$Ze("animationstart"), $ac4a9effa24fe7be$var$cf = $ac4a9effa24fe7be$var$Ze("transitionend"), $ac4a9effa24fe7be$var$df = new Map, $ac4a9effa24fe7be$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $ac4a9effa24fe7be$var$ff(a, b) {
    $ac4a9effa24fe7be$var$df.set(a, b);
    $ac4a9effa24fe7be$var$fa(b, [
        a
    ]);
}
for(var $ac4a9effa24fe7be$var$gf = 0; $ac4a9effa24fe7be$var$gf < $ac4a9effa24fe7be$var$ef.length; $ac4a9effa24fe7be$var$gf++){
    var $ac4a9effa24fe7be$var$hf = $ac4a9effa24fe7be$var$ef[$ac4a9effa24fe7be$var$gf], $ac4a9effa24fe7be$var$jf = $ac4a9effa24fe7be$var$hf.toLowerCase(), $ac4a9effa24fe7be$var$kf = $ac4a9effa24fe7be$var$hf[0].toUpperCase() + $ac4a9effa24fe7be$var$hf.slice(1);
    $ac4a9effa24fe7be$var$ff($ac4a9effa24fe7be$var$jf, "on" + $ac4a9effa24fe7be$var$kf);
}
$ac4a9effa24fe7be$var$ff($ac4a9effa24fe7be$var$$e, "onAnimationEnd");
$ac4a9effa24fe7be$var$ff($ac4a9effa24fe7be$var$af, "onAnimationIteration");
$ac4a9effa24fe7be$var$ff($ac4a9effa24fe7be$var$bf, "onAnimationStart");
$ac4a9effa24fe7be$var$ff("dblclick", "onDoubleClick");
$ac4a9effa24fe7be$var$ff("focusin", "onFocus");
$ac4a9effa24fe7be$var$ff("focusout", "onBlur");
$ac4a9effa24fe7be$var$ff($ac4a9effa24fe7be$var$cf, "onTransitionEnd");
$ac4a9effa24fe7be$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$ac4a9effa24fe7be$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$ac4a9effa24fe7be$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$ac4a9effa24fe7be$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$ac4a9effa24fe7be$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$ac4a9effa24fe7be$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$ac4a9effa24fe7be$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$ac4a9effa24fe7be$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$ac4a9effa24fe7be$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$ac4a9effa24fe7be$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $ac4a9effa24fe7be$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $ac4a9effa24fe7be$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($ac4a9effa24fe7be$var$lf));
function $ac4a9effa24fe7be$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $ac4a9effa24fe7be$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $ac4a9effa24fe7be$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $ac4a9effa24fe7be$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $ac4a9effa24fe7be$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($ac4a9effa24fe7be$var$Qb) throw a = $ac4a9effa24fe7be$var$Rb, $ac4a9effa24fe7be$var$Qb = !1, $ac4a9effa24fe7be$var$Rb = null, a;
}
function $ac4a9effa24fe7be$var$D(a, b) {
    var c = b[$ac4a9effa24fe7be$var$of];
    void 0 === c && (c = b[$ac4a9effa24fe7be$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($ac4a9effa24fe7be$var$pf(b, a, 2, !1), c.add(d));
}
function $ac4a9effa24fe7be$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $ac4a9effa24fe7be$var$pf(c, a, d, b);
}
var $ac4a9effa24fe7be$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $ac4a9effa24fe7be$var$sf(a) {
    if (!a[$ac4a9effa24fe7be$var$rf]) {
        a[$ac4a9effa24fe7be$var$rf] = !0;
        $ac4a9effa24fe7be$var$da.forEach(function(b) {
            "selectionchange" !== b && ($ac4a9effa24fe7be$var$mf.has(b) || $ac4a9effa24fe7be$var$qf(b, !1, a), $ac4a9effa24fe7be$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$ac4a9effa24fe7be$var$rf] || (b[$ac4a9effa24fe7be$var$rf] = !0, $ac4a9effa24fe7be$var$qf("selectionchange", !1, b));
    }
}
function $ac4a9effa24fe7be$var$pf(a, b, c, d) {
    switch($ac4a9effa24fe7be$var$jd(b)){
        case 1:
            var e = $ac4a9effa24fe7be$var$ed;
            break;
        case 4:
            e = $ac4a9effa24fe7be$var$gd;
            break;
        default:
            e = $ac4a9effa24fe7be$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$ac4a9effa24fe7be$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $ac4a9effa24fe7be$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $ac4a9effa24fe7be$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $ac4a9effa24fe7be$var$Jb(function() {
        var d = f, e = $ac4a9effa24fe7be$var$xb(c), g = [];
        a: {
            var h = $ac4a9effa24fe7be$var$df.get(a);
            if (void 0 !== h) {
                var k = $ac4a9effa24fe7be$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $ac4a9effa24fe7be$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $ac4a9effa24fe7be$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $ac4a9effa24fe7be$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $ac4a9effa24fe7be$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $ac4a9effa24fe7be$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $ac4a9effa24fe7be$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $ac4a9effa24fe7be$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $ac4a9effa24fe7be$var$Vd;
                        break;
                    case $ac4a9effa24fe7be$var$$e:
                    case $ac4a9effa24fe7be$var$af:
                    case $ac4a9effa24fe7be$var$bf:
                        k = $ac4a9effa24fe7be$var$Hd;
                        break;
                    case $ac4a9effa24fe7be$var$cf:
                        k = $ac4a9effa24fe7be$var$Xd;
                        break;
                    case "scroll":
                        k = $ac4a9effa24fe7be$var$vd;
                        break;
                    case "wheel":
                        k = $ac4a9effa24fe7be$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $ac4a9effa24fe7be$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $ac4a9effa24fe7be$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $ac4a9effa24fe7be$var$Kb(w, x), null != F && t.push($ac4a9effa24fe7be$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $ac4a9effa24fe7be$var$wb && (n = c.relatedTarget || c.fromElement) && ($ac4a9effa24fe7be$var$Wc(n) || n[$ac4a9effa24fe7be$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $ac4a9effa24fe7be$var$Wc(n) : null, null !== n && (J = $ac4a9effa24fe7be$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $ac4a9effa24fe7be$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $ac4a9effa24fe7be$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $ac4a9effa24fe7be$var$ue(k);
                        u = null == n ? h : $ac4a9effa24fe7be$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $ac4a9effa24fe7be$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $ac4a9effa24fe7be$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $ac4a9effa24fe7be$var$vf(F))u++;
                            for(; 0 < w - u;)t = $ac4a9effa24fe7be$var$vf(t), w--;
                            for(; 0 < u - w;)x = $ac4a9effa24fe7be$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $ac4a9effa24fe7be$var$vf(t);
                                x = $ac4a9effa24fe7be$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $ac4a9effa24fe7be$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $ac4a9effa24fe7be$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $ac4a9effa24fe7be$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $ac4a9effa24fe7be$var$ve;
                else if ($ac4a9effa24fe7be$var$me(h)) {
                    if ($ac4a9effa24fe7be$var$we) na = $ac4a9effa24fe7be$var$Fe;
                    else {
                        na = $ac4a9effa24fe7be$var$De;
                        var xa = $ac4a9effa24fe7be$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $ac4a9effa24fe7be$var$Ee);
                if (na && (na = na(a, d))) {
                    $ac4a9effa24fe7be$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $ac4a9effa24fe7be$var$cb(h, "number", h.value);
            }
            xa = d ? $ac4a9effa24fe7be$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($ac4a9effa24fe7be$var$me(xa) || "true" === xa.contentEditable) $ac4a9effa24fe7be$var$Qe = xa, $ac4a9effa24fe7be$var$Re = d, $ac4a9effa24fe7be$var$Se = null;
                    break;
                case "focusout":
                    $ac4a9effa24fe7be$var$Se = $ac4a9effa24fe7be$var$Re = $ac4a9effa24fe7be$var$Qe = null;
                    break;
                case "mousedown":
                    $ac4a9effa24fe7be$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $ac4a9effa24fe7be$var$Te = !1;
                    $ac4a9effa24fe7be$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($ac4a9effa24fe7be$var$Pe) break;
                case "keydown":
                case "keyup":
                    $ac4a9effa24fe7be$var$Ue(g, c, e);
            }
            var $a;
            if ($ac4a9effa24fe7be$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $ac4a9effa24fe7be$var$ie ? $ac4a9effa24fe7be$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($ac4a9effa24fe7be$var$de && "ko" !== c.locale && ($ac4a9effa24fe7be$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $ac4a9effa24fe7be$var$ie && ($a = $ac4a9effa24fe7be$var$nd()) : ($ac4a9effa24fe7be$var$kd = e, $ac4a9effa24fe7be$var$ld = "value" in $ac4a9effa24fe7be$var$kd ? $ac4a9effa24fe7be$var$kd.value : $ac4a9effa24fe7be$var$kd.textContent, $ac4a9effa24fe7be$var$ie = !0)), xa = $ac4a9effa24fe7be$var$oe(d, ba), 0 < xa.length && (ba = new $ac4a9effa24fe7be$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $ac4a9effa24fe7be$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $ac4a9effa24fe7be$var$ce ? $ac4a9effa24fe7be$var$je(a, c) : $ac4a9effa24fe7be$var$ke(a, c)) d = $ac4a9effa24fe7be$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $ac4a9effa24fe7be$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $ac4a9effa24fe7be$var$se(g, b);
    });
}
function $ac4a9effa24fe7be$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $ac4a9effa24fe7be$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $ac4a9effa24fe7be$var$Kb(a, c), null != f && d.unshift($ac4a9effa24fe7be$var$tf(a, f, e)), f = $ac4a9effa24fe7be$var$Kb(a, b), null != f && d.push($ac4a9effa24fe7be$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $ac4a9effa24fe7be$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $ac4a9effa24fe7be$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $ac4a9effa24fe7be$var$Kb(c, f), null != k && g.unshift($ac4a9effa24fe7be$var$tf(c, k, h))) : e || (k = $ac4a9effa24fe7be$var$Kb(c, f), null != k && g.push($ac4a9effa24fe7be$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $ac4a9effa24fe7be$var$xf = /\r\n?/g, $ac4a9effa24fe7be$var$yf = /\u0000|\uFFFD/g;
function $ac4a9effa24fe7be$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($ac4a9effa24fe7be$var$xf, "\n").replace($ac4a9effa24fe7be$var$yf, "");
}
function $ac4a9effa24fe7be$var$Af(a, b, c) {
    b = $ac4a9effa24fe7be$var$zf(b);
    if ($ac4a9effa24fe7be$var$zf(a) !== b && c) throw Error($ac4a9effa24fe7be$var$p(425));
}
function $ac4a9effa24fe7be$var$Bf() {}
var $ac4a9effa24fe7be$var$Cf = null, $ac4a9effa24fe7be$var$Df = null;
function $ac4a9effa24fe7be$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $ac4a9effa24fe7be$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $ac4a9effa24fe7be$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $ac4a9effa24fe7be$var$Hf = "function" === typeof Promise ? Promise : void 0, $ac4a9effa24fe7be$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $ac4a9effa24fe7be$var$Hf ? function(a) {
    return $ac4a9effa24fe7be$var$Hf.resolve(null).then(a).catch($ac4a9effa24fe7be$var$If);
} : $ac4a9effa24fe7be$var$Ff;
function $ac4a9effa24fe7be$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $ac4a9effa24fe7be$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $ac4a9effa24fe7be$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $ac4a9effa24fe7be$var$bd(b);
}
function $ac4a9effa24fe7be$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $ac4a9effa24fe7be$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $ac4a9effa24fe7be$var$Nf = Math.random().toString(36).slice(2), $ac4a9effa24fe7be$var$Of = "__reactFiber$" + $ac4a9effa24fe7be$var$Nf, $ac4a9effa24fe7be$var$Pf = "__reactProps$" + $ac4a9effa24fe7be$var$Nf, $ac4a9effa24fe7be$var$uf = "__reactContainer$" + $ac4a9effa24fe7be$var$Nf, $ac4a9effa24fe7be$var$of = "__reactEvents$" + $ac4a9effa24fe7be$var$Nf, $ac4a9effa24fe7be$var$Qf = "__reactListeners$" + $ac4a9effa24fe7be$var$Nf, $ac4a9effa24fe7be$var$Rf = "__reactHandles$" + $ac4a9effa24fe7be$var$Nf;
function $ac4a9effa24fe7be$var$Wc(a) {
    var b = a[$ac4a9effa24fe7be$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$ac4a9effa24fe7be$var$uf] || c[$ac4a9effa24fe7be$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $ac4a9effa24fe7be$var$Mf(a); null !== a;){
                if (c = a[$ac4a9effa24fe7be$var$Of]) return c;
                a = $ac4a9effa24fe7be$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $ac4a9effa24fe7be$var$Cb(a) {
    a = a[$ac4a9effa24fe7be$var$Of] || a[$ac4a9effa24fe7be$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $ac4a9effa24fe7be$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($ac4a9effa24fe7be$var$p(33));
}
function $ac4a9effa24fe7be$var$Db(a) {
    return a[$ac4a9effa24fe7be$var$Pf] || null;
}
var $ac4a9effa24fe7be$var$Sf = [], $ac4a9effa24fe7be$var$Tf = -1;
function $ac4a9effa24fe7be$var$Uf(a) {
    return {
        current: a
    };
}
function $ac4a9effa24fe7be$var$E(a) {
    0 > $ac4a9effa24fe7be$var$Tf || (a.current = $ac4a9effa24fe7be$var$Sf[$ac4a9effa24fe7be$var$Tf], $ac4a9effa24fe7be$var$Sf[$ac4a9effa24fe7be$var$Tf] = null, $ac4a9effa24fe7be$var$Tf--);
}
function $ac4a9effa24fe7be$var$G(a, b) {
    $ac4a9effa24fe7be$var$Tf++;
    $ac4a9effa24fe7be$var$Sf[$ac4a9effa24fe7be$var$Tf] = a.current;
    a.current = b;
}
var $ac4a9effa24fe7be$var$Vf = {}, $ac4a9effa24fe7be$var$H = $ac4a9effa24fe7be$var$Uf($ac4a9effa24fe7be$var$Vf), $ac4a9effa24fe7be$var$Wf = $ac4a9effa24fe7be$var$Uf(!1), $ac4a9effa24fe7be$var$Xf = $ac4a9effa24fe7be$var$Vf;
function $ac4a9effa24fe7be$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $ac4a9effa24fe7be$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $ac4a9effa24fe7be$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $ac4a9effa24fe7be$var$$f() {
    $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$Wf);
    $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$H);
}
function $ac4a9effa24fe7be$var$ag(a, b, c) {
    if ($ac4a9effa24fe7be$var$H.current !== $ac4a9effa24fe7be$var$Vf) throw Error($ac4a9effa24fe7be$var$p(168));
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$H, b);
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$Wf, c);
}
function $ac4a9effa24fe7be$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($ac4a9effa24fe7be$var$p(108, $ac4a9effa24fe7be$var$Ra(a) || "Unknown", e));
    return $ac4a9effa24fe7be$var$A({}, c, d);
}
function $ac4a9effa24fe7be$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $ac4a9effa24fe7be$var$Vf;
    $ac4a9effa24fe7be$var$Xf = $ac4a9effa24fe7be$var$H.current;
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$H, a);
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$Wf, $ac4a9effa24fe7be$var$Wf.current);
    return !0;
}
function $ac4a9effa24fe7be$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($ac4a9effa24fe7be$var$p(169));
    c ? (a = $ac4a9effa24fe7be$var$bg(a, b, $ac4a9effa24fe7be$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$Wf), $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$H), $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$H, a)) : $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$Wf);
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$Wf, c);
}
var $ac4a9effa24fe7be$var$eg = null, $ac4a9effa24fe7be$var$fg = !1, $ac4a9effa24fe7be$var$gg = !1;
function $ac4a9effa24fe7be$var$hg(a) {
    null === $ac4a9effa24fe7be$var$eg ? $ac4a9effa24fe7be$var$eg = [
        a
    ] : $ac4a9effa24fe7be$var$eg.push(a);
}
function $ac4a9effa24fe7be$var$ig(a) {
    $ac4a9effa24fe7be$var$fg = !0;
    $ac4a9effa24fe7be$var$hg(a);
}
function $ac4a9effa24fe7be$var$jg() {
    if (!$ac4a9effa24fe7be$var$gg && null !== $ac4a9effa24fe7be$var$eg) {
        $ac4a9effa24fe7be$var$gg = !0;
        var a = 0, b = $ac4a9effa24fe7be$var$C;
        try {
            var c = $ac4a9effa24fe7be$var$eg;
            for($ac4a9effa24fe7be$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $ac4a9effa24fe7be$var$eg = null;
            $ac4a9effa24fe7be$var$fg = !1;
        } catch (e) {
            throw null !== $ac4a9effa24fe7be$var$eg && ($ac4a9effa24fe7be$var$eg = $ac4a9effa24fe7be$var$eg.slice(a + 1)), $ac4a9effa24fe7be$var$ac($ac4a9effa24fe7be$var$fc, $ac4a9effa24fe7be$var$jg), e;
        } finally{
            $ac4a9effa24fe7be$var$C = b, $ac4a9effa24fe7be$var$gg = !1;
        }
    }
    return null;
}
var $ac4a9effa24fe7be$var$kg = [], $ac4a9effa24fe7be$var$lg = 0, $ac4a9effa24fe7be$var$mg = null, $ac4a9effa24fe7be$var$ng = 0, $ac4a9effa24fe7be$var$og = [], $ac4a9effa24fe7be$var$pg = 0, $ac4a9effa24fe7be$var$qg = null, $ac4a9effa24fe7be$var$rg = 1, $ac4a9effa24fe7be$var$sg = "";
function $ac4a9effa24fe7be$var$tg(a, b) {
    $ac4a9effa24fe7be$var$kg[$ac4a9effa24fe7be$var$lg++] = $ac4a9effa24fe7be$var$ng;
    $ac4a9effa24fe7be$var$kg[$ac4a9effa24fe7be$var$lg++] = $ac4a9effa24fe7be$var$mg;
    $ac4a9effa24fe7be$var$mg = a;
    $ac4a9effa24fe7be$var$ng = b;
}
function $ac4a9effa24fe7be$var$ug(a, b, c) {
    $ac4a9effa24fe7be$var$og[$ac4a9effa24fe7be$var$pg++] = $ac4a9effa24fe7be$var$rg;
    $ac4a9effa24fe7be$var$og[$ac4a9effa24fe7be$var$pg++] = $ac4a9effa24fe7be$var$sg;
    $ac4a9effa24fe7be$var$og[$ac4a9effa24fe7be$var$pg++] = $ac4a9effa24fe7be$var$qg;
    $ac4a9effa24fe7be$var$qg = a;
    var d = $ac4a9effa24fe7be$var$rg;
    a = $ac4a9effa24fe7be$var$sg;
    var e = 32 - $ac4a9effa24fe7be$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $ac4a9effa24fe7be$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $ac4a9effa24fe7be$var$rg = 1 << 32 - $ac4a9effa24fe7be$var$oc(b) + e | c << e | d;
        $ac4a9effa24fe7be$var$sg = f + a;
    } else $ac4a9effa24fe7be$var$rg = 1 << f | c << e | d, $ac4a9effa24fe7be$var$sg = a;
}
function $ac4a9effa24fe7be$var$vg(a) {
    null !== a.return && ($ac4a9effa24fe7be$var$tg(a, 1), $ac4a9effa24fe7be$var$ug(a, 1, 0));
}
function $ac4a9effa24fe7be$var$wg(a) {
    for(; a === $ac4a9effa24fe7be$var$mg;)$ac4a9effa24fe7be$var$mg = $ac4a9effa24fe7be$var$kg[--$ac4a9effa24fe7be$var$lg], $ac4a9effa24fe7be$var$kg[$ac4a9effa24fe7be$var$lg] = null, $ac4a9effa24fe7be$var$ng = $ac4a9effa24fe7be$var$kg[--$ac4a9effa24fe7be$var$lg], $ac4a9effa24fe7be$var$kg[$ac4a9effa24fe7be$var$lg] = null;
    for(; a === $ac4a9effa24fe7be$var$qg;)$ac4a9effa24fe7be$var$qg = $ac4a9effa24fe7be$var$og[--$ac4a9effa24fe7be$var$pg], $ac4a9effa24fe7be$var$og[$ac4a9effa24fe7be$var$pg] = null, $ac4a9effa24fe7be$var$sg = $ac4a9effa24fe7be$var$og[--$ac4a9effa24fe7be$var$pg], $ac4a9effa24fe7be$var$og[$ac4a9effa24fe7be$var$pg] = null, $ac4a9effa24fe7be$var$rg = $ac4a9effa24fe7be$var$og[--$ac4a9effa24fe7be$var$pg], $ac4a9effa24fe7be$var$og[$ac4a9effa24fe7be$var$pg] = null;
}
var $ac4a9effa24fe7be$var$xg = null, $ac4a9effa24fe7be$var$yg = null, $ac4a9effa24fe7be$var$I = !1, $ac4a9effa24fe7be$var$zg = null;
function $ac4a9effa24fe7be$var$Ag(a, b) {
    var c = $ac4a9effa24fe7be$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $ac4a9effa24fe7be$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $ac4a9effa24fe7be$var$xg = a, $ac4a9effa24fe7be$var$yg = $ac4a9effa24fe7be$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $ac4a9effa24fe7be$var$xg = a, $ac4a9effa24fe7be$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $ac4a9effa24fe7be$var$qg ? {
                id: $ac4a9effa24fe7be$var$rg,
                overflow: $ac4a9effa24fe7be$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $ac4a9effa24fe7be$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $ac4a9effa24fe7be$var$xg = a, $ac4a9effa24fe7be$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $ac4a9effa24fe7be$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $ac4a9effa24fe7be$var$Eg(a) {
    if ($ac4a9effa24fe7be$var$I) {
        var b = $ac4a9effa24fe7be$var$yg;
        if (b) {
            var c = b;
            if (!$ac4a9effa24fe7be$var$Cg(a, b)) {
                if ($ac4a9effa24fe7be$var$Dg(a)) throw Error($ac4a9effa24fe7be$var$p(418));
                b = $ac4a9effa24fe7be$var$Lf(c.nextSibling);
                var d = $ac4a9effa24fe7be$var$xg;
                b && $ac4a9effa24fe7be$var$Cg(a, b) ? $ac4a9effa24fe7be$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $ac4a9effa24fe7be$var$I = !1, $ac4a9effa24fe7be$var$xg = a);
            }
        } else {
            if ($ac4a9effa24fe7be$var$Dg(a)) throw Error($ac4a9effa24fe7be$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $ac4a9effa24fe7be$var$I = !1;
            $ac4a9effa24fe7be$var$xg = a;
        }
    }
}
function $ac4a9effa24fe7be$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $ac4a9effa24fe7be$var$xg = a;
}
function $ac4a9effa24fe7be$var$Gg(a) {
    if (a !== $ac4a9effa24fe7be$var$xg) return !1;
    if (!$ac4a9effa24fe7be$var$I) return $ac4a9effa24fe7be$var$Fg(a), $ac4a9effa24fe7be$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$ac4a9effa24fe7be$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $ac4a9effa24fe7be$var$yg)) {
        if ($ac4a9effa24fe7be$var$Dg(a)) throw $ac4a9effa24fe7be$var$Hg(), Error($ac4a9effa24fe7be$var$p(418));
        for(; b;)$ac4a9effa24fe7be$var$Ag(a, b), b = $ac4a9effa24fe7be$var$Lf(b.nextSibling);
    }
    $ac4a9effa24fe7be$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($ac4a9effa24fe7be$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $ac4a9effa24fe7be$var$yg = $ac4a9effa24fe7be$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $ac4a9effa24fe7be$var$yg = null;
        }
    } else $ac4a9effa24fe7be$var$yg = $ac4a9effa24fe7be$var$xg ? $ac4a9effa24fe7be$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $ac4a9effa24fe7be$var$Hg() {
    for(var a = $ac4a9effa24fe7be$var$yg; a;)a = $ac4a9effa24fe7be$var$Lf(a.nextSibling);
}
function $ac4a9effa24fe7be$var$Ig() {
    $ac4a9effa24fe7be$var$yg = $ac4a9effa24fe7be$var$xg = null;
    $ac4a9effa24fe7be$var$I = !1;
}
function $ac4a9effa24fe7be$var$Jg(a) {
    null === $ac4a9effa24fe7be$var$zg ? $ac4a9effa24fe7be$var$zg = [
        a
    ] : $ac4a9effa24fe7be$var$zg.push(a);
}
var $ac4a9effa24fe7be$var$Kg = $ac4a9effa24fe7be$var$ua.ReactCurrentBatchConfig;
function $ac4a9effa24fe7be$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $ac4a9effa24fe7be$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $ac4a9effa24fe7be$var$Mg = $ac4a9effa24fe7be$var$Uf(null), $ac4a9effa24fe7be$var$Ng = null, $ac4a9effa24fe7be$var$Og = null, $ac4a9effa24fe7be$var$Pg = null;
function $ac4a9effa24fe7be$var$Qg() {
    $ac4a9effa24fe7be$var$Pg = $ac4a9effa24fe7be$var$Og = $ac4a9effa24fe7be$var$Ng = null;
}
function $ac4a9effa24fe7be$var$Rg(a) {
    var b = $ac4a9effa24fe7be$var$Mg.current;
    $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$Mg);
    a._currentValue = b;
}
function $ac4a9effa24fe7be$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $ac4a9effa24fe7be$var$Tg(a, b) {
    $ac4a9effa24fe7be$var$Ng = a;
    $ac4a9effa24fe7be$var$Pg = $ac4a9effa24fe7be$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($ac4a9effa24fe7be$var$Ug = !0), a.firstContext = null);
}
function $ac4a9effa24fe7be$var$Vg(a) {
    var b = a._currentValue;
    if ($ac4a9effa24fe7be$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $ac4a9effa24fe7be$var$Og) {
            if (null === $ac4a9effa24fe7be$var$Ng) throw Error($ac4a9effa24fe7be$var$p(308));
            $ac4a9effa24fe7be$var$Og = a;
            $ac4a9effa24fe7be$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $ac4a9effa24fe7be$var$Og = $ac4a9effa24fe7be$var$Og.next = a;
    }
    return b;
}
var $ac4a9effa24fe7be$var$Wg = null;
function $ac4a9effa24fe7be$var$Xg(a) {
    null === $ac4a9effa24fe7be$var$Wg ? $ac4a9effa24fe7be$var$Wg = [
        a
    ] : $ac4a9effa24fe7be$var$Wg.push(a);
}
function $ac4a9effa24fe7be$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $ac4a9effa24fe7be$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $ac4a9effa24fe7be$var$Zg(a, d);
}
function $ac4a9effa24fe7be$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $ac4a9effa24fe7be$var$$g = !1;
function $ac4a9effa24fe7be$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $ac4a9effa24fe7be$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $ac4a9effa24fe7be$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $ac4a9effa24fe7be$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($ac4a9effa24fe7be$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $ac4a9effa24fe7be$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $ac4a9effa24fe7be$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $ac4a9effa24fe7be$var$Zg(a, c);
}
function $ac4a9effa24fe7be$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $ac4a9effa24fe7be$var$Cc(a, c);
    }
}
function $ac4a9effa24fe7be$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $ac4a9effa24fe7be$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $ac4a9effa24fe7be$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $ac4a9effa24fe7be$var$A({}, q, r);
                            break a;
                        case 2:
                            $ac4a9effa24fe7be$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $ac4a9effa24fe7be$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $ac4a9effa24fe7be$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($ac4a9effa24fe7be$var$p(191, e));
            e.call(d);
        }
    }
}
var $ac4a9effa24fe7be$var$jh = (new $gIfym.Component).refs;
function $ac4a9effa24fe7be$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $ac4a9effa24fe7be$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $ac4a9effa24fe7be$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $ac4a9effa24fe7be$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $ac4a9effa24fe7be$var$L(), e = $ac4a9effa24fe7be$var$lh(a), f = $ac4a9effa24fe7be$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $ac4a9effa24fe7be$var$dh(a, f, e);
        null !== b && ($ac4a9effa24fe7be$var$mh(b, a, e, d), $ac4a9effa24fe7be$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $ac4a9effa24fe7be$var$L(), e = $ac4a9effa24fe7be$var$lh(a), f = $ac4a9effa24fe7be$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $ac4a9effa24fe7be$var$dh(a, f, e);
        null !== b && ($ac4a9effa24fe7be$var$mh(b, a, e, d), $ac4a9effa24fe7be$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $ac4a9effa24fe7be$var$L(), d = $ac4a9effa24fe7be$var$lh(a), e = $ac4a9effa24fe7be$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $ac4a9effa24fe7be$var$dh(a, e, d);
        null !== b && ($ac4a9effa24fe7be$var$mh(b, a, d, c), $ac4a9effa24fe7be$var$eh(b, a, d));
    }
};
function $ac4a9effa24fe7be$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$ac4a9effa24fe7be$var$Ie(c, d) || !$ac4a9effa24fe7be$var$Ie(e, f) : !0;
}
function $ac4a9effa24fe7be$var$ph(a, b, c) {
    var d = !1, e = $ac4a9effa24fe7be$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $ac4a9effa24fe7be$var$Vg(f) : (e = $ac4a9effa24fe7be$var$Zf(b) ? $ac4a9effa24fe7be$var$Xf : $ac4a9effa24fe7be$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $ac4a9effa24fe7be$var$Yf(a, e) : $ac4a9effa24fe7be$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $ac4a9effa24fe7be$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $ac4a9effa24fe7be$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $ac4a9effa24fe7be$var$nh.enqueueReplaceState(b, b.state, null);
}
function $ac4a9effa24fe7be$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $ac4a9effa24fe7be$var$jh;
    $ac4a9effa24fe7be$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $ac4a9effa24fe7be$var$Vg(f) : (f = $ac4a9effa24fe7be$var$Zf(b) ? $ac4a9effa24fe7be$var$Xf : $ac4a9effa24fe7be$var$H.current, e.context = $ac4a9effa24fe7be$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($ac4a9effa24fe7be$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $ac4a9effa24fe7be$var$nh.enqueueReplaceState(e, e.state, null), $ac4a9effa24fe7be$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $ac4a9effa24fe7be$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($ac4a9effa24fe7be$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($ac4a9effa24fe7be$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $ac4a9effa24fe7be$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($ac4a9effa24fe7be$var$p(284));
        if (!c._owner) throw Error($ac4a9effa24fe7be$var$p(290, a));
    }
    return a;
}
function $ac4a9effa24fe7be$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($ac4a9effa24fe7be$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $ac4a9effa24fe7be$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $ac4a9effa24fe7be$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $ac4a9effa24fe7be$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $ac4a9effa24fe7be$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $ac4a9effa24fe7be$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $ac4a9effa24fe7be$var$Ha && $ac4a9effa24fe7be$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $ac4a9effa24fe7be$var$sh(a, b, c), d.return = a, d;
        d = $ac4a9effa24fe7be$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $ac4a9effa24fe7be$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $ac4a9effa24fe7be$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $ac4a9effa24fe7be$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $ac4a9effa24fe7be$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $ac4a9effa24fe7be$var$va:
                    return c = $ac4a9effa24fe7be$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $ac4a9effa24fe7be$var$sh(a, null, b), c.return = a, c;
                case $ac4a9effa24fe7be$var$wa:
                    return b = $ac4a9effa24fe7be$var$zh(b, a.mode, c), b.return = a, b;
                case $ac4a9effa24fe7be$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($ac4a9effa24fe7be$var$eb(b) || $ac4a9effa24fe7be$var$Ka(b)) return b = $ac4a9effa24fe7be$var$Ah(b, a.mode, c, null), b.return = a, b;
            $ac4a9effa24fe7be$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $ac4a9effa24fe7be$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $ac4a9effa24fe7be$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $ac4a9effa24fe7be$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($ac4a9effa24fe7be$var$eb(c) || $ac4a9effa24fe7be$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $ac4a9effa24fe7be$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $ac4a9effa24fe7be$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $ac4a9effa24fe7be$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $ac4a9effa24fe7be$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($ac4a9effa24fe7be$var$eb(d) || $ac4a9effa24fe7be$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $ac4a9effa24fe7be$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $ac4a9effa24fe7be$var$I && $ac4a9effa24fe7be$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $ac4a9effa24fe7be$var$I && $ac4a9effa24fe7be$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $ac4a9effa24fe7be$var$I && $ac4a9effa24fe7be$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $ac4a9effa24fe7be$var$Ka(h);
        if ("function" !== typeof l) throw Error($ac4a9effa24fe7be$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($ac4a9effa24fe7be$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $ac4a9effa24fe7be$var$I && $ac4a9effa24fe7be$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $ac4a9effa24fe7be$var$I && $ac4a9effa24fe7be$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $ac4a9effa24fe7be$var$I && $ac4a9effa24fe7be$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $ac4a9effa24fe7be$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $ac4a9effa24fe7be$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $ac4a9effa24fe7be$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $ac4a9effa24fe7be$var$Ha && $ac4a9effa24fe7be$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $ac4a9effa24fe7be$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $ac4a9effa24fe7be$var$ya ? (d = $ac4a9effa24fe7be$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $ac4a9effa24fe7be$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $ac4a9effa24fe7be$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $ac4a9effa24fe7be$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $ac4a9effa24fe7be$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $ac4a9effa24fe7be$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($ac4a9effa24fe7be$var$eb(f)) return n(a, d, f, h);
            if ($ac4a9effa24fe7be$var$Ka(f)) return t(a, d, f, h);
            $ac4a9effa24fe7be$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $ac4a9effa24fe7be$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $ac4a9effa24fe7be$var$Bh = $ac4a9effa24fe7be$var$vh(!0), $ac4a9effa24fe7be$var$Ch = $ac4a9effa24fe7be$var$vh(!1), $ac4a9effa24fe7be$var$Dh = {}, $ac4a9effa24fe7be$var$Eh = $ac4a9effa24fe7be$var$Uf($ac4a9effa24fe7be$var$Dh), $ac4a9effa24fe7be$var$Fh = $ac4a9effa24fe7be$var$Uf($ac4a9effa24fe7be$var$Dh), $ac4a9effa24fe7be$var$Gh = $ac4a9effa24fe7be$var$Uf($ac4a9effa24fe7be$var$Dh);
function $ac4a9effa24fe7be$var$Hh(a) {
    if (a === $ac4a9effa24fe7be$var$Dh) throw Error($ac4a9effa24fe7be$var$p(174));
    return a;
}
function $ac4a9effa24fe7be$var$Ih(a, b) {
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$Gh, b);
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$Fh, a);
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$Eh, $ac4a9effa24fe7be$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $ac4a9effa24fe7be$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $ac4a9effa24fe7be$var$lb(b, a);
    }
    $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$Eh);
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$Eh, b);
}
function $ac4a9effa24fe7be$var$Jh() {
    $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$Eh);
    $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$Fh);
    $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$Gh);
}
function $ac4a9effa24fe7be$var$Kh(a) {
    $ac4a9effa24fe7be$var$Hh($ac4a9effa24fe7be$var$Gh.current);
    var b = $ac4a9effa24fe7be$var$Hh($ac4a9effa24fe7be$var$Eh.current);
    var c = $ac4a9effa24fe7be$var$lb(b, a.type);
    b !== c && ($ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$Fh, a), $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$Eh, c));
}
function $ac4a9effa24fe7be$var$Lh(a) {
    $ac4a9effa24fe7be$var$Fh.current === a && ($ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$Eh), $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$Fh));
}
var $ac4a9effa24fe7be$var$M = $ac4a9effa24fe7be$var$Uf(0);
function $ac4a9effa24fe7be$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $ac4a9effa24fe7be$var$Nh = [];
function $ac4a9effa24fe7be$var$Oh() {
    for(var a = 0; a < $ac4a9effa24fe7be$var$Nh.length; a++)$ac4a9effa24fe7be$var$Nh[a]._workInProgressVersionPrimary = null;
    $ac4a9effa24fe7be$var$Nh.length = 0;
}
var $ac4a9effa24fe7be$var$Ph = $ac4a9effa24fe7be$var$ua.ReactCurrentDispatcher, $ac4a9effa24fe7be$var$Qh = $ac4a9effa24fe7be$var$ua.ReactCurrentBatchConfig, $ac4a9effa24fe7be$var$Rh = 0, $ac4a9effa24fe7be$var$N = null, $ac4a9effa24fe7be$var$O = null, $ac4a9effa24fe7be$var$P = null, $ac4a9effa24fe7be$var$Sh = !1, $ac4a9effa24fe7be$var$Th = !1, $ac4a9effa24fe7be$var$Uh = 0, $ac4a9effa24fe7be$var$Vh = 0;
function $ac4a9effa24fe7be$var$Q() {
    throw Error($ac4a9effa24fe7be$var$p(321));
}
function $ac4a9effa24fe7be$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$ac4a9effa24fe7be$var$He(a[c], b[c])) return !1;
    return !0;
}
function $ac4a9effa24fe7be$var$Xh(a, b, c, d, e, f) {
    $ac4a9effa24fe7be$var$Rh = f;
    $ac4a9effa24fe7be$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $ac4a9effa24fe7be$var$Ph.current = null === a || null === a.memoizedState ? $ac4a9effa24fe7be$var$Yh : $ac4a9effa24fe7be$var$Zh;
    a = c(d, e);
    if ($ac4a9effa24fe7be$var$Th) {
        f = 0;
        do {
            $ac4a9effa24fe7be$var$Th = !1;
            $ac4a9effa24fe7be$var$Uh = 0;
            if (25 <= f) throw Error($ac4a9effa24fe7be$var$p(301));
            f += 1;
            $ac4a9effa24fe7be$var$P = $ac4a9effa24fe7be$var$O = null;
            b.updateQueue = null;
            $ac4a9effa24fe7be$var$Ph.current = $ac4a9effa24fe7be$var$$h;
            a = c(d, e);
        }while ($ac4a9effa24fe7be$var$Th);
    }
    $ac4a9effa24fe7be$var$Ph.current = $ac4a9effa24fe7be$var$ai;
    b = null !== $ac4a9effa24fe7be$var$O && null !== $ac4a9effa24fe7be$var$O.next;
    $ac4a9effa24fe7be$var$Rh = 0;
    $ac4a9effa24fe7be$var$P = $ac4a9effa24fe7be$var$O = $ac4a9effa24fe7be$var$N = null;
    $ac4a9effa24fe7be$var$Sh = !1;
    if (b) throw Error($ac4a9effa24fe7be$var$p(300));
    return a;
}
function $ac4a9effa24fe7be$var$bi() {
    var a = 0 !== $ac4a9effa24fe7be$var$Uh;
    $ac4a9effa24fe7be$var$Uh = 0;
    return a;
}
function $ac4a9effa24fe7be$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $ac4a9effa24fe7be$var$P ? $ac4a9effa24fe7be$var$N.memoizedState = $ac4a9effa24fe7be$var$P = a : $ac4a9effa24fe7be$var$P = $ac4a9effa24fe7be$var$P.next = a;
    return $ac4a9effa24fe7be$var$P;
}
function $ac4a9effa24fe7be$var$di() {
    if (null === $ac4a9effa24fe7be$var$O) {
        var a = $ac4a9effa24fe7be$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $ac4a9effa24fe7be$var$O.next;
    var b = null === $ac4a9effa24fe7be$var$P ? $ac4a9effa24fe7be$var$N.memoizedState : $ac4a9effa24fe7be$var$P.next;
    if (null !== b) $ac4a9effa24fe7be$var$P = b, $ac4a9effa24fe7be$var$O = a;
    else {
        if (null === a) throw Error($ac4a9effa24fe7be$var$p(310));
        $ac4a9effa24fe7be$var$O = a;
        a = {
            memoizedState: $ac4a9effa24fe7be$var$O.memoizedState,
            baseState: $ac4a9effa24fe7be$var$O.baseState,
            baseQueue: $ac4a9effa24fe7be$var$O.baseQueue,
            queue: $ac4a9effa24fe7be$var$O.queue,
            next: null
        };
        null === $ac4a9effa24fe7be$var$P ? $ac4a9effa24fe7be$var$N.memoizedState = $ac4a9effa24fe7be$var$P = a : $ac4a9effa24fe7be$var$P = $ac4a9effa24fe7be$var$P.next = a;
    }
    return $ac4a9effa24fe7be$var$P;
}
function $ac4a9effa24fe7be$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $ac4a9effa24fe7be$var$fi(a) {
    var b = $ac4a9effa24fe7be$var$di(), c = b.queue;
    if (null === c) throw Error($ac4a9effa24fe7be$var$p(311));
    c.lastRenderedReducer = a;
    var d = $ac4a9effa24fe7be$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($ac4a9effa24fe7be$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $ac4a9effa24fe7be$var$N.lanes |= m;
                $ac4a9effa24fe7be$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $ac4a9effa24fe7be$var$He(d, b.memoizedState) || ($ac4a9effa24fe7be$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $ac4a9effa24fe7be$var$N.lanes |= f, $ac4a9effa24fe7be$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $ac4a9effa24fe7be$var$gi(a) {
    var b = $ac4a9effa24fe7be$var$di(), c = b.queue;
    if (null === c) throw Error($ac4a9effa24fe7be$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $ac4a9effa24fe7be$var$He(f, b.memoizedState) || ($ac4a9effa24fe7be$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $ac4a9effa24fe7be$var$hi() {}
function $ac4a9effa24fe7be$var$ii(a, b) {
    var c = $ac4a9effa24fe7be$var$N, d = $ac4a9effa24fe7be$var$di(), e = b(), f = !$ac4a9effa24fe7be$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $ac4a9effa24fe7be$var$Ug = !0);
    d = d.queue;
    $ac4a9effa24fe7be$var$ji($ac4a9effa24fe7be$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $ac4a9effa24fe7be$var$P && $ac4a9effa24fe7be$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $ac4a9effa24fe7be$var$li(9, $ac4a9effa24fe7be$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $ac4a9effa24fe7be$var$R) throw Error($ac4a9effa24fe7be$var$p(349));
        0 !== ($ac4a9effa24fe7be$var$Rh & 30) || $ac4a9effa24fe7be$var$ni(c, b, e);
    }
    return e;
}
function $ac4a9effa24fe7be$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $ac4a9effa24fe7be$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $ac4a9effa24fe7be$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $ac4a9effa24fe7be$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $ac4a9effa24fe7be$var$oi(b) && $ac4a9effa24fe7be$var$pi(a);
}
function $ac4a9effa24fe7be$var$ki(a, b, c) {
    return c(function() {
        $ac4a9effa24fe7be$var$oi(b) && $ac4a9effa24fe7be$var$pi(a);
    });
}
function $ac4a9effa24fe7be$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$ac4a9effa24fe7be$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $ac4a9effa24fe7be$var$pi(a) {
    var b = $ac4a9effa24fe7be$var$Zg(a, 1);
    null !== b && $ac4a9effa24fe7be$var$mh(b, a, 1, -1);
}
function $ac4a9effa24fe7be$var$qi(a) {
    var b = $ac4a9effa24fe7be$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $ac4a9effa24fe7be$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $ac4a9effa24fe7be$var$ri.bind(null, $ac4a9effa24fe7be$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $ac4a9effa24fe7be$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $ac4a9effa24fe7be$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $ac4a9effa24fe7be$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $ac4a9effa24fe7be$var$si() {
    return $ac4a9effa24fe7be$var$di().memoizedState;
}
function $ac4a9effa24fe7be$var$ti(a, b, c, d) {
    var e = $ac4a9effa24fe7be$var$ci();
    $ac4a9effa24fe7be$var$N.flags |= a;
    e.memoizedState = $ac4a9effa24fe7be$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $ac4a9effa24fe7be$var$ui(a, b, c, d) {
    var e = $ac4a9effa24fe7be$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $ac4a9effa24fe7be$var$O) {
        var g = $ac4a9effa24fe7be$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $ac4a9effa24fe7be$var$Wh(d, g.deps)) {
            e.memoizedState = $ac4a9effa24fe7be$var$li(b, c, f, d);
            return;
        }
    }
    $ac4a9effa24fe7be$var$N.flags |= a;
    e.memoizedState = $ac4a9effa24fe7be$var$li(1 | b, c, f, d);
}
function $ac4a9effa24fe7be$var$vi(a, b) {
    return $ac4a9effa24fe7be$var$ti(8390656, 8, a, b);
}
function $ac4a9effa24fe7be$var$ji(a, b) {
    return $ac4a9effa24fe7be$var$ui(2048, 8, a, b);
}
function $ac4a9effa24fe7be$var$wi(a, b) {
    return $ac4a9effa24fe7be$var$ui(4, 2, a, b);
}
function $ac4a9effa24fe7be$var$xi(a, b) {
    return $ac4a9effa24fe7be$var$ui(4, 4, a, b);
}
function $ac4a9effa24fe7be$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $ac4a9effa24fe7be$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $ac4a9effa24fe7be$var$ui(4, 4, $ac4a9effa24fe7be$var$yi.bind(null, b, a), c);
}
function $ac4a9effa24fe7be$var$Ai() {}
function $ac4a9effa24fe7be$var$Bi(a, b) {
    var c = $ac4a9effa24fe7be$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $ac4a9effa24fe7be$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $ac4a9effa24fe7be$var$Ci(a, b) {
    var c = $ac4a9effa24fe7be$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $ac4a9effa24fe7be$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $ac4a9effa24fe7be$var$Di(a, b, c) {
    if (0 === ($ac4a9effa24fe7be$var$Rh & 21)) return a.baseState && (a.baseState = !1, $ac4a9effa24fe7be$var$Ug = !0), a.memoizedState = c;
    $ac4a9effa24fe7be$var$He(c, b) || (c = $ac4a9effa24fe7be$var$yc(), $ac4a9effa24fe7be$var$N.lanes |= c, $ac4a9effa24fe7be$var$hh |= c, a.baseState = !0);
    return b;
}
function $ac4a9effa24fe7be$var$Ei(a, b) {
    var c = $ac4a9effa24fe7be$var$C;
    $ac4a9effa24fe7be$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $ac4a9effa24fe7be$var$Qh.transition;
    $ac4a9effa24fe7be$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $ac4a9effa24fe7be$var$C = c, $ac4a9effa24fe7be$var$Qh.transition = d;
    }
}
function $ac4a9effa24fe7be$var$Fi() {
    return $ac4a9effa24fe7be$var$di().memoizedState;
}
function $ac4a9effa24fe7be$var$Gi(a, b, c) {
    var d = $ac4a9effa24fe7be$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($ac4a9effa24fe7be$var$Hi(a)) $ac4a9effa24fe7be$var$Ii(b, c);
    else if (c = $ac4a9effa24fe7be$var$Yg(a, b, c, d), null !== c) {
        var e = $ac4a9effa24fe7be$var$L();
        $ac4a9effa24fe7be$var$mh(c, a, d, e);
        $ac4a9effa24fe7be$var$Ji(c, b, d);
    }
}
function $ac4a9effa24fe7be$var$ri(a, b, c) {
    var d = $ac4a9effa24fe7be$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($ac4a9effa24fe7be$var$Hi(a)) $ac4a9effa24fe7be$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($ac4a9effa24fe7be$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $ac4a9effa24fe7be$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $ac4a9effa24fe7be$var$Yg(a, b, e, d);
        null !== c && (e = $ac4a9effa24fe7be$var$L(), $ac4a9effa24fe7be$var$mh(c, a, d, e), $ac4a9effa24fe7be$var$Ji(c, b, d));
    }
}
function $ac4a9effa24fe7be$var$Hi(a) {
    var b = a.alternate;
    return a === $ac4a9effa24fe7be$var$N || null !== b && b === $ac4a9effa24fe7be$var$N;
}
function $ac4a9effa24fe7be$var$Ii(a, b) {
    $ac4a9effa24fe7be$var$Th = $ac4a9effa24fe7be$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $ac4a9effa24fe7be$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $ac4a9effa24fe7be$var$Cc(a, c);
    }
}
var $ac4a9effa24fe7be$var$ai = {
    readContext: $ac4a9effa24fe7be$var$Vg,
    useCallback: $ac4a9effa24fe7be$var$Q,
    useContext: $ac4a9effa24fe7be$var$Q,
    useEffect: $ac4a9effa24fe7be$var$Q,
    useImperativeHandle: $ac4a9effa24fe7be$var$Q,
    useInsertionEffect: $ac4a9effa24fe7be$var$Q,
    useLayoutEffect: $ac4a9effa24fe7be$var$Q,
    useMemo: $ac4a9effa24fe7be$var$Q,
    useReducer: $ac4a9effa24fe7be$var$Q,
    useRef: $ac4a9effa24fe7be$var$Q,
    useState: $ac4a9effa24fe7be$var$Q,
    useDebugValue: $ac4a9effa24fe7be$var$Q,
    useDeferredValue: $ac4a9effa24fe7be$var$Q,
    useTransition: $ac4a9effa24fe7be$var$Q,
    useMutableSource: $ac4a9effa24fe7be$var$Q,
    useSyncExternalStore: $ac4a9effa24fe7be$var$Q,
    useId: $ac4a9effa24fe7be$var$Q,
    unstable_isNewReconciler: !1
}, $ac4a9effa24fe7be$var$Yh = {
    readContext: $ac4a9effa24fe7be$var$Vg,
    useCallback: function(a, b) {
        $ac4a9effa24fe7be$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $ac4a9effa24fe7be$var$Vg,
    useEffect: $ac4a9effa24fe7be$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $ac4a9effa24fe7be$var$ti(4194308, 4, $ac4a9effa24fe7be$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $ac4a9effa24fe7be$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $ac4a9effa24fe7be$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $ac4a9effa24fe7be$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $ac4a9effa24fe7be$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $ac4a9effa24fe7be$var$Gi.bind(null, $ac4a9effa24fe7be$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $ac4a9effa24fe7be$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $ac4a9effa24fe7be$var$qi,
    useDebugValue: $ac4a9effa24fe7be$var$Ai,
    useDeferredValue: function(a) {
        return $ac4a9effa24fe7be$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $ac4a9effa24fe7be$var$qi(!1), b = a[0];
        a = $ac4a9effa24fe7be$var$Ei.bind(null, a[1]);
        $ac4a9effa24fe7be$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $ac4a9effa24fe7be$var$N, e = $ac4a9effa24fe7be$var$ci();
        if ($ac4a9effa24fe7be$var$I) {
            if (void 0 === c) throw Error($ac4a9effa24fe7be$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $ac4a9effa24fe7be$var$R) throw Error($ac4a9effa24fe7be$var$p(349));
            0 !== ($ac4a9effa24fe7be$var$Rh & 30) || $ac4a9effa24fe7be$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $ac4a9effa24fe7be$var$vi($ac4a9effa24fe7be$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $ac4a9effa24fe7be$var$li(9, $ac4a9effa24fe7be$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $ac4a9effa24fe7be$var$ci(), b = $ac4a9effa24fe7be$var$R.identifierPrefix;
        if ($ac4a9effa24fe7be$var$I) {
            var c = $ac4a9effa24fe7be$var$sg;
            var d = $ac4a9effa24fe7be$var$rg;
            c = (d & ~(1 << 32 - $ac4a9effa24fe7be$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $ac4a9effa24fe7be$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $ac4a9effa24fe7be$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $ac4a9effa24fe7be$var$Zh = {
    readContext: $ac4a9effa24fe7be$var$Vg,
    useCallback: $ac4a9effa24fe7be$var$Bi,
    useContext: $ac4a9effa24fe7be$var$Vg,
    useEffect: $ac4a9effa24fe7be$var$ji,
    useImperativeHandle: $ac4a9effa24fe7be$var$zi,
    useInsertionEffect: $ac4a9effa24fe7be$var$wi,
    useLayoutEffect: $ac4a9effa24fe7be$var$xi,
    useMemo: $ac4a9effa24fe7be$var$Ci,
    useReducer: $ac4a9effa24fe7be$var$fi,
    useRef: $ac4a9effa24fe7be$var$si,
    useState: function() {
        return $ac4a9effa24fe7be$var$fi($ac4a9effa24fe7be$var$ei);
    },
    useDebugValue: $ac4a9effa24fe7be$var$Ai,
    useDeferredValue: function(a) {
        var b = $ac4a9effa24fe7be$var$di();
        return $ac4a9effa24fe7be$var$Di(b, $ac4a9effa24fe7be$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $ac4a9effa24fe7be$var$fi($ac4a9effa24fe7be$var$ei)[0], b = $ac4a9effa24fe7be$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $ac4a9effa24fe7be$var$hi,
    useSyncExternalStore: $ac4a9effa24fe7be$var$ii,
    useId: $ac4a9effa24fe7be$var$Fi,
    unstable_isNewReconciler: !1
}, $ac4a9effa24fe7be$var$$h = {
    readContext: $ac4a9effa24fe7be$var$Vg,
    useCallback: $ac4a9effa24fe7be$var$Bi,
    useContext: $ac4a9effa24fe7be$var$Vg,
    useEffect: $ac4a9effa24fe7be$var$ji,
    useImperativeHandle: $ac4a9effa24fe7be$var$zi,
    useInsertionEffect: $ac4a9effa24fe7be$var$wi,
    useLayoutEffect: $ac4a9effa24fe7be$var$xi,
    useMemo: $ac4a9effa24fe7be$var$Ci,
    useReducer: $ac4a9effa24fe7be$var$gi,
    useRef: $ac4a9effa24fe7be$var$si,
    useState: function() {
        return $ac4a9effa24fe7be$var$gi($ac4a9effa24fe7be$var$ei);
    },
    useDebugValue: $ac4a9effa24fe7be$var$Ai,
    useDeferredValue: function(a) {
        var b = $ac4a9effa24fe7be$var$di();
        return null === $ac4a9effa24fe7be$var$O ? b.memoizedState = a : $ac4a9effa24fe7be$var$Di(b, $ac4a9effa24fe7be$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $ac4a9effa24fe7be$var$gi($ac4a9effa24fe7be$var$ei)[0], b = $ac4a9effa24fe7be$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $ac4a9effa24fe7be$var$hi,
    useSyncExternalStore: $ac4a9effa24fe7be$var$ii,
    useId: $ac4a9effa24fe7be$var$Fi,
    unstable_isNewReconciler: !1
};
function $ac4a9effa24fe7be$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $ac4a9effa24fe7be$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $ac4a9effa24fe7be$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $ac4a9effa24fe7be$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $ac4a9effa24fe7be$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $ac4a9effa24fe7be$var$Oi(a, b, c) {
    c = $ac4a9effa24fe7be$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $ac4a9effa24fe7be$var$Pi || ($ac4a9effa24fe7be$var$Pi = !0, $ac4a9effa24fe7be$var$Qi = d);
        $ac4a9effa24fe7be$var$Mi(a, b);
    };
    return c;
}
function $ac4a9effa24fe7be$var$Ri(a, b, c) {
    c = $ac4a9effa24fe7be$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $ac4a9effa24fe7be$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $ac4a9effa24fe7be$var$Mi(a, b);
        "function" !== typeof d && (null === $ac4a9effa24fe7be$var$Si ? $ac4a9effa24fe7be$var$Si = new Set([
            this
        ]) : $ac4a9effa24fe7be$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $ac4a9effa24fe7be$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $ac4a9effa24fe7be$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $ac4a9effa24fe7be$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $ac4a9effa24fe7be$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $ac4a9effa24fe7be$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $ac4a9effa24fe7be$var$ch(-1, 1), b.tag = 2, $ac4a9effa24fe7be$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $ac4a9effa24fe7be$var$Xi = $ac4a9effa24fe7be$var$ua.ReactCurrentOwner, $ac4a9effa24fe7be$var$Ug = !1;
function $ac4a9effa24fe7be$var$Yi(a, b, c, d) {
    b.child = null === a ? $ac4a9effa24fe7be$var$Ch(b, null, c, d) : $ac4a9effa24fe7be$var$Bh(b, a.child, c, d);
}
function $ac4a9effa24fe7be$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $ac4a9effa24fe7be$var$Tg(b, e);
    d = $ac4a9effa24fe7be$var$Xh(a, b, c, d, f, e);
    c = $ac4a9effa24fe7be$var$bi();
    if (null !== a && !$ac4a9effa24fe7be$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $ac4a9effa24fe7be$var$$i(a, b, e);
    $ac4a9effa24fe7be$var$I && c && $ac4a9effa24fe7be$var$vg(b);
    b.flags |= 1;
    $ac4a9effa24fe7be$var$Yi(a, b, d, e);
    return b.child;
}
function $ac4a9effa24fe7be$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$ac4a9effa24fe7be$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $ac4a9effa24fe7be$var$cj(a, b, f, d, e);
        a = $ac4a9effa24fe7be$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $ac4a9effa24fe7be$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $ac4a9effa24fe7be$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $ac4a9effa24fe7be$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $ac4a9effa24fe7be$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($ac4a9effa24fe7be$var$Ie(f, d) && a.ref === b.ref) {
            if ($ac4a9effa24fe7be$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($ac4a9effa24fe7be$var$Ug = !0);
            else return b.lanes = a.lanes, $ac4a9effa24fe7be$var$$i(a, b, e);
        }
    }
    return $ac4a9effa24fe7be$var$dj(a, b, c, d, e);
}
function $ac4a9effa24fe7be$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$fj, $ac4a9effa24fe7be$var$gj), $ac4a9effa24fe7be$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$fj, $ac4a9effa24fe7be$var$gj), $ac4a9effa24fe7be$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$fj, $ac4a9effa24fe7be$var$gj);
            $ac4a9effa24fe7be$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$fj, $ac4a9effa24fe7be$var$gj), $ac4a9effa24fe7be$var$gj |= d;
    $ac4a9effa24fe7be$var$Yi(a, b, e, c);
    return b.child;
}
function $ac4a9effa24fe7be$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $ac4a9effa24fe7be$var$dj(a, b, c, d, e) {
    var f = $ac4a9effa24fe7be$var$Zf(c) ? $ac4a9effa24fe7be$var$Xf : $ac4a9effa24fe7be$var$H.current;
    f = $ac4a9effa24fe7be$var$Yf(b, f);
    $ac4a9effa24fe7be$var$Tg(b, e);
    c = $ac4a9effa24fe7be$var$Xh(a, b, c, d, f, e);
    d = $ac4a9effa24fe7be$var$bi();
    if (null !== a && !$ac4a9effa24fe7be$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $ac4a9effa24fe7be$var$$i(a, b, e);
    $ac4a9effa24fe7be$var$I && d && $ac4a9effa24fe7be$var$vg(b);
    b.flags |= 1;
    $ac4a9effa24fe7be$var$Yi(a, b, c, e);
    return b.child;
}
function $ac4a9effa24fe7be$var$ij(a, b, c, d, e) {
    if ($ac4a9effa24fe7be$var$Zf(c)) {
        var f = !0;
        $ac4a9effa24fe7be$var$cg(b);
    } else f = !1;
    $ac4a9effa24fe7be$var$Tg(b, e);
    if (null === b.stateNode) $ac4a9effa24fe7be$var$jj(a, b), $ac4a9effa24fe7be$var$ph(b, c, d), $ac4a9effa24fe7be$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $ac4a9effa24fe7be$var$Vg(l) : (l = $ac4a9effa24fe7be$var$Zf(c) ? $ac4a9effa24fe7be$var$Xf : $ac4a9effa24fe7be$var$H.current, l = $ac4a9effa24fe7be$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $ac4a9effa24fe7be$var$qh(b, g, d, l);
        $ac4a9effa24fe7be$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $ac4a9effa24fe7be$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $ac4a9effa24fe7be$var$Wf.current || $ac4a9effa24fe7be$var$$g ? ("function" === typeof m && ($ac4a9effa24fe7be$var$kh(b, c, m, d), k = b.memoizedState), (h = $ac4a9effa24fe7be$var$$g || $ac4a9effa24fe7be$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $ac4a9effa24fe7be$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $ac4a9effa24fe7be$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $ac4a9effa24fe7be$var$Vg(k) : (k = $ac4a9effa24fe7be$var$Zf(c) ? $ac4a9effa24fe7be$var$Xf : $ac4a9effa24fe7be$var$H.current, k = $ac4a9effa24fe7be$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $ac4a9effa24fe7be$var$qh(b, g, d, k);
        $ac4a9effa24fe7be$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $ac4a9effa24fe7be$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $ac4a9effa24fe7be$var$Wf.current || $ac4a9effa24fe7be$var$$g ? ("function" === typeof y && ($ac4a9effa24fe7be$var$kh(b, c, y, d), n = b.memoizedState), (l = $ac4a9effa24fe7be$var$$g || $ac4a9effa24fe7be$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $ac4a9effa24fe7be$var$kj(a, b, c, d, f, e);
}
function $ac4a9effa24fe7be$var$kj(a, b, c, d, e, f) {
    $ac4a9effa24fe7be$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $ac4a9effa24fe7be$var$dg(b, c, !1), $ac4a9effa24fe7be$var$$i(a, b, f);
    d = b.stateNode;
    $ac4a9effa24fe7be$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $ac4a9effa24fe7be$var$Bh(b, a.child, null, f), b.child = $ac4a9effa24fe7be$var$Bh(b, null, h, f)) : $ac4a9effa24fe7be$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $ac4a9effa24fe7be$var$dg(b, c, !0);
    return b.child;
}
function $ac4a9effa24fe7be$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $ac4a9effa24fe7be$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $ac4a9effa24fe7be$var$ag(a, b.context, !1);
    $ac4a9effa24fe7be$var$Ih(a, b.containerInfo);
}
function $ac4a9effa24fe7be$var$mj(a, b, c, d, e) {
    $ac4a9effa24fe7be$var$Ig();
    $ac4a9effa24fe7be$var$Jg(e);
    b.flags |= 256;
    $ac4a9effa24fe7be$var$Yi(a, b, c, d);
    return b.child;
}
var $ac4a9effa24fe7be$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $ac4a9effa24fe7be$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $ac4a9effa24fe7be$var$pj(a, b, c) {
    var d = b.pendingProps, e = $ac4a9effa24fe7be$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$M, e & 1);
    if (null === a) {
        $ac4a9effa24fe7be$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $ac4a9effa24fe7be$var$qj(g, d, 0, null), a = $ac4a9effa24fe7be$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $ac4a9effa24fe7be$var$oj(c), b.memoizedState = $ac4a9effa24fe7be$var$nj, a) : $ac4a9effa24fe7be$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $ac4a9effa24fe7be$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $ac4a9effa24fe7be$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $ac4a9effa24fe7be$var$wh(h, f) : (f = $ac4a9effa24fe7be$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $ac4a9effa24fe7be$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $ac4a9effa24fe7be$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $ac4a9effa24fe7be$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $ac4a9effa24fe7be$var$rj(a, b) {
    b = $ac4a9effa24fe7be$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $ac4a9effa24fe7be$var$tj(a, b, c, d) {
    null !== d && $ac4a9effa24fe7be$var$Jg(d);
    $ac4a9effa24fe7be$var$Bh(b, a.child, null, c);
    a = $ac4a9effa24fe7be$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $ac4a9effa24fe7be$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $ac4a9effa24fe7be$var$Li(Error($ac4a9effa24fe7be$var$p(422))), $ac4a9effa24fe7be$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $ac4a9effa24fe7be$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $ac4a9effa24fe7be$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $ac4a9effa24fe7be$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $ac4a9effa24fe7be$var$oj(g);
        b.memoizedState = $ac4a9effa24fe7be$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $ac4a9effa24fe7be$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($ac4a9effa24fe7be$var$p(419));
        d = $ac4a9effa24fe7be$var$Li(f, d, void 0);
        return $ac4a9effa24fe7be$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($ac4a9effa24fe7be$var$Ug || h) {
        d = $ac4a9effa24fe7be$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $ac4a9effa24fe7be$var$Zg(a, e), $ac4a9effa24fe7be$var$mh(d, a, e, -1));
        }
        $ac4a9effa24fe7be$var$uj();
        d = $ac4a9effa24fe7be$var$Li(Error($ac4a9effa24fe7be$var$p(421)));
        return $ac4a9effa24fe7be$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $ac4a9effa24fe7be$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $ac4a9effa24fe7be$var$yg = $ac4a9effa24fe7be$var$Lf(e.nextSibling);
    $ac4a9effa24fe7be$var$xg = b;
    $ac4a9effa24fe7be$var$I = !0;
    $ac4a9effa24fe7be$var$zg = null;
    null !== a && ($ac4a9effa24fe7be$var$og[$ac4a9effa24fe7be$var$pg++] = $ac4a9effa24fe7be$var$rg, $ac4a9effa24fe7be$var$og[$ac4a9effa24fe7be$var$pg++] = $ac4a9effa24fe7be$var$sg, $ac4a9effa24fe7be$var$og[$ac4a9effa24fe7be$var$pg++] = $ac4a9effa24fe7be$var$qg, $ac4a9effa24fe7be$var$rg = a.id, $ac4a9effa24fe7be$var$sg = a.overflow, $ac4a9effa24fe7be$var$qg = b);
    b = $ac4a9effa24fe7be$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $ac4a9effa24fe7be$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $ac4a9effa24fe7be$var$Sg(a.return, b, c);
}
function $ac4a9effa24fe7be$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $ac4a9effa24fe7be$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $ac4a9effa24fe7be$var$Yi(a, b, d.children, c);
    d = $ac4a9effa24fe7be$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $ac4a9effa24fe7be$var$wj(a, c, b);
            else if (19 === a.tag) $ac4a9effa24fe7be$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $ac4a9effa24fe7be$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $ac4a9effa24fe7be$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $ac4a9effa24fe7be$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $ac4a9effa24fe7be$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $ac4a9effa24fe7be$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $ac4a9effa24fe7be$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $ac4a9effa24fe7be$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $ac4a9effa24fe7be$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($ac4a9effa24fe7be$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $ac4a9effa24fe7be$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $ac4a9effa24fe7be$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $ac4a9effa24fe7be$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $ac4a9effa24fe7be$var$lj(b);
            $ac4a9effa24fe7be$var$Ig();
            break;
        case 5:
            $ac4a9effa24fe7be$var$Kh(b);
            break;
        case 1:
            $ac4a9effa24fe7be$var$Zf(b.type) && $ac4a9effa24fe7be$var$cg(b);
            break;
        case 4:
            $ac4a9effa24fe7be$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$M, $ac4a9effa24fe7be$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $ac4a9effa24fe7be$var$pj(a, b, c);
                $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$M, $ac4a9effa24fe7be$var$M.current & 1);
                a = $ac4a9effa24fe7be$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$M, $ac4a9effa24fe7be$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $ac4a9effa24fe7be$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$M, $ac4a9effa24fe7be$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $ac4a9effa24fe7be$var$ej(a, b, c);
    }
    return $ac4a9effa24fe7be$var$$i(a, b, c);
}
var $ac4a9effa24fe7be$var$Aj, $ac4a9effa24fe7be$var$Bj, $ac4a9effa24fe7be$var$Cj, $ac4a9effa24fe7be$var$Dj;
$ac4a9effa24fe7be$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$ac4a9effa24fe7be$var$Bj = function() {};
$ac4a9effa24fe7be$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $ac4a9effa24fe7be$var$Hh($ac4a9effa24fe7be$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $ac4a9effa24fe7be$var$Ya(a, e);
                d = $ac4a9effa24fe7be$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $ac4a9effa24fe7be$var$A({}, e, {
                    value: void 0
                });
                d = $ac4a9effa24fe7be$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $ac4a9effa24fe7be$var$gb(a, e);
                d = $ac4a9effa24fe7be$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $ac4a9effa24fe7be$var$Bf);
        }
        $ac4a9effa24fe7be$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($ac4a9effa24fe7be$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($ac4a9effa24fe7be$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $ac4a9effa24fe7be$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$ac4a9effa24fe7be$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $ac4a9effa24fe7be$var$Ej(a, b) {
    if (!$ac4a9effa24fe7be$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $ac4a9effa24fe7be$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $ac4a9effa24fe7be$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $ac4a9effa24fe7be$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $ac4a9effa24fe7be$var$S(b), null;
        case 1:
            return $ac4a9effa24fe7be$var$Zf(b.type) && $ac4a9effa24fe7be$var$$f(), $ac4a9effa24fe7be$var$S(b), null;
        case 3:
            d = b.stateNode;
            $ac4a9effa24fe7be$var$Jh();
            $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$Wf);
            $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$H);
            $ac4a9effa24fe7be$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $ac4a9effa24fe7be$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $ac4a9effa24fe7be$var$zg && ($ac4a9effa24fe7be$var$Gj($ac4a9effa24fe7be$var$zg), $ac4a9effa24fe7be$var$zg = null));
            $ac4a9effa24fe7be$var$Bj(a, b);
            $ac4a9effa24fe7be$var$S(b);
            return null;
        case 5:
            $ac4a9effa24fe7be$var$Lh(b);
            var e = $ac4a9effa24fe7be$var$Hh($ac4a9effa24fe7be$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $ac4a9effa24fe7be$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($ac4a9effa24fe7be$var$p(166));
                    $ac4a9effa24fe7be$var$S(b);
                    return null;
                }
                a = $ac4a9effa24fe7be$var$Hh($ac4a9effa24fe7be$var$Eh.current);
                if ($ac4a9effa24fe7be$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$ac4a9effa24fe7be$var$Of] = b;
                    d[$ac4a9effa24fe7be$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $ac4a9effa24fe7be$var$D("cancel", d);
                            $ac4a9effa24fe7be$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $ac4a9effa24fe7be$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $ac4a9effa24fe7be$var$lf.length; e++)$ac4a9effa24fe7be$var$D($ac4a9effa24fe7be$var$lf[e], d);
                            break;
                        case "source":
                            $ac4a9effa24fe7be$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $ac4a9effa24fe7be$var$D("error", d);
                            $ac4a9effa24fe7be$var$D("load", d);
                            break;
                        case "details":
                            $ac4a9effa24fe7be$var$D("toggle", d);
                            break;
                        case "input":
                            $ac4a9effa24fe7be$var$Za(d, f);
                            $ac4a9effa24fe7be$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $ac4a9effa24fe7be$var$D("invalid", d);
                            break;
                        case "textarea":
                            $ac4a9effa24fe7be$var$hb(d, f), $ac4a9effa24fe7be$var$D("invalid", d);
                    }
                    $ac4a9effa24fe7be$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $ac4a9effa24fe7be$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $ac4a9effa24fe7be$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $ac4a9effa24fe7be$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $ac4a9effa24fe7be$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $ac4a9effa24fe7be$var$Va(d);
                            $ac4a9effa24fe7be$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $ac4a9effa24fe7be$var$Va(d);
                            $ac4a9effa24fe7be$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $ac4a9effa24fe7be$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $ac4a9effa24fe7be$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$ac4a9effa24fe7be$var$Of] = b;
                    a[$ac4a9effa24fe7be$var$Pf] = d;
                    $ac4a9effa24fe7be$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $ac4a9effa24fe7be$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $ac4a9effa24fe7be$var$D("cancel", a);
                                $ac4a9effa24fe7be$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $ac4a9effa24fe7be$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $ac4a9effa24fe7be$var$lf.length; e++)$ac4a9effa24fe7be$var$D($ac4a9effa24fe7be$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $ac4a9effa24fe7be$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $ac4a9effa24fe7be$var$D("error", a);
                                $ac4a9effa24fe7be$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $ac4a9effa24fe7be$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $ac4a9effa24fe7be$var$Za(a, d);
                                e = $ac4a9effa24fe7be$var$Ya(a, d);
                                $ac4a9effa24fe7be$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $ac4a9effa24fe7be$var$A({}, d, {
                                    value: void 0
                                });
                                $ac4a9effa24fe7be$var$D("invalid", a);
                                break;
                            case "textarea":
                                $ac4a9effa24fe7be$var$hb(a, d);
                                e = $ac4a9effa24fe7be$var$gb(a, d);
                                $ac4a9effa24fe7be$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $ac4a9effa24fe7be$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $ac4a9effa24fe7be$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $ac4a9effa24fe7be$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $ac4a9effa24fe7be$var$ob(a, k) : "number" === typeof k && $ac4a9effa24fe7be$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($ac4a9effa24fe7be$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $ac4a9effa24fe7be$var$D("scroll", a) : null != k && $ac4a9effa24fe7be$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $ac4a9effa24fe7be$var$Va(a);
                                $ac4a9effa24fe7be$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $ac4a9effa24fe7be$var$Va(a);
                                $ac4a9effa24fe7be$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $ac4a9effa24fe7be$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $ac4a9effa24fe7be$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $ac4a9effa24fe7be$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $ac4a9effa24fe7be$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $ac4a9effa24fe7be$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $ac4a9effa24fe7be$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($ac4a9effa24fe7be$var$p(166));
                c = $ac4a9effa24fe7be$var$Hh($ac4a9effa24fe7be$var$Gh.current);
                $ac4a9effa24fe7be$var$Hh($ac4a9effa24fe7be$var$Eh.current);
                if ($ac4a9effa24fe7be$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$ac4a9effa24fe7be$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $ac4a9effa24fe7be$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $ac4a9effa24fe7be$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $ac4a9effa24fe7be$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$ac4a9effa24fe7be$var$Of] = b, b.stateNode = d;
            }
            $ac4a9effa24fe7be$var$S(b);
            return null;
        case 13:
            $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($ac4a9effa24fe7be$var$I && null !== $ac4a9effa24fe7be$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $ac4a9effa24fe7be$var$Hg(), $ac4a9effa24fe7be$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $ac4a9effa24fe7be$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($ac4a9effa24fe7be$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($ac4a9effa24fe7be$var$p(317));
                        f[$ac4a9effa24fe7be$var$Of] = b;
                    } else $ac4a9effa24fe7be$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $ac4a9effa24fe7be$var$S(b);
                    f = !1;
                } else null !== $ac4a9effa24fe7be$var$zg && ($ac4a9effa24fe7be$var$Gj($ac4a9effa24fe7be$var$zg), $ac4a9effa24fe7be$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($ac4a9effa24fe7be$var$M.current & 1) ? 0 === $ac4a9effa24fe7be$var$T && ($ac4a9effa24fe7be$var$T = 3) : $ac4a9effa24fe7be$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $ac4a9effa24fe7be$var$S(b);
            return null;
        case 4:
            return $ac4a9effa24fe7be$var$Jh(), $ac4a9effa24fe7be$var$Bj(a, b), null === a && $ac4a9effa24fe7be$var$sf(b.stateNode.containerInfo), $ac4a9effa24fe7be$var$S(b), null;
        case 10:
            return $ac4a9effa24fe7be$var$Rg(b.type._context), $ac4a9effa24fe7be$var$S(b), null;
        case 17:
            return $ac4a9effa24fe7be$var$Zf(b.type) && $ac4a9effa24fe7be$var$$f(), $ac4a9effa24fe7be$var$S(b), null;
        case 19:
            $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$M);
            f = b.memoizedState;
            if (null === f) return $ac4a9effa24fe7be$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $ac4a9effa24fe7be$var$Ej(f, !1);
                else {
                    if (0 !== $ac4a9effa24fe7be$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $ac4a9effa24fe7be$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $ac4a9effa24fe7be$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$M, $ac4a9effa24fe7be$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $ac4a9effa24fe7be$var$B() > $ac4a9effa24fe7be$var$Hj && (b.flags |= 128, d = !0, $ac4a9effa24fe7be$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $ac4a9effa24fe7be$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $ac4a9effa24fe7be$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$ac4a9effa24fe7be$var$I) return $ac4a9effa24fe7be$var$S(b), null;
                    } else 2 * $ac4a9effa24fe7be$var$B() - f.renderingStartTime > $ac4a9effa24fe7be$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $ac4a9effa24fe7be$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $ac4a9effa24fe7be$var$B(), b.sibling = null, c = $ac4a9effa24fe7be$var$M.current, $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$M, d ? c & 1 | 2 : c & 1), b;
            $ac4a9effa24fe7be$var$S(b);
            return null;
        case 22:
        case 23:
            return $ac4a9effa24fe7be$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($ac4a9effa24fe7be$var$gj & 1073741824) && ($ac4a9effa24fe7be$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $ac4a9effa24fe7be$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($ac4a9effa24fe7be$var$p(156, b.tag));
}
function $ac4a9effa24fe7be$var$Jj(a, b) {
    $ac4a9effa24fe7be$var$wg(b);
    switch(b.tag){
        case 1:
            return $ac4a9effa24fe7be$var$Zf(b.type) && $ac4a9effa24fe7be$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $ac4a9effa24fe7be$var$Jh(), $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$Wf), $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$H), $ac4a9effa24fe7be$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $ac4a9effa24fe7be$var$Lh(b), null;
        case 13:
            $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($ac4a9effa24fe7be$var$p(340));
                $ac4a9effa24fe7be$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$M), null;
        case 4:
            return $ac4a9effa24fe7be$var$Jh(), null;
        case 10:
            return $ac4a9effa24fe7be$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $ac4a9effa24fe7be$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $ac4a9effa24fe7be$var$Kj = !1, $ac4a9effa24fe7be$var$U = !1, $ac4a9effa24fe7be$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $ac4a9effa24fe7be$var$V = null;
function $ac4a9effa24fe7be$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $ac4a9effa24fe7be$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $ac4a9effa24fe7be$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $ac4a9effa24fe7be$var$W(a, b, d);
    }
}
var $ac4a9effa24fe7be$var$Oj = !1;
function $ac4a9effa24fe7be$var$Pj(a, b) {
    $ac4a9effa24fe7be$var$Cf = $ac4a9effa24fe7be$var$dd;
    a = $ac4a9effa24fe7be$var$Me();
    if ($ac4a9effa24fe7be$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $ac4a9effa24fe7be$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $ac4a9effa24fe7be$var$dd = !1;
    for($ac4a9effa24fe7be$var$V = b; null !== $ac4a9effa24fe7be$var$V;)if (b = $ac4a9effa24fe7be$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $ac4a9effa24fe7be$var$V = a;
    else for(; null !== $ac4a9effa24fe7be$var$V;){
        b = $ac4a9effa24fe7be$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $ac4a9effa24fe7be$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($ac4a9effa24fe7be$var$p(163));
            }
        } catch (F) {
            $ac4a9effa24fe7be$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $ac4a9effa24fe7be$var$V = a;
            break;
        }
        $ac4a9effa24fe7be$var$V = b.return;
    }
    n = $ac4a9effa24fe7be$var$Oj;
    $ac4a9effa24fe7be$var$Oj = !1;
    return n;
}
function $ac4a9effa24fe7be$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $ac4a9effa24fe7be$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $ac4a9effa24fe7be$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $ac4a9effa24fe7be$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $ac4a9effa24fe7be$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $ac4a9effa24fe7be$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$ac4a9effa24fe7be$var$Of], delete b[$ac4a9effa24fe7be$var$Pf], delete b[$ac4a9effa24fe7be$var$of], delete b[$ac4a9effa24fe7be$var$Qf], delete b[$ac4a9effa24fe7be$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $ac4a9effa24fe7be$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $ac4a9effa24fe7be$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $ac4a9effa24fe7be$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $ac4a9effa24fe7be$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $ac4a9effa24fe7be$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($ac4a9effa24fe7be$var$Wj(a, b, c), a = a.sibling; null !== a;)$ac4a9effa24fe7be$var$Wj(a, b, c), a = a.sibling;
}
function $ac4a9effa24fe7be$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($ac4a9effa24fe7be$var$Xj(a, b, c), a = a.sibling; null !== a;)$ac4a9effa24fe7be$var$Xj(a, b, c), a = a.sibling;
}
var $ac4a9effa24fe7be$var$X = null, $ac4a9effa24fe7be$var$Yj = !1;
function $ac4a9effa24fe7be$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$ac4a9effa24fe7be$var$ak(a, b, c), c = c.sibling;
}
function $ac4a9effa24fe7be$var$ak(a, b, c) {
    if ($ac4a9effa24fe7be$var$lc && "function" === typeof $ac4a9effa24fe7be$var$lc.onCommitFiberUnmount) try {
        $ac4a9effa24fe7be$var$lc.onCommitFiberUnmount($ac4a9effa24fe7be$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $ac4a9effa24fe7be$var$U || $ac4a9effa24fe7be$var$Mj(c, b);
        case 6:
            var d = $ac4a9effa24fe7be$var$X, e = $ac4a9effa24fe7be$var$Yj;
            $ac4a9effa24fe7be$var$X = null;
            $ac4a9effa24fe7be$var$Zj(a, b, c);
            $ac4a9effa24fe7be$var$X = d;
            $ac4a9effa24fe7be$var$Yj = e;
            null !== $ac4a9effa24fe7be$var$X && ($ac4a9effa24fe7be$var$Yj ? (a = $ac4a9effa24fe7be$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $ac4a9effa24fe7be$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $ac4a9effa24fe7be$var$X && ($ac4a9effa24fe7be$var$Yj ? (a = $ac4a9effa24fe7be$var$X, c = c.stateNode, 8 === a.nodeType ? $ac4a9effa24fe7be$var$Kf(a.parentNode, c) : 1 === a.nodeType && $ac4a9effa24fe7be$var$Kf(a, c), $ac4a9effa24fe7be$var$bd(a)) : $ac4a9effa24fe7be$var$Kf($ac4a9effa24fe7be$var$X, c.stateNode));
            break;
        case 4:
            d = $ac4a9effa24fe7be$var$X;
            e = $ac4a9effa24fe7be$var$Yj;
            $ac4a9effa24fe7be$var$X = c.stateNode.containerInfo;
            $ac4a9effa24fe7be$var$Yj = !0;
            $ac4a9effa24fe7be$var$Zj(a, b, c);
            $ac4a9effa24fe7be$var$X = d;
            $ac4a9effa24fe7be$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$ac4a9effa24fe7be$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $ac4a9effa24fe7be$var$Nj(c, b, g) : 0 !== (f & 4) && $ac4a9effa24fe7be$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $ac4a9effa24fe7be$var$Zj(a, b, c);
            break;
        case 1:
            if (!$ac4a9effa24fe7be$var$U && ($ac4a9effa24fe7be$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $ac4a9effa24fe7be$var$W(c, b, h);
            }
            $ac4a9effa24fe7be$var$Zj(a, b, c);
            break;
        case 21:
            $ac4a9effa24fe7be$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($ac4a9effa24fe7be$var$U = (d = $ac4a9effa24fe7be$var$U) || null !== c.memoizedState, $ac4a9effa24fe7be$var$Zj(a, b, c), $ac4a9effa24fe7be$var$U = d) : $ac4a9effa24fe7be$var$Zj(a, b, c);
            break;
        default:
            $ac4a9effa24fe7be$var$Zj(a, b, c);
    }
}
function $ac4a9effa24fe7be$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $ac4a9effa24fe7be$var$Lj);
        b.forEach(function(b) {
            var d = $ac4a9effa24fe7be$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $ac4a9effa24fe7be$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $ac4a9effa24fe7be$var$X = h.stateNode;
                        $ac4a9effa24fe7be$var$Yj = !1;
                        break a;
                    case 3:
                        $ac4a9effa24fe7be$var$X = h.stateNode.containerInfo;
                        $ac4a9effa24fe7be$var$Yj = !0;
                        break a;
                    case 4:
                        $ac4a9effa24fe7be$var$X = h.stateNode.containerInfo;
                        $ac4a9effa24fe7be$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $ac4a9effa24fe7be$var$X) throw Error($ac4a9effa24fe7be$var$p(160));
            $ac4a9effa24fe7be$var$ak(f, g, e);
            $ac4a9effa24fe7be$var$X = null;
            $ac4a9effa24fe7be$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $ac4a9effa24fe7be$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$ac4a9effa24fe7be$var$ek(b, a), b = b.sibling;
}
function $ac4a9effa24fe7be$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $ac4a9effa24fe7be$var$dk(b, a);
            $ac4a9effa24fe7be$var$fk(a);
            if (d & 4) {
                try {
                    $ac4a9effa24fe7be$var$Qj(3, a, a.return), $ac4a9effa24fe7be$var$Rj(3, a);
                } catch (t) {
                    $ac4a9effa24fe7be$var$W(a, a.return, t);
                }
                try {
                    $ac4a9effa24fe7be$var$Qj(5, a, a.return);
                } catch (t) {
                    $ac4a9effa24fe7be$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $ac4a9effa24fe7be$var$dk(b, a);
            $ac4a9effa24fe7be$var$fk(a);
            d & 512 && null !== c && $ac4a9effa24fe7be$var$Mj(c, c.return);
            break;
        case 5:
            $ac4a9effa24fe7be$var$dk(b, a);
            $ac4a9effa24fe7be$var$fk(a);
            d & 512 && null !== c && $ac4a9effa24fe7be$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $ac4a9effa24fe7be$var$ob(e, "");
                } catch (t) {
                    $ac4a9effa24fe7be$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $ac4a9effa24fe7be$var$ab(e, f);
                    $ac4a9effa24fe7be$var$vb(h, g);
                    var l = $ac4a9effa24fe7be$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $ac4a9effa24fe7be$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $ac4a9effa24fe7be$var$nb(e, q) : "children" === m ? $ac4a9effa24fe7be$var$ob(e, q) : $ac4a9effa24fe7be$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $ac4a9effa24fe7be$var$bb(e, f);
                            break;
                        case "textarea":
                            $ac4a9effa24fe7be$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $ac4a9effa24fe7be$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $ac4a9effa24fe7be$var$fb(e, !!f.multiple, f.defaultValue, !0) : $ac4a9effa24fe7be$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$ac4a9effa24fe7be$var$Pf] = f;
                } catch (t) {
                    $ac4a9effa24fe7be$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $ac4a9effa24fe7be$var$dk(b, a);
            $ac4a9effa24fe7be$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($ac4a9effa24fe7be$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $ac4a9effa24fe7be$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $ac4a9effa24fe7be$var$dk(b, a);
            $ac4a9effa24fe7be$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $ac4a9effa24fe7be$var$bd(b.containerInfo);
            } catch (t) {
                $ac4a9effa24fe7be$var$W(a, a.return, t);
            }
            break;
        case 4:
            $ac4a9effa24fe7be$var$dk(b, a);
            $ac4a9effa24fe7be$var$fk(a);
            break;
        case 13:
            $ac4a9effa24fe7be$var$dk(b, a);
            $ac4a9effa24fe7be$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($ac4a9effa24fe7be$var$gk = $ac4a9effa24fe7be$var$B()));
            d & 4 && $ac4a9effa24fe7be$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($ac4a9effa24fe7be$var$U = (l = $ac4a9effa24fe7be$var$U) || m, $ac4a9effa24fe7be$var$dk(b, a), $ac4a9effa24fe7be$var$U = l) : $ac4a9effa24fe7be$var$dk(b, a);
            $ac4a9effa24fe7be$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($ac4a9effa24fe7be$var$V = a, m = a.child; null !== m;){
                    for(q = $ac4a9effa24fe7be$var$V = m; null !== $ac4a9effa24fe7be$var$V;){
                        r = $ac4a9effa24fe7be$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $ac4a9effa24fe7be$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $ac4a9effa24fe7be$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $ac4a9effa24fe7be$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $ac4a9effa24fe7be$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $ac4a9effa24fe7be$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $ac4a9effa24fe7be$var$V = y) : $ac4a9effa24fe7be$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $ac4a9effa24fe7be$var$rb("display", g));
                            } catch (t) {
                                $ac4a9effa24fe7be$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $ac4a9effa24fe7be$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $ac4a9effa24fe7be$var$dk(b, a);
            $ac4a9effa24fe7be$var$fk(a);
            d & 4 && $ac4a9effa24fe7be$var$bk(a);
            break;
        case 21:
            break;
        default:
            $ac4a9effa24fe7be$var$dk(b, a), $ac4a9effa24fe7be$var$fk(a);
    }
}
function $ac4a9effa24fe7be$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($ac4a9effa24fe7be$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($ac4a9effa24fe7be$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($ac4a9effa24fe7be$var$ob(e, ""), d.flags &= -33);
                    var f = $ac4a9effa24fe7be$var$Vj(a);
                    $ac4a9effa24fe7be$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $ac4a9effa24fe7be$var$Vj(a);
                    $ac4a9effa24fe7be$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($ac4a9effa24fe7be$var$p(161));
            }
        } catch (k) {
            $ac4a9effa24fe7be$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $ac4a9effa24fe7be$var$ik(a, b, c) {
    $ac4a9effa24fe7be$var$V = a;
    $ac4a9effa24fe7be$var$jk(a, b, c);
}
function $ac4a9effa24fe7be$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $ac4a9effa24fe7be$var$V;){
        var e = $ac4a9effa24fe7be$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $ac4a9effa24fe7be$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $ac4a9effa24fe7be$var$U;
                h = $ac4a9effa24fe7be$var$Kj;
                var l = $ac4a9effa24fe7be$var$U;
                $ac4a9effa24fe7be$var$Kj = g;
                if (($ac4a9effa24fe7be$var$U = k) && !l) for($ac4a9effa24fe7be$var$V = e; null !== $ac4a9effa24fe7be$var$V;)g = $ac4a9effa24fe7be$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $ac4a9effa24fe7be$var$kk(e) : null !== k ? (k.return = g, $ac4a9effa24fe7be$var$V = k) : $ac4a9effa24fe7be$var$kk(e);
                for(; null !== f;)$ac4a9effa24fe7be$var$V = f, $ac4a9effa24fe7be$var$jk(f, b, c), f = f.sibling;
                $ac4a9effa24fe7be$var$V = e;
                $ac4a9effa24fe7be$var$Kj = h;
                $ac4a9effa24fe7be$var$U = l;
            }
            $ac4a9effa24fe7be$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $ac4a9effa24fe7be$var$V = f) : $ac4a9effa24fe7be$var$lk(a, b, c);
    }
}
function $ac4a9effa24fe7be$var$lk(a) {
    for(; null !== $ac4a9effa24fe7be$var$V;){
        var b = $ac4a9effa24fe7be$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $ac4a9effa24fe7be$var$U || $ac4a9effa24fe7be$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$ac4a9effa24fe7be$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $ac4a9effa24fe7be$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $ac4a9effa24fe7be$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $ac4a9effa24fe7be$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $ac4a9effa24fe7be$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($ac4a9effa24fe7be$var$p(163));
                }
                $ac4a9effa24fe7be$var$U || b.flags & 512 && $ac4a9effa24fe7be$var$Sj(b);
            } catch (r) {
                $ac4a9effa24fe7be$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $ac4a9effa24fe7be$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $ac4a9effa24fe7be$var$V = c;
            break;
        }
        $ac4a9effa24fe7be$var$V = b.return;
    }
}
function $ac4a9effa24fe7be$var$hk(a) {
    for(; null !== $ac4a9effa24fe7be$var$V;){
        var b = $ac4a9effa24fe7be$var$V;
        if (b === a) {
            $ac4a9effa24fe7be$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $ac4a9effa24fe7be$var$V = c;
            break;
        }
        $ac4a9effa24fe7be$var$V = b.return;
    }
}
function $ac4a9effa24fe7be$var$kk(a) {
    for(; null !== $ac4a9effa24fe7be$var$V;){
        var b = $ac4a9effa24fe7be$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $ac4a9effa24fe7be$var$Rj(4, b);
                    } catch (k) {
                        $ac4a9effa24fe7be$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $ac4a9effa24fe7be$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $ac4a9effa24fe7be$var$Sj(b);
                    } catch (k) {
                        $ac4a9effa24fe7be$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $ac4a9effa24fe7be$var$Sj(b);
                    } catch (k) {
                        $ac4a9effa24fe7be$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $ac4a9effa24fe7be$var$W(b, b.return, k);
        }
        if (b === a) {
            $ac4a9effa24fe7be$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $ac4a9effa24fe7be$var$V = h;
            break;
        }
        $ac4a9effa24fe7be$var$V = b.return;
    }
}
var $ac4a9effa24fe7be$var$mk = Math.ceil, $ac4a9effa24fe7be$var$nk = $ac4a9effa24fe7be$var$ua.ReactCurrentDispatcher, $ac4a9effa24fe7be$var$ok = $ac4a9effa24fe7be$var$ua.ReactCurrentOwner, $ac4a9effa24fe7be$var$pk = $ac4a9effa24fe7be$var$ua.ReactCurrentBatchConfig, $ac4a9effa24fe7be$var$K = 0, $ac4a9effa24fe7be$var$R = null, $ac4a9effa24fe7be$var$Y = null, $ac4a9effa24fe7be$var$Z = 0, $ac4a9effa24fe7be$var$gj = 0, $ac4a9effa24fe7be$var$fj = $ac4a9effa24fe7be$var$Uf(0), $ac4a9effa24fe7be$var$T = 0, $ac4a9effa24fe7be$var$qk = null, $ac4a9effa24fe7be$var$hh = 0, $ac4a9effa24fe7be$var$rk = 0, $ac4a9effa24fe7be$var$sk = 0, $ac4a9effa24fe7be$var$tk = null, $ac4a9effa24fe7be$var$uk = null, $ac4a9effa24fe7be$var$gk = 0, $ac4a9effa24fe7be$var$Hj = Infinity, $ac4a9effa24fe7be$var$vk = null, $ac4a9effa24fe7be$var$Pi = !1, $ac4a9effa24fe7be$var$Qi = null, $ac4a9effa24fe7be$var$Si = null, $ac4a9effa24fe7be$var$wk = !1, $ac4a9effa24fe7be$var$xk = null, $ac4a9effa24fe7be$var$yk = 0, $ac4a9effa24fe7be$var$zk = 0, $ac4a9effa24fe7be$var$Ak = null, $ac4a9effa24fe7be$var$Bk = -1, $ac4a9effa24fe7be$var$Ck = 0;
function $ac4a9effa24fe7be$var$L() {
    return 0 !== ($ac4a9effa24fe7be$var$K & 6) ? $ac4a9effa24fe7be$var$B() : -1 !== $ac4a9effa24fe7be$var$Bk ? $ac4a9effa24fe7be$var$Bk : $ac4a9effa24fe7be$var$Bk = $ac4a9effa24fe7be$var$B();
}
function $ac4a9effa24fe7be$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($ac4a9effa24fe7be$var$K & 2) && 0 !== $ac4a9effa24fe7be$var$Z) return $ac4a9effa24fe7be$var$Z & -$ac4a9effa24fe7be$var$Z;
    if (null !== $ac4a9effa24fe7be$var$Kg.transition) return 0 === $ac4a9effa24fe7be$var$Ck && ($ac4a9effa24fe7be$var$Ck = $ac4a9effa24fe7be$var$yc()), $ac4a9effa24fe7be$var$Ck;
    a = $ac4a9effa24fe7be$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $ac4a9effa24fe7be$var$jd(a.type);
    return a;
}
function $ac4a9effa24fe7be$var$mh(a, b, c, d) {
    if (50 < $ac4a9effa24fe7be$var$zk) throw $ac4a9effa24fe7be$var$zk = 0, $ac4a9effa24fe7be$var$Ak = null, Error($ac4a9effa24fe7be$var$p(185));
    $ac4a9effa24fe7be$var$Ac(a, c, d);
    if (0 === ($ac4a9effa24fe7be$var$K & 2) || a !== $ac4a9effa24fe7be$var$R) a === $ac4a9effa24fe7be$var$R && (0 === ($ac4a9effa24fe7be$var$K & 2) && ($ac4a9effa24fe7be$var$rk |= c), 4 === $ac4a9effa24fe7be$var$T && $ac4a9effa24fe7be$var$Dk(a, $ac4a9effa24fe7be$var$Z)), $ac4a9effa24fe7be$var$Ek(a, d), 1 === c && 0 === $ac4a9effa24fe7be$var$K && 0 === (b.mode & 1) && ($ac4a9effa24fe7be$var$Hj = $ac4a9effa24fe7be$var$B() + 500, $ac4a9effa24fe7be$var$fg && $ac4a9effa24fe7be$var$jg());
}
function $ac4a9effa24fe7be$var$Ek(a, b) {
    var c = a.callbackNode;
    $ac4a9effa24fe7be$var$wc(a, b);
    var d = $ac4a9effa24fe7be$var$uc(a, a === $ac4a9effa24fe7be$var$R ? $ac4a9effa24fe7be$var$Z : 0);
    if (0 === d) null !== c && $ac4a9effa24fe7be$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $ac4a9effa24fe7be$var$bc(c);
        if (1 === b) 0 === a.tag ? $ac4a9effa24fe7be$var$ig($ac4a9effa24fe7be$var$Fk.bind(null, a)) : $ac4a9effa24fe7be$var$hg($ac4a9effa24fe7be$var$Fk.bind(null, a)), $ac4a9effa24fe7be$var$Jf(function() {
            0 === ($ac4a9effa24fe7be$var$K & 6) && $ac4a9effa24fe7be$var$jg();
        }), c = null;
        else {
            switch($ac4a9effa24fe7be$var$Dc(d)){
                case 1:
                    c = $ac4a9effa24fe7be$var$fc;
                    break;
                case 4:
                    c = $ac4a9effa24fe7be$var$gc;
                    break;
                case 16:
                    c = $ac4a9effa24fe7be$var$hc;
                    break;
                case 536870912:
                    c = $ac4a9effa24fe7be$var$jc;
                    break;
                default:
                    c = $ac4a9effa24fe7be$var$hc;
            }
            c = $ac4a9effa24fe7be$var$Gk(c, $ac4a9effa24fe7be$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $ac4a9effa24fe7be$var$Hk(a, b) {
    $ac4a9effa24fe7be$var$Bk = -1;
    $ac4a9effa24fe7be$var$Ck = 0;
    if (0 !== ($ac4a9effa24fe7be$var$K & 6)) throw Error($ac4a9effa24fe7be$var$p(327));
    var c = a.callbackNode;
    if ($ac4a9effa24fe7be$var$Ik() && a.callbackNode !== c) return null;
    var d = $ac4a9effa24fe7be$var$uc(a, a === $ac4a9effa24fe7be$var$R ? $ac4a9effa24fe7be$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $ac4a9effa24fe7be$var$Jk(a, d);
    else {
        b = d;
        var e = $ac4a9effa24fe7be$var$K;
        $ac4a9effa24fe7be$var$K |= 2;
        var f = $ac4a9effa24fe7be$var$Kk();
        if ($ac4a9effa24fe7be$var$R !== a || $ac4a9effa24fe7be$var$Z !== b) $ac4a9effa24fe7be$var$vk = null, $ac4a9effa24fe7be$var$Hj = $ac4a9effa24fe7be$var$B() + 500, $ac4a9effa24fe7be$var$Lk(a, b);
        for(;;)try {
            $ac4a9effa24fe7be$var$Mk();
            break;
        } catch (h) {
            $ac4a9effa24fe7be$var$Nk(a, h);
        }
        $ac4a9effa24fe7be$var$Qg();
        $ac4a9effa24fe7be$var$nk.current = f;
        $ac4a9effa24fe7be$var$K = e;
        null !== $ac4a9effa24fe7be$var$Y ? b = 0 : ($ac4a9effa24fe7be$var$R = null, $ac4a9effa24fe7be$var$Z = 0, b = $ac4a9effa24fe7be$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $ac4a9effa24fe7be$var$xc(a), 0 !== e && (d = e, b = $ac4a9effa24fe7be$var$Ok(a, e)));
        if (1 === b) throw c = $ac4a9effa24fe7be$var$qk, $ac4a9effa24fe7be$var$Lk(a, 0), $ac4a9effa24fe7be$var$Dk(a, d), $ac4a9effa24fe7be$var$Ek(a, $ac4a9effa24fe7be$var$B()), c;
        if (6 === b) $ac4a9effa24fe7be$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$ac4a9effa24fe7be$var$Pk(e) && (b = $ac4a9effa24fe7be$var$Jk(a, d), 2 === b && (f = $ac4a9effa24fe7be$var$xc(a), 0 !== f && (d = f, b = $ac4a9effa24fe7be$var$Ok(a, f))), 1 === b)) throw c = $ac4a9effa24fe7be$var$qk, $ac4a9effa24fe7be$var$Lk(a, 0), $ac4a9effa24fe7be$var$Dk(a, d), $ac4a9effa24fe7be$var$Ek(a, $ac4a9effa24fe7be$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($ac4a9effa24fe7be$var$p(345));
                case 2:
                    $ac4a9effa24fe7be$var$Qk(a, $ac4a9effa24fe7be$var$uk, $ac4a9effa24fe7be$var$vk);
                    break;
                case 3:
                    $ac4a9effa24fe7be$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $ac4a9effa24fe7be$var$gk + 500 - $ac4a9effa24fe7be$var$B(), 10 < b)) {
                        if (0 !== $ac4a9effa24fe7be$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $ac4a9effa24fe7be$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $ac4a9effa24fe7be$var$Ff($ac4a9effa24fe7be$var$Qk.bind(null, a, $ac4a9effa24fe7be$var$uk, $ac4a9effa24fe7be$var$vk), b);
                        break;
                    }
                    $ac4a9effa24fe7be$var$Qk(a, $ac4a9effa24fe7be$var$uk, $ac4a9effa24fe7be$var$vk);
                    break;
                case 4:
                    $ac4a9effa24fe7be$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $ac4a9effa24fe7be$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $ac4a9effa24fe7be$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $ac4a9effa24fe7be$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $ac4a9effa24fe7be$var$Ff($ac4a9effa24fe7be$var$Qk.bind(null, a, $ac4a9effa24fe7be$var$uk, $ac4a9effa24fe7be$var$vk), d);
                        break;
                    }
                    $ac4a9effa24fe7be$var$Qk(a, $ac4a9effa24fe7be$var$uk, $ac4a9effa24fe7be$var$vk);
                    break;
                case 5:
                    $ac4a9effa24fe7be$var$Qk(a, $ac4a9effa24fe7be$var$uk, $ac4a9effa24fe7be$var$vk);
                    break;
                default:
                    throw Error($ac4a9effa24fe7be$var$p(329));
            }
        }
    }
    $ac4a9effa24fe7be$var$Ek(a, $ac4a9effa24fe7be$var$B());
    return a.callbackNode === c ? $ac4a9effa24fe7be$var$Hk.bind(null, a) : null;
}
function $ac4a9effa24fe7be$var$Ok(a, b) {
    var c = $ac4a9effa24fe7be$var$tk;
    a.current.memoizedState.isDehydrated && ($ac4a9effa24fe7be$var$Lk(a, b).flags |= 256);
    a = $ac4a9effa24fe7be$var$Jk(a, b);
    2 !== a && (b = $ac4a9effa24fe7be$var$uk, $ac4a9effa24fe7be$var$uk = c, null !== b && $ac4a9effa24fe7be$var$Gj(b));
    return a;
}
function $ac4a9effa24fe7be$var$Gj(a) {
    null === $ac4a9effa24fe7be$var$uk ? $ac4a9effa24fe7be$var$uk = a : $ac4a9effa24fe7be$var$uk.push.apply($ac4a9effa24fe7be$var$uk, a);
}
function $ac4a9effa24fe7be$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$ac4a9effa24fe7be$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $ac4a9effa24fe7be$var$Dk(a, b) {
    b &= ~$ac4a9effa24fe7be$var$sk;
    b &= ~$ac4a9effa24fe7be$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $ac4a9effa24fe7be$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $ac4a9effa24fe7be$var$Fk(a) {
    if (0 !== ($ac4a9effa24fe7be$var$K & 6)) throw Error($ac4a9effa24fe7be$var$p(327));
    $ac4a9effa24fe7be$var$Ik();
    var b = $ac4a9effa24fe7be$var$uc(a, 0);
    if (0 === (b & 1)) return $ac4a9effa24fe7be$var$Ek(a, $ac4a9effa24fe7be$var$B()), null;
    var c = $ac4a9effa24fe7be$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $ac4a9effa24fe7be$var$xc(a);
        0 !== d && (b = d, c = $ac4a9effa24fe7be$var$Ok(a, d));
    }
    if (1 === c) throw c = $ac4a9effa24fe7be$var$qk, $ac4a9effa24fe7be$var$Lk(a, 0), $ac4a9effa24fe7be$var$Dk(a, b), $ac4a9effa24fe7be$var$Ek(a, $ac4a9effa24fe7be$var$B()), c;
    if (6 === c) throw Error($ac4a9effa24fe7be$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $ac4a9effa24fe7be$var$Qk(a, $ac4a9effa24fe7be$var$uk, $ac4a9effa24fe7be$var$vk);
    $ac4a9effa24fe7be$var$Ek(a, $ac4a9effa24fe7be$var$B());
    return null;
}
function $ac4a9effa24fe7be$var$Rk(a, b) {
    var c = $ac4a9effa24fe7be$var$K;
    $ac4a9effa24fe7be$var$K |= 1;
    try {
        return a(b);
    } finally{
        $ac4a9effa24fe7be$var$K = c, 0 === $ac4a9effa24fe7be$var$K && ($ac4a9effa24fe7be$var$Hj = $ac4a9effa24fe7be$var$B() + 500, $ac4a9effa24fe7be$var$fg && $ac4a9effa24fe7be$var$jg());
    }
}
function $ac4a9effa24fe7be$var$Sk(a) {
    null !== $ac4a9effa24fe7be$var$xk && 0 === $ac4a9effa24fe7be$var$xk.tag && 0 === ($ac4a9effa24fe7be$var$K & 6) && $ac4a9effa24fe7be$var$Ik();
    var b = $ac4a9effa24fe7be$var$K;
    $ac4a9effa24fe7be$var$K |= 1;
    var c = $ac4a9effa24fe7be$var$pk.transition, d = $ac4a9effa24fe7be$var$C;
    try {
        if ($ac4a9effa24fe7be$var$pk.transition = null, $ac4a9effa24fe7be$var$C = 1, a) return a();
    } finally{
        $ac4a9effa24fe7be$var$C = d, $ac4a9effa24fe7be$var$pk.transition = c, $ac4a9effa24fe7be$var$K = b, 0 === ($ac4a9effa24fe7be$var$K & 6) && $ac4a9effa24fe7be$var$jg();
    }
}
function $ac4a9effa24fe7be$var$Ij() {
    $ac4a9effa24fe7be$var$gj = $ac4a9effa24fe7be$var$fj.current;
    $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$fj);
}
function $ac4a9effa24fe7be$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $ac4a9effa24fe7be$var$Gf(c));
    if (null !== $ac4a9effa24fe7be$var$Y) for(c = $ac4a9effa24fe7be$var$Y.return; null !== c;){
        var d = c;
        $ac4a9effa24fe7be$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $ac4a9effa24fe7be$var$$f();
                break;
            case 3:
                $ac4a9effa24fe7be$var$Jh();
                $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$Wf);
                $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$H);
                $ac4a9effa24fe7be$var$Oh();
                break;
            case 5:
                $ac4a9effa24fe7be$var$Lh(d);
                break;
            case 4:
                $ac4a9effa24fe7be$var$Jh();
                break;
            case 13:
                $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$M);
                break;
            case 19:
                $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$M);
                break;
            case 10:
                $ac4a9effa24fe7be$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $ac4a9effa24fe7be$var$Ij();
        }
        c = c.return;
    }
    $ac4a9effa24fe7be$var$R = a;
    $ac4a9effa24fe7be$var$Y = a = $ac4a9effa24fe7be$var$wh(a.current, null);
    $ac4a9effa24fe7be$var$Z = $ac4a9effa24fe7be$var$gj = b;
    $ac4a9effa24fe7be$var$T = 0;
    $ac4a9effa24fe7be$var$qk = null;
    $ac4a9effa24fe7be$var$sk = $ac4a9effa24fe7be$var$rk = $ac4a9effa24fe7be$var$hh = 0;
    $ac4a9effa24fe7be$var$uk = $ac4a9effa24fe7be$var$tk = null;
    if (null !== $ac4a9effa24fe7be$var$Wg) {
        for(b = 0; b < $ac4a9effa24fe7be$var$Wg.length; b++)if (c = $ac4a9effa24fe7be$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $ac4a9effa24fe7be$var$Wg = null;
    }
    return a;
}
function $ac4a9effa24fe7be$var$Nk(a, b) {
    do {
        var c = $ac4a9effa24fe7be$var$Y;
        try {
            $ac4a9effa24fe7be$var$Qg();
            $ac4a9effa24fe7be$var$Ph.current = $ac4a9effa24fe7be$var$ai;
            if ($ac4a9effa24fe7be$var$Sh) {
                for(var d = $ac4a9effa24fe7be$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $ac4a9effa24fe7be$var$Sh = !1;
            }
            $ac4a9effa24fe7be$var$Rh = 0;
            $ac4a9effa24fe7be$var$P = $ac4a9effa24fe7be$var$O = $ac4a9effa24fe7be$var$N = null;
            $ac4a9effa24fe7be$var$Th = !1;
            $ac4a9effa24fe7be$var$Uh = 0;
            $ac4a9effa24fe7be$var$ok.current = null;
            if (null === c || null === c.return) {
                $ac4a9effa24fe7be$var$T = 1;
                $ac4a9effa24fe7be$var$qk = b;
                $ac4a9effa24fe7be$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $ac4a9effa24fe7be$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $ac4a9effa24fe7be$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $ac4a9effa24fe7be$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $ac4a9effa24fe7be$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $ac4a9effa24fe7be$var$Ti(f, l, b);
                            $ac4a9effa24fe7be$var$uj();
                            break a;
                        }
                        k = Error($ac4a9effa24fe7be$var$p(426));
                    }
                } else if ($ac4a9effa24fe7be$var$I && h.mode & 1) {
                    var J = $ac4a9effa24fe7be$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $ac4a9effa24fe7be$var$Wi(J, g, h, f, b);
                        $ac4a9effa24fe7be$var$Jg($ac4a9effa24fe7be$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $ac4a9effa24fe7be$var$Ki(k, h);
                4 !== $ac4a9effa24fe7be$var$T && ($ac4a9effa24fe7be$var$T = 2);
                null === $ac4a9effa24fe7be$var$tk ? $ac4a9effa24fe7be$var$tk = [
                    f
                ] : $ac4a9effa24fe7be$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $ac4a9effa24fe7be$var$Oi(f, k, b);
                            $ac4a9effa24fe7be$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $ac4a9effa24fe7be$var$Si || !$ac4a9effa24fe7be$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $ac4a9effa24fe7be$var$Ri(f, h, b);
                                $ac4a9effa24fe7be$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $ac4a9effa24fe7be$var$Tk(c);
        } catch (na) {
            b = na;
            $ac4a9effa24fe7be$var$Y === c && null !== c && ($ac4a9effa24fe7be$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $ac4a9effa24fe7be$var$Kk() {
    var a = $ac4a9effa24fe7be$var$nk.current;
    $ac4a9effa24fe7be$var$nk.current = $ac4a9effa24fe7be$var$ai;
    return null === a ? $ac4a9effa24fe7be$var$ai : a;
}
function $ac4a9effa24fe7be$var$uj() {
    if (0 === $ac4a9effa24fe7be$var$T || 3 === $ac4a9effa24fe7be$var$T || 2 === $ac4a9effa24fe7be$var$T) $ac4a9effa24fe7be$var$T = 4;
    null === $ac4a9effa24fe7be$var$R || 0 === ($ac4a9effa24fe7be$var$hh & 268435455) && 0 === ($ac4a9effa24fe7be$var$rk & 268435455) || $ac4a9effa24fe7be$var$Dk($ac4a9effa24fe7be$var$R, $ac4a9effa24fe7be$var$Z);
}
function $ac4a9effa24fe7be$var$Jk(a, b) {
    var c = $ac4a9effa24fe7be$var$K;
    $ac4a9effa24fe7be$var$K |= 2;
    var d = $ac4a9effa24fe7be$var$Kk();
    if ($ac4a9effa24fe7be$var$R !== a || $ac4a9effa24fe7be$var$Z !== b) $ac4a9effa24fe7be$var$vk = null, $ac4a9effa24fe7be$var$Lk(a, b);
    for(;;)try {
        $ac4a9effa24fe7be$var$Uk();
        break;
    } catch (e) {
        $ac4a9effa24fe7be$var$Nk(a, e);
    }
    $ac4a9effa24fe7be$var$Qg();
    $ac4a9effa24fe7be$var$K = c;
    $ac4a9effa24fe7be$var$nk.current = d;
    if (null !== $ac4a9effa24fe7be$var$Y) throw Error($ac4a9effa24fe7be$var$p(261));
    $ac4a9effa24fe7be$var$R = null;
    $ac4a9effa24fe7be$var$Z = 0;
    return $ac4a9effa24fe7be$var$T;
}
function $ac4a9effa24fe7be$var$Uk() {
    for(; null !== $ac4a9effa24fe7be$var$Y;)$ac4a9effa24fe7be$var$Vk($ac4a9effa24fe7be$var$Y);
}
function $ac4a9effa24fe7be$var$Mk() {
    for(; null !== $ac4a9effa24fe7be$var$Y && !$ac4a9effa24fe7be$var$cc();)$ac4a9effa24fe7be$var$Vk($ac4a9effa24fe7be$var$Y);
}
function $ac4a9effa24fe7be$var$Vk(a) {
    var b = $ac4a9effa24fe7be$var$Wk(a.alternate, a, $ac4a9effa24fe7be$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $ac4a9effa24fe7be$var$Tk(a) : $ac4a9effa24fe7be$var$Y = b;
    $ac4a9effa24fe7be$var$ok.current = null;
}
function $ac4a9effa24fe7be$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $ac4a9effa24fe7be$var$Fj(c, b, $ac4a9effa24fe7be$var$gj), null !== c) {
                $ac4a9effa24fe7be$var$Y = c;
                return;
            }
        } else {
            c = $ac4a9effa24fe7be$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $ac4a9effa24fe7be$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $ac4a9effa24fe7be$var$T = 6;
                $ac4a9effa24fe7be$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $ac4a9effa24fe7be$var$Y = b;
            return;
        }
        $ac4a9effa24fe7be$var$Y = b = a;
    }while (null !== b);
    0 === $ac4a9effa24fe7be$var$T && ($ac4a9effa24fe7be$var$T = 5);
}
function $ac4a9effa24fe7be$var$Qk(a, b, c) {
    var d = $ac4a9effa24fe7be$var$C, e = $ac4a9effa24fe7be$var$pk.transition;
    try {
        $ac4a9effa24fe7be$var$pk.transition = null, $ac4a9effa24fe7be$var$C = 1, $ac4a9effa24fe7be$var$Xk(a, b, c, d);
    } finally{
        $ac4a9effa24fe7be$var$pk.transition = e, $ac4a9effa24fe7be$var$C = d;
    }
    return null;
}
function $ac4a9effa24fe7be$var$Xk(a, b, c, d) {
    do $ac4a9effa24fe7be$var$Ik();
    while (null !== $ac4a9effa24fe7be$var$xk);
    if (0 !== ($ac4a9effa24fe7be$var$K & 6)) throw Error($ac4a9effa24fe7be$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($ac4a9effa24fe7be$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $ac4a9effa24fe7be$var$Bc(a, f);
    a === $ac4a9effa24fe7be$var$R && ($ac4a9effa24fe7be$var$Y = $ac4a9effa24fe7be$var$R = null, $ac4a9effa24fe7be$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $ac4a9effa24fe7be$var$wk || ($ac4a9effa24fe7be$var$wk = !0, $ac4a9effa24fe7be$var$Gk($ac4a9effa24fe7be$var$hc, function() {
        $ac4a9effa24fe7be$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $ac4a9effa24fe7be$var$pk.transition;
        $ac4a9effa24fe7be$var$pk.transition = null;
        var g = $ac4a9effa24fe7be$var$C;
        $ac4a9effa24fe7be$var$C = 1;
        var h = $ac4a9effa24fe7be$var$K;
        $ac4a9effa24fe7be$var$K |= 4;
        $ac4a9effa24fe7be$var$ok.current = null;
        $ac4a9effa24fe7be$var$Pj(a, c);
        $ac4a9effa24fe7be$var$ek(c, a);
        $ac4a9effa24fe7be$var$Oe($ac4a9effa24fe7be$var$Df);
        $ac4a9effa24fe7be$var$dd = !!$ac4a9effa24fe7be$var$Cf;
        $ac4a9effa24fe7be$var$Df = $ac4a9effa24fe7be$var$Cf = null;
        a.current = c;
        $ac4a9effa24fe7be$var$ik(c, a, e);
        $ac4a9effa24fe7be$var$dc();
        $ac4a9effa24fe7be$var$K = h;
        $ac4a9effa24fe7be$var$C = g;
        $ac4a9effa24fe7be$var$pk.transition = f;
    } else a.current = c;
    $ac4a9effa24fe7be$var$wk && ($ac4a9effa24fe7be$var$wk = !1, $ac4a9effa24fe7be$var$xk = a, $ac4a9effa24fe7be$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($ac4a9effa24fe7be$var$Si = null);
    $ac4a9effa24fe7be$var$mc(c.stateNode, d);
    $ac4a9effa24fe7be$var$Ek(a, $ac4a9effa24fe7be$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($ac4a9effa24fe7be$var$Pi) throw $ac4a9effa24fe7be$var$Pi = !1, a = $ac4a9effa24fe7be$var$Qi, $ac4a9effa24fe7be$var$Qi = null, a;
    0 !== ($ac4a9effa24fe7be$var$yk & 1) && 0 !== a.tag && $ac4a9effa24fe7be$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $ac4a9effa24fe7be$var$Ak ? $ac4a9effa24fe7be$var$zk++ : ($ac4a9effa24fe7be$var$zk = 0, $ac4a9effa24fe7be$var$Ak = a) : $ac4a9effa24fe7be$var$zk = 0;
    $ac4a9effa24fe7be$var$jg();
    return null;
}
function $ac4a9effa24fe7be$var$Ik() {
    if (null !== $ac4a9effa24fe7be$var$xk) {
        var a = $ac4a9effa24fe7be$var$Dc($ac4a9effa24fe7be$var$yk), b = $ac4a9effa24fe7be$var$pk.transition, c = $ac4a9effa24fe7be$var$C;
        try {
            $ac4a9effa24fe7be$var$pk.transition = null;
            $ac4a9effa24fe7be$var$C = 16 > a ? 16 : a;
            if (null === $ac4a9effa24fe7be$var$xk) var d = !1;
            else {
                a = $ac4a9effa24fe7be$var$xk;
                $ac4a9effa24fe7be$var$xk = null;
                $ac4a9effa24fe7be$var$yk = 0;
                if (0 !== ($ac4a9effa24fe7be$var$K & 6)) throw Error($ac4a9effa24fe7be$var$p(331));
                var e = $ac4a9effa24fe7be$var$K;
                $ac4a9effa24fe7be$var$K |= 4;
                for($ac4a9effa24fe7be$var$V = a.current; null !== $ac4a9effa24fe7be$var$V;){
                    var f = $ac4a9effa24fe7be$var$V, g = f.child;
                    if (0 !== ($ac4a9effa24fe7be$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($ac4a9effa24fe7be$var$V = l; null !== $ac4a9effa24fe7be$var$V;){
                                    var m = $ac4a9effa24fe7be$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $ac4a9effa24fe7be$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $ac4a9effa24fe7be$var$V = q;
                                    else for(; null !== $ac4a9effa24fe7be$var$V;){
                                        m = $ac4a9effa24fe7be$var$V;
                                        var r = m.sibling, y = m.return;
                                        $ac4a9effa24fe7be$var$Tj(m);
                                        if (m === l) {
                                            $ac4a9effa24fe7be$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $ac4a9effa24fe7be$var$V = r;
                                            break;
                                        }
                                        $ac4a9effa24fe7be$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $ac4a9effa24fe7be$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $ac4a9effa24fe7be$var$V = g;
                    else b: for(; null !== $ac4a9effa24fe7be$var$V;){
                        f = $ac4a9effa24fe7be$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $ac4a9effa24fe7be$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $ac4a9effa24fe7be$var$V = x;
                            break b;
                        }
                        $ac4a9effa24fe7be$var$V = f.return;
                    }
                }
                var w = a.current;
                for($ac4a9effa24fe7be$var$V = w; null !== $ac4a9effa24fe7be$var$V;){
                    g = $ac4a9effa24fe7be$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $ac4a9effa24fe7be$var$V = u;
                    else b: for(g = w; null !== $ac4a9effa24fe7be$var$V;){
                        h = $ac4a9effa24fe7be$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $ac4a9effa24fe7be$var$Rj(9, h);
                            }
                        } catch (na) {
                            $ac4a9effa24fe7be$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $ac4a9effa24fe7be$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $ac4a9effa24fe7be$var$V = F;
                            break b;
                        }
                        $ac4a9effa24fe7be$var$V = h.return;
                    }
                }
                $ac4a9effa24fe7be$var$K = e;
                $ac4a9effa24fe7be$var$jg();
                if ($ac4a9effa24fe7be$var$lc && "function" === typeof $ac4a9effa24fe7be$var$lc.onPostCommitFiberRoot) try {
                    $ac4a9effa24fe7be$var$lc.onPostCommitFiberRoot($ac4a9effa24fe7be$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $ac4a9effa24fe7be$var$C = c, $ac4a9effa24fe7be$var$pk.transition = b;
        }
    }
    return !1;
}
function $ac4a9effa24fe7be$var$Yk(a, b, c) {
    b = $ac4a9effa24fe7be$var$Ki(c, b);
    b = $ac4a9effa24fe7be$var$Oi(a, b, 1);
    a = $ac4a9effa24fe7be$var$dh(a, b, 1);
    b = $ac4a9effa24fe7be$var$L();
    null !== a && ($ac4a9effa24fe7be$var$Ac(a, 1, b), $ac4a9effa24fe7be$var$Ek(a, b));
}
function $ac4a9effa24fe7be$var$W(a, b, c) {
    if (3 === a.tag) $ac4a9effa24fe7be$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $ac4a9effa24fe7be$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $ac4a9effa24fe7be$var$Si || !$ac4a9effa24fe7be$var$Si.has(d))) {
                a = $ac4a9effa24fe7be$var$Ki(c, a);
                a = $ac4a9effa24fe7be$var$Ri(b, a, 1);
                b = $ac4a9effa24fe7be$var$dh(b, a, 1);
                a = $ac4a9effa24fe7be$var$L();
                null !== b && ($ac4a9effa24fe7be$var$Ac(b, 1, a), $ac4a9effa24fe7be$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $ac4a9effa24fe7be$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $ac4a9effa24fe7be$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $ac4a9effa24fe7be$var$R === a && ($ac4a9effa24fe7be$var$Z & c) === c && (4 === $ac4a9effa24fe7be$var$T || 3 === $ac4a9effa24fe7be$var$T && ($ac4a9effa24fe7be$var$Z & 130023424) === $ac4a9effa24fe7be$var$Z && 500 > $ac4a9effa24fe7be$var$B() - $ac4a9effa24fe7be$var$gk ? $ac4a9effa24fe7be$var$Lk(a, 0) : $ac4a9effa24fe7be$var$sk |= c);
    $ac4a9effa24fe7be$var$Ek(a, b);
}
function $ac4a9effa24fe7be$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $ac4a9effa24fe7be$var$sc, $ac4a9effa24fe7be$var$sc <<= 1, 0 === ($ac4a9effa24fe7be$var$sc & 130023424) && ($ac4a9effa24fe7be$var$sc = 4194304)));
    var c = $ac4a9effa24fe7be$var$L();
    a = $ac4a9effa24fe7be$var$Zg(a, b);
    null !== a && ($ac4a9effa24fe7be$var$Ac(a, b, c), $ac4a9effa24fe7be$var$Ek(a, c));
}
function $ac4a9effa24fe7be$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $ac4a9effa24fe7be$var$Zk(a, c);
}
function $ac4a9effa24fe7be$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($ac4a9effa24fe7be$var$p(314));
    }
    null !== d && d.delete(b);
    $ac4a9effa24fe7be$var$Zk(a, c);
}
var $ac4a9effa24fe7be$var$Wk;
$ac4a9effa24fe7be$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $ac4a9effa24fe7be$var$Wf.current) $ac4a9effa24fe7be$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $ac4a9effa24fe7be$var$Ug = !1, $ac4a9effa24fe7be$var$zj(a, b, c);
            $ac4a9effa24fe7be$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $ac4a9effa24fe7be$var$Ug = !1, $ac4a9effa24fe7be$var$I && 0 !== (b.flags & 1048576) && $ac4a9effa24fe7be$var$ug(b, $ac4a9effa24fe7be$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $ac4a9effa24fe7be$var$jj(a, b);
            a = b.pendingProps;
            var e = $ac4a9effa24fe7be$var$Yf(b, $ac4a9effa24fe7be$var$H.current);
            $ac4a9effa24fe7be$var$Tg(b, c);
            e = $ac4a9effa24fe7be$var$Xh(null, b, d, a, e, c);
            var f = $ac4a9effa24fe7be$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $ac4a9effa24fe7be$var$Zf(d) ? (f = !0, $ac4a9effa24fe7be$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $ac4a9effa24fe7be$var$ah(b), e.updater = $ac4a9effa24fe7be$var$nh, b.stateNode = e, e._reactInternals = b, $ac4a9effa24fe7be$var$rh(b, d, a, c), b = $ac4a9effa24fe7be$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $ac4a9effa24fe7be$var$I && f && $ac4a9effa24fe7be$var$vg(b), $ac4a9effa24fe7be$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $ac4a9effa24fe7be$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $ac4a9effa24fe7be$var$$k(d);
                a = $ac4a9effa24fe7be$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $ac4a9effa24fe7be$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $ac4a9effa24fe7be$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $ac4a9effa24fe7be$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $ac4a9effa24fe7be$var$aj(null, b, d, $ac4a9effa24fe7be$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($ac4a9effa24fe7be$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $ac4a9effa24fe7be$var$Lg(d, e), $ac4a9effa24fe7be$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $ac4a9effa24fe7be$var$Lg(d, e), $ac4a9effa24fe7be$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $ac4a9effa24fe7be$var$lj(b);
                if (null === a) throw Error($ac4a9effa24fe7be$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $ac4a9effa24fe7be$var$bh(a, b);
                $ac4a9effa24fe7be$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $ac4a9effa24fe7be$var$Ki(Error($ac4a9effa24fe7be$var$p(423)), b);
                        b = $ac4a9effa24fe7be$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $ac4a9effa24fe7be$var$Ki(Error($ac4a9effa24fe7be$var$p(424)), b);
                        b = $ac4a9effa24fe7be$var$mj(a, b, d, c, e);
                        break a;
                    } else for($ac4a9effa24fe7be$var$yg = $ac4a9effa24fe7be$var$Lf(b.stateNode.containerInfo.firstChild), $ac4a9effa24fe7be$var$xg = b, $ac4a9effa24fe7be$var$I = !0, $ac4a9effa24fe7be$var$zg = null, c = $ac4a9effa24fe7be$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $ac4a9effa24fe7be$var$Ig();
                    if (d === e) {
                        b = $ac4a9effa24fe7be$var$$i(a, b, c);
                        break a;
                    }
                    $ac4a9effa24fe7be$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $ac4a9effa24fe7be$var$Kh(b), null === a && $ac4a9effa24fe7be$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $ac4a9effa24fe7be$var$Ef(d, e) ? g = null : null !== f && $ac4a9effa24fe7be$var$Ef(d, f) && (b.flags |= 32), $ac4a9effa24fe7be$var$hj(a, b), $ac4a9effa24fe7be$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $ac4a9effa24fe7be$var$Eg(b), null;
        case 13:
            return $ac4a9effa24fe7be$var$pj(a, b, c);
        case 4:
            return $ac4a9effa24fe7be$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $ac4a9effa24fe7be$var$Bh(b, null, d, c) : $ac4a9effa24fe7be$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $ac4a9effa24fe7be$var$Lg(d, e), $ac4a9effa24fe7be$var$Zi(a, b, d, e, c);
        case 7:
            return $ac4a9effa24fe7be$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $ac4a9effa24fe7be$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $ac4a9effa24fe7be$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($ac4a9effa24fe7be$var$He(f.value, g)) {
                        if (f.children === e.children && !$ac4a9effa24fe7be$var$Wf.current) {
                            b = $ac4a9effa24fe7be$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $ac4a9effa24fe7be$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $ac4a9effa24fe7be$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($ac4a9effa24fe7be$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $ac4a9effa24fe7be$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $ac4a9effa24fe7be$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $ac4a9effa24fe7be$var$Tg(b, c), e = $ac4a9effa24fe7be$var$Vg(e), d = d(e), b.flags |= 1, $ac4a9effa24fe7be$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $ac4a9effa24fe7be$var$Lg(d, b.pendingProps), e = $ac4a9effa24fe7be$var$Lg(d.type, e), $ac4a9effa24fe7be$var$aj(a, b, d, e, c);
        case 15:
            return $ac4a9effa24fe7be$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $ac4a9effa24fe7be$var$Lg(d, e), $ac4a9effa24fe7be$var$jj(a, b), b.tag = 1, $ac4a9effa24fe7be$var$Zf(d) ? (a = !0, $ac4a9effa24fe7be$var$cg(b)) : a = !1, $ac4a9effa24fe7be$var$Tg(b, c), $ac4a9effa24fe7be$var$ph(b, d, e), $ac4a9effa24fe7be$var$rh(b, d, e, c), $ac4a9effa24fe7be$var$kj(null, b, d, !0, a, c);
        case 19:
            return $ac4a9effa24fe7be$var$yj(a, b, c);
        case 22:
            return $ac4a9effa24fe7be$var$ej(a, b, c);
    }
    throw Error($ac4a9effa24fe7be$var$p(156, b.tag));
};
function $ac4a9effa24fe7be$var$Gk(a, b) {
    return $ac4a9effa24fe7be$var$ac(a, b);
}
function $ac4a9effa24fe7be$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $ac4a9effa24fe7be$var$Bg(a, b, c, d) {
    return new $ac4a9effa24fe7be$var$al(a, b, c, d);
}
function $ac4a9effa24fe7be$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $ac4a9effa24fe7be$var$$k(a) {
    if ("function" === typeof a) return $ac4a9effa24fe7be$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $ac4a9effa24fe7be$var$Da) return 11;
        if (a === $ac4a9effa24fe7be$var$Ga) return 14;
    }
    return 2;
}
function $ac4a9effa24fe7be$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $ac4a9effa24fe7be$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $ac4a9effa24fe7be$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $ac4a9effa24fe7be$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $ac4a9effa24fe7be$var$ya:
            return $ac4a9effa24fe7be$var$Ah(c.children, e, f, b);
        case $ac4a9effa24fe7be$var$za:
            g = 8;
            e |= 8;
            break;
        case $ac4a9effa24fe7be$var$Aa:
            return a = $ac4a9effa24fe7be$var$Bg(12, c, b, e | 2), a.elementType = $ac4a9effa24fe7be$var$Aa, a.lanes = f, a;
        case $ac4a9effa24fe7be$var$Ea:
            return a = $ac4a9effa24fe7be$var$Bg(13, c, b, e), a.elementType = $ac4a9effa24fe7be$var$Ea, a.lanes = f, a;
        case $ac4a9effa24fe7be$var$Fa:
            return a = $ac4a9effa24fe7be$var$Bg(19, c, b, e), a.elementType = $ac4a9effa24fe7be$var$Fa, a.lanes = f, a;
        case $ac4a9effa24fe7be$var$Ia:
            return $ac4a9effa24fe7be$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $ac4a9effa24fe7be$var$Ba:
                    g = 10;
                    break a;
                case $ac4a9effa24fe7be$var$Ca:
                    g = 9;
                    break a;
                case $ac4a9effa24fe7be$var$Da:
                    g = 11;
                    break a;
                case $ac4a9effa24fe7be$var$Ga:
                    g = 14;
                    break a;
                case $ac4a9effa24fe7be$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($ac4a9effa24fe7be$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $ac4a9effa24fe7be$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $ac4a9effa24fe7be$var$Ah(a, b, c, d) {
    a = $ac4a9effa24fe7be$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $ac4a9effa24fe7be$var$qj(a, b, c, d) {
    a = $ac4a9effa24fe7be$var$Bg(22, a, d, b);
    a.elementType = $ac4a9effa24fe7be$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $ac4a9effa24fe7be$var$xh(a, b, c) {
    a = $ac4a9effa24fe7be$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $ac4a9effa24fe7be$var$zh(a, b, c) {
    b = $ac4a9effa24fe7be$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $ac4a9effa24fe7be$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $ac4a9effa24fe7be$var$zc(0);
    this.expirationTimes = $ac4a9effa24fe7be$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $ac4a9effa24fe7be$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $ac4a9effa24fe7be$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $ac4a9effa24fe7be$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $ac4a9effa24fe7be$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $ac4a9effa24fe7be$var$ah(f);
    return a;
}
function $ac4a9effa24fe7be$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $ac4a9effa24fe7be$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $ac4a9effa24fe7be$var$el(a) {
    if (!a) return $ac4a9effa24fe7be$var$Vf;
    a = a._reactInternals;
    a: {
        if ($ac4a9effa24fe7be$var$Vb(a) !== a || 1 !== a.tag) throw Error($ac4a9effa24fe7be$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($ac4a9effa24fe7be$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($ac4a9effa24fe7be$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($ac4a9effa24fe7be$var$Zf(c)) return $ac4a9effa24fe7be$var$bg(a, c, b);
    }
    return b;
}
function $ac4a9effa24fe7be$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $ac4a9effa24fe7be$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $ac4a9effa24fe7be$var$el(null);
    c = a.current;
    d = $ac4a9effa24fe7be$var$L();
    e = $ac4a9effa24fe7be$var$lh(c);
    f = $ac4a9effa24fe7be$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $ac4a9effa24fe7be$var$dh(c, f, e);
    a.current.lanes = e;
    $ac4a9effa24fe7be$var$Ac(a, e, d);
    $ac4a9effa24fe7be$var$Ek(a, d);
    return a;
}
function $ac4a9effa24fe7be$var$gl(a, b, c, d) {
    var e = b.current, f = $ac4a9effa24fe7be$var$L(), g = $ac4a9effa24fe7be$var$lh(e);
    c = $ac4a9effa24fe7be$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $ac4a9effa24fe7be$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $ac4a9effa24fe7be$var$dh(e, b, g);
    null !== a && ($ac4a9effa24fe7be$var$mh(a, e, g, f), $ac4a9effa24fe7be$var$eh(a, e, g));
    return g;
}
function $ac4a9effa24fe7be$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $ac4a9effa24fe7be$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $ac4a9effa24fe7be$var$jl(a, b) {
    $ac4a9effa24fe7be$var$il(a, b);
    (a = a.alternate) && $ac4a9effa24fe7be$var$il(a, b);
}
function $ac4a9effa24fe7be$var$kl() {
    return null;
}
var $ac4a9effa24fe7be$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $ac4a9effa24fe7be$var$ml(a) {
    this._internalRoot = a;
}
$ac4a9effa24fe7be$var$nl.prototype.render = $ac4a9effa24fe7be$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($ac4a9effa24fe7be$var$p(409));
    $ac4a9effa24fe7be$var$gl(a, b, null, null);
};
$ac4a9effa24fe7be$var$nl.prototype.unmount = $ac4a9effa24fe7be$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $ac4a9effa24fe7be$var$Sk(function() {
            $ac4a9effa24fe7be$var$gl(null, a, null, null);
        });
        b[$ac4a9effa24fe7be$var$uf] = null;
    }
};
function $ac4a9effa24fe7be$var$nl(a) {
    this._internalRoot = a;
}
$ac4a9effa24fe7be$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $ac4a9effa24fe7be$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $ac4a9effa24fe7be$var$Qc.length && 0 !== b && b < $ac4a9effa24fe7be$var$Qc[c].priority; c++);
        $ac4a9effa24fe7be$var$Qc.splice(c, 0, a);
        0 === c && $ac4a9effa24fe7be$var$Vc(a);
    }
};
function $ac4a9effa24fe7be$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $ac4a9effa24fe7be$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $ac4a9effa24fe7be$var$ql() {}
function $ac4a9effa24fe7be$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $ac4a9effa24fe7be$var$hl(g);
                f.call(a);
            };
        }
        var g = $ac4a9effa24fe7be$var$fl(b, d, a, 0, null, !1, !1, "", $ac4a9effa24fe7be$var$ql);
        a._reactRootContainer = g;
        a[$ac4a9effa24fe7be$var$uf] = g.current;
        $ac4a9effa24fe7be$var$sf(8 === a.nodeType ? a.parentNode : a);
        $ac4a9effa24fe7be$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $ac4a9effa24fe7be$var$hl(k);
            h.call(a);
        };
    }
    var k = $ac4a9effa24fe7be$var$cl(a, 0, !1, null, null, !1, !1, "", $ac4a9effa24fe7be$var$ql);
    a._reactRootContainer = k;
    a[$ac4a9effa24fe7be$var$uf] = k.current;
    $ac4a9effa24fe7be$var$sf(8 === a.nodeType ? a.parentNode : a);
    $ac4a9effa24fe7be$var$Sk(function() {
        $ac4a9effa24fe7be$var$gl(b, k, c, d);
    });
    return k;
}
function $ac4a9effa24fe7be$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $ac4a9effa24fe7be$var$hl(g);
                h.call(a);
            };
        }
        $ac4a9effa24fe7be$var$gl(b, g, a, e);
    } else g = $ac4a9effa24fe7be$var$rl(c, b, a, e, d);
    return $ac4a9effa24fe7be$var$hl(g);
}
$ac4a9effa24fe7be$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $ac4a9effa24fe7be$var$tc(b.pendingLanes);
                0 !== c && ($ac4a9effa24fe7be$var$Cc(b, c | 1), $ac4a9effa24fe7be$var$Ek(b, $ac4a9effa24fe7be$var$B()), 0 === ($ac4a9effa24fe7be$var$K & 6) && ($ac4a9effa24fe7be$var$Hj = $ac4a9effa24fe7be$var$B() + 500, $ac4a9effa24fe7be$var$jg()));
            }
            break;
        case 13:
            $ac4a9effa24fe7be$var$Sk(function() {
                var b = $ac4a9effa24fe7be$var$Zg(a, 1);
                if (null !== b) {
                    var c = $ac4a9effa24fe7be$var$L();
                    $ac4a9effa24fe7be$var$mh(b, a, 1, c);
                }
            }), $ac4a9effa24fe7be$var$jl(a, 1);
    }
};
$ac4a9effa24fe7be$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $ac4a9effa24fe7be$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $ac4a9effa24fe7be$var$L();
            $ac4a9effa24fe7be$var$mh(b, a, 134217728, c);
        }
        $ac4a9effa24fe7be$var$jl(a, 134217728);
    }
};
$ac4a9effa24fe7be$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $ac4a9effa24fe7be$var$lh(a), c = $ac4a9effa24fe7be$var$Zg(a, b);
        if (null !== c) {
            var d = $ac4a9effa24fe7be$var$L();
            $ac4a9effa24fe7be$var$mh(c, a, b, d);
        }
        $ac4a9effa24fe7be$var$jl(a, b);
    }
};
$ac4a9effa24fe7be$var$Hc = function() {
    return $ac4a9effa24fe7be$var$C;
};
$ac4a9effa24fe7be$var$Ic = function(a, b) {
    var c = $ac4a9effa24fe7be$var$C;
    try {
        return $ac4a9effa24fe7be$var$C = a, b();
    } finally{
        $ac4a9effa24fe7be$var$C = c;
    }
};
$ac4a9effa24fe7be$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $ac4a9effa24fe7be$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $ac4a9effa24fe7be$var$Db(d);
                        if (!e) throw Error($ac4a9effa24fe7be$var$p(90));
                        $ac4a9effa24fe7be$var$Wa(d);
                        $ac4a9effa24fe7be$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $ac4a9effa24fe7be$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $ac4a9effa24fe7be$var$fb(a, !!c.multiple, b, !1);
    }
};
$ac4a9effa24fe7be$var$Gb = $ac4a9effa24fe7be$var$Rk;
$ac4a9effa24fe7be$var$Hb = $ac4a9effa24fe7be$var$Sk;
var $ac4a9effa24fe7be$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $ac4a9effa24fe7be$var$Cb,
        $ac4a9effa24fe7be$var$ue,
        $ac4a9effa24fe7be$var$Db,
        $ac4a9effa24fe7be$var$Eb,
        $ac4a9effa24fe7be$var$Fb,
        $ac4a9effa24fe7be$var$Rk
    ]
}, $ac4a9effa24fe7be$var$ul = {
    findFiberByHostInstance: $ac4a9effa24fe7be$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $ac4a9effa24fe7be$var$vl = {
    bundleType: $ac4a9effa24fe7be$var$ul.bundleType,
    version: $ac4a9effa24fe7be$var$ul.version,
    rendererPackageName: $ac4a9effa24fe7be$var$ul.rendererPackageName,
    rendererConfig: $ac4a9effa24fe7be$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $ac4a9effa24fe7be$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $ac4a9effa24fe7be$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $ac4a9effa24fe7be$var$ul.findFiberByHostInstance || $ac4a9effa24fe7be$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $ac4a9effa24fe7be$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$ac4a9effa24fe7be$var$wl.isDisabled && $ac4a9effa24fe7be$var$wl.supportsFiber) try {
        $ac4a9effa24fe7be$var$kc = $ac4a9effa24fe7be$var$wl.inject($ac4a9effa24fe7be$var$vl), $ac4a9effa24fe7be$var$lc = $ac4a9effa24fe7be$var$wl;
    } catch (a) {}
}
$ac4a9effa24fe7be$export$ae55be85d98224ed = $ac4a9effa24fe7be$var$tl;
$ac4a9effa24fe7be$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$ac4a9effa24fe7be$var$ol(b)) throw Error($ac4a9effa24fe7be$var$p(200));
    return $ac4a9effa24fe7be$var$dl(a, b, null, c);
};
$ac4a9effa24fe7be$export$882461b6382ed46c = function(a, b) {
    if (!$ac4a9effa24fe7be$var$ol(a)) throw Error($ac4a9effa24fe7be$var$p(299));
    var c = !1, d = "", e = $ac4a9effa24fe7be$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $ac4a9effa24fe7be$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$ac4a9effa24fe7be$var$uf] = b.current;
    $ac4a9effa24fe7be$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $ac4a9effa24fe7be$var$ml(b);
};
$ac4a9effa24fe7be$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($ac4a9effa24fe7be$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($ac4a9effa24fe7be$var$p(268, a));
    }
    a = $ac4a9effa24fe7be$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$ac4a9effa24fe7be$export$cd75ccfd720a3cd4 = function(a) {
    return $ac4a9effa24fe7be$var$Sk(a);
};
$ac4a9effa24fe7be$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$ac4a9effa24fe7be$var$pl(b)) throw Error($ac4a9effa24fe7be$var$p(200));
    return $ac4a9effa24fe7be$var$sl(null, a, b, !0, c);
};
$ac4a9effa24fe7be$export$757ceba2d55c277e = function(a, b, c) {
    if (!$ac4a9effa24fe7be$var$ol(a)) throw Error($ac4a9effa24fe7be$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $ac4a9effa24fe7be$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $ac4a9effa24fe7be$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$ac4a9effa24fe7be$var$uf] = b.current;
    $ac4a9effa24fe7be$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $ac4a9effa24fe7be$var$nl(b);
};
$ac4a9effa24fe7be$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$ac4a9effa24fe7be$var$pl(b)) throw Error($ac4a9effa24fe7be$var$p(200));
    return $ac4a9effa24fe7be$var$sl(null, a, b, !1, c);
};
$ac4a9effa24fe7be$export$502457920280e6be = function(a) {
    if (!$ac4a9effa24fe7be$var$pl(a)) throw Error($ac4a9effa24fe7be$var$p(40));
    return a._reactRootContainer ? ($ac4a9effa24fe7be$var$Sk(function() {
        $ac4a9effa24fe7be$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$ac4a9effa24fe7be$var$uf] = null;
        });
    }), !0) : !1;
};
$ac4a9effa24fe7be$export$c78a37762a8d58e1 = $ac4a9effa24fe7be$var$Rk;
$ac4a9effa24fe7be$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$ac4a9effa24fe7be$var$pl(c)) throw Error($ac4a9effa24fe7be$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($ac4a9effa24fe7be$var$p(38));
    return $ac4a9effa24fe7be$var$sl(a, b, c, !1, d);
};
$ac4a9effa24fe7be$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("Qw0kg", function(module, exports) {
"use strict";

module.exports = (parcelRequire("29Llp"));

});
parcelRegister("29Llp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $192125a6b5623347$export$c4744153514ff05d; }, function (v) { return $192125a6b5623347$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $192125a6b5623347$export$3e506c1ccc9cc1a7; }, function (v) { return $192125a6b5623347$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $192125a6b5623347$export$e26fe2ed2fa76875; }, function (v) { return $192125a6b5623347$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $192125a6b5623347$export$502329bbf4b505b1; }, function (v) { return $192125a6b5623347$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $192125a6b5623347$export$6e3807111c4874c4; }, function (v) { return $192125a6b5623347$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $192125a6b5623347$export$c27134553091fb3a; }, function (v) { return $192125a6b5623347$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $192125a6b5623347$export$33ee1acdc04fd2a2; }, function (v) { return $192125a6b5623347$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $192125a6b5623347$export$b00a404bbd5edef2; }, function (v) { return $192125a6b5623347$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $192125a6b5623347$export$8352ce38b91d0c62; }, function (v) { return $192125a6b5623347$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $192125a6b5623347$export$d66a1c1c77bd778b; }, function (v) { return $192125a6b5623347$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $192125a6b5623347$export$d3dfb8e4810cb555; }, function (v) { return $192125a6b5623347$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $192125a6b5623347$export$839f9183b0465a69; }, function (v) { return $192125a6b5623347$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $192125a6b5623347$export$72fdf0e06517287b; }, function (v) { return $192125a6b5623347$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $192125a6b5623347$export$4b844e58a3e414b4; }, function (v) { return $192125a6b5623347$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $192125a6b5623347$export$816d2913ae6b83b1; }, function (v) { return $192125a6b5623347$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $192125a6b5623347$export$61bcfe829111a1d0; }, function (v) { return $192125a6b5623347$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $192125a6b5623347$export$7ee8c9beb337bc3f; }, function (v) { return $192125a6b5623347$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $192125a6b5623347$export$b5836b71941fa3ed; }, function (v) { return $192125a6b5623347$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $192125a6b5623347$export$cf845f2c119da08a; }, function (v) { return $192125a6b5623347$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $192125a6b5623347$export$c4744153514ff05d;
var $192125a6b5623347$export$3e506c1ccc9cc1a7;
var $192125a6b5623347$export$e26fe2ed2fa76875;
var $192125a6b5623347$export$502329bbf4b505b1;
var $192125a6b5623347$export$6e3807111c4874c4;
var $192125a6b5623347$export$c27134553091fb3a;
var $192125a6b5623347$export$33ee1acdc04fd2a2;
var $192125a6b5623347$export$b00a404bbd5edef2;
var $192125a6b5623347$export$8352ce38b91d0c62;
var $192125a6b5623347$export$d66a1c1c77bd778b;
var $192125a6b5623347$export$d3dfb8e4810cb555;
var $192125a6b5623347$export$839f9183b0465a69;
var $192125a6b5623347$export$72fdf0e06517287b;
var $192125a6b5623347$export$4b844e58a3e414b4;
var $192125a6b5623347$export$816d2913ae6b83b1;
var $192125a6b5623347$export$61bcfe829111a1d0;
var $192125a6b5623347$export$7ee8c9beb337bc3f;
var $192125a6b5623347$export$b5836b71941fa3ed;
var $192125a6b5623347$export$cf845f2c119da08a;
"use strict";
function $192125a6b5623347$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $192125a6b5623347$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $192125a6b5623347$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $192125a6b5623347$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $192125a6b5623347$var$g(C, c)) n < e && 0 > $192125a6b5623347$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $192125a6b5623347$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $192125a6b5623347$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $192125a6b5623347$var$l = performance;
    $192125a6b5623347$export$c4744153514ff05d = function() {
        return $192125a6b5623347$var$l.now();
    };
} else {
    var $192125a6b5623347$var$p = Date, $192125a6b5623347$var$q = $192125a6b5623347$var$p.now();
    $192125a6b5623347$export$c4744153514ff05d = function() {
        return $192125a6b5623347$var$p.now() - $192125a6b5623347$var$q;
    };
}
var $192125a6b5623347$var$r = [], $192125a6b5623347$var$t = [], $192125a6b5623347$var$u = 1, $192125a6b5623347$var$v = null, $192125a6b5623347$var$y = 3, $192125a6b5623347$var$z = !1, $192125a6b5623347$var$A = !1, $192125a6b5623347$var$B = !1, $192125a6b5623347$var$D = "function" === typeof setTimeout ? setTimeout : null, $192125a6b5623347$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $192125a6b5623347$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $192125a6b5623347$var$G(a) {
    for(var b = $192125a6b5623347$var$h($192125a6b5623347$var$t); null !== b;){
        if (null === b.callback) $192125a6b5623347$var$k($192125a6b5623347$var$t);
        else if (b.startTime <= a) $192125a6b5623347$var$k($192125a6b5623347$var$t), b.sortIndex = b.expirationTime, $192125a6b5623347$var$f($192125a6b5623347$var$r, b);
        else break;
        b = $192125a6b5623347$var$h($192125a6b5623347$var$t);
    }
}
function $192125a6b5623347$var$H(a) {
    $192125a6b5623347$var$B = !1;
    $192125a6b5623347$var$G(a);
    if (!$192125a6b5623347$var$A) {
        if (null !== $192125a6b5623347$var$h($192125a6b5623347$var$r)) $192125a6b5623347$var$A = !0, $192125a6b5623347$var$I($192125a6b5623347$var$J);
        else {
            var b = $192125a6b5623347$var$h($192125a6b5623347$var$t);
            null !== b && $192125a6b5623347$var$K($192125a6b5623347$var$H, b.startTime - a);
        }
    }
}
function $192125a6b5623347$var$J(a, b) {
    $192125a6b5623347$var$A = !1;
    $192125a6b5623347$var$B && ($192125a6b5623347$var$B = !1, $192125a6b5623347$var$E($192125a6b5623347$var$L), $192125a6b5623347$var$L = -1);
    $192125a6b5623347$var$z = !0;
    var c = $192125a6b5623347$var$y;
    try {
        $192125a6b5623347$var$G(b);
        for($192125a6b5623347$var$v = $192125a6b5623347$var$h($192125a6b5623347$var$r); null !== $192125a6b5623347$var$v && (!($192125a6b5623347$var$v.expirationTime > b) || a && !$192125a6b5623347$var$M());){
            var d = $192125a6b5623347$var$v.callback;
            if ("function" === typeof d) {
                $192125a6b5623347$var$v.callback = null;
                $192125a6b5623347$var$y = $192125a6b5623347$var$v.priorityLevel;
                var e = d($192125a6b5623347$var$v.expirationTime <= b);
                b = $192125a6b5623347$export$c4744153514ff05d();
                "function" === typeof e ? $192125a6b5623347$var$v.callback = e : $192125a6b5623347$var$v === $192125a6b5623347$var$h($192125a6b5623347$var$r) && $192125a6b5623347$var$k($192125a6b5623347$var$r);
                $192125a6b5623347$var$G(b);
            } else $192125a6b5623347$var$k($192125a6b5623347$var$r);
            $192125a6b5623347$var$v = $192125a6b5623347$var$h($192125a6b5623347$var$r);
        }
        if (null !== $192125a6b5623347$var$v) var w = !0;
        else {
            var m = $192125a6b5623347$var$h($192125a6b5623347$var$t);
            null !== m && $192125a6b5623347$var$K($192125a6b5623347$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $192125a6b5623347$var$v = null, $192125a6b5623347$var$y = c, $192125a6b5623347$var$z = !1;
    }
}
var $192125a6b5623347$var$N = !1, $192125a6b5623347$var$O = null, $192125a6b5623347$var$L = -1, $192125a6b5623347$var$P = 5, $192125a6b5623347$var$Q = -1;
function $192125a6b5623347$var$M() {
    return $192125a6b5623347$export$c4744153514ff05d() - $192125a6b5623347$var$Q < $192125a6b5623347$var$P ? !1 : !0;
}
function $192125a6b5623347$var$R() {
    if (null !== $192125a6b5623347$var$O) {
        var a = $192125a6b5623347$export$c4744153514ff05d();
        $192125a6b5623347$var$Q = a;
        var b = !0;
        try {
            b = $192125a6b5623347$var$O(!0, a);
        } finally{
            b ? $192125a6b5623347$var$S() : ($192125a6b5623347$var$N = !1, $192125a6b5623347$var$O = null);
        }
    } else $192125a6b5623347$var$N = !1;
}
var $192125a6b5623347$var$S;
if ("function" === typeof $192125a6b5623347$var$F) $192125a6b5623347$var$S = function() {
    $192125a6b5623347$var$F($192125a6b5623347$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $192125a6b5623347$var$T = new MessageChannel, $192125a6b5623347$var$U = $192125a6b5623347$var$T.port2;
    $192125a6b5623347$var$T.port1.onmessage = $192125a6b5623347$var$R;
    $192125a6b5623347$var$S = function() {
        $192125a6b5623347$var$U.postMessage(null);
    };
} else $192125a6b5623347$var$S = function() {
    $192125a6b5623347$var$D($192125a6b5623347$var$R, 0);
};
function $192125a6b5623347$var$I(a) {
    $192125a6b5623347$var$O = a;
    $192125a6b5623347$var$N || ($192125a6b5623347$var$N = !0, $192125a6b5623347$var$S());
}
function $192125a6b5623347$var$K(a, b) {
    $192125a6b5623347$var$L = $192125a6b5623347$var$D(function() {
        a($192125a6b5623347$export$c4744153514ff05d());
    }, b);
}
$192125a6b5623347$export$3e506c1ccc9cc1a7 = 5;
$192125a6b5623347$export$e26fe2ed2fa76875 = 1;
$192125a6b5623347$export$502329bbf4b505b1 = 4;
$192125a6b5623347$export$6e3807111c4874c4 = 3;
$192125a6b5623347$export$c27134553091fb3a = null;
$192125a6b5623347$export$33ee1acdc04fd2a2 = 2;
$192125a6b5623347$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$192125a6b5623347$export$8352ce38b91d0c62 = function() {
    $192125a6b5623347$var$A || $192125a6b5623347$var$z || ($192125a6b5623347$var$A = !0, $192125a6b5623347$var$I($192125a6b5623347$var$J));
};
$192125a6b5623347$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $192125a6b5623347$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$192125a6b5623347$export$d3dfb8e4810cb555 = function() {
    return $192125a6b5623347$var$y;
};
$192125a6b5623347$export$839f9183b0465a69 = function() {
    return $192125a6b5623347$var$h($192125a6b5623347$var$r);
};
$192125a6b5623347$export$72fdf0e06517287b = function(a) {
    switch($192125a6b5623347$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $192125a6b5623347$var$y;
    }
    var c = $192125a6b5623347$var$y;
    $192125a6b5623347$var$y = b;
    try {
        return a();
    } finally{
        $192125a6b5623347$var$y = c;
    }
};
$192125a6b5623347$export$4b844e58a3e414b4 = function() {};
$192125a6b5623347$export$816d2913ae6b83b1 = function() {};
$192125a6b5623347$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $192125a6b5623347$var$y;
    $192125a6b5623347$var$y = a;
    try {
        return b();
    } finally{
        $192125a6b5623347$var$y = c;
    }
};
$192125a6b5623347$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $192125a6b5623347$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $192125a6b5623347$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $192125a6b5623347$var$f($192125a6b5623347$var$t, a), null === $192125a6b5623347$var$h($192125a6b5623347$var$r) && a === $192125a6b5623347$var$h($192125a6b5623347$var$t) && ($192125a6b5623347$var$B ? ($192125a6b5623347$var$E($192125a6b5623347$var$L), $192125a6b5623347$var$L = -1) : $192125a6b5623347$var$B = !0, $192125a6b5623347$var$K($192125a6b5623347$var$H, c - d))) : (a.sortIndex = e, $192125a6b5623347$var$f($192125a6b5623347$var$r, a), $192125a6b5623347$var$A || $192125a6b5623347$var$z || ($192125a6b5623347$var$A = !0, $192125a6b5623347$var$I($192125a6b5623347$var$J)));
    return a;
};
$192125a6b5623347$export$b5836b71941fa3ed = $192125a6b5623347$var$M;
$192125a6b5623347$export$cf845f2c119da08a = function(a) {
    var b = $192125a6b5623347$var$y;
    return function() {
        var c = $192125a6b5623347$var$y;
        $192125a6b5623347$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $192125a6b5623347$var$y = c;
        }
    };
};

});



parcelRegister("kh2Rv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $4H3Nt = parcelRequire("4H3Nt");
function $ec279d803f66d50f$var$emptyFunction() {}
function $ec279d803f66d50f$var$emptyFunctionWithReset() {}
$ec279d803f66d50f$var$emptyFunctionWithReset.resetWarningCache = $ec279d803f66d50f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $4H3Nt) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $ec279d803f66d50f$var$emptyFunctionWithReset,
        resetWarningCache: $ec279d803f66d50f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("4H3Nt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $36ae1f94766f6c68$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $36ae1f94766f6c68$var$ReactPropTypesSecret;

});


parcelRegister("kFpAu", function(module, exports) {

var $17tgv = parcelRequire("17tgv");

var $98IaM = parcelRequire("98IaM");
var $f0bb7c288364d569$require$Buffer = $98IaM.Buffer;










/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2023 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */ (function webpackUniversalModuleDefinition11(root11, factory11) {
    module.exports = root11.pdfjsLib = factory11();
})(globalThis, ()=>{
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ (__unused_webpack_module11, exports11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.VerbosityLevel = exports11.Util = exports11.UnknownErrorException = exports11.UnexpectedResponseException = exports11.TextRenderingMode = exports11.RenderingIntentFlag = exports11.PromiseCapability = exports11.PermissionFlag = exports11.PasswordResponses = exports11.PasswordException = exports11.PageActionEventType = exports11.OPS = exports11.MissingPDFException = exports11.MAX_IMAGE_SIZE_TO_CACHE = exports11.LINE_FACTOR = exports11.LINE_DESCENT_FACTOR = exports11.InvalidPDFException = exports11.ImageKind = exports11.IDENTITY_MATRIX = exports11.FormatError = exports11.FeatureTest = exports11.FONT_IDENTITY_MATRIX = exports11.DocumentActionEventType = exports11.CMapCompressionType = exports11.BaseException = exports11.BASELINE_FACTOR = exports11.AnnotationType = exports11.AnnotationReplyType = exports11.AnnotationPrefix = exports11.AnnotationMode = exports11.AnnotationFlag = exports11.AnnotationFieldFlag = exports11.AnnotationEditorType = exports11.AnnotationEditorPrefix = exports11.AnnotationEditorParamsType = exports11.AnnotationBorderStyleType = exports11.AnnotationActionEventType = exports11.AbortException = void 0;
                exports11.assert = assert11;
                exports11.bytesToString = bytesToString11;
                exports11.createValidAbsoluteUrl = createValidAbsoluteUrl11;
                exports11.getModificationDate = getModificationDate11;
                exports11.getUuid = getUuid11;
                exports11.getVerbosityLevel = getVerbosityLevel11;
                exports11.info = info11;
                exports11.isArrayBuffer = isArrayBuffer11;
                exports11.isArrayEqual = isArrayEqual11;
                exports11.isNodeJS = void 0;
                exports11.normalizeUnicode = normalizeUnicode11;
                exports11.objectFromMap = objectFromMap11;
                exports11.objectSize = objectSize11;
                exports11.setVerbosityLevel = setVerbosityLevel11;
                exports11.shadow = shadow11;
                exports11.string32 = string3211;
                exports11.stringToBytes = stringToBytes11;
                exports11.stringToPDFString = stringToPDFString11;
                exports11.stringToUTF8String = stringToUTF8String11;
                exports11.unreachable = unreachable11;
                exports11.utf8StringToString = utf8StringToString11;
                exports11.warn = warn11;
                const isNodeJS11 = typeof $17tgv === "object" && $17tgv + "" === "[object process]" && !$17tgv.versions.nw && !($17tgv.versions.electron && $17tgv.type && $17tgv.type !== "browser");
                exports11.isNodeJS = isNodeJS11;
                const IDENTITY_MATRIX11 = [
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ];
                exports11.IDENTITY_MATRIX = IDENTITY_MATRIX11;
                const FONT_IDENTITY_MATRIX11 = [
                    0.001,
                    0,
                    0,
                    0.001,
                    0,
                    0
                ];
                exports11.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX11;
                const MAX_IMAGE_SIZE_TO_CACHE11 = 10e6;
                exports11.MAX_IMAGE_SIZE_TO_CACHE = MAX_IMAGE_SIZE_TO_CACHE11;
                const LINE_FACTOR11 = 1.35;
                exports11.LINE_FACTOR = LINE_FACTOR11;
                const LINE_DESCENT_FACTOR11 = 0.35;
                exports11.LINE_DESCENT_FACTOR = LINE_DESCENT_FACTOR11;
                const BASELINE_FACTOR11 = LINE_DESCENT_FACTOR11 / LINE_FACTOR11;
                exports11.BASELINE_FACTOR = BASELINE_FACTOR11;
                const RenderingIntentFlag11 = {
                    ANY: 0x01,
                    DISPLAY: 0x02,
                    PRINT: 0x04,
                    SAVE: 0x08,
                    ANNOTATIONS_FORMS: 0x10,
                    ANNOTATIONS_STORAGE: 0x20,
                    ANNOTATIONS_DISABLE: 0x40,
                    OPLIST: 0x100
                };
                exports11.RenderingIntentFlag = RenderingIntentFlag11;
                const AnnotationMode11 = {
                    DISABLE: 0,
                    ENABLE: 1,
                    ENABLE_FORMS: 2,
                    ENABLE_STORAGE: 3
                };
                exports11.AnnotationMode = AnnotationMode11;
                const AnnotationEditorPrefix11 = "pdfjs_internal_editor_";
                exports11.AnnotationEditorPrefix = AnnotationEditorPrefix11;
                const AnnotationEditorType11 = {
                    DISABLE: -1,
                    NONE: 0,
                    FREETEXT: 3,
                    STAMP: 13,
                    INK: 15
                };
                exports11.AnnotationEditorType = AnnotationEditorType11;
                const AnnotationEditorParamsType11 = {
                    RESIZE: 1,
                    CREATE: 2,
                    FREETEXT_SIZE: 11,
                    FREETEXT_COLOR: 12,
                    FREETEXT_OPACITY: 13,
                    INK_COLOR: 21,
                    INK_THICKNESS: 22,
                    INK_OPACITY: 23
                };
                exports11.AnnotationEditorParamsType = AnnotationEditorParamsType11;
                const PermissionFlag11 = {
                    PRINT: 0x04,
                    MODIFY_CONTENTS: 0x08,
                    COPY: 0x10,
                    MODIFY_ANNOTATIONS: 0x20,
                    FILL_INTERACTIVE_FORMS: 0x100,
                    COPY_FOR_ACCESSIBILITY: 0x200,
                    ASSEMBLE: 0x400,
                    PRINT_HIGH_QUALITY: 0x800
                };
                exports11.PermissionFlag = PermissionFlag11;
                const TextRenderingMode11 = {
                    FILL: 0,
                    STROKE: 1,
                    FILL_STROKE: 2,
                    INVISIBLE: 3,
                    FILL_ADD_TO_PATH: 4,
                    STROKE_ADD_TO_PATH: 5,
                    FILL_STROKE_ADD_TO_PATH: 6,
                    ADD_TO_PATH: 7,
                    FILL_STROKE_MASK: 3,
                    ADD_TO_PATH_FLAG: 4
                };
                exports11.TextRenderingMode = TextRenderingMode11;
                const ImageKind11 = {
                    GRAYSCALE_1BPP: 1,
                    RGB_24BPP: 2,
                    RGBA_32BPP: 3
                };
                exports11.ImageKind = ImageKind11;
                const AnnotationType11 = {
                    TEXT: 1,
                    LINK: 2,
                    FREETEXT: 3,
                    LINE: 4,
                    SQUARE: 5,
                    CIRCLE: 6,
                    POLYGON: 7,
                    POLYLINE: 8,
                    HIGHLIGHT: 9,
                    UNDERLINE: 10,
                    SQUIGGLY: 11,
                    STRIKEOUT: 12,
                    STAMP: 13,
                    CARET: 14,
                    INK: 15,
                    POPUP: 16,
                    FILEATTACHMENT: 17,
                    SOUND: 18,
                    MOVIE: 19,
                    WIDGET: 20,
                    SCREEN: 21,
                    PRINTERMARK: 22,
                    TRAPNET: 23,
                    WATERMARK: 24,
                    THREED: 25,
                    REDACT: 26
                };
                exports11.AnnotationType = AnnotationType11;
                const AnnotationReplyType11 = {
                    GROUP: "Group",
                    REPLY: "R"
                };
                exports11.AnnotationReplyType = AnnotationReplyType11;
                const AnnotationFlag11 = {
                    INVISIBLE: 0x01,
                    HIDDEN: 0x02,
                    PRINT: 0x04,
                    NOZOOM: 0x08,
                    NOROTATE: 0x10,
                    NOVIEW: 0x20,
                    READONLY: 0x40,
                    LOCKED: 0x80,
                    TOGGLENOVIEW: 0x100,
                    LOCKEDCONTENTS: 0x200
                };
                exports11.AnnotationFlag = AnnotationFlag11;
                const AnnotationFieldFlag11 = {
                    READONLY: 0x0000001,
                    REQUIRED: 0x0000002,
                    NOEXPORT: 0x0000004,
                    MULTILINE: 0x0001000,
                    PASSWORD: 0x0002000,
                    NOTOGGLETOOFF: 0x0004000,
                    RADIO: 0x0008000,
                    PUSHBUTTON: 0x0010000,
                    COMBO: 0x0020000,
                    EDIT: 0x0040000,
                    SORT: 0x0080000,
                    FILESELECT: 0x0100000,
                    MULTISELECT: 0x0200000,
                    DONOTSPELLCHECK: 0x0400000,
                    DONOTSCROLL: 0x0800000,
                    COMB: 0x1000000,
                    RICHTEXT: 0x2000000,
                    RADIOSINUNISON: 0x2000000,
                    COMMITONSELCHANGE: 0x4000000
                };
                exports11.AnnotationFieldFlag = AnnotationFieldFlag11;
                const AnnotationBorderStyleType11 = {
                    SOLID: 1,
                    DASHED: 2,
                    BEVELED: 3,
                    INSET: 4,
                    UNDERLINE: 5
                };
                exports11.AnnotationBorderStyleType = AnnotationBorderStyleType11;
                const AnnotationActionEventType11 = {
                    E: "Mouse Enter",
                    X: "Mouse Exit",
                    D: "Mouse Down",
                    U: "Mouse Up",
                    Fo: "Focus",
                    Bl: "Blur",
                    PO: "PageOpen",
                    PC: "PageClose",
                    PV: "PageVisible",
                    PI: "PageInvisible",
                    K: "Keystroke",
                    F: "Format",
                    V: "Validate",
                    C: "Calculate"
                };
                exports11.AnnotationActionEventType = AnnotationActionEventType11;
                const DocumentActionEventType11 = {
                    WC: "WillClose",
                    WS: "WillSave",
                    DS: "DidSave",
                    WP: "WillPrint",
                    DP: "DidPrint"
                };
                exports11.DocumentActionEventType = DocumentActionEventType11;
                const PageActionEventType11 = {
                    O: "PageOpen",
                    C: "PageClose"
                };
                exports11.PageActionEventType = PageActionEventType11;
                const VerbosityLevel11 = {
                    ERRORS: 0,
                    WARNINGS: 1,
                    INFOS: 5
                };
                exports11.VerbosityLevel = VerbosityLevel11;
                const CMapCompressionType11 = {
                    NONE: 0,
                    BINARY: 1
                };
                exports11.CMapCompressionType = CMapCompressionType11;
                const OPS11 = {
                    dependency: 1,
                    setLineWidth: 2,
                    setLineCap: 3,
                    setLineJoin: 4,
                    setMiterLimit: 5,
                    setDash: 6,
                    setRenderingIntent: 7,
                    setFlatness: 8,
                    setGState: 9,
                    save: 10,
                    restore: 11,
                    transform: 12,
                    moveTo: 13,
                    lineTo: 14,
                    curveTo: 15,
                    curveTo2: 16,
                    curveTo3: 17,
                    closePath: 18,
                    rectangle: 19,
                    stroke: 20,
                    closeStroke: 21,
                    fill: 22,
                    eoFill: 23,
                    fillStroke: 24,
                    eoFillStroke: 25,
                    closeFillStroke: 26,
                    closeEOFillStroke: 27,
                    endPath: 28,
                    clip: 29,
                    eoClip: 30,
                    beginText: 31,
                    endText: 32,
                    setCharSpacing: 33,
                    setWordSpacing: 34,
                    setHScale: 35,
                    setLeading: 36,
                    setFont: 37,
                    setTextRenderingMode: 38,
                    setTextRise: 39,
                    moveText: 40,
                    setLeadingMoveText: 41,
                    setTextMatrix: 42,
                    nextLine: 43,
                    showText: 44,
                    showSpacedText: 45,
                    nextLineShowText: 46,
                    nextLineSetSpacingShowText: 47,
                    setCharWidth: 48,
                    setCharWidthAndBounds: 49,
                    setStrokeColorSpace: 50,
                    setFillColorSpace: 51,
                    setStrokeColor: 52,
                    setStrokeColorN: 53,
                    setFillColor: 54,
                    setFillColorN: 55,
                    setStrokeGray: 56,
                    setFillGray: 57,
                    setStrokeRGBColor: 58,
                    setFillRGBColor: 59,
                    setStrokeCMYKColor: 60,
                    setFillCMYKColor: 61,
                    shadingFill: 62,
                    beginInlineImage: 63,
                    beginImageData: 64,
                    endInlineImage: 65,
                    paintXObject: 66,
                    markPoint: 67,
                    markPointProps: 68,
                    beginMarkedContent: 69,
                    beginMarkedContentProps: 70,
                    endMarkedContent: 71,
                    beginCompat: 72,
                    endCompat: 73,
                    paintFormXObjectBegin: 74,
                    paintFormXObjectEnd: 75,
                    beginGroup: 76,
                    endGroup: 77,
                    beginAnnotation: 80,
                    endAnnotation: 81,
                    paintImageMaskXObject: 83,
                    paintImageMaskXObjectGroup: 84,
                    paintImageXObject: 85,
                    paintInlineImageXObject: 86,
                    paintInlineImageXObjectGroup: 87,
                    paintImageXObjectRepeat: 88,
                    paintImageMaskXObjectRepeat: 89,
                    paintSolidColorImageMask: 90,
                    constructPath: 91
                };
                exports11.OPS = OPS11;
                const PasswordResponses11 = {
                    NEED_PASSWORD: 1,
                    INCORRECT_PASSWORD: 2
                };
                exports11.PasswordResponses = PasswordResponses11;
                let verbosity11 = VerbosityLevel11.WARNINGS;
                function setVerbosityLevel11(level11) {
                    if (Number.isInteger(level11)) verbosity11 = level11;
                }
                function getVerbosityLevel11() {
                    return verbosity11;
                }
                function info11(msg11) {
                    if (verbosity11 >= VerbosityLevel11.INFOS) console.log(`Info: ${msg11}`);
                }
                function warn11(msg11) {
                    if (verbosity11 >= VerbosityLevel11.WARNINGS) console.log(`Warning: ${msg11}`);
                }
                function unreachable11(msg11) {
                    throw new Error(msg11);
                }
                function assert11(cond11, msg11) {
                    if (!cond11) unreachable11(msg11);
                }
                function _isValidProtocol11(url11) {
                    switch(url11?.protocol){
                        case "http:":
                        case "https:":
                        case "ftp:":
                        case "mailto:":
                        case "tel:":
                            return true;
                        default:
                            return false;
                    }
                }
                function createValidAbsoluteUrl11(url11, baseUrl11 = null, options11 = null) {
                    if (!url11) return null;
                    try {
                        if (options11 && typeof url11 === "string") {
                            if (options11.addDefaultProtocol && url11.startsWith("www.")) {
                                const dots11 = url11.match(/\./g);
                                if (dots11?.length >= 2) url11 = `http://${url11}`;
                            }
                            if (options11.tryConvertEncoding) try {
                                url11 = stringToUTF8String11(url11);
                            } catch  {}
                        }
                        const absoluteUrl11 = baseUrl11 ? new URL(url11, baseUrl11) : new URL(url11);
                        if (_isValidProtocol11(absoluteUrl11)) return absoluteUrl11;
                    } catch  {}
                    return null;
                }
                function shadow11(obj11, prop11, value11, nonSerializable11 = false) {
                    Object.defineProperty(obj11, prop11, {
                        value: value11,
                        enumerable: !nonSerializable11,
                        configurable: true,
                        writable: false
                    });
                    return value11;
                }
                const BaseException11 = function BaseExceptionClosure11() {
                    function BaseException11(message11, name11) {
                        if (this.constructor === BaseException11) unreachable11("Cannot initialize BaseException.");
                        this.message = message11;
                        this.name = name11;
                    }
                    BaseException11.prototype = new Error();
                    BaseException11.constructor = BaseException11;
                    return BaseException11;
                }();
                exports11.BaseException = BaseException11;
                class PasswordException11 extends BaseException11 {
                    constructor(msg11, code11){
                        super(msg11, "PasswordException");
                        this.code = code11;
                    }
                }
                exports11.PasswordException = PasswordException11;
                class UnknownErrorException11 extends BaseException11 {
                    constructor(msg11, details11){
                        super(msg11, "UnknownErrorException");
                        this.details = details11;
                    }
                }
                exports11.UnknownErrorException = UnknownErrorException11;
                class InvalidPDFException11 extends BaseException11 {
                    constructor(msg11){
                        super(msg11, "InvalidPDFException");
                    }
                }
                exports11.InvalidPDFException = InvalidPDFException11;
                class MissingPDFException11 extends BaseException11 {
                    constructor(msg11){
                        super(msg11, "MissingPDFException");
                    }
                }
                exports11.MissingPDFException = MissingPDFException11;
                class UnexpectedResponseException11 extends BaseException11 {
                    constructor(msg11, status11){
                        super(msg11, "UnexpectedResponseException");
                        this.status = status11;
                    }
                }
                exports11.UnexpectedResponseException = UnexpectedResponseException11;
                class FormatError11 extends BaseException11 {
                    constructor(msg11){
                        super(msg11, "FormatError");
                    }
                }
                exports11.FormatError = FormatError11;
                class AbortException11 extends BaseException11 {
                    constructor(msg11){
                        super(msg11, "AbortException");
                    }
                }
                exports11.AbortException = AbortException11;
                function bytesToString11(bytes11) {
                    if (typeof bytes11 !== "object" || bytes11?.length === undefined) unreachable11("Invalid argument for bytesToString");
                    const length11 = bytes11.length;
                    const MAX_ARGUMENT_COUNT11 = 8192;
                    if (length11 < MAX_ARGUMENT_COUNT11) return String.fromCharCode.apply(null, bytes11);
                    const strBuf11 = [];
                    for(let i11 = 0; i11 < length11; i11 += MAX_ARGUMENT_COUNT11){
                        const chunkEnd11 = Math.min(i11 + MAX_ARGUMENT_COUNT11, length11);
                        const chunk31 = bytes11.subarray(i11, chunkEnd11);
                        strBuf11.push(String.fromCharCode.apply(null, chunk31));
                    }
                    return strBuf11.join("");
                }
                function stringToBytes11(str11) {
                    if (typeof str11 !== "string") unreachable11("Invalid argument for stringToBytes");
                    const length11 = str11.length;
                    const bytes11 = new Uint8Array(length11);
                    for(let i11 = 0; i11 < length11; ++i11)bytes11[i11] = str11.charCodeAt(i11) & 0xff;
                    return bytes11;
                }
                function string3211(value11) {
                    return String.fromCharCode(value11 >> 24 & 0xff, value11 >> 16 & 0xff, value11 >> 8 & 0xff, value11 & 0xff);
                }
                function objectSize11(obj11) {
                    return Object.keys(obj11).length;
                }
                function objectFromMap11(map11) {
                    const obj11 = Object.create(null);
                    for (const [key11, value11] of map11)obj11[key11] = value11;
                    return obj11;
                }
                function isLittleEndian11() {
                    const buffer811 = new Uint8Array(4);
                    buffer811[0] = 1;
                    const view3211 = new Uint32Array(buffer811.buffer, 0, 1);
                    return view3211[0] === 1;
                }
                function isEvalSupported11() {
                    try {
                        new Function("");
                        return true;
                    } catch  {
                        return false;
                    }
                }
                class FeatureTest11 {
                    static get isLittleEndian() {
                        return shadow11(this, "isLittleEndian", isLittleEndian11());
                    }
                    static get isEvalSupported() {
                        return shadow11(this, "isEvalSupported", isEvalSupported11());
                    }
                    static get isOffscreenCanvasSupported() {
                        return shadow11(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
                    }
                    static get platform() {
                        if (typeof navigator === "undefined") return shadow11(this, "platform", {
                            isWin: false,
                            isMac: false
                        });
                        return shadow11(this, "platform", {
                            isWin: navigator.platform.includes("Win"),
                            isMac: navigator.platform.includes("Mac")
                        });
                    }
                    static get isCSSRoundSupported() {
                        return shadow11(this, "isCSSRoundSupported", globalThis.CSS?.supports?.("width: round(1.5px, 1px)"));
                    }
                }
                exports11.FeatureTest = FeatureTest11;
                const hexNumbers11 = [
                    ...Array(256).keys()
                ].map((n11)=>n11.toString(16).padStart(2, "0"));
                class Util11 {
                    static makeHexColor(r11, g11, b41) {
                        return `#${hexNumbers11[r11]}${hexNumbers11[g11]}${hexNumbers11[b41]}`;
                    }
                    static scaleMinMax(transform11, minMax11) {
                        let temp11;
                        if (transform11[0]) {
                            if (transform11[0] < 0) {
                                temp11 = minMax11[0];
                                minMax11[0] = minMax11[1];
                                minMax11[1] = temp11;
                            }
                            minMax11[0] *= transform11[0];
                            minMax11[1] *= transform11[0];
                            if (transform11[3] < 0) {
                                temp11 = minMax11[2];
                                minMax11[2] = minMax11[3];
                                minMax11[3] = temp11;
                            }
                            minMax11[2] *= transform11[3];
                            minMax11[3] *= transform11[3];
                        } else {
                            temp11 = minMax11[0];
                            minMax11[0] = minMax11[2];
                            minMax11[2] = temp11;
                            temp11 = minMax11[1];
                            minMax11[1] = minMax11[3];
                            minMax11[3] = temp11;
                            if (transform11[1] < 0) {
                                temp11 = minMax11[2];
                                minMax11[2] = minMax11[3];
                                minMax11[3] = temp11;
                            }
                            minMax11[2] *= transform11[1];
                            minMax11[3] *= transform11[1];
                            if (transform11[2] < 0) {
                                temp11 = minMax11[0];
                                minMax11[0] = minMax11[1];
                                minMax11[1] = temp11;
                            }
                            minMax11[0] *= transform11[2];
                            minMax11[1] *= transform11[2];
                        }
                        minMax11[0] += transform11[4];
                        minMax11[1] += transform11[4];
                        minMax11[2] += transform11[5];
                        minMax11[3] += transform11[5];
                    }
                    static transform(m111, m211) {
                        return [
                            m111[0] * m211[0] + m111[2] * m211[1],
                            m111[1] * m211[0] + m111[3] * m211[1],
                            m111[0] * m211[2] + m111[2] * m211[3],
                            m111[1] * m211[2] + m111[3] * m211[3],
                            m111[0] * m211[4] + m111[2] * m211[5] + m111[4],
                            m111[1] * m211[4] + m111[3] * m211[5] + m111[5]
                        ];
                    }
                    static applyTransform(p51, m31) {
                        const xt11 = p51[0] * m31[0] + p51[1] * m31[2] + m31[4];
                        const yt11 = p51[0] * m31[1] + p51[1] * m31[3] + m31[5];
                        return [
                            xt11,
                            yt11
                        ];
                    }
                    static applyInverseTransform(p51, m31) {
                        const d51 = m31[0] * m31[3] - m31[1] * m31[2];
                        const xt11 = (p51[0] * m31[3] - p51[1] * m31[2] + m31[2] * m31[5] - m31[4] * m31[3]) / d51;
                        const yt11 = (-p51[0] * m31[1] + p51[1] * m31[0] + m31[4] * m31[1] - m31[5] * m31[0]) / d51;
                        return [
                            xt11,
                            yt11
                        ];
                    }
                    static getAxialAlignedBoundingBox(r11, m31) {
                        const p121 = this.applyTransform(r11, m31);
                        const p221 = this.applyTransform(r11.slice(2, 4), m31);
                        const p321 = this.applyTransform([
                            r11[0],
                            r11[3]
                        ], m31);
                        const p421 = this.applyTransform([
                            r11[2],
                            r11[1]
                        ], m31);
                        return [
                            Math.min(p121[0], p221[0], p321[0], p421[0]),
                            Math.min(p121[1], p221[1], p321[1], p421[1]),
                            Math.max(p121[0], p221[0], p321[0], p421[0]),
                            Math.max(p121[1], p221[1], p321[1], p421[1])
                        ];
                    }
                    static inverseTransform(m31) {
                        const d51 = m31[0] * m31[3] - m31[1] * m31[2];
                        return [
                            m31[3] / d51,
                            -m31[1] / d51,
                            -m31[2] / d51,
                            m31[0] / d51,
                            (m31[2] * m31[5] - m31[4] * m31[3]) / d51,
                            (m31[4] * m31[1] - m31[5] * m31[0]) / d51
                        ];
                    }
                    static singularValueDecompose2dScale(m31) {
                        const transpose11 = [
                            m31[0],
                            m31[2],
                            m31[1],
                            m31[3]
                        ];
                        const a11 = m31[0] * transpose11[0] + m31[1] * transpose11[2];
                        const b41 = m31[0] * transpose11[1] + m31[1] * transpose11[3];
                        const c41 = m31[2] * transpose11[0] + m31[3] * transpose11[2];
                        const d51 = m31[2] * transpose11[1] + m31[3] * transpose11[3];
                        const first11 = (a11 + d51) / 2;
                        const second11 = Math.sqrt((a11 + d51) ** 2 - 4 * (a11 * d51 - c41 * b41)) / 2;
                        const sx11 = first11 + second11 || 1;
                        const sy11 = first11 - second11 || 1;
                        return [
                            Math.sqrt(sx11),
                            Math.sqrt(sy11)
                        ];
                    }
                    static normalizeRect(rect31) {
                        const r11 = rect31.slice(0);
                        if (rect31[0] > rect31[2]) {
                            r11[0] = rect31[2];
                            r11[2] = rect31[0];
                        }
                        if (rect31[1] > rect31[3]) {
                            r11[1] = rect31[3];
                            r11[3] = rect31[1];
                        }
                        return r11;
                    }
                    static intersect(rect111, rect211) {
                        const xLow11 = Math.max(Math.min(rect111[0], rect111[2]), Math.min(rect211[0], rect211[2]));
                        const xHigh11 = Math.min(Math.max(rect111[0], rect111[2]), Math.max(rect211[0], rect211[2]));
                        if (xLow11 > xHigh11) return null;
                        const yLow11 = Math.max(Math.min(rect111[1], rect111[3]), Math.min(rect211[1], rect211[3]));
                        const yHigh11 = Math.min(Math.max(rect111[1], rect111[3]), Math.max(rect211[1], rect211[3]));
                        if (yLow11 > yHigh11) return null;
                        return [
                            xLow11,
                            yLow11,
                            xHigh11,
                            yHigh11
                        ];
                    }
                    static bezierBoundingBox(x011, y011, x111, y111, x211, y211, x311, y311) {
                        const tvalues11 = [], bounds11 = [
                            [],
                            []
                        ];
                        let a11, b41, c41, t31, t111, t211, b2ac11, sqrtb2ac11;
                        for(let i11 = 0; i11 < 2; ++i11){
                            if (i11 === 0) {
                                b41 = 6 * x011 - 12 * x111 + 6 * x211;
                                a11 = -3 * x011 + 9 * x111 - 9 * x211 + 3 * x311;
                                c41 = 3 * x111 - 3 * x011;
                            } else {
                                b41 = 6 * y011 - 12 * y111 + 6 * y211;
                                a11 = -3 * y011 + 9 * y111 - 9 * y211 + 3 * y311;
                                c41 = 3 * y111 - 3 * y011;
                            }
                            if (Math.abs(a11) < 1e-12) {
                                if (Math.abs(b41) < 1e-12) continue;
                                t31 = -c41 / b41;
                                if (0 < t31 && t31 < 1) tvalues11.push(t31);
                                continue;
                            }
                            b2ac11 = b41 * b41 - 4 * c41 * a11;
                            sqrtb2ac11 = Math.sqrt(b2ac11);
                            if (b2ac11 < 0) continue;
                            t111 = (-b41 + sqrtb2ac11) / (2 * a11);
                            if (0 < t111 && t111 < 1) tvalues11.push(t111);
                            t211 = (-b41 - sqrtb2ac11) / (2 * a11);
                            if (0 < t211 && t211 < 1) tvalues11.push(t211);
                        }
                        let j11 = tvalues11.length, mt11;
                        const jlen11 = j11;
                        while(j11--){
                            t31 = tvalues11[j11];
                            mt11 = 1 - t31;
                            bounds11[0][j11] = mt11 * mt11 * mt11 * x011 + 3 * mt11 * mt11 * t31 * x111 + 3 * mt11 * t31 * t31 * x211 + t31 * t31 * t31 * x311;
                            bounds11[1][j11] = mt11 * mt11 * mt11 * y011 + 3 * mt11 * mt11 * t31 * y111 + 3 * mt11 * t31 * t31 * y211 + t31 * t31 * t31 * y311;
                        }
                        bounds11[0][jlen11] = x011;
                        bounds11[1][jlen11] = y011;
                        bounds11[0][jlen11 + 1] = x311;
                        bounds11[1][jlen11 + 1] = y311;
                        bounds11[0].length = bounds11[1].length = jlen11 + 2;
                        return [
                            Math.min(...bounds11[0]),
                            Math.min(...bounds11[1]),
                            Math.max(...bounds11[0]),
                            Math.max(...bounds11[1])
                        ];
                    }
                }
                exports11.Util = Util11;
                const PDFStringTranslateTable11 = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2d8,
                    0x2c7,
                    0x2c6,
                    0x2d9,
                    0x2dd,
                    0x2db,
                    0x2da,
                    0x2dc,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2022,
                    0x2020,
                    0x2021,
                    0x2026,
                    0x2014,
                    0x2013,
                    0x192,
                    0x2044,
                    0x2039,
                    0x203a,
                    0x2212,
                    0x2030,
                    0x201e,
                    0x201c,
                    0x201d,
                    0x2018,
                    0x2019,
                    0x201a,
                    0x2122,
                    0xfb01,
                    0xfb02,
                    0x141,
                    0x152,
                    0x160,
                    0x178,
                    0x17d,
                    0x131,
                    0x142,
                    0x153,
                    0x161,
                    0x17e,
                    0,
                    0x20ac
                ];
                function stringToPDFString11(str11) {
                    if (str11[0] >= "\xef") {
                        let encoding11;
                        if (str11[0] === "\xfe" && str11[1] === "\xff") encoding11 = "utf-16be";
                        else if (str11[0] === "\xff" && str11[1] === "\xfe") encoding11 = "utf-16le";
                        else if (str11[0] === "\xef" && str11[1] === "\xbb" && str11[2] === "\xbf") encoding11 = "utf-8";
                        if (encoding11) try {
                            const decoder11 = new TextDecoder(encoding11, {
                                fatal: true
                            });
                            const buffer11 = stringToBytes11(str11);
                            return decoder11.decode(buffer11);
                        } catch (ex11) {
                            warn11(`stringToPDFString: "${ex11}".`);
                        }
                    }
                    const strBuf11 = [];
                    for(let i11 = 0, ii11 = str11.length; i11 < ii11; i11++){
                        const code11 = PDFStringTranslateTable11[str11.charCodeAt(i11)];
                        strBuf11.push(code11 ? String.fromCharCode(code11) : str11.charAt(i11));
                    }
                    return strBuf11.join("");
                }
                function stringToUTF8String11(str11) {
                    return decodeURIComponent(escape(str11));
                }
                function utf8StringToString11(str11) {
                    return unescape(encodeURIComponent(str11));
                }
                function isArrayBuffer11(v11) {
                    return typeof v11 === "object" && v11?.byteLength !== undefined;
                }
                function isArrayEqual11(arr111, arr211) {
                    if (arr111.length !== arr211.length) return false;
                    for(let i11 = 0, ii11 = arr111.length; i11 < ii11; i11++){
                        if (arr111[i11] !== arr211[i11]) return false;
                    }
                    return true;
                }
                function getModificationDate11(date11 = new Date()) {
                    const buffer11 = [
                        date11.getUTCFullYear().toString(),
                        (date11.getUTCMonth() + 1).toString().padStart(2, "0"),
                        date11.getUTCDate().toString().padStart(2, "0"),
                        date11.getUTCHours().toString().padStart(2, "0"),
                        date11.getUTCMinutes().toString().padStart(2, "0"),
                        date11.getUTCSeconds().toString().padStart(2, "0")
                    ];
                    return buffer11.join("");
                }
                class PromiseCapability11 {
                    #settled = false;
                    constructor(){
                        this.promise = new Promise((resolve11, reject11)=>{
                            this.resolve = (data11)=>{
                                this.#settled = true;
                                resolve11(data11);
                            };
                            this.reject = (reason11)=>{
                                this.#settled = true;
                                reject11(reason11);
                            };
                        });
                    }
                    get settled() {
                        return this.#settled;
                    }
                }
                exports11.PromiseCapability = PromiseCapability11;
                let NormalizeRegex11 = null;
                let NormalizationMap11 = null;
                function normalizeUnicode11(str11) {
                    if (!NormalizeRegex11) {
                        NormalizeRegex11 = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
                        NormalizationMap11 = new Map([
                            [
                                "\uFB05",
                                "\u017Ft"
                            ]
                        ]);
                    }
                    return str11.replaceAll(NormalizeRegex11, (_11, p121, p221)=>{
                        return p121 ? p121.normalize("NFKC") : NormalizationMap11.get(p221);
                    });
                }
                function getUuid11() {
                    if (typeof crypto !== "undefined" && typeof crypto?.randomUUID === "function") return crypto.randomUUID();
                    const buf11 = new Uint8Array(32);
                    if (typeof crypto !== "undefined" && typeof crypto?.getRandomValues === "function") crypto.getRandomValues(buf11);
                    else for(let i11 = 0; i11 < 32; i11++)buf11[i11] = Math.floor(Math.random() * 255);
                    return bytesToString11(buf11);
                }
                const AnnotationPrefix11 = "pdfjs_internal_id_";
                exports11.AnnotationPrefix = AnnotationPrefix11;
            /***/ },
            /* 2 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RenderTask = exports.PDFWorkerUtil = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultFilterFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0;
                Object.defineProperty(exports, "SVGGraphics", {
                    enumerable: true,
                    get: function() {
                        return _displaySvg.SVGGraphics;
                    }
                });
                exports.build = void 0;
                exports.getDocument = getDocument;
                exports.version = void 0;
                var _util = __w_pdfjs_require__(1);
                var _annotation_storage = __w_pdfjs_require__(3);
                var _display_utils = __w_pdfjs_require__(6);
                var _font_loader = __w_pdfjs_require__(9);
                var _displayNode_utils = __w_pdfjs_require__(10);
                var _canvas = __w_pdfjs_require__(11);
                var _worker_options = __w_pdfjs_require__(14);
                var _message_handler = __w_pdfjs_require__(15);
                var _metadata = __w_pdfjs_require__(16);
                var _optional_content_config = __w_pdfjs_require__(17);
                var _transport_stream = __w_pdfjs_require__(18);
                var _displayFetch_stream = __w_pdfjs_require__(19);
                var _displayNetwork = __w_pdfjs_require__(22);
                var _displayNode_stream = __w_pdfjs_require__(23);
                var _displaySvg = __w_pdfjs_require__(24);
                var _xfa_text = __w_pdfjs_require__(25);
                const DEFAULT_RANGE_CHUNK_SIZE = 65536;
                const RENDERING_CANCELLED_TIMEOUT = 100;
                const DELAYED_CLEANUP_TIMEOUT = 5000;
                const DefaultCanvasFactory = _util.isNodeJS ? _displayNode_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
                exports.DefaultCanvasFactory = DefaultCanvasFactory;
                const DefaultCMapReaderFactory = _util.isNodeJS ? _displayNode_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
                exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
                const DefaultFilterFactory = _util.isNodeJS ? _displayNode_utils.NodeFilterFactory : _display_utils.DOMFilterFactory;
                exports.DefaultFilterFactory = DefaultFilterFactory;
                const DefaultStandardFontDataFactory = _util.isNodeJS ? _displayNode_utils.NodeStandardFontDataFactory : _display_utils.DOMStandardFontDataFactory;
                exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
                function getDocument(src11) {
                    if (typeof src11 === "string" || src11 instanceof URL) src11 = {
                        url: src11
                    };
                    else if ((0, _util.isArrayBuffer)(src11)) src11 = {
                        data: src11
                    };
                    if (typeof src11 !== "object") throw new Error("Invalid parameter in getDocument, need parameter object.");
                    if (!src11.url && !src11.data && !src11.range) throw new Error("Invalid parameter object: need either .data, .range or .url");
                    const task11 = new PDFDocumentLoadingTask();
                    const { docId: docId11 } = task11;
                    const url11 = src11.url ? getUrlProp(src11.url) : null;
                    const data11 = src11.data ? getDataProp(src11.data) : null;
                    const httpHeaders11 = src11.httpHeaders || null;
                    const withCredentials11 = src11.withCredentials === true;
                    const password11 = src11.password ?? null;
                    const rangeTransport11 = src11.range instanceof PDFDataRangeTransport ? src11.range : null;
                    const rangeChunkSize11 = Number.isInteger(src11.rangeChunkSize) && src11.rangeChunkSize > 0 ? src11.rangeChunkSize : DEFAULT_RANGE_CHUNK_SIZE;
                    let worker11 = src11.worker instanceof PDFWorker ? src11.worker : null;
                    const verbosity11 = src11.verbosity;
                    const docBaseUrl11 = typeof src11.docBaseUrl === "string" && !(0, _display_utils.isDataScheme)(src11.docBaseUrl) ? src11.docBaseUrl : null;
                    const cMapUrl11 = typeof src11.cMapUrl === "string" ? src11.cMapUrl : null;
                    const cMapPacked11 = src11.cMapPacked !== false;
                    const CMapReaderFactory11 = src11.CMapReaderFactory || DefaultCMapReaderFactory;
                    const standardFontDataUrl11 = typeof src11.standardFontDataUrl === "string" ? src11.standardFontDataUrl : null;
                    const StandardFontDataFactory11 = src11.StandardFontDataFactory || DefaultStandardFontDataFactory;
                    const ignoreErrors11 = src11.stopAtErrors !== true;
                    const maxImageSize11 = Number.isInteger(src11.maxImageSize) && src11.maxImageSize > -1 ? src11.maxImageSize : -1;
                    const isEvalSupported11 = src11.isEvalSupported !== false;
                    const isOffscreenCanvasSupported11 = typeof src11.isOffscreenCanvasSupported === "boolean" ? src11.isOffscreenCanvasSupported : !_util.isNodeJS;
                    const canvasMaxAreaInBytes11 = Number.isInteger(src11.canvasMaxAreaInBytes) ? src11.canvasMaxAreaInBytes : -1;
                    const disableFontFace11 = typeof src11.disableFontFace === "boolean" ? src11.disableFontFace : _util.isNodeJS;
                    const fontExtraProperties11 = src11.fontExtraProperties === true;
                    const enableXfa11 = src11.enableXfa === true;
                    const ownerDocument11 = src11.ownerDocument || globalThis.document;
                    const disableRange11 = src11.disableRange === true;
                    const disableStream11 = src11.disableStream === true;
                    const disableAutoFetch11 = src11.disableAutoFetch === true;
                    const pdfBug11 = src11.pdfBug === true;
                    const length11 = rangeTransport11 ? rangeTransport11.length : src11.length ?? NaN;
                    const useSystemFonts11 = typeof src11.useSystemFonts === "boolean" ? src11.useSystemFonts : !_util.isNodeJS && !disableFontFace11;
                    const useWorkerFetch11 = typeof src11.useWorkerFetch === "boolean" ? src11.useWorkerFetch : CMapReaderFactory11 === _display_utils.DOMCMapReaderFactory && StandardFontDataFactory11 === _display_utils.DOMStandardFontDataFactory && cMapUrl11 && standardFontDataUrl11 && (0, _display_utils.isValidFetchUrl)(cMapUrl11, document.baseURI) && (0, _display_utils.isValidFetchUrl)(standardFontDataUrl11, document.baseURI);
                    const canvasFactory11 = src11.canvasFactory || new DefaultCanvasFactory({
                        ownerDocument: ownerDocument11
                    });
                    const filterFactory11 = src11.filterFactory || new DefaultFilterFactory({
                        docId: docId11,
                        ownerDocument: ownerDocument11
                    });
                    const styleElement11 = null;
                    (0, _util.setVerbosityLevel)(verbosity11);
                    const transportFactory11 = {
                        canvasFactory: canvasFactory11,
                        filterFactory: filterFactory11
                    };
                    if (!useWorkerFetch11) {
                        transportFactory11.cMapReaderFactory = new CMapReaderFactory11({
                            baseUrl: cMapUrl11,
                            isCompressed: cMapPacked11
                        });
                        transportFactory11.standardFontDataFactory = new StandardFontDataFactory11({
                            baseUrl: standardFontDataUrl11
                        });
                    }
                    if (!worker11) {
                        const workerParams11 = {
                            verbosity: verbosity11,
                            port: _worker_options.GlobalWorkerOptions.workerPort
                        };
                        worker11 = workerParams11.port ? PDFWorker.fromPort(workerParams11) : new PDFWorker(workerParams11);
                        task11._worker = worker11;
                    }
                    const fetchDocParams11 = {
                        docId: docId11,
                        apiVersion: "3.11.174",
                        data: data11,
                        password: password11,
                        disableAutoFetch: disableAutoFetch11,
                        rangeChunkSize: rangeChunkSize11,
                        length: length11,
                        docBaseUrl: docBaseUrl11,
                        enableXfa: enableXfa11,
                        evaluatorOptions: {
                            maxImageSize: maxImageSize11,
                            disableFontFace: disableFontFace11,
                            ignoreErrors: ignoreErrors11,
                            isEvalSupported: isEvalSupported11,
                            isOffscreenCanvasSupported: isOffscreenCanvasSupported11,
                            canvasMaxAreaInBytes: canvasMaxAreaInBytes11,
                            fontExtraProperties: fontExtraProperties11,
                            useSystemFonts: useSystemFonts11,
                            cMapUrl: useWorkerFetch11 ? cMapUrl11 : null,
                            standardFontDataUrl: useWorkerFetch11 ? standardFontDataUrl11 : null
                        }
                    };
                    const transportParams11 = {
                        ignoreErrors: ignoreErrors11,
                        isEvalSupported: isEvalSupported11,
                        disableFontFace: disableFontFace11,
                        fontExtraProperties: fontExtraProperties11,
                        enableXfa: enableXfa11,
                        ownerDocument: ownerDocument11,
                        disableAutoFetch: disableAutoFetch11,
                        pdfBug: pdfBug11,
                        styleElement: styleElement11
                    };
                    worker11.promise.then(function() {
                        if (task11.destroyed) throw new Error("Loading aborted");
                        const workerIdPromise11 = _fetchDocument(worker11, fetchDocParams11);
                        const networkStreamPromise11 = new Promise(function(resolve11) {
                            let networkStream11;
                            if (rangeTransport11) networkStream11 = new _transport_stream.PDFDataTransportStream({
                                length: length11,
                                initialData: rangeTransport11.initialData,
                                progressiveDone: rangeTransport11.progressiveDone,
                                contentDispositionFilename: rangeTransport11.contentDispositionFilename,
                                disableRange: disableRange11,
                                disableStream: disableStream11
                            }, rangeTransport11);
                            else if (!data11) {
                                const createPDFNetworkStream11 = (params11)=>{
                                    if (_util.isNodeJS) return new _displayNode_stream.PDFNodeStream(params11);
                                    return (0, _display_utils.isValidFetchUrl)(params11.url) ? new _displayFetch_stream.PDFFetchStream(params11) : new _displayNetwork.PDFNetworkStream(params11);
                                };
                                networkStream11 = createPDFNetworkStream11({
                                    url: url11,
                                    length: length11,
                                    httpHeaders: httpHeaders11,
                                    withCredentials: withCredentials11,
                                    rangeChunkSize: rangeChunkSize11,
                                    disableRange: disableRange11,
                                    disableStream: disableStream11
                                });
                            }
                            resolve11(networkStream11);
                        });
                        return Promise.all([
                            workerIdPromise11,
                            networkStreamPromise11
                        ]).then(function([workerId11, networkStream11]) {
                            if (task11.destroyed) throw new Error("Loading aborted");
                            const messageHandler11 = new _message_handler.MessageHandler(docId11, workerId11, worker11.port);
                            const transport11 = new WorkerTransport(messageHandler11, task11, networkStream11, transportParams11, transportFactory11);
                            task11._transport = transport11;
                            messageHandler11.send("Ready", null);
                        });
                    }).catch(task11._capability.reject);
                    return task11;
                }
                async function _fetchDocument(worker11, source11) {
                    if (worker11.destroyed) throw new Error("Worker was destroyed");
                    const workerId11 = await worker11.messageHandler.sendWithPromise("GetDocRequest", source11, source11.data ? [
                        source11.data.buffer
                    ] : null);
                    if (worker11.destroyed) throw new Error("Worker was destroyed");
                    return workerId11;
                }
                function getUrlProp(val11) {
                    if (val11 instanceof URL) return val11.href;
                    try {
                        return new URL(val11, window.location).href;
                    } catch  {
                        if (_util.isNodeJS && typeof val11 === "string") return val11;
                    }
                    throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
                }
                function getDataProp(val11) {
                    if (_util.isNodeJS && typeof $f0bb7c288364d569$require$Buffer !== "undefined" && val11 instanceof $f0bb7c288364d569$require$Buffer) throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
                    if (val11 instanceof Uint8Array && val11.byteLength === val11.buffer.byteLength) return val11;
                    if (typeof val11 === "string") return (0, _util.stringToBytes)(val11);
                    if (typeof val11 === "object" && !isNaN(val11?.length) || (0, _util.isArrayBuffer)(val11)) return new Uint8Array(val11);
                    throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
                }
                class PDFDocumentLoadingTask {
                    static #docId = 0;
                    constructor(){
                        this._capability = new _util.PromiseCapability();
                        this._transport = null;
                        this._worker = null;
                        this.docId = `d${PDFDocumentLoadingTask.#docId++}`;
                        this.destroyed = false;
                        this.onPassword = null;
                        this.onProgress = null;
                    }
                    get promise() {
                        return this._capability.promise;
                    }
                    async destroy() {
                        this.destroyed = true;
                        try {
                            if (this._worker?.port) this._worker._pendingDestroy = true;
                            await this._transport?.destroy();
                        } catch (ex11) {
                            if (this._worker?.port) delete this._worker._pendingDestroy;
                            throw ex11;
                        }
                        this._transport = null;
                        if (this._worker) {
                            this._worker.destroy();
                            this._worker = null;
                        }
                    }
                }
                exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
                class PDFDataRangeTransport {
                    constructor(length11, initialData11, progressiveDone11 = false, contentDispositionFilename11 = null){
                        this.length = length11;
                        this.initialData = initialData11;
                        this.progressiveDone = progressiveDone11;
                        this.contentDispositionFilename = contentDispositionFilename11;
                        this._rangeListeners = [];
                        this._progressListeners = [];
                        this._progressiveReadListeners = [];
                        this._progressiveDoneListeners = [];
                        this._readyCapability = new _util.PromiseCapability();
                    }
                    addRangeListener(listener11) {
                        this._rangeListeners.push(listener11);
                    }
                    addProgressListener(listener11) {
                        this._progressListeners.push(listener11);
                    }
                    addProgressiveReadListener(listener11) {
                        this._progressiveReadListeners.push(listener11);
                    }
                    addProgressiveDoneListener(listener11) {
                        this._progressiveDoneListeners.push(listener11);
                    }
                    onDataRange(begin11, chunk31) {
                        for (const listener11 of this._rangeListeners)listener11(begin11, chunk31);
                    }
                    onDataProgress(loaded11, total11) {
                        this._readyCapability.promise.then(()=>{
                            for (const listener11 of this._progressListeners)listener11(loaded11, total11);
                        });
                    }
                    onDataProgressiveRead(chunk31) {
                        this._readyCapability.promise.then(()=>{
                            for (const listener11 of this._progressiveReadListeners)listener11(chunk31);
                        });
                    }
                    onDataProgressiveDone() {
                        this._readyCapability.promise.then(()=>{
                            for (const listener11 of this._progressiveDoneListeners)listener11();
                        });
                    }
                    transportReady() {
                        this._readyCapability.resolve();
                    }
                    requestDataRange(begin11, end11) {
                        (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
                    }
                    abort() {}
                }
                exports.PDFDataRangeTransport = PDFDataRangeTransport;
                class PDFDocumentProxy {
                    constructor(pdfInfo11, transport11){
                        this._pdfInfo = pdfInfo11;
                        this._transport = transport11;
                        Object.defineProperty(this, "getJavaScript", {
                            value: ()=>{
                                (0, _display_utils.deprecated)("`PDFDocumentProxy.getJavaScript`, please use `PDFDocumentProxy.getJSActions` instead.");
                                return this.getJSActions().then((js11)=>{
                                    if (!js11) return js11;
                                    const jsArr11 = [];
                                    for(const name11 in js11)jsArr11.push(...js11[name11]);
                                    return jsArr11;
                                });
                            }
                        });
                    }
                    get annotationStorage() {
                        return this._transport.annotationStorage;
                    }
                    get filterFactory() {
                        return this._transport.filterFactory;
                    }
                    get numPages() {
                        return this._pdfInfo.numPages;
                    }
                    get fingerprints() {
                        return this._pdfInfo.fingerprints;
                    }
                    get isPureXfa() {
                        return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
                    }
                    get allXfaHtml() {
                        return this._transport._htmlForXfa;
                    }
                    getPage(pageNumber11) {
                        return this._transport.getPage(pageNumber11);
                    }
                    getPageIndex(ref11) {
                        return this._transport.getPageIndex(ref11);
                    }
                    getDestinations() {
                        return this._transport.getDestinations();
                    }
                    getDestination(id11) {
                        return this._transport.getDestination(id11);
                    }
                    getPageLabels() {
                        return this._transport.getPageLabels();
                    }
                    getPageLayout() {
                        return this._transport.getPageLayout();
                    }
                    getPageMode() {
                        return this._transport.getPageMode();
                    }
                    getViewerPreferences() {
                        return this._transport.getViewerPreferences();
                    }
                    getOpenAction() {
                        return this._transport.getOpenAction();
                    }
                    getAttachments() {
                        return this._transport.getAttachments();
                    }
                    getJSActions() {
                        return this._transport.getDocJSActions();
                    }
                    getOutline() {
                        return this._transport.getOutline();
                    }
                    getOptionalContentConfig() {
                        return this._transport.getOptionalContentConfig();
                    }
                    getPermissions() {
                        return this._transport.getPermissions();
                    }
                    getMetadata() {
                        return this._transport.getMetadata();
                    }
                    getMarkInfo() {
                        return this._transport.getMarkInfo();
                    }
                    getData() {
                        return this._transport.getData();
                    }
                    saveDocument() {
                        return this._transport.saveDocument();
                    }
                    getDownloadInfo() {
                        return this._transport.downloadInfoCapability.promise;
                    }
                    cleanup(keepLoadedFonts11 = false) {
                        return this._transport.startCleanup(keepLoadedFonts11 || this.isPureXfa);
                    }
                    destroy() {
                        return this.loadingTask.destroy();
                    }
                    get loadingParams() {
                        return this._transport.loadingParams;
                    }
                    get loadingTask() {
                        return this._transport.loadingTask;
                    }
                    getFieldObjects() {
                        return this._transport.getFieldObjects();
                    }
                    hasJSActions() {
                        return this._transport.hasJSActions();
                    }
                    getCalculationOrderIds() {
                        return this._transport.getCalculationOrderIds();
                    }
                }
                exports.PDFDocumentProxy = PDFDocumentProxy;
                class PDFPageProxy {
                    #delayedCleanupTimeout = null;
                    #pendingCleanup = false;
                    constructor(pageIndex11, pageInfo11, transport11, pdfBug11 = false){
                        this._pageIndex = pageIndex11;
                        this._pageInfo = pageInfo11;
                        this._transport = transport11;
                        this._stats = pdfBug11 ? new _display_utils.StatTimer() : null;
                        this._pdfBug = pdfBug11;
                        this.commonObjs = transport11.commonObjs;
                        this.objs = new PDFObjects();
                        this._maybeCleanupAfterRender = false;
                        this._intentStates = new Map();
                        this.destroyed = false;
                    }
                    get pageNumber() {
                        return this._pageIndex + 1;
                    }
                    get rotate() {
                        return this._pageInfo.rotate;
                    }
                    get ref() {
                        return this._pageInfo.ref;
                    }
                    get userUnit() {
                        return this._pageInfo.userUnit;
                    }
                    get view() {
                        return this._pageInfo.view;
                    }
                    getViewport({ scale: scale11, rotation: rotation11 = this.rotate, offsetX: offsetX11 = 0, offsetY: offsetY11 = 0, dontFlip: dontFlip11 = false } = {}) {
                        return new _display_utils.PageViewport({
                            viewBox: this.view,
                            scale: scale11,
                            rotation: rotation11,
                            offsetX: offsetX11,
                            offsetY: offsetY11,
                            dontFlip: dontFlip11
                        });
                    }
                    getAnnotations({ intent: intent11 = "display" } = {}) {
                        const intentArgs11 = this._transport.getRenderingIntent(intent11);
                        return this._transport.getAnnotations(this._pageIndex, intentArgs11.renderingIntent);
                    }
                    getJSActions() {
                        return this._transport.getPageJSActions(this._pageIndex);
                    }
                    get filterFactory() {
                        return this._transport.filterFactory;
                    }
                    get isPureXfa() {
                        return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
                    }
                    async getXfa() {
                        return this._transport._htmlForXfa?.children[this._pageIndex] || null;
                    }
                    render({ canvasContext: canvasContext11, viewport: viewport11, intent: intent11 = "display", annotationMode: annotationMode11 = _util.AnnotationMode.ENABLE, transform: transform11 = null, background: background11 = null, optionalContentConfigPromise: optionalContentConfigPromise11 = null, annotationCanvasMap: annotationCanvasMap11 = null, pageColors: pageColors11 = null, printAnnotationStorage: printAnnotationStorage11 = null }) {
                        this._stats?.time("Overall");
                        const intentArgs11 = this._transport.getRenderingIntent(intent11, annotationMode11, printAnnotationStorage11);
                        this.#pendingCleanup = false;
                        this.#abortDelayedCleanup();
                        if (!optionalContentConfigPromise11) optionalContentConfigPromise11 = this._transport.getOptionalContentConfig();
                        let intentState11 = this._intentStates.get(intentArgs11.cacheKey);
                        if (!intentState11) {
                            intentState11 = Object.create(null);
                            this._intentStates.set(intentArgs11.cacheKey, intentState11);
                        }
                        if (intentState11.streamReaderCancelTimeout) {
                            clearTimeout(intentState11.streamReaderCancelTimeout);
                            intentState11.streamReaderCancelTimeout = null;
                        }
                        const intentPrint11 = !!(intentArgs11.renderingIntent & _util.RenderingIntentFlag.PRINT);
                        if (!intentState11.displayReadyCapability) {
                            intentState11.displayReadyCapability = new _util.PromiseCapability();
                            intentState11.operatorList = {
                                fnArray: [],
                                argsArray: [],
                                lastChunk: false,
                                separateAnnots: null
                            };
                            this._stats?.time("Page Request");
                            this._pumpOperatorList(intentArgs11);
                        }
                        const complete11 = (error11)=>{
                            intentState11.renderTasks.delete(internalRenderTask11);
                            if (this._maybeCleanupAfterRender || intentPrint11) this.#pendingCleanup = true;
                            this.#tryCleanup(!intentPrint11);
                            if (error11) {
                                internalRenderTask11.capability.reject(error11);
                                this._abortOperatorList({
                                    intentState: intentState11,
                                    reason: error11 instanceof Error ? error11 : new Error(error11)
                                });
                            } else internalRenderTask11.capability.resolve();
                            this._stats?.timeEnd("Rendering");
                            this._stats?.timeEnd("Overall");
                        };
                        const internalRenderTask11 = new InternalRenderTask({
                            callback: complete11,
                            params: {
                                canvasContext: canvasContext11,
                                viewport: viewport11,
                                transform: transform11,
                                background: background11
                            },
                            objs: this.objs,
                            commonObjs: this.commonObjs,
                            annotationCanvasMap: annotationCanvasMap11,
                            operatorList: intentState11.operatorList,
                            pageIndex: this._pageIndex,
                            canvasFactory: this._transport.canvasFactory,
                            filterFactory: this._transport.filterFactory,
                            useRequestAnimationFrame: !intentPrint11,
                            pdfBug: this._pdfBug,
                            pageColors: pageColors11
                        });
                        (intentState11.renderTasks ||= new Set()).add(internalRenderTask11);
                        const renderTask11 = internalRenderTask11.task;
                        Promise.all([
                            intentState11.displayReadyCapability.promise,
                            optionalContentConfigPromise11
                        ]).then(([transparency11, optionalContentConfig11])=>{
                            if (this.destroyed) {
                                complete11();
                                return;
                            }
                            this._stats?.time("Rendering");
                            internalRenderTask11.initializeGraphics({
                                transparency: transparency11,
                                optionalContentConfig: optionalContentConfig11
                            });
                            internalRenderTask11.operatorListChanged();
                        }).catch(complete11);
                        return renderTask11;
                    }
                    getOperatorList({ intent: intent11 = "display", annotationMode: annotationMode11 = _util.AnnotationMode.ENABLE, printAnnotationStorage: printAnnotationStorage11 = null } = {}) {
                        function operatorListChanged11() {
                            if (intentState11.operatorList.lastChunk) {
                                intentState11.opListReadCapability.resolve(intentState11.operatorList);
                                intentState11.renderTasks.delete(opListTask11);
                            }
                        }
                        const intentArgs11 = this._transport.getRenderingIntent(intent11, annotationMode11, printAnnotationStorage11, true);
                        let intentState11 = this._intentStates.get(intentArgs11.cacheKey);
                        if (!intentState11) {
                            intentState11 = Object.create(null);
                            this._intentStates.set(intentArgs11.cacheKey, intentState11);
                        }
                        let opListTask11;
                        if (!intentState11.opListReadCapability) {
                            opListTask11 = Object.create(null);
                            opListTask11.operatorListChanged = operatorListChanged11;
                            intentState11.opListReadCapability = new _util.PromiseCapability();
                            (intentState11.renderTasks ||= new Set()).add(opListTask11);
                            intentState11.operatorList = {
                                fnArray: [],
                                argsArray: [],
                                lastChunk: false,
                                separateAnnots: null
                            };
                            this._stats?.time("Page Request");
                            this._pumpOperatorList(intentArgs11);
                        }
                        return intentState11.opListReadCapability.promise;
                    }
                    streamTextContent({ includeMarkedContent: includeMarkedContent11 = false, disableNormalization: disableNormalization11 = false } = {}) {
                        const TEXT_CONTENT_CHUNK_SIZE11 = 100;
                        return this._transport.messageHandler.sendWithStream("GetTextContent", {
                            pageIndex: this._pageIndex,
                            includeMarkedContent: includeMarkedContent11 === true,
                            disableNormalization: disableNormalization11 === true
                        }, {
                            highWaterMark: TEXT_CONTENT_CHUNK_SIZE11,
                            size (textContent11) {
                                return textContent11.items.length;
                            }
                        });
                    }
                    getTextContent(params11 = {}) {
                        if (this._transport._htmlForXfa) return this.getXfa().then((xfa11)=>{
                            return _xfa_text.XfaText.textContent(xfa11);
                        });
                        const readableStream11 = this.streamTextContent(params11);
                        return new Promise(function(resolve11, reject11) {
                            function pump11() {
                                reader11.read().then(function({ value: value11, done: done11 }) {
                                    if (done11) {
                                        resolve11(textContent11);
                                        return;
                                    }
                                    Object.assign(textContent11.styles, value11.styles);
                                    textContent11.items.push(...value11.items);
                                    pump11();
                                }, reject11);
                            }
                            const reader11 = readableStream11.getReader();
                            const textContent11 = {
                                items: [],
                                styles: Object.create(null)
                            };
                            pump11();
                        });
                    }
                    getStructTree() {
                        return this._transport.getStructTree(this._pageIndex);
                    }
                    _destroy() {
                        this.destroyed = true;
                        const waitOn11 = [];
                        for (const intentState11 of this._intentStates.values()){
                            this._abortOperatorList({
                                intentState: intentState11,
                                reason: new Error("Page was destroyed."),
                                force: true
                            });
                            if (intentState11.opListReadCapability) continue;
                            for (const internalRenderTask11 of intentState11.renderTasks){
                                waitOn11.push(internalRenderTask11.completed);
                                internalRenderTask11.cancel();
                            }
                        }
                        this.objs.clear();
                        this.#pendingCleanup = false;
                        this.#abortDelayedCleanup();
                        return Promise.all(waitOn11);
                    }
                    cleanup(resetStats11 = false) {
                        this.#pendingCleanup = true;
                        const success11 = this.#tryCleanup(false);
                        if (resetStats11 && success11) this._stats &&= new _display_utils.StatTimer();
                        return success11;
                    }
                    #tryCleanup(delayed11 = false) {
                        this.#abortDelayedCleanup();
                        if (!this.#pendingCleanup || this.destroyed) return false;
                        if (delayed11) {
                            this.#delayedCleanupTimeout = setTimeout(()=>{
                                this.#delayedCleanupTimeout = null;
                                this.#tryCleanup(false);
                            }, DELAYED_CLEANUP_TIMEOUT);
                            return false;
                        }
                        for (const { renderTasks: renderTasks11, operatorList: operatorList11 } of this._intentStates.values()){
                            if (renderTasks11.size > 0 || !operatorList11.lastChunk) return false;
                        }
                        this._intentStates.clear();
                        this.objs.clear();
                        this.#pendingCleanup = false;
                        return true;
                    }
                    #abortDelayedCleanup() {
                        if (this.#delayedCleanupTimeout) {
                            clearTimeout(this.#delayedCleanupTimeout);
                            this.#delayedCleanupTimeout = null;
                        }
                    }
                    _startRenderPage(transparency11, cacheKey11) {
                        const intentState11 = this._intentStates.get(cacheKey11);
                        if (!intentState11) return;
                        this._stats?.timeEnd("Page Request");
                        intentState11.displayReadyCapability?.resolve(transparency11);
                    }
                    _renderPageChunk(operatorListChunk11, intentState11) {
                        for(let i11 = 0, ii11 = operatorListChunk11.length; i11 < ii11; i11++){
                            intentState11.operatorList.fnArray.push(operatorListChunk11.fnArray[i11]);
                            intentState11.operatorList.argsArray.push(operatorListChunk11.argsArray[i11]);
                        }
                        intentState11.operatorList.lastChunk = operatorListChunk11.lastChunk;
                        intentState11.operatorList.separateAnnots = operatorListChunk11.separateAnnots;
                        for (const internalRenderTask11 of intentState11.renderTasks)internalRenderTask11.operatorListChanged();
                        if (operatorListChunk11.lastChunk) this.#tryCleanup(true);
                    }
                    _pumpOperatorList({ renderingIntent: renderingIntent11, cacheKey: cacheKey11, annotationStorageSerializable: annotationStorageSerializable11 }) {
                        const { map: map11, transfers: transfers11 } = annotationStorageSerializable11;
                        const readableStream11 = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                            pageIndex: this._pageIndex,
                            intent: renderingIntent11,
                            cacheKey: cacheKey11,
                            annotationStorage: map11
                        }, transfers11);
                        const reader11 = readableStream11.getReader();
                        const intentState11 = this._intentStates.get(cacheKey11);
                        intentState11.streamReader = reader11;
                        const pump11 = ()=>{
                            reader11.read().then(({ value: value11, done: done11 })=>{
                                if (done11) {
                                    intentState11.streamReader = null;
                                    return;
                                }
                                if (this._transport.destroyed) return;
                                this._renderPageChunk(value11, intentState11);
                                pump11();
                            }, (reason11)=>{
                                intentState11.streamReader = null;
                                if (this._transport.destroyed) return;
                                if (intentState11.operatorList) {
                                    intentState11.operatorList.lastChunk = true;
                                    for (const internalRenderTask11 of intentState11.renderTasks)internalRenderTask11.operatorListChanged();
                                    this.#tryCleanup(true);
                                }
                                if (intentState11.displayReadyCapability) intentState11.displayReadyCapability.reject(reason11);
                                else if (intentState11.opListReadCapability) intentState11.opListReadCapability.reject(reason11);
                                else throw reason11;
                            });
                        };
                        pump11();
                    }
                    _abortOperatorList({ intentState: intentState11, reason: reason11, force: force11 = false }) {
                        if (!intentState11.streamReader) return;
                        if (intentState11.streamReaderCancelTimeout) {
                            clearTimeout(intentState11.streamReaderCancelTimeout);
                            intentState11.streamReaderCancelTimeout = null;
                        }
                        if (!force11) {
                            if (intentState11.renderTasks.size > 0) return;
                            if (reason11 instanceof _display_utils.RenderingCancelledException) {
                                let delay11 = RENDERING_CANCELLED_TIMEOUT;
                                if (reason11.extraDelay > 0 && reason11.extraDelay < 1000) delay11 += reason11.extraDelay;
                                intentState11.streamReaderCancelTimeout = setTimeout(()=>{
                                    intentState11.streamReaderCancelTimeout = null;
                                    this._abortOperatorList({
                                        intentState: intentState11,
                                        reason: reason11,
                                        force: true
                                    });
                                }, delay11);
                                return;
                            }
                        }
                        intentState11.streamReader.cancel(new _util.AbortException(reason11.message)).catch(()=>{});
                        intentState11.streamReader = null;
                        if (this._transport.destroyed) return;
                        for (const [curCacheKey11, curIntentState11] of this._intentStates)if (curIntentState11 === intentState11) {
                            this._intentStates.delete(curCacheKey11);
                            break;
                        }
                        this.cleanup();
                    }
                    get stats() {
                        return this._stats;
                    }
                }
                exports.PDFPageProxy = PDFPageProxy;
                class LoopbackPort {
                    #listeners = new Set();
                    #deferred = Promise.resolve();
                    postMessage(obj11, transfer11) {
                        const event11 = {
                            data: structuredClone(obj11, transfer11 ? {
                                transfer: transfer11
                            } : null)
                        };
                        this.#deferred.then(()=>{
                            for (const listener11 of this.#listeners)listener11.call(this, event11);
                        });
                    }
                    addEventListener(name11, listener11) {
                        this.#listeners.add(listener11);
                    }
                    removeEventListener(name11, listener11) {
                        this.#listeners.delete(listener11);
                    }
                    terminate() {
                        this.#listeners.clear();
                    }
                }
                exports.LoopbackPort = LoopbackPort;
                const PDFWorkerUtil = {
                    isWorkerDisabled: false,
                    fallbackWorkerSrc: null,
                    fakeWorkerId: 0
                };
                exports.PDFWorkerUtil = PDFWorkerUtil;
                if (_util.isNodeJS && true) {
                    PDFWorkerUtil.isWorkerDisabled = true;
                    PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
                } else if (typeof document === "object") {
                    const pdfjsFilePath = document?.currentScript?.src;
                    if (pdfjsFilePath) PDFWorkerUtil.fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
                }
                PDFWorkerUtil.isSameOrigin = function(baseUrl11, otherUrl11) {
                    let base11;
                    try {
                        base11 = new URL(baseUrl11);
                        if (!base11.origin || base11.origin === "null") return false;
                    } catch  {
                        return false;
                    }
                    const other11 = new URL(otherUrl11, base11);
                    return base11.origin === other11.origin;
                };
                PDFWorkerUtil.createCDNWrapper = function(url11) {
                    const wrapper11 = `importScripts("${url11}");`;
                    return URL.createObjectURL(new Blob([
                        wrapper11
                    ]));
                };
                class PDFWorker {
                    static #workerPorts;
                    constructor({ name: name11 = null, port: port11 = null, verbosity: verbosity11 = (0, _util.getVerbosityLevel)() } = {}){
                        this.name = name11;
                        this.destroyed = false;
                        this.verbosity = verbosity11;
                        this._readyCapability = new _util.PromiseCapability();
                        this._port = null;
                        this._webWorker = null;
                        this._messageHandler = null;
                        if (port11) {
                            if (PDFWorker.#workerPorts?.has(port11)) throw new Error("Cannot use more than one PDFWorker per port.");
                            (PDFWorker.#workerPorts ||= new WeakMap()).set(port11, this);
                            this._initializeFromPort(port11);
                            return;
                        }
                        this._initialize();
                    }
                    get promise() {
                        return this._readyCapability.promise;
                    }
                    get port() {
                        return this._port;
                    }
                    get messageHandler() {
                        return this._messageHandler;
                    }
                    _initializeFromPort(port11) {
                        this._port = port11;
                        this._messageHandler = new _message_handler.MessageHandler("main", "worker", port11);
                        this._messageHandler.on("ready", function() {});
                        this._readyCapability.resolve();
                        this._messageHandler.send("configure", {
                            verbosity: this.verbosity
                        });
                    }
                    _initialize() {
                        if (!PDFWorkerUtil.isWorkerDisabled && !PDFWorker._mainThreadWorkerMessageHandler) {
                            let { workerSrc: workerSrc11 } = PDFWorker;
                            try {
                                if (!PDFWorkerUtil.isSameOrigin(window.location.href, workerSrc11)) workerSrc11 = PDFWorkerUtil.createCDNWrapper(new URL(workerSrc11, window.location).href);
                                const worker11 = new Worker(workerSrc11);
                                const messageHandler11 = new _message_handler.MessageHandler("main", "worker", worker11);
                                const terminateEarly11 = ()=>{
                                    worker11.removeEventListener("error", onWorkerError11);
                                    messageHandler11.destroy();
                                    worker11.terminate();
                                    if (this.destroyed) this._readyCapability.reject(new Error("Worker was destroyed"));
                                    else this._setupFakeWorker();
                                };
                                const onWorkerError11 = ()=>{
                                    if (!this._webWorker) terminateEarly11();
                                };
                                worker11.addEventListener("error", onWorkerError11);
                                messageHandler11.on("test", (data11)=>{
                                    worker11.removeEventListener("error", onWorkerError11);
                                    if (this.destroyed) {
                                        terminateEarly11();
                                        return;
                                    }
                                    if (data11) {
                                        this._messageHandler = messageHandler11;
                                        this._port = worker11;
                                        this._webWorker = worker11;
                                        this._readyCapability.resolve();
                                        messageHandler11.send("configure", {
                                            verbosity: this.verbosity
                                        });
                                    } else {
                                        this._setupFakeWorker();
                                        messageHandler11.destroy();
                                        worker11.terminate();
                                    }
                                });
                                messageHandler11.on("ready", (data11)=>{
                                    worker11.removeEventListener("error", onWorkerError11);
                                    if (this.destroyed) {
                                        terminateEarly11();
                                        return;
                                    }
                                    try {
                                        sendTest11();
                                    } catch  {
                                        this._setupFakeWorker();
                                    }
                                });
                                const sendTest11 = ()=>{
                                    const testObj11 = new Uint8Array();
                                    messageHandler11.send("test", testObj11, [
                                        testObj11.buffer
                                    ]);
                                };
                                sendTest11();
                                return;
                            } catch  {
                                (0, _util.info)("The worker has been disabled.");
                            }
                        }
                        this._setupFakeWorker();
                    }
                    _setupFakeWorker() {
                        if (!PDFWorkerUtil.isWorkerDisabled) {
                            (0, _util.warn)("Setting up fake worker.");
                            PDFWorkerUtil.isWorkerDisabled = true;
                        }
                        PDFWorker._setupFakeWorkerGlobal.then((WorkerMessageHandler11)=>{
                            if (this.destroyed) {
                                this._readyCapability.reject(new Error("Worker was destroyed"));
                                return;
                            }
                            const port11 = new LoopbackPort();
                            this._port = port11;
                            const id11 = `fake${PDFWorkerUtil.fakeWorkerId++}`;
                            const workerHandler11 = new _message_handler.MessageHandler(id11 + "_worker", id11, port11);
                            WorkerMessageHandler11.setup(workerHandler11, port11);
                            const messageHandler11 = new _message_handler.MessageHandler(id11, id11 + "_worker", port11);
                            this._messageHandler = messageHandler11;
                            this._readyCapability.resolve();
                            messageHandler11.send("configure", {
                                verbosity: this.verbosity
                            });
                        }).catch((reason11)=>{
                            this._readyCapability.reject(new Error(`Setting up fake worker failed: "${reason11.message}".`));
                        });
                    }
                    destroy() {
                        this.destroyed = true;
                        if (this._webWorker) {
                            this._webWorker.terminate();
                            this._webWorker = null;
                        }
                        PDFWorker.#workerPorts?.delete(this._port);
                        this._port = null;
                        if (this._messageHandler) {
                            this._messageHandler.destroy();
                            this._messageHandler = null;
                        }
                    }
                    static fromPort(params11) {
                        if (!params11?.port) throw new Error("PDFWorker.fromPort - invalid method signature.");
                        const cachedPort11 = this.#workerPorts?.get(params11.port);
                        if (cachedPort11) {
                            if (cachedPort11._pendingDestroy) throw new Error("PDFWorker.fromPort - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
                            return cachedPort11;
                        }
                        return new PDFWorker(params11);
                    }
                    static get workerSrc() {
                        if (_worker_options.GlobalWorkerOptions.workerSrc) return _worker_options.GlobalWorkerOptions.workerSrc;
                        if (PDFWorkerUtil.fallbackWorkerSrc !== null) {
                            if (!_util.isNodeJS) (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.');
                            return PDFWorkerUtil.fallbackWorkerSrc;
                        }
                        throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
                    }
                    static get _mainThreadWorkerMessageHandler() {
                        try {
                            return globalThis.pdfjsWorker?.WorkerMessageHandler || null;
                        } catch  {
                            return null;
                        }
                    }
                    static get _setupFakeWorkerGlobal() {
                        const loader = async ()=>{
                            const mainWorkerMessageHandler = this._mainThreadWorkerMessageHandler;
                            if (mainWorkerMessageHandler) return mainWorkerMessageHandler;
                            if (_util.isNodeJS && true) {
                                const worker = eval("require")(this.workerSrc);
                                return worker.WorkerMessageHandler;
                            }
                            await (0, _display_utils.loadScript)(this.workerSrc);
                            return window.pdfjsWorker.WorkerMessageHandler;
                        };
                        return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
                    }
                }
                exports.PDFWorker = PDFWorker;
                class WorkerTransport {
                    #methodPromises = new Map();
                    #pageCache = new Map();
                    #pagePromises = new Map();
                    #passwordCapability = null;
                    constructor(messageHandler11, loadingTask11, networkStream11, params11, factory11){
                        this.messageHandler = messageHandler11;
                        this.loadingTask = loadingTask11;
                        this.commonObjs = new PDFObjects();
                        this.fontLoader = new _font_loader.FontLoader({
                            ownerDocument: params11.ownerDocument,
                            styleElement: params11.styleElement
                        });
                        this._params = params11;
                        this.canvasFactory = factory11.canvasFactory;
                        this.filterFactory = factory11.filterFactory;
                        this.cMapReaderFactory = factory11.cMapReaderFactory;
                        this.standardFontDataFactory = factory11.standardFontDataFactory;
                        this.destroyed = false;
                        this.destroyCapability = null;
                        this._networkStream = networkStream11;
                        this._fullReader = null;
                        this._lastProgress = null;
                        this.downloadInfoCapability = new _util.PromiseCapability();
                        this.setupMessageHandler();
                    }
                    #cacheSimpleMethod(name11, data11 = null) {
                        const cachedPromise11 = this.#methodPromises.get(name11);
                        if (cachedPromise11) return cachedPromise11;
                        const promise11 = this.messageHandler.sendWithPromise(name11, data11);
                        this.#methodPromises.set(name11, promise11);
                        return promise11;
                    }
                    get annotationStorage() {
                        return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
                    }
                    getRenderingIntent(intent11, annotationMode11 = _util.AnnotationMode.ENABLE, printAnnotationStorage11 = null, isOpList11 = false) {
                        let renderingIntent11 = _util.RenderingIntentFlag.DISPLAY;
                        let annotationStorageSerializable11 = _annotation_storage.SerializableEmpty;
                        switch(intent11){
                            case "any":
                                renderingIntent11 = _util.RenderingIntentFlag.ANY;
                                break;
                            case "display":
                                break;
                            case "print":
                                renderingIntent11 = _util.RenderingIntentFlag.PRINT;
                                break;
                            default:
                                (0, _util.warn)(`getRenderingIntent - invalid intent: ${intent11}`);
                        }
                        switch(annotationMode11){
                            case _util.AnnotationMode.DISABLE:
                                renderingIntent11 += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                                break;
                            case _util.AnnotationMode.ENABLE:
                                break;
                            case _util.AnnotationMode.ENABLE_FORMS:
                                renderingIntent11 += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                                break;
                            case _util.AnnotationMode.ENABLE_STORAGE:
                                renderingIntent11 += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE;
                                const annotationStorage11 = renderingIntent11 & _util.RenderingIntentFlag.PRINT && printAnnotationStorage11 instanceof _annotation_storage.PrintAnnotationStorage ? printAnnotationStorage11 : this.annotationStorage;
                                annotationStorageSerializable11 = annotationStorage11.serializable;
                                break;
                            default:
                                (0, _util.warn)(`getRenderingIntent - invalid annotationMode: ${annotationMode11}`);
                        }
                        if (isOpList11) renderingIntent11 += _util.RenderingIntentFlag.OPLIST;
                        return {
                            renderingIntent: renderingIntent11,
                            cacheKey: `${renderingIntent11}_${annotationStorageSerializable11.hash}`,
                            annotationStorageSerializable: annotationStorageSerializable11
                        };
                    }
                    destroy() {
                        if (this.destroyCapability) return this.destroyCapability.promise;
                        this.destroyed = true;
                        this.destroyCapability = new _util.PromiseCapability();
                        this.#passwordCapability?.reject(new Error("Worker was destroyed during onPassword callback"));
                        const waitOn11 = [];
                        for (const page11 of this.#pageCache.values())waitOn11.push(page11._destroy());
                        this.#pageCache.clear();
                        this.#pagePromises.clear();
                        if (this.hasOwnProperty("annotationStorage")) this.annotationStorage.resetModified();
                        const terminated11 = this.messageHandler.sendWithPromise("Terminate", null);
                        waitOn11.push(terminated11);
                        Promise.all(waitOn11).then(()=>{
                            this.commonObjs.clear();
                            this.fontLoader.clear();
                            this.#methodPromises.clear();
                            this.filterFactory.destroy();
                            this._networkStream?.cancelAllRequests(new _util.AbortException("Worker was terminated."));
                            if (this.messageHandler) {
                                this.messageHandler.destroy();
                                this.messageHandler = null;
                            }
                            this.destroyCapability.resolve();
                        }, this.destroyCapability.reject);
                        return this.destroyCapability.promise;
                    }
                    setupMessageHandler() {
                        const { messageHandler: messageHandler11, loadingTask: loadingTask11 } = this;
                        messageHandler11.on("GetReader", (data11, sink11)=>{
                            (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available.");
                            this._fullReader = this._networkStream.getFullReader();
                            this._fullReader.onProgress = (evt11)=>{
                                this._lastProgress = {
                                    loaded: evt11.loaded,
                                    total: evt11.total
                                };
                            };
                            sink11.onPull = ()=>{
                                this._fullReader.read().then(function({ value: value11, done: done11 }) {
                                    if (done11) {
                                        sink11.close();
                                        return;
                                    }
                                    (0, _util.assert)(value11 instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer.");
                                    sink11.enqueue(new Uint8Array(value11), 1, [
                                        value11
                                    ]);
                                }).catch((reason11)=>{
                                    sink11.error(reason11);
                                });
                            };
                            sink11.onCancel = (reason11)=>{
                                this._fullReader.cancel(reason11);
                                sink11.ready.catch((readyReason11)=>{
                                    if (this.destroyed) return;
                                    throw readyReason11;
                                });
                            };
                        });
                        messageHandler11.on("ReaderHeadersReady", (data11)=>{
                            const headersCapability11 = new _util.PromiseCapability();
                            const fullReader11 = this._fullReader;
                            fullReader11.headersReady.then(()=>{
                                if (!fullReader11.isStreamingSupported || !fullReader11.isRangeSupported) {
                                    if (this._lastProgress) loadingTask11.onProgress?.(this._lastProgress);
                                    fullReader11.onProgress = (evt11)=>{
                                        loadingTask11.onProgress?.({
                                            loaded: evt11.loaded,
                                            total: evt11.total
                                        });
                                    };
                                }
                                headersCapability11.resolve({
                                    isStreamingSupported: fullReader11.isStreamingSupported,
                                    isRangeSupported: fullReader11.isRangeSupported,
                                    contentLength: fullReader11.contentLength
                                });
                            }, headersCapability11.reject);
                            return headersCapability11.promise;
                        });
                        messageHandler11.on("GetRangeReader", (data11, sink11)=>{
                            (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                            const rangeReader11 = this._networkStream.getRangeReader(data11.begin, data11.end);
                            if (!rangeReader11) {
                                sink11.close();
                                return;
                            }
                            sink11.onPull = ()=>{
                                rangeReader11.read().then(function({ value: value11, done: done11 }) {
                                    if (done11) {
                                        sink11.close();
                                        return;
                                    }
                                    (0, _util.assert)(value11 instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer.");
                                    sink11.enqueue(new Uint8Array(value11), 1, [
                                        value11
                                    ]);
                                }).catch((reason11)=>{
                                    sink11.error(reason11);
                                });
                            };
                            sink11.onCancel = (reason11)=>{
                                rangeReader11.cancel(reason11);
                                sink11.ready.catch((readyReason11)=>{
                                    if (this.destroyed) return;
                                    throw readyReason11;
                                });
                            };
                        });
                        messageHandler11.on("GetDoc", ({ pdfInfo: pdfInfo11 })=>{
                            this._numPages = pdfInfo11.numPages;
                            this._htmlForXfa = pdfInfo11.htmlForXfa;
                            delete pdfInfo11.htmlForXfa;
                            loadingTask11._capability.resolve(new PDFDocumentProxy(pdfInfo11, this));
                        });
                        messageHandler11.on("DocException", function(ex11) {
                            let reason11;
                            switch(ex11.name){
                                case "PasswordException":
                                    reason11 = new _util.PasswordException(ex11.message, ex11.code);
                                    break;
                                case "InvalidPDFException":
                                    reason11 = new _util.InvalidPDFException(ex11.message);
                                    break;
                                case "MissingPDFException":
                                    reason11 = new _util.MissingPDFException(ex11.message);
                                    break;
                                case "UnexpectedResponseException":
                                    reason11 = new _util.UnexpectedResponseException(ex11.message, ex11.status);
                                    break;
                                case "UnknownErrorException":
                                    reason11 = new _util.UnknownErrorException(ex11.message, ex11.details);
                                    break;
                                default:
                                    (0, _util.unreachable)("DocException - expected a valid Error.");
                            }
                            loadingTask11._capability.reject(reason11);
                        });
                        messageHandler11.on("PasswordRequest", (exception11)=>{
                            this.#passwordCapability = new _util.PromiseCapability();
                            if (loadingTask11.onPassword) {
                                const updatePassword11 = (password11)=>{
                                    if (password11 instanceof Error) this.#passwordCapability.reject(password11);
                                    else this.#passwordCapability.resolve({
                                        password: password11
                                    });
                                };
                                try {
                                    loadingTask11.onPassword(updatePassword11, exception11.code);
                                } catch (ex11) {
                                    this.#passwordCapability.reject(ex11);
                                }
                            } else this.#passwordCapability.reject(new _util.PasswordException(exception11.message, exception11.code));
                            return this.#passwordCapability.promise;
                        });
                        messageHandler11.on("DataLoaded", (data11)=>{
                            loadingTask11.onProgress?.({
                                loaded: data11.length,
                                total: data11.length
                            });
                            this.downloadInfoCapability.resolve(data11);
                        });
                        messageHandler11.on("StartRenderPage", (data11)=>{
                            if (this.destroyed) return;
                            const page11 = this.#pageCache.get(data11.pageIndex);
                            page11._startRenderPage(data11.transparency, data11.cacheKey);
                        });
                        messageHandler11.on("commonobj", ([id11, type11, exportedData11])=>{
                            if (this.destroyed) return;
                            if (this.commonObjs.has(id11)) return;
                            switch(type11){
                                case "Font":
                                    const params11 = this._params;
                                    if ("error" in exportedData11) {
                                        const exportedError11 = exportedData11.error;
                                        (0, _util.warn)(`Error during font loading: ${exportedError11}`);
                                        this.commonObjs.resolve(id11, exportedError11);
                                        break;
                                    }
                                    const inspectFont11 = params11.pdfBug && globalThis.FontInspector?.enabled ? (font11, url11)=>globalThis.FontInspector.fontAdded(font11, url11) : null;
                                    const font11 = new _font_loader.FontFaceObject(exportedData11, {
                                        isEvalSupported: params11.isEvalSupported,
                                        disableFontFace: params11.disableFontFace,
                                        ignoreErrors: params11.ignoreErrors,
                                        inspectFont: inspectFont11
                                    });
                                    this.fontLoader.bind(font11).catch((reason11)=>{
                                        return messageHandler11.sendWithPromise("FontFallback", {
                                            id: id11
                                        });
                                    }).finally(()=>{
                                        if (!params11.fontExtraProperties && font11.data) font11.data = null;
                                        this.commonObjs.resolve(id11, font11);
                                    });
                                    break;
                                case "FontPath":
                                case "Image":
                                case "Pattern":
                                    this.commonObjs.resolve(id11, exportedData11);
                                    break;
                                default:
                                    throw new Error(`Got unknown common object type ${type11}`);
                            }
                        });
                        messageHandler11.on("obj", ([id11, pageIndex11, type11, imageData11])=>{
                            if (this.destroyed) return;
                            const pageProxy11 = this.#pageCache.get(pageIndex11);
                            if (pageProxy11.objs.has(id11)) return;
                            switch(type11){
                                case "Image":
                                    pageProxy11.objs.resolve(id11, imageData11);
                                    if (imageData11) {
                                        let length11;
                                        if (imageData11.bitmap) {
                                            const { width: width21, height: height11 } = imageData11;
                                            length11 = width21 * height11 * 4;
                                        } else length11 = imageData11.data?.length || 0;
                                        if (length11 > _util.MAX_IMAGE_SIZE_TO_CACHE) pageProxy11._maybeCleanupAfterRender = true;
                                    }
                                    break;
                                case "Pattern":
                                    pageProxy11.objs.resolve(id11, imageData11);
                                    break;
                                default:
                                    throw new Error(`Got unknown object type ${type11}`);
                            }
                        });
                        messageHandler11.on("DocProgress", (data11)=>{
                            if (this.destroyed) return;
                            loadingTask11.onProgress?.({
                                loaded: data11.loaded,
                                total: data11.total
                            });
                        });
                        messageHandler11.on("FetchBuiltInCMap", (data11)=>{
                            if (this.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                            if (!this.cMapReaderFactory) return Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."));
                            return this.cMapReaderFactory.fetch(data11);
                        });
                        messageHandler11.on("FetchStandardFontData", (data11)=>{
                            if (this.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                            if (!this.standardFontDataFactory) return Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter."));
                            return this.standardFontDataFactory.fetch(data11);
                        });
                    }
                    getData() {
                        return this.messageHandler.sendWithPromise("GetData", null);
                    }
                    saveDocument() {
                        if (this.annotationStorage.size <= 0) (0, _util.warn)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
                        const { map: map11, transfers: transfers11 } = this.annotationStorage.serializable;
                        return this.messageHandler.sendWithPromise("SaveDocument", {
                            isPureXfa: !!this._htmlForXfa,
                            numPages: this._numPages,
                            annotationStorage: map11,
                            filename: this._fullReader?.filename ?? null
                        }, transfers11).finally(()=>{
                            this.annotationStorage.resetModified();
                        });
                    }
                    getPage(pageNumber11) {
                        if (!Number.isInteger(pageNumber11) || pageNumber11 <= 0 || pageNumber11 > this._numPages) return Promise.reject(new Error("Invalid page request."));
                        const pageIndex11 = pageNumber11 - 1, cachedPromise11 = this.#pagePromises.get(pageIndex11);
                        if (cachedPromise11) return cachedPromise11;
                        const promise11 = this.messageHandler.sendWithPromise("GetPage", {
                            pageIndex: pageIndex11
                        }).then((pageInfo11)=>{
                            if (this.destroyed) throw new Error("Transport destroyed");
                            const page11 = new PDFPageProxy(pageIndex11, pageInfo11, this, this._params.pdfBug);
                            this.#pageCache.set(pageIndex11, page11);
                            return page11;
                        });
                        this.#pagePromises.set(pageIndex11, promise11);
                        return promise11;
                    }
                    getPageIndex(ref11) {
                        if (typeof ref11 !== "object" || ref11 === null || !Number.isInteger(ref11.num) || ref11.num < 0 || !Number.isInteger(ref11.gen) || ref11.gen < 0) return Promise.reject(new Error("Invalid pageIndex request."));
                        return this.messageHandler.sendWithPromise("GetPageIndex", {
                            num: ref11.num,
                            gen: ref11.gen
                        });
                    }
                    getAnnotations(pageIndex11, intent11) {
                        return this.messageHandler.sendWithPromise("GetAnnotations", {
                            pageIndex: pageIndex11,
                            intent: intent11
                        });
                    }
                    getFieldObjects() {
                        return this.#cacheSimpleMethod("GetFieldObjects");
                    }
                    hasJSActions() {
                        return this.#cacheSimpleMethod("HasJSActions");
                    }
                    getCalculationOrderIds() {
                        return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
                    }
                    getDestinations() {
                        return this.messageHandler.sendWithPromise("GetDestinations", null);
                    }
                    getDestination(id11) {
                        if (typeof id11 !== "string") return Promise.reject(new Error("Invalid destination request."));
                        return this.messageHandler.sendWithPromise("GetDestination", {
                            id: id11
                        });
                    }
                    getPageLabels() {
                        return this.messageHandler.sendWithPromise("GetPageLabels", null);
                    }
                    getPageLayout() {
                        return this.messageHandler.sendWithPromise("GetPageLayout", null);
                    }
                    getPageMode() {
                        return this.messageHandler.sendWithPromise("GetPageMode", null);
                    }
                    getViewerPreferences() {
                        return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
                    }
                    getOpenAction() {
                        return this.messageHandler.sendWithPromise("GetOpenAction", null);
                    }
                    getAttachments() {
                        return this.messageHandler.sendWithPromise("GetAttachments", null);
                    }
                    getDocJSActions() {
                        return this.#cacheSimpleMethod("GetDocJSActions");
                    }
                    getPageJSActions(pageIndex11) {
                        return this.messageHandler.sendWithPromise("GetPageJSActions", {
                            pageIndex: pageIndex11
                        });
                    }
                    getStructTree(pageIndex11) {
                        return this.messageHandler.sendWithPromise("GetStructTree", {
                            pageIndex: pageIndex11
                        });
                    }
                    getOutline() {
                        return this.messageHandler.sendWithPromise("GetOutline", null);
                    }
                    getOptionalContentConfig() {
                        return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then((results11)=>{
                            return new _optional_content_config.OptionalContentConfig(results11);
                        });
                    }
                    getPermissions() {
                        return this.messageHandler.sendWithPromise("GetPermissions", null);
                    }
                    getMetadata() {
                        const name11 = "GetMetadata", cachedPromise11 = this.#methodPromises.get(name11);
                        if (cachedPromise11) return cachedPromise11;
                        const promise11 = this.messageHandler.sendWithPromise(name11, null).then((results11)=>{
                            return {
                                info: results11[0],
                                metadata: results11[1] ? new _metadata.Metadata(results11[1]) : null,
                                contentDispositionFilename: this._fullReader?.filename ?? null,
                                contentLength: this._fullReader?.contentLength ?? null
                            };
                        });
                        this.#methodPromises.set(name11, promise11);
                        return promise11;
                    }
                    getMarkInfo() {
                        return this.messageHandler.sendWithPromise("GetMarkInfo", null);
                    }
                    async startCleanup(keepLoadedFonts11 = false) {
                        if (this.destroyed) return;
                        await this.messageHandler.sendWithPromise("Cleanup", null);
                        for (const page11 of this.#pageCache.values()){
                            const cleanupSuccessful11 = page11.cleanup();
                            if (!cleanupSuccessful11) throw new Error(`startCleanup: Page ${page11.pageNumber} is currently rendering.`);
                        }
                        this.commonObjs.clear();
                        if (!keepLoadedFonts11) this.fontLoader.clear();
                        this.#methodPromises.clear();
                        this.filterFactory.destroy(true);
                    }
                    get loadingParams() {
                        const { disableAutoFetch: disableAutoFetch11, enableXfa: enableXfa11 } = this._params;
                        return (0, _util.shadow)(this, "loadingParams", {
                            disableAutoFetch: disableAutoFetch11,
                            enableXfa: enableXfa11
                        });
                    }
                }
                class PDFObjects {
                    #objs = Object.create(null);
                    #ensureObj(objId11) {
                        return this.#objs[objId11] ||= {
                            capability: new _util.PromiseCapability(),
                            data: null
                        };
                    }
                    get(objId11, callback11 = null) {
                        if (callback11) {
                            const obj11 = this.#ensureObj(objId11);
                            obj11.capability.promise.then(()=>callback11(obj11.data));
                            return null;
                        }
                        const obj11 = this.#objs[objId11];
                        if (!obj11?.capability.settled) throw new Error(`Requesting object that isn't resolved yet ${objId11}.`);
                        return obj11.data;
                    }
                    has(objId11) {
                        const obj11 = this.#objs[objId11];
                        return obj11?.capability.settled || false;
                    }
                    resolve(objId11, data11 = null) {
                        const obj11 = this.#ensureObj(objId11);
                        obj11.data = data11;
                        obj11.capability.resolve();
                    }
                    clear() {
                        for(const objId11 in this.#objs){
                            const { data: data11 } = this.#objs[objId11];
                            data11?.bitmap?.close();
                        }
                        this.#objs = Object.create(null);
                    }
                }
                class RenderTask {
                    #internalRenderTask = null;
                    constructor(internalRenderTask11){
                        this.#internalRenderTask = internalRenderTask11;
                        this.onContinue = null;
                    }
                    get promise() {
                        return this.#internalRenderTask.capability.promise;
                    }
                    cancel(extraDelay11 = 0) {
                        this.#internalRenderTask.cancel(null, extraDelay11);
                    }
                    get separateAnnots() {
                        const { separateAnnots: separateAnnots11 } = this.#internalRenderTask.operatorList;
                        if (!separateAnnots11) return false;
                        const { annotationCanvasMap: annotationCanvasMap11 } = this.#internalRenderTask;
                        return separateAnnots11.form || separateAnnots11.canvas && annotationCanvasMap11?.size > 0;
                    }
                }
                exports.RenderTask = RenderTask;
                class InternalRenderTask {
                    static #canvasInUse = new WeakSet();
                    constructor({ callback: callback11, params: params11, objs: objs11, commonObjs: commonObjs11, annotationCanvasMap: annotationCanvasMap11, operatorList: operatorList11, pageIndex: pageIndex11, canvasFactory: canvasFactory11, filterFactory: filterFactory11, useRequestAnimationFrame: useRequestAnimationFrame11 = false, pdfBug: pdfBug11 = false, pageColors: pageColors11 = null }){
                        this.callback = callback11;
                        this.params = params11;
                        this.objs = objs11;
                        this.commonObjs = commonObjs11;
                        this.annotationCanvasMap = annotationCanvasMap11;
                        this.operatorListIdx = null;
                        this.operatorList = operatorList11;
                        this._pageIndex = pageIndex11;
                        this.canvasFactory = canvasFactory11;
                        this.filterFactory = filterFactory11;
                        this._pdfBug = pdfBug11;
                        this.pageColors = pageColors11;
                        this.running = false;
                        this.graphicsReadyCallback = null;
                        this.graphicsReady = false;
                        this._useRequestAnimationFrame = useRequestAnimationFrame11 === true && typeof window !== "undefined";
                        this.cancelled = false;
                        this.capability = new _util.PromiseCapability();
                        this.task = new RenderTask(this);
                        this._cancelBound = this.cancel.bind(this);
                        this._continueBound = this._continue.bind(this);
                        this._scheduleNextBound = this._scheduleNext.bind(this);
                        this._nextBound = this._next.bind(this);
                        this._canvas = params11.canvasContext.canvas;
                    }
                    get completed() {
                        return this.capability.promise.catch(function() {});
                    }
                    initializeGraphics({ transparency: transparency11 = false, optionalContentConfig: optionalContentConfig11 }) {
                        if (this.cancelled) return;
                        if (this._canvas) {
                            if (InternalRenderTask.#canvasInUse.has(this._canvas)) throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                            InternalRenderTask.#canvasInUse.add(this._canvas);
                        }
                        if (this._pdfBug && globalThis.StepperManager?.enabled) {
                            this.stepper = globalThis.StepperManager.create(this._pageIndex);
                            this.stepper.init(this.operatorList);
                            this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
                        }
                        const { canvasContext: canvasContext11, viewport: viewport11, transform: transform11, background: background11 } = this.params;
                        this.gfx = new _canvas.CanvasGraphics(canvasContext11, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                            optionalContentConfig: optionalContentConfig11
                        }, this.annotationCanvasMap, this.pageColors);
                        this.gfx.beginDrawing({
                            transform: transform11,
                            viewport: viewport11,
                            transparency: transparency11,
                            background: background11
                        });
                        this.operatorListIdx = 0;
                        this.graphicsReady = true;
                        this.graphicsReadyCallback?.();
                    }
                    cancel(error11 = null, extraDelay11 = 0) {
                        this.running = false;
                        this.cancelled = true;
                        this.gfx?.endDrawing();
                        InternalRenderTask.#canvasInUse.delete(this._canvas);
                        this.callback(error11 || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, extraDelay11));
                    }
                    operatorListChanged() {
                        if (!this.graphicsReady) {
                            this.graphicsReadyCallback ||= this._continueBound;
                            return;
                        }
                        this.stepper?.updateOperatorList(this.operatorList);
                        if (this.running) return;
                        this._continue();
                    }
                    _continue() {
                        this.running = true;
                        if (this.cancelled) return;
                        if (this.task.onContinue) this.task.onContinue(this._scheduleNextBound);
                        else this._scheduleNext();
                    }
                    _scheduleNext() {
                        if (this._useRequestAnimationFrame) window.requestAnimationFrame(()=>{
                            this._nextBound().catch(this._cancelBound);
                        });
                        else Promise.resolve().then(this._nextBound).catch(this._cancelBound);
                    }
                    async _next() {
                        if (this.cancelled) return;
                        this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
                        if (this.operatorListIdx === this.operatorList.argsArray.length) {
                            this.running = false;
                            if (this.operatorList.lastChunk) {
                                this.gfx.endDrawing();
                                InternalRenderTask.#canvasInUse.delete(this._canvas);
                                this.callback();
                            }
                        }
                    }
                }
                const version = "3.11.174";
                exports.version = version;
                const build = "ce8716743";
                exports.build = build;
            /***/ },
            /* 3 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.SerializableEmpty = exports11.PrintAnnotationStorage = exports11.AnnotationStorage = void 0;
                var _util11 = __w_pdfjs_require__11(1);
                var _editor11 = __w_pdfjs_require__11(4);
                var _murmurhash11 = __w_pdfjs_require__11(8);
                const SerializableEmpty11 = Object.freeze({
                    map: null,
                    hash: "",
                    transfers: undefined
                });
                exports11.SerializableEmpty = SerializableEmpty11;
                class AnnotationStorage11 {
                    #modified = false;
                    #storage = new Map();
                    constructor(){
                        this.onSetModified = null;
                        this.onResetModified = null;
                        this.onAnnotationEditor = null;
                    }
                    getValue(key11, defaultValue11) {
                        const value11 = this.#storage.get(key11);
                        if (value11 === undefined) return defaultValue11;
                        return Object.assign(defaultValue11, value11);
                    }
                    getRawValue(key11) {
                        return this.#storage.get(key11);
                    }
                    remove(key11) {
                        this.#storage.delete(key11);
                        if (this.#storage.size === 0) this.resetModified();
                        if (typeof this.onAnnotationEditor === "function") {
                            for (const value11 of this.#storage.values()){
                                if (value11 instanceof _editor11.AnnotationEditor) return;
                            }
                            this.onAnnotationEditor(null);
                        }
                    }
                    setValue(key11, value11) {
                        const obj11 = this.#storage.get(key11);
                        let modified11 = false;
                        if (obj11 !== undefined) {
                            for (const [entry11, val11] of Object.entries(value11))if (obj11[entry11] !== val11) {
                                modified11 = true;
                                obj11[entry11] = val11;
                            }
                        } else {
                            modified11 = true;
                            this.#storage.set(key11, value11);
                        }
                        if (modified11) this.#setModified();
                        if (value11 instanceof _editor11.AnnotationEditor && typeof this.onAnnotationEditor === "function") this.onAnnotationEditor(value11.constructor._type);
                    }
                    has(key11) {
                        return this.#storage.has(key11);
                    }
                    getAll() {
                        return this.#storage.size > 0 ? (0, _util11.objectFromMap)(this.#storage) : null;
                    }
                    setAll(obj11) {
                        for (const [key11, val11] of Object.entries(obj11))this.setValue(key11, val11);
                    }
                    get size() {
                        return this.#storage.size;
                    }
                    #setModified() {
                        if (!this.#modified) {
                            this.#modified = true;
                            if (typeof this.onSetModified === "function") this.onSetModified();
                        }
                    }
                    resetModified() {
                        if (this.#modified) {
                            this.#modified = false;
                            if (typeof this.onResetModified === "function") this.onResetModified();
                        }
                    }
                    get print() {
                        return new PrintAnnotationStorage11(this);
                    }
                    get serializable() {
                        if (this.#storage.size === 0) return SerializableEmpty11;
                        const map11 = new Map(), hash11 = new _murmurhash11.MurmurHash3_64(), transfers11 = [];
                        const context11 = Object.create(null);
                        let hasBitmap11 = false;
                        for (const [key11, val11] of this.#storage){
                            const serialized11 = val11 instanceof _editor11.AnnotationEditor ? val11.serialize(false, context11) : val11;
                            if (serialized11) {
                                map11.set(key11, serialized11);
                                hash11.update(`${key11}:${JSON.stringify(serialized11)}`);
                                hasBitmap11 ||= !!serialized11.bitmap;
                            }
                        }
                        if (hasBitmap11) {
                            for (const value11 of map11.values())if (value11.bitmap) transfers11.push(value11.bitmap);
                        }
                        return map11.size > 0 ? {
                            map: map11,
                            hash: hash11.hexdigest(),
                            transfers: transfers11
                        } : SerializableEmpty11;
                    }
                }
                exports11.AnnotationStorage = AnnotationStorage11;
                class PrintAnnotationStorage11 extends AnnotationStorage11 {
                    #serializable;
                    constructor(parent11){
                        super();
                        const { map: map11, hash: hash11, transfers: transfers11 } = parent11.serializable;
                        const clone11 = structuredClone(map11, transfers11 ? {
                            transfer: transfers11
                        } : null);
                        this.#serializable = {
                            map: clone11,
                            hash: hash11,
                            transfers: transfers11
                        };
                    }
                    get print() {
                        (0, _util11.unreachable)("Should not call PrintAnnotationStorage.print");
                    }
                    get serializable() {
                        return this.#serializable;
                    }
                }
                exports11.PrintAnnotationStorage = PrintAnnotationStorage11;
            /***/ },
            /* 4 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.AnnotationEditor = void 0;
                var _tools11 = __w_pdfjs_require__11(5);
                var _util11 = __w_pdfjs_require__11(1);
                var _display_utils11 = __w_pdfjs_require__11(6);
                class AnnotationEditor11 {
                    #altText = "";
                    #altTextDecorative = false;
                    #altTextButton = null;
                    #altTextTooltip = null;
                    #altTextTooltipTimeout = null;
                    #keepAspectRatio = false;
                    #resizersDiv = null;
                    #boundFocusin = this.focusin.bind(this);
                    #boundFocusout = this.focusout.bind(this);
                    #hasBeenClicked = false;
                    #isEditing = false;
                    #isInEditMode = false;
                    _initialOptions = Object.create(null);
                    _uiManager = null;
                    _focusEventsAllowed = true;
                    _l10nPromise = null;
                    #isDraggable = false;
                    #zIndex = AnnotationEditor11._zIndex++;
                    static _borderLineWidth = -1;
                    static _colorManager = new _tools11.ColorManager();
                    static _zIndex = 1;
                    static SMALL_EDITOR_SIZE = 0;
                    constructor(parameters11){
                        if (this.constructor === AnnotationEditor11) (0, _util11.unreachable)("Cannot initialize AnnotationEditor.");
                        this.parent = parameters11.parent;
                        this.id = parameters11.id;
                        this.width = this.height = null;
                        this.pageIndex = parameters11.parent.pageIndex;
                        this.name = parameters11.name;
                        this.div = null;
                        this._uiManager = parameters11.uiManager;
                        this.annotationElementId = null;
                        this._willKeepAspectRatio = false;
                        this._initialOptions.isCentered = parameters11.isCentered;
                        this._structTreeParentId = null;
                        const { rotation: rotation11, rawDims: { pageWidth: pageWidth11, pageHeight: pageHeight11, pageX: pageX11, pageY: pageY11 } } = this.parent.viewport;
                        this.rotation = rotation11;
                        this.pageRotation = (360 + rotation11 - this._uiManager.viewParameters.rotation) % 360;
                        this.pageDimensions = [
                            pageWidth11,
                            pageHeight11
                        ];
                        this.pageTranslation = [
                            pageX11,
                            pageY11
                        ];
                        const [width21, height11] = this.parentDimensions;
                        this.x = parameters11.x / width21;
                        this.y = parameters11.y / height11;
                        this.isAttachedToDOM = false;
                        this.deleted = false;
                    }
                    get editorType() {
                        return Object.getPrototypeOf(this).constructor._type;
                    }
                    static get _defaultLineColor() {
                        return (0, _util11.shadow)(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
                    }
                    static deleteAnnotationElement(editor11) {
                        const fakeEditor11 = new FakeEditor11({
                            id: editor11.parent.getNextId(),
                            parent: editor11.parent,
                            uiManager: editor11._uiManager
                        });
                        fakeEditor11.annotationElementId = editor11.annotationElementId;
                        fakeEditor11.deleted = true;
                        fakeEditor11._uiManager.addToAnnotationStorage(fakeEditor11);
                    }
                    static initialize(l10n11, options11 = null) {
                        AnnotationEditor11._l10nPromise ||= new Map([
                            "editor_alt_text_button_label",
                            "editor_alt_text_edit_button_label",
                            "editor_alt_text_decorative_tooltip"
                        ].map((str11)=>[
                                str11,
                                l10n11.get(str11)
                            ]));
                        if (options11?.strings) for (const str11 of options11.strings)AnnotationEditor11._l10nPromise.set(str11, l10n11.get(str11));
                        if (AnnotationEditor11._borderLineWidth !== -1) return;
                        const style11 = getComputedStyle(document.documentElement);
                        AnnotationEditor11._borderLineWidth = parseFloat(style11.getPropertyValue("--outline-width")) || 0;
                    }
                    static updateDefaultParams(_type11, _value11) {}
                    static get defaultPropertiesToUpdate() {
                        return [];
                    }
                    static isHandlingMimeForPasting(mime11) {
                        return false;
                    }
                    static paste(item11, parent11) {
                        (0, _util11.unreachable)("Not implemented");
                    }
                    get propertiesToUpdate() {
                        return [];
                    }
                    get _isDraggable() {
                        return this.#isDraggable;
                    }
                    set _isDraggable(value11) {
                        this.#isDraggable = value11;
                        this.div?.classList.toggle("draggable", value11);
                    }
                    center() {
                        const [pageWidth11, pageHeight11] = this.pageDimensions;
                        switch(this.parentRotation){
                            case 90:
                                this.x -= this.height * pageHeight11 / (pageWidth11 * 2);
                                this.y += this.width * pageWidth11 / (pageHeight11 * 2);
                                break;
                            case 180:
                                this.x += this.width / 2;
                                this.y += this.height / 2;
                                break;
                            case 270:
                                this.x += this.height * pageHeight11 / (pageWidth11 * 2);
                                this.y -= this.width * pageWidth11 / (pageHeight11 * 2);
                                break;
                            default:
                                this.x -= this.width / 2;
                                this.y -= this.height / 2;
                                break;
                        }
                        this.fixAndSetPosition();
                    }
                    addCommands(params11) {
                        this._uiManager.addCommands(params11);
                    }
                    get currentLayer() {
                        return this._uiManager.currentLayer;
                    }
                    setInBackground() {
                        this.div.style.zIndex = 0;
                    }
                    setInForeground() {
                        this.div.style.zIndex = this.#zIndex;
                    }
                    setParent(parent11) {
                        if (parent11 !== null) {
                            this.pageIndex = parent11.pageIndex;
                            this.pageDimensions = parent11.pageDimensions;
                        }
                        this.parent = parent11;
                    }
                    focusin(event11) {
                        if (!this._focusEventsAllowed) return;
                        if (!this.#hasBeenClicked) this.parent.setSelected(this);
                        else this.#hasBeenClicked = false;
                    }
                    focusout(event11) {
                        if (!this._focusEventsAllowed) return;
                        if (!this.isAttachedToDOM) return;
                        const target11 = event11.relatedTarget;
                        if (target11?.closest(`#${this.id}`)) return;
                        event11.preventDefault();
                        if (!this.parent?.isMultipleSelection) this.commitOrRemove();
                    }
                    commitOrRemove() {
                        if (this.isEmpty()) this.remove();
                        else this.commit();
                    }
                    commit() {
                        this.addToAnnotationStorage();
                    }
                    addToAnnotationStorage() {
                        this._uiManager.addToAnnotationStorage(this);
                    }
                    setAt(x41, y41, tx21, ty21) {
                        const [width21, height11] = this.parentDimensions;
                        [tx21, ty21] = this.screenToPageTranslation(tx21, ty21);
                        this.x = (x41 + tx21) / width21;
                        this.y = (y41 + ty21) / height11;
                        this.fixAndSetPosition();
                    }
                    #translate([width21, height11], x41, y41) {
                        [x41, y41] = this.screenToPageTranslation(x41, y41);
                        this.x += x41 / width21;
                        this.y += y41 / height11;
                        this.fixAndSetPosition();
                    }
                    translate(x41, y41) {
                        this.#translate(this.parentDimensions, x41, y41);
                    }
                    translateInPage(x41, y41) {
                        this.#translate(this.pageDimensions, x41, y41);
                        this.div.scrollIntoView({
                            block: "nearest"
                        });
                    }
                    drag(tx21, ty21) {
                        const [parentWidth11, parentHeight11] = this.parentDimensions;
                        this.x += tx21 / parentWidth11;
                        this.y += ty21 / parentHeight11;
                        if (this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
                            const { x: x41, y: y41 } = this.div.getBoundingClientRect();
                            if (this.parent.findNewParent(this, x41, y41)) {
                                this.x -= Math.floor(this.x);
                                this.y -= Math.floor(this.y);
                            }
                        }
                        let { x: x41, y: y41 } = this;
                        const [bx11, by11] = this.#getBaseTranslation();
                        x41 += bx11;
                        y41 += by11;
                        this.div.style.left = `${(100 * x41).toFixed(2)}%`;
                        this.div.style.top = `${(100 * y41).toFixed(2)}%`;
                        this.div.scrollIntoView({
                            block: "nearest"
                        });
                    }
                    #getBaseTranslation() {
                        const [parentWidth11, parentHeight11] = this.parentDimensions;
                        const { _borderLineWidth: _borderLineWidth11 } = AnnotationEditor11;
                        const x41 = _borderLineWidth11 / parentWidth11;
                        const y41 = _borderLineWidth11 / parentHeight11;
                        switch(this.rotation){
                            case 90:
                                return [
                                    -x41,
                                    y41
                                ];
                            case 180:
                                return [
                                    x41,
                                    y41
                                ];
                            case 270:
                                return [
                                    x41,
                                    -y41
                                ];
                            default:
                                return [
                                    -x41,
                                    -y41
                                ];
                        }
                    }
                    fixAndSetPosition() {
                        const [pageWidth11, pageHeight11] = this.pageDimensions;
                        let { x: x41, y: y41, width: width21, height: height11 } = this;
                        width21 *= pageWidth11;
                        height11 *= pageHeight11;
                        x41 *= pageWidth11;
                        y41 *= pageHeight11;
                        switch(this.rotation){
                            case 0:
                                x41 = Math.max(0, Math.min(pageWidth11 - width21, x41));
                                y41 = Math.max(0, Math.min(pageHeight11 - height11, y41));
                                break;
                            case 90:
                                x41 = Math.max(0, Math.min(pageWidth11 - height11, x41));
                                y41 = Math.min(pageHeight11, Math.max(width21, y41));
                                break;
                            case 180:
                                x41 = Math.min(pageWidth11, Math.max(width21, x41));
                                y41 = Math.min(pageHeight11, Math.max(height11, y41));
                                break;
                            case 270:
                                x41 = Math.min(pageWidth11, Math.max(height11, x41));
                                y41 = Math.max(0, Math.min(pageHeight11 - width21, y41));
                                break;
                        }
                        this.x = x41 /= pageWidth11;
                        this.y = y41 /= pageHeight11;
                        const [bx11, by11] = this.#getBaseTranslation();
                        x41 += bx11;
                        y41 += by11;
                        const { style: style11 } = this.div;
                        style11.left = `${(100 * x41).toFixed(2)}%`;
                        style11.top = `${(100 * y41).toFixed(2)}%`;
                        this.moveInDOM();
                    }
                    static #rotatePoint(x41, y41, angle11) {
                        switch(angle11){
                            case 90:
                                return [
                                    y41,
                                    -x41
                                ];
                            case 180:
                                return [
                                    -x41,
                                    -y41
                                ];
                            case 270:
                                return [
                                    -y41,
                                    x41
                                ];
                            default:
                                return [
                                    x41,
                                    y41
                                ];
                        }
                    }
                    screenToPageTranslation(x41, y41) {
                        return AnnotationEditor11.#rotatePoint(x41, y41, this.parentRotation);
                    }
                    pageTranslationToScreen(x41, y41) {
                        return AnnotationEditor11.#rotatePoint(x41, y41, 360 - this.parentRotation);
                    }
                    #getRotationMatrix(rotation11) {
                        switch(rotation11){
                            case 90:
                                {
                                    const [pageWidth11, pageHeight11] = this.pageDimensions;
                                    return [
                                        0,
                                        -pageWidth11 / pageHeight11,
                                        pageHeight11 / pageWidth11,
                                        0
                                    ];
                                }
                            case 180:
                                return [
                                    -1,
                                    0,
                                    0,
                                    -1
                                ];
                            case 270:
                                {
                                    const [pageWidth11, pageHeight11] = this.pageDimensions;
                                    return [
                                        0,
                                        pageWidth11 / pageHeight11,
                                        -pageHeight11 / pageWidth11,
                                        0
                                    ];
                                }
                            default:
                                return [
                                    1,
                                    0,
                                    0,
                                    1
                                ];
                        }
                    }
                    get parentScale() {
                        return this._uiManager.viewParameters.realScale;
                    }
                    get parentRotation() {
                        return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
                    }
                    get parentDimensions() {
                        const { parentScale: parentScale11, pageDimensions: [pageWidth11, pageHeight11] } = this;
                        const scaledWidth11 = pageWidth11 * parentScale11;
                        const scaledHeight11 = pageHeight11 * parentScale11;
                        return _util11.FeatureTest.isCSSRoundSupported ? [
                            Math.round(scaledWidth11),
                            Math.round(scaledHeight11)
                        ] : [
                            scaledWidth11,
                            scaledHeight11
                        ];
                    }
                    setDims(width21, height11) {
                        const [parentWidth11, parentHeight11] = this.parentDimensions;
                        this.div.style.width = `${(100 * width21 / parentWidth11).toFixed(2)}%`;
                        if (!this.#keepAspectRatio) this.div.style.height = `${(100 * height11 / parentHeight11).toFixed(2)}%`;
                        this.#altTextButton?.classList.toggle("small", width21 < AnnotationEditor11.SMALL_EDITOR_SIZE || height11 < AnnotationEditor11.SMALL_EDITOR_SIZE);
                    }
                    fixDims() {
                        const { style: style11 } = this.div;
                        const { height: height11, width: width21 } = style11;
                        const widthPercent11 = width21.endsWith("%");
                        const heightPercent11 = !this.#keepAspectRatio && height11.endsWith("%");
                        if (widthPercent11 && heightPercent11) return;
                        const [parentWidth11, parentHeight11] = this.parentDimensions;
                        if (!widthPercent11) style11.width = `${(100 * parseFloat(width21) / parentWidth11).toFixed(2)}%`;
                        if (!this.#keepAspectRatio && !heightPercent11) style11.height = `${(100 * parseFloat(height11) / parentHeight11).toFixed(2)}%`;
                    }
                    getInitialTranslation() {
                        return [
                            0,
                            0
                        ];
                    }
                    #createResizers() {
                        if (this.#resizersDiv) return;
                        this.#resizersDiv = document.createElement("div");
                        this.#resizersDiv.classList.add("resizers");
                        const classes11 = [
                            "topLeft",
                            "topRight",
                            "bottomRight",
                            "bottomLeft"
                        ];
                        if (!this._willKeepAspectRatio) classes11.push("topMiddle", "middleRight", "bottomMiddle", "middleLeft");
                        for (const name11 of classes11){
                            const div11 = document.createElement("div");
                            this.#resizersDiv.append(div11);
                            div11.classList.add("resizer", name11);
                            div11.addEventListener("pointerdown", this.#resizerPointerdown.bind(this, name11));
                            div11.addEventListener("contextmenu", _display_utils11.noContextMenu);
                        }
                        this.div.prepend(this.#resizersDiv);
                    }
                    #resizerPointerdown(name11, event11) {
                        event11.preventDefault();
                        const { isMac: isMac11 } = _util11.FeatureTest.platform;
                        if (event11.button !== 0 || event11.ctrlKey && isMac11) return;
                        const boundResizerPointermove11 = this.#resizerPointermove.bind(this, name11);
                        const savedDraggable11 = this._isDraggable;
                        this._isDraggable = false;
                        const pointerMoveOptions11 = {
                            passive: true,
                            capture: true
                        };
                        window.addEventListener("pointermove", boundResizerPointermove11, pointerMoveOptions11);
                        const savedX11 = this.x;
                        const savedY11 = this.y;
                        const savedWidth11 = this.width;
                        const savedHeight11 = this.height;
                        const savedParentCursor11 = this.parent.div.style.cursor;
                        const savedCursor11 = this.div.style.cursor;
                        this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(event11.target).cursor;
                        const pointerUpCallback11 = ()=>{
                            this._isDraggable = savedDraggable11;
                            window.removeEventListener("pointerup", pointerUpCallback11);
                            window.removeEventListener("blur", pointerUpCallback11);
                            window.removeEventListener("pointermove", boundResizerPointermove11, pointerMoveOptions11);
                            this.parent.div.style.cursor = savedParentCursor11;
                            this.div.style.cursor = savedCursor11;
                            const newX11 = this.x;
                            const newY11 = this.y;
                            const newWidth11 = this.width;
                            const newHeight11 = this.height;
                            if (newX11 === savedX11 && newY11 === savedY11 && newWidth11 === savedWidth11 && newHeight11 === savedHeight11) return;
                            this.addCommands({
                                cmd: ()=>{
                                    this.width = newWidth11;
                                    this.height = newHeight11;
                                    this.x = newX11;
                                    this.y = newY11;
                                    const [parentWidth11, parentHeight11] = this.parentDimensions;
                                    this.setDims(parentWidth11 * newWidth11, parentHeight11 * newHeight11);
                                    this.fixAndSetPosition();
                                },
                                undo: ()=>{
                                    this.width = savedWidth11;
                                    this.height = savedHeight11;
                                    this.x = savedX11;
                                    this.y = savedY11;
                                    const [parentWidth11, parentHeight11] = this.parentDimensions;
                                    this.setDims(parentWidth11 * savedWidth11, parentHeight11 * savedHeight11);
                                    this.fixAndSetPosition();
                                },
                                mustExec: true
                            });
                        };
                        window.addEventListener("pointerup", pointerUpCallback11);
                        window.addEventListener("blur", pointerUpCallback11);
                    }
                    #resizerPointermove(name11, event11) {
                        const [parentWidth11, parentHeight11] = this.parentDimensions;
                        const savedX11 = this.x;
                        const savedY11 = this.y;
                        const savedWidth11 = this.width;
                        const savedHeight11 = this.height;
                        const minWidth11 = AnnotationEditor11.MIN_SIZE / parentWidth11;
                        const minHeight11 = AnnotationEditor11.MIN_SIZE / parentHeight11;
                        const round11 = (x41)=>Math.round(x41 * 10000) / 10000;
                        const rotationMatrix11 = this.#getRotationMatrix(this.rotation);
                        const transf11 = (x41, y41)=>[
                                rotationMatrix11[0] * x41 + rotationMatrix11[2] * y41,
                                rotationMatrix11[1] * x41 + rotationMatrix11[3] * y41
                            ];
                        const invRotationMatrix11 = this.#getRotationMatrix(360 - this.rotation);
                        const invTransf11 = (x41, y41)=>[
                                invRotationMatrix11[0] * x41 + invRotationMatrix11[2] * y41,
                                invRotationMatrix11[1] * x41 + invRotationMatrix11[3] * y41
                            ];
                        let getPoint11;
                        let getOpposite11;
                        let isDiagonal11 = false;
                        let isHorizontal11 = false;
                        switch(name11){
                            case "topLeft":
                                isDiagonal11 = true;
                                getPoint11 = (w11, h31)=>[
                                        0,
                                        0
                                    ];
                                getOpposite11 = (w11, h31)=>[
                                        w11,
                                        h31
                                    ];
                                break;
                            case "topMiddle":
                                getPoint11 = (w11, h31)=>[
                                        w11 / 2,
                                        0
                                    ];
                                getOpposite11 = (w11, h31)=>[
                                        w11 / 2,
                                        h31
                                    ];
                                break;
                            case "topRight":
                                isDiagonal11 = true;
                                getPoint11 = (w11, h31)=>[
                                        w11,
                                        0
                                    ];
                                getOpposite11 = (w11, h31)=>[
                                        0,
                                        h31
                                    ];
                                break;
                            case "middleRight":
                                isHorizontal11 = true;
                                getPoint11 = (w11, h31)=>[
                                        w11,
                                        h31 / 2
                                    ];
                                getOpposite11 = (w11, h31)=>[
                                        0,
                                        h31 / 2
                                    ];
                                break;
                            case "bottomRight":
                                isDiagonal11 = true;
                                getPoint11 = (w11, h31)=>[
                                        w11,
                                        h31
                                    ];
                                getOpposite11 = (w11, h31)=>[
                                        0,
                                        0
                                    ];
                                break;
                            case "bottomMiddle":
                                getPoint11 = (w11, h31)=>[
                                        w11 / 2,
                                        h31
                                    ];
                                getOpposite11 = (w11, h31)=>[
                                        w11 / 2,
                                        0
                                    ];
                                break;
                            case "bottomLeft":
                                isDiagonal11 = true;
                                getPoint11 = (w11, h31)=>[
                                        0,
                                        h31
                                    ];
                                getOpposite11 = (w11, h31)=>[
                                        w11,
                                        0
                                    ];
                                break;
                            case "middleLeft":
                                isHorizontal11 = true;
                                getPoint11 = (w11, h31)=>[
                                        0,
                                        h31 / 2
                                    ];
                                getOpposite11 = (w11, h31)=>[
                                        w11,
                                        h31 / 2
                                    ];
                                break;
                        }
                        const point21 = getPoint11(savedWidth11, savedHeight11);
                        const oppositePoint11 = getOpposite11(savedWidth11, savedHeight11);
                        let transfOppositePoint11 = transf11(...oppositePoint11);
                        const oppositeX11 = round11(savedX11 + transfOppositePoint11[0]);
                        const oppositeY11 = round11(savedY11 + transfOppositePoint11[1]);
                        let ratioX11 = 1;
                        let ratioY11 = 1;
                        let [deltaX11, deltaY11] = this.screenToPageTranslation(event11.movementX, event11.movementY);
                        [deltaX11, deltaY11] = invTransf11(deltaX11 / parentWidth11, deltaY11 / parentHeight11);
                        if (isDiagonal11) {
                            const oldDiag11 = Math.hypot(savedWidth11, savedHeight11);
                            ratioX11 = ratioY11 = Math.max(Math.min(Math.hypot(oppositePoint11[0] - point21[0] - deltaX11, oppositePoint11[1] - point21[1] - deltaY11) / oldDiag11, 1 / savedWidth11, 1 / savedHeight11), minWidth11 / savedWidth11, minHeight11 / savedHeight11);
                        } else if (isHorizontal11) ratioX11 = Math.max(minWidth11, Math.min(1, Math.abs(oppositePoint11[0] - point21[0] - deltaX11))) / savedWidth11;
                        else ratioY11 = Math.max(minHeight11, Math.min(1, Math.abs(oppositePoint11[1] - point21[1] - deltaY11))) / savedHeight11;
                        const newWidth11 = round11(savedWidth11 * ratioX11);
                        const newHeight11 = round11(savedHeight11 * ratioY11);
                        transfOppositePoint11 = transf11(...getOpposite11(newWidth11, newHeight11));
                        const newX11 = oppositeX11 - transfOppositePoint11[0];
                        const newY11 = oppositeY11 - transfOppositePoint11[1];
                        this.width = newWidth11;
                        this.height = newHeight11;
                        this.x = newX11;
                        this.y = newY11;
                        this.setDims(parentWidth11 * newWidth11, parentHeight11 * newHeight11);
                        this.fixAndSetPosition();
                    }
                    async addAltTextButton() {
                        if (this.#altTextButton) return;
                        const altText11 = this.#altTextButton = document.createElement("button");
                        altText11.className = "altText";
                        const msg11 = await AnnotationEditor11._l10nPromise.get("editor_alt_text_button_label");
                        altText11.textContent = msg11;
                        altText11.setAttribute("aria-label", msg11);
                        altText11.tabIndex = "0";
                        altText11.addEventListener("contextmenu", _display_utils11.noContextMenu);
                        altText11.addEventListener("pointerdown", (event11)=>event11.stopPropagation());
                        altText11.addEventListener("click", (event11)=>{
                            event11.preventDefault();
                            this._uiManager.editAltText(this);
                        }, {
                            capture: true
                        });
                        altText11.addEventListener("keydown", (event11)=>{
                            if (event11.target === altText11 && event11.key === "Enter") {
                                event11.preventDefault();
                                this._uiManager.editAltText(this);
                            }
                        });
                        this.#setAltTextButtonState();
                        this.div.append(altText11);
                        if (!AnnotationEditor11.SMALL_EDITOR_SIZE) {
                            const PERCENT11 = 40;
                            AnnotationEditor11.SMALL_EDITOR_SIZE = Math.min(128, Math.round(altText11.getBoundingClientRect().width * (1 + PERCENT11 / 100)));
                        }
                    }
                    async #setAltTextButtonState() {
                        const button11 = this.#altTextButton;
                        if (!button11) return;
                        if (!this.#altText && !this.#altTextDecorative) {
                            button11.classList.remove("done");
                            this.#altTextTooltip?.remove();
                            return;
                        }
                        AnnotationEditor11._l10nPromise.get("editor_alt_text_edit_button_label").then((msg11)=>{
                            button11.setAttribute("aria-label", msg11);
                        });
                        let tooltip11 = this.#altTextTooltip;
                        if (!tooltip11) {
                            this.#altTextTooltip = tooltip11 = document.createElement("span");
                            tooltip11.className = "tooltip";
                            tooltip11.setAttribute("role", "tooltip");
                            const id11 = tooltip11.id = `alt-text-tooltip-${this.id}`;
                            button11.setAttribute("aria-describedby", id11);
                            const DELAY_TO_SHOW_TOOLTIP11 = 100;
                            button11.addEventListener("mouseenter", ()=>{
                                this.#altTextTooltipTimeout = setTimeout(()=>{
                                    this.#altTextTooltipTimeout = null;
                                    this.#altTextTooltip.classList.add("show");
                                    this._uiManager._eventBus.dispatch("reporttelemetry", {
                                        source: this,
                                        details: {
                                            type: "editing",
                                            subtype: this.editorType,
                                            data: {
                                                action: "alt_text_tooltip"
                                            }
                                        }
                                    });
                                }, DELAY_TO_SHOW_TOOLTIP11);
                            });
                            button11.addEventListener("mouseleave", ()=>{
                                clearTimeout(this.#altTextTooltipTimeout);
                                this.#altTextTooltipTimeout = null;
                                this.#altTextTooltip?.classList.remove("show");
                            });
                        }
                        button11.classList.add("done");
                        tooltip11.innerText = this.#altTextDecorative ? await AnnotationEditor11._l10nPromise.get("editor_alt_text_decorative_tooltip") : this.#altText;
                        if (!tooltip11.parentNode) button11.append(tooltip11);
                    }
                    getClientDimensions() {
                        return this.div.getBoundingClientRect();
                    }
                    get altTextData() {
                        return {
                            altText: this.#altText,
                            decorative: this.#altTextDecorative
                        };
                    }
                    set altTextData({ altText: altText11, decorative: decorative11 }) {
                        if (this.#altText === altText11 && this.#altTextDecorative === decorative11) return;
                        this.#altText = altText11;
                        this.#altTextDecorative = decorative11;
                        this.#setAltTextButtonState();
                    }
                    render() {
                        this.div = document.createElement("div");
                        this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
                        this.div.className = this.name;
                        this.div.setAttribute("id", this.id);
                        this.div.setAttribute("tabIndex", 0);
                        this.setInForeground();
                        this.div.addEventListener("focusin", this.#boundFocusin);
                        this.div.addEventListener("focusout", this.#boundFocusout);
                        const [parentWidth11, parentHeight11] = this.parentDimensions;
                        if (this.parentRotation % 180 !== 0) {
                            this.div.style.maxWidth = `${(100 * parentHeight11 / parentWidth11).toFixed(2)}%`;
                            this.div.style.maxHeight = `${(100 * parentWidth11 / parentHeight11).toFixed(2)}%`;
                        }
                        const [tx21, ty21] = this.getInitialTranslation();
                        this.translate(tx21, ty21);
                        (0, _tools11.bindEvents)(this, this.div, [
                            "pointerdown"
                        ]);
                        return this.div;
                    }
                    pointerdown(event11) {
                        const { isMac: isMac11 } = _util11.FeatureTest.platform;
                        if (event11.button !== 0 || event11.ctrlKey && isMac11) {
                            event11.preventDefault();
                            return;
                        }
                        this.#hasBeenClicked = true;
                        this.#setUpDragSession(event11);
                    }
                    #setUpDragSession(event11) {
                        if (!this._isDraggable) return;
                        const isSelected11 = this._uiManager.isSelected(this);
                        this._uiManager.setUpDragSession();
                        let pointerMoveOptions11, pointerMoveCallback11;
                        if (isSelected11) {
                            pointerMoveOptions11 = {
                                passive: true,
                                capture: true
                            };
                            pointerMoveCallback11 = (e11)=>{
                                const [tx21, ty21] = this.screenToPageTranslation(e11.movementX, e11.movementY);
                                this._uiManager.dragSelectedEditors(tx21, ty21);
                            };
                            window.addEventListener("pointermove", pointerMoveCallback11, pointerMoveOptions11);
                        }
                        const pointerUpCallback11 = ()=>{
                            window.removeEventListener("pointerup", pointerUpCallback11);
                            window.removeEventListener("blur", pointerUpCallback11);
                            if (isSelected11) window.removeEventListener("pointermove", pointerMoveCallback11, pointerMoveOptions11);
                            this.#hasBeenClicked = false;
                            if (!this._uiManager.endDragSession()) {
                                const { isMac: isMac11 } = _util11.FeatureTest.platform;
                                if (event11.ctrlKey && !isMac11 || event11.shiftKey || event11.metaKey && isMac11) this.parent.toggleSelected(this);
                                else this.parent.setSelected(this);
                            }
                        };
                        window.addEventListener("pointerup", pointerUpCallback11);
                        window.addEventListener("blur", pointerUpCallback11);
                    }
                    moveInDOM() {
                        this.parent?.moveEditorInDOM(this);
                    }
                    _setParentAndPosition(parent11, x41, y41) {
                        parent11.changeParent(this);
                        this.x = x41;
                        this.y = y41;
                        this.fixAndSetPosition();
                    }
                    getRect(tx21, ty21) {
                        const scale11 = this.parentScale;
                        const [pageWidth11, pageHeight11] = this.pageDimensions;
                        const [pageX11, pageY11] = this.pageTranslation;
                        const shiftX11 = tx21 / scale11;
                        const shiftY11 = ty21 / scale11;
                        const x41 = this.x * pageWidth11;
                        const y41 = this.y * pageHeight11;
                        const width21 = this.width * pageWidth11;
                        const height11 = this.height * pageHeight11;
                        switch(this.rotation){
                            case 0:
                                return [
                                    x41 + shiftX11 + pageX11,
                                    pageHeight11 - y41 - shiftY11 - height11 + pageY11,
                                    x41 + shiftX11 + width21 + pageX11,
                                    pageHeight11 - y41 - shiftY11 + pageY11
                                ];
                            case 90:
                                return [
                                    x41 + shiftY11 + pageX11,
                                    pageHeight11 - y41 + shiftX11 + pageY11,
                                    x41 + shiftY11 + height11 + pageX11,
                                    pageHeight11 - y41 + shiftX11 + width21 + pageY11
                                ];
                            case 180:
                                return [
                                    x41 - shiftX11 - width21 + pageX11,
                                    pageHeight11 - y41 + shiftY11 + pageY11,
                                    x41 - shiftX11 + pageX11,
                                    pageHeight11 - y41 + shiftY11 + height11 + pageY11
                                ];
                            case 270:
                                return [
                                    x41 - shiftY11 - height11 + pageX11,
                                    pageHeight11 - y41 - shiftX11 - width21 + pageY11,
                                    x41 - shiftY11 + pageX11,
                                    pageHeight11 - y41 - shiftX11 + pageY11
                                ];
                            default:
                                throw new Error("Invalid rotation");
                        }
                    }
                    getRectInCurrentCoords(rect31, pageHeight11) {
                        const [x111, y111, x211, y211] = rect31;
                        const width21 = x211 - x111;
                        const height11 = y211 - y111;
                        switch(this.rotation){
                            case 0:
                                return [
                                    x111,
                                    pageHeight11 - y211,
                                    width21,
                                    height11
                                ];
                            case 90:
                                return [
                                    x111,
                                    pageHeight11 - y111,
                                    height11,
                                    width21
                                ];
                            case 180:
                                return [
                                    x211,
                                    pageHeight11 - y111,
                                    width21,
                                    height11
                                ];
                            case 270:
                                return [
                                    x211,
                                    pageHeight11 - y211,
                                    height11,
                                    width21
                                ];
                            default:
                                throw new Error("Invalid rotation");
                        }
                    }
                    onceAdded() {}
                    isEmpty() {
                        return false;
                    }
                    enableEditMode() {
                        this.#isInEditMode = true;
                    }
                    disableEditMode() {
                        this.#isInEditMode = false;
                    }
                    isInEditMode() {
                        return this.#isInEditMode;
                    }
                    shouldGetKeyboardEvents() {
                        return false;
                    }
                    needsToBeRebuilt() {
                        return this.div && !this.isAttachedToDOM;
                    }
                    rebuild() {
                        this.div?.addEventListener("focusin", this.#boundFocusin);
                        this.div?.addEventListener("focusout", this.#boundFocusout);
                    }
                    serialize(isForCopying11 = false, context11 = null) {
                        (0, _util11.unreachable)("An editor must be serializable");
                    }
                    static deserialize(data11, parent11, uiManager11) {
                        const editor11 = new this.prototype.constructor({
                            parent: parent11,
                            id: parent11.getNextId(),
                            uiManager: uiManager11
                        });
                        editor11.rotation = data11.rotation;
                        const [pageWidth11, pageHeight11] = editor11.pageDimensions;
                        const [x41, y41, width21, height11] = editor11.getRectInCurrentCoords(data11.rect, pageHeight11);
                        editor11.x = x41 / pageWidth11;
                        editor11.y = y41 / pageHeight11;
                        editor11.width = width21 / pageWidth11;
                        editor11.height = height11 / pageHeight11;
                        return editor11;
                    }
                    remove() {
                        this.div.removeEventListener("focusin", this.#boundFocusin);
                        this.div.removeEventListener("focusout", this.#boundFocusout);
                        if (!this.isEmpty()) this.commit();
                        if (this.parent) this.parent.remove(this);
                        else this._uiManager.removeEditor(this);
                        this.#altTextButton?.remove();
                        this.#altTextButton = null;
                        this.#altTextTooltip = null;
                    }
                    get isResizable() {
                        return false;
                    }
                    makeResizable() {
                        if (this.isResizable) {
                            this.#createResizers();
                            this.#resizersDiv.classList.remove("hidden");
                        }
                    }
                    select() {
                        this.makeResizable();
                        this.div?.classList.add("selectedEditor");
                    }
                    unselect() {
                        this.#resizersDiv?.classList.add("hidden");
                        this.div?.classList.remove("selectedEditor");
                        if (this.div?.contains(document.activeElement)) this._uiManager.currentLayer.div.focus();
                    }
                    updateParams(type11, value11) {}
                    disableEditing() {
                        if (this.#altTextButton) this.#altTextButton.hidden = true;
                    }
                    enableEditing() {
                        if (this.#altTextButton) this.#altTextButton.hidden = false;
                    }
                    enterInEditMode() {}
                    get contentDiv() {
                        return this.div;
                    }
                    get isEditing() {
                        return this.#isEditing;
                    }
                    set isEditing(value11) {
                        this.#isEditing = value11;
                        if (!this.parent) return;
                        if (value11) {
                            this.parent.setSelected(this);
                            this.parent.setActiveEditor(this);
                        } else this.parent.setActiveEditor(null);
                    }
                    setAspectRatio(width21, height11) {
                        this.#keepAspectRatio = true;
                        const aspectRatio11 = width21 / height11;
                        const { style: style11 } = this.div;
                        style11.aspectRatio = aspectRatio11;
                        style11.height = "auto";
                    }
                    static get MIN_SIZE() {
                        return 16;
                    }
                }
                exports11.AnnotationEditor = AnnotationEditor11;
                class FakeEditor11 extends AnnotationEditor11 {
                    constructor(params11){
                        super(params11);
                        this.annotationElementId = params11.annotationElementId;
                        this.deleted = true;
                    }
                    serialize() {
                        return {
                            id: this.annotationElementId,
                            deleted: true,
                            pageIndex: this.pageIndex
                        };
                    }
                }
            /***/ },
            /* 5 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.KeyboardManager = exports11.CommandManager = exports11.ColorManager = exports11.AnnotationEditorUIManager = void 0;
                exports11.bindEvents = bindEvents11;
                exports11.opacityToHex = opacityToHex11;
                var _util11 = __w_pdfjs_require__11(1);
                var _display_utils11 = __w_pdfjs_require__11(6);
                function bindEvents11(obj11, element11, names11) {
                    for (const name11 of names11)element11.addEventListener(name11, obj11[name11].bind(obj11));
                }
                function opacityToHex11(opacity11) {
                    return Math.round(Math.min(255, Math.max(1, 255 * opacity11))).toString(16).padStart(2, "0");
                }
                class IdManager11 {
                    #id = 0;
                    getId() {
                        return `${_util11.AnnotationEditorPrefix}${this.#id++}`;
                    }
                }
                class ImageManager11 {
                    #baseId = (0, _util11.getUuid)();
                    #id = 0;
                    #cache = null;
                    static get _isSVGFittingCanvas() {
                        const svg11 = `data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>`;
                        const canvas11 = new OffscreenCanvas(1, 3);
                        const ctx11 = canvas11.getContext("2d");
                        const image11 = new Image();
                        image11.src = svg11;
                        const promise11 = image11.decode().then(()=>{
                            ctx11.drawImage(image11, 0, 0, 1, 1, 0, 0, 1, 3);
                            return new Uint32Array(ctx11.getImageData(0, 0, 1, 1).data.buffer)[0] === 0;
                        });
                        return (0, _util11.shadow)(this, "_isSVGFittingCanvas", promise11);
                    }
                    async #get(key11, rawData11) {
                        this.#cache ||= new Map();
                        let data11 = this.#cache.get(key11);
                        if (data11 === null) return null;
                        if (data11?.bitmap) {
                            data11.refCounter += 1;
                            return data11;
                        }
                        try {
                            data11 ||= {
                                bitmap: null,
                                id: `image_${this.#baseId}_${this.#id++}`,
                                refCounter: 0,
                                isSvg: false
                            };
                            let image11;
                            if (typeof rawData11 === "string") {
                                data11.url = rawData11;
                                const response11 = await fetch(rawData11);
                                if (!response11.ok) throw new Error(response11.statusText);
                                image11 = await response11.blob();
                            } else image11 = data11.file = rawData11;
                            if (image11.type === "image/svg+xml") {
                                const mustRemoveAspectRatioPromise11 = ImageManager11._isSVGFittingCanvas;
                                const fileReader11 = new FileReader();
                                const imageElement11 = new Image();
                                const imagePromise11 = new Promise((resolve11, reject11)=>{
                                    imageElement11.onload = ()=>{
                                        data11.bitmap = imageElement11;
                                        data11.isSvg = true;
                                        resolve11();
                                    };
                                    fileReader11.onload = async ()=>{
                                        const url11 = data11.svgUrl = fileReader11.result;
                                        imageElement11.src = await mustRemoveAspectRatioPromise11 ? `${url11}#svgView(preserveAspectRatio(none))` : url11;
                                    };
                                    imageElement11.onerror = fileReader11.onerror = reject11;
                                });
                                fileReader11.readAsDataURL(image11);
                                await imagePromise11;
                            } else data11.bitmap = await createImageBitmap(image11);
                            data11.refCounter = 1;
                        } catch (e11) {
                            console.error(e11);
                            data11 = null;
                        }
                        this.#cache.set(key11, data11);
                        if (data11) this.#cache.set(data11.id, data11);
                        return data11;
                    }
                    async getFromFile(file11) {
                        const { lastModified: lastModified11, name: name11, size: size11, type: type11 } = file11;
                        return this.#get(`${lastModified11}_${name11}_${size11}_${type11}`, file11);
                    }
                    async getFromUrl(url11) {
                        return this.#get(url11, url11);
                    }
                    async getFromId(id11) {
                        this.#cache ||= new Map();
                        const data11 = this.#cache.get(id11);
                        if (!data11) return null;
                        if (data11.bitmap) {
                            data11.refCounter += 1;
                            return data11;
                        }
                        if (data11.file) return this.getFromFile(data11.file);
                        return this.getFromUrl(data11.url);
                    }
                    getSvgUrl(id11) {
                        const data11 = this.#cache.get(id11);
                        if (!data11?.isSvg) return null;
                        return data11.svgUrl;
                    }
                    deleteId(id11) {
                        this.#cache ||= new Map();
                        const data11 = this.#cache.get(id11);
                        if (!data11) return;
                        data11.refCounter -= 1;
                        if (data11.refCounter !== 0) return;
                        data11.bitmap = null;
                    }
                    isValidId(id11) {
                        return id11.startsWith(`image_${this.#baseId}_`);
                    }
                }
                class CommandManager11 {
                    #commands = [];
                    #locked = false;
                    #maxSize;
                    #position = -1;
                    constructor(maxSize11 = 128){
                        this.#maxSize = maxSize11;
                    }
                    add({ cmd: cmd11, undo: undo11, mustExec: mustExec11, type: type11 = NaN, overwriteIfSameType: overwriteIfSameType11 = false, keepUndo: keepUndo11 = false }) {
                        if (mustExec11) cmd11();
                        if (this.#locked) return;
                        const save11 = {
                            cmd: cmd11,
                            undo: undo11,
                            type: type11
                        };
                        if (this.#position === -1) {
                            if (this.#commands.length > 0) this.#commands.length = 0;
                            this.#position = 0;
                            this.#commands.push(save11);
                            return;
                        }
                        if (overwriteIfSameType11 && this.#commands[this.#position].type === type11) {
                            if (keepUndo11) save11.undo = this.#commands[this.#position].undo;
                            this.#commands[this.#position] = save11;
                            return;
                        }
                        const next11 = this.#position + 1;
                        if (next11 === this.#maxSize) this.#commands.splice(0, 1);
                        else {
                            this.#position = next11;
                            if (next11 < this.#commands.length) this.#commands.splice(next11);
                        }
                        this.#commands.push(save11);
                    }
                    undo() {
                        if (this.#position === -1) return;
                        this.#locked = true;
                        this.#commands[this.#position].undo();
                        this.#locked = false;
                        this.#position -= 1;
                    }
                    redo() {
                        if (this.#position < this.#commands.length - 1) {
                            this.#position += 1;
                            this.#locked = true;
                            this.#commands[this.#position].cmd();
                            this.#locked = false;
                        }
                    }
                    hasSomethingToUndo() {
                        return this.#position !== -1;
                    }
                    hasSomethingToRedo() {
                        return this.#position < this.#commands.length - 1;
                    }
                    destroy() {
                        this.#commands = null;
                    }
                }
                exports11.CommandManager = CommandManager11;
                class KeyboardManager11 {
                    constructor(callbacks11){
                        this.buffer = [];
                        this.callbacks = new Map();
                        this.allKeys = new Set();
                        const { isMac: isMac11 } = _util11.FeatureTest.platform;
                        for (const [keys11, callback11, options11 = {}] of callbacks11)for (const key11 of keys11){
                            const isMacKey11 = key11.startsWith("mac+");
                            if (isMac11 && isMacKey11) {
                                this.callbacks.set(key11.slice(4), {
                                    callback: callback11,
                                    options: options11
                                });
                                this.allKeys.add(key11.split("+").at(-1));
                            } else if (!isMac11 && !isMacKey11) {
                                this.callbacks.set(key11, {
                                    callback: callback11,
                                    options: options11
                                });
                                this.allKeys.add(key11.split("+").at(-1));
                            }
                        }
                    }
                    #serialize(event11) {
                        if (event11.altKey) this.buffer.push("alt");
                        if (event11.ctrlKey) this.buffer.push("ctrl");
                        if (event11.metaKey) this.buffer.push("meta");
                        if (event11.shiftKey) this.buffer.push("shift");
                        this.buffer.push(event11.key);
                        const str11 = this.buffer.join("+");
                        this.buffer.length = 0;
                        return str11;
                    }
                    exec(self11, event11) {
                        if (!this.allKeys.has(event11.key)) return;
                        const info11 = this.callbacks.get(this.#serialize(event11));
                        if (!info11) return;
                        const { callback: callback11, options: { bubbles: bubbles11 = false, args: args11 = [], checker: checker11 = null } } = info11;
                        if (checker11 && !checker11(self11, event11)) return;
                        callback11.bind(self11, ...args11)();
                        if (!bubbles11) {
                            event11.stopPropagation();
                            event11.preventDefault();
                        }
                    }
                }
                exports11.KeyboardManager = KeyboardManager11;
                class ColorManager11 {
                    static _colorsMapping = new Map([
                        [
                            "CanvasText",
                            [
                                0,
                                0,
                                0
                            ]
                        ],
                        [
                            "Canvas",
                            [
                                255,
                                255,
                                255
                            ]
                        ]
                    ]);
                    get _colors() {
                        const colors11 = new Map([
                            [
                                "CanvasText",
                                null
                            ],
                            [
                                "Canvas",
                                null
                            ]
                        ]);
                        (0, _display_utils11.getColorValues)(colors11);
                        return (0, _util11.shadow)(this, "_colors", colors11);
                    }
                    convert(color11) {
                        const rgb11 = (0, _display_utils11.getRGB)(color11);
                        if (!window.matchMedia("(forced-colors: active)").matches) return rgb11;
                        for (const [name11, RGB11] of this._colors){
                            if (RGB11.every((x41, i11)=>x41 === rgb11[i11])) return ColorManager11._colorsMapping.get(name11);
                        }
                        return rgb11;
                    }
                    getHexCode(name11) {
                        const rgb11 = this._colors.get(name11);
                        if (!rgb11) return name11;
                        return _util11.Util.makeHexColor(...rgb11);
                    }
                }
                exports11.ColorManager = ColorManager11;
                class AnnotationEditorUIManager11 {
                    #activeEditor = null;
                    #allEditors = new Map();
                    #allLayers = new Map();
                    #altTextManager = null;
                    #annotationStorage = null;
                    #commandManager = new CommandManager11();
                    #currentPageIndex = 0;
                    #deletedAnnotationsElementIds = new Set();
                    #draggingEditors = null;
                    #editorTypes = null;
                    #editorsToRescale = new Set();
                    #filterFactory = null;
                    #idManager = new IdManager11();
                    #isEnabled = false;
                    #isWaiting = false;
                    #lastActiveElement = null;
                    #mode = _util11.AnnotationEditorType.NONE;
                    #selectedEditors = new Set();
                    #pageColors = null;
                    #boundBlur = this.blur.bind(this);
                    #boundFocus = this.focus.bind(this);
                    #boundCopy = this.copy.bind(this);
                    #boundCut = this.cut.bind(this);
                    #boundPaste = this.paste.bind(this);
                    #boundKeydown = this.keydown.bind(this);
                    #boundOnEditingAction = this.onEditingAction.bind(this);
                    #boundOnPageChanging = this.onPageChanging.bind(this);
                    #boundOnScaleChanging = this.onScaleChanging.bind(this);
                    #boundOnRotationChanging = this.onRotationChanging.bind(this);
                    #previousStates = {
                        isEditing: false,
                        isEmpty: true,
                        hasSomethingToUndo: false,
                        hasSomethingToRedo: false,
                        hasSelectedEditor: false
                    };
                    #translation = [
                        0,
                        0
                    ];
                    #translationTimeoutId = null;
                    #container = null;
                    #viewer = null;
                    static TRANSLATE_SMALL = 1;
                    static TRANSLATE_BIG = 10;
                    static get _keyboardManager() {
                        const proto11 = AnnotationEditorUIManager11.prototype;
                        const arrowChecker11 = (self11)=>{
                            const { activeElement: activeElement11 } = document;
                            return activeElement11 && self11.#container.contains(activeElement11) && self11.hasSomethingToControl();
                        };
                        const small11 = this.TRANSLATE_SMALL;
                        const big11 = this.TRANSLATE_BIG;
                        return (0, _util11.shadow)(this, "_keyboardManager", new KeyboardManager11([
                            [
                                [
                                    "ctrl+a",
                                    "mac+meta+a"
                                ],
                                proto11.selectAll
                            ],
                            [
                                [
                                    "ctrl+z",
                                    "mac+meta+z"
                                ],
                                proto11.undo
                            ],
                            [
                                [
                                    "ctrl+y",
                                    "ctrl+shift+z",
                                    "mac+meta+shift+z",
                                    "ctrl+shift+Z",
                                    "mac+meta+shift+Z"
                                ],
                                proto11.redo
                            ],
                            [
                                [
                                    "Backspace",
                                    "alt+Backspace",
                                    "ctrl+Backspace",
                                    "shift+Backspace",
                                    "mac+Backspace",
                                    "mac+alt+Backspace",
                                    "mac+ctrl+Backspace",
                                    "Delete",
                                    "ctrl+Delete",
                                    "shift+Delete",
                                    "mac+Delete"
                                ],
                                proto11.delete
                            ],
                            [
                                [
                                    "Escape",
                                    "mac+Escape"
                                ],
                                proto11.unselectAll
                            ],
                            [
                                [
                                    "ArrowLeft",
                                    "mac+ArrowLeft"
                                ],
                                proto11.translateSelectedEditors,
                                {
                                    args: [
                                        -small11,
                                        0
                                    ],
                                    checker: arrowChecker11
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowLeft",
                                    "mac+shift+ArrowLeft"
                                ],
                                proto11.translateSelectedEditors,
                                {
                                    args: [
                                        -big11,
                                        0
                                    ],
                                    checker: arrowChecker11
                                }
                            ],
                            [
                                [
                                    "ArrowRight",
                                    "mac+ArrowRight"
                                ],
                                proto11.translateSelectedEditors,
                                {
                                    args: [
                                        small11,
                                        0
                                    ],
                                    checker: arrowChecker11
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowRight",
                                    "mac+shift+ArrowRight"
                                ],
                                proto11.translateSelectedEditors,
                                {
                                    args: [
                                        big11,
                                        0
                                    ],
                                    checker: arrowChecker11
                                }
                            ],
                            [
                                [
                                    "ArrowUp",
                                    "mac+ArrowUp"
                                ],
                                proto11.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        -small11
                                    ],
                                    checker: arrowChecker11
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowUp",
                                    "mac+shift+ArrowUp"
                                ],
                                proto11.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        -big11
                                    ],
                                    checker: arrowChecker11
                                }
                            ],
                            [
                                [
                                    "ArrowDown",
                                    "mac+ArrowDown"
                                ],
                                proto11.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        small11
                                    ],
                                    checker: arrowChecker11
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowDown",
                                    "mac+shift+ArrowDown"
                                ],
                                proto11.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        big11
                                    ],
                                    checker: arrowChecker11
                                }
                            ]
                        ]));
                    }
                    constructor(container11, viewer11, altTextManager11, eventBus11, pdfDocument11, pageColors11){
                        this.#container = container11;
                        this.#viewer = viewer11;
                        this.#altTextManager = altTextManager11;
                        this._eventBus = eventBus11;
                        this._eventBus._on("editingaction", this.#boundOnEditingAction);
                        this._eventBus._on("pagechanging", this.#boundOnPageChanging);
                        this._eventBus._on("scalechanging", this.#boundOnScaleChanging);
                        this._eventBus._on("rotationchanging", this.#boundOnRotationChanging);
                        this.#annotationStorage = pdfDocument11.annotationStorage;
                        this.#filterFactory = pdfDocument11.filterFactory;
                        this.#pageColors = pageColors11;
                        this.viewParameters = {
                            realScale: _display_utils11.PixelsPerInch.PDF_TO_CSS_UNITS,
                            rotation: 0
                        };
                    }
                    destroy() {
                        this.#removeKeyboardManager();
                        this.#removeFocusManager();
                        this._eventBus._off("editingaction", this.#boundOnEditingAction);
                        this._eventBus._off("pagechanging", this.#boundOnPageChanging);
                        this._eventBus._off("scalechanging", this.#boundOnScaleChanging);
                        this._eventBus._off("rotationchanging", this.#boundOnRotationChanging);
                        for (const layer11 of this.#allLayers.values())layer11.destroy();
                        this.#allLayers.clear();
                        this.#allEditors.clear();
                        this.#editorsToRescale.clear();
                        this.#activeEditor = null;
                        this.#selectedEditors.clear();
                        this.#commandManager.destroy();
                        this.#altTextManager.destroy();
                    }
                    get hcmFilter() {
                        return (0, _util11.shadow)(this, "hcmFilter", this.#pageColors ? this.#filterFactory.addHCMFilter(this.#pageColors.foreground, this.#pageColors.background) : "none");
                    }
                    get direction() {
                        return (0, _util11.shadow)(this, "direction", getComputedStyle(this.#container).direction);
                    }
                    editAltText(editor11) {
                        this.#altTextManager?.editAltText(this, editor11);
                    }
                    onPageChanging({ pageNumber: pageNumber11 }) {
                        this.#currentPageIndex = pageNumber11 - 1;
                    }
                    focusMainContainer() {
                        this.#container.focus();
                    }
                    findParent(x41, y41) {
                        for (const layer11 of this.#allLayers.values()){
                            const { x: layerX11, y: layerY11, width: width21, height: height11 } = layer11.div.getBoundingClientRect();
                            if (x41 >= layerX11 && x41 <= layerX11 + width21 && y41 >= layerY11 && y41 <= layerY11 + height11) return layer11;
                        }
                        return null;
                    }
                    disableUserSelect(value11 = false) {
                        this.#viewer.classList.toggle("noUserSelect", value11);
                    }
                    addShouldRescale(editor11) {
                        this.#editorsToRescale.add(editor11);
                    }
                    removeShouldRescale(editor11) {
                        this.#editorsToRescale.delete(editor11);
                    }
                    onScaleChanging({ scale: scale11 }) {
                        this.commitOrRemove();
                        this.viewParameters.realScale = scale11 * _display_utils11.PixelsPerInch.PDF_TO_CSS_UNITS;
                        for (const editor11 of this.#editorsToRescale)editor11.onScaleChanging();
                    }
                    onRotationChanging({ pagesRotation: pagesRotation11 }) {
                        this.commitOrRemove();
                        this.viewParameters.rotation = pagesRotation11;
                    }
                    addToAnnotationStorage(editor11) {
                        if (!editor11.isEmpty() && this.#annotationStorage && !this.#annotationStorage.has(editor11.id)) this.#annotationStorage.setValue(editor11.id, editor11);
                    }
                    #addFocusManager() {
                        window.addEventListener("focus", this.#boundFocus);
                        window.addEventListener("blur", this.#boundBlur);
                    }
                    #removeFocusManager() {
                        window.removeEventListener("focus", this.#boundFocus);
                        window.removeEventListener("blur", this.#boundBlur);
                    }
                    blur() {
                        if (!this.hasSelection) return;
                        const { activeElement: activeElement11 } = document;
                        for (const editor11 of this.#selectedEditors)if (editor11.div.contains(activeElement11)) {
                            this.#lastActiveElement = [
                                editor11,
                                activeElement11
                            ];
                            editor11._focusEventsAllowed = false;
                            break;
                        }
                    }
                    focus() {
                        if (!this.#lastActiveElement) return;
                        const [lastEditor11, lastActiveElement11] = this.#lastActiveElement;
                        this.#lastActiveElement = null;
                        lastActiveElement11.addEventListener("focusin", ()=>{
                            lastEditor11._focusEventsAllowed = true;
                        }, {
                            once: true
                        });
                        lastActiveElement11.focus();
                    }
                    #addKeyboardManager() {
                        window.addEventListener("keydown", this.#boundKeydown, {
                            capture: true
                        });
                    }
                    #removeKeyboardManager() {
                        window.removeEventListener("keydown", this.#boundKeydown, {
                            capture: true
                        });
                    }
                    #addCopyPasteListeners() {
                        document.addEventListener("copy", this.#boundCopy);
                        document.addEventListener("cut", this.#boundCut);
                        document.addEventListener("paste", this.#boundPaste);
                    }
                    #removeCopyPasteListeners() {
                        document.removeEventListener("copy", this.#boundCopy);
                        document.removeEventListener("cut", this.#boundCut);
                        document.removeEventListener("paste", this.#boundPaste);
                    }
                    addEditListeners() {
                        this.#addKeyboardManager();
                        this.#addCopyPasteListeners();
                    }
                    removeEditListeners() {
                        this.#removeKeyboardManager();
                        this.#removeCopyPasteListeners();
                    }
                    copy(event11) {
                        event11.preventDefault();
                        this.#activeEditor?.commitOrRemove();
                        if (!this.hasSelection) return;
                        const editors11 = [];
                        for (const editor11 of this.#selectedEditors){
                            const serialized11 = editor11.serialize(true);
                            if (serialized11) editors11.push(serialized11);
                        }
                        if (editors11.length === 0) return;
                        event11.clipboardData.setData("application/pdfjs", JSON.stringify(editors11));
                    }
                    cut(event11) {
                        this.copy(event11);
                        this.delete();
                    }
                    paste(event11) {
                        event11.preventDefault();
                        const { clipboardData: clipboardData11 } = event11;
                        for (const item11 of clipboardData11.items){
                            for (const editorType11 of this.#editorTypes)if (editorType11.isHandlingMimeForPasting(item11.type)) {
                                editorType11.paste(item11, this.currentLayer);
                                return;
                            }
                        }
                        let data11 = clipboardData11.getData("application/pdfjs");
                        if (!data11) return;
                        try {
                            data11 = JSON.parse(data11);
                        } catch (ex11) {
                            (0, _util11.warn)(`paste: "${ex11.message}".`);
                            return;
                        }
                        if (!Array.isArray(data11)) return;
                        this.unselectAll();
                        const layer11 = this.currentLayer;
                        try {
                            const newEditors11 = [];
                            for (const editor11 of data11){
                                const deserializedEditor11 = layer11.deserialize(editor11);
                                if (!deserializedEditor11) return;
                                newEditors11.push(deserializedEditor11);
                            }
                            const cmd11 = ()=>{
                                for (const editor11 of newEditors11)this.#addEditorToLayer(editor11);
                                this.#selectEditors(newEditors11);
                            };
                            const undo11 = ()=>{
                                for (const editor11 of newEditors11)editor11.remove();
                            };
                            this.addCommands({
                                cmd: cmd11,
                                undo: undo11,
                                mustExec: true
                            });
                        } catch (ex11) {
                            (0, _util11.warn)(`paste: "${ex11.message}".`);
                        }
                    }
                    keydown(event11) {
                        if (!this.getActive()?.shouldGetKeyboardEvents()) AnnotationEditorUIManager11._keyboardManager.exec(this, event11);
                    }
                    onEditingAction(details11) {
                        if ([
                            "undo",
                            "redo",
                            "delete",
                            "selectAll"
                        ].includes(details11.name)) this[details11.name]();
                    }
                    #dispatchUpdateStates(details11) {
                        const hasChanged11 = Object.entries(details11).some(([key11, value11])=>this.#previousStates[key11] !== value11);
                        if (hasChanged11) this._eventBus.dispatch("annotationeditorstateschanged", {
                            source: this,
                            details: Object.assign(this.#previousStates, details11)
                        });
                    }
                    #dispatchUpdateUI(details11) {
                        this._eventBus.dispatch("annotationeditorparamschanged", {
                            source: this,
                            details: details11
                        });
                    }
                    setEditingState(isEditing11) {
                        if (isEditing11) {
                            this.#addFocusManager();
                            this.#addKeyboardManager();
                            this.#addCopyPasteListeners();
                            this.#dispatchUpdateStates({
                                isEditing: this.#mode !== _util11.AnnotationEditorType.NONE,
                                isEmpty: this.#isEmpty(),
                                hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
                                hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
                                hasSelectedEditor: false
                            });
                        } else {
                            this.#removeFocusManager();
                            this.#removeKeyboardManager();
                            this.#removeCopyPasteListeners();
                            this.#dispatchUpdateStates({
                                isEditing: false
                            });
                            this.disableUserSelect(false);
                        }
                    }
                    registerEditorTypes(types11) {
                        if (this.#editorTypes) return;
                        this.#editorTypes = types11;
                        for (const editorType11 of this.#editorTypes)this.#dispatchUpdateUI(editorType11.defaultPropertiesToUpdate);
                    }
                    getId() {
                        return this.#idManager.getId();
                    }
                    get currentLayer() {
                        return this.#allLayers.get(this.#currentPageIndex);
                    }
                    getLayer(pageIndex11) {
                        return this.#allLayers.get(pageIndex11);
                    }
                    get currentPageIndex() {
                        return this.#currentPageIndex;
                    }
                    addLayer(layer11) {
                        this.#allLayers.set(layer11.pageIndex, layer11);
                        if (this.#isEnabled) layer11.enable();
                        else layer11.disable();
                    }
                    removeLayer(layer11) {
                        this.#allLayers.delete(layer11.pageIndex);
                    }
                    updateMode(mode11, editId11 = null) {
                        if (this.#mode === mode11) return;
                        this.#mode = mode11;
                        if (mode11 === _util11.AnnotationEditorType.NONE) {
                            this.setEditingState(false);
                            this.#disableAll();
                            return;
                        }
                        this.setEditingState(true);
                        this.#enableAll();
                        this.unselectAll();
                        for (const layer11 of this.#allLayers.values())layer11.updateMode(mode11);
                        if (!editId11) return;
                        for (const editor11 of this.#allEditors.values())if (editor11.annotationElementId === editId11) {
                            this.setSelected(editor11);
                            editor11.enterInEditMode();
                            break;
                        }
                    }
                    updateToolbar(mode11) {
                        if (mode11 === this.#mode) return;
                        this._eventBus.dispatch("switchannotationeditormode", {
                            source: this,
                            mode: mode11
                        });
                    }
                    updateParams(type11, value11) {
                        if (!this.#editorTypes) return;
                        if (type11 === _util11.AnnotationEditorParamsType.CREATE) {
                            this.currentLayer.addNewEditor(type11);
                            return;
                        }
                        for (const editor11 of this.#selectedEditors)editor11.updateParams(type11, value11);
                        for (const editorType11 of this.#editorTypes)editorType11.updateDefaultParams(type11, value11);
                    }
                    enableWaiting(mustWait11 = false) {
                        if (this.#isWaiting === mustWait11) return;
                        this.#isWaiting = mustWait11;
                        for (const layer11 of this.#allLayers.values()){
                            if (mustWait11) layer11.disableClick();
                            else layer11.enableClick();
                            layer11.div.classList.toggle("waiting", mustWait11);
                        }
                    }
                    #enableAll() {
                        if (!this.#isEnabled) {
                            this.#isEnabled = true;
                            for (const layer11 of this.#allLayers.values())layer11.enable();
                        }
                    }
                    #disableAll() {
                        this.unselectAll();
                        if (this.#isEnabled) {
                            this.#isEnabled = false;
                            for (const layer11 of this.#allLayers.values())layer11.disable();
                        }
                    }
                    getEditors(pageIndex11) {
                        const editors11 = [];
                        for (const editor11 of this.#allEditors.values())if (editor11.pageIndex === pageIndex11) editors11.push(editor11);
                        return editors11;
                    }
                    getEditor(id11) {
                        return this.#allEditors.get(id11);
                    }
                    addEditor(editor11) {
                        this.#allEditors.set(editor11.id, editor11);
                    }
                    removeEditor(editor11) {
                        this.#allEditors.delete(editor11.id);
                        this.unselect(editor11);
                        if (!editor11.annotationElementId || !this.#deletedAnnotationsElementIds.has(editor11.annotationElementId)) this.#annotationStorage?.remove(editor11.id);
                    }
                    addDeletedAnnotationElement(editor11) {
                        this.#deletedAnnotationsElementIds.add(editor11.annotationElementId);
                        editor11.deleted = true;
                    }
                    isDeletedAnnotationElement(annotationElementId11) {
                        return this.#deletedAnnotationsElementIds.has(annotationElementId11);
                    }
                    removeDeletedAnnotationElement(editor11) {
                        this.#deletedAnnotationsElementIds.delete(editor11.annotationElementId);
                        editor11.deleted = false;
                    }
                    #addEditorToLayer(editor11) {
                        const layer11 = this.#allLayers.get(editor11.pageIndex);
                        if (layer11) layer11.addOrRebuild(editor11);
                        else this.addEditor(editor11);
                    }
                    setActiveEditor(editor11) {
                        if (this.#activeEditor === editor11) return;
                        this.#activeEditor = editor11;
                        if (editor11) this.#dispatchUpdateUI(editor11.propertiesToUpdate);
                    }
                    toggleSelected(editor11) {
                        if (this.#selectedEditors.has(editor11)) {
                            this.#selectedEditors.delete(editor11);
                            editor11.unselect();
                            this.#dispatchUpdateStates({
                                hasSelectedEditor: this.hasSelection
                            });
                            return;
                        }
                        this.#selectedEditors.add(editor11);
                        editor11.select();
                        this.#dispatchUpdateUI(editor11.propertiesToUpdate);
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: true
                        });
                    }
                    setSelected(editor11) {
                        for (const ed11 of this.#selectedEditors)if (ed11 !== editor11) ed11.unselect();
                        this.#selectedEditors.clear();
                        this.#selectedEditors.add(editor11);
                        editor11.select();
                        this.#dispatchUpdateUI(editor11.propertiesToUpdate);
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: true
                        });
                    }
                    isSelected(editor11) {
                        return this.#selectedEditors.has(editor11);
                    }
                    unselect(editor11) {
                        editor11.unselect();
                        this.#selectedEditors.delete(editor11);
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: this.hasSelection
                        });
                    }
                    get hasSelection() {
                        return this.#selectedEditors.size !== 0;
                    }
                    undo() {
                        this.#commandManager.undo();
                        this.#dispatchUpdateStates({
                            hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
                            hasSomethingToRedo: true,
                            isEmpty: this.#isEmpty()
                        });
                    }
                    redo() {
                        this.#commandManager.redo();
                        this.#dispatchUpdateStates({
                            hasSomethingToUndo: true,
                            hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
                            isEmpty: this.#isEmpty()
                        });
                    }
                    addCommands(params11) {
                        this.#commandManager.add(params11);
                        this.#dispatchUpdateStates({
                            hasSomethingToUndo: true,
                            hasSomethingToRedo: false,
                            isEmpty: this.#isEmpty()
                        });
                    }
                    #isEmpty() {
                        if (this.#allEditors.size === 0) return true;
                        if (this.#allEditors.size === 1) {
                            for (const editor11 of this.#allEditors.values())return editor11.isEmpty();
                        }
                        return false;
                    }
                    delete() {
                        this.commitOrRemove();
                        if (!this.hasSelection) return;
                        const editors11 = [
                            ...this.#selectedEditors
                        ];
                        const cmd11 = ()=>{
                            for (const editor11 of editors11)editor11.remove();
                        };
                        const undo11 = ()=>{
                            for (const editor11 of editors11)this.#addEditorToLayer(editor11);
                        };
                        this.addCommands({
                            cmd: cmd11,
                            undo: undo11,
                            mustExec: true
                        });
                    }
                    commitOrRemove() {
                        this.#activeEditor?.commitOrRemove();
                    }
                    hasSomethingToControl() {
                        return this.#activeEditor || this.hasSelection;
                    }
                    #selectEditors(editors11) {
                        this.#selectedEditors.clear();
                        for (const editor11 of editors11){
                            if (editor11.isEmpty()) continue;
                            this.#selectedEditors.add(editor11);
                            editor11.select();
                        }
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: true
                        });
                    }
                    selectAll() {
                        for (const editor11 of this.#selectedEditors)editor11.commit();
                        this.#selectEditors(this.#allEditors.values());
                    }
                    unselectAll() {
                        if (this.#activeEditor) {
                            this.#activeEditor.commitOrRemove();
                            return;
                        }
                        if (!this.hasSelection) return;
                        for (const editor11 of this.#selectedEditors)editor11.unselect();
                        this.#selectedEditors.clear();
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: false
                        });
                    }
                    translateSelectedEditors(x41, y41, noCommit11 = false) {
                        if (!noCommit11) this.commitOrRemove();
                        if (!this.hasSelection) return;
                        this.#translation[0] += x41;
                        this.#translation[1] += y41;
                        const [totalX11, totalY11] = this.#translation;
                        const editors11 = [
                            ...this.#selectedEditors
                        ];
                        const TIME_TO_WAIT11 = 1000;
                        if (this.#translationTimeoutId) clearTimeout(this.#translationTimeoutId);
                        this.#translationTimeoutId = setTimeout(()=>{
                            this.#translationTimeoutId = null;
                            this.#translation[0] = this.#translation[1] = 0;
                            this.addCommands({
                                cmd: ()=>{
                                    for (const editor11 of editors11)if (this.#allEditors.has(editor11.id)) editor11.translateInPage(totalX11, totalY11);
                                },
                                undo: ()=>{
                                    for (const editor11 of editors11)if (this.#allEditors.has(editor11.id)) editor11.translateInPage(-totalX11, -totalY11);
                                },
                                mustExec: false
                            });
                        }, TIME_TO_WAIT11);
                        for (const editor11 of editors11)editor11.translateInPage(x41, y41);
                    }
                    setUpDragSession() {
                        if (!this.hasSelection) return;
                        this.disableUserSelect(true);
                        this.#draggingEditors = new Map();
                        for (const editor11 of this.#selectedEditors)this.#draggingEditors.set(editor11, {
                            savedX: editor11.x,
                            savedY: editor11.y,
                            savedPageIndex: editor11.pageIndex,
                            newX: 0,
                            newY: 0,
                            newPageIndex: -1
                        });
                    }
                    endDragSession() {
                        if (!this.#draggingEditors) return false;
                        this.disableUserSelect(false);
                        const map11 = this.#draggingEditors;
                        this.#draggingEditors = null;
                        let mustBeAddedInUndoStack11 = false;
                        for (const [{ x: x41, y: y41, pageIndex: pageIndex11 }, value11] of map11){
                            value11.newX = x41;
                            value11.newY = y41;
                            value11.newPageIndex = pageIndex11;
                            mustBeAddedInUndoStack11 ||= x41 !== value11.savedX || y41 !== value11.savedY || pageIndex11 !== value11.savedPageIndex;
                        }
                        if (!mustBeAddedInUndoStack11) return false;
                        const move11 = (editor11, x41, y41, pageIndex11)=>{
                            if (this.#allEditors.has(editor11.id)) {
                                const parent11 = this.#allLayers.get(pageIndex11);
                                if (parent11) editor11._setParentAndPosition(parent11, x41, y41);
                                else {
                                    editor11.pageIndex = pageIndex11;
                                    editor11.x = x41;
                                    editor11.y = y41;
                                }
                            }
                        };
                        this.addCommands({
                            cmd: ()=>{
                                for (const [editor11, { newX: newX11, newY: newY11, newPageIndex: newPageIndex11 }] of map11)move11(editor11, newX11, newY11, newPageIndex11);
                            },
                            undo: ()=>{
                                for (const [editor11, { savedX: savedX11, savedY: savedY11, savedPageIndex: savedPageIndex11 }] of map11)move11(editor11, savedX11, savedY11, savedPageIndex11);
                            },
                            mustExec: true
                        });
                        return true;
                    }
                    dragSelectedEditors(tx21, ty21) {
                        if (!this.#draggingEditors) return;
                        for (const editor11 of this.#draggingEditors.keys())editor11.drag(tx21, ty21);
                    }
                    rebuild(editor11) {
                        if (editor11.parent === null) {
                            const parent11 = this.getLayer(editor11.pageIndex);
                            if (parent11) {
                                parent11.changeParent(editor11);
                                parent11.addOrRebuild(editor11);
                            } else {
                                this.addEditor(editor11);
                                this.addToAnnotationStorage(editor11);
                                editor11.rebuild();
                            }
                        } else editor11.parent.addOrRebuild(editor11);
                    }
                    isActive(editor11) {
                        return this.#activeEditor === editor11;
                    }
                    getActive() {
                        return this.#activeEditor;
                    }
                    getMode() {
                        return this.#mode;
                    }
                    get imageManager() {
                        return (0, _util11.shadow)(this, "imageManager", new ImageManager11());
                    }
                }
                exports11.AnnotationEditorUIManager = AnnotationEditorUIManager11;
            /***/ },
            /* 6 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.StatTimer = exports11.RenderingCancelledException = exports11.PixelsPerInch = exports11.PageViewport = exports11.PDFDateString = exports11.DOMStandardFontDataFactory = exports11.DOMSVGFactory = exports11.DOMFilterFactory = exports11.DOMCanvasFactory = exports11.DOMCMapReaderFactory = void 0;
                exports11.deprecated = deprecated11;
                exports11.getColorValues = getColorValues11;
                exports11.getCurrentTransform = getCurrentTransform11;
                exports11.getCurrentTransformInverse = getCurrentTransformInverse11;
                exports11.getFilenameFromUrl = getFilenameFromUrl11;
                exports11.getPdfFilenameFromUrl = getPdfFilenameFromUrl11;
                exports11.getRGB = getRGB11;
                exports11.getXfaPageViewport = getXfaPageViewport11;
                exports11.isDataScheme = isDataScheme11;
                exports11.isPdfFile = isPdfFile11;
                exports11.isValidFetchUrl = isValidFetchUrl11;
                exports11.loadScript = loadScript11;
                exports11.noContextMenu = noContextMenu11;
                exports11.setLayerDimensions = setLayerDimensions11;
                var _base_factory11 = __w_pdfjs_require__11(7);
                var _util11 = __w_pdfjs_require__11(1);
                const SVG_NS11 = "http://www.w3.org/2000/svg";
                class PixelsPerInch11 {
                    static CSS = 96.0;
                    static PDF = 72.0;
                    static PDF_TO_CSS_UNITS = this.CSS / this.PDF;
                }
                exports11.PixelsPerInch = PixelsPerInch11;
                class DOMFilterFactory11 extends _base_factory11.BaseFilterFactory {
                    #_cache;
                    #_defs;
                    #docId;
                    #document;
                    #hcmFilter;
                    #hcmKey;
                    #hcmUrl;
                    #hcmHighlightFilter;
                    #hcmHighlightKey;
                    #hcmHighlightUrl;
                    #id = 0;
                    constructor({ docId: docId11, ownerDocument: ownerDocument11 = globalThis.document } = {}){
                        super();
                        this.#docId = docId11;
                        this.#document = ownerDocument11;
                    }
                    get #cache() {
                        return this.#_cache ||= new Map();
                    }
                    get #defs() {
                        if (!this.#_defs) {
                            const div11 = this.#document.createElement("div");
                            const { style: style11 } = div11;
                            style11.visibility = "hidden";
                            style11.contain = "strict";
                            style11.width = style11.height = 0;
                            style11.position = "absolute";
                            style11.top = style11.left = 0;
                            style11.zIndex = -1;
                            const svg11 = this.#document.createElementNS(SVG_NS11, "svg");
                            svg11.setAttribute("width", 0);
                            svg11.setAttribute("height", 0);
                            this.#_defs = this.#document.createElementNS(SVG_NS11, "defs");
                            div11.append(svg11);
                            svg11.append(this.#_defs);
                            this.#document.body.append(div11);
                        }
                        return this.#_defs;
                    }
                    addFilter(maps11) {
                        if (!maps11) return "none";
                        let value11 = this.#cache.get(maps11);
                        if (value11) return value11;
                        let tableR11, tableG11, tableB11, key11;
                        if (maps11.length === 1) {
                            const mapR11 = maps11[0];
                            const buffer11 = new Array(256);
                            for(let i11 = 0; i11 < 256; i11++)buffer11[i11] = mapR11[i11] / 255;
                            key11 = tableR11 = tableG11 = tableB11 = buffer11.join(",");
                        } else {
                            const [mapR11, mapG11, mapB11] = maps11;
                            const bufferR11 = new Array(256);
                            const bufferG11 = new Array(256);
                            const bufferB11 = new Array(256);
                            for(let i11 = 0; i11 < 256; i11++){
                                bufferR11[i11] = mapR11[i11] / 255;
                                bufferG11[i11] = mapG11[i11] / 255;
                                bufferB11[i11] = mapB11[i11] / 255;
                            }
                            tableR11 = bufferR11.join(",");
                            tableG11 = bufferG11.join(",");
                            tableB11 = bufferB11.join(",");
                            key11 = `${tableR11}${tableG11}${tableB11}`;
                        }
                        value11 = this.#cache.get(key11);
                        if (value11) {
                            this.#cache.set(maps11, value11);
                            return value11;
                        }
                        const id11 = `g_${this.#docId}_transfer_map_${this.#id++}`;
                        const url11 = `url(#${id11})`;
                        this.#cache.set(maps11, url11);
                        this.#cache.set(key11, url11);
                        const filter11 = this.#createFilter(id11);
                        this.#addTransferMapConversion(tableR11, tableG11, tableB11, filter11);
                        return url11;
                    }
                    addHCMFilter(fgColor11, bgColor11) {
                        const key11 = `${fgColor11}-${bgColor11}`;
                        if (this.#hcmKey === key11) return this.#hcmUrl;
                        this.#hcmKey = key11;
                        this.#hcmUrl = "none";
                        this.#hcmFilter?.remove();
                        if (!fgColor11 || !bgColor11) return this.#hcmUrl;
                        const fgRGB11 = this.#getRGB(fgColor11);
                        fgColor11 = _util11.Util.makeHexColor(...fgRGB11);
                        const bgRGB11 = this.#getRGB(bgColor11);
                        bgColor11 = _util11.Util.makeHexColor(...bgRGB11);
                        this.#defs.style.color = "";
                        if (fgColor11 === "#000000" && bgColor11 === "#ffffff" || fgColor11 === bgColor11) return this.#hcmUrl;
                        const map11 = new Array(256);
                        for(let i11 = 0; i11 <= 255; i11++){
                            const x41 = i11 / 255;
                            map11[i11] = x41 <= 0.03928 ? x41 / 12.92 : ((x41 + 0.055) / 1.055) ** 2.4;
                        }
                        const table11 = map11.join(",");
                        const id11 = `g_${this.#docId}_hcm_filter`;
                        const filter11 = this.#hcmHighlightFilter = this.#createFilter(id11);
                        this.#addTransferMapConversion(table11, table11, table11, filter11);
                        this.#addGrayConversion(filter11);
                        const getSteps11 = (c41, n11)=>{
                            const start11 = fgRGB11[c41] / 255;
                            const end11 = bgRGB11[c41] / 255;
                            const arr31 = new Array(n11 + 1);
                            for(let i11 = 0; i11 <= n11; i11++)arr31[i11] = start11 + i11 / n11 * (end11 - start11);
                            return arr31.join(",");
                        };
                        this.#addTransferMapConversion(getSteps11(0, 5), getSteps11(1, 5), getSteps11(2, 5), filter11);
                        this.#hcmUrl = `url(#${id11})`;
                        return this.#hcmUrl;
                    }
                    addHighlightHCMFilter(fgColor11, bgColor11, newFgColor11, newBgColor11) {
                        const key11 = `${fgColor11}-${bgColor11}-${newFgColor11}-${newBgColor11}`;
                        if (this.#hcmHighlightKey === key11) return this.#hcmHighlightUrl;
                        this.#hcmHighlightKey = key11;
                        this.#hcmHighlightUrl = "none";
                        this.#hcmHighlightFilter?.remove();
                        if (!fgColor11 || !bgColor11) return this.#hcmHighlightUrl;
                        const [fgRGB11, bgRGB11] = [
                            fgColor11,
                            bgColor11
                        ].map(this.#getRGB.bind(this));
                        let fgGray11 = Math.round(0.2126 * fgRGB11[0] + 0.7152 * fgRGB11[1] + 0.0722 * fgRGB11[2]);
                        let bgGray11 = Math.round(0.2126 * bgRGB11[0] + 0.7152 * bgRGB11[1] + 0.0722 * bgRGB11[2]);
                        let [newFgRGB11, newBgRGB11] = [
                            newFgColor11,
                            newBgColor11
                        ].map(this.#getRGB.bind(this));
                        if (bgGray11 < fgGray11) [fgGray11, bgGray11, newFgRGB11, newBgRGB11] = [
                            bgGray11,
                            fgGray11,
                            newBgRGB11,
                            newFgRGB11
                        ];
                        this.#defs.style.color = "";
                        const getSteps11 = (fg11, bg11, n11)=>{
                            const arr31 = new Array(256);
                            const step11 = (bgGray11 - fgGray11) / n11;
                            const newStart11 = fg11 / 255;
                            const newStep11 = (bg11 - fg11) / (255 * n11);
                            let prev11 = 0;
                            for(let i11 = 0; i11 <= n11; i11++){
                                const k31 = Math.round(fgGray11 + i11 * step11);
                                const value11 = newStart11 + i11 * newStep11;
                                for(let j11 = prev11; j11 <= k31; j11++)arr31[j11] = value11;
                                prev11 = k31 + 1;
                            }
                            for(let i11 = prev11; i11 < 256; i11++)arr31[i11] = arr31[prev11 - 1];
                            return arr31.join(",");
                        };
                        const id11 = `g_${this.#docId}_hcm_highlight_filter`;
                        const filter11 = this.#hcmHighlightFilter = this.#createFilter(id11);
                        this.#addGrayConversion(filter11);
                        this.#addTransferMapConversion(getSteps11(newFgRGB11[0], newBgRGB11[0], 5), getSteps11(newFgRGB11[1], newBgRGB11[1], 5), getSteps11(newFgRGB11[2], newBgRGB11[2], 5), filter11);
                        this.#hcmHighlightUrl = `url(#${id11})`;
                        return this.#hcmHighlightUrl;
                    }
                    destroy(keepHCM11 = false) {
                        if (keepHCM11 && (this.#hcmUrl || this.#hcmHighlightUrl)) return;
                        if (this.#_defs) {
                            this.#_defs.parentNode.parentNode.remove();
                            this.#_defs = null;
                        }
                        if (this.#_cache) {
                            this.#_cache.clear();
                            this.#_cache = null;
                        }
                        this.#id = 0;
                    }
                    #addGrayConversion(filter11) {
                        const feColorMatrix11 = this.#document.createElementNS(SVG_NS11, "feColorMatrix");
                        feColorMatrix11.setAttribute("type", "matrix");
                        feColorMatrix11.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0");
                        filter11.append(feColorMatrix11);
                    }
                    #createFilter(id11) {
                        const filter11 = this.#document.createElementNS(SVG_NS11, "filter");
                        filter11.setAttribute("color-interpolation-filters", "sRGB");
                        filter11.setAttribute("id", id11);
                        this.#defs.append(filter11);
                        return filter11;
                    }
                    #appendFeFunc(feComponentTransfer11, func11, table11) {
                        const feFunc11 = this.#document.createElementNS(SVG_NS11, func11);
                        feFunc11.setAttribute("type", "discrete");
                        feFunc11.setAttribute("tableValues", table11);
                        feComponentTransfer11.append(feFunc11);
                    }
                    #addTransferMapConversion(rTable11, gTable11, bTable11, filter11) {
                        const feComponentTransfer11 = this.#document.createElementNS(SVG_NS11, "feComponentTransfer");
                        filter11.append(feComponentTransfer11);
                        this.#appendFeFunc(feComponentTransfer11, "feFuncR", rTable11);
                        this.#appendFeFunc(feComponentTransfer11, "feFuncG", gTable11);
                        this.#appendFeFunc(feComponentTransfer11, "feFuncB", bTable11);
                    }
                    #getRGB(color11) {
                        this.#defs.style.color = color11;
                        return getRGB11(getComputedStyle(this.#defs).getPropertyValue("color"));
                    }
                }
                exports11.DOMFilterFactory = DOMFilterFactory11;
                class DOMCanvasFactory11 extends _base_factory11.BaseCanvasFactory {
                    constructor({ ownerDocument: ownerDocument11 = globalThis.document } = {}){
                        super();
                        this._document = ownerDocument11;
                    }
                    _createCanvas(width21, height11) {
                        const canvas11 = this._document.createElement("canvas");
                        canvas11.width = width21;
                        canvas11.height = height11;
                        return canvas11;
                    }
                }
                exports11.DOMCanvasFactory = DOMCanvasFactory11;
                async function fetchData11(url11, asTypedArray11 = false) {
                    if (isValidFetchUrl11(url11, document.baseURI)) {
                        const response11 = await fetch(url11);
                        if (!response11.ok) throw new Error(response11.statusText);
                        return asTypedArray11 ? new Uint8Array(await response11.arrayBuffer()) : (0, _util11.stringToBytes)(await response11.text());
                    }
                    return new Promise((resolve11, reject11)=>{
                        const request11 = new XMLHttpRequest();
                        request11.open("GET", url11, true);
                        if (asTypedArray11) request11.responseType = "arraybuffer";
                        request11.onreadystatechange = ()=>{
                            if (request11.readyState !== XMLHttpRequest.DONE) return;
                            if (request11.status === 200 || request11.status === 0) {
                                let data11;
                                if (asTypedArray11 && request11.response) data11 = new Uint8Array(request11.response);
                                else if (!asTypedArray11 && request11.responseText) data11 = (0, _util11.stringToBytes)(request11.responseText);
                                if (data11) {
                                    resolve11(data11);
                                    return;
                                }
                            }
                            reject11(new Error(request11.statusText));
                        };
                        request11.send(null);
                    });
                }
                class DOMCMapReaderFactory11 extends _base_factory11.BaseCMapReaderFactory {
                    _fetchData(url11, compressionType11) {
                        return fetchData11(url11, this.isCompressed).then((data11)=>{
                            return {
                                cMapData: data11,
                                compressionType: compressionType11
                            };
                        });
                    }
                }
                exports11.DOMCMapReaderFactory = DOMCMapReaderFactory11;
                class DOMStandardFontDataFactory11 extends _base_factory11.BaseStandardFontDataFactory {
                    _fetchData(url11) {
                        return fetchData11(url11, true);
                    }
                }
                exports11.DOMStandardFontDataFactory = DOMStandardFontDataFactory11;
                class DOMSVGFactory11 extends _base_factory11.BaseSVGFactory {
                    _createSVG(type11) {
                        return document.createElementNS(SVG_NS11, type11);
                    }
                }
                exports11.DOMSVGFactory = DOMSVGFactory11;
                class PageViewport11 {
                    constructor({ viewBox: viewBox11, scale: scale11, rotation: rotation11, offsetX: offsetX11 = 0, offsetY: offsetY11 = 0, dontFlip: dontFlip11 = false }){
                        this.viewBox = viewBox11;
                        this.scale = scale11;
                        this.rotation = rotation11;
                        this.offsetX = offsetX11;
                        this.offsetY = offsetY11;
                        const centerX11 = (viewBox11[2] + viewBox11[0]) / 2;
                        const centerY11 = (viewBox11[3] + viewBox11[1]) / 2;
                        let rotateA11, rotateB11, rotateC11, rotateD11;
                        rotation11 %= 360;
                        if (rotation11 < 0) rotation11 += 360;
                        switch(rotation11){
                            case 180:
                                rotateA11 = -1;
                                rotateB11 = 0;
                                rotateC11 = 0;
                                rotateD11 = 1;
                                break;
                            case 90:
                                rotateA11 = 0;
                                rotateB11 = 1;
                                rotateC11 = 1;
                                rotateD11 = 0;
                                break;
                            case 270:
                                rotateA11 = 0;
                                rotateB11 = -1;
                                rotateC11 = -1;
                                rotateD11 = 0;
                                break;
                            case 0:
                                rotateA11 = 1;
                                rotateB11 = 0;
                                rotateC11 = 0;
                                rotateD11 = -1;
                                break;
                            default:
                                throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
                        }
                        if (dontFlip11) {
                            rotateC11 = -rotateC11;
                            rotateD11 = -rotateD11;
                        }
                        let offsetCanvasX11, offsetCanvasY11;
                        let width21, height11;
                        if (rotateA11 === 0) {
                            offsetCanvasX11 = Math.abs(centerY11 - viewBox11[1]) * scale11 + offsetX11;
                            offsetCanvasY11 = Math.abs(centerX11 - viewBox11[0]) * scale11 + offsetY11;
                            width21 = (viewBox11[3] - viewBox11[1]) * scale11;
                            height11 = (viewBox11[2] - viewBox11[0]) * scale11;
                        } else {
                            offsetCanvasX11 = Math.abs(centerX11 - viewBox11[0]) * scale11 + offsetX11;
                            offsetCanvasY11 = Math.abs(centerY11 - viewBox11[1]) * scale11 + offsetY11;
                            width21 = (viewBox11[2] - viewBox11[0]) * scale11;
                            height11 = (viewBox11[3] - viewBox11[1]) * scale11;
                        }
                        this.transform = [
                            rotateA11 * scale11,
                            rotateB11 * scale11,
                            rotateC11 * scale11,
                            rotateD11 * scale11,
                            offsetCanvasX11 - rotateA11 * scale11 * centerX11 - rotateC11 * scale11 * centerY11,
                            offsetCanvasY11 - rotateB11 * scale11 * centerX11 - rotateD11 * scale11 * centerY11
                        ];
                        this.width = width21;
                        this.height = height11;
                    }
                    get rawDims() {
                        const { viewBox: viewBox11 } = this;
                        return (0, _util11.shadow)(this, "rawDims", {
                            pageWidth: viewBox11[2] - viewBox11[0],
                            pageHeight: viewBox11[3] - viewBox11[1],
                            pageX: viewBox11[0],
                            pageY: viewBox11[1]
                        });
                    }
                    clone({ scale: scale11 = this.scale, rotation: rotation11 = this.rotation, offsetX: offsetX11 = this.offsetX, offsetY: offsetY11 = this.offsetY, dontFlip: dontFlip11 = false } = {}) {
                        return new PageViewport11({
                            viewBox: this.viewBox.slice(),
                            scale: scale11,
                            rotation: rotation11,
                            offsetX: offsetX11,
                            offsetY: offsetY11,
                            dontFlip: dontFlip11
                        });
                    }
                    convertToViewportPoint(x41, y41) {
                        return _util11.Util.applyTransform([
                            x41,
                            y41
                        ], this.transform);
                    }
                    convertToViewportRectangle(rect31) {
                        const topLeft11 = _util11.Util.applyTransform([
                            rect31[0],
                            rect31[1]
                        ], this.transform);
                        const bottomRight11 = _util11.Util.applyTransform([
                            rect31[2],
                            rect31[3]
                        ], this.transform);
                        return [
                            topLeft11[0],
                            topLeft11[1],
                            bottomRight11[0],
                            bottomRight11[1]
                        ];
                    }
                    convertToPdfPoint(x41, y41) {
                        return _util11.Util.applyInverseTransform([
                            x41,
                            y41
                        ], this.transform);
                    }
                }
                exports11.PageViewport = PageViewport11;
                class RenderingCancelledException11 extends _util11.BaseException {
                    constructor(msg11, extraDelay11 = 0){
                        super(msg11, "RenderingCancelledException");
                        this.extraDelay = extraDelay11;
                    }
                }
                exports11.RenderingCancelledException = RenderingCancelledException11;
                function isDataScheme11(url11) {
                    const ii11 = url11.length;
                    let i11 = 0;
                    while(i11 < ii11 && url11[i11].trim() === "")i11++;
                    return url11.substring(i11, i11 + 5).toLowerCase() === "data:";
                }
                function isPdfFile11(filename11) {
                    return typeof filename11 === "string" && /\.pdf$/i.test(filename11);
                }
                function getFilenameFromUrl11(url11, onlyStripPath11 = false) {
                    if (!onlyStripPath11) [url11] = url11.split(/[#?]/, 1);
                    return url11.substring(url11.lastIndexOf("/") + 1);
                }
                function getPdfFilenameFromUrl11(url11, defaultFilename11 = "document.pdf") {
                    if (typeof url11 !== "string") return defaultFilename11;
                    if (isDataScheme11(url11)) {
                        (0, _util11.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
                        return defaultFilename11;
                    }
                    const reURI11 = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
                    const reFilename11 = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
                    const splitURI11 = reURI11.exec(url11);
                    let suggestedFilename11 = reFilename11.exec(splitURI11[1]) || reFilename11.exec(splitURI11[2]) || reFilename11.exec(splitURI11[3]);
                    if (suggestedFilename11) {
                        suggestedFilename11 = suggestedFilename11[0];
                        if (suggestedFilename11.includes("%")) try {
                            suggestedFilename11 = reFilename11.exec(decodeURIComponent(suggestedFilename11))[0];
                        } catch  {}
                    }
                    return suggestedFilename11 || defaultFilename11;
                }
                class StatTimer11 {
                    started = Object.create(null);
                    times = [];
                    time(name11) {
                        if (name11 in this.started) (0, _util11.warn)(`Timer is already running for ${name11}`);
                        this.started[name11] = Date.now();
                    }
                    timeEnd(name11) {
                        if (!(name11 in this.started)) (0, _util11.warn)(`Timer has not been started for ${name11}`);
                        this.times.push({
                            name: name11,
                            start: this.started[name11],
                            end: Date.now()
                        });
                        delete this.started[name11];
                    }
                    toString() {
                        const outBuf11 = [];
                        let longest11 = 0;
                        for (const { name: name11 } of this.times)longest11 = Math.max(name11.length, longest11);
                        for (const { name: name11, start: start11, end: end11 } of this.times)outBuf11.push(`${name11.padEnd(longest11)} ${end11 - start11}ms\n`);
                        return outBuf11.join("");
                    }
                }
                exports11.StatTimer = StatTimer11;
                function isValidFetchUrl11(url11, baseUrl11) {
                    try {
                        const { protocol: protocol11 } = baseUrl11 ? new URL(url11, baseUrl11) : new URL(url11);
                        return protocol11 === "http:" || protocol11 === "https:";
                    } catch  {
                        return false;
                    }
                }
                function noContextMenu11(e11) {
                    e11.preventDefault();
                }
                function loadScript11(src11, removeScriptElement11 = false) {
                    return new Promise((resolve11, reject11)=>{
                        const script11 = document.createElement("script");
                        script11.src = src11;
                        script11.onload = function(evt11) {
                            if (removeScriptElement11) script11.remove();
                            resolve11(evt11);
                        };
                        script11.onerror = function() {
                            reject11(new Error(`Cannot load script at: ${script11.src}`));
                        };
                        (document.head || document.documentElement).append(script11);
                    });
                }
                function deprecated11(details11) {
                    console.log("Deprecated API usage: " + details11);
                }
                let pdfDateStringRegex11;
                class PDFDateString11 {
                    static toDateObject(input11) {
                        if (!input11 || typeof input11 !== "string") return null;
                        pdfDateStringRegex11 ||= new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?");
                        const matches11 = pdfDateStringRegex11.exec(input11);
                        if (!matches11) return null;
                        const year11 = parseInt(matches11[1], 10);
                        let month11 = parseInt(matches11[2], 10);
                        month11 = month11 >= 1 && month11 <= 12 ? month11 - 1 : 0;
                        let day11 = parseInt(matches11[3], 10);
                        day11 = day11 >= 1 && day11 <= 31 ? day11 : 1;
                        let hour11 = parseInt(matches11[4], 10);
                        hour11 = hour11 >= 0 && hour11 <= 23 ? hour11 : 0;
                        let minute11 = parseInt(matches11[5], 10);
                        minute11 = minute11 >= 0 && minute11 <= 59 ? minute11 : 0;
                        let second11 = parseInt(matches11[6], 10);
                        second11 = second11 >= 0 && second11 <= 59 ? second11 : 0;
                        const universalTimeRelation11 = matches11[7] || "Z";
                        let offsetHour11 = parseInt(matches11[8], 10);
                        offsetHour11 = offsetHour11 >= 0 && offsetHour11 <= 23 ? offsetHour11 : 0;
                        let offsetMinute11 = parseInt(matches11[9], 10) || 0;
                        offsetMinute11 = offsetMinute11 >= 0 && offsetMinute11 <= 59 ? offsetMinute11 : 0;
                        if (universalTimeRelation11 === "-") {
                            hour11 += offsetHour11;
                            minute11 += offsetMinute11;
                        } else if (universalTimeRelation11 === "+") {
                            hour11 -= offsetHour11;
                            minute11 -= offsetMinute11;
                        }
                        return new Date(Date.UTC(year11, month11, day11, hour11, minute11, second11));
                    }
                }
                exports11.PDFDateString = PDFDateString11;
                function getXfaPageViewport11(xfaPage11, { scale: scale11 = 1, rotation: rotation11 = 0 }) {
                    const { width: width21, height: height11 } = xfaPage11.attributes.style;
                    const viewBox11 = [
                        0,
                        0,
                        parseInt(width21),
                        parseInt(height11)
                    ];
                    return new PageViewport11({
                        viewBox: viewBox11,
                        scale: scale11,
                        rotation: rotation11
                    });
                }
                function getRGB11(color11) {
                    if (color11.startsWith("#")) {
                        const colorRGB11 = parseInt(color11.slice(1), 16);
                        return [
                            (colorRGB11 & 0xff0000) >> 16,
                            (colorRGB11 & 0x00ff00) >> 8,
                            colorRGB11 & 0x0000ff
                        ];
                    }
                    if (color11.startsWith("rgb(")) return color11.slice(4, -1).split(",").map((x41)=>parseInt(x41));
                    if (color11.startsWith("rgba(")) return color11.slice(5, -1).split(",").map((x41)=>parseInt(x41)).slice(0, 3);
                    (0, _util11.warn)(`Not a valid color format: "${color11}"`);
                    return [
                        0,
                        0,
                        0
                    ];
                }
                function getColorValues11(colors11) {
                    const span11 = document.createElement("span");
                    span11.style.visibility = "hidden";
                    document.body.append(span11);
                    for (const name11 of colors11.keys()){
                        span11.style.color = name11;
                        const computedColor11 = window.getComputedStyle(span11).color;
                        colors11.set(name11, getRGB11(computedColor11));
                    }
                    span11.remove();
                }
                function getCurrentTransform11(ctx11) {
                    const { a: a11, b: b41, c: c41, d: d51, e: e11, f: f11 } = ctx11.getTransform();
                    return [
                        a11,
                        b41,
                        c41,
                        d51,
                        e11,
                        f11
                    ];
                }
                function getCurrentTransformInverse11(ctx11) {
                    const { a: a11, b: b41, c: c41, d: d51, e: e11, f: f11 } = ctx11.getTransform().invertSelf();
                    return [
                        a11,
                        b41,
                        c41,
                        d51,
                        e11,
                        f11
                    ];
                }
                function setLayerDimensions11(div11, viewport11, mustFlip11 = false, mustRotate11 = true) {
                    if (viewport11 instanceof PageViewport11) {
                        const { pageWidth: pageWidth11, pageHeight: pageHeight11 } = viewport11.rawDims;
                        const { style: style11 } = div11;
                        const useRound11 = _util11.FeatureTest.isCSSRoundSupported;
                        const w11 = `var(--scale-factor) * ${pageWidth11}px`, h31 = `var(--scale-factor) * ${pageHeight11}px`;
                        const widthStr11 = useRound11 ? `round(${w11}, 1px)` : `calc(${w11})`, heightStr11 = useRound11 ? `round(${h31}, 1px)` : `calc(${h31})`;
                        if (!mustFlip11 || viewport11.rotation % 180 === 0) {
                            style11.width = widthStr11;
                            style11.height = heightStr11;
                        } else {
                            style11.width = heightStr11;
                            style11.height = widthStr11;
                        }
                    }
                    if (mustRotate11) div11.setAttribute("data-main-rotation", viewport11.rotation);
                }
            /***/ },
            /* 7 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.BaseStandardFontDataFactory = exports11.BaseSVGFactory = exports11.BaseFilterFactory = exports11.BaseCanvasFactory = exports11.BaseCMapReaderFactory = void 0;
                var _util11 = __w_pdfjs_require__11(1);
                class BaseFilterFactory11 {
                    constructor(){
                        if (this.constructor === BaseFilterFactory11) (0, _util11.unreachable)("Cannot initialize BaseFilterFactory.");
                    }
                    addFilter(maps11) {
                        return "none";
                    }
                    addHCMFilter(fgColor11, bgColor11) {
                        return "none";
                    }
                    addHighlightHCMFilter(fgColor11, bgColor11, newFgColor11, newBgColor11) {
                        return "none";
                    }
                    destroy(keepHCM11 = false) {}
                }
                exports11.BaseFilterFactory = BaseFilterFactory11;
                class BaseCanvasFactory11 {
                    constructor(){
                        if (this.constructor === BaseCanvasFactory11) (0, _util11.unreachable)("Cannot initialize BaseCanvasFactory.");
                    }
                    create(width21, height11) {
                        if (width21 <= 0 || height11 <= 0) throw new Error("Invalid canvas size");
                        const canvas11 = this._createCanvas(width21, height11);
                        return {
                            canvas: canvas11,
                            context: canvas11.getContext("2d")
                        };
                    }
                    reset(canvasAndContext11, width21, height11) {
                        if (!canvasAndContext11.canvas) throw new Error("Canvas is not specified");
                        if (width21 <= 0 || height11 <= 0) throw new Error("Invalid canvas size");
                        canvasAndContext11.canvas.width = width21;
                        canvasAndContext11.canvas.height = height11;
                    }
                    destroy(canvasAndContext11) {
                        if (!canvasAndContext11.canvas) throw new Error("Canvas is not specified");
                        canvasAndContext11.canvas.width = 0;
                        canvasAndContext11.canvas.height = 0;
                        canvasAndContext11.canvas = null;
                        canvasAndContext11.context = null;
                    }
                    _createCanvas(width21, height11) {
                        (0, _util11.unreachable)("Abstract method `_createCanvas` called.");
                    }
                }
                exports11.BaseCanvasFactory = BaseCanvasFactory11;
                class BaseCMapReaderFactory11 {
                    constructor({ baseUrl: baseUrl11 = null, isCompressed: isCompressed11 = true }){
                        if (this.constructor === BaseCMapReaderFactory11) (0, _util11.unreachable)("Cannot initialize BaseCMapReaderFactory.");
                        this.baseUrl = baseUrl11;
                        this.isCompressed = isCompressed11;
                    }
                    async fetch({ name: name11 }) {
                        if (!this.baseUrl) throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
                        if (!name11) throw new Error("CMap name must be specified.");
                        const url11 = this.baseUrl + name11 + (this.isCompressed ? ".bcmap" : "");
                        const compressionType11 = this.isCompressed ? _util11.CMapCompressionType.BINARY : _util11.CMapCompressionType.NONE;
                        return this._fetchData(url11, compressionType11).catch((reason11)=>{
                            throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${url11}`);
                        });
                    }
                    _fetchData(url11, compressionType11) {
                        (0, _util11.unreachable)("Abstract method `_fetchData` called.");
                    }
                }
                exports11.BaseCMapReaderFactory = BaseCMapReaderFactory11;
                class BaseStandardFontDataFactory11 {
                    constructor({ baseUrl: baseUrl11 = null }){
                        if (this.constructor === BaseStandardFontDataFactory11) (0, _util11.unreachable)("Cannot initialize BaseStandardFontDataFactory.");
                        this.baseUrl = baseUrl11;
                    }
                    async fetch({ filename: filename11 }) {
                        if (!this.baseUrl) throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
                        if (!filename11) throw new Error("Font filename must be specified.");
                        const url11 = `${this.baseUrl}${filename11}`;
                        return this._fetchData(url11).catch((reason11)=>{
                            throw new Error(`Unable to load font data at: ${url11}`);
                        });
                    }
                    _fetchData(url11) {
                        (0, _util11.unreachable)("Abstract method `_fetchData` called.");
                    }
                }
                exports11.BaseStandardFontDataFactory = BaseStandardFontDataFactory11;
                class BaseSVGFactory11 {
                    constructor(){
                        if (this.constructor === BaseSVGFactory11) (0, _util11.unreachable)("Cannot initialize BaseSVGFactory.");
                    }
                    create(width21, height11, skipDimensions11 = false) {
                        if (width21 <= 0 || height11 <= 0) throw new Error("Invalid SVG dimensions");
                        const svg11 = this._createSVG("svg:svg");
                        svg11.setAttribute("version", "1.1");
                        if (!skipDimensions11) {
                            svg11.setAttribute("width", `${width21}px`);
                            svg11.setAttribute("height", `${height11}px`);
                        }
                        svg11.setAttribute("preserveAspectRatio", "none");
                        svg11.setAttribute("viewBox", `0 0 ${width21} ${height11}`);
                        return svg11;
                    }
                    createElement(type11) {
                        if (typeof type11 !== "string") throw new Error("Invalid SVG element type");
                        return this._createSVG(type11);
                    }
                    _createSVG(type11) {
                        (0, _util11.unreachable)("Abstract method `_createSVG` called.");
                    }
                }
                exports11.BaseSVGFactory = BaseSVGFactory11;
            /***/ },
            /* 8 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.MurmurHash3_64 = void 0;
                var _util11 = __w_pdfjs_require__11(1);
                const SEED11 = 0xc3d2e1f0;
                const MASK_HIGH11 = 0xffff0000;
                const MASK_LOW11 = 0xffff;
                class MurmurHash3_6411 {
                    constructor(seed11){
                        this.h1 = seed11 ? seed11 & 0xffffffff : SEED11;
                        this.h2 = seed11 ? seed11 & 0xffffffff : SEED11;
                    }
                    update(input11) {
                        let data11, length11;
                        if (typeof input11 === "string") {
                            data11 = new Uint8Array(input11.length * 2);
                            length11 = 0;
                            for(let i11 = 0, ii11 = input11.length; i11 < ii11; i11++){
                                const code11 = input11.charCodeAt(i11);
                                if (code11 <= 0xff) data11[length11++] = code11;
                                else {
                                    data11[length11++] = code11 >>> 8;
                                    data11[length11++] = code11 & 0xff;
                                }
                            }
                        } else if ((0, _util11.isArrayBuffer)(input11)) {
                            data11 = input11.slice();
                            length11 = data11.byteLength;
                        } else throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                        const blockCounts11 = length11 >> 2;
                        const tailLength11 = length11 - blockCounts11 * 4;
                        const dataUint3211 = new Uint32Array(data11.buffer, 0, blockCounts11);
                        let k111 = 0, k211 = 0;
                        let h111 = this.h1, h211 = this.h2;
                        const C111 = 0xcc9e2d51, C211 = 0x1b873593;
                        const C1_LOW11 = C111 & MASK_LOW11, C2_LOW11 = C211 & MASK_LOW11;
                        for(let i11 = 0; i11 < blockCounts11; i11++)if (i11 & 1) {
                            k111 = dataUint3211[i11];
                            k111 = k111 * C111 & MASK_HIGH11 | k111 * C1_LOW11 & MASK_LOW11;
                            k111 = k111 << 15 | k111 >>> 17;
                            k111 = k111 * C211 & MASK_HIGH11 | k111 * C2_LOW11 & MASK_LOW11;
                            h111 ^= k111;
                            h111 = h111 << 13 | h111 >>> 19;
                            h111 = h111 * 5 + 0xe6546b64;
                        } else {
                            k211 = dataUint3211[i11];
                            k211 = k211 * C111 & MASK_HIGH11 | k211 * C1_LOW11 & MASK_LOW11;
                            k211 = k211 << 15 | k211 >>> 17;
                            k211 = k211 * C211 & MASK_HIGH11 | k211 * C2_LOW11 & MASK_LOW11;
                            h211 ^= k211;
                            h211 = h211 << 13 | h211 >>> 19;
                            h211 = h211 * 5 + 0xe6546b64;
                        }
                        k111 = 0;
                        switch(tailLength11){
                            case 3:
                                k111 ^= data11[blockCounts11 * 4 + 2] << 16;
                            case 2:
                                k111 ^= data11[blockCounts11 * 4 + 1] << 8;
                            case 1:
                                k111 ^= data11[blockCounts11 * 4];
                                k111 = k111 * C111 & MASK_HIGH11 | k111 * C1_LOW11 & MASK_LOW11;
                                k111 = k111 << 15 | k111 >>> 17;
                                k111 = k111 * C211 & MASK_HIGH11 | k111 * C2_LOW11 & MASK_LOW11;
                                if (blockCounts11 & 1) h111 ^= k111;
                                else h211 ^= k111;
                        }
                        this.h1 = h111;
                        this.h2 = h211;
                    }
                    hexdigest() {
                        let h111 = this.h1, h211 = this.h2;
                        h111 ^= h211 >>> 1;
                        h111 = h111 * 0xed558ccd & MASK_HIGH11 | h111 * 0x8ccd & MASK_LOW11;
                        h211 = h211 * 0xff51afd7 & MASK_HIGH11 | ((h211 << 16 | h111 >>> 16) * 0xafd7ed55 & MASK_HIGH11) >>> 16;
                        h111 ^= h211 >>> 1;
                        h111 = h111 * 0x1a85ec53 & MASK_HIGH11 | h111 * 0xec53 & MASK_LOW11;
                        h211 = h211 * 0xc4ceb9fe & MASK_HIGH11 | ((h211 << 16 | h111 >>> 16) * 0xb9fe1a85 & MASK_HIGH11) >>> 16;
                        h111 ^= h211 >>> 1;
                        return (h111 >>> 0).toString(16).padStart(8, "0") + (h211 >>> 0).toString(16).padStart(8, "0");
                    }
                }
                exports11.MurmurHash3_64 = MurmurHash3_6411;
            /***/ },
            /* 9 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.FontLoader = exports11.FontFaceObject = void 0;
                var _util11 = __w_pdfjs_require__11(1);
                class FontLoader11 {
                    #systemFonts = new Set();
                    constructor({ ownerDocument: ownerDocument11 = globalThis.document, styleElement: styleElement11 = null }){
                        this._document = ownerDocument11;
                        this.nativeFontFaces = new Set();
                        this.styleElement = null;
                        this.loadingRequests = [];
                        this.loadTestFontId = 0;
                    }
                    addNativeFontFace(nativeFontFace11) {
                        this.nativeFontFaces.add(nativeFontFace11);
                        this._document.fonts.add(nativeFontFace11);
                    }
                    removeNativeFontFace(nativeFontFace11) {
                        this.nativeFontFaces.delete(nativeFontFace11);
                        this._document.fonts.delete(nativeFontFace11);
                    }
                    insertRule(rule11) {
                        if (!this.styleElement) {
                            this.styleElement = this._document.createElement("style");
                            this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement);
                        }
                        const styleSheet11 = this.styleElement.sheet;
                        styleSheet11.insertRule(rule11, styleSheet11.cssRules.length);
                    }
                    clear() {
                        for (const nativeFontFace11 of this.nativeFontFaces)this._document.fonts.delete(nativeFontFace11);
                        this.nativeFontFaces.clear();
                        this.#systemFonts.clear();
                        if (this.styleElement) {
                            this.styleElement.remove();
                            this.styleElement = null;
                        }
                    }
                    async loadSystemFont(info11) {
                        if (!info11 || this.#systemFonts.has(info11.loadedName)) return;
                        (0, _util11.assert)(!this.disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set.");
                        if (this.isFontLoadingAPISupported) {
                            const { loadedName: loadedName11, src: src11, style: style11 } = info11;
                            const fontFace11 = new FontFace(loadedName11, src11, style11);
                            this.addNativeFontFace(fontFace11);
                            try {
                                await fontFace11.load();
                                this.#systemFonts.add(loadedName11);
                            } catch  {
                                (0, _util11.warn)(`Cannot load system font: ${info11.baseFontName}, installing it could help to improve PDF rendering.`);
                                this.removeNativeFontFace(fontFace11);
                            }
                            return;
                        }
                        (0, _util11.unreachable)("Not implemented: loadSystemFont without the Font Loading API.");
                    }
                    async bind(font11) {
                        if (font11.attached || font11.missingFile && !font11.systemFontInfo) return;
                        font11.attached = true;
                        if (font11.systemFontInfo) {
                            await this.loadSystemFont(font11.systemFontInfo);
                            return;
                        }
                        if (this.isFontLoadingAPISupported) {
                            const nativeFontFace11 = font11.createNativeFontFace();
                            if (nativeFontFace11) {
                                this.addNativeFontFace(nativeFontFace11);
                                try {
                                    await nativeFontFace11.loaded;
                                } catch (ex11) {
                                    (0, _util11.warn)(`Failed to load font '${nativeFontFace11.family}': '${ex11}'.`);
                                    font11.disableFontFace = true;
                                    throw ex11;
                                }
                            }
                            return;
                        }
                        const rule11 = font11.createFontFaceRule();
                        if (rule11) {
                            this.insertRule(rule11);
                            if (this.isSyncFontLoadingSupported) return;
                            await new Promise((resolve11)=>{
                                const request11 = this._queueLoadingCallback(resolve11);
                                this._prepareFontLoadEvent(font11, request11);
                            });
                        }
                    }
                    get isFontLoadingAPISupported() {
                        const hasFonts11 = !!this._document?.fonts;
                        return (0, _util11.shadow)(this, "isFontLoadingAPISupported", hasFonts11);
                    }
                    get isSyncFontLoadingSupported() {
                        let supported11 = false;
                        if (_util11.isNodeJS) supported11 = true;
                        else if (typeof navigator !== "undefined" && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent)) supported11 = true;
                        return (0, _util11.shadow)(this, "isSyncFontLoadingSupported", supported11);
                    }
                    _queueLoadingCallback(callback11) {
                        function completeRequest11() {
                            (0, _util11.assert)(!request11.done, "completeRequest() cannot be called twice.");
                            request11.done = true;
                            while(loadingRequests11.length > 0 && loadingRequests11[0].done){
                                const otherRequest11 = loadingRequests11.shift();
                                setTimeout(otherRequest11.callback, 0);
                            }
                        }
                        const { loadingRequests: loadingRequests11 } = this;
                        const request11 = {
                            done: false,
                            complete: completeRequest11,
                            callback: callback11
                        };
                        loadingRequests11.push(request11);
                        return request11;
                    }
                    get _loadTestFont() {
                        const testFont11 = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                        return (0, _util11.shadow)(this, "_loadTestFont", testFont11);
                    }
                    _prepareFontLoadEvent(font11, request11) {
                        function int3211(data11, offset11) {
                            return data11.charCodeAt(offset11) << 24 | data11.charCodeAt(offset11 + 1) << 16 | data11.charCodeAt(offset11 + 2) << 8 | data11.charCodeAt(offset11 + 3) & 0xff;
                        }
                        function spliceString11(s41, offset11, remove11, insert11) {
                            const chunk111 = s41.substring(0, offset11);
                            const chunk211 = s41.substring(offset11 + remove11);
                            return chunk111 + insert11 + chunk211;
                        }
                        let i11, ii11;
                        const canvas11 = this._document.createElement("canvas");
                        canvas11.width = 1;
                        canvas11.height = 1;
                        const ctx11 = canvas11.getContext("2d");
                        let called11 = 0;
                        function isFontReady11(name11, callback11) {
                            if (++called11 > 30) {
                                (0, _util11.warn)("Load test font never loaded.");
                                callback11();
                                return;
                            }
                            ctx11.font = "30px " + name11;
                            ctx11.fillText(".", 0, 20);
                            const imageData11 = ctx11.getImageData(0, 0, 1, 1);
                            if (imageData11.data[3] > 0) {
                                callback11();
                                return;
                            }
                            setTimeout(isFontReady11.bind(null, name11, callback11));
                        }
                        const loadTestFontId11 = `lt${Date.now()}${this.loadTestFontId++}`;
                        let data11 = this._loadTestFont;
                        const COMMENT_OFFSET11 = 976;
                        data11 = spliceString11(data11, COMMENT_OFFSET11, loadTestFontId11.length, loadTestFontId11);
                        const CFF_CHECKSUM_OFFSET11 = 16;
                        const XXXX_VALUE11 = 0x58585858;
                        let checksum11 = int3211(data11, CFF_CHECKSUM_OFFSET11);
                        for(i11 = 0, ii11 = loadTestFontId11.length - 3; i11 < ii11; i11 += 4)checksum11 = checksum11 - XXXX_VALUE11 + int3211(loadTestFontId11, i11) | 0;
                        if (i11 < loadTestFontId11.length) checksum11 = checksum11 - XXXX_VALUE11 + int3211(loadTestFontId11 + "XXX", i11) | 0;
                        data11 = spliceString11(data11, CFF_CHECKSUM_OFFSET11, 4, (0, _util11.string32)(checksum11));
                        const url11 = `url(data:font/opentype;base64,${btoa(data11)});`;
                        const rule11 = `@font-face {font-family:"${loadTestFontId11}";src:${url11}}`;
                        this.insertRule(rule11);
                        const div11 = this._document.createElement("div");
                        div11.style.visibility = "hidden";
                        div11.style.width = div11.style.height = "10px";
                        div11.style.position = "absolute";
                        div11.style.top = div11.style.left = "0px";
                        for (const name11 of [
                            font11.loadedName,
                            loadTestFontId11
                        ]){
                            const span11 = this._document.createElement("span");
                            span11.textContent = "Hi";
                            span11.style.fontFamily = name11;
                            div11.append(span11);
                        }
                        this._document.body.append(div11);
                        isFontReady11(loadTestFontId11, ()=>{
                            div11.remove();
                            request11.complete();
                        });
                    }
                }
                exports11.FontLoader = FontLoader11;
                class FontFaceObject11 {
                    constructor(translatedData11, { isEvalSupported: isEvalSupported11 = true, disableFontFace: disableFontFace11 = false, ignoreErrors: ignoreErrors11 = false, inspectFont: inspectFont11 = null }){
                        this.compiledGlyphs = Object.create(null);
                        for(const i11 in translatedData11)this[i11] = translatedData11[i11];
                        this.isEvalSupported = isEvalSupported11 !== false;
                        this.disableFontFace = disableFontFace11 === true;
                        this.ignoreErrors = ignoreErrors11 === true;
                        this._inspectFont = inspectFont11;
                    }
                    createNativeFontFace() {
                        if (!this.data || this.disableFontFace) return null;
                        let nativeFontFace11;
                        if (!this.cssFontInfo) nativeFontFace11 = new FontFace(this.loadedName, this.data, {});
                        else {
                            const css11 = {
                                weight: this.cssFontInfo.fontWeight
                            };
                            if (this.cssFontInfo.italicAngle) css11.style = `oblique ${this.cssFontInfo.italicAngle}deg`;
                            nativeFontFace11 = new FontFace(this.cssFontInfo.fontFamily, this.data, css11);
                        }
                        this._inspectFont?.(this);
                        return nativeFontFace11;
                    }
                    createFontFaceRule() {
                        if (!this.data || this.disableFontFace) return null;
                        const data11 = (0, _util11.bytesToString)(this.data);
                        const url11 = `url(data:${this.mimetype};base64,${btoa(data11)});`;
                        let rule11;
                        if (!this.cssFontInfo) rule11 = `@font-face {font-family:"${this.loadedName}";src:${url11}}`;
                        else {
                            let css11 = `font-weight: ${this.cssFontInfo.fontWeight};`;
                            if (this.cssFontInfo.italicAngle) css11 += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`;
                            rule11 = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${css11}src:${url11}}`;
                        }
                        this._inspectFont?.(this, url11);
                        return rule11;
                    }
                    getPathGenerator(objs11, character11) {
                        if (this.compiledGlyphs[character11] !== undefined) return this.compiledGlyphs[character11];
                        let cmds11;
                        try {
                            cmds11 = objs11.get(this.loadedName + "_path_" + character11);
                        } catch (ex11) {
                            if (!this.ignoreErrors) throw ex11;
                            (0, _util11.warn)(`getPathGenerator - ignoring character: "${ex11}".`);
                            return this.compiledGlyphs[character11] = function(c41, size11) {};
                        }
                        if (this.isEvalSupported && _util11.FeatureTest.isEvalSupported) {
                            const jsBuf11 = [];
                            for (const current11 of cmds11){
                                const args11 = current11.args !== undefined ? current11.args.join(",") : "";
                                jsBuf11.push("c.", current11.cmd, "(", args11, ");\n");
                            }
                            return this.compiledGlyphs[character11] = new Function("c", "size", jsBuf11.join(""));
                        }
                        return this.compiledGlyphs[character11] = function(c41, size11) {
                            for (const current11 of cmds11){
                                if (current11.cmd === "scale") current11.args = [
                                    size11,
                                    -size11
                                ];
                                c41[current11.cmd].apply(c41, current11.args);
                            }
                        };
                    }
                }
                exports11.FontFaceObject = FontFaceObject11;
            /***/ },
            /* 10 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.NodeStandardFontDataFactory = exports11.NodeFilterFactory = exports11.NodeCanvasFactory = exports11.NodeCMapReaderFactory = void 0;
                var _base_factory11 = __w_pdfjs_require__11(7);
                var _util11 = __w_pdfjs_require__11(1);
                const fetchData11 = function(url11) {
                    return new Promise((resolve11, reject11)=>{
                        const fs11 = (parcelRequire("gFNhN"));
                        fs11.readFile(url11, (error11, data11)=>{
                            if (error11 || !data11) {
                                reject11(new Error(error11));
                                return;
                            }
                            resolve11(new Uint8Array(data11));
                        });
                    });
                };
                class NodeFilterFactory11 extends _base_factory11.BaseFilterFactory {
                }
                exports11.NodeFilterFactory = NodeFilterFactory11;
                class NodeCanvasFactory11 extends _base_factory11.BaseCanvasFactory {
                    _createCanvas(width21, height11) {
                        const Canvas11 = (parcelRequire("gFNhN"));
                        return Canvas11.createCanvas(width21, height11);
                    }
                }
                exports11.NodeCanvasFactory = NodeCanvasFactory11;
                class NodeCMapReaderFactory11 extends _base_factory11.BaseCMapReaderFactory {
                    _fetchData(url11, compressionType11) {
                        return fetchData11(url11).then((data11)=>{
                            return {
                                cMapData: data11,
                                compressionType: compressionType11
                            };
                        });
                    }
                }
                exports11.NodeCMapReaderFactory = NodeCMapReaderFactory11;
                class NodeStandardFontDataFactory11 extends _base_factory11.BaseStandardFontDataFactory {
                    _fetchData(url11) {
                        return fetchData11(url11);
                    }
                }
                exports11.NodeStandardFontDataFactory = NodeStandardFontDataFactory11;
            /***/ },
            /* 11 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.CanvasGraphics = void 0;
                var _util11 = __w_pdfjs_require__11(1);
                var _display_utils11 = __w_pdfjs_require__11(6);
                var _pattern_helper11 = __w_pdfjs_require__11(12);
                var _image_utils11 = __w_pdfjs_require__11(13);
                const MIN_FONT_SIZE11 = 16;
                const MAX_FONT_SIZE11 = 100;
                const MAX_GROUP_SIZE11 = 4096;
                const EXECUTION_TIME11 = 15;
                const EXECUTION_STEPS11 = 10;
                const MAX_SIZE_TO_COMPILE11 = 1000;
                const FULL_CHUNK_HEIGHT11 = 16;
                function mirrorContextOperations11(ctx11, destCtx11) {
                    if (ctx11._removeMirroring) throw new Error("Context is already forwarding operations.");
                    ctx11.__originalSave = ctx11.save;
                    ctx11.__originalRestore = ctx11.restore;
                    ctx11.__originalRotate = ctx11.rotate;
                    ctx11.__originalScale = ctx11.scale;
                    ctx11.__originalTranslate = ctx11.translate;
                    ctx11.__originalTransform = ctx11.transform;
                    ctx11.__originalSetTransform = ctx11.setTransform;
                    ctx11.__originalResetTransform = ctx11.resetTransform;
                    ctx11.__originalClip = ctx11.clip;
                    ctx11.__originalMoveTo = ctx11.moveTo;
                    ctx11.__originalLineTo = ctx11.lineTo;
                    ctx11.__originalBezierCurveTo = ctx11.bezierCurveTo;
                    ctx11.__originalRect = ctx11.rect;
                    ctx11.__originalClosePath = ctx11.closePath;
                    ctx11.__originalBeginPath = ctx11.beginPath;
                    ctx11._removeMirroring = ()=>{
                        ctx11.save = ctx11.__originalSave;
                        ctx11.restore = ctx11.__originalRestore;
                        ctx11.rotate = ctx11.__originalRotate;
                        ctx11.scale = ctx11.__originalScale;
                        ctx11.translate = ctx11.__originalTranslate;
                        ctx11.transform = ctx11.__originalTransform;
                        ctx11.setTransform = ctx11.__originalSetTransform;
                        ctx11.resetTransform = ctx11.__originalResetTransform;
                        ctx11.clip = ctx11.__originalClip;
                        ctx11.moveTo = ctx11.__originalMoveTo;
                        ctx11.lineTo = ctx11.__originalLineTo;
                        ctx11.bezierCurveTo = ctx11.__originalBezierCurveTo;
                        ctx11.rect = ctx11.__originalRect;
                        ctx11.closePath = ctx11.__originalClosePath;
                        ctx11.beginPath = ctx11.__originalBeginPath;
                        delete ctx11._removeMirroring;
                    };
                    ctx11.save = function ctxSave11() {
                        destCtx11.save();
                        this.__originalSave();
                    };
                    ctx11.restore = function ctxRestore11() {
                        destCtx11.restore();
                        this.__originalRestore();
                    };
                    ctx11.translate = function ctxTranslate11(x41, y41) {
                        destCtx11.translate(x41, y41);
                        this.__originalTranslate(x41, y41);
                    };
                    ctx11.scale = function ctxScale11(x41, y41) {
                        destCtx11.scale(x41, y41);
                        this.__originalScale(x41, y41);
                    };
                    ctx11.transform = function ctxTransform11(a11, b41, c41, d51, e11, f11) {
                        destCtx11.transform(a11, b41, c41, d51, e11, f11);
                        this.__originalTransform(a11, b41, c41, d51, e11, f11);
                    };
                    ctx11.setTransform = function ctxSetTransform11(a11, b41, c41, d51, e11, f11) {
                        destCtx11.setTransform(a11, b41, c41, d51, e11, f11);
                        this.__originalSetTransform(a11, b41, c41, d51, e11, f11);
                    };
                    ctx11.resetTransform = function ctxResetTransform11() {
                        destCtx11.resetTransform();
                        this.__originalResetTransform();
                    };
                    ctx11.rotate = function ctxRotate11(angle11) {
                        destCtx11.rotate(angle11);
                        this.__originalRotate(angle11);
                    };
                    ctx11.clip = function ctxRotate11(rule11) {
                        destCtx11.clip(rule11);
                        this.__originalClip(rule11);
                    };
                    ctx11.moveTo = function(x41, y41) {
                        destCtx11.moveTo(x41, y41);
                        this.__originalMoveTo(x41, y41);
                    };
                    ctx11.lineTo = function(x41, y41) {
                        destCtx11.lineTo(x41, y41);
                        this.__originalLineTo(x41, y41);
                    };
                    ctx11.bezierCurveTo = function(cp1x11, cp1y11, cp2x11, cp2y11, x41, y41) {
                        destCtx11.bezierCurveTo(cp1x11, cp1y11, cp2x11, cp2y11, x41, y41);
                        this.__originalBezierCurveTo(cp1x11, cp1y11, cp2x11, cp2y11, x41, y41);
                    };
                    ctx11.rect = function(x41, y41, width21, height11) {
                        destCtx11.rect(x41, y41, width21, height11);
                        this.__originalRect(x41, y41, width21, height11);
                    };
                    ctx11.closePath = function() {
                        destCtx11.closePath();
                        this.__originalClosePath();
                    };
                    ctx11.beginPath = function() {
                        destCtx11.beginPath();
                        this.__originalBeginPath();
                    };
                }
                class CachedCanvases11 {
                    constructor(canvasFactory11){
                        this.canvasFactory = canvasFactory11;
                        this.cache = Object.create(null);
                    }
                    getCanvas(id11, width21, height11) {
                        let canvasEntry11;
                        if (this.cache[id11] !== undefined) {
                            canvasEntry11 = this.cache[id11];
                            this.canvasFactory.reset(canvasEntry11, width21, height11);
                        } else {
                            canvasEntry11 = this.canvasFactory.create(width21, height11);
                            this.cache[id11] = canvasEntry11;
                        }
                        return canvasEntry11;
                    }
                    delete(id11) {
                        delete this.cache[id11];
                    }
                    clear() {
                        for(const id11 in this.cache){
                            const canvasEntry11 = this.cache[id11];
                            this.canvasFactory.destroy(canvasEntry11);
                            delete this.cache[id11];
                        }
                    }
                }
                function drawImageAtIntegerCoords11(ctx11, srcImg11, srcX11, srcY11, srcW11, srcH11, destX11, destY11, destW11, destH11) {
                    const [a11, b41, c41, d51, tx21, ty21] = (0, _display_utils11.getCurrentTransform)(ctx11);
                    if (b41 === 0 && c41 === 0) {
                        const tlX11 = destX11 * a11 + tx21;
                        const rTlX11 = Math.round(tlX11);
                        const tlY11 = destY11 * d51 + ty21;
                        const rTlY11 = Math.round(tlY11);
                        const brX11 = (destX11 + destW11) * a11 + tx21;
                        const rWidth11 = Math.abs(Math.round(brX11) - rTlX11) || 1;
                        const brY11 = (destY11 + destH11) * d51 + ty21;
                        const rHeight11 = Math.abs(Math.round(brY11) - rTlY11) || 1;
                        ctx11.setTransform(Math.sign(a11), 0, 0, Math.sign(d51), rTlX11, rTlY11);
                        ctx11.drawImage(srcImg11, srcX11, srcY11, srcW11, srcH11, 0, 0, rWidth11, rHeight11);
                        ctx11.setTransform(a11, b41, c41, d51, tx21, ty21);
                        return [
                            rWidth11,
                            rHeight11
                        ];
                    }
                    if (a11 === 0 && d51 === 0) {
                        const tlX11 = destY11 * c41 + tx21;
                        const rTlX11 = Math.round(tlX11);
                        const tlY11 = destX11 * b41 + ty21;
                        const rTlY11 = Math.round(tlY11);
                        const brX11 = (destY11 + destH11) * c41 + tx21;
                        const rWidth11 = Math.abs(Math.round(brX11) - rTlX11) || 1;
                        const brY11 = (destX11 + destW11) * b41 + ty21;
                        const rHeight11 = Math.abs(Math.round(brY11) - rTlY11) || 1;
                        ctx11.setTransform(0, Math.sign(b41), Math.sign(c41), 0, rTlX11, rTlY11);
                        ctx11.drawImage(srcImg11, srcX11, srcY11, srcW11, srcH11, 0, 0, rHeight11, rWidth11);
                        ctx11.setTransform(a11, b41, c41, d51, tx21, ty21);
                        return [
                            rHeight11,
                            rWidth11
                        ];
                    }
                    ctx11.drawImage(srcImg11, srcX11, srcY11, srcW11, srcH11, destX11, destY11, destW11, destH11);
                    const scaleX11 = Math.hypot(a11, b41);
                    const scaleY11 = Math.hypot(c41, d51);
                    return [
                        scaleX11 * destW11,
                        scaleY11 * destH11
                    ];
                }
                function compileType3Glyph11(imgData11) {
                    const { width: width21, height: height11 } = imgData11;
                    if (width21 > MAX_SIZE_TO_COMPILE11 || height11 > MAX_SIZE_TO_COMPILE11) return null;
                    const POINT_TO_PROCESS_LIMIT11 = 1000;
                    const POINT_TYPES11 = new Uint8Array([
                        0,
                        2,
                        4,
                        0,
                        1,
                        0,
                        5,
                        4,
                        8,
                        10,
                        0,
                        8,
                        0,
                        2,
                        1,
                        0
                    ]);
                    const width111 = width21 + 1;
                    let points11 = new Uint8Array(width111 * (height11 + 1));
                    let i11, j11, j011;
                    const lineSize11 = width21 + 7 & -8;
                    let data11 = new Uint8Array(lineSize11 * height11), pos11 = 0;
                    for (const elem11 of imgData11.data){
                        let mask11 = 128;
                        while(mask11 > 0){
                            data11[pos11++] = elem11 & mask11 ? 0 : 255;
                            mask11 >>= 1;
                        }
                    }
                    let count11 = 0;
                    pos11 = 0;
                    if (data11[pos11] !== 0) {
                        points11[0] = 1;
                        ++count11;
                    }
                    for(j11 = 1; j11 < width21; j11++){
                        if (data11[pos11] !== data11[pos11 + 1]) {
                            points11[j11] = data11[pos11] ? 2 : 1;
                            ++count11;
                        }
                        pos11++;
                    }
                    if (data11[pos11] !== 0) {
                        points11[j11] = 2;
                        ++count11;
                    }
                    for(i11 = 1; i11 < height11; i11++){
                        pos11 = i11 * lineSize11;
                        j011 = i11 * width111;
                        if (data11[pos11 - lineSize11] !== data11[pos11]) {
                            points11[j011] = data11[pos11] ? 1 : 8;
                            ++count11;
                        }
                        let sum11 = (data11[pos11] ? 4 : 0) + (data11[pos11 - lineSize11] ? 8 : 0);
                        for(j11 = 1; j11 < width21; j11++){
                            sum11 = (sum11 >> 2) + (data11[pos11 + 1] ? 4 : 0) + (data11[pos11 - lineSize11 + 1] ? 8 : 0);
                            if (POINT_TYPES11[sum11]) {
                                points11[j011 + j11] = POINT_TYPES11[sum11];
                                ++count11;
                            }
                            pos11++;
                        }
                        if (data11[pos11 - lineSize11] !== data11[pos11]) {
                            points11[j011 + j11] = data11[pos11] ? 2 : 4;
                            ++count11;
                        }
                        if (count11 > POINT_TO_PROCESS_LIMIT11) return null;
                    }
                    pos11 = lineSize11 * (height11 - 1);
                    j011 = i11 * width111;
                    if (data11[pos11] !== 0) {
                        points11[j011] = 8;
                        ++count11;
                    }
                    for(j11 = 1; j11 < width21; j11++){
                        if (data11[pos11] !== data11[pos11 + 1]) {
                            points11[j011 + j11] = data11[pos11] ? 4 : 8;
                            ++count11;
                        }
                        pos11++;
                    }
                    if (data11[pos11] !== 0) {
                        points11[j011 + j11] = 4;
                        ++count11;
                    }
                    if (count11 > POINT_TO_PROCESS_LIMIT11) return null;
                    const steps11 = new Int32Array([
                        0,
                        width111,
                        -1,
                        0,
                        -width111,
                        0,
                        0,
                        0,
                        1
                    ]);
                    const path11 = new Path2D();
                    for(i11 = 0; count11 && i11 <= height11; i11++){
                        let p51 = i11 * width111;
                        const end11 = p51 + width21;
                        while(p51 < end11 && !points11[p51])p51++;
                        if (p51 === end11) continue;
                        path11.moveTo(p51 % width111, i11);
                        const p011 = p51;
                        let type11 = points11[p51];
                        do {
                            const step11 = steps11[type11];
                            do p51 += step11;
                            while (!points11[p51]);
                            const pp11 = points11[p51];
                            if (pp11 !== 5 && pp11 !== 10) {
                                type11 = pp11;
                                points11[p51] = 0;
                            } else {
                                type11 = pp11 & 0x33 * type11 >> 4;
                                points11[p51] &= type11 >> 2 | type11 << 2;
                            }
                            path11.lineTo(p51 % width111, p51 / width111 | 0);
                            if (!points11[p51]) --count11;
                        }while (p011 !== p51);
                        --i11;
                    }
                    data11 = null;
                    points11 = null;
                    const drawOutline11 = function(c41) {
                        c41.save();
                        c41.scale(1 / width21, -1 / height11);
                        c41.translate(0, -height11);
                        c41.fill(path11);
                        c41.beginPath();
                        c41.restore();
                    };
                    return drawOutline11;
                }
                class CanvasExtraState11 {
                    constructor(width21, height11){
                        this.alphaIsShape = false;
                        this.fontSize = 0;
                        this.fontSizeScale = 1;
                        this.textMatrix = _util11.IDENTITY_MATRIX;
                        this.textMatrixScale = 1;
                        this.fontMatrix = _util11.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRenderingMode = _util11.TextRenderingMode.FILL;
                        this.textRise = 0;
                        this.fillColor = "#000000";
                        this.strokeColor = "#000000";
                        this.patternFill = false;
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.activeSMask = null;
                        this.transferMaps = "none";
                        this.startNewPathAndClipBox([
                            0,
                            0,
                            width21,
                            height11
                        ]);
                    }
                    clone() {
                        const clone11 = Object.create(this);
                        clone11.clipBox = this.clipBox.slice();
                        return clone11;
                    }
                    setCurrentPoint(x41, y41) {
                        this.x = x41;
                        this.y = y41;
                    }
                    updatePathMinMax(transform11, x41, y41) {
                        [x41, y41] = _util11.Util.applyTransform([
                            x41,
                            y41
                        ], transform11);
                        this.minX = Math.min(this.minX, x41);
                        this.minY = Math.min(this.minY, y41);
                        this.maxX = Math.max(this.maxX, x41);
                        this.maxY = Math.max(this.maxY, y41);
                    }
                    updateRectMinMax(transform11, rect31) {
                        const p121 = _util11.Util.applyTransform(rect31, transform11);
                        const p221 = _util11.Util.applyTransform(rect31.slice(2), transform11);
                        this.minX = Math.min(this.minX, p121[0], p221[0]);
                        this.minY = Math.min(this.minY, p121[1], p221[1]);
                        this.maxX = Math.max(this.maxX, p121[0], p221[0]);
                        this.maxY = Math.max(this.maxY, p121[1], p221[1]);
                    }
                    updateScalingPathMinMax(transform11, minMax11) {
                        _util11.Util.scaleMinMax(transform11, minMax11);
                        this.minX = Math.min(this.minX, minMax11[0]);
                        this.maxX = Math.max(this.maxX, minMax11[1]);
                        this.minY = Math.min(this.minY, minMax11[2]);
                        this.maxY = Math.max(this.maxY, minMax11[3]);
                    }
                    updateCurvePathMinMax(transform11, x011, y011, x111, y111, x211, y211, x311, y311, minMax11) {
                        const box11 = _util11.Util.bezierBoundingBox(x011, y011, x111, y111, x211, y211, x311, y311);
                        if (minMax11) {
                            minMax11[0] = Math.min(minMax11[0], box11[0], box11[2]);
                            minMax11[1] = Math.max(minMax11[1], box11[0], box11[2]);
                            minMax11[2] = Math.min(minMax11[2], box11[1], box11[3]);
                            minMax11[3] = Math.max(minMax11[3], box11[1], box11[3]);
                            return;
                        }
                        this.updateRectMinMax(transform11, box11);
                    }
                    getPathBoundingBox(pathType11 = _pattern_helper11.PathType.FILL, transform11 = null) {
                        const box11 = [
                            this.minX,
                            this.minY,
                            this.maxX,
                            this.maxY
                        ];
                        if (pathType11 === _pattern_helper11.PathType.STROKE) {
                            if (!transform11) (0, _util11.unreachable)("Stroke bounding box must include transform.");
                            const scale11 = _util11.Util.singularValueDecompose2dScale(transform11);
                            const xStrokePad11 = scale11[0] * this.lineWidth / 2;
                            const yStrokePad11 = scale11[1] * this.lineWidth / 2;
                            box11[0] -= xStrokePad11;
                            box11[1] -= yStrokePad11;
                            box11[2] += xStrokePad11;
                            box11[3] += yStrokePad11;
                        }
                        return box11;
                    }
                    updateClipFromPath() {
                        const intersect11 = _util11.Util.intersect(this.clipBox, this.getPathBoundingBox());
                        this.startNewPathAndClipBox(intersect11 || [
                            0,
                            0,
                            0,
                            0
                        ]);
                    }
                    isEmptyClip() {
                        return this.minX === Infinity;
                    }
                    startNewPathAndClipBox(box11) {
                        this.clipBox = box11;
                        this.minX = Infinity;
                        this.minY = Infinity;
                        this.maxX = 0;
                        this.maxY = 0;
                    }
                    getClippedPathBoundingBox(pathType11 = _pattern_helper11.PathType.FILL, transform11 = null) {
                        return _util11.Util.intersect(this.clipBox, this.getPathBoundingBox(pathType11, transform11));
                    }
                }
                function putBinaryImageData11(ctx11, imgData11) {
                    if (typeof ImageData !== "undefined" && imgData11 instanceof ImageData) {
                        ctx11.putImageData(imgData11, 0, 0);
                        return;
                    }
                    const height11 = imgData11.height, width21 = imgData11.width;
                    const partialChunkHeight11 = height11 % FULL_CHUNK_HEIGHT11;
                    const fullChunks11 = (height11 - partialChunkHeight11) / FULL_CHUNK_HEIGHT11;
                    const totalChunks11 = partialChunkHeight11 === 0 ? fullChunks11 : fullChunks11 + 1;
                    const chunkImgData11 = ctx11.createImageData(width21, FULL_CHUNK_HEIGHT11);
                    let srcPos11 = 0, destPos11;
                    const src11 = imgData11.data;
                    const dest11 = chunkImgData11.data;
                    let i11, j11, thisChunkHeight11, elemsInThisChunk11;
                    if (imgData11.kind === _util11.ImageKind.GRAYSCALE_1BPP) {
                        const srcLength11 = src11.byteLength;
                        const dest3211 = new Uint32Array(dest11.buffer, 0, dest11.byteLength >> 2);
                        const dest32DataLength11 = dest3211.length;
                        const fullSrcDiff11 = width21 + 7 >> 3;
                        const white11 = 0xffffffff;
                        const black11 = _util11.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
                        for(i11 = 0; i11 < totalChunks11; i11++){
                            thisChunkHeight11 = i11 < fullChunks11 ? FULL_CHUNK_HEIGHT11 : partialChunkHeight11;
                            destPos11 = 0;
                            for(j11 = 0; j11 < thisChunkHeight11; j11++){
                                const srcDiff11 = srcLength11 - srcPos11;
                                let k31 = 0;
                                const kEnd11 = srcDiff11 > fullSrcDiff11 ? width21 : srcDiff11 * 8 - 7;
                                const kEndUnrolled11 = kEnd11 & -8;
                                let mask11 = 0;
                                let srcByte11 = 0;
                                for(; k31 < kEndUnrolled11; k31 += 8){
                                    srcByte11 = src11[srcPos11++];
                                    dest3211[destPos11++] = srcByte11 & 128 ? white11 : black11;
                                    dest3211[destPos11++] = srcByte11 & 64 ? white11 : black11;
                                    dest3211[destPos11++] = srcByte11 & 32 ? white11 : black11;
                                    dest3211[destPos11++] = srcByte11 & 16 ? white11 : black11;
                                    dest3211[destPos11++] = srcByte11 & 8 ? white11 : black11;
                                    dest3211[destPos11++] = srcByte11 & 4 ? white11 : black11;
                                    dest3211[destPos11++] = srcByte11 & 2 ? white11 : black11;
                                    dest3211[destPos11++] = srcByte11 & 1 ? white11 : black11;
                                }
                                for(; k31 < kEnd11; k31++){
                                    if (mask11 === 0) {
                                        srcByte11 = src11[srcPos11++];
                                        mask11 = 128;
                                    }
                                    dest3211[destPos11++] = srcByte11 & mask11 ? white11 : black11;
                                    mask11 >>= 1;
                                }
                            }
                            while(destPos11 < dest32DataLength11)dest3211[destPos11++] = 0;
                            ctx11.putImageData(chunkImgData11, 0, i11 * FULL_CHUNK_HEIGHT11);
                        }
                    } else if (imgData11.kind === _util11.ImageKind.RGBA_32BPP) {
                        j11 = 0;
                        elemsInThisChunk11 = width21 * FULL_CHUNK_HEIGHT11 * 4;
                        for(i11 = 0; i11 < fullChunks11; i11++){
                            dest11.set(src11.subarray(srcPos11, srcPos11 + elemsInThisChunk11));
                            srcPos11 += elemsInThisChunk11;
                            ctx11.putImageData(chunkImgData11, 0, j11);
                            j11 += FULL_CHUNK_HEIGHT11;
                        }
                        if (i11 < totalChunks11) {
                            elemsInThisChunk11 = width21 * partialChunkHeight11 * 4;
                            dest11.set(src11.subarray(srcPos11, srcPos11 + elemsInThisChunk11));
                            ctx11.putImageData(chunkImgData11, 0, j11);
                        }
                    } else if (imgData11.kind === _util11.ImageKind.RGB_24BPP) {
                        thisChunkHeight11 = FULL_CHUNK_HEIGHT11;
                        elemsInThisChunk11 = width21 * thisChunkHeight11;
                        for(i11 = 0; i11 < totalChunks11; i11++){
                            if (i11 >= fullChunks11) {
                                thisChunkHeight11 = partialChunkHeight11;
                                elemsInThisChunk11 = width21 * thisChunkHeight11;
                            }
                            destPos11 = 0;
                            for(j11 = elemsInThisChunk11; j11--;){
                                dest11[destPos11++] = src11[srcPos11++];
                                dest11[destPos11++] = src11[srcPos11++];
                                dest11[destPos11++] = src11[srcPos11++];
                                dest11[destPos11++] = 255;
                            }
                            ctx11.putImageData(chunkImgData11, 0, i11 * FULL_CHUNK_HEIGHT11);
                        }
                    } else throw new Error(`bad image kind: ${imgData11.kind}`);
                }
                function putBinaryImageMask11(ctx11, imgData11) {
                    if (imgData11.bitmap) {
                        ctx11.drawImage(imgData11.bitmap, 0, 0);
                        return;
                    }
                    const height11 = imgData11.height, width21 = imgData11.width;
                    const partialChunkHeight11 = height11 % FULL_CHUNK_HEIGHT11;
                    const fullChunks11 = (height11 - partialChunkHeight11) / FULL_CHUNK_HEIGHT11;
                    const totalChunks11 = partialChunkHeight11 === 0 ? fullChunks11 : fullChunks11 + 1;
                    const chunkImgData11 = ctx11.createImageData(width21, FULL_CHUNK_HEIGHT11);
                    let srcPos11 = 0;
                    const src11 = imgData11.data;
                    const dest11 = chunkImgData11.data;
                    for(let i11 = 0; i11 < totalChunks11; i11++){
                        const thisChunkHeight11 = i11 < fullChunks11 ? FULL_CHUNK_HEIGHT11 : partialChunkHeight11;
                        ({ srcPos: srcPos11 } = (0, _image_utils11.convertBlackAndWhiteToRGBA)({
                            src: src11,
                            srcPos: srcPos11,
                            dest: dest11,
                            width: width21,
                            height: thisChunkHeight11,
                            nonBlackColor: 0
                        }));
                        ctx11.putImageData(chunkImgData11, 0, i11 * FULL_CHUNK_HEIGHT11);
                    }
                }
                function copyCtxState11(sourceCtx11, destCtx11) {
                    const properties11 = [
                        "strokeStyle",
                        "fillStyle",
                        "fillRule",
                        "globalAlpha",
                        "lineWidth",
                        "lineCap",
                        "lineJoin",
                        "miterLimit",
                        "globalCompositeOperation",
                        "font",
                        "filter"
                    ];
                    for (const property11 of properties11)if (sourceCtx11[property11] !== undefined) destCtx11[property11] = sourceCtx11[property11];
                    if (sourceCtx11.setLineDash !== undefined) {
                        destCtx11.setLineDash(sourceCtx11.getLineDash());
                        destCtx11.lineDashOffset = sourceCtx11.lineDashOffset;
                    }
                }
                function resetCtxToDefault11(ctx11) {
                    ctx11.strokeStyle = ctx11.fillStyle = "#000000";
                    ctx11.fillRule = "nonzero";
                    ctx11.globalAlpha = 1;
                    ctx11.lineWidth = 1;
                    ctx11.lineCap = "butt";
                    ctx11.lineJoin = "miter";
                    ctx11.miterLimit = 10;
                    ctx11.globalCompositeOperation = "source-over";
                    ctx11.font = "10px sans-serif";
                    if (ctx11.setLineDash !== undefined) {
                        ctx11.setLineDash([]);
                        ctx11.lineDashOffset = 0;
                    }
                    if (!_util11.isNodeJS) {
                        const { filter: filter11 } = ctx11;
                        if (filter11 !== "none" && filter11 !== "") ctx11.filter = "none";
                    }
                }
                function composeSMaskBackdrop11(bytes11, r011, g011, b011) {
                    const length11 = bytes11.length;
                    for(let i11 = 3; i11 < length11; i11 += 4){
                        const alpha11 = bytes11[i11];
                        if (alpha11 === 0) {
                            bytes11[i11 - 3] = r011;
                            bytes11[i11 - 2] = g011;
                            bytes11[i11 - 1] = b011;
                        } else if (alpha11 < 255) {
                            const alpha_11 = 255 - alpha11;
                            bytes11[i11 - 3] = bytes11[i11 - 3] * alpha11 + r011 * alpha_11 >> 8;
                            bytes11[i11 - 2] = bytes11[i11 - 2] * alpha11 + g011 * alpha_11 >> 8;
                            bytes11[i11 - 1] = bytes11[i11 - 1] * alpha11 + b011 * alpha_11 >> 8;
                        }
                    }
                }
                function composeSMaskAlpha11(maskData11, layerData11, transferMap11) {
                    const length11 = maskData11.length;
                    const scale11 = 1 / 255;
                    for(let i11 = 3; i11 < length11; i11 += 4){
                        const alpha11 = transferMap11 ? transferMap11[maskData11[i11]] : maskData11[i11];
                        layerData11[i11] = layerData11[i11] * alpha11 * scale11 | 0;
                    }
                }
                function composeSMaskLuminosity11(maskData11, layerData11, transferMap11) {
                    const length11 = maskData11.length;
                    for(let i11 = 3; i11 < length11; i11 += 4){
                        const y41 = maskData11[i11 - 3] * 77 + maskData11[i11 - 2] * 152 + maskData11[i11 - 1] * 28;
                        layerData11[i11] = transferMap11 ? layerData11[i11] * transferMap11[y41 >> 8] >> 8 : layerData11[i11] * y41 >> 16;
                    }
                }
                function genericComposeSMask11(maskCtx11, layerCtx11, width21, height11, subtype11, backdrop11, transferMap11, layerOffsetX11, layerOffsetY11, maskOffsetX11, maskOffsetY11) {
                    const hasBackdrop11 = !!backdrop11;
                    const r011 = hasBackdrop11 ? backdrop11[0] : 0;
                    const g011 = hasBackdrop11 ? backdrop11[1] : 0;
                    const b011 = hasBackdrop11 ? backdrop11[2] : 0;
                    const composeFn11 = subtype11 === "Luminosity" ? composeSMaskLuminosity11 : composeSMaskAlpha11;
                    const PIXELS_TO_PROCESS11 = 1048576;
                    const chunkSize11 = Math.min(height11, Math.ceil(PIXELS_TO_PROCESS11 / width21));
                    for(let row11 = 0; row11 < height11; row11 += chunkSize11){
                        const chunkHeight11 = Math.min(chunkSize11, height11 - row11);
                        const maskData11 = maskCtx11.getImageData(layerOffsetX11 - maskOffsetX11, row11 + (layerOffsetY11 - maskOffsetY11), width21, chunkHeight11);
                        const layerData11 = layerCtx11.getImageData(layerOffsetX11, row11 + layerOffsetY11, width21, chunkHeight11);
                        if (hasBackdrop11) composeSMaskBackdrop11(maskData11.data, r011, g011, b011);
                        composeFn11(maskData11.data, layerData11.data, transferMap11);
                        layerCtx11.putImageData(layerData11, layerOffsetX11, row11 + layerOffsetY11);
                    }
                }
                function composeSMask11(ctx11, smask11, layerCtx11, layerBox11) {
                    const layerOffsetX11 = layerBox11[0];
                    const layerOffsetY11 = layerBox11[1];
                    const layerWidth11 = layerBox11[2] - layerOffsetX11;
                    const layerHeight11 = layerBox11[3] - layerOffsetY11;
                    if (layerWidth11 === 0 || layerHeight11 === 0) return;
                    genericComposeSMask11(smask11.context, layerCtx11, layerWidth11, layerHeight11, smask11.subtype, smask11.backdrop, smask11.transferMap, layerOffsetX11, layerOffsetY11, smask11.offsetX, smask11.offsetY);
                    ctx11.save();
                    ctx11.globalAlpha = 1;
                    ctx11.globalCompositeOperation = "source-over";
                    ctx11.setTransform(1, 0, 0, 1, 0, 0);
                    ctx11.drawImage(layerCtx11.canvas, 0, 0);
                    ctx11.restore();
                }
                function getImageSmoothingEnabled11(transform11, interpolate11) {
                    const scale11 = _util11.Util.singularValueDecompose2dScale(transform11);
                    scale11[0] = Math.fround(scale11[0]);
                    scale11[1] = Math.fround(scale11[1]);
                    const actualScale11 = Math.fround((globalThis.devicePixelRatio || 1) * _display_utils11.PixelsPerInch.PDF_TO_CSS_UNITS);
                    if (interpolate11 !== undefined) return interpolate11;
                    else if (scale11[0] <= actualScale11 || scale11[1] <= actualScale11) return true;
                    return false;
                }
                const LINE_CAP_STYLES11 = [
                    "butt",
                    "round",
                    "square"
                ];
                const LINE_JOIN_STYLES11 = [
                    "miter",
                    "round",
                    "bevel"
                ];
                const NORMAL_CLIP11 = {};
                const EO_CLIP11 = {};
                class CanvasGraphics11 {
                    constructor(canvasCtx11, commonObjs11, objs11, canvasFactory11, filterFactory11, { optionalContentConfig: optionalContentConfig11, markedContentStack: markedContentStack11 = null }, annotationCanvasMap11, pageColors11){
                        this.ctx = canvasCtx11;
                        this.current = new CanvasExtraState11(this.ctx.canvas.width, this.ctx.canvas.height);
                        this.stateStack = [];
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.res = null;
                        this.xobjs = null;
                        this.commonObjs = commonObjs11;
                        this.objs = objs11;
                        this.canvasFactory = canvasFactory11;
                        this.filterFactory = filterFactory11;
                        this.groupStack = [];
                        this.processingType3 = null;
                        this.baseTransform = null;
                        this.baseTransformStack = [];
                        this.groupLevel = 0;
                        this.smaskStack = [];
                        this.smaskCounter = 0;
                        this.tempSMask = null;
                        this.suspendedCtx = null;
                        this.contentVisible = true;
                        this.markedContentStack = markedContentStack11 || [];
                        this.optionalContentConfig = optionalContentConfig11;
                        this.cachedCanvases = new CachedCanvases11(this.canvasFactory);
                        this.cachedPatterns = new Map();
                        this.annotationCanvasMap = annotationCanvasMap11;
                        this.viewportScale = 1;
                        this.outputScaleX = 1;
                        this.outputScaleY = 1;
                        this.pageColors = pageColors11;
                        this._cachedScaleForStroking = [
                            -1,
                            0
                        ];
                        this._cachedGetSinglePixelWidth = null;
                        this._cachedBitmapsMap = new Map();
                    }
                    getObject(data11, fallback11 = null) {
                        if (typeof data11 === "string") return data11.startsWith("g_") ? this.commonObjs.get(data11) : this.objs.get(data11);
                        return fallback11;
                    }
                    beginDrawing({ transform: transform11, viewport: viewport11, transparency: transparency11 = false, background: background11 = null }) {
                        const width21 = this.ctx.canvas.width;
                        const height11 = this.ctx.canvas.height;
                        const savedFillStyle11 = this.ctx.fillStyle;
                        this.ctx.fillStyle = background11 || "#ffffff";
                        this.ctx.fillRect(0, 0, width21, height11);
                        this.ctx.fillStyle = savedFillStyle11;
                        if (transparency11) {
                            const transparentCanvas11 = this.cachedCanvases.getCanvas("transparent", width21, height11);
                            this.compositeCtx = this.ctx;
                            this.transparentCanvas = transparentCanvas11.canvas;
                            this.ctx = transparentCanvas11.context;
                            this.ctx.save();
                            this.ctx.transform(...(0, _display_utils11.getCurrentTransform)(this.compositeCtx));
                        }
                        this.ctx.save();
                        resetCtxToDefault11(this.ctx);
                        if (transform11) {
                            this.ctx.transform(...transform11);
                            this.outputScaleX = transform11[0];
                            this.outputScaleY = transform11[0];
                        }
                        this.ctx.transform(...viewport11.transform);
                        this.viewportScale = viewport11.scale;
                        this.baseTransform = (0, _display_utils11.getCurrentTransform)(this.ctx);
                    }
                    executeOperatorList(operatorList11, executionStartIdx11, continueCallback11, stepper11) {
                        const argsArray11 = operatorList11.argsArray;
                        const fnArray11 = operatorList11.fnArray;
                        let i11 = executionStartIdx11 || 0;
                        const argsArrayLen11 = argsArray11.length;
                        if (argsArrayLen11 === i11) return i11;
                        const chunkOperations11 = argsArrayLen11 - i11 > EXECUTION_STEPS11 && typeof continueCallback11 === "function";
                        const endTime11 = chunkOperations11 ? Date.now() + EXECUTION_TIME11 : 0;
                        let steps11 = 0;
                        const commonObjs11 = this.commonObjs;
                        const objs11 = this.objs;
                        let fnId11;
                        while(true){
                            if (stepper11 !== undefined && i11 === stepper11.nextBreakPoint) {
                                stepper11.breakIt(i11, continueCallback11);
                                return i11;
                            }
                            fnId11 = fnArray11[i11];
                            if (fnId11 !== _util11.OPS.dependency) this[fnId11].apply(this, argsArray11[i11]);
                            else for (const depObjId11 of argsArray11[i11]){
                                const objsPool11 = depObjId11.startsWith("g_") ? commonObjs11 : objs11;
                                if (!objsPool11.has(depObjId11)) {
                                    objsPool11.get(depObjId11, continueCallback11);
                                    return i11;
                                }
                            }
                            i11++;
                            if (i11 === argsArrayLen11) return i11;
                            if (chunkOperations11 && ++steps11 > EXECUTION_STEPS11) {
                                if (Date.now() > endTime11) {
                                    continueCallback11();
                                    return i11;
                                }
                                steps11 = 0;
                            }
                        }
                    }
                    #restoreInitialState() {
                        while(this.stateStack.length || this.inSMaskMode)this.restore();
                        this.ctx.restore();
                        if (this.transparentCanvas) {
                            this.ctx = this.compositeCtx;
                            this.ctx.save();
                            this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                            this.ctx.drawImage(this.transparentCanvas, 0, 0);
                            this.ctx.restore();
                            this.transparentCanvas = null;
                        }
                    }
                    endDrawing() {
                        this.#restoreInitialState();
                        this.cachedCanvases.clear();
                        this.cachedPatterns.clear();
                        for (const cache11 of this._cachedBitmapsMap.values()){
                            for (const canvas11 of cache11.values())if (typeof HTMLCanvasElement !== "undefined" && canvas11 instanceof HTMLCanvasElement) canvas11.width = canvas11.height = 0;
                            cache11.clear();
                        }
                        this._cachedBitmapsMap.clear();
                        this.#drawFilter();
                    }
                    #drawFilter() {
                        if (this.pageColors) {
                            const hcmFilterId11 = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
                            if (hcmFilterId11 !== "none") {
                                const savedFilter11 = this.ctx.filter;
                                this.ctx.filter = hcmFilterId11;
                                this.ctx.drawImage(this.ctx.canvas, 0, 0);
                                this.ctx.filter = savedFilter11;
                            }
                        }
                    }
                    _scaleImage(img11, inverseTransform11) {
                        const width21 = img11.width;
                        const height11 = img11.height;
                        let widthScale11 = Math.max(Math.hypot(inverseTransform11[0], inverseTransform11[1]), 1);
                        let heightScale11 = Math.max(Math.hypot(inverseTransform11[2], inverseTransform11[3]), 1);
                        let paintWidth11 = width21, paintHeight11 = height11;
                        let tmpCanvasId11 = "prescale1";
                        let tmpCanvas11, tmpCtx11;
                        while(widthScale11 > 2 && paintWidth11 > 1 || heightScale11 > 2 && paintHeight11 > 1){
                            let newWidth11 = paintWidth11, newHeight11 = paintHeight11;
                            if (widthScale11 > 2 && paintWidth11 > 1) {
                                newWidth11 = paintWidth11 >= 16384 ? Math.floor(paintWidth11 / 2) - 1 || 1 : Math.ceil(paintWidth11 / 2);
                                widthScale11 /= paintWidth11 / newWidth11;
                            }
                            if (heightScale11 > 2 && paintHeight11 > 1) {
                                newHeight11 = paintHeight11 >= 16384 ? Math.floor(paintHeight11 / 2) - 1 || 1 : Math.ceil(paintHeight11) / 2;
                                heightScale11 /= paintHeight11 / newHeight11;
                            }
                            tmpCanvas11 = this.cachedCanvases.getCanvas(tmpCanvasId11, newWidth11, newHeight11);
                            tmpCtx11 = tmpCanvas11.context;
                            tmpCtx11.clearRect(0, 0, newWidth11, newHeight11);
                            tmpCtx11.drawImage(img11, 0, 0, paintWidth11, paintHeight11, 0, 0, newWidth11, newHeight11);
                            img11 = tmpCanvas11.canvas;
                            paintWidth11 = newWidth11;
                            paintHeight11 = newHeight11;
                            tmpCanvasId11 = tmpCanvasId11 === "prescale1" ? "prescale2" : "prescale1";
                        }
                        return {
                            img: img11,
                            paintWidth: paintWidth11,
                            paintHeight: paintHeight11
                        };
                    }
                    _createMaskCanvas(img11) {
                        const ctx11 = this.ctx;
                        const { width: width21, height: height11 } = img11;
                        const fillColor11 = this.current.fillColor;
                        const isPatternFill11 = this.current.patternFill;
                        const currentTransform11 = (0, _display_utils11.getCurrentTransform)(ctx11);
                        let cache11, cacheKey11, scaled11, maskCanvas11;
                        if ((img11.bitmap || img11.data) && img11.count > 1) {
                            const mainKey11 = img11.bitmap || img11.data.buffer;
                            cacheKey11 = JSON.stringify(isPatternFill11 ? currentTransform11 : [
                                currentTransform11.slice(0, 4),
                                fillColor11
                            ]);
                            cache11 = this._cachedBitmapsMap.get(mainKey11);
                            if (!cache11) {
                                cache11 = new Map();
                                this._cachedBitmapsMap.set(mainKey11, cache11);
                            }
                            const cachedImage11 = cache11.get(cacheKey11);
                            if (cachedImage11 && !isPatternFill11) {
                                const offsetX11 = Math.round(Math.min(currentTransform11[0], currentTransform11[2]) + currentTransform11[4]);
                                const offsetY11 = Math.round(Math.min(currentTransform11[1], currentTransform11[3]) + currentTransform11[5]);
                                return {
                                    canvas: cachedImage11,
                                    offsetX: offsetX11,
                                    offsetY: offsetY11
                                };
                            }
                            scaled11 = cachedImage11;
                        }
                        if (!scaled11) {
                            maskCanvas11 = this.cachedCanvases.getCanvas("maskCanvas", width21, height11);
                            putBinaryImageMask11(maskCanvas11.context, img11);
                        }
                        let maskToCanvas11 = _util11.Util.transform(currentTransform11, [
                            1 / width21,
                            0,
                            0,
                            -1 / height11,
                            0,
                            0
                        ]);
                        maskToCanvas11 = _util11.Util.transform(maskToCanvas11, [
                            1,
                            0,
                            0,
                            1,
                            0,
                            -height11
                        ]);
                        const cord111 = _util11.Util.applyTransform([
                            0,
                            0
                        ], maskToCanvas11);
                        const cord211 = _util11.Util.applyTransform([
                            width21,
                            height11
                        ], maskToCanvas11);
                        const rect31 = _util11.Util.normalizeRect([
                            cord111[0],
                            cord111[1],
                            cord211[0],
                            cord211[1]
                        ]);
                        const drawnWidth11 = Math.round(rect31[2] - rect31[0]) || 1;
                        const drawnHeight11 = Math.round(rect31[3] - rect31[1]) || 1;
                        const fillCanvas11 = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth11, drawnHeight11);
                        const fillCtx11 = fillCanvas11.context;
                        const offsetX11 = Math.min(cord111[0], cord211[0]);
                        const offsetY11 = Math.min(cord111[1], cord211[1]);
                        fillCtx11.translate(-offsetX11, -offsetY11);
                        fillCtx11.transform(...maskToCanvas11);
                        if (!scaled11) {
                            scaled11 = this._scaleImage(maskCanvas11.canvas, (0, _display_utils11.getCurrentTransformInverse)(fillCtx11));
                            scaled11 = scaled11.img;
                            if (cache11 && isPatternFill11) cache11.set(cacheKey11, scaled11);
                        }
                        fillCtx11.imageSmoothingEnabled = getImageSmoothingEnabled11((0, _display_utils11.getCurrentTransform)(fillCtx11), img11.interpolate);
                        drawImageAtIntegerCoords11(fillCtx11, scaled11, 0, 0, scaled11.width, scaled11.height, 0, 0, width21, height11);
                        fillCtx11.globalCompositeOperation = "source-in";
                        const inverse11 = _util11.Util.transform((0, _display_utils11.getCurrentTransformInverse)(fillCtx11), [
                            1,
                            0,
                            0,
                            1,
                            -offsetX11,
                            -offsetY11
                        ]);
                        fillCtx11.fillStyle = isPatternFill11 ? fillColor11.getPattern(ctx11, this, inverse11, _pattern_helper11.PathType.FILL) : fillColor11;
                        fillCtx11.fillRect(0, 0, width21, height11);
                        if (cache11 && !isPatternFill11) {
                            this.cachedCanvases.delete("fillCanvas");
                            cache11.set(cacheKey11, fillCanvas11.canvas);
                        }
                        return {
                            canvas: fillCanvas11.canvas,
                            offsetX: Math.round(offsetX11),
                            offsetY: Math.round(offsetY11)
                        };
                    }
                    setLineWidth(width21) {
                        if (width21 !== this.current.lineWidth) this._cachedScaleForStroking[0] = -1;
                        this.current.lineWidth = width21;
                        this.ctx.lineWidth = width21;
                    }
                    setLineCap(style11) {
                        this.ctx.lineCap = LINE_CAP_STYLES11[style11];
                    }
                    setLineJoin(style11) {
                        this.ctx.lineJoin = LINE_JOIN_STYLES11[style11];
                    }
                    setMiterLimit(limit11) {
                        this.ctx.miterLimit = limit11;
                    }
                    setDash(dashArray11, dashPhase11) {
                        const ctx11 = this.ctx;
                        if (ctx11.setLineDash !== undefined) {
                            ctx11.setLineDash(dashArray11);
                            ctx11.lineDashOffset = dashPhase11;
                        }
                    }
                    setRenderingIntent(intent11) {}
                    setFlatness(flatness11) {}
                    setGState(states11) {
                        for (const [key11, value11] of states11)switch(key11){
                            case "LW":
                                this.setLineWidth(value11);
                                break;
                            case "LC":
                                this.setLineCap(value11);
                                break;
                            case "LJ":
                                this.setLineJoin(value11);
                                break;
                            case "ML":
                                this.setMiterLimit(value11);
                                break;
                            case "D":
                                this.setDash(value11[0], value11[1]);
                                break;
                            case "RI":
                                this.setRenderingIntent(value11);
                                break;
                            case "FL":
                                this.setFlatness(value11);
                                break;
                            case "Font":
                                this.setFont(value11[0], value11[1]);
                                break;
                            case "CA":
                                this.current.strokeAlpha = value11;
                                break;
                            case "ca":
                                this.current.fillAlpha = value11;
                                this.ctx.globalAlpha = value11;
                                break;
                            case "BM":
                                this.ctx.globalCompositeOperation = value11;
                                break;
                            case "SMask":
                                this.current.activeSMask = value11 ? this.tempSMask : null;
                                this.tempSMask = null;
                                this.checkSMaskState();
                                break;
                            case "TR":
                                this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(value11);
                                break;
                        }
                    }
                    get inSMaskMode() {
                        return !!this.suspendedCtx;
                    }
                    checkSMaskState() {
                        const inSMaskMode11 = this.inSMaskMode;
                        if (this.current.activeSMask && !inSMaskMode11) this.beginSMaskMode();
                        else if (!this.current.activeSMask && inSMaskMode11) this.endSMaskMode();
                    }
                    beginSMaskMode() {
                        if (this.inSMaskMode) throw new Error("beginSMaskMode called while already in smask mode");
                        const drawnWidth11 = this.ctx.canvas.width;
                        const drawnHeight11 = this.ctx.canvas.height;
                        const cacheId11 = "smaskGroupAt" + this.groupLevel;
                        const scratchCanvas11 = this.cachedCanvases.getCanvas(cacheId11, drawnWidth11, drawnHeight11);
                        this.suspendedCtx = this.ctx;
                        this.ctx = scratchCanvas11.context;
                        const ctx11 = this.ctx;
                        ctx11.setTransform(...(0, _display_utils11.getCurrentTransform)(this.suspendedCtx));
                        copyCtxState11(this.suspendedCtx, ctx11);
                        mirrorContextOperations11(ctx11, this.suspendedCtx);
                        this.setGState([
                            [
                                "BM",
                                "source-over"
                            ],
                            [
                                "ca",
                                1
                            ],
                            [
                                "CA",
                                1
                            ]
                        ]);
                    }
                    endSMaskMode() {
                        if (!this.inSMaskMode) throw new Error("endSMaskMode called while not in smask mode");
                        this.ctx._removeMirroring();
                        copyCtxState11(this.ctx, this.suspendedCtx);
                        this.ctx = this.suspendedCtx;
                        this.suspendedCtx = null;
                    }
                    compose(dirtyBox11) {
                        if (!this.current.activeSMask) return;
                        if (!dirtyBox11) dirtyBox11 = [
                            0,
                            0,
                            this.ctx.canvas.width,
                            this.ctx.canvas.height
                        ];
                        else {
                            dirtyBox11[0] = Math.floor(dirtyBox11[0]);
                            dirtyBox11[1] = Math.floor(dirtyBox11[1]);
                            dirtyBox11[2] = Math.ceil(dirtyBox11[2]);
                            dirtyBox11[3] = Math.ceil(dirtyBox11[3]);
                        }
                        const smask11 = this.current.activeSMask;
                        const suspendedCtx11 = this.suspendedCtx;
                        composeSMask11(suspendedCtx11, smask11, this.ctx, dirtyBox11);
                        this.ctx.save();
                        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
                        this.ctx.restore();
                    }
                    save() {
                        if (this.inSMaskMode) {
                            copyCtxState11(this.ctx, this.suspendedCtx);
                            this.suspendedCtx.save();
                        } else this.ctx.save();
                        const old11 = this.current;
                        this.stateStack.push(old11);
                        this.current = old11.clone();
                    }
                    restore() {
                        if (this.stateStack.length === 0 && this.inSMaskMode) this.endSMaskMode();
                        if (this.stateStack.length !== 0) {
                            this.current = this.stateStack.pop();
                            if (this.inSMaskMode) {
                                this.suspendedCtx.restore();
                                copyCtxState11(this.suspendedCtx, this.ctx);
                            } else this.ctx.restore();
                            this.checkSMaskState();
                            this.pendingClip = null;
                            this._cachedScaleForStroking[0] = -1;
                            this._cachedGetSinglePixelWidth = null;
                        }
                    }
                    transform(a11, b41, c41, d51, e11, f11) {
                        this.ctx.transform(a11, b41, c41, d51, e11, f11);
                        this._cachedScaleForStroking[0] = -1;
                        this._cachedGetSinglePixelWidth = null;
                    }
                    constructPath(ops11, args11, minMax11) {
                        const ctx11 = this.ctx;
                        const current11 = this.current;
                        let x41 = current11.x, y41 = current11.y;
                        let startX11, startY11;
                        const currentTransform11 = (0, _display_utils11.getCurrentTransform)(ctx11);
                        const isScalingMatrix11 = currentTransform11[0] === 0 && currentTransform11[3] === 0 || currentTransform11[1] === 0 && currentTransform11[2] === 0;
                        const minMaxForBezier11 = isScalingMatrix11 ? minMax11.slice(0) : null;
                        for(let i11 = 0, j11 = 0, ii11 = ops11.length; i11 < ii11; i11++)switch(ops11[i11] | 0){
                            case _util11.OPS.rectangle:
                                x41 = args11[j11++];
                                y41 = args11[j11++];
                                const width21 = args11[j11++];
                                const height11 = args11[j11++];
                                const xw11 = x41 + width21;
                                const yh11 = y41 + height11;
                                ctx11.moveTo(x41, y41);
                                if (width21 === 0 || height11 === 0) ctx11.lineTo(xw11, yh11);
                                else {
                                    ctx11.lineTo(xw11, y41);
                                    ctx11.lineTo(xw11, yh11);
                                    ctx11.lineTo(x41, yh11);
                                }
                                if (!isScalingMatrix11) current11.updateRectMinMax(currentTransform11, [
                                    x41,
                                    y41,
                                    xw11,
                                    yh11
                                ]);
                                ctx11.closePath();
                                break;
                            case _util11.OPS.moveTo:
                                x41 = args11[j11++];
                                y41 = args11[j11++];
                                ctx11.moveTo(x41, y41);
                                if (!isScalingMatrix11) current11.updatePathMinMax(currentTransform11, x41, y41);
                                break;
                            case _util11.OPS.lineTo:
                                x41 = args11[j11++];
                                y41 = args11[j11++];
                                ctx11.lineTo(x41, y41);
                                if (!isScalingMatrix11) current11.updatePathMinMax(currentTransform11, x41, y41);
                                break;
                            case _util11.OPS.curveTo:
                                startX11 = x41;
                                startY11 = y41;
                                x41 = args11[j11 + 4];
                                y41 = args11[j11 + 5];
                                ctx11.bezierCurveTo(args11[j11], args11[j11 + 1], args11[j11 + 2], args11[j11 + 3], x41, y41);
                                current11.updateCurvePathMinMax(currentTransform11, startX11, startY11, args11[j11], args11[j11 + 1], args11[j11 + 2], args11[j11 + 3], x41, y41, minMaxForBezier11);
                                j11 += 6;
                                break;
                            case _util11.OPS.curveTo2:
                                startX11 = x41;
                                startY11 = y41;
                                ctx11.bezierCurveTo(x41, y41, args11[j11], args11[j11 + 1], args11[j11 + 2], args11[j11 + 3]);
                                current11.updateCurvePathMinMax(currentTransform11, startX11, startY11, x41, y41, args11[j11], args11[j11 + 1], args11[j11 + 2], args11[j11 + 3], minMaxForBezier11);
                                x41 = args11[j11 + 2];
                                y41 = args11[j11 + 3];
                                j11 += 4;
                                break;
                            case _util11.OPS.curveTo3:
                                startX11 = x41;
                                startY11 = y41;
                                x41 = args11[j11 + 2];
                                y41 = args11[j11 + 3];
                                ctx11.bezierCurveTo(args11[j11], args11[j11 + 1], x41, y41, x41, y41);
                                current11.updateCurvePathMinMax(currentTransform11, startX11, startY11, args11[j11], args11[j11 + 1], x41, y41, x41, y41, minMaxForBezier11);
                                j11 += 4;
                                break;
                            case _util11.OPS.closePath:
                                ctx11.closePath();
                                break;
                        }
                        if (isScalingMatrix11) current11.updateScalingPathMinMax(currentTransform11, minMaxForBezier11);
                        current11.setCurrentPoint(x41, y41);
                    }
                    closePath() {
                        this.ctx.closePath();
                    }
                    stroke(consumePath11 = true) {
                        const ctx11 = this.ctx;
                        const strokeColor11 = this.current.strokeColor;
                        ctx11.globalAlpha = this.current.strokeAlpha;
                        if (this.contentVisible) {
                            if (typeof strokeColor11 === "object" && strokeColor11?.getPattern) {
                                ctx11.save();
                                ctx11.strokeStyle = strokeColor11.getPattern(ctx11, this, (0, _display_utils11.getCurrentTransformInverse)(ctx11), _pattern_helper11.PathType.STROKE);
                                this.rescaleAndStroke(false);
                                ctx11.restore();
                            } else this.rescaleAndStroke(true);
                        }
                        if (consumePath11) this.consumePath(this.current.getClippedPathBoundingBox());
                        ctx11.globalAlpha = this.current.fillAlpha;
                    }
                    closeStroke() {
                        this.closePath();
                        this.stroke();
                    }
                    fill(consumePath11 = true) {
                        const ctx11 = this.ctx;
                        const fillColor11 = this.current.fillColor;
                        const isPatternFill11 = this.current.patternFill;
                        let needRestore11 = false;
                        if (isPatternFill11) {
                            ctx11.save();
                            ctx11.fillStyle = fillColor11.getPattern(ctx11, this, (0, _display_utils11.getCurrentTransformInverse)(ctx11), _pattern_helper11.PathType.FILL);
                            needRestore11 = true;
                        }
                        const intersect11 = this.current.getClippedPathBoundingBox();
                        if (this.contentVisible && intersect11 !== null) {
                            if (this.pendingEOFill) {
                                ctx11.fill("evenodd");
                                this.pendingEOFill = false;
                            } else ctx11.fill();
                        }
                        if (needRestore11) ctx11.restore();
                        if (consumePath11) this.consumePath(intersect11);
                    }
                    eoFill() {
                        this.pendingEOFill = true;
                        this.fill();
                    }
                    fillStroke() {
                        this.fill(false);
                        this.stroke(false);
                        this.consumePath();
                    }
                    eoFillStroke() {
                        this.pendingEOFill = true;
                        this.fillStroke();
                    }
                    closeFillStroke() {
                        this.closePath();
                        this.fillStroke();
                    }
                    closeEOFillStroke() {
                        this.pendingEOFill = true;
                        this.closePath();
                        this.fillStroke();
                    }
                    endPath() {
                        this.consumePath();
                    }
                    clip() {
                        this.pendingClip = NORMAL_CLIP11;
                    }
                    eoClip() {
                        this.pendingClip = EO_CLIP11;
                    }
                    beginText() {
                        this.current.textMatrix = _util11.IDENTITY_MATRIX;
                        this.current.textMatrixScale = 1;
                        this.current.x = this.current.lineX = 0;
                        this.current.y = this.current.lineY = 0;
                    }
                    endText() {
                        const paths11 = this.pendingTextPaths;
                        const ctx11 = this.ctx;
                        if (paths11 === undefined) {
                            ctx11.beginPath();
                            return;
                        }
                        ctx11.save();
                        ctx11.beginPath();
                        for (const path11 of paths11){
                            ctx11.setTransform(...path11.transform);
                            ctx11.translate(path11.x, path11.y);
                            path11.addToPath(ctx11, path11.fontSize);
                        }
                        ctx11.restore();
                        ctx11.clip();
                        ctx11.beginPath();
                        delete this.pendingTextPaths;
                    }
                    setCharSpacing(spacing11) {
                        this.current.charSpacing = spacing11;
                    }
                    setWordSpacing(spacing11) {
                        this.current.wordSpacing = spacing11;
                    }
                    setHScale(scale11) {
                        this.current.textHScale = scale11 / 100;
                    }
                    setLeading(leading11) {
                        this.current.leading = -leading11;
                    }
                    setFont(fontRefName11, size11) {
                        const fontObj11 = this.commonObjs.get(fontRefName11);
                        const current11 = this.current;
                        if (!fontObj11) throw new Error(`Can't find font for ${fontRefName11}`);
                        current11.fontMatrix = fontObj11.fontMatrix || _util11.FONT_IDENTITY_MATRIX;
                        if (current11.fontMatrix[0] === 0 || current11.fontMatrix[3] === 0) (0, _util11.warn)("Invalid font matrix for font " + fontRefName11);
                        if (size11 < 0) {
                            size11 = -size11;
                            current11.fontDirection = -1;
                        } else current11.fontDirection = 1;
                        this.current.font = fontObj11;
                        this.current.fontSize = size11;
                        if (fontObj11.isType3Font) return;
                        const name11 = fontObj11.loadedName || "sans-serif";
                        const typeface11 = fontObj11.systemFontInfo?.css || `"${name11}", ${fontObj11.fallbackName}`;
                        let bold11 = "normal";
                        if (fontObj11.black) bold11 = "900";
                        else if (fontObj11.bold) bold11 = "bold";
                        const italic11 = fontObj11.italic ? "italic" : "normal";
                        let browserFontSize11 = size11;
                        if (size11 < MIN_FONT_SIZE11) browserFontSize11 = MIN_FONT_SIZE11;
                        else if (size11 > MAX_FONT_SIZE11) browserFontSize11 = MAX_FONT_SIZE11;
                        this.current.fontSizeScale = size11 / browserFontSize11;
                        this.ctx.font = `${italic11} ${bold11} ${browserFontSize11}px ${typeface11}`;
                    }
                    setTextRenderingMode(mode11) {
                        this.current.textRenderingMode = mode11;
                    }
                    setTextRise(rise11) {
                        this.current.textRise = rise11;
                    }
                    moveText(x41, y41) {
                        this.current.x = this.current.lineX += x41;
                        this.current.y = this.current.lineY += y41;
                    }
                    setLeadingMoveText(x41, y41) {
                        this.setLeading(-y41);
                        this.moveText(x41, y41);
                    }
                    setTextMatrix(a11, b41, c41, d51, e11, f11) {
                        this.current.textMatrix = [
                            a11,
                            b41,
                            c41,
                            d51,
                            e11,
                            f11
                        ];
                        this.current.textMatrixScale = Math.hypot(a11, b41);
                        this.current.x = this.current.lineX = 0;
                        this.current.y = this.current.lineY = 0;
                    }
                    nextLine() {
                        this.moveText(0, this.current.leading);
                    }
                    paintChar(character11, x41, y41, patternTransform11) {
                        const ctx11 = this.ctx;
                        const current11 = this.current;
                        const font11 = current11.font;
                        const textRenderingMode11 = current11.textRenderingMode;
                        const fontSize11 = current11.fontSize / current11.fontSizeScale;
                        const fillStrokeMode11 = textRenderingMode11 & _util11.TextRenderingMode.FILL_STROKE_MASK;
                        const isAddToPathSet11 = !!(textRenderingMode11 & _util11.TextRenderingMode.ADD_TO_PATH_FLAG);
                        const patternFill11 = current11.patternFill && !font11.missingFile;
                        let addToPath11;
                        if (font11.disableFontFace || isAddToPathSet11 || patternFill11) addToPath11 = font11.getPathGenerator(this.commonObjs, character11);
                        if (font11.disableFontFace || patternFill11) {
                            ctx11.save();
                            ctx11.translate(x41, y41);
                            ctx11.beginPath();
                            addToPath11(ctx11, fontSize11);
                            if (patternTransform11) ctx11.setTransform(...patternTransform11);
                            if (fillStrokeMode11 === _util11.TextRenderingMode.FILL || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) ctx11.fill();
                            if (fillStrokeMode11 === _util11.TextRenderingMode.STROKE || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) ctx11.stroke();
                            ctx11.restore();
                        } else {
                            if (fillStrokeMode11 === _util11.TextRenderingMode.FILL || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) ctx11.fillText(character11, x41, y41);
                            if (fillStrokeMode11 === _util11.TextRenderingMode.STROKE || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) ctx11.strokeText(character11, x41, y41);
                        }
                        if (isAddToPathSet11) {
                            const paths11 = this.pendingTextPaths ||= [];
                            paths11.push({
                                transform: (0, _display_utils11.getCurrentTransform)(ctx11),
                                x: x41,
                                y: y41,
                                fontSize: fontSize11,
                                addToPath: addToPath11
                            });
                        }
                    }
                    get isFontSubpixelAAEnabled() {
                        const { context: ctx11 } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
                        ctx11.scale(1.5, 1);
                        ctx11.fillText("I", 0, 10);
                        const data11 = ctx11.getImageData(0, 0, 10, 10).data;
                        let enabled11 = false;
                        for(let i11 = 3; i11 < data11.length; i11 += 4)if (data11[i11] > 0 && data11[i11] < 255) {
                            enabled11 = true;
                            break;
                        }
                        return (0, _util11.shadow)(this, "isFontSubpixelAAEnabled", enabled11);
                    }
                    showText(glyphs11) {
                        const current11 = this.current;
                        const font11 = current11.font;
                        if (font11.isType3Font) return this.showType3Text(glyphs11);
                        const fontSize11 = current11.fontSize;
                        if (fontSize11 === 0) return undefined;
                        const ctx11 = this.ctx;
                        const fontSizeScale11 = current11.fontSizeScale;
                        const charSpacing11 = current11.charSpacing;
                        const wordSpacing11 = current11.wordSpacing;
                        const fontDirection11 = current11.fontDirection;
                        const textHScale11 = current11.textHScale * fontDirection11;
                        const glyphsLength11 = glyphs11.length;
                        const vertical11 = font11.vertical;
                        const spacingDir11 = vertical11 ? 1 : -1;
                        const defaultVMetrics11 = font11.defaultVMetrics;
                        const widthAdvanceScale11 = fontSize11 * current11.fontMatrix[0];
                        const simpleFillText11 = current11.textRenderingMode === _util11.TextRenderingMode.FILL && !font11.disableFontFace && !current11.patternFill;
                        ctx11.save();
                        ctx11.transform(...current11.textMatrix);
                        ctx11.translate(current11.x, current11.y + current11.textRise);
                        if (fontDirection11 > 0) ctx11.scale(textHScale11, -1);
                        else ctx11.scale(textHScale11, 1);
                        let patternTransform11;
                        if (current11.patternFill) {
                            ctx11.save();
                            const pattern11 = current11.fillColor.getPattern(ctx11, this, (0, _display_utils11.getCurrentTransformInverse)(ctx11), _pattern_helper11.PathType.FILL);
                            patternTransform11 = (0, _display_utils11.getCurrentTransform)(ctx11);
                            ctx11.restore();
                            ctx11.fillStyle = pattern11;
                        }
                        let lineWidth11 = current11.lineWidth;
                        const scale11 = current11.textMatrixScale;
                        if (scale11 === 0 || lineWidth11 === 0) {
                            const fillStrokeMode11 = current11.textRenderingMode & _util11.TextRenderingMode.FILL_STROKE_MASK;
                            if (fillStrokeMode11 === _util11.TextRenderingMode.STROKE || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) lineWidth11 = this.getSinglePixelWidth();
                        } else lineWidth11 /= scale11;
                        if (fontSizeScale11 !== 1.0) {
                            ctx11.scale(fontSizeScale11, fontSizeScale11);
                            lineWidth11 /= fontSizeScale11;
                        }
                        ctx11.lineWidth = lineWidth11;
                        if (font11.isInvalidPDFjsFont) {
                            const chars11 = [];
                            let width21 = 0;
                            for (const glyph11 of glyphs11){
                                chars11.push(glyph11.unicode);
                                width21 += glyph11.width;
                            }
                            ctx11.fillText(chars11.join(""), 0, 0);
                            current11.x += width21 * widthAdvanceScale11 * textHScale11;
                            ctx11.restore();
                            this.compose();
                            return undefined;
                        }
                        let x41 = 0, i11;
                        for(i11 = 0; i11 < glyphsLength11; ++i11){
                            const glyph11 = glyphs11[i11];
                            if (typeof glyph11 === "number") {
                                x41 += spacingDir11 * glyph11 * fontSize11 / 1000;
                                continue;
                            }
                            let restoreNeeded11 = false;
                            const spacing11 = (glyph11.isSpace ? wordSpacing11 : 0) + charSpacing11;
                            const character11 = glyph11.fontChar;
                            const accent11 = glyph11.accent;
                            let scaledX11, scaledY11;
                            let width21 = glyph11.width;
                            if (vertical11) {
                                const vmetric11 = glyph11.vmetric || defaultVMetrics11;
                                const vx11 = -(glyph11.vmetric ? vmetric11[1] : width21 * 0.5) * widthAdvanceScale11;
                                const vy11 = vmetric11[2] * widthAdvanceScale11;
                                width21 = vmetric11 ? -vmetric11[0] : width21;
                                scaledX11 = vx11 / fontSizeScale11;
                                scaledY11 = (x41 + vy11) / fontSizeScale11;
                            } else {
                                scaledX11 = x41 / fontSizeScale11;
                                scaledY11 = 0;
                            }
                            if (font11.remeasure && width21 > 0) {
                                const measuredWidth11 = ctx11.measureText(character11).width * 1000 / fontSize11 * fontSizeScale11;
                                if (width21 < measuredWidth11 && this.isFontSubpixelAAEnabled) {
                                    const characterScaleX11 = width21 / measuredWidth11;
                                    restoreNeeded11 = true;
                                    ctx11.save();
                                    ctx11.scale(characterScaleX11, 1);
                                    scaledX11 /= characterScaleX11;
                                } else if (width21 !== measuredWidth11) scaledX11 += (width21 - measuredWidth11) / 2000 * fontSize11 / fontSizeScale11;
                            }
                            if (this.contentVisible && (glyph11.isInFont || font11.missingFile)) {
                                if (simpleFillText11 && !accent11) ctx11.fillText(character11, scaledX11, scaledY11);
                                else {
                                    this.paintChar(character11, scaledX11, scaledY11, patternTransform11);
                                    if (accent11) {
                                        const scaledAccentX11 = scaledX11 + fontSize11 * accent11.offset.x / fontSizeScale11;
                                        const scaledAccentY11 = scaledY11 - fontSize11 * accent11.offset.y / fontSizeScale11;
                                        this.paintChar(accent11.fontChar, scaledAccentX11, scaledAccentY11, patternTransform11);
                                    }
                                }
                            }
                            const charWidth11 = vertical11 ? width21 * widthAdvanceScale11 - spacing11 * fontDirection11 : width21 * widthAdvanceScale11 + spacing11 * fontDirection11;
                            x41 += charWidth11;
                            if (restoreNeeded11) ctx11.restore();
                        }
                        if (vertical11) current11.y -= x41;
                        else current11.x += x41 * textHScale11;
                        ctx11.restore();
                        this.compose();
                        return undefined;
                    }
                    showType3Text(glyphs11) {
                        const ctx11 = this.ctx;
                        const current11 = this.current;
                        const font11 = current11.font;
                        const fontSize11 = current11.fontSize;
                        const fontDirection11 = current11.fontDirection;
                        const spacingDir11 = font11.vertical ? 1 : -1;
                        const charSpacing11 = current11.charSpacing;
                        const wordSpacing11 = current11.wordSpacing;
                        const textHScale11 = current11.textHScale * fontDirection11;
                        const fontMatrix11 = current11.fontMatrix || _util11.FONT_IDENTITY_MATRIX;
                        const glyphsLength11 = glyphs11.length;
                        const isTextInvisible11 = current11.textRenderingMode === _util11.TextRenderingMode.INVISIBLE;
                        let i11, glyph11, width21, spacingLength11;
                        if (isTextInvisible11 || fontSize11 === 0) return;
                        this._cachedScaleForStroking[0] = -1;
                        this._cachedGetSinglePixelWidth = null;
                        ctx11.save();
                        ctx11.transform(...current11.textMatrix);
                        ctx11.translate(current11.x, current11.y);
                        ctx11.scale(textHScale11, fontDirection11);
                        for(i11 = 0; i11 < glyphsLength11; ++i11){
                            glyph11 = glyphs11[i11];
                            if (typeof glyph11 === "number") {
                                spacingLength11 = spacingDir11 * glyph11 * fontSize11 / 1000;
                                this.ctx.translate(spacingLength11, 0);
                                current11.x += spacingLength11 * textHScale11;
                                continue;
                            }
                            const spacing11 = (glyph11.isSpace ? wordSpacing11 : 0) + charSpacing11;
                            const operatorList11 = font11.charProcOperatorList[glyph11.operatorListId];
                            if (!operatorList11) {
                                (0, _util11.warn)(`Type3 character "${glyph11.operatorListId}" is not available.`);
                                continue;
                            }
                            if (this.contentVisible) {
                                this.processingType3 = glyph11;
                                this.save();
                                ctx11.scale(fontSize11, fontSize11);
                                ctx11.transform(...fontMatrix11);
                                this.executeOperatorList(operatorList11);
                                this.restore();
                            }
                            const transformed11 = _util11.Util.applyTransform([
                                glyph11.width,
                                0
                            ], fontMatrix11);
                            width21 = transformed11[0] * fontSize11 + spacing11;
                            ctx11.translate(width21, 0);
                            current11.x += width21 * textHScale11;
                        }
                        ctx11.restore();
                        this.processingType3 = null;
                    }
                    setCharWidth(xWidth11, yWidth11) {}
                    setCharWidthAndBounds(xWidth11, yWidth11, llx11, lly11, urx11, ury11) {
                        this.ctx.rect(llx11, lly11, urx11 - llx11, ury11 - lly11);
                        this.ctx.clip();
                        this.endPath();
                    }
                    getColorN_Pattern(IR11) {
                        let pattern11;
                        if (IR11[0] === "TilingPattern") {
                            const color11 = IR11[1];
                            const baseTransform11 = this.baseTransform || (0, _display_utils11.getCurrentTransform)(this.ctx);
                            const canvasGraphicsFactory11 = {
                                createCanvasGraphics: (ctx11)=>{
                                    return new CanvasGraphics11(ctx11, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                                        optionalContentConfig: this.optionalContentConfig,
                                        markedContentStack: this.markedContentStack
                                    });
                                }
                            };
                            pattern11 = new _pattern_helper11.TilingPattern(IR11, color11, this.ctx, canvasGraphicsFactory11, baseTransform11);
                        } else pattern11 = this._getPattern(IR11[1], IR11[2]);
                        return pattern11;
                    }
                    setStrokeColorN() {
                        this.current.strokeColor = this.getColorN_Pattern(arguments);
                    }
                    setFillColorN() {
                        this.current.fillColor = this.getColorN_Pattern(arguments);
                        this.current.patternFill = true;
                    }
                    setStrokeRGBColor(r11, g11, b41) {
                        const color11 = _util11.Util.makeHexColor(r11, g11, b41);
                        this.ctx.strokeStyle = color11;
                        this.current.strokeColor = color11;
                    }
                    setFillRGBColor(r11, g11, b41) {
                        const color11 = _util11.Util.makeHexColor(r11, g11, b41);
                        this.ctx.fillStyle = color11;
                        this.current.fillColor = color11;
                        this.current.patternFill = false;
                    }
                    _getPattern(objId11, matrix11 = null) {
                        let pattern11;
                        if (this.cachedPatterns.has(objId11)) pattern11 = this.cachedPatterns.get(objId11);
                        else {
                            pattern11 = (0, _pattern_helper11.getShadingPattern)(this.getObject(objId11));
                            this.cachedPatterns.set(objId11, pattern11);
                        }
                        if (matrix11) pattern11.matrix = matrix11;
                        return pattern11;
                    }
                    shadingFill(objId11) {
                        if (!this.contentVisible) return;
                        const ctx11 = this.ctx;
                        this.save();
                        const pattern11 = this._getPattern(objId11);
                        ctx11.fillStyle = pattern11.getPattern(ctx11, this, (0, _display_utils11.getCurrentTransformInverse)(ctx11), _pattern_helper11.PathType.SHADING);
                        const inv11 = (0, _display_utils11.getCurrentTransformInverse)(ctx11);
                        if (inv11) {
                            const { width: width21, height: height11 } = ctx11.canvas;
                            const [x011, y011, x111, y111] = _util11.Util.getAxialAlignedBoundingBox([
                                0,
                                0,
                                width21,
                                height11
                            ], inv11);
                            this.ctx.fillRect(x011, y011, x111 - x011, y111 - y011);
                        } else this.ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
                        this.compose(this.current.getClippedPathBoundingBox());
                        this.restore();
                    }
                    beginInlineImage() {
                        (0, _util11.unreachable)("Should not call beginInlineImage");
                    }
                    beginImageData() {
                        (0, _util11.unreachable)("Should not call beginImageData");
                    }
                    paintFormXObjectBegin(matrix11, bbox11) {
                        if (!this.contentVisible) return;
                        this.save();
                        this.baseTransformStack.push(this.baseTransform);
                        if (Array.isArray(matrix11) && matrix11.length === 6) this.transform(...matrix11);
                        this.baseTransform = (0, _display_utils11.getCurrentTransform)(this.ctx);
                        if (bbox11) {
                            const width21 = bbox11[2] - bbox11[0];
                            const height11 = bbox11[3] - bbox11[1];
                            this.ctx.rect(bbox11[0], bbox11[1], width21, height11);
                            this.current.updateRectMinMax((0, _display_utils11.getCurrentTransform)(this.ctx), bbox11);
                            this.clip();
                            this.endPath();
                        }
                    }
                    paintFormXObjectEnd() {
                        if (!this.contentVisible) return;
                        this.restore();
                        this.baseTransform = this.baseTransformStack.pop();
                    }
                    beginGroup(group11) {
                        if (!this.contentVisible) return;
                        this.save();
                        if (this.inSMaskMode) {
                            this.endSMaskMode();
                            this.current.activeSMask = null;
                        }
                        const currentCtx11 = this.ctx;
                        if (!group11.isolated) (0, _util11.info)("TODO: Support non-isolated groups.");
                        if (group11.knockout) (0, _util11.warn)("Knockout groups not supported.");
                        const currentTransform11 = (0, _display_utils11.getCurrentTransform)(currentCtx11);
                        if (group11.matrix) currentCtx11.transform(...group11.matrix);
                        if (!group11.bbox) throw new Error("Bounding box is required.");
                        let bounds11 = _util11.Util.getAxialAlignedBoundingBox(group11.bbox, (0, _display_utils11.getCurrentTransform)(currentCtx11));
                        const canvasBounds11 = [
                            0,
                            0,
                            currentCtx11.canvas.width,
                            currentCtx11.canvas.height
                        ];
                        bounds11 = _util11.Util.intersect(bounds11, canvasBounds11) || [
                            0,
                            0,
                            0,
                            0
                        ];
                        const offsetX11 = Math.floor(bounds11[0]);
                        const offsetY11 = Math.floor(bounds11[1]);
                        let drawnWidth11 = Math.max(Math.ceil(bounds11[2]) - offsetX11, 1);
                        let drawnHeight11 = Math.max(Math.ceil(bounds11[3]) - offsetY11, 1);
                        let scaleX11 = 1, scaleY11 = 1;
                        if (drawnWidth11 > MAX_GROUP_SIZE11) {
                            scaleX11 = drawnWidth11 / MAX_GROUP_SIZE11;
                            drawnWidth11 = MAX_GROUP_SIZE11;
                        }
                        if (drawnHeight11 > MAX_GROUP_SIZE11) {
                            scaleY11 = drawnHeight11 / MAX_GROUP_SIZE11;
                            drawnHeight11 = MAX_GROUP_SIZE11;
                        }
                        this.current.startNewPathAndClipBox([
                            0,
                            0,
                            drawnWidth11,
                            drawnHeight11
                        ]);
                        let cacheId11 = "groupAt" + this.groupLevel;
                        if (group11.smask) cacheId11 += "_smask_" + this.smaskCounter++ % 2;
                        const scratchCanvas11 = this.cachedCanvases.getCanvas(cacheId11, drawnWidth11, drawnHeight11);
                        const groupCtx11 = scratchCanvas11.context;
                        groupCtx11.scale(1 / scaleX11, 1 / scaleY11);
                        groupCtx11.translate(-offsetX11, -offsetY11);
                        groupCtx11.transform(...currentTransform11);
                        if (group11.smask) this.smaskStack.push({
                            canvas: scratchCanvas11.canvas,
                            context: groupCtx11,
                            offsetX: offsetX11,
                            offsetY: offsetY11,
                            scaleX: scaleX11,
                            scaleY: scaleY11,
                            subtype: group11.smask.subtype,
                            backdrop: group11.smask.backdrop,
                            transferMap: group11.smask.transferMap || null,
                            startTransformInverse: null
                        });
                        else {
                            currentCtx11.setTransform(1, 0, 0, 1, 0, 0);
                            currentCtx11.translate(offsetX11, offsetY11);
                            currentCtx11.scale(scaleX11, scaleY11);
                            currentCtx11.save();
                        }
                        copyCtxState11(currentCtx11, groupCtx11);
                        this.ctx = groupCtx11;
                        this.setGState([
                            [
                                "BM",
                                "source-over"
                            ],
                            [
                                "ca",
                                1
                            ],
                            [
                                "CA",
                                1
                            ]
                        ]);
                        this.groupStack.push(currentCtx11);
                        this.groupLevel++;
                    }
                    endGroup(group11) {
                        if (!this.contentVisible) return;
                        this.groupLevel--;
                        const groupCtx11 = this.ctx;
                        const ctx11 = this.groupStack.pop();
                        this.ctx = ctx11;
                        this.ctx.imageSmoothingEnabled = false;
                        if (group11.smask) {
                            this.tempSMask = this.smaskStack.pop();
                            this.restore();
                        } else {
                            this.ctx.restore();
                            const currentMtx11 = (0, _display_utils11.getCurrentTransform)(this.ctx);
                            this.restore();
                            this.ctx.save();
                            this.ctx.setTransform(...currentMtx11);
                            const dirtyBox11 = _util11.Util.getAxialAlignedBoundingBox([
                                0,
                                0,
                                groupCtx11.canvas.width,
                                groupCtx11.canvas.height
                            ], currentMtx11);
                            this.ctx.drawImage(groupCtx11.canvas, 0, 0);
                            this.ctx.restore();
                            this.compose(dirtyBox11);
                        }
                    }
                    beginAnnotation(id11, rect31, transform11, matrix11, hasOwnCanvas11) {
                        this.#restoreInitialState();
                        resetCtxToDefault11(this.ctx);
                        this.ctx.save();
                        this.save();
                        if (this.baseTransform) this.ctx.setTransform(...this.baseTransform);
                        if (Array.isArray(rect31) && rect31.length === 4) {
                            const width21 = rect31[2] - rect31[0];
                            const height11 = rect31[3] - rect31[1];
                            if (hasOwnCanvas11 && this.annotationCanvasMap) {
                                transform11 = transform11.slice();
                                transform11[4] -= rect31[0];
                                transform11[5] -= rect31[1];
                                rect31 = rect31.slice();
                                rect31[0] = rect31[1] = 0;
                                rect31[2] = width21;
                                rect31[3] = height11;
                                const [scaleX11, scaleY11] = _util11.Util.singularValueDecompose2dScale((0, _display_utils11.getCurrentTransform)(this.ctx));
                                const { viewportScale: viewportScale11 } = this;
                                const canvasWidth11 = Math.ceil(width21 * this.outputScaleX * viewportScale11);
                                const canvasHeight11 = Math.ceil(height11 * this.outputScaleY * viewportScale11);
                                this.annotationCanvas = this.canvasFactory.create(canvasWidth11, canvasHeight11);
                                const { canvas: canvas11, context: context11 } = this.annotationCanvas;
                                this.annotationCanvasMap.set(id11, canvas11);
                                this.annotationCanvas.savedCtx = this.ctx;
                                this.ctx = context11;
                                this.ctx.save();
                                this.ctx.setTransform(scaleX11, 0, 0, -scaleY11, 0, height11 * scaleY11);
                                resetCtxToDefault11(this.ctx);
                            } else {
                                resetCtxToDefault11(this.ctx);
                                this.ctx.rect(rect31[0], rect31[1], width21, height11);
                                this.ctx.clip();
                                this.endPath();
                            }
                        }
                        this.current = new CanvasExtraState11(this.ctx.canvas.width, this.ctx.canvas.height);
                        this.transform(...transform11);
                        this.transform(...matrix11);
                    }
                    endAnnotation() {
                        if (this.annotationCanvas) {
                            this.ctx.restore();
                            this.#drawFilter();
                            this.ctx = this.annotationCanvas.savedCtx;
                            delete this.annotationCanvas.savedCtx;
                            delete this.annotationCanvas;
                        }
                    }
                    paintImageMaskXObject(img11) {
                        if (!this.contentVisible) return;
                        const count11 = img11.count;
                        img11 = this.getObject(img11.data, img11);
                        img11.count = count11;
                        const ctx11 = this.ctx;
                        const glyph11 = this.processingType3;
                        if (glyph11) {
                            if (glyph11.compiled === undefined) glyph11.compiled = compileType3Glyph11(img11);
                            if (glyph11.compiled) {
                                glyph11.compiled(ctx11);
                                return;
                            }
                        }
                        const mask11 = this._createMaskCanvas(img11);
                        const maskCanvas11 = mask11.canvas;
                        ctx11.save();
                        ctx11.setTransform(1, 0, 0, 1, 0, 0);
                        ctx11.drawImage(maskCanvas11, mask11.offsetX, mask11.offsetY);
                        ctx11.restore();
                        this.compose();
                    }
                    paintImageMaskXObjectRepeat(img11, scaleX11, skewX11 = 0, skewY11 = 0, scaleY11, positions11) {
                        if (!this.contentVisible) return;
                        img11 = this.getObject(img11.data, img11);
                        const ctx11 = this.ctx;
                        ctx11.save();
                        const currentTransform11 = (0, _display_utils11.getCurrentTransform)(ctx11);
                        ctx11.transform(scaleX11, skewX11, skewY11, scaleY11, 0, 0);
                        const mask11 = this._createMaskCanvas(img11);
                        ctx11.setTransform(1, 0, 0, 1, mask11.offsetX - currentTransform11[4], mask11.offsetY - currentTransform11[5]);
                        for(let i11 = 0, ii11 = positions11.length; i11 < ii11; i11 += 2){
                            const trans11 = _util11.Util.transform(currentTransform11, [
                                scaleX11,
                                skewX11,
                                skewY11,
                                scaleY11,
                                positions11[i11],
                                positions11[i11 + 1]
                            ]);
                            const [x41, y41] = _util11.Util.applyTransform([
                                0,
                                0
                            ], trans11);
                            ctx11.drawImage(mask11.canvas, x41, y41);
                        }
                        ctx11.restore();
                        this.compose();
                    }
                    paintImageMaskXObjectGroup(images11) {
                        if (!this.contentVisible) return;
                        const ctx11 = this.ctx;
                        const fillColor11 = this.current.fillColor;
                        const isPatternFill11 = this.current.patternFill;
                        for (const image11 of images11){
                            const { data: data11, width: width21, height: height11, transform: transform11 } = image11;
                            const maskCanvas11 = this.cachedCanvases.getCanvas("maskCanvas", width21, height11);
                            const maskCtx11 = maskCanvas11.context;
                            maskCtx11.save();
                            const img11 = this.getObject(data11, image11);
                            putBinaryImageMask11(maskCtx11, img11);
                            maskCtx11.globalCompositeOperation = "source-in";
                            maskCtx11.fillStyle = isPatternFill11 ? fillColor11.getPattern(maskCtx11, this, (0, _display_utils11.getCurrentTransformInverse)(ctx11), _pattern_helper11.PathType.FILL) : fillColor11;
                            maskCtx11.fillRect(0, 0, width21, height11);
                            maskCtx11.restore();
                            ctx11.save();
                            ctx11.transform(...transform11);
                            ctx11.scale(1, -1);
                            drawImageAtIntegerCoords11(ctx11, maskCanvas11.canvas, 0, 0, width21, height11, 0, -1, 1, 1);
                            ctx11.restore();
                        }
                        this.compose();
                    }
                    paintImageXObject(objId11) {
                        if (!this.contentVisible) return;
                        const imgData11 = this.getObject(objId11);
                        if (!imgData11) {
                            (0, _util11.warn)("Dependent image isn't ready yet");
                            return;
                        }
                        this.paintInlineImageXObject(imgData11);
                    }
                    paintImageXObjectRepeat(objId11, scaleX11, scaleY11, positions11) {
                        if (!this.contentVisible) return;
                        const imgData11 = this.getObject(objId11);
                        if (!imgData11) {
                            (0, _util11.warn)("Dependent image isn't ready yet");
                            return;
                        }
                        const width21 = imgData11.width;
                        const height11 = imgData11.height;
                        const map11 = [];
                        for(let i11 = 0, ii11 = positions11.length; i11 < ii11; i11 += 2)map11.push({
                            transform: [
                                scaleX11,
                                0,
                                0,
                                scaleY11,
                                positions11[i11],
                                positions11[i11 + 1]
                            ],
                            x: 0,
                            y: 0,
                            w: width21,
                            h: height11
                        });
                        this.paintInlineImageXObjectGroup(imgData11, map11);
                    }
                    applyTransferMapsToCanvas(ctx11) {
                        if (this.current.transferMaps !== "none") {
                            ctx11.filter = this.current.transferMaps;
                            ctx11.drawImage(ctx11.canvas, 0, 0);
                            ctx11.filter = "none";
                        }
                        return ctx11.canvas;
                    }
                    applyTransferMapsToBitmap(imgData11) {
                        if (this.current.transferMaps === "none") return imgData11.bitmap;
                        const { bitmap: bitmap11, width: width21, height: height11 } = imgData11;
                        const tmpCanvas11 = this.cachedCanvases.getCanvas("inlineImage", width21, height11);
                        const tmpCtx11 = tmpCanvas11.context;
                        tmpCtx11.filter = this.current.transferMaps;
                        tmpCtx11.drawImage(bitmap11, 0, 0);
                        tmpCtx11.filter = "none";
                        return tmpCanvas11.canvas;
                    }
                    paintInlineImageXObject(imgData11) {
                        if (!this.contentVisible) return;
                        const width21 = imgData11.width;
                        const height11 = imgData11.height;
                        const ctx11 = this.ctx;
                        this.save();
                        if (!_util11.isNodeJS) {
                            const { filter: filter11 } = ctx11;
                            if (filter11 !== "none" && filter11 !== "") ctx11.filter = "none";
                        }
                        ctx11.scale(1 / width21, -1 / height11);
                        let imgToPaint11;
                        if (imgData11.bitmap) imgToPaint11 = this.applyTransferMapsToBitmap(imgData11);
                        else if (typeof HTMLElement === "function" && imgData11 instanceof HTMLElement || !imgData11.data) imgToPaint11 = imgData11;
                        else {
                            const tmpCanvas11 = this.cachedCanvases.getCanvas("inlineImage", width21, height11);
                            const tmpCtx11 = tmpCanvas11.context;
                            putBinaryImageData11(tmpCtx11, imgData11);
                            imgToPaint11 = this.applyTransferMapsToCanvas(tmpCtx11);
                        }
                        const scaled11 = this._scaleImage(imgToPaint11, (0, _display_utils11.getCurrentTransformInverse)(ctx11));
                        ctx11.imageSmoothingEnabled = getImageSmoothingEnabled11((0, _display_utils11.getCurrentTransform)(ctx11), imgData11.interpolate);
                        drawImageAtIntegerCoords11(ctx11, scaled11.img, 0, 0, scaled11.paintWidth, scaled11.paintHeight, 0, -height11, width21, height11);
                        this.compose();
                        this.restore();
                    }
                    paintInlineImageXObjectGroup(imgData11, map11) {
                        if (!this.contentVisible) return;
                        const ctx11 = this.ctx;
                        let imgToPaint11;
                        if (imgData11.bitmap) imgToPaint11 = imgData11.bitmap;
                        else {
                            const w11 = imgData11.width;
                            const h31 = imgData11.height;
                            const tmpCanvas11 = this.cachedCanvases.getCanvas("inlineImage", w11, h31);
                            const tmpCtx11 = tmpCanvas11.context;
                            putBinaryImageData11(tmpCtx11, imgData11);
                            imgToPaint11 = this.applyTransferMapsToCanvas(tmpCtx11);
                        }
                        for (const entry11 of map11){
                            ctx11.save();
                            ctx11.transform(...entry11.transform);
                            ctx11.scale(1, -1);
                            drawImageAtIntegerCoords11(ctx11, imgToPaint11, entry11.x, entry11.y, entry11.w, entry11.h, 0, -1, 1, 1);
                            ctx11.restore();
                        }
                        this.compose();
                    }
                    paintSolidColorImageMask() {
                        if (!this.contentVisible) return;
                        this.ctx.fillRect(0, 0, 1, 1);
                        this.compose();
                    }
                    markPoint(tag11) {}
                    markPointProps(tag11, properties11) {}
                    beginMarkedContent(tag11) {
                        this.markedContentStack.push({
                            visible: true
                        });
                    }
                    beginMarkedContentProps(tag11, properties11) {
                        if (tag11 === "OC") this.markedContentStack.push({
                            visible: this.optionalContentConfig.isVisible(properties11)
                        });
                        else this.markedContentStack.push({
                            visible: true
                        });
                        this.contentVisible = this.isContentVisible();
                    }
                    endMarkedContent() {
                        this.markedContentStack.pop();
                        this.contentVisible = this.isContentVisible();
                    }
                    beginCompat() {}
                    endCompat() {}
                    consumePath(clipBox11) {
                        const isEmpty11 = this.current.isEmptyClip();
                        if (this.pendingClip) this.current.updateClipFromPath();
                        if (!this.pendingClip) this.compose(clipBox11);
                        const ctx11 = this.ctx;
                        if (this.pendingClip) {
                            if (!isEmpty11) {
                                if (this.pendingClip === EO_CLIP11) ctx11.clip("evenodd");
                                else ctx11.clip();
                            }
                            this.pendingClip = null;
                        }
                        this.current.startNewPathAndClipBox(this.current.clipBox);
                        ctx11.beginPath();
                    }
                    getSinglePixelWidth() {
                        if (!this._cachedGetSinglePixelWidth) {
                            const m31 = (0, _display_utils11.getCurrentTransform)(this.ctx);
                            if (m31[1] === 0 && m31[2] === 0) this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m31[0]), Math.abs(m31[3]));
                            else {
                                const absDet11 = Math.abs(m31[0] * m31[3] - m31[2] * m31[1]);
                                const normX11 = Math.hypot(m31[0], m31[2]);
                                const normY11 = Math.hypot(m31[1], m31[3]);
                                this._cachedGetSinglePixelWidth = Math.max(normX11, normY11) / absDet11;
                            }
                        }
                        return this._cachedGetSinglePixelWidth;
                    }
                    getScaleForStroking() {
                        if (this._cachedScaleForStroking[0] === -1) {
                            const { lineWidth: lineWidth11 } = this.current;
                            const { a: a11, b: b41, c: c41, d: d51 } = this.ctx.getTransform();
                            let scaleX11, scaleY11;
                            if (b41 === 0 && c41 === 0) {
                                const normX11 = Math.abs(a11);
                                const normY11 = Math.abs(d51);
                                if (normX11 === normY11) {
                                    if (lineWidth11 === 0) scaleX11 = scaleY11 = 1 / normX11;
                                    else {
                                        const scaledLineWidth11 = normX11 * lineWidth11;
                                        scaleX11 = scaleY11 = scaledLineWidth11 < 1 ? 1 / scaledLineWidth11 : 1;
                                    }
                                } else if (lineWidth11 === 0) {
                                    scaleX11 = 1 / normX11;
                                    scaleY11 = 1 / normY11;
                                } else {
                                    const scaledXLineWidth11 = normX11 * lineWidth11;
                                    const scaledYLineWidth11 = normY11 * lineWidth11;
                                    scaleX11 = scaledXLineWidth11 < 1 ? 1 / scaledXLineWidth11 : 1;
                                    scaleY11 = scaledYLineWidth11 < 1 ? 1 / scaledYLineWidth11 : 1;
                                }
                            } else {
                                const absDet11 = Math.abs(a11 * d51 - b41 * c41);
                                const normX11 = Math.hypot(a11, b41);
                                const normY11 = Math.hypot(c41, d51);
                                if (lineWidth11 === 0) {
                                    scaleX11 = normY11 / absDet11;
                                    scaleY11 = normX11 / absDet11;
                                } else {
                                    const baseArea11 = lineWidth11 * absDet11;
                                    scaleX11 = normY11 > baseArea11 ? normY11 / baseArea11 : 1;
                                    scaleY11 = normX11 > baseArea11 ? normX11 / baseArea11 : 1;
                                }
                            }
                            this._cachedScaleForStroking[0] = scaleX11;
                            this._cachedScaleForStroking[1] = scaleY11;
                        }
                        return this._cachedScaleForStroking;
                    }
                    rescaleAndStroke(saveRestore11) {
                        const { ctx: ctx11 } = this;
                        const { lineWidth: lineWidth11 } = this.current;
                        const [scaleX11, scaleY11] = this.getScaleForStroking();
                        ctx11.lineWidth = lineWidth11 || 1;
                        if (scaleX11 === 1 && scaleY11 === 1) {
                            ctx11.stroke();
                            return;
                        }
                        const dashes11 = ctx11.getLineDash();
                        if (saveRestore11) ctx11.save();
                        ctx11.scale(scaleX11, scaleY11);
                        if (dashes11.length > 0) {
                            const scale11 = Math.max(scaleX11, scaleY11);
                            ctx11.setLineDash(dashes11.map((x41)=>x41 / scale11));
                            ctx11.lineDashOffset /= scale11;
                        }
                        ctx11.stroke();
                        if (saveRestore11) ctx11.restore();
                    }
                    isContentVisible() {
                        for(let i11 = this.markedContentStack.length - 1; i11 >= 0; i11--){
                            if (!this.markedContentStack[i11].visible) return false;
                        }
                        return true;
                    }
                }
                exports11.CanvasGraphics = CanvasGraphics11;
                for(const op11 in _util11.OPS)if (CanvasGraphics11.prototype[op11] !== undefined) CanvasGraphics11.prototype[_util11.OPS[op11]] = CanvasGraphics11.prototype[op11];
            /***/ },
            /* 12 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.TilingPattern = exports11.PathType = void 0;
                exports11.getShadingPattern = getShadingPattern11;
                var _util11 = __w_pdfjs_require__11(1);
                var _display_utils11 = __w_pdfjs_require__11(6);
                const PathType11 = {
                    FILL: "Fill",
                    STROKE: "Stroke",
                    SHADING: "Shading"
                };
                exports11.PathType = PathType11;
                function applyBoundingBox11(ctx11, bbox11) {
                    if (!bbox11) return;
                    const width21 = bbox11[2] - bbox11[0];
                    const height11 = bbox11[3] - bbox11[1];
                    const region11 = new Path2D();
                    region11.rect(bbox11[0], bbox11[1], width21, height11);
                    ctx11.clip(region11);
                }
                class BaseShadingPattern11 {
                    constructor(){
                        if (this.constructor === BaseShadingPattern11) (0, _util11.unreachable)("Cannot initialize BaseShadingPattern.");
                    }
                    getPattern() {
                        (0, _util11.unreachable)("Abstract method `getPattern` called.");
                    }
                }
                class RadialAxialShadingPattern11 extends BaseShadingPattern11 {
                    constructor(IR11){
                        super();
                        this._type = IR11[1];
                        this._bbox = IR11[2];
                        this._colorStops = IR11[3];
                        this._p0 = IR11[4];
                        this._p1 = IR11[5];
                        this._r0 = IR11[6];
                        this._r1 = IR11[7];
                        this.matrix = null;
                    }
                    _createGradient(ctx11) {
                        let grad11;
                        if (this._type === "axial") grad11 = ctx11.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
                        else if (this._type === "radial") grad11 = ctx11.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
                        for (const colorStop11 of this._colorStops)grad11.addColorStop(colorStop11[0], colorStop11[1]);
                        return grad11;
                    }
                    getPattern(ctx11, owner11, inverse11, pathType11) {
                        let pattern11;
                        if (pathType11 === PathType11.STROKE || pathType11 === PathType11.FILL) {
                            const ownerBBox11 = owner11.current.getClippedPathBoundingBox(pathType11, (0, _display_utils11.getCurrentTransform)(ctx11)) || [
                                0,
                                0,
                                0,
                                0
                            ];
                            const width21 = Math.ceil(ownerBBox11[2] - ownerBBox11[0]) || 1;
                            const height11 = Math.ceil(ownerBBox11[3] - ownerBBox11[1]) || 1;
                            const tmpCanvas11 = owner11.cachedCanvases.getCanvas("pattern", width21, height11, true);
                            const tmpCtx11 = tmpCanvas11.context;
                            tmpCtx11.clearRect(0, 0, tmpCtx11.canvas.width, tmpCtx11.canvas.height);
                            tmpCtx11.beginPath();
                            tmpCtx11.rect(0, 0, tmpCtx11.canvas.width, tmpCtx11.canvas.height);
                            tmpCtx11.translate(-ownerBBox11[0], -ownerBBox11[1]);
                            inverse11 = _util11.Util.transform(inverse11, [
                                1,
                                0,
                                0,
                                1,
                                ownerBBox11[0],
                                ownerBBox11[1]
                            ]);
                            tmpCtx11.transform(...owner11.baseTransform);
                            if (this.matrix) tmpCtx11.transform(...this.matrix);
                            applyBoundingBox11(tmpCtx11, this._bbox);
                            tmpCtx11.fillStyle = this._createGradient(tmpCtx11);
                            tmpCtx11.fill();
                            pattern11 = ctx11.createPattern(tmpCanvas11.canvas, "no-repeat");
                            const domMatrix11 = new DOMMatrix(inverse11);
                            pattern11.setTransform(domMatrix11);
                        } else {
                            applyBoundingBox11(ctx11, this._bbox);
                            pattern11 = this._createGradient(ctx11);
                        }
                        return pattern11;
                    }
                }
                function drawTriangle11(data11, context11, p121, p221, p321, c111, c211, c311) {
                    const coords11 = context11.coords, colors11 = context11.colors;
                    const bytes11 = data11.data, rowSize11 = data11.width * 4;
                    let tmp11;
                    if (coords11[p121 + 1] > coords11[p221 + 1]) {
                        tmp11 = p121;
                        p121 = p221;
                        p221 = tmp11;
                        tmp11 = c111;
                        c111 = c211;
                        c211 = tmp11;
                    }
                    if (coords11[p221 + 1] > coords11[p321 + 1]) {
                        tmp11 = p221;
                        p221 = p321;
                        p321 = tmp11;
                        tmp11 = c211;
                        c211 = c311;
                        c311 = tmp11;
                    }
                    if (coords11[p121 + 1] > coords11[p221 + 1]) {
                        tmp11 = p121;
                        p121 = p221;
                        p221 = tmp11;
                        tmp11 = c111;
                        c111 = c211;
                        c211 = tmp11;
                    }
                    const x111 = (coords11[p121] + context11.offsetX) * context11.scaleX;
                    const y111 = (coords11[p121 + 1] + context11.offsetY) * context11.scaleY;
                    const x211 = (coords11[p221] + context11.offsetX) * context11.scaleX;
                    const y211 = (coords11[p221 + 1] + context11.offsetY) * context11.scaleY;
                    const x311 = (coords11[p321] + context11.offsetX) * context11.scaleX;
                    const y311 = (coords11[p321 + 1] + context11.offsetY) * context11.scaleY;
                    if (y111 >= y311) return;
                    const c1r11 = colors11[c111], c1g11 = colors11[c111 + 1], c1b11 = colors11[c111 + 2];
                    const c2r11 = colors11[c211], c2g11 = colors11[c211 + 1], c2b11 = colors11[c211 + 2];
                    const c3r11 = colors11[c311], c3g11 = colors11[c311 + 1], c3b11 = colors11[c311 + 2];
                    const minY11 = Math.round(y111), maxY11 = Math.round(y311);
                    let xa11, car11, cag11, cab11;
                    let xb11, cbr11, cbg11, cbb11;
                    for(let y41 = minY11; y41 <= maxY11; y41++){
                        if (y41 < y211) {
                            const k31 = y41 < y111 ? 0 : (y111 - y41) / (y111 - y211);
                            xa11 = x111 - (x111 - x211) * k31;
                            car11 = c1r11 - (c1r11 - c2r11) * k31;
                            cag11 = c1g11 - (c1g11 - c2g11) * k31;
                            cab11 = c1b11 - (c1b11 - c2b11) * k31;
                        } else {
                            let k31;
                            if (y41 > y311) k31 = 1;
                            else if (y211 === y311) k31 = 0;
                            else k31 = (y211 - y41) / (y211 - y311);
                            xa11 = x211 - (x211 - x311) * k31;
                            car11 = c2r11 - (c2r11 - c3r11) * k31;
                            cag11 = c2g11 - (c2g11 - c3g11) * k31;
                            cab11 = c2b11 - (c2b11 - c3b11) * k31;
                        }
                        let k31;
                        if (y41 < y111) k31 = 0;
                        else if (y41 > y311) k31 = 1;
                        else k31 = (y111 - y41) / (y111 - y311);
                        xb11 = x111 - (x111 - x311) * k31;
                        cbr11 = c1r11 - (c1r11 - c3r11) * k31;
                        cbg11 = c1g11 - (c1g11 - c3g11) * k31;
                        cbb11 = c1b11 - (c1b11 - c3b11) * k31;
                        const x1_11 = Math.round(Math.min(xa11, xb11));
                        const x2_11 = Math.round(Math.max(xa11, xb11));
                        let j11 = rowSize11 * y41 + x1_11 * 4;
                        for(let x41 = x1_11; x41 <= x2_11; x41++){
                            k31 = (xa11 - x41) / (xa11 - xb11);
                            if (k31 < 0) k31 = 0;
                            else if (k31 > 1) k31 = 1;
                            bytes11[j11++] = car11 - (car11 - cbr11) * k31 | 0;
                            bytes11[j11++] = cag11 - (cag11 - cbg11) * k31 | 0;
                            bytes11[j11++] = cab11 - (cab11 - cbb11) * k31 | 0;
                            bytes11[j11++] = 255;
                        }
                    }
                }
                function drawFigure11(data11, figure11, context11) {
                    const ps11 = figure11.coords;
                    const cs11 = figure11.colors;
                    let i11, ii11;
                    switch(figure11.type){
                        case "lattice":
                            const verticesPerRow11 = figure11.verticesPerRow;
                            const rows11 = Math.floor(ps11.length / verticesPerRow11) - 1;
                            const cols11 = verticesPerRow11 - 1;
                            for(i11 = 0; i11 < rows11; i11++){
                                let q11 = i11 * verticesPerRow11;
                                for(let j11 = 0; j11 < cols11; j11++, q11++){
                                    drawTriangle11(data11, context11, ps11[q11], ps11[q11 + 1], ps11[q11 + verticesPerRow11], cs11[q11], cs11[q11 + 1], cs11[q11 + verticesPerRow11]);
                                    drawTriangle11(data11, context11, ps11[q11 + verticesPerRow11 + 1], ps11[q11 + 1], ps11[q11 + verticesPerRow11], cs11[q11 + verticesPerRow11 + 1], cs11[q11 + 1], cs11[q11 + verticesPerRow11]);
                                }
                            }
                            break;
                        case "triangles":
                            for(i11 = 0, ii11 = ps11.length; i11 < ii11; i11 += 3)drawTriangle11(data11, context11, ps11[i11], ps11[i11 + 1], ps11[i11 + 2], cs11[i11], cs11[i11 + 1], cs11[i11 + 2]);
                            break;
                        default:
                            throw new Error("illegal figure");
                    }
                }
                class MeshShadingPattern11 extends BaseShadingPattern11 {
                    constructor(IR11){
                        super();
                        this._coords = IR11[2];
                        this._colors = IR11[3];
                        this._figures = IR11[4];
                        this._bounds = IR11[5];
                        this._bbox = IR11[7];
                        this._background = IR11[8];
                        this.matrix = null;
                    }
                    _createMeshCanvas(combinedScale11, backgroundColor11, cachedCanvases11) {
                        const EXPECTED_SCALE11 = 1.1;
                        const MAX_PATTERN_SIZE11 = 3000;
                        const BORDER_SIZE11 = 2;
                        const offsetX11 = Math.floor(this._bounds[0]);
                        const offsetY11 = Math.floor(this._bounds[1]);
                        const boundsWidth11 = Math.ceil(this._bounds[2]) - offsetX11;
                        const boundsHeight11 = Math.ceil(this._bounds[3]) - offsetY11;
                        const width21 = Math.min(Math.ceil(Math.abs(boundsWidth11 * combinedScale11[0] * EXPECTED_SCALE11)), MAX_PATTERN_SIZE11);
                        const height11 = Math.min(Math.ceil(Math.abs(boundsHeight11 * combinedScale11[1] * EXPECTED_SCALE11)), MAX_PATTERN_SIZE11);
                        const scaleX11 = boundsWidth11 / width21;
                        const scaleY11 = boundsHeight11 / height11;
                        const context11 = {
                            coords: this._coords,
                            colors: this._colors,
                            offsetX: -offsetX11,
                            offsetY: -offsetY11,
                            scaleX: 1 / scaleX11,
                            scaleY: 1 / scaleY11
                        };
                        const paddedWidth11 = width21 + BORDER_SIZE11 * 2;
                        const paddedHeight11 = height11 + BORDER_SIZE11 * 2;
                        const tmpCanvas11 = cachedCanvases11.getCanvas("mesh", paddedWidth11, paddedHeight11, false);
                        const tmpCtx11 = tmpCanvas11.context;
                        const data11 = tmpCtx11.createImageData(width21, height11);
                        if (backgroundColor11) {
                            const bytes11 = data11.data;
                            for(let i11 = 0, ii11 = bytes11.length; i11 < ii11; i11 += 4){
                                bytes11[i11] = backgroundColor11[0];
                                bytes11[i11 + 1] = backgroundColor11[1];
                                bytes11[i11 + 2] = backgroundColor11[2];
                                bytes11[i11 + 3] = 255;
                            }
                        }
                        for (const figure11 of this._figures)drawFigure11(data11, figure11, context11);
                        tmpCtx11.putImageData(data11, BORDER_SIZE11, BORDER_SIZE11);
                        const canvas11 = tmpCanvas11.canvas;
                        return {
                            canvas: canvas11,
                            offsetX: offsetX11 - BORDER_SIZE11 * scaleX11,
                            offsetY: offsetY11 - BORDER_SIZE11 * scaleY11,
                            scaleX: scaleX11,
                            scaleY: scaleY11
                        };
                    }
                    getPattern(ctx11, owner11, inverse11, pathType11) {
                        applyBoundingBox11(ctx11, this._bbox);
                        let scale11;
                        if (pathType11 === PathType11.SHADING) scale11 = _util11.Util.singularValueDecompose2dScale((0, _display_utils11.getCurrentTransform)(ctx11));
                        else {
                            scale11 = _util11.Util.singularValueDecompose2dScale(owner11.baseTransform);
                            if (this.matrix) {
                                const matrixScale11 = _util11.Util.singularValueDecompose2dScale(this.matrix);
                                scale11 = [
                                    scale11[0] * matrixScale11[0],
                                    scale11[1] * matrixScale11[1]
                                ];
                            }
                        }
                        const temporaryPatternCanvas11 = this._createMeshCanvas(scale11, pathType11 === PathType11.SHADING ? null : this._background, owner11.cachedCanvases);
                        if (pathType11 !== PathType11.SHADING) {
                            ctx11.setTransform(...owner11.baseTransform);
                            if (this.matrix) ctx11.transform(...this.matrix);
                        }
                        ctx11.translate(temporaryPatternCanvas11.offsetX, temporaryPatternCanvas11.offsetY);
                        ctx11.scale(temporaryPatternCanvas11.scaleX, temporaryPatternCanvas11.scaleY);
                        return ctx11.createPattern(temporaryPatternCanvas11.canvas, "no-repeat");
                    }
                }
                class DummyShadingPattern11 extends BaseShadingPattern11 {
                    getPattern() {
                        return "hotpink";
                    }
                }
                function getShadingPattern11(IR11) {
                    switch(IR11[0]){
                        case "RadialAxial":
                            return new RadialAxialShadingPattern11(IR11);
                        case "Mesh":
                            return new MeshShadingPattern11(IR11);
                        case "Dummy":
                            return new DummyShadingPattern11();
                    }
                    throw new Error(`Unknown IR type: ${IR11[0]}`);
                }
                const PaintType11 = {
                    COLORED: 1,
                    UNCOLORED: 2
                };
                class TilingPattern11 {
                    static MAX_PATTERN_SIZE = 3000;
                    constructor(IR11, color11, ctx11, canvasGraphicsFactory11, baseTransform11){
                        this.operatorList = IR11[2];
                        this.matrix = IR11[3] || [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        this.bbox = IR11[4];
                        this.xstep = IR11[5];
                        this.ystep = IR11[6];
                        this.paintType = IR11[7];
                        this.tilingType = IR11[8];
                        this.color = color11;
                        this.ctx = ctx11;
                        this.canvasGraphicsFactory = canvasGraphicsFactory11;
                        this.baseTransform = baseTransform11;
                    }
                    createPatternCanvas(owner11) {
                        const operatorList11 = this.operatorList;
                        const bbox11 = this.bbox;
                        const xstep11 = this.xstep;
                        const ystep11 = this.ystep;
                        const paintType11 = this.paintType;
                        const tilingType11 = this.tilingType;
                        const color11 = this.color;
                        const canvasGraphicsFactory11 = this.canvasGraphicsFactory;
                        (0, _util11.info)("TilingType: " + tilingType11);
                        const x011 = bbox11[0], y011 = bbox11[1], x111 = bbox11[2], y111 = bbox11[3];
                        const matrixScale11 = _util11.Util.singularValueDecompose2dScale(this.matrix);
                        const curMatrixScale11 = _util11.Util.singularValueDecompose2dScale(this.baseTransform);
                        const combinedScale11 = [
                            matrixScale11[0] * curMatrixScale11[0],
                            matrixScale11[1] * curMatrixScale11[1]
                        ];
                        const dimx11 = this.getSizeAndScale(xstep11, this.ctx.canvas.width, combinedScale11[0]);
                        const dimy11 = this.getSizeAndScale(ystep11, this.ctx.canvas.height, combinedScale11[1]);
                        const tmpCanvas11 = owner11.cachedCanvases.getCanvas("pattern", dimx11.size, dimy11.size, true);
                        const tmpCtx11 = tmpCanvas11.context;
                        const graphics11 = canvasGraphicsFactory11.createCanvasGraphics(tmpCtx11);
                        graphics11.groupLevel = owner11.groupLevel;
                        this.setFillAndStrokeStyleToContext(graphics11, paintType11, color11);
                        let adjustedX011 = x011;
                        let adjustedY011 = y011;
                        let adjustedX111 = x111;
                        let adjustedY111 = y111;
                        if (x011 < 0) {
                            adjustedX011 = 0;
                            adjustedX111 += Math.abs(x011);
                        }
                        if (y011 < 0) {
                            adjustedY011 = 0;
                            adjustedY111 += Math.abs(y011);
                        }
                        tmpCtx11.translate(-(dimx11.scale * adjustedX011), -(dimy11.scale * adjustedY011));
                        graphics11.transform(dimx11.scale, 0, 0, dimy11.scale, 0, 0);
                        tmpCtx11.save();
                        this.clipBbox(graphics11, adjustedX011, adjustedY011, adjustedX111, adjustedY111);
                        graphics11.baseTransform = (0, _display_utils11.getCurrentTransform)(graphics11.ctx);
                        graphics11.executeOperatorList(operatorList11);
                        graphics11.endDrawing();
                        return {
                            canvas: tmpCanvas11.canvas,
                            scaleX: dimx11.scale,
                            scaleY: dimy11.scale,
                            offsetX: adjustedX011,
                            offsetY: adjustedY011
                        };
                    }
                    getSizeAndScale(step11, realOutputSize11, scale11) {
                        step11 = Math.abs(step11);
                        const maxSize11 = Math.max(TilingPattern11.MAX_PATTERN_SIZE, realOutputSize11);
                        let size11 = Math.ceil(step11 * scale11);
                        if (size11 >= maxSize11) size11 = maxSize11;
                        else scale11 = size11 / step11;
                        return {
                            scale: scale11,
                            size: size11
                        };
                    }
                    clipBbox(graphics11, x011, y011, x111, y111) {
                        const bboxWidth11 = x111 - x011;
                        const bboxHeight11 = y111 - y011;
                        graphics11.ctx.rect(x011, y011, bboxWidth11, bboxHeight11);
                        graphics11.current.updateRectMinMax((0, _display_utils11.getCurrentTransform)(graphics11.ctx), [
                            x011,
                            y011,
                            x111,
                            y111
                        ]);
                        graphics11.clip();
                        graphics11.endPath();
                    }
                    setFillAndStrokeStyleToContext(graphics11, paintType11, color11) {
                        const context11 = graphics11.ctx, current11 = graphics11.current;
                        switch(paintType11){
                            case PaintType11.COLORED:
                                const ctx11 = this.ctx;
                                context11.fillStyle = ctx11.fillStyle;
                                context11.strokeStyle = ctx11.strokeStyle;
                                current11.fillColor = ctx11.fillStyle;
                                current11.strokeColor = ctx11.strokeStyle;
                                break;
                            case PaintType11.UNCOLORED:
                                const cssColor11 = _util11.Util.makeHexColor(color11[0], color11[1], color11[2]);
                                context11.fillStyle = cssColor11;
                                context11.strokeStyle = cssColor11;
                                current11.fillColor = cssColor11;
                                current11.strokeColor = cssColor11;
                                break;
                            default:
                                throw new _util11.FormatError(`Unsupported paint type: ${paintType11}`);
                        }
                    }
                    getPattern(ctx11, owner11, inverse11, pathType11) {
                        let matrix11 = inverse11;
                        if (pathType11 !== PathType11.SHADING) {
                            matrix11 = _util11.Util.transform(matrix11, owner11.baseTransform);
                            if (this.matrix) matrix11 = _util11.Util.transform(matrix11, this.matrix);
                        }
                        const temporaryPatternCanvas11 = this.createPatternCanvas(owner11);
                        let domMatrix11 = new DOMMatrix(matrix11);
                        domMatrix11 = domMatrix11.translate(temporaryPatternCanvas11.offsetX, temporaryPatternCanvas11.offsetY);
                        domMatrix11 = domMatrix11.scale(1 / temporaryPatternCanvas11.scaleX, 1 / temporaryPatternCanvas11.scaleY);
                        const pattern11 = ctx11.createPattern(temporaryPatternCanvas11.canvas, "repeat");
                        pattern11.setTransform(domMatrix11);
                        return pattern11;
                    }
                }
                exports11.TilingPattern = TilingPattern11;
            /***/ },
            /* 13 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.convertBlackAndWhiteToRGBA = convertBlackAndWhiteToRGBA11;
                exports11.convertToRGBA = convertToRGBA11;
                exports11.grayToRGBA = grayToRGBA11;
                var _util11 = __w_pdfjs_require__11(1);
                function convertToRGBA11(params11) {
                    switch(params11.kind){
                        case _util11.ImageKind.GRAYSCALE_1BPP:
                            return convertBlackAndWhiteToRGBA11(params11);
                        case _util11.ImageKind.RGB_24BPP:
                            return convertRGBToRGBA11(params11);
                    }
                    return null;
                }
                function convertBlackAndWhiteToRGBA11({ src: src11, srcPos: srcPos11 = 0, dest: dest11, width: width21, height: height11, nonBlackColor: nonBlackColor11 = 0xffffffff, inverseDecode: inverseDecode11 = false }) {
                    const black11 = _util11.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
                    const [zeroMapping11, oneMapping11] = inverseDecode11 ? [
                        nonBlackColor11,
                        black11
                    ] : [
                        black11,
                        nonBlackColor11
                    ];
                    const widthInSource11 = width21 >> 3;
                    const widthRemainder11 = width21 & 7;
                    const srcLength11 = src11.length;
                    dest11 = new Uint32Array(dest11.buffer);
                    let destPos11 = 0;
                    for(let i11 = 0; i11 < height11; i11++){
                        for(const max11 = srcPos11 + widthInSource11; srcPos11 < max11; srcPos11++){
                            const elem11 = srcPos11 < srcLength11 ? src11[srcPos11] : 255;
                            dest11[destPos11++] = elem11 & 128 ? oneMapping11 : zeroMapping11;
                            dest11[destPos11++] = elem11 & 64 ? oneMapping11 : zeroMapping11;
                            dest11[destPos11++] = elem11 & 32 ? oneMapping11 : zeroMapping11;
                            dest11[destPos11++] = elem11 & 16 ? oneMapping11 : zeroMapping11;
                            dest11[destPos11++] = elem11 & 8 ? oneMapping11 : zeroMapping11;
                            dest11[destPos11++] = elem11 & 4 ? oneMapping11 : zeroMapping11;
                            dest11[destPos11++] = elem11 & 2 ? oneMapping11 : zeroMapping11;
                            dest11[destPos11++] = elem11 & 1 ? oneMapping11 : zeroMapping11;
                        }
                        if (widthRemainder11 === 0) continue;
                        const elem11 = srcPos11 < srcLength11 ? src11[srcPos11++] : 255;
                        for(let j11 = 0; j11 < widthRemainder11; j11++)dest11[destPos11++] = elem11 & 1 << 7 - j11 ? oneMapping11 : zeroMapping11;
                    }
                    return {
                        srcPos: srcPos11,
                        destPos: destPos11
                    };
                }
                function convertRGBToRGBA11({ src: src11, srcPos: srcPos11 = 0, dest: dest11, destPos: destPos11 = 0, width: width21, height: height11 }) {
                    let i11 = 0;
                    const len3211 = src11.length >> 2;
                    const src3211 = new Uint32Array(src11.buffer, srcPos11, len3211);
                    if (_util11.FeatureTest.isLittleEndian) {
                        for(; i11 < len3211 - 2; i11 += 3, destPos11 += 4){
                            const s111 = src3211[i11];
                            const s211 = src3211[i11 + 1];
                            const s311 = src3211[i11 + 2];
                            dest11[destPos11] = s111 | 0xff000000;
                            dest11[destPos11 + 1] = s111 >>> 24 | s211 << 8 | 0xff000000;
                            dest11[destPos11 + 2] = s211 >>> 16 | s311 << 16 | 0xff000000;
                            dest11[destPos11 + 3] = s311 >>> 8 | 0xff000000;
                        }
                        for(let j11 = i11 * 4, jj11 = src11.length; j11 < jj11; j11 += 3)dest11[destPos11++] = src11[j11] | src11[j11 + 1] << 8 | src11[j11 + 2] << 16 | 0xff000000;
                    } else {
                        for(; i11 < len3211 - 2; i11 += 3, destPos11 += 4){
                            const s111 = src3211[i11];
                            const s211 = src3211[i11 + 1];
                            const s311 = src3211[i11 + 2];
                            dest11[destPos11] = s111 | 0xff;
                            dest11[destPos11 + 1] = s111 << 24 | s211 >>> 8 | 0xff;
                            dest11[destPos11 + 2] = s211 << 16 | s311 >>> 16 | 0xff;
                            dest11[destPos11 + 3] = s311 << 8 | 0xff;
                        }
                        for(let j11 = i11 * 4, jj11 = src11.length; j11 < jj11; j11 += 3)dest11[destPos11++] = src11[j11] << 24 | src11[j11 + 1] << 16 | src11[j11 + 2] << 8 | 0xff;
                    }
                    return {
                        srcPos: srcPos11,
                        destPos: destPos11
                    };
                }
                function grayToRGBA11(src11, dest11) {
                    if (_util11.FeatureTest.isLittleEndian) for(let i11 = 0, ii11 = src11.length; i11 < ii11; i11++)dest11[i11] = src11[i11] * 0x10101 | 0xff000000;
                    else for(let i11 = 0, ii11 = src11.length; i11 < ii11; i11++)dest11[i11] = src11[i11] * 0x1010100 | 0x000000ff;
                }
            /***/ },
            /* 14 */ /***/ (__unused_webpack_module11, exports11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.GlobalWorkerOptions = void 0;
                const GlobalWorkerOptions11 = Object.create(null);
                exports11.GlobalWorkerOptions = GlobalWorkerOptions11;
                GlobalWorkerOptions11.workerPort = null;
                GlobalWorkerOptions11.workerSrc = "";
            /***/ },
            /* 15 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.MessageHandler = void 0;
                var _util11 = __w_pdfjs_require__11(1);
                const CallbackKind11 = {
                    UNKNOWN: 0,
                    DATA: 1,
                    ERROR: 2
                };
                const StreamKind11 = {
                    UNKNOWN: 0,
                    CANCEL: 1,
                    CANCEL_COMPLETE: 2,
                    CLOSE: 3,
                    ENQUEUE: 4,
                    ERROR: 5,
                    PULL: 6,
                    PULL_COMPLETE: 7,
                    START_COMPLETE: 8
                };
                function wrapReason11(reason11) {
                    if (!(reason11 instanceof Error || typeof reason11 === "object" && reason11 !== null)) (0, _util11.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
                    switch(reason11.name){
                        case "AbortException":
                            return new _util11.AbortException(reason11.message);
                        case "MissingPDFException":
                            return new _util11.MissingPDFException(reason11.message);
                        case "PasswordException":
                            return new _util11.PasswordException(reason11.message, reason11.code);
                        case "UnexpectedResponseException":
                            return new _util11.UnexpectedResponseException(reason11.message, reason11.status);
                        case "UnknownErrorException":
                            return new _util11.UnknownErrorException(reason11.message, reason11.details);
                        default:
                            return new _util11.UnknownErrorException(reason11.message, reason11.toString());
                    }
                }
                class MessageHandler11 {
                    constructor(sourceName11, targetName11, comObj11){
                        this.sourceName = sourceName11;
                        this.targetName = targetName11;
                        this.comObj = comObj11;
                        this.callbackId = 1;
                        this.streamId = 1;
                        this.streamSinks = Object.create(null);
                        this.streamControllers = Object.create(null);
                        this.callbackCapabilities = Object.create(null);
                        this.actionHandler = Object.create(null);
                        this._onComObjOnMessage = (event11)=>{
                            const data11 = event11.data;
                            if (data11.targetName !== this.sourceName) return;
                            if (data11.stream) {
                                this.#processStreamMessage(data11);
                                return;
                            }
                            if (data11.callback) {
                                const callbackId11 = data11.callbackId;
                                const capability11 = this.callbackCapabilities[callbackId11];
                                if (!capability11) throw new Error(`Cannot resolve callback ${callbackId11}`);
                                delete this.callbackCapabilities[callbackId11];
                                if (data11.callback === CallbackKind11.DATA) capability11.resolve(data11.data);
                                else if (data11.callback === CallbackKind11.ERROR) capability11.reject(wrapReason11(data11.reason));
                                else throw new Error("Unexpected callback case");
                                return;
                            }
                            const action11 = this.actionHandler[data11.action];
                            if (!action11) throw new Error(`Unknown action from worker: ${data11.action}`);
                            if (data11.callbackId) {
                                const cbSourceName11 = this.sourceName;
                                const cbTargetName11 = data11.sourceName;
                                new Promise(function(resolve11) {
                                    resolve11(action11(data11.data));
                                }).then(function(result11) {
                                    comObj11.postMessage({
                                        sourceName: cbSourceName11,
                                        targetName: cbTargetName11,
                                        callback: CallbackKind11.DATA,
                                        callbackId: data11.callbackId,
                                        data: result11
                                    });
                                }, function(reason11) {
                                    comObj11.postMessage({
                                        sourceName: cbSourceName11,
                                        targetName: cbTargetName11,
                                        callback: CallbackKind11.ERROR,
                                        callbackId: data11.callbackId,
                                        reason: wrapReason11(reason11)
                                    });
                                });
                                return;
                            }
                            if (data11.streamId) {
                                this.#createStreamSink(data11);
                                return;
                            }
                            action11(data11.data);
                        };
                        comObj11.addEventListener("message", this._onComObjOnMessage);
                    }
                    on(actionName11, handler11) {
                        const ah11 = this.actionHandler;
                        if (ah11[actionName11]) throw new Error(`There is already an actionName called "${actionName11}"`);
                        ah11[actionName11] = handler11;
                    }
                    send(actionName11, data11, transfers11) {
                        this.comObj.postMessage({
                            sourceName: this.sourceName,
                            targetName: this.targetName,
                            action: actionName11,
                            data: data11
                        }, transfers11);
                    }
                    sendWithPromise(actionName11, data11, transfers11) {
                        const callbackId11 = this.callbackId++;
                        const capability11 = new _util11.PromiseCapability();
                        this.callbackCapabilities[callbackId11] = capability11;
                        try {
                            this.comObj.postMessage({
                                sourceName: this.sourceName,
                                targetName: this.targetName,
                                action: actionName11,
                                callbackId: callbackId11,
                                data: data11
                            }, transfers11);
                        } catch (ex11) {
                            capability11.reject(ex11);
                        }
                        return capability11.promise;
                    }
                    sendWithStream(actionName11, data11, queueingStrategy11, transfers11) {
                        const streamId11 = this.streamId++, sourceName11 = this.sourceName, targetName11 = this.targetName, comObj11 = this.comObj;
                        return new ReadableStream({
                            start: (controller11)=>{
                                const startCapability11 = new _util11.PromiseCapability();
                                this.streamControllers[streamId11] = {
                                    controller: controller11,
                                    startCall: startCapability11,
                                    pullCall: null,
                                    cancelCall: null,
                                    isClosed: false
                                };
                                comObj11.postMessage({
                                    sourceName: sourceName11,
                                    targetName: targetName11,
                                    action: actionName11,
                                    streamId: streamId11,
                                    data: data11,
                                    desiredSize: controller11.desiredSize
                                }, transfers11);
                                return startCapability11.promise;
                            },
                            pull: (controller11)=>{
                                const pullCapability11 = new _util11.PromiseCapability();
                                this.streamControllers[streamId11].pullCall = pullCapability11;
                                comObj11.postMessage({
                                    sourceName: sourceName11,
                                    targetName: targetName11,
                                    stream: StreamKind11.PULL,
                                    streamId: streamId11,
                                    desiredSize: controller11.desiredSize
                                });
                                return pullCapability11.promise;
                            },
                            cancel: (reason11)=>{
                                (0, _util11.assert)(reason11 instanceof Error, "cancel must have a valid reason");
                                const cancelCapability11 = new _util11.PromiseCapability();
                                this.streamControllers[streamId11].cancelCall = cancelCapability11;
                                this.streamControllers[streamId11].isClosed = true;
                                comObj11.postMessage({
                                    sourceName: sourceName11,
                                    targetName: targetName11,
                                    stream: StreamKind11.CANCEL,
                                    streamId: streamId11,
                                    reason: wrapReason11(reason11)
                                });
                                return cancelCapability11.promise;
                            }
                        }, queueingStrategy11);
                    }
                    #createStreamSink(data11) {
                        const streamId11 = data11.streamId, sourceName11 = this.sourceName, targetName11 = data11.sourceName, comObj11 = this.comObj;
                        const self11 = this, action11 = this.actionHandler[data11.action];
                        const streamSink11 = {
                            enqueue (chunk31, size11 = 1, transfers11) {
                                if (this.isCancelled) return;
                                const lastDesiredSize11 = this.desiredSize;
                                this.desiredSize -= size11;
                                if (lastDesiredSize11 > 0 && this.desiredSize <= 0) {
                                    this.sinkCapability = new _util11.PromiseCapability();
                                    this.ready = this.sinkCapability.promise;
                                }
                                comObj11.postMessage({
                                    sourceName: sourceName11,
                                    targetName: targetName11,
                                    stream: StreamKind11.ENQUEUE,
                                    streamId: streamId11,
                                    chunk: chunk31
                                }, transfers11);
                            },
                            close () {
                                if (this.isCancelled) return;
                                this.isCancelled = true;
                                comObj11.postMessage({
                                    sourceName: sourceName11,
                                    targetName: targetName11,
                                    stream: StreamKind11.CLOSE,
                                    streamId: streamId11
                                });
                                delete self11.streamSinks[streamId11];
                            },
                            error (reason11) {
                                (0, _util11.assert)(reason11 instanceof Error, "error must have a valid reason");
                                if (this.isCancelled) return;
                                this.isCancelled = true;
                                comObj11.postMessage({
                                    sourceName: sourceName11,
                                    targetName: targetName11,
                                    stream: StreamKind11.ERROR,
                                    streamId: streamId11,
                                    reason: wrapReason11(reason11)
                                });
                            },
                            sinkCapability: new _util11.PromiseCapability(),
                            onPull: null,
                            onCancel: null,
                            isCancelled: false,
                            desiredSize: data11.desiredSize,
                            ready: null
                        };
                        streamSink11.sinkCapability.resolve();
                        streamSink11.ready = streamSink11.sinkCapability.promise;
                        this.streamSinks[streamId11] = streamSink11;
                        new Promise(function(resolve11) {
                            resolve11(action11(data11.data, streamSink11));
                        }).then(function() {
                            comObj11.postMessage({
                                sourceName: sourceName11,
                                targetName: targetName11,
                                stream: StreamKind11.START_COMPLETE,
                                streamId: streamId11,
                                success: true
                            });
                        }, function(reason11) {
                            comObj11.postMessage({
                                sourceName: sourceName11,
                                targetName: targetName11,
                                stream: StreamKind11.START_COMPLETE,
                                streamId: streamId11,
                                reason: wrapReason11(reason11)
                            });
                        });
                    }
                    #processStreamMessage(data11) {
                        const streamId11 = data11.streamId, sourceName11 = this.sourceName, targetName11 = data11.sourceName, comObj11 = this.comObj;
                        const streamController11 = this.streamControllers[streamId11], streamSink11 = this.streamSinks[streamId11];
                        switch(data11.stream){
                            case StreamKind11.START_COMPLETE:
                                if (data11.success) streamController11.startCall.resolve();
                                else streamController11.startCall.reject(wrapReason11(data11.reason));
                                break;
                            case StreamKind11.PULL_COMPLETE:
                                if (data11.success) streamController11.pullCall.resolve();
                                else streamController11.pullCall.reject(wrapReason11(data11.reason));
                                break;
                            case StreamKind11.PULL:
                                if (!streamSink11) {
                                    comObj11.postMessage({
                                        sourceName: sourceName11,
                                        targetName: targetName11,
                                        stream: StreamKind11.PULL_COMPLETE,
                                        streamId: streamId11,
                                        success: true
                                    });
                                    break;
                                }
                                if (streamSink11.desiredSize <= 0 && data11.desiredSize > 0) streamSink11.sinkCapability.resolve();
                                streamSink11.desiredSize = data11.desiredSize;
                                new Promise(function(resolve11) {
                                    resolve11(streamSink11.onPull?.());
                                }).then(function() {
                                    comObj11.postMessage({
                                        sourceName: sourceName11,
                                        targetName: targetName11,
                                        stream: StreamKind11.PULL_COMPLETE,
                                        streamId: streamId11,
                                        success: true
                                    });
                                }, function(reason11) {
                                    comObj11.postMessage({
                                        sourceName: sourceName11,
                                        targetName: targetName11,
                                        stream: StreamKind11.PULL_COMPLETE,
                                        streamId: streamId11,
                                        reason: wrapReason11(reason11)
                                    });
                                });
                                break;
                            case StreamKind11.ENQUEUE:
                                (0, _util11.assert)(streamController11, "enqueue should have stream controller");
                                if (streamController11.isClosed) break;
                                streamController11.controller.enqueue(data11.chunk);
                                break;
                            case StreamKind11.CLOSE:
                                (0, _util11.assert)(streamController11, "close should have stream controller");
                                if (streamController11.isClosed) break;
                                streamController11.isClosed = true;
                                streamController11.controller.close();
                                this.#deleteStreamController(streamController11, streamId11);
                                break;
                            case StreamKind11.ERROR:
                                (0, _util11.assert)(streamController11, "error should have stream controller");
                                streamController11.controller.error(wrapReason11(data11.reason));
                                this.#deleteStreamController(streamController11, streamId11);
                                break;
                            case StreamKind11.CANCEL_COMPLETE:
                                if (data11.success) streamController11.cancelCall.resolve();
                                else streamController11.cancelCall.reject(wrapReason11(data11.reason));
                                this.#deleteStreamController(streamController11, streamId11);
                                break;
                            case StreamKind11.CANCEL:
                                if (!streamSink11) break;
                                new Promise(function(resolve11) {
                                    resolve11(streamSink11.onCancel?.(wrapReason11(data11.reason)));
                                }).then(function() {
                                    comObj11.postMessage({
                                        sourceName: sourceName11,
                                        targetName: targetName11,
                                        stream: StreamKind11.CANCEL_COMPLETE,
                                        streamId: streamId11,
                                        success: true
                                    });
                                }, function(reason11) {
                                    comObj11.postMessage({
                                        sourceName: sourceName11,
                                        targetName: targetName11,
                                        stream: StreamKind11.CANCEL_COMPLETE,
                                        streamId: streamId11,
                                        reason: wrapReason11(reason11)
                                    });
                                });
                                streamSink11.sinkCapability.reject(wrapReason11(data11.reason));
                                streamSink11.isCancelled = true;
                                delete this.streamSinks[streamId11];
                                break;
                            default:
                                throw new Error("Unexpected stream case");
                        }
                    }
                    async #deleteStreamController(streamController11, streamId11) {
                        await Promise.allSettled([
                            streamController11.startCall?.promise,
                            streamController11.pullCall?.promise,
                            streamController11.cancelCall?.promise
                        ]);
                        delete this.streamControllers[streamId11];
                    }
                    destroy() {
                        this.comObj.removeEventListener("message", this._onComObjOnMessage);
                    }
                }
                exports11.MessageHandler = MessageHandler11;
            /***/ },
            /* 16 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.Metadata = void 0;
                var _util11 = __w_pdfjs_require__11(1);
                class Metadata11 {
                    #metadataMap;
                    #data;
                    constructor({ parsedData: parsedData11, rawData: rawData11 }){
                        this.#metadataMap = parsedData11;
                        this.#data = rawData11;
                    }
                    getRaw() {
                        return this.#data;
                    }
                    get(name11) {
                        return this.#metadataMap.get(name11) ?? null;
                    }
                    getAll() {
                        return (0, _util11.objectFromMap)(this.#metadataMap);
                    }
                    has(name11) {
                        return this.#metadataMap.has(name11);
                    }
                }
                exports11.Metadata = Metadata11;
            /***/ },
            /* 17 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.OptionalContentConfig = void 0;
                var _util11 = __w_pdfjs_require__11(1);
                var _murmurhash11 = __w_pdfjs_require__11(8);
                const INTERNAL11 = Symbol("INTERNAL");
                class OptionalContentGroup11 {
                    #visible = true;
                    constructor(name11, intent11){
                        this.name = name11;
                        this.intent = intent11;
                    }
                    get visible() {
                        return this.#visible;
                    }
                    _setVisible(internal11, visible11) {
                        if (internal11 !== INTERNAL11) (0, _util11.unreachable)("Internal method `_setVisible` called.");
                        this.#visible = visible11;
                    }
                }
                class OptionalContentConfig11 {
                    #cachedGetHash = null;
                    #groups = new Map();
                    #initialHash = null;
                    #order = null;
                    constructor(data11){
                        this.name = null;
                        this.creator = null;
                        if (data11 === null) return;
                        this.name = data11.name;
                        this.creator = data11.creator;
                        this.#order = data11.order;
                        for (const group11 of data11.groups)this.#groups.set(group11.id, new OptionalContentGroup11(group11.name, group11.intent));
                        if (data11.baseState === "OFF") for (const group11 of this.#groups.values())group11._setVisible(INTERNAL11, false);
                        for (const on11 of data11.on)this.#groups.get(on11)._setVisible(INTERNAL11, true);
                        for (const off11 of data11.off)this.#groups.get(off11)._setVisible(INTERNAL11, false);
                        this.#initialHash = this.getHash();
                    }
                    #evaluateVisibilityExpression(array11) {
                        const length11 = array11.length;
                        if (length11 < 2) return true;
                        const operator11 = array11[0];
                        for(let i11 = 1; i11 < length11; i11++){
                            const element11 = array11[i11];
                            let state11;
                            if (Array.isArray(element11)) state11 = this.#evaluateVisibilityExpression(element11);
                            else if (this.#groups.has(element11)) state11 = this.#groups.get(element11).visible;
                            else {
                                (0, _util11.warn)(`Optional content group not found: ${element11}`);
                                return true;
                            }
                            switch(operator11){
                                case "And":
                                    if (!state11) return false;
                                    break;
                                case "Or":
                                    if (state11) return true;
                                    break;
                                case "Not":
                                    return !state11;
                                default:
                                    return true;
                            }
                        }
                        return operator11 === "And";
                    }
                    isVisible(group11) {
                        if (this.#groups.size === 0) return true;
                        if (!group11) {
                            (0, _util11.warn)("Optional content group not defined.");
                            return true;
                        }
                        if (group11.type === "OCG") {
                            if (!this.#groups.has(group11.id)) {
                                (0, _util11.warn)(`Optional content group not found: ${group11.id}`);
                                return true;
                            }
                            return this.#groups.get(group11.id).visible;
                        } else if (group11.type === "OCMD") {
                            if (group11.expression) return this.#evaluateVisibilityExpression(group11.expression);
                            if (!group11.policy || group11.policy === "AnyOn") {
                                for (const id11 of group11.ids){
                                    if (!this.#groups.has(id11)) {
                                        (0, _util11.warn)(`Optional content group not found: ${id11}`);
                                        return true;
                                    }
                                    if (this.#groups.get(id11).visible) return true;
                                }
                                return false;
                            } else if (group11.policy === "AllOn") {
                                for (const id11 of group11.ids){
                                    if (!this.#groups.has(id11)) {
                                        (0, _util11.warn)(`Optional content group not found: ${id11}`);
                                        return true;
                                    }
                                    if (!this.#groups.get(id11).visible) return false;
                                }
                                return true;
                            } else if (group11.policy === "AnyOff") {
                                for (const id11 of group11.ids){
                                    if (!this.#groups.has(id11)) {
                                        (0, _util11.warn)(`Optional content group not found: ${id11}`);
                                        return true;
                                    }
                                    if (!this.#groups.get(id11).visible) return true;
                                }
                                return false;
                            } else if (group11.policy === "AllOff") {
                                for (const id11 of group11.ids){
                                    if (!this.#groups.has(id11)) {
                                        (0, _util11.warn)(`Optional content group not found: ${id11}`);
                                        return true;
                                    }
                                    if (this.#groups.get(id11).visible) return false;
                                }
                                return true;
                            }
                            (0, _util11.warn)(`Unknown optional content policy ${group11.policy}.`);
                            return true;
                        }
                        (0, _util11.warn)(`Unknown group type ${group11.type}.`);
                        return true;
                    }
                    setVisibility(id11, visible11 = true) {
                        if (!this.#groups.has(id11)) {
                            (0, _util11.warn)(`Optional content group not found: ${id11}`);
                            return;
                        }
                        this.#groups.get(id11)._setVisible(INTERNAL11, !!visible11);
                        this.#cachedGetHash = null;
                    }
                    get hasInitialVisibility() {
                        return this.#initialHash === null || this.getHash() === this.#initialHash;
                    }
                    getOrder() {
                        if (!this.#groups.size) return null;
                        if (this.#order) return this.#order.slice();
                        return [
                            ...this.#groups.keys()
                        ];
                    }
                    getGroups() {
                        return this.#groups.size > 0 ? (0, _util11.objectFromMap)(this.#groups) : null;
                    }
                    getGroup(id11) {
                        return this.#groups.get(id11) || null;
                    }
                    getHash() {
                        if (this.#cachedGetHash !== null) return this.#cachedGetHash;
                        const hash11 = new _murmurhash11.MurmurHash3_64();
                        for (const [id11, group11] of this.#groups)hash11.update(`${id11}:${group11.visible}`);
                        return this.#cachedGetHash = hash11.hexdigest();
                    }
                }
                exports11.OptionalContentConfig = OptionalContentConfig11;
            /***/ },
            /* 18 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.PDFDataTransportStream = void 0;
                var _util11 = __w_pdfjs_require__11(1);
                var _display_utils11 = __w_pdfjs_require__11(6);
                class PDFDataTransportStream11 {
                    constructor({ length: length11, initialData: initialData11, progressiveDone: progressiveDone11 = false, contentDispositionFilename: contentDispositionFilename11 = null, disableRange: disableRange11 = false, disableStream: disableStream11 = false }, pdfDataRangeTransport11){
                        (0, _util11.assert)(pdfDataRangeTransport11, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
                        this._queuedChunks = [];
                        this._progressiveDone = progressiveDone11;
                        this._contentDispositionFilename = contentDispositionFilename11;
                        if (initialData11?.length > 0) {
                            const buffer11 = initialData11 instanceof Uint8Array && initialData11.byteLength === initialData11.buffer.byteLength ? initialData11.buffer : new Uint8Array(initialData11).buffer;
                            this._queuedChunks.push(buffer11);
                        }
                        this._pdfDataRangeTransport = pdfDataRangeTransport11;
                        this._isStreamingSupported = !disableStream11;
                        this._isRangeSupported = !disableRange11;
                        this._contentLength = length11;
                        this._fullRequestReader = null;
                        this._rangeReaders = [];
                        this._pdfDataRangeTransport.addRangeListener((begin11, chunk31)=>{
                            this._onReceiveData({
                                begin: begin11,
                                chunk: chunk31
                            });
                        });
                        this._pdfDataRangeTransport.addProgressListener((loaded11, total11)=>{
                            this._onProgress({
                                loaded: loaded11,
                                total: total11
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveReadListener((chunk31)=>{
                            this._onReceiveData({
                                chunk: chunk31
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveDoneListener(()=>{
                            this._onProgressiveDone();
                        });
                        this._pdfDataRangeTransport.transportReady();
                    }
                    _onReceiveData({ begin: begin11, chunk: chunk31 }) {
                        const buffer11 = chunk31 instanceof Uint8Array && chunk31.byteLength === chunk31.buffer.byteLength ? chunk31.buffer : new Uint8Array(chunk31).buffer;
                        if (begin11 === undefined) {
                            if (this._fullRequestReader) this._fullRequestReader._enqueue(buffer11);
                            else this._queuedChunks.push(buffer11);
                        } else {
                            const found11 = this._rangeReaders.some(function(rangeReader11) {
                                if (rangeReader11._begin !== begin11) return false;
                                rangeReader11._enqueue(buffer11);
                                return true;
                            });
                            (0, _util11.assert)(found11, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                        }
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    _onProgress(evt11) {
                        if (evt11.total === undefined) this._rangeReaders[0]?.onProgress?.({
                            loaded: evt11.loaded
                        });
                        else this._fullRequestReader?.onProgress?.({
                            loaded: evt11.loaded,
                            total: evt11.total
                        });
                    }
                    _onProgressiveDone() {
                        this._fullRequestReader?.progressiveDone();
                        this._progressiveDone = true;
                    }
                    _removeRangeReader(reader11) {
                        const i11 = this._rangeReaders.indexOf(reader11);
                        if (i11 >= 0) this._rangeReaders.splice(i11, 1);
                    }
                    getFullReader() {
                        (0, _util11.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
                        const queuedChunks11 = this._queuedChunks;
                        this._queuedChunks = null;
                        return new PDFDataTransportStreamReader11(this, queuedChunks11, this._progressiveDone, this._contentDispositionFilename);
                    }
                    getRangeReader(begin11, end11) {
                        if (end11 <= this._progressiveDataLength) return null;
                        const reader11 = new PDFDataTransportStreamRangeReader11(this, begin11, end11);
                        this._pdfDataRangeTransport.requestDataRange(begin11, end11);
                        this._rangeReaders.push(reader11);
                        return reader11;
                    }
                    cancelAllRequests(reason11) {
                        this._fullRequestReader?.cancel(reason11);
                        for (const reader11 of this._rangeReaders.slice(0))reader11.cancel(reason11);
                        this._pdfDataRangeTransport.abort();
                    }
                }
                exports11.PDFDataTransportStream = PDFDataTransportStream11;
                class PDFDataTransportStreamReader11 {
                    constructor(stream11, queuedChunks11, progressiveDone11 = false, contentDispositionFilename11 = null){
                        this._stream = stream11;
                        this._done = progressiveDone11 || false;
                        this._filename = (0, _display_utils11.isPdfFile)(contentDispositionFilename11) ? contentDispositionFilename11 : null;
                        this._queuedChunks = queuedChunks11 || [];
                        this._loaded = 0;
                        for (const chunk31 of this._queuedChunks)this._loaded += chunk31.byteLength;
                        this._requests = [];
                        this._headersReady = Promise.resolve();
                        stream11._fullRequestReader = this;
                        this.onProgress = null;
                    }
                    _enqueue(chunk31) {
                        if (this._done) return;
                        if (this._requests.length > 0) {
                            const requestCapability11 = this._requests.shift();
                            requestCapability11.resolve({
                                value: chunk31,
                                done: false
                            });
                        } else this._queuedChunks.push(chunk31);
                        this._loaded += chunk31.byteLength;
                    }
                    get headersReady() {
                        return this._headersReady;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get isRangeSupported() {
                        return this._stream._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._stream._isStreamingSupported;
                    }
                    get contentLength() {
                        return this._stream._contentLength;
                    }
                    async read() {
                        if (this._queuedChunks.length > 0) {
                            const chunk31 = this._queuedChunks.shift();
                            return {
                                value: chunk31,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability11 = new _util11.PromiseCapability();
                        this._requests.push(requestCapability11);
                        return requestCapability11.promise;
                    }
                    cancel(reason11) {
                        this._done = true;
                        for (const requestCapability11 of this._requests)requestCapability11.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                    }
                    progressiveDone() {
                        if (this._done) return;
                        this._done = true;
                    }
                }
                class PDFDataTransportStreamRangeReader11 {
                    constructor(stream11, begin11, end11){
                        this._stream = stream11;
                        this._begin = begin11;
                        this._end = end11;
                        this._queuedChunk = null;
                        this._requests = [];
                        this._done = false;
                        this.onProgress = null;
                    }
                    _enqueue(chunk31) {
                        if (this._done) return;
                        if (this._requests.length === 0) this._queuedChunk = chunk31;
                        else {
                            const requestsCapability11 = this._requests.shift();
                            requestsCapability11.resolve({
                                value: chunk31,
                                done: false
                            });
                            for (const requestCapability11 of this._requests)requestCapability11.resolve({
                                value: undefined,
                                done: true
                            });
                            this._requests.length = 0;
                        }
                        this._done = true;
                        this._stream._removeRangeReader(this);
                    }
                    get isStreamingSupported() {
                        return false;
                    }
                    async read() {
                        if (this._queuedChunk) {
                            const chunk31 = this._queuedChunk;
                            this._queuedChunk = null;
                            return {
                                value: chunk31,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability11 = new _util11.PromiseCapability();
                        this._requests.push(requestCapability11);
                        return requestCapability11.promise;
                    }
                    cancel(reason11) {
                        this._done = true;
                        for (const requestCapability11 of this._requests)requestCapability11.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        this._stream._removeRangeReader(this);
                    }
                }
            /***/ },
            /* 19 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.PDFFetchStream = void 0;
                var _util11 = __w_pdfjs_require__11(1);
                var _network_utils11 = __w_pdfjs_require__11(20);
                function createFetchOptions11(headers11, withCredentials11, abortController11) {
                    return {
                        method: "GET",
                        headers: headers11,
                        signal: abortController11.signal,
                        mode: "cors",
                        credentials: withCredentials11 ? "include" : "same-origin",
                        redirect: "follow"
                    };
                }
                function createHeaders11(httpHeaders11) {
                    const headers11 = new Headers();
                    for(const property11 in httpHeaders11){
                        const value11 = httpHeaders11[property11];
                        if (value11 === undefined) continue;
                        headers11.append(property11, value11);
                    }
                    return headers11;
                }
                function getArrayBuffer11(val11) {
                    if (val11 instanceof Uint8Array) return val11.buffer;
                    if (val11 instanceof ArrayBuffer) return val11;
                    (0, _util11.warn)(`getArrayBuffer - unexpected data format: ${val11}`);
                    return new Uint8Array(val11).buffer;
                }
                class PDFFetchStream11 {
                    constructor(source11){
                        this.source = source11;
                        this.isHttp = /^https?:/i.test(source11.url);
                        this.httpHeaders = this.isHttp && source11.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    getFullReader() {
                        (0, _util11.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
                        this._fullRequestReader = new PDFFetchStreamReader11(this);
                        return this._fullRequestReader;
                    }
                    getRangeReader(begin11, end11) {
                        if (end11 <= this._progressiveDataLength) return null;
                        const reader11 = new PDFFetchStreamRangeReader11(this, begin11, end11);
                        this._rangeRequestReaders.push(reader11);
                        return reader11;
                    }
                    cancelAllRequests(reason11) {
                        this._fullRequestReader?.cancel(reason11);
                        for (const reader11 of this._rangeRequestReaders.slice(0))reader11.cancel(reason11);
                    }
                }
                exports11.PDFFetchStream = PDFFetchStream11;
                class PDFFetchStreamReader11 {
                    constructor(stream11){
                        this._stream = stream11;
                        this._reader = null;
                        this._loaded = 0;
                        this._filename = null;
                        const source11 = stream11.source;
                        this._withCredentials = source11.withCredentials || false;
                        this._contentLength = source11.length;
                        this._headersCapability = new _util11.PromiseCapability();
                        this._disableRange = source11.disableRange || false;
                        this._rangeChunkSize = source11.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._abortController = new AbortController();
                        this._isStreamingSupported = !source11.disableStream;
                        this._isRangeSupported = !source11.disableRange;
                        this._headers = createHeaders11(this._stream.httpHeaders);
                        const url11 = source11.url;
                        fetch(url11, createFetchOptions11(this._headers, this._withCredentials, this._abortController)).then((response11)=>{
                            if (!(0, _network_utils11.validateResponseStatus)(response11.status)) throw (0, _network_utils11.createResponseStatusError)(response11.status, url11);
                            this._reader = response11.body.getReader();
                            this._headersCapability.resolve();
                            const getResponseHeader11 = (name11)=>{
                                return response11.headers.get(name11);
                            };
                            const { allowRangeRequests: allowRangeRequests11, suggestedLength: suggestedLength11 } = (0, _network_utils11.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader11,
                                isHttp: this._stream.isHttp,
                                rangeChunkSize: this._rangeChunkSize,
                                disableRange: this._disableRange
                            });
                            this._isRangeSupported = allowRangeRequests11;
                            this._contentLength = suggestedLength11 || this._contentLength;
                            this._filename = (0, _network_utils11.extractFilenameFromHeader)(getResponseHeader11);
                            if (!this._isStreamingSupported && this._isRangeSupported) this.cancel(new _util11.AbortException("Streaming is disabled."));
                        }).catch(this._headersCapability.reject);
                        this.onProgress = null;
                    }
                    get headersReady() {
                        return this._headersCapability.promise;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._headersCapability.promise;
                        const { value: value11, done: done11 } = await this._reader.read();
                        if (done11) return {
                            value: value11,
                            done: done11
                        };
                        this._loaded += value11.byteLength;
                        this.onProgress?.({
                            loaded: this._loaded,
                            total: this._contentLength
                        });
                        return {
                            value: getArrayBuffer11(value11),
                            done: false
                        };
                    }
                    cancel(reason11) {
                        this._reader?.cancel(reason11);
                        this._abortController.abort();
                    }
                }
                class PDFFetchStreamRangeReader11 {
                    constructor(stream11, begin11, end11){
                        this._stream = stream11;
                        this._reader = null;
                        this._loaded = 0;
                        const source11 = stream11.source;
                        this._withCredentials = source11.withCredentials || false;
                        this._readCapability = new _util11.PromiseCapability();
                        this._isStreamingSupported = !source11.disableStream;
                        this._abortController = new AbortController();
                        this._headers = createHeaders11(this._stream.httpHeaders);
                        this._headers.append("Range", `bytes=${begin11}-${end11 - 1}`);
                        const url11 = source11.url;
                        fetch(url11, createFetchOptions11(this._headers, this._withCredentials, this._abortController)).then((response11)=>{
                            if (!(0, _network_utils11.validateResponseStatus)(response11.status)) throw (0, _network_utils11.createResponseStatusError)(response11.status, url11);
                            this._readCapability.resolve();
                            this._reader = response11.body.getReader();
                        }).catch(this._readCapability.reject);
                        this.onProgress = null;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        const { value: value11, done: done11 } = await this._reader.read();
                        if (done11) return {
                            value: value11,
                            done: done11
                        };
                        this._loaded += value11.byteLength;
                        this.onProgress?.({
                            loaded: this._loaded
                        });
                        return {
                            value: getArrayBuffer11(value11),
                            done: false
                        };
                    }
                    cancel(reason11) {
                        this._reader?.cancel(reason11);
                        this._abortController.abort();
                    }
                }
            /***/ },
            /* 20 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.createResponseStatusError = createResponseStatusError11;
                exports11.extractFilenameFromHeader = extractFilenameFromHeader11;
                exports11.validateRangeRequestCapabilities = validateRangeRequestCapabilities11;
                exports11.validateResponseStatus = validateResponseStatus11;
                var _util11 = __w_pdfjs_require__11(1);
                var _content_disposition11 = __w_pdfjs_require__11(21);
                var _display_utils11 = __w_pdfjs_require__11(6);
                function validateRangeRequestCapabilities11({ getResponseHeader: getResponseHeader11, isHttp: isHttp11, rangeChunkSize: rangeChunkSize11, disableRange: disableRange11 }) {
                    const returnValues11 = {
                        allowRangeRequests: false,
                        suggestedLength: undefined
                    };
                    const length11 = parseInt(getResponseHeader11("Content-Length"), 10);
                    if (!Number.isInteger(length11)) return returnValues11;
                    returnValues11.suggestedLength = length11;
                    if (length11 <= 2 * rangeChunkSize11) return returnValues11;
                    if (disableRange11 || !isHttp11) return returnValues11;
                    if (getResponseHeader11("Accept-Ranges") !== "bytes") return returnValues11;
                    const contentEncoding11 = getResponseHeader11("Content-Encoding") || "identity";
                    if (contentEncoding11 !== "identity") return returnValues11;
                    returnValues11.allowRangeRequests = true;
                    return returnValues11;
                }
                function extractFilenameFromHeader11(getResponseHeader11) {
                    const contentDisposition11 = getResponseHeader11("Content-Disposition");
                    if (contentDisposition11) {
                        let filename11 = (0, _content_disposition11.getFilenameFromContentDispositionHeader)(contentDisposition11);
                        if (filename11.includes("%")) try {
                            filename11 = decodeURIComponent(filename11);
                        } catch  {}
                        if ((0, _display_utils11.isPdfFile)(filename11)) return filename11;
                    }
                    return null;
                }
                function createResponseStatusError11(status11, url11) {
                    if (status11 === 404 || status11 === 0 && url11.startsWith("file:")) return new _util11.MissingPDFException('Missing PDF "' + url11 + '".');
                    return new _util11.UnexpectedResponseException(`Unexpected server response (${status11}) while retrieving PDF "${url11}".`, status11);
                }
                function validateResponseStatus11(status11) {
                    return status11 === 200 || status11 === 206;
                }
            /***/ },
            /* 21 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader11;
                var _util11 = __w_pdfjs_require__11(1);
                function getFilenameFromContentDispositionHeader11(contentDisposition11) {
                    let needsEncodingFixup11 = true;
                    let tmp11 = toParamRegExp11("filename\\*", "i").exec(contentDisposition11);
                    if (tmp11) {
                        tmp11 = tmp11[1];
                        let filename11 = rfc2616unquote11(tmp11);
                        filename11 = unescape(filename11);
                        filename11 = rfc5987decode11(filename11);
                        filename11 = rfc2047decode11(filename11);
                        return fixupEncoding11(filename11);
                    }
                    tmp11 = rfc2231getparam11(contentDisposition11);
                    if (tmp11) {
                        const filename11 = rfc2047decode11(tmp11);
                        return fixupEncoding11(filename11);
                    }
                    tmp11 = toParamRegExp11("filename", "i").exec(contentDisposition11);
                    if (tmp11) {
                        tmp11 = tmp11[1];
                        let filename11 = rfc2616unquote11(tmp11);
                        filename11 = rfc2047decode11(filename11);
                        return fixupEncoding11(filename11);
                    }
                    function toParamRegExp11(attributePattern11, flags11) {
                        return new RegExp("(?:^|;)\\s*" + attributePattern11 + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags11);
                    }
                    function textdecode11(encoding11, value11) {
                        if (encoding11) {
                            if (!/^[\x00-\xFF]+$/.test(value11)) return value11;
                            try {
                                const decoder11 = new TextDecoder(encoding11, {
                                    fatal: true
                                });
                                const buffer11 = (0, _util11.stringToBytes)(value11);
                                value11 = decoder11.decode(buffer11);
                                needsEncodingFixup11 = false;
                            } catch  {}
                        }
                        return value11;
                    }
                    function fixupEncoding11(value11) {
                        if (needsEncodingFixup11 && /[\x80-\xff]/.test(value11)) {
                            value11 = textdecode11("utf-8", value11);
                            if (needsEncodingFixup11) value11 = textdecode11("iso-8859-1", value11);
                        }
                        return value11;
                    }
                    function rfc2231getparam11(contentDispositionStr11) {
                        const matches11 = [];
                        let match11;
                        const iter11 = toParamRegExp11("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
                        while((match11 = iter11.exec(contentDispositionStr11)) !== null){
                            let [, n11, quot11, part11] = match11;
                            n11 = parseInt(n11, 10);
                            if (n11 in matches11) {
                                if (n11 === 0) break;
                                continue;
                            }
                            matches11[n11] = [
                                quot11,
                                part11
                            ];
                        }
                        const parts11 = [];
                        for(let n11 = 0; n11 < matches11.length; ++n11){
                            if (!(n11 in matches11)) break;
                            let [quot11, part11] = matches11[n11];
                            part11 = rfc2616unquote11(part11);
                            if (quot11) {
                                part11 = unescape(part11);
                                if (n11 === 0) part11 = rfc5987decode11(part11);
                            }
                            parts11.push(part11);
                        }
                        return parts11.join("");
                    }
                    function rfc2616unquote11(value11) {
                        if (value11.startsWith('"')) {
                            const parts11 = value11.slice(1).split('\\"');
                            for(let i11 = 0; i11 < parts11.length; ++i11){
                                const quotindex11 = parts11[i11].indexOf('"');
                                if (quotindex11 !== -1) {
                                    parts11[i11] = parts11[i11].slice(0, quotindex11);
                                    parts11.length = i11 + 1;
                                }
                                parts11[i11] = parts11[i11].replaceAll(/\\(.)/g, "$1");
                            }
                            value11 = parts11.join('"');
                        }
                        return value11;
                    }
                    function rfc5987decode11(extvalue11) {
                        const encodingend11 = extvalue11.indexOf("'");
                        if (encodingend11 === -1) return extvalue11;
                        const encoding11 = extvalue11.slice(0, encodingend11);
                        const langvalue11 = extvalue11.slice(encodingend11 + 1);
                        const value11 = langvalue11.replace(/^[^']*'/, "");
                        return textdecode11(encoding11, value11);
                    }
                    function rfc2047decode11(value11) {
                        if (!value11.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value11)) return value11;
                        return value11.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches11, charset11, encoding11, text11) {
                            if (encoding11 === "q" || encoding11 === "Q") {
                                text11 = text11.replaceAll("_", " ");
                                text11 = text11.replaceAll(/=([0-9a-fA-F]{2})/g, function(match11, hex11) {
                                    return String.fromCharCode(parseInt(hex11, 16));
                                });
                                return textdecode11(charset11, text11);
                            }
                            try {
                                text11 = atob(text11);
                            } catch  {}
                            return textdecode11(charset11, text11);
                        });
                    }
                    return "";
                }
            /***/ },
            /* 22 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.PDFNetworkStream = void 0;
                var _util11 = __w_pdfjs_require__11(1);
                var _network_utils11 = __w_pdfjs_require__11(20);
                const OK_RESPONSE11 = 200;
                const PARTIAL_CONTENT_RESPONSE11 = 206;
                function getArrayBuffer11(xhr11) {
                    const data11 = xhr11.response;
                    if (typeof data11 !== "string") return data11;
                    return (0, _util11.stringToBytes)(data11).buffer;
                }
                class NetworkManager11 {
                    constructor(url11, args11 = {}){
                        this.url = url11;
                        this.isHttp = /^https?:/i.test(url11);
                        this.httpHeaders = this.isHttp && args11.httpHeaders || Object.create(null);
                        this.withCredentials = args11.withCredentials || false;
                        this.currXhrId = 0;
                        this.pendingRequests = Object.create(null);
                    }
                    requestRange(begin11, end11, listeners11) {
                        const args11 = {
                            begin: begin11,
                            end: end11
                        };
                        for(const prop11 in listeners11)args11[prop11] = listeners11[prop11];
                        return this.request(args11);
                    }
                    requestFull(listeners11) {
                        return this.request(listeners11);
                    }
                    request(args11) {
                        const xhr11 = new XMLHttpRequest();
                        const xhrId11 = this.currXhrId++;
                        const pendingRequest11 = this.pendingRequests[xhrId11] = {
                            xhr: xhr11
                        };
                        xhr11.open("GET", this.url);
                        xhr11.withCredentials = this.withCredentials;
                        for(const property11 in this.httpHeaders){
                            const value11 = this.httpHeaders[property11];
                            if (value11 === undefined) continue;
                            xhr11.setRequestHeader(property11, value11);
                        }
                        if (this.isHttp && "begin" in args11 && "end" in args11) {
                            xhr11.setRequestHeader("Range", `bytes=${args11.begin}-${args11.end - 1}`);
                            pendingRequest11.expectedStatus = PARTIAL_CONTENT_RESPONSE11;
                        } else pendingRequest11.expectedStatus = OK_RESPONSE11;
                        xhr11.responseType = "arraybuffer";
                        if (args11.onError) xhr11.onerror = function(evt11) {
                            args11.onError(xhr11.status);
                        };
                        xhr11.onreadystatechange = this.onStateChange.bind(this, xhrId11);
                        xhr11.onprogress = this.onProgress.bind(this, xhrId11);
                        pendingRequest11.onHeadersReceived = args11.onHeadersReceived;
                        pendingRequest11.onDone = args11.onDone;
                        pendingRequest11.onError = args11.onError;
                        pendingRequest11.onProgress = args11.onProgress;
                        xhr11.send(null);
                        return xhrId11;
                    }
                    onProgress(xhrId11, evt11) {
                        const pendingRequest11 = this.pendingRequests[xhrId11];
                        if (!pendingRequest11) return;
                        pendingRequest11.onProgress?.(evt11);
                    }
                    onStateChange(xhrId11, evt11) {
                        const pendingRequest11 = this.pendingRequests[xhrId11];
                        if (!pendingRequest11) return;
                        const xhr11 = pendingRequest11.xhr;
                        if (xhr11.readyState >= 2 && pendingRequest11.onHeadersReceived) {
                            pendingRequest11.onHeadersReceived();
                            delete pendingRequest11.onHeadersReceived;
                        }
                        if (xhr11.readyState !== 4) return;
                        if (!(xhrId11 in this.pendingRequests)) return;
                        delete this.pendingRequests[xhrId11];
                        if (xhr11.status === 0 && this.isHttp) {
                            pendingRequest11.onError?.(xhr11.status);
                            return;
                        }
                        const xhrStatus11 = xhr11.status || OK_RESPONSE11;
                        const ok_response_on_range_request11 = xhrStatus11 === OK_RESPONSE11 && pendingRequest11.expectedStatus === PARTIAL_CONTENT_RESPONSE11;
                        if (!ok_response_on_range_request11 && xhrStatus11 !== pendingRequest11.expectedStatus) {
                            pendingRequest11.onError?.(xhr11.status);
                            return;
                        }
                        const chunk31 = getArrayBuffer11(xhr11);
                        if (xhrStatus11 === PARTIAL_CONTENT_RESPONSE11) {
                            const rangeHeader11 = xhr11.getResponseHeader("Content-Range");
                            const matches11 = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader11);
                            pendingRequest11.onDone({
                                begin: parseInt(matches11[1], 10),
                                chunk: chunk31
                            });
                        } else if (chunk31) pendingRequest11.onDone({
                            begin: 0,
                            chunk: chunk31
                        });
                        else pendingRequest11.onError?.(xhr11.status);
                    }
                    getRequestXhr(xhrId11) {
                        return this.pendingRequests[xhrId11].xhr;
                    }
                    isPendingRequest(xhrId11) {
                        return xhrId11 in this.pendingRequests;
                    }
                    abortRequest(xhrId11) {
                        const xhr11 = this.pendingRequests[xhrId11].xhr;
                        delete this.pendingRequests[xhrId11];
                        xhr11.abort();
                    }
                }
                class PDFNetworkStream11 {
                    constructor(source11){
                        this._source = source11;
                        this._manager = new NetworkManager11(source11.url, {
                            httpHeaders: source11.httpHeaders,
                            withCredentials: source11.withCredentials
                        });
                        this._rangeChunkSize = source11.rangeChunkSize;
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    _onRangeRequestReaderClosed(reader11) {
                        const i11 = this._rangeRequestReaders.indexOf(reader11);
                        if (i11 >= 0) this._rangeRequestReaders.splice(i11, 1);
                    }
                    getFullReader() {
                        (0, _util11.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
                        this._fullRequestReader = new PDFNetworkStreamFullRequestReader11(this._manager, this._source);
                        return this._fullRequestReader;
                    }
                    getRangeReader(begin11, end11) {
                        const reader11 = new PDFNetworkStreamRangeRequestReader11(this._manager, begin11, end11);
                        reader11.onClosed = this._onRangeRequestReaderClosed.bind(this);
                        this._rangeRequestReaders.push(reader11);
                        return reader11;
                    }
                    cancelAllRequests(reason11) {
                        this._fullRequestReader?.cancel(reason11);
                        for (const reader11 of this._rangeRequestReaders.slice(0))reader11.cancel(reason11);
                    }
                }
                exports11.PDFNetworkStream = PDFNetworkStream11;
                class PDFNetworkStreamFullRequestReader11 {
                    constructor(manager11, source11){
                        this._manager = manager11;
                        const args11 = {
                            onHeadersReceived: this._onHeadersReceived.bind(this),
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = source11.url;
                        this._fullRequestId = manager11.requestFull(args11);
                        this._headersReceivedCapability = new _util11.PromiseCapability();
                        this._disableRange = source11.disableRange || false;
                        this._contentLength = source11.length;
                        this._rangeChunkSize = source11.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = false;
                        this._isRangeSupported = false;
                        this._cachedChunks = [];
                        this._requests = [];
                        this._done = false;
                        this._storedError = undefined;
                        this._filename = null;
                        this.onProgress = null;
                    }
                    _onHeadersReceived() {
                        const fullRequestXhrId11 = this._fullRequestId;
                        const fullRequestXhr11 = this._manager.getRequestXhr(fullRequestXhrId11);
                        const getResponseHeader11 = (name11)=>{
                            return fullRequestXhr11.getResponseHeader(name11);
                        };
                        const { allowRangeRequests: allowRangeRequests11, suggestedLength: suggestedLength11 } = (0, _network_utils11.validateRangeRequestCapabilities)({
                            getResponseHeader: getResponseHeader11,
                            isHttp: this._manager.isHttp,
                            rangeChunkSize: this._rangeChunkSize,
                            disableRange: this._disableRange
                        });
                        if (allowRangeRequests11) this._isRangeSupported = true;
                        this._contentLength = suggestedLength11 || this._contentLength;
                        this._filename = (0, _network_utils11.extractFilenameFromHeader)(getResponseHeader11);
                        if (this._isRangeSupported) this._manager.abortRequest(fullRequestXhrId11);
                        this._headersReceivedCapability.resolve();
                    }
                    _onDone(data11) {
                        if (data11) {
                            if (this._requests.length > 0) {
                                const requestCapability11 = this._requests.shift();
                                requestCapability11.resolve({
                                    value: data11.chunk,
                                    done: false
                                });
                            } else this._cachedChunks.push(data11.chunk);
                        }
                        this._done = true;
                        if (this._cachedChunks.length > 0) return;
                        for (const requestCapability11 of this._requests)requestCapability11.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                    }
                    _onError(status11) {
                        this._storedError = (0, _network_utils11.createResponseStatusError)(status11, this._url);
                        this._headersReceivedCapability.reject(this._storedError);
                        for (const requestCapability11 of this._requests)requestCapability11.reject(this._storedError);
                        this._requests.length = 0;
                        this._cachedChunks.length = 0;
                    }
                    _onProgress(evt11) {
                        this.onProgress?.({
                            loaded: evt11.loaded,
                            total: evt11.lengthComputable ? evt11.total : this._contentLength
                        });
                    }
                    get filename() {
                        return this._filename;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get headersReady() {
                        return this._headersReceivedCapability.promise;
                    }
                    async read() {
                        if (this._storedError) throw this._storedError;
                        if (this._cachedChunks.length > 0) {
                            const chunk31 = this._cachedChunks.shift();
                            return {
                                value: chunk31,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability11 = new _util11.PromiseCapability();
                        this._requests.push(requestCapability11);
                        return requestCapability11.promise;
                    }
                    cancel(reason11) {
                        this._done = true;
                        this._headersReceivedCapability.reject(reason11);
                        for (const requestCapability11 of this._requests)requestCapability11.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        if (this._manager.isPendingRequest(this._fullRequestId)) this._manager.abortRequest(this._fullRequestId);
                        this._fullRequestReader = null;
                    }
                }
                class PDFNetworkStreamRangeRequestReader11 {
                    constructor(manager11, begin11, end11){
                        this._manager = manager11;
                        const args11 = {
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = manager11.url;
                        this._requestId = manager11.requestRange(begin11, end11, args11);
                        this._requests = [];
                        this._queuedChunk = null;
                        this._done = false;
                        this._storedError = undefined;
                        this.onProgress = null;
                        this.onClosed = null;
                    }
                    _close() {
                        this.onClosed?.(this);
                    }
                    _onDone(data11) {
                        const chunk31 = data11.chunk;
                        if (this._requests.length > 0) {
                            const requestCapability11 = this._requests.shift();
                            requestCapability11.resolve({
                                value: chunk31,
                                done: false
                            });
                        } else this._queuedChunk = chunk31;
                        this._done = true;
                        for (const requestCapability11 of this._requests)requestCapability11.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        this._close();
                    }
                    _onError(status11) {
                        this._storedError = (0, _network_utils11.createResponseStatusError)(status11, this._url);
                        for (const requestCapability11 of this._requests)requestCapability11.reject(this._storedError);
                        this._requests.length = 0;
                        this._queuedChunk = null;
                    }
                    _onProgress(evt11) {
                        if (!this.isStreamingSupported) this.onProgress?.({
                            loaded: evt11.loaded
                        });
                    }
                    get isStreamingSupported() {
                        return false;
                    }
                    async read() {
                        if (this._storedError) throw this._storedError;
                        if (this._queuedChunk !== null) {
                            const chunk31 = this._queuedChunk;
                            this._queuedChunk = null;
                            return {
                                value: chunk31,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability11 = new _util11.PromiseCapability();
                        this._requests.push(requestCapability11);
                        return requestCapability11.promise;
                    }
                    cancel(reason11) {
                        this._done = true;
                        for (const requestCapability11 of this._requests)requestCapability11.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        if (this._manager.isPendingRequest(this._requestId)) this._manager.abortRequest(this._requestId);
                        this._close();
                    }
                }
            /***/ },
            /* 23 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.PDFNodeStream = void 0;
                var _util11 = __w_pdfjs_require__11(1);
                var _network_utils11 = __w_pdfjs_require__11(20);
                const fileUriRegex11 = /^file:\/\/\/[a-zA-Z]:\//;
                function parseUrl11(sourceUrl11) {
                    const url11 = (parcelRequire("gFNhN"));
                    const parsedUrl11 = url11.parse(sourceUrl11);
                    if (parsedUrl11.protocol === "file:" || parsedUrl11.host) return parsedUrl11;
                    if (/^[a-z]:[/\\]/i.test(sourceUrl11)) return url11.parse(`file:///${sourceUrl11}`);
                    if (!parsedUrl11.host) parsedUrl11.protocol = "file:";
                    return parsedUrl11;
                }
                class PDFNodeStream11 {
                    constructor(source11){
                        this.source = source11;
                        this.url = parseUrl11(source11.url);
                        this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
                        this.isFsUrl = this.url.protocol === "file:";
                        this.httpHeaders = this.isHttp && source11.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    getFullReader() {
                        (0, _util11.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
                        this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader11(this) : new PDFNodeStreamFullReader11(this);
                        return this._fullRequestReader;
                    }
                    getRangeReader(start11, end11) {
                        if (end11 <= this._progressiveDataLength) return null;
                        const rangeReader11 = this.isFsUrl ? new PDFNodeStreamFsRangeReader11(this, start11, end11) : new PDFNodeStreamRangeReader11(this, start11, end11);
                        this._rangeRequestReaders.push(rangeReader11);
                        return rangeReader11;
                    }
                    cancelAllRequests(reason11) {
                        this._fullRequestReader?.cancel(reason11);
                        for (const reader11 of this._rangeRequestReaders.slice(0))reader11.cancel(reason11);
                    }
                }
                exports11.PDFNodeStream = PDFNodeStream11;
                class BaseFullReader11 {
                    constructor(stream11){
                        this._url = stream11.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        const source11 = stream11.source;
                        this._contentLength = source11.length;
                        this._loaded = 0;
                        this._filename = null;
                        this._disableRange = source11.disableRange || false;
                        this._rangeChunkSize = source11.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = !source11.disableStream;
                        this._isRangeSupported = !source11.disableRange;
                        this._readableStream = null;
                        this._readCapability = new _util11.PromiseCapability();
                        this._headersCapability = new _util11.PromiseCapability();
                    }
                    get headersReady() {
                        return this._headersCapability.promise;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        if (this._storedError) throw this._storedError;
                        const chunk31 = this._readableStream.read();
                        if (chunk31 === null) {
                            this._readCapability = new _util11.PromiseCapability();
                            return this.read();
                        }
                        this._loaded += chunk31.length;
                        this.onProgress?.({
                            loaded: this._loaded,
                            total: this._contentLength
                        });
                        const buffer11 = new Uint8Array(chunk31).buffer;
                        return {
                            value: buffer11,
                            done: false
                        };
                    }
                    cancel(reason11) {
                        if (!this._readableStream) {
                            this._error(reason11);
                            return;
                        }
                        this._readableStream.destroy(reason11);
                    }
                    _error(reason11) {
                        this._storedError = reason11;
                        this._readCapability.resolve();
                    }
                    _setReadableStream(readableStream11) {
                        this._readableStream = readableStream11;
                        readableStream11.on("readable", ()=>{
                            this._readCapability.resolve();
                        });
                        readableStream11.on("end", ()=>{
                            readableStream11.destroy();
                            this._done = true;
                            this._readCapability.resolve();
                        });
                        readableStream11.on("error", (reason11)=>{
                            this._error(reason11);
                        });
                        if (!this._isStreamingSupported && this._isRangeSupported) this._error(new _util11.AbortException("streaming is disabled"));
                        if (this._storedError) this._readableStream.destroy(this._storedError);
                    }
                }
                class BaseRangeReader11 {
                    constructor(stream11){
                        this._url = stream11.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        this._loaded = 0;
                        this._readableStream = null;
                        this._readCapability = new _util11.PromiseCapability();
                        const source11 = stream11.source;
                        this._isStreamingSupported = !source11.disableStream;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        if (this._storedError) throw this._storedError;
                        const chunk31 = this._readableStream.read();
                        if (chunk31 === null) {
                            this._readCapability = new _util11.PromiseCapability();
                            return this.read();
                        }
                        this._loaded += chunk31.length;
                        this.onProgress?.({
                            loaded: this._loaded
                        });
                        const buffer11 = new Uint8Array(chunk31).buffer;
                        return {
                            value: buffer11,
                            done: false
                        };
                    }
                    cancel(reason11) {
                        if (!this._readableStream) {
                            this._error(reason11);
                            return;
                        }
                        this._readableStream.destroy(reason11);
                    }
                    _error(reason11) {
                        this._storedError = reason11;
                        this._readCapability.resolve();
                    }
                    _setReadableStream(readableStream11) {
                        this._readableStream = readableStream11;
                        readableStream11.on("readable", ()=>{
                            this._readCapability.resolve();
                        });
                        readableStream11.on("end", ()=>{
                            readableStream11.destroy();
                            this._done = true;
                            this._readCapability.resolve();
                        });
                        readableStream11.on("error", (reason11)=>{
                            this._error(reason11);
                        });
                        if (this._storedError) this._readableStream.destroy(this._storedError);
                    }
                }
                function createRequestOptions11(parsedUrl11, headers11) {
                    return {
                        protocol: parsedUrl11.protocol,
                        auth: parsedUrl11.auth,
                        host: parsedUrl11.hostname,
                        port: parsedUrl11.port,
                        path: parsedUrl11.path,
                        method: "GET",
                        headers: headers11
                    };
                }
                class PDFNodeStreamFullReader11 extends BaseFullReader11 {
                    constructor(stream11){
                        super(stream11);
                        const handleResponse11 = (response11)=>{
                            if (response11.statusCode === 404) {
                                const error11 = new _util11.MissingPDFException(`Missing PDF "${this._url}".`);
                                this._storedError = error11;
                                this._headersCapability.reject(error11);
                                return;
                            }
                            this._headersCapability.resolve();
                            this._setReadableStream(response11);
                            const getResponseHeader11 = (name11)=>{
                                return this._readableStream.headers[name11.toLowerCase()];
                            };
                            const { allowRangeRequests: allowRangeRequests11, suggestedLength: suggestedLength11 } = (0, _network_utils11.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader11,
                                isHttp: stream11.isHttp,
                                rangeChunkSize: this._rangeChunkSize,
                                disableRange: this._disableRange
                            });
                            this._isRangeSupported = allowRangeRequests11;
                            this._contentLength = suggestedLength11 || this._contentLength;
                            this._filename = (0, _network_utils11.extractFilenameFromHeader)(getResponseHeader11);
                        };
                        this._request = null;
                        if (this._url.protocol === "http:") {
                            const http11 = (parcelRequire("gFNhN"));
                            this._request = http11.request(createRequestOptions11(this._url, stream11.httpHeaders), handleResponse11);
                        } else {
                            const https11 = (parcelRequire("gFNhN"));
                            this._request = https11.request(createRequestOptions11(this._url, stream11.httpHeaders), handleResponse11);
                        }
                        this._request.on("error", (reason11)=>{
                            this._storedError = reason11;
                            this._headersCapability.reject(reason11);
                        });
                        this._request.end();
                    }
                }
                class PDFNodeStreamRangeReader11 extends BaseRangeReader11 {
                    constructor(stream11, start11, end11){
                        super(stream11);
                        this._httpHeaders = {};
                        for(const property11 in stream11.httpHeaders){
                            const value11 = stream11.httpHeaders[property11];
                            if (value11 === undefined) continue;
                            this._httpHeaders[property11] = value11;
                        }
                        this._httpHeaders.Range = `bytes=${start11}-${end11 - 1}`;
                        const handleResponse11 = (response11)=>{
                            if (response11.statusCode === 404) {
                                const error11 = new _util11.MissingPDFException(`Missing PDF "${this._url}".`);
                                this._storedError = error11;
                                return;
                            }
                            this._setReadableStream(response11);
                        };
                        this._request = null;
                        if (this._url.protocol === "http:") {
                            const http11 = (parcelRequire("gFNhN"));
                            this._request = http11.request(createRequestOptions11(this._url, this._httpHeaders), handleResponse11);
                        } else {
                            const https11 = (parcelRequire("gFNhN"));
                            this._request = https11.request(createRequestOptions11(this._url, this._httpHeaders), handleResponse11);
                        }
                        this._request.on("error", (reason11)=>{
                            this._storedError = reason11;
                        });
                        this._request.end();
                    }
                }
                class PDFNodeStreamFsFullReader11 extends BaseFullReader11 {
                    constructor(stream11){
                        super(stream11);
                        let path11 = decodeURIComponent(this._url.path);
                        if (fileUriRegex11.test(this._url.href)) path11 = path11.replace(/^\//, "");
                        const fs11 = (parcelRequire("gFNhN"));
                        fs11.lstat(path11, (error11, stat11)=>{
                            if (error11) {
                                if (error11.code === "ENOENT") error11 = new _util11.MissingPDFException(`Missing PDF "${path11}".`);
                                this._storedError = error11;
                                this._headersCapability.reject(error11);
                                return;
                            }
                            this._contentLength = stat11.size;
                            this._setReadableStream(fs11.createReadStream(path11));
                            this._headersCapability.resolve();
                        });
                    }
                }
                class PDFNodeStreamFsRangeReader11 extends BaseRangeReader11 {
                    constructor(stream11, start11, end11){
                        super(stream11);
                        let path11 = decodeURIComponent(this._url.path);
                        if (fileUriRegex11.test(this._url.href)) path11 = path11.replace(/^\//, "");
                        const fs11 = (parcelRequire("gFNhN"));
                        this._setReadableStream(fs11.createReadStream(path11, {
                            start: start11,
                            end: end11 - 1
                        }));
                    }
                }
            /***/ },
            /* 24 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.SVGGraphics = void 0;
                var _display_utils11 = __w_pdfjs_require__11(6);
                var _util11 = __w_pdfjs_require__11(1);
                const SVG_DEFAULTS11 = {
                    fontStyle: "normal",
                    fontWeight: "normal",
                    fillColor: "#000000"
                };
                const XML_NS11 = "http://www.w3.org/XML/1998/namespace";
                const XLINK_NS11 = "http://www.w3.org/1999/xlink";
                const LINE_CAP_STYLES11 = [
                    "butt",
                    "round",
                    "square"
                ];
                const LINE_JOIN_STYLES11 = [
                    "miter",
                    "round",
                    "bevel"
                ];
                const createObjectURL11 = function(data11, contentType11 = "", forceDataSchema11 = false) {
                    if (URL.createObjectURL && typeof Blob !== "undefined" && !forceDataSchema11) return URL.createObjectURL(new Blob([
                        data11
                    ], {
                        type: contentType11
                    }));
                    const digits11 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                    let buffer11 = `data:${contentType11};base64,`;
                    for(let i11 = 0, ii11 = data11.length; i11 < ii11; i11 += 3){
                        const b111 = data11[i11] & 0xff;
                        const b211 = data11[i11 + 1] & 0xff;
                        const b311 = data11[i11 + 2] & 0xff;
                        const d111 = b111 >> 2, d211 = (b111 & 3) << 4 | b211 >> 4;
                        const d311 = i11 + 1 < ii11 ? (b211 & 0xf) << 2 | b311 >> 6 : 64;
                        const d411 = i11 + 2 < ii11 ? b311 & 0x3f : 64;
                        buffer11 += digits11[d111] + digits11[d211] + digits11[d311] + digits11[d411];
                    }
                    return buffer11;
                };
                const convertImgDataToPng11 = function() {
                    const PNG_HEADER11 = new Uint8Array([
                        0x89,
                        0x50,
                        0x4e,
                        0x47,
                        0x0d,
                        0x0a,
                        0x1a,
                        0x0a
                    ]);
                    const CHUNK_WRAPPER_SIZE11 = 12;
                    const crcTable11 = new Int32Array(256);
                    for(let i11 = 0; i11 < 256; i11++){
                        let c41 = i11;
                        for(let h31 = 0; h31 < 8; h31++)c41 = c41 & 1 ? 0xedb88320 ^ c41 >> 1 & 0x7fffffff : c41 >> 1 & 0x7fffffff;
                        crcTable11[i11] = c41;
                    }
                    function crc3211(data11, start11, end11) {
                        let crc11 = -1;
                        for(let i11 = start11; i11 < end11; i11++){
                            const a11 = (crc11 ^ data11[i11]) & 0xff;
                            const b41 = crcTable11[a11];
                            crc11 = crc11 >>> 8 ^ b41;
                        }
                        return crc11 ^ -1;
                    }
                    function writePngChunk11(type11, body11, data11, offset11) {
                        let p51 = offset11;
                        const len11 = body11.length;
                        data11[p51] = len11 >> 24 & 0xff;
                        data11[p51 + 1] = len11 >> 16 & 0xff;
                        data11[p51 + 2] = len11 >> 8 & 0xff;
                        data11[p51 + 3] = len11 & 0xff;
                        p51 += 4;
                        data11[p51] = type11.charCodeAt(0) & 0xff;
                        data11[p51 + 1] = type11.charCodeAt(1) & 0xff;
                        data11[p51 + 2] = type11.charCodeAt(2) & 0xff;
                        data11[p51 + 3] = type11.charCodeAt(3) & 0xff;
                        p51 += 4;
                        data11.set(body11, p51);
                        p51 += body11.length;
                        const crc11 = crc3211(data11, offset11 + 4, p51);
                        data11[p51] = crc11 >> 24 & 0xff;
                        data11[p51 + 1] = crc11 >> 16 & 0xff;
                        data11[p51 + 2] = crc11 >> 8 & 0xff;
                        data11[p51 + 3] = crc11 & 0xff;
                    }
                    function adler3211(data11, start11, end11) {
                        let a11 = 1;
                        let b41 = 0;
                        for(let i11 = start11; i11 < end11; ++i11){
                            a11 = (a11 + (data11[i11] & 0xff)) % 65521;
                            b41 = (b41 + a11) % 65521;
                        }
                        return b41 << 16 | a11;
                    }
                    function deflateSync11(literals11) {
                        if (!_util11.isNodeJS) return deflateSyncUncompressed11(literals11);
                        try {
                            const input11 = parseInt($17tgv.versions.node) >= 8 ? literals11 : $f0bb7c288364d569$require$Buffer.from(literals11);
                            const output11 = (parcelRequire("gFNhN")).deflateSync(input11, {
                                level: 9
                            });
                            return output11 instanceof Uint8Array ? output11 : new Uint8Array(output11);
                        } catch (e11) {
                            (0, _util11.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + e11);
                        }
                        return deflateSyncUncompressed11(literals11);
                    }
                    function deflateSyncUncompressed11(literals11) {
                        let len11 = literals11.length;
                        const maxBlockLength11 = 0xffff;
                        const deflateBlocks11 = Math.ceil(len11 / maxBlockLength11);
                        const idat11 = new Uint8Array(2 + len11 + deflateBlocks11 * 5 + 4);
                        let pi11 = 0;
                        idat11[pi11++] = 0x78;
                        idat11[pi11++] = 0x9c;
                        let pos11 = 0;
                        while(len11 > maxBlockLength11){
                            idat11[pi11++] = 0x00;
                            idat11[pi11++] = 0xff;
                            idat11[pi11++] = 0xff;
                            idat11[pi11++] = 0x00;
                            idat11[pi11++] = 0x00;
                            idat11.set(literals11.subarray(pos11, pos11 + maxBlockLength11), pi11);
                            pi11 += maxBlockLength11;
                            pos11 += maxBlockLength11;
                            len11 -= maxBlockLength11;
                        }
                        idat11[pi11++] = 0x01;
                        idat11[pi11++] = len11 & 0xff;
                        idat11[pi11++] = len11 >> 8 & 0xff;
                        idat11[pi11++] = ~len11 & 255;
                        idat11[pi11++] = (~len11 & 0xffff) >> 8 & 0xff;
                        idat11.set(literals11.subarray(pos11), pi11);
                        pi11 += literals11.length - pos11;
                        const adler11 = adler3211(literals11, 0, literals11.length);
                        idat11[pi11++] = adler11 >> 24 & 0xff;
                        idat11[pi11++] = adler11 >> 16 & 0xff;
                        idat11[pi11++] = adler11 >> 8 & 0xff;
                        idat11[pi11++] = adler11 & 0xff;
                        return idat11;
                    }
                    function encode11(imgData11, kind11, forceDataSchema11, isMask11) {
                        const width21 = imgData11.width;
                        const height11 = imgData11.height;
                        let bitDepth11, colorType11, lineSize11;
                        const bytes11 = imgData11.data;
                        switch(kind11){
                            case _util11.ImageKind.GRAYSCALE_1BPP:
                                colorType11 = 0;
                                bitDepth11 = 1;
                                lineSize11 = width21 + 7 >> 3;
                                break;
                            case _util11.ImageKind.RGB_24BPP:
                                colorType11 = 2;
                                bitDepth11 = 8;
                                lineSize11 = width21 * 3;
                                break;
                            case _util11.ImageKind.RGBA_32BPP:
                                colorType11 = 6;
                                bitDepth11 = 8;
                                lineSize11 = width21 * 4;
                                break;
                            default:
                                throw new Error("invalid format");
                        }
                        const literals11 = new Uint8Array((1 + lineSize11) * height11);
                        let offsetLiterals11 = 0, offsetBytes11 = 0;
                        for(let y41 = 0; y41 < height11; ++y41){
                            literals11[offsetLiterals11++] = 0;
                            literals11.set(bytes11.subarray(offsetBytes11, offsetBytes11 + lineSize11), offsetLiterals11);
                            offsetBytes11 += lineSize11;
                            offsetLiterals11 += lineSize11;
                        }
                        if (kind11 === _util11.ImageKind.GRAYSCALE_1BPP && isMask11) {
                            offsetLiterals11 = 0;
                            for(let y41 = 0; y41 < height11; y41++){
                                offsetLiterals11++;
                                for(let i11 = 0; i11 < lineSize11; i11++)literals11[offsetLiterals11++] ^= 0xff;
                            }
                        }
                        const ihdr11 = new Uint8Array([
                            width21 >> 24 & 0xff,
                            width21 >> 16 & 0xff,
                            width21 >> 8 & 0xff,
                            width21 & 0xff,
                            height11 >> 24 & 0xff,
                            height11 >> 16 & 0xff,
                            height11 >> 8 & 0xff,
                            height11 & 0xff,
                            bitDepth11,
                            colorType11,
                            0x00,
                            0x00,
                            0x00
                        ]);
                        const idat11 = deflateSync11(literals11);
                        const pngLength11 = PNG_HEADER11.length + CHUNK_WRAPPER_SIZE11 * 3 + ihdr11.length + idat11.length;
                        const data11 = new Uint8Array(pngLength11);
                        let offset11 = 0;
                        data11.set(PNG_HEADER11, offset11);
                        offset11 += PNG_HEADER11.length;
                        writePngChunk11("IHDR", ihdr11, data11, offset11);
                        offset11 += CHUNK_WRAPPER_SIZE11 + ihdr11.length;
                        writePngChunk11("IDATA", idat11, data11, offset11);
                        offset11 += CHUNK_WRAPPER_SIZE11 + idat11.length;
                        writePngChunk11("IEND", new Uint8Array(0), data11, offset11);
                        return createObjectURL11(data11, "image/png", forceDataSchema11);
                    }
                    return function convertImgDataToPng11(imgData11, forceDataSchema11, isMask11) {
                        const kind11 = imgData11.kind === undefined ? _util11.ImageKind.GRAYSCALE_1BPP : imgData11.kind;
                        return encode11(imgData11, kind11, forceDataSchema11, isMask11);
                    };
                }();
                class SVGExtraState11 {
                    constructor(){
                        this.fontSizeScale = 1;
                        this.fontWeight = SVG_DEFAULTS11.fontWeight;
                        this.fontSize = 0;
                        this.textMatrix = _util11.IDENTITY_MATRIX;
                        this.fontMatrix = _util11.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.textRenderingMode = _util11.TextRenderingMode.FILL;
                        this.textMatrixScale = 1;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRise = 0;
                        this.fillColor = SVG_DEFAULTS11.fillColor;
                        this.strokeColor = "#000000";
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.lineJoin = "";
                        this.lineCap = "";
                        this.miterLimit = 0;
                        this.dashArray = [];
                        this.dashPhase = 0;
                        this.dependencies = [];
                        this.activeClipUrl = null;
                        this.clipGroup = null;
                        this.maskId = "";
                    }
                    clone() {
                        return Object.create(this);
                    }
                    setCurrentPoint(x41, y41) {
                        this.x = x41;
                        this.y = y41;
                    }
                }
                function opListToTree11(opList11) {
                    let opTree11 = [];
                    const tmp11 = [];
                    for (const opListElement11 of opList11){
                        if (opListElement11.fn === "save") {
                            opTree11.push({
                                fnId: 92,
                                fn: "group",
                                items: []
                            });
                            tmp11.push(opTree11);
                            opTree11 = opTree11.at(-1).items;
                            continue;
                        }
                        if (opListElement11.fn === "restore") opTree11 = tmp11.pop();
                        else opTree11.push(opListElement11);
                    }
                    return opTree11;
                }
                function pf11(value11) {
                    if (Number.isInteger(value11)) return value11.toString();
                    const s41 = value11.toFixed(10);
                    let i11 = s41.length - 1;
                    if (s41[i11] !== "0") return s41;
                    do i11--;
                    while (s41[i11] === "0");
                    return s41.substring(0, s41[i11] === "." ? i11 : i11 + 1);
                }
                function pm11(m31) {
                    if (m31[4] === 0 && m31[5] === 0) {
                        if (m31[1] === 0 && m31[2] === 0) {
                            if (m31[0] === 1 && m31[3] === 1) return "";
                            return `scale(${pf11(m31[0])} ${pf11(m31[3])})`;
                        }
                        if (m31[0] === m31[3] && m31[1] === -m31[2]) {
                            const a11 = Math.acos(m31[0]) * 180 / Math.PI;
                            return `rotate(${pf11(a11)})`;
                        }
                    } else if (m31[0] === 1 && m31[1] === 0 && m31[2] === 0 && m31[3] === 1) return `translate(${pf11(m31[4])} ${pf11(m31[5])})`;
                    return `matrix(${pf11(m31[0])} ${pf11(m31[1])} ${pf11(m31[2])} ${pf11(m31[3])} ${pf11(m31[4])} ` + `${pf11(m31[5])})`;
                }
                let clipCount11 = 0;
                let maskCount11 = 0;
                let shadingCount11 = 0;
                class SVGGraphics11 {
                    constructor(commonObjs11, objs11, forceDataSchema11 = false){
                        (0, _display_utils11.deprecated)("The SVG back-end is no longer maintained and *may* be removed in the future.");
                        this.svgFactory = new _display_utils11.DOMSVGFactory();
                        this.current = new SVGExtraState11();
                        this.transformMatrix = _util11.IDENTITY_MATRIX;
                        this.transformStack = [];
                        this.extraStack = [];
                        this.commonObjs = commonObjs11;
                        this.objs = objs11;
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.embedFonts = false;
                        this.embeddedFonts = Object.create(null);
                        this.cssStyle = null;
                        this.forceDataSchema = !!forceDataSchema11;
                        this._operatorIdMapping = [];
                        for(const op11 in _util11.OPS)this._operatorIdMapping[_util11.OPS[op11]] = op11;
                    }
                    getObject(data11, fallback11 = null) {
                        if (typeof data11 === "string") return data11.startsWith("g_") ? this.commonObjs.get(data11) : this.objs.get(data11);
                        return fallback11;
                    }
                    save() {
                        this.transformStack.push(this.transformMatrix);
                        const old11 = this.current;
                        this.extraStack.push(old11);
                        this.current = old11.clone();
                    }
                    restore() {
                        this.transformMatrix = this.transformStack.pop();
                        this.current = this.extraStack.pop();
                        this.pendingClip = null;
                        this.tgrp = null;
                    }
                    group(items11) {
                        this.save();
                        this.executeOpTree(items11);
                        this.restore();
                    }
                    loadDependencies(operatorList11) {
                        const fnArray11 = operatorList11.fnArray;
                        const argsArray11 = operatorList11.argsArray;
                        for(let i11 = 0, ii11 = fnArray11.length; i11 < ii11; i11++){
                            if (fnArray11[i11] !== _util11.OPS.dependency) continue;
                            for (const obj11 of argsArray11[i11]){
                                const objsPool11 = obj11.startsWith("g_") ? this.commonObjs : this.objs;
                                const promise11 = new Promise((resolve11)=>{
                                    objsPool11.get(obj11, resolve11);
                                });
                                this.current.dependencies.push(promise11);
                            }
                        }
                        return Promise.all(this.current.dependencies);
                    }
                    transform(a11, b41, c41, d51, e11, f11) {
                        const transformMatrix11 = [
                            a11,
                            b41,
                            c41,
                            d51,
                            e11,
                            f11
                        ];
                        this.transformMatrix = _util11.Util.transform(this.transformMatrix, transformMatrix11);
                        this.tgrp = null;
                    }
                    getSVG(operatorList11, viewport11) {
                        this.viewport = viewport11;
                        const svgElement11 = this._initialize(viewport11);
                        return this.loadDependencies(operatorList11).then(()=>{
                            this.transformMatrix = _util11.IDENTITY_MATRIX;
                            this.executeOpTree(this.convertOpList(operatorList11));
                            return svgElement11;
                        });
                    }
                    convertOpList(operatorList11) {
                        const operatorIdMapping11 = this._operatorIdMapping;
                        const argsArray11 = operatorList11.argsArray;
                        const fnArray11 = operatorList11.fnArray;
                        const opList11 = [];
                        for(let i11 = 0, ii11 = fnArray11.length; i11 < ii11; i11++){
                            const fnId11 = fnArray11[i11];
                            opList11.push({
                                fnId: fnId11,
                                fn: operatorIdMapping11[fnId11],
                                args: argsArray11[i11]
                            });
                        }
                        return opListToTree11(opList11);
                    }
                    executeOpTree(opTree11) {
                        for (const opTreeElement11 of opTree11){
                            const fn11 = opTreeElement11.fn;
                            const fnId11 = opTreeElement11.fnId;
                            const args11 = opTreeElement11.args;
                            switch(fnId11 | 0){
                                case _util11.OPS.beginText:
                                    this.beginText();
                                    break;
                                case _util11.OPS.dependency:
                                    break;
                                case _util11.OPS.setLeading:
                                    this.setLeading(args11);
                                    break;
                                case _util11.OPS.setLeadingMoveText:
                                    this.setLeadingMoveText(args11[0], args11[1]);
                                    break;
                                case _util11.OPS.setFont:
                                    this.setFont(args11);
                                    break;
                                case _util11.OPS.showText:
                                    this.showText(args11[0]);
                                    break;
                                case _util11.OPS.showSpacedText:
                                    this.showText(args11[0]);
                                    break;
                                case _util11.OPS.endText:
                                    this.endText();
                                    break;
                                case _util11.OPS.moveText:
                                    this.moveText(args11[0], args11[1]);
                                    break;
                                case _util11.OPS.setCharSpacing:
                                    this.setCharSpacing(args11[0]);
                                    break;
                                case _util11.OPS.setWordSpacing:
                                    this.setWordSpacing(args11[0]);
                                    break;
                                case _util11.OPS.setHScale:
                                    this.setHScale(args11[0]);
                                    break;
                                case _util11.OPS.setTextMatrix:
                                    this.setTextMatrix(args11[0], args11[1], args11[2], args11[3], args11[4], args11[5]);
                                    break;
                                case _util11.OPS.setTextRise:
                                    this.setTextRise(args11[0]);
                                    break;
                                case _util11.OPS.setTextRenderingMode:
                                    this.setTextRenderingMode(args11[0]);
                                    break;
                                case _util11.OPS.setLineWidth:
                                    this.setLineWidth(args11[0]);
                                    break;
                                case _util11.OPS.setLineJoin:
                                    this.setLineJoin(args11[0]);
                                    break;
                                case _util11.OPS.setLineCap:
                                    this.setLineCap(args11[0]);
                                    break;
                                case _util11.OPS.setMiterLimit:
                                    this.setMiterLimit(args11[0]);
                                    break;
                                case _util11.OPS.setFillRGBColor:
                                    this.setFillRGBColor(args11[0], args11[1], args11[2]);
                                    break;
                                case _util11.OPS.setStrokeRGBColor:
                                    this.setStrokeRGBColor(args11[0], args11[1], args11[2]);
                                    break;
                                case _util11.OPS.setStrokeColorN:
                                    this.setStrokeColorN(args11);
                                    break;
                                case _util11.OPS.setFillColorN:
                                    this.setFillColorN(args11);
                                    break;
                                case _util11.OPS.shadingFill:
                                    this.shadingFill(args11[0]);
                                    break;
                                case _util11.OPS.setDash:
                                    this.setDash(args11[0], args11[1]);
                                    break;
                                case _util11.OPS.setRenderingIntent:
                                    this.setRenderingIntent(args11[0]);
                                    break;
                                case _util11.OPS.setFlatness:
                                    this.setFlatness(args11[0]);
                                    break;
                                case _util11.OPS.setGState:
                                    this.setGState(args11[0]);
                                    break;
                                case _util11.OPS.fill:
                                    this.fill();
                                    break;
                                case _util11.OPS.eoFill:
                                    this.eoFill();
                                    break;
                                case _util11.OPS.stroke:
                                    this.stroke();
                                    break;
                                case _util11.OPS.fillStroke:
                                    this.fillStroke();
                                    break;
                                case _util11.OPS.eoFillStroke:
                                    this.eoFillStroke();
                                    break;
                                case _util11.OPS.clip:
                                    this.clip("nonzero");
                                    break;
                                case _util11.OPS.eoClip:
                                    this.clip("evenodd");
                                    break;
                                case _util11.OPS.paintSolidColorImageMask:
                                    this.paintSolidColorImageMask();
                                    break;
                                case _util11.OPS.paintImageXObject:
                                    this.paintImageXObject(args11[0]);
                                    break;
                                case _util11.OPS.paintInlineImageXObject:
                                    this.paintInlineImageXObject(args11[0]);
                                    break;
                                case _util11.OPS.paintImageMaskXObject:
                                    this.paintImageMaskXObject(args11[0]);
                                    break;
                                case _util11.OPS.paintFormXObjectBegin:
                                    this.paintFormXObjectBegin(args11[0], args11[1]);
                                    break;
                                case _util11.OPS.paintFormXObjectEnd:
                                    this.paintFormXObjectEnd();
                                    break;
                                case _util11.OPS.closePath:
                                    this.closePath();
                                    break;
                                case _util11.OPS.closeStroke:
                                    this.closeStroke();
                                    break;
                                case _util11.OPS.closeFillStroke:
                                    this.closeFillStroke();
                                    break;
                                case _util11.OPS.closeEOFillStroke:
                                    this.closeEOFillStroke();
                                    break;
                                case _util11.OPS.nextLine:
                                    this.nextLine();
                                    break;
                                case _util11.OPS.transform:
                                    this.transform(args11[0], args11[1], args11[2], args11[3], args11[4], args11[5]);
                                    break;
                                case _util11.OPS.constructPath:
                                    this.constructPath(args11[0], args11[1]);
                                    break;
                                case _util11.OPS.endPath:
                                    this.endPath();
                                    break;
                                case 92:
                                    this.group(opTreeElement11.items);
                                    break;
                                default:
                                    (0, _util11.warn)(`Unimplemented operator ${fn11}`);
                                    break;
                            }
                        }
                    }
                    setWordSpacing(wordSpacing11) {
                        this.current.wordSpacing = wordSpacing11;
                    }
                    setCharSpacing(charSpacing11) {
                        this.current.charSpacing = charSpacing11;
                    }
                    nextLine() {
                        this.moveText(0, this.current.leading);
                    }
                    setTextMatrix(a11, b41, c41, d51, e11, f11) {
                        const current11 = this.current;
                        current11.textMatrix = current11.lineMatrix = [
                            a11,
                            b41,
                            c41,
                            d51,
                            e11,
                            f11
                        ];
                        current11.textMatrixScale = Math.hypot(a11, b41);
                        current11.x = current11.lineX = 0;
                        current11.y = current11.lineY = 0;
                        current11.xcoords = [];
                        current11.ycoords = [];
                        current11.tspan = this.svgFactory.createElement("svg:tspan");
                        current11.tspan.setAttributeNS(null, "font-family", current11.fontFamily);
                        current11.tspan.setAttributeNS(null, "font-size", `${pf11(current11.fontSize)}px`);
                        current11.tspan.setAttributeNS(null, "y", pf11(-current11.y));
                        current11.txtElement = this.svgFactory.createElement("svg:text");
                        current11.txtElement.append(current11.tspan);
                    }
                    beginText() {
                        const current11 = this.current;
                        current11.x = current11.lineX = 0;
                        current11.y = current11.lineY = 0;
                        current11.textMatrix = _util11.IDENTITY_MATRIX;
                        current11.lineMatrix = _util11.IDENTITY_MATRIX;
                        current11.textMatrixScale = 1;
                        current11.tspan = this.svgFactory.createElement("svg:tspan");
                        current11.txtElement = this.svgFactory.createElement("svg:text");
                        current11.txtgrp = this.svgFactory.createElement("svg:g");
                        current11.xcoords = [];
                        current11.ycoords = [];
                    }
                    moveText(x41, y41) {
                        const current11 = this.current;
                        current11.x = current11.lineX += x41;
                        current11.y = current11.lineY += y41;
                        current11.xcoords = [];
                        current11.ycoords = [];
                        current11.tspan = this.svgFactory.createElement("svg:tspan");
                        current11.tspan.setAttributeNS(null, "font-family", current11.fontFamily);
                        current11.tspan.setAttributeNS(null, "font-size", `${pf11(current11.fontSize)}px`);
                        current11.tspan.setAttributeNS(null, "y", pf11(-current11.y));
                    }
                    showText(glyphs11) {
                        const current11 = this.current;
                        const font11 = current11.font;
                        const fontSize11 = current11.fontSize;
                        if (fontSize11 === 0) return;
                        const fontSizeScale11 = current11.fontSizeScale;
                        const charSpacing11 = current11.charSpacing;
                        const wordSpacing11 = current11.wordSpacing;
                        const fontDirection11 = current11.fontDirection;
                        const textHScale11 = current11.textHScale * fontDirection11;
                        const vertical11 = font11.vertical;
                        const spacingDir11 = vertical11 ? 1 : -1;
                        const defaultVMetrics11 = font11.defaultVMetrics;
                        const widthAdvanceScale11 = fontSize11 * current11.fontMatrix[0];
                        let x41 = 0;
                        for (const glyph11 of glyphs11){
                            if (glyph11 === null) {
                                x41 += fontDirection11 * wordSpacing11;
                                continue;
                            } else if (typeof glyph11 === "number") {
                                x41 += spacingDir11 * glyph11 * fontSize11 / 1000;
                                continue;
                            }
                            const spacing11 = (glyph11.isSpace ? wordSpacing11 : 0) + charSpacing11;
                            const character11 = glyph11.fontChar;
                            let scaledX11, scaledY11;
                            let width21 = glyph11.width;
                            if (vertical11) {
                                let vx11;
                                const vmetric11 = glyph11.vmetric || defaultVMetrics11;
                                vx11 = glyph11.vmetric ? vmetric11[1] : width21 * 0.5;
                                vx11 = -vx11 * widthAdvanceScale11;
                                const vy11 = vmetric11[2] * widthAdvanceScale11;
                                width21 = vmetric11 ? -vmetric11[0] : width21;
                                scaledX11 = vx11 / fontSizeScale11;
                                scaledY11 = (x41 + vy11) / fontSizeScale11;
                            } else {
                                scaledX11 = x41 / fontSizeScale11;
                                scaledY11 = 0;
                            }
                            if (glyph11.isInFont || font11.missingFile) {
                                current11.xcoords.push(current11.x + scaledX11);
                                if (vertical11) current11.ycoords.push(-current11.y + scaledY11);
                                current11.tspan.textContent += character11;
                            }
                            const charWidth11 = vertical11 ? width21 * widthAdvanceScale11 - spacing11 * fontDirection11 : width21 * widthAdvanceScale11 + spacing11 * fontDirection11;
                            x41 += charWidth11;
                        }
                        current11.tspan.setAttributeNS(null, "x", current11.xcoords.map(pf11).join(" "));
                        if (vertical11) current11.tspan.setAttributeNS(null, "y", current11.ycoords.map(pf11).join(" "));
                        else current11.tspan.setAttributeNS(null, "y", pf11(-current11.y));
                        if (vertical11) current11.y -= x41;
                        else current11.x += x41 * textHScale11;
                        current11.tspan.setAttributeNS(null, "font-family", current11.fontFamily);
                        current11.tspan.setAttributeNS(null, "font-size", `${pf11(current11.fontSize)}px`);
                        if (current11.fontStyle !== SVG_DEFAULTS11.fontStyle) current11.tspan.setAttributeNS(null, "font-style", current11.fontStyle);
                        if (current11.fontWeight !== SVG_DEFAULTS11.fontWeight) current11.tspan.setAttributeNS(null, "font-weight", current11.fontWeight);
                        const fillStrokeMode11 = current11.textRenderingMode & _util11.TextRenderingMode.FILL_STROKE_MASK;
                        if (fillStrokeMode11 === _util11.TextRenderingMode.FILL || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) {
                            if (current11.fillColor !== SVG_DEFAULTS11.fillColor) current11.tspan.setAttributeNS(null, "fill", current11.fillColor);
                            if (current11.fillAlpha < 1) current11.tspan.setAttributeNS(null, "fill-opacity", current11.fillAlpha);
                        } else if (current11.textRenderingMode === _util11.TextRenderingMode.ADD_TO_PATH) current11.tspan.setAttributeNS(null, "fill", "transparent");
                        else current11.tspan.setAttributeNS(null, "fill", "none");
                        if (fillStrokeMode11 === _util11.TextRenderingMode.STROKE || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) {
                            const lineWidthScale11 = 1 / (current11.textMatrixScale || 1);
                            this._setStrokeAttributes(current11.tspan, lineWidthScale11);
                        }
                        let textMatrix11 = current11.textMatrix;
                        if (current11.textRise !== 0) {
                            textMatrix11 = textMatrix11.slice();
                            textMatrix11[5] += current11.textRise;
                        }
                        current11.txtElement.setAttributeNS(null, "transform", `${pm11(textMatrix11)} scale(${pf11(textHScale11)}, -1)`);
                        current11.txtElement.setAttributeNS(XML_NS11, "xml:space", "preserve");
                        current11.txtElement.append(current11.tspan);
                        current11.txtgrp.append(current11.txtElement);
                        this._ensureTransformGroup().append(current11.txtElement);
                    }
                    setLeadingMoveText(x41, y41) {
                        this.setLeading(-y41);
                        this.moveText(x41, y41);
                    }
                    addFontStyle(fontObj11) {
                        if (!fontObj11.data) throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                        if (!this.cssStyle) {
                            this.cssStyle = this.svgFactory.createElement("svg:style");
                            this.cssStyle.setAttributeNS(null, "type", "text/css");
                            this.defs.append(this.cssStyle);
                        }
                        const url11 = createObjectURL11(fontObj11.data, fontObj11.mimetype, this.forceDataSchema);
                        this.cssStyle.textContent += `@font-face { font-family: "${fontObj11.loadedName}";` + ` src: url(${url11}); }\n`;
                    }
                    setFont(details11) {
                        const current11 = this.current;
                        const fontObj11 = this.commonObjs.get(details11[0]);
                        let size11 = details11[1];
                        current11.font = fontObj11;
                        if (this.embedFonts && !fontObj11.missingFile && !this.embeddedFonts[fontObj11.loadedName]) {
                            this.addFontStyle(fontObj11);
                            this.embeddedFonts[fontObj11.loadedName] = fontObj11;
                        }
                        current11.fontMatrix = fontObj11.fontMatrix || _util11.FONT_IDENTITY_MATRIX;
                        let bold11 = "normal";
                        if (fontObj11.black) bold11 = "900";
                        else if (fontObj11.bold) bold11 = "bold";
                        const italic11 = fontObj11.italic ? "italic" : "normal";
                        if (size11 < 0) {
                            size11 = -size11;
                            current11.fontDirection = -1;
                        } else current11.fontDirection = 1;
                        current11.fontSize = size11;
                        current11.fontFamily = fontObj11.loadedName;
                        current11.fontWeight = bold11;
                        current11.fontStyle = italic11;
                        current11.tspan = this.svgFactory.createElement("svg:tspan");
                        current11.tspan.setAttributeNS(null, "y", pf11(-current11.y));
                        current11.xcoords = [];
                        current11.ycoords = [];
                    }
                    endText() {
                        const current11 = this.current;
                        if (current11.textRenderingMode & _util11.TextRenderingMode.ADD_TO_PATH_FLAG && current11.txtElement?.hasChildNodes()) {
                            current11.element = current11.txtElement;
                            this.clip("nonzero");
                            this.endPath();
                        }
                    }
                    setLineWidth(width21) {
                        if (width21 > 0) this.current.lineWidth = width21;
                    }
                    setLineCap(style11) {
                        this.current.lineCap = LINE_CAP_STYLES11[style11];
                    }
                    setLineJoin(style11) {
                        this.current.lineJoin = LINE_JOIN_STYLES11[style11];
                    }
                    setMiterLimit(limit11) {
                        this.current.miterLimit = limit11;
                    }
                    setStrokeAlpha(strokeAlpha11) {
                        this.current.strokeAlpha = strokeAlpha11;
                    }
                    setStrokeRGBColor(r11, g11, b41) {
                        this.current.strokeColor = _util11.Util.makeHexColor(r11, g11, b41);
                    }
                    setFillAlpha(fillAlpha11) {
                        this.current.fillAlpha = fillAlpha11;
                    }
                    setFillRGBColor(r11, g11, b41) {
                        this.current.fillColor = _util11.Util.makeHexColor(r11, g11, b41);
                        this.current.tspan = this.svgFactory.createElement("svg:tspan");
                        this.current.xcoords = [];
                        this.current.ycoords = [];
                    }
                    setStrokeColorN(args11) {
                        this.current.strokeColor = this._makeColorN_Pattern(args11);
                    }
                    setFillColorN(args11) {
                        this.current.fillColor = this._makeColorN_Pattern(args11);
                    }
                    shadingFill(args11) {
                        const { width: width21, height: height11 } = this.viewport;
                        const inv11 = _util11.Util.inverseTransform(this.transformMatrix);
                        const [x011, y011, x111, y111] = _util11.Util.getAxialAlignedBoundingBox([
                            0,
                            0,
                            width21,
                            height11
                        ], inv11);
                        const rect31 = this.svgFactory.createElement("svg:rect");
                        rect31.setAttributeNS(null, "x", x011);
                        rect31.setAttributeNS(null, "y", y011);
                        rect31.setAttributeNS(null, "width", x111 - x011);
                        rect31.setAttributeNS(null, "height", y111 - y011);
                        rect31.setAttributeNS(null, "fill", this._makeShadingPattern(args11));
                        if (this.current.fillAlpha < 1) rect31.setAttributeNS(null, "fill-opacity", this.current.fillAlpha);
                        this._ensureTransformGroup().append(rect31);
                    }
                    _makeColorN_Pattern(args11) {
                        if (args11[0] === "TilingPattern") return this._makeTilingPattern(args11);
                        return this._makeShadingPattern(args11);
                    }
                    _makeTilingPattern(args11) {
                        const color11 = args11[1];
                        const operatorList11 = args11[2];
                        const matrix11 = args11[3] || _util11.IDENTITY_MATRIX;
                        const [x011, y011, x111, y111] = args11[4];
                        const xstep11 = args11[5];
                        const ystep11 = args11[6];
                        const paintType11 = args11[7];
                        const tilingId11 = `shading${shadingCount11++}`;
                        const [tx011, ty011, tx111, ty111] = _util11.Util.normalizeRect([
                            ..._util11.Util.applyTransform([
                                x011,
                                y011
                            ], matrix11),
                            ..._util11.Util.applyTransform([
                                x111,
                                y111
                            ], matrix11)
                        ]);
                        const [xscale11, yscale11] = _util11.Util.singularValueDecompose2dScale(matrix11);
                        const txstep11 = xstep11 * xscale11;
                        const tystep11 = ystep11 * yscale11;
                        const tiling11 = this.svgFactory.createElement("svg:pattern");
                        tiling11.setAttributeNS(null, "id", tilingId11);
                        tiling11.setAttributeNS(null, "patternUnits", "userSpaceOnUse");
                        tiling11.setAttributeNS(null, "width", txstep11);
                        tiling11.setAttributeNS(null, "height", tystep11);
                        tiling11.setAttributeNS(null, "x", `${tx011}`);
                        tiling11.setAttributeNS(null, "y", `${ty011}`);
                        const svg11 = this.svg;
                        const transformMatrix11 = this.transformMatrix;
                        const fillColor11 = this.current.fillColor;
                        const strokeColor11 = this.current.strokeColor;
                        const bbox11 = this.svgFactory.create(tx111 - tx011, ty111 - ty011);
                        this.svg = bbox11;
                        this.transformMatrix = matrix11;
                        if (paintType11 === 2) {
                            const cssColor11 = _util11.Util.makeHexColor(...color11);
                            this.current.fillColor = cssColor11;
                            this.current.strokeColor = cssColor11;
                        }
                        this.executeOpTree(this.convertOpList(operatorList11));
                        this.svg = svg11;
                        this.transformMatrix = transformMatrix11;
                        this.current.fillColor = fillColor11;
                        this.current.strokeColor = strokeColor11;
                        tiling11.append(bbox11.childNodes[0]);
                        this.defs.append(tiling11);
                        return `url(#${tilingId11})`;
                    }
                    _makeShadingPattern(args11) {
                        if (typeof args11 === "string") args11 = this.objs.get(args11);
                        switch(args11[0]){
                            case "RadialAxial":
                                const shadingId11 = `shading${shadingCount11++}`;
                                const colorStops11 = args11[3];
                                let gradient11;
                                switch(args11[1]){
                                    case "axial":
                                        const point011 = args11[4];
                                        const point111 = args11[5];
                                        gradient11 = this.svgFactory.createElement("svg:linearGradient");
                                        gradient11.setAttributeNS(null, "id", shadingId11);
                                        gradient11.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                        gradient11.setAttributeNS(null, "x1", point011[0]);
                                        gradient11.setAttributeNS(null, "y1", point011[1]);
                                        gradient11.setAttributeNS(null, "x2", point111[0]);
                                        gradient11.setAttributeNS(null, "y2", point111[1]);
                                        break;
                                    case "radial":
                                        const focalPoint11 = args11[4];
                                        const circlePoint11 = args11[5];
                                        const focalRadius11 = args11[6];
                                        const circleRadius11 = args11[7];
                                        gradient11 = this.svgFactory.createElement("svg:radialGradient");
                                        gradient11.setAttributeNS(null, "id", shadingId11);
                                        gradient11.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                        gradient11.setAttributeNS(null, "cx", circlePoint11[0]);
                                        gradient11.setAttributeNS(null, "cy", circlePoint11[1]);
                                        gradient11.setAttributeNS(null, "r", circleRadius11);
                                        gradient11.setAttributeNS(null, "fx", focalPoint11[0]);
                                        gradient11.setAttributeNS(null, "fy", focalPoint11[1]);
                                        gradient11.setAttributeNS(null, "fr", focalRadius11);
                                        break;
                                    default:
                                        throw new Error(`Unknown RadialAxial type: ${args11[1]}`);
                                }
                                for (const colorStop11 of colorStops11){
                                    const stop11 = this.svgFactory.createElement("svg:stop");
                                    stop11.setAttributeNS(null, "offset", colorStop11[0]);
                                    stop11.setAttributeNS(null, "stop-color", colorStop11[1]);
                                    gradient11.append(stop11);
                                }
                                this.defs.append(gradient11);
                                return `url(#${shadingId11})`;
                            case "Mesh":
                                (0, _util11.warn)("Unimplemented pattern Mesh");
                                return null;
                            case "Dummy":
                                return "hotpink";
                            default:
                                throw new Error(`Unknown IR type: ${args11[0]}`);
                        }
                    }
                    setDash(dashArray11, dashPhase11) {
                        this.current.dashArray = dashArray11;
                        this.current.dashPhase = dashPhase11;
                    }
                    constructPath(ops11, args11) {
                        const current11 = this.current;
                        let x41 = current11.x, y41 = current11.y;
                        let d51 = [];
                        let j11 = 0;
                        for (const op11 of ops11)switch(op11 | 0){
                            case _util11.OPS.rectangle:
                                x41 = args11[j11++];
                                y41 = args11[j11++];
                                const width21 = args11[j11++];
                                const height11 = args11[j11++];
                                const xw11 = x41 + width21;
                                const yh11 = y41 + height11;
                                d51.push("M", pf11(x41), pf11(y41), "L", pf11(xw11), pf11(y41), "L", pf11(xw11), pf11(yh11), "L", pf11(x41), pf11(yh11), "Z");
                                break;
                            case _util11.OPS.moveTo:
                                x41 = args11[j11++];
                                y41 = args11[j11++];
                                d51.push("M", pf11(x41), pf11(y41));
                                break;
                            case _util11.OPS.lineTo:
                                x41 = args11[j11++];
                                y41 = args11[j11++];
                                d51.push("L", pf11(x41), pf11(y41));
                                break;
                            case _util11.OPS.curveTo:
                                x41 = args11[j11 + 4];
                                y41 = args11[j11 + 5];
                                d51.push("C", pf11(args11[j11]), pf11(args11[j11 + 1]), pf11(args11[j11 + 2]), pf11(args11[j11 + 3]), pf11(x41), pf11(y41));
                                j11 += 6;
                                break;
                            case _util11.OPS.curveTo2:
                                d51.push("C", pf11(x41), pf11(y41), pf11(args11[j11]), pf11(args11[j11 + 1]), pf11(args11[j11 + 2]), pf11(args11[j11 + 3]));
                                x41 = args11[j11 + 2];
                                y41 = args11[j11 + 3];
                                j11 += 4;
                                break;
                            case _util11.OPS.curveTo3:
                                x41 = args11[j11 + 2];
                                y41 = args11[j11 + 3];
                                d51.push("C", pf11(args11[j11]), pf11(args11[j11 + 1]), pf11(x41), pf11(y41), pf11(x41), pf11(y41));
                                j11 += 4;
                                break;
                            case _util11.OPS.closePath:
                                d51.push("Z");
                                break;
                        }
                        d51 = d51.join(" ");
                        if (current11.path && ops11.length > 0 && ops11[0] !== _util11.OPS.rectangle && ops11[0] !== _util11.OPS.moveTo) d51 = current11.path.getAttributeNS(null, "d") + d51;
                        else {
                            current11.path = this.svgFactory.createElement("svg:path");
                            this._ensureTransformGroup().append(current11.path);
                        }
                        current11.path.setAttributeNS(null, "d", d51);
                        current11.path.setAttributeNS(null, "fill", "none");
                        current11.element = current11.path;
                        current11.setCurrentPoint(x41, y41);
                    }
                    endPath() {
                        const current11 = this.current;
                        current11.path = null;
                        if (!this.pendingClip) return;
                        if (!current11.element) {
                            this.pendingClip = null;
                            return;
                        }
                        const clipId11 = `clippath${clipCount11++}`;
                        const clipPath11 = this.svgFactory.createElement("svg:clipPath");
                        clipPath11.setAttributeNS(null, "id", clipId11);
                        clipPath11.setAttributeNS(null, "transform", pm11(this.transformMatrix));
                        const clipElement11 = current11.element.cloneNode(true);
                        if (this.pendingClip === "evenodd") clipElement11.setAttributeNS(null, "clip-rule", "evenodd");
                        else clipElement11.setAttributeNS(null, "clip-rule", "nonzero");
                        this.pendingClip = null;
                        clipPath11.append(clipElement11);
                        this.defs.append(clipPath11);
                        if (current11.activeClipUrl) {
                            current11.clipGroup = null;
                            for (const prev11 of this.extraStack)prev11.clipGroup = null;
                            clipPath11.setAttributeNS(null, "clip-path", current11.activeClipUrl);
                        }
                        current11.activeClipUrl = `url(#${clipId11})`;
                        this.tgrp = null;
                    }
                    clip(type11) {
                        this.pendingClip = type11;
                    }
                    closePath() {
                        const current11 = this.current;
                        if (current11.path) {
                            const d51 = `${current11.path.getAttributeNS(null, "d")}Z`;
                            current11.path.setAttributeNS(null, "d", d51);
                        }
                    }
                    setLeading(leading11) {
                        this.current.leading = -leading11;
                    }
                    setTextRise(textRise11) {
                        this.current.textRise = textRise11;
                    }
                    setTextRenderingMode(textRenderingMode11) {
                        this.current.textRenderingMode = textRenderingMode11;
                    }
                    setHScale(scale11) {
                        this.current.textHScale = scale11 / 100;
                    }
                    setRenderingIntent(intent11) {}
                    setFlatness(flatness11) {}
                    setGState(states11) {
                        for (const [key11, value11] of states11)switch(key11){
                            case "LW":
                                this.setLineWidth(value11);
                                break;
                            case "LC":
                                this.setLineCap(value11);
                                break;
                            case "LJ":
                                this.setLineJoin(value11);
                                break;
                            case "ML":
                                this.setMiterLimit(value11);
                                break;
                            case "D":
                                this.setDash(value11[0], value11[1]);
                                break;
                            case "RI":
                                this.setRenderingIntent(value11);
                                break;
                            case "FL":
                                this.setFlatness(value11);
                                break;
                            case "Font":
                                this.setFont(value11);
                                break;
                            case "CA":
                                this.setStrokeAlpha(value11);
                                break;
                            case "ca":
                                this.setFillAlpha(value11);
                                break;
                            default:
                                (0, _util11.warn)(`Unimplemented graphic state operator ${key11}`);
                                break;
                        }
                    }
                    fill() {
                        const current11 = this.current;
                        if (current11.element) {
                            current11.element.setAttributeNS(null, "fill", current11.fillColor);
                            current11.element.setAttributeNS(null, "fill-opacity", current11.fillAlpha);
                            this.endPath();
                        }
                    }
                    stroke() {
                        const current11 = this.current;
                        if (current11.element) {
                            this._setStrokeAttributes(current11.element);
                            current11.element.setAttributeNS(null, "fill", "none");
                            this.endPath();
                        }
                    }
                    _setStrokeAttributes(element11, lineWidthScale11 = 1) {
                        const current11 = this.current;
                        let dashArray11 = current11.dashArray;
                        if (lineWidthScale11 !== 1 && dashArray11.length > 0) dashArray11 = dashArray11.map(function(value11) {
                            return lineWidthScale11 * value11;
                        });
                        element11.setAttributeNS(null, "stroke", current11.strokeColor);
                        element11.setAttributeNS(null, "stroke-opacity", current11.strokeAlpha);
                        element11.setAttributeNS(null, "stroke-miterlimit", pf11(current11.miterLimit));
                        element11.setAttributeNS(null, "stroke-linecap", current11.lineCap);
                        element11.setAttributeNS(null, "stroke-linejoin", current11.lineJoin);
                        element11.setAttributeNS(null, "stroke-width", pf11(lineWidthScale11 * current11.lineWidth) + "px");
                        element11.setAttributeNS(null, "stroke-dasharray", dashArray11.map(pf11).join(" "));
                        element11.setAttributeNS(null, "stroke-dashoffset", pf11(lineWidthScale11 * current11.dashPhase) + "px");
                    }
                    eoFill() {
                        this.current.element?.setAttributeNS(null, "fill-rule", "evenodd");
                        this.fill();
                    }
                    fillStroke() {
                        this.stroke();
                        this.fill();
                    }
                    eoFillStroke() {
                        this.current.element?.setAttributeNS(null, "fill-rule", "evenodd");
                        this.fillStroke();
                    }
                    closeStroke() {
                        this.closePath();
                        this.stroke();
                    }
                    closeFillStroke() {
                        this.closePath();
                        this.fillStroke();
                    }
                    closeEOFillStroke() {
                        this.closePath();
                        this.eoFillStroke();
                    }
                    paintSolidColorImageMask() {
                        const rect31 = this.svgFactory.createElement("svg:rect");
                        rect31.setAttributeNS(null, "x", "0");
                        rect31.setAttributeNS(null, "y", "0");
                        rect31.setAttributeNS(null, "width", "1px");
                        rect31.setAttributeNS(null, "height", "1px");
                        rect31.setAttributeNS(null, "fill", this.current.fillColor);
                        this._ensureTransformGroup().append(rect31);
                    }
                    paintImageXObject(objId11) {
                        const imgData11 = this.getObject(objId11);
                        if (!imgData11) {
                            (0, _util11.warn)(`Dependent image with object ID ${objId11} is not ready yet`);
                            return;
                        }
                        this.paintInlineImageXObject(imgData11);
                    }
                    paintInlineImageXObject(imgData11, mask11) {
                        const width21 = imgData11.width;
                        const height11 = imgData11.height;
                        const imgSrc11 = convertImgDataToPng11(imgData11, this.forceDataSchema, !!mask11);
                        const cliprect11 = this.svgFactory.createElement("svg:rect");
                        cliprect11.setAttributeNS(null, "x", "0");
                        cliprect11.setAttributeNS(null, "y", "0");
                        cliprect11.setAttributeNS(null, "width", pf11(width21));
                        cliprect11.setAttributeNS(null, "height", pf11(height11));
                        this.current.element = cliprect11;
                        this.clip("nonzero");
                        const imgEl11 = this.svgFactory.createElement("svg:image");
                        imgEl11.setAttributeNS(XLINK_NS11, "xlink:href", imgSrc11);
                        imgEl11.setAttributeNS(null, "x", "0");
                        imgEl11.setAttributeNS(null, "y", pf11(-height11));
                        imgEl11.setAttributeNS(null, "width", pf11(width21) + "px");
                        imgEl11.setAttributeNS(null, "height", pf11(height11) + "px");
                        imgEl11.setAttributeNS(null, "transform", `scale(${pf11(1 / width21)} ${pf11(-1 / height11)})`);
                        if (mask11) mask11.append(imgEl11);
                        else this._ensureTransformGroup().append(imgEl11);
                    }
                    paintImageMaskXObject(img11) {
                        const imgData11 = this.getObject(img11.data, img11);
                        if (imgData11.bitmap) {
                            (0, _util11.warn)("paintImageMaskXObject: ImageBitmap support is not implemented, ensure that the `isOffscreenCanvasSupported` API parameter is disabled.");
                            return;
                        }
                        const current11 = this.current;
                        const width21 = imgData11.width;
                        const height11 = imgData11.height;
                        const fillColor11 = current11.fillColor;
                        current11.maskId = `mask${maskCount11++}`;
                        const mask11 = this.svgFactory.createElement("svg:mask");
                        mask11.setAttributeNS(null, "id", current11.maskId);
                        const rect31 = this.svgFactory.createElement("svg:rect");
                        rect31.setAttributeNS(null, "x", "0");
                        rect31.setAttributeNS(null, "y", "0");
                        rect31.setAttributeNS(null, "width", pf11(width21));
                        rect31.setAttributeNS(null, "height", pf11(height11));
                        rect31.setAttributeNS(null, "fill", fillColor11);
                        rect31.setAttributeNS(null, "mask", `url(#${current11.maskId})`);
                        this.defs.append(mask11);
                        this._ensureTransformGroup().append(rect31);
                        this.paintInlineImageXObject(imgData11, mask11);
                    }
                    paintFormXObjectBegin(matrix11, bbox11) {
                        if (Array.isArray(matrix11) && matrix11.length === 6) this.transform(matrix11[0], matrix11[1], matrix11[2], matrix11[3], matrix11[4], matrix11[5]);
                        if (bbox11) {
                            const width21 = bbox11[2] - bbox11[0];
                            const height11 = bbox11[3] - bbox11[1];
                            const cliprect11 = this.svgFactory.createElement("svg:rect");
                            cliprect11.setAttributeNS(null, "x", bbox11[0]);
                            cliprect11.setAttributeNS(null, "y", bbox11[1]);
                            cliprect11.setAttributeNS(null, "width", pf11(width21));
                            cliprect11.setAttributeNS(null, "height", pf11(height11));
                            this.current.element = cliprect11;
                            this.clip("nonzero");
                            this.endPath();
                        }
                    }
                    paintFormXObjectEnd() {}
                    _initialize(viewport11) {
                        const svg11 = this.svgFactory.create(viewport11.width, viewport11.height);
                        const definitions11 = this.svgFactory.createElement("svg:defs");
                        svg11.append(definitions11);
                        this.defs = definitions11;
                        const rootGroup11 = this.svgFactory.createElement("svg:g");
                        rootGroup11.setAttributeNS(null, "transform", pm11(viewport11.transform));
                        svg11.append(rootGroup11);
                        this.svg = rootGroup11;
                        return svg11;
                    }
                    _ensureClipGroup() {
                        if (!this.current.clipGroup) {
                            const clipGroup11 = this.svgFactory.createElement("svg:g");
                            clipGroup11.setAttributeNS(null, "clip-path", this.current.activeClipUrl);
                            this.svg.append(clipGroup11);
                            this.current.clipGroup = clipGroup11;
                        }
                        return this.current.clipGroup;
                    }
                    _ensureTransformGroup() {
                        if (!this.tgrp) {
                            this.tgrp = this.svgFactory.createElement("svg:g");
                            this.tgrp.setAttributeNS(null, "transform", pm11(this.transformMatrix));
                            if (this.current.activeClipUrl) this._ensureClipGroup().append(this.tgrp);
                            else this.svg.append(this.tgrp);
                        }
                        return this.tgrp;
                    }
                }
                exports11.SVGGraphics = SVGGraphics11;
            /***/ },
            /* 25 */ /***/ (__unused_webpack_module11, exports11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.XfaText = void 0;
                class XfaText11 {
                    static textContent(xfa11) {
                        const items11 = [];
                        const output11 = {
                            items: items11,
                            styles: Object.create(null)
                        };
                        function walk11(node11) {
                            if (!node11) return;
                            let str11 = null;
                            const name11 = node11.name;
                            if (name11 === "#text") str11 = node11.value;
                            else if (!XfaText11.shouldBuildText(name11)) return;
                            else if (node11?.attributes?.textContent) str11 = node11.attributes.textContent;
                            else if (node11.value) str11 = node11.value;
                            if (str11 !== null) items11.push({
                                str: str11
                            });
                            if (!node11.children) return;
                            for (const child11 of node11.children)walk11(child11);
                        }
                        walk11(xfa11);
                        return output11;
                    }
                    static shouldBuildText(name11) {
                        return !(name11 === "textarea" || name11 === "input" || name11 === "option" || name11 === "select");
                    }
                }
                exports11.XfaText = XfaText11;
            /***/ },
            /* 26 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.TextLayerRenderTask = void 0;
                exports11.renderTextLayer = renderTextLayer11;
                exports11.updateTextLayer = updateTextLayer11;
                var _util11 = __w_pdfjs_require__11(1);
                var _display_utils11 = __w_pdfjs_require__11(6);
                const MAX_TEXT_DIVS_TO_RENDER11 = 100000;
                const DEFAULT_FONT_SIZE11 = 30;
                const DEFAULT_FONT_ASCENT11 = 0.8;
                const ascentCache11 = new Map();
                function getCtx11(size11, isOffscreenCanvasSupported11) {
                    let ctx11;
                    if (isOffscreenCanvasSupported11 && _util11.FeatureTest.isOffscreenCanvasSupported) ctx11 = new OffscreenCanvas(size11, size11).getContext("2d", {
                        alpha: false
                    });
                    else {
                        const canvas11 = document.createElement("canvas");
                        canvas11.width = canvas11.height = size11;
                        ctx11 = canvas11.getContext("2d", {
                            alpha: false
                        });
                    }
                    return ctx11;
                }
                function getAscent11(fontFamily11, isOffscreenCanvasSupported11) {
                    const cachedAscent11 = ascentCache11.get(fontFamily11);
                    if (cachedAscent11) return cachedAscent11;
                    const ctx11 = getCtx11(DEFAULT_FONT_SIZE11, isOffscreenCanvasSupported11);
                    ctx11.font = `${DEFAULT_FONT_SIZE11}px ${fontFamily11}`;
                    const metrics11 = ctx11.measureText("");
                    let ascent11 = metrics11.fontBoundingBoxAscent;
                    let descent11 = Math.abs(metrics11.fontBoundingBoxDescent);
                    if (ascent11) {
                        const ratio11 = ascent11 / (ascent11 + descent11);
                        ascentCache11.set(fontFamily11, ratio11);
                        ctx11.canvas.width = ctx11.canvas.height = 0;
                        return ratio11;
                    }
                    ctx11.strokeStyle = "red";
                    ctx11.clearRect(0, 0, DEFAULT_FONT_SIZE11, DEFAULT_FONT_SIZE11);
                    ctx11.strokeText("g", 0, 0);
                    let pixels11 = ctx11.getImageData(0, 0, DEFAULT_FONT_SIZE11, DEFAULT_FONT_SIZE11).data;
                    descent11 = 0;
                    for(let i11 = pixels11.length - 1 - 3; i11 >= 0; i11 -= 4)if (pixels11[i11] > 0) {
                        descent11 = Math.ceil(i11 / 4 / DEFAULT_FONT_SIZE11);
                        break;
                    }
                    ctx11.clearRect(0, 0, DEFAULT_FONT_SIZE11, DEFAULT_FONT_SIZE11);
                    ctx11.strokeText("A", 0, DEFAULT_FONT_SIZE11);
                    pixels11 = ctx11.getImageData(0, 0, DEFAULT_FONT_SIZE11, DEFAULT_FONT_SIZE11).data;
                    ascent11 = 0;
                    for(let i11 = 0, ii11 = pixels11.length; i11 < ii11; i11 += 4)if (pixels11[i11] > 0) {
                        ascent11 = DEFAULT_FONT_SIZE11 - Math.floor(i11 / 4 / DEFAULT_FONT_SIZE11);
                        break;
                    }
                    ctx11.canvas.width = ctx11.canvas.height = 0;
                    if (ascent11) {
                        const ratio11 = ascent11 / (ascent11 + descent11);
                        ascentCache11.set(fontFamily11, ratio11);
                        return ratio11;
                    }
                    ascentCache11.set(fontFamily11, DEFAULT_FONT_ASCENT11);
                    return DEFAULT_FONT_ASCENT11;
                }
                function appendText11(task11, geom11, styles11) {
                    const textDiv11 = document.createElement("span");
                    const textDivProperties11 = {
                        angle: 0,
                        canvasWidth: 0,
                        hasText: geom11.str !== "",
                        hasEOL: geom11.hasEOL,
                        fontSize: 0
                    };
                    task11._textDivs.push(textDiv11);
                    const tx21 = _util11.Util.transform(task11._transform, geom11.transform);
                    let angle11 = Math.atan2(tx21[1], tx21[0]);
                    const style11 = styles11[geom11.fontName];
                    if (style11.vertical) angle11 += Math.PI / 2;
                    const fontHeight11 = Math.hypot(tx21[2], tx21[3]);
                    const fontAscent11 = fontHeight11 * getAscent11(style11.fontFamily, task11._isOffscreenCanvasSupported);
                    let left11, top11;
                    if (angle11 === 0) {
                        left11 = tx21[4];
                        top11 = tx21[5] - fontAscent11;
                    } else {
                        left11 = tx21[4] + fontAscent11 * Math.sin(angle11);
                        top11 = tx21[5] - fontAscent11 * Math.cos(angle11);
                    }
                    const scaleFactorStr11 = "calc(var(--scale-factor)*";
                    const divStyle11 = textDiv11.style;
                    if (task11._container === task11._rootContainer) {
                        divStyle11.left = `${(100 * left11 / task11._pageWidth).toFixed(2)}%`;
                        divStyle11.top = `${(100 * top11 / task11._pageHeight).toFixed(2)}%`;
                    } else {
                        divStyle11.left = `${scaleFactorStr11}${left11.toFixed(2)}px)`;
                        divStyle11.top = `${scaleFactorStr11}${top11.toFixed(2)}px)`;
                    }
                    divStyle11.fontSize = `${scaleFactorStr11}${fontHeight11.toFixed(2)}px)`;
                    divStyle11.fontFamily = style11.fontFamily;
                    textDivProperties11.fontSize = fontHeight11;
                    textDiv11.setAttribute("role", "presentation");
                    textDiv11.textContent = geom11.str;
                    textDiv11.dir = geom11.dir;
                    if (task11._fontInspectorEnabled) textDiv11.dataset.fontName = geom11.fontName;
                    if (angle11 !== 0) textDivProperties11.angle = angle11 * (180 / Math.PI);
                    let shouldScaleText11 = false;
                    if (geom11.str.length > 1) shouldScaleText11 = true;
                    else if (geom11.str !== " " && geom11.transform[0] !== geom11.transform[3]) {
                        const absScaleX11 = Math.abs(geom11.transform[0]), absScaleY11 = Math.abs(geom11.transform[3]);
                        if (absScaleX11 !== absScaleY11 && Math.max(absScaleX11, absScaleY11) / Math.min(absScaleX11, absScaleY11) > 1.5) shouldScaleText11 = true;
                    }
                    if (shouldScaleText11) textDivProperties11.canvasWidth = style11.vertical ? geom11.height : geom11.width;
                    task11._textDivProperties.set(textDiv11, textDivProperties11);
                    if (task11._isReadableStream) task11._layoutText(textDiv11);
                }
                function layout11(params11) {
                    const { div: div11, scale: scale11, properties: properties11, ctx: ctx11, prevFontSize: prevFontSize11, prevFontFamily: prevFontFamily11 } = params11;
                    const { style: style11 } = div11;
                    let transform11 = "";
                    if (properties11.canvasWidth !== 0 && properties11.hasText) {
                        const { fontFamily: fontFamily11 } = style11;
                        const { canvasWidth: canvasWidth11, fontSize: fontSize11 } = properties11;
                        if (prevFontSize11 !== fontSize11 || prevFontFamily11 !== fontFamily11) {
                            ctx11.font = `${fontSize11 * scale11}px ${fontFamily11}`;
                            params11.prevFontSize = fontSize11;
                            params11.prevFontFamily = fontFamily11;
                        }
                        const { width: width21 } = ctx11.measureText(div11.textContent);
                        if (width21 > 0) transform11 = `scaleX(${canvasWidth11 * scale11 / width21})`;
                    }
                    if (properties11.angle !== 0) transform11 = `rotate(${properties11.angle}deg) ${transform11}`;
                    if (transform11.length > 0) style11.transform = transform11;
                }
                function render11(task11) {
                    if (task11._canceled) return;
                    const textDivs11 = task11._textDivs;
                    const capability11 = task11._capability;
                    const textDivsLength11 = textDivs11.length;
                    if (textDivsLength11 > MAX_TEXT_DIVS_TO_RENDER11) {
                        capability11.resolve();
                        return;
                    }
                    if (!task11._isReadableStream) for (const textDiv11 of textDivs11)task11._layoutText(textDiv11);
                    capability11.resolve();
                }
                class TextLayerRenderTask11 {
                    constructor({ textContentSource: textContentSource11, container: container11, viewport: viewport11, textDivs: textDivs11, textDivProperties: textDivProperties11, textContentItemsStr: textContentItemsStr11, isOffscreenCanvasSupported: isOffscreenCanvasSupported11 }){
                        this._textContentSource = textContentSource11;
                        this._isReadableStream = textContentSource11 instanceof ReadableStream;
                        this._container = this._rootContainer = container11;
                        this._textDivs = textDivs11 || [];
                        this._textContentItemsStr = textContentItemsStr11 || [];
                        this._isOffscreenCanvasSupported = isOffscreenCanvasSupported11;
                        this._fontInspectorEnabled = !!globalThis.FontInspector?.enabled;
                        this._reader = null;
                        this._textDivProperties = textDivProperties11 || new WeakMap();
                        this._canceled = false;
                        this._capability = new _util11.PromiseCapability();
                        this._layoutTextParams = {
                            prevFontSize: null,
                            prevFontFamily: null,
                            div: null,
                            scale: viewport11.scale * (globalThis.devicePixelRatio || 1),
                            properties: null,
                            ctx: getCtx11(0, isOffscreenCanvasSupported11)
                        };
                        const { pageWidth: pageWidth11, pageHeight: pageHeight11, pageX: pageX11, pageY: pageY11 } = viewport11.rawDims;
                        this._transform = [
                            1,
                            0,
                            0,
                            -1,
                            -pageX11,
                            pageY11 + pageHeight11
                        ];
                        this._pageWidth = pageWidth11;
                        this._pageHeight = pageHeight11;
                        (0, _display_utils11.setLayerDimensions)(container11, viewport11);
                        this._capability.promise.finally(()=>{
                            this._layoutTextParams = null;
                        }).catch(()=>{});
                    }
                    get promise() {
                        return this._capability.promise;
                    }
                    cancel() {
                        this._canceled = true;
                        if (this._reader) {
                            this._reader.cancel(new _util11.AbortException("TextLayer task cancelled.")).catch(()=>{});
                            this._reader = null;
                        }
                        this._capability.reject(new _util11.AbortException("TextLayer task cancelled."));
                    }
                    _processItems(items11, styleCache11) {
                        for (const item11 of items11){
                            if (item11.str === undefined) {
                                if (item11.type === "beginMarkedContentProps" || item11.type === "beginMarkedContent") {
                                    const parent11 = this._container;
                                    this._container = document.createElement("span");
                                    this._container.classList.add("markedContent");
                                    if (item11.id !== null) this._container.setAttribute("id", `${item11.id}`);
                                    parent11.append(this._container);
                                } else if (item11.type === "endMarkedContent") this._container = this._container.parentNode;
                                continue;
                            }
                            this._textContentItemsStr.push(item11.str);
                            appendText11(this, item11, styleCache11);
                        }
                    }
                    _layoutText(textDiv11) {
                        const textDivProperties11 = this._layoutTextParams.properties = this._textDivProperties.get(textDiv11);
                        this._layoutTextParams.div = textDiv11;
                        layout11(this._layoutTextParams);
                        if (textDivProperties11.hasText) this._container.append(textDiv11);
                        if (textDivProperties11.hasEOL) {
                            const br11 = document.createElement("br");
                            br11.setAttribute("role", "presentation");
                            this._container.append(br11);
                        }
                    }
                    _render() {
                        const capability11 = new _util11.PromiseCapability();
                        let styleCache11 = Object.create(null);
                        if (this._isReadableStream) {
                            const pump11 = ()=>{
                                this._reader.read().then(({ value: value11, done: done11 })=>{
                                    if (done11) {
                                        capability11.resolve();
                                        return;
                                    }
                                    Object.assign(styleCache11, value11.styles);
                                    this._processItems(value11.items, styleCache11);
                                    pump11();
                                }, capability11.reject);
                            };
                            this._reader = this._textContentSource.getReader();
                            pump11();
                        } else if (this._textContentSource) {
                            const { items: items11, styles: styles11 } = this._textContentSource;
                            this._processItems(items11, styles11);
                            capability11.resolve();
                        } else throw new Error('No "textContentSource" parameter specified.');
                        capability11.promise.then(()=>{
                            styleCache11 = null;
                            render11(this);
                        }, this._capability.reject);
                    }
                }
                exports11.TextLayerRenderTask = TextLayerRenderTask11;
                function renderTextLayer11(params11) {
                    if (!params11.textContentSource && (params11.textContent || params11.textContentStream)) {
                        (0, _display_utils11.deprecated)("The TextLayerRender `textContent`/`textContentStream` parameters will be removed in the future, please use `textContentSource` instead.");
                        params11.textContentSource = params11.textContent || params11.textContentStream;
                    }
                    const { container: container11, viewport: viewport11 } = params11;
                    const style11 = getComputedStyle(container11);
                    const visibility11 = style11.getPropertyValue("visibility");
                    const scaleFactor11 = parseFloat(style11.getPropertyValue("--scale-factor"));
                    if (visibility11 === "visible" && (!scaleFactor11 || Math.abs(scaleFactor11 - viewport11.scale) > 1e-5)) console.error("The `--scale-factor` CSS-variable must be set, to the same value as `viewport.scale`, either on the `container`-element itself or higher up in the DOM.");
                    const task11 = new TextLayerRenderTask11(params11);
                    task11._render();
                    return task11;
                }
                function updateTextLayer11({ container: container11, viewport: viewport11, textDivs: textDivs11, textDivProperties: textDivProperties11, isOffscreenCanvasSupported: isOffscreenCanvasSupported11, mustRotate: mustRotate11 = true, mustRescale: mustRescale11 = true }) {
                    if (mustRotate11) (0, _display_utils11.setLayerDimensions)(container11, {
                        rotation: viewport11.rotation
                    });
                    if (mustRescale11) {
                        const ctx11 = getCtx11(0, isOffscreenCanvasSupported11);
                        const scale11 = viewport11.scale * (globalThis.devicePixelRatio || 1);
                        const params11 = {
                            prevFontSize: null,
                            prevFontFamily: null,
                            div: null,
                            scale: scale11,
                            properties: null,
                            ctx: ctx11
                        };
                        for (const div11 of textDivs11){
                            params11.properties = textDivProperties11.get(div11);
                            params11.div = div11;
                            layout11(params11);
                        }
                    }
                }
            /***/ },
            /* 27 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.AnnotationEditorLayer = void 0;
                var _util11 = __w_pdfjs_require__11(1);
                var _editor11 = __w_pdfjs_require__11(4);
                var _freetext11 = __w_pdfjs_require__11(28);
                var _ink11 = __w_pdfjs_require__11(33);
                var _display_utils11 = __w_pdfjs_require__11(6);
                var _stamp11 = __w_pdfjs_require__11(34);
                class AnnotationEditorLayer11 {
                    #accessibilityManager;
                    #allowClick = false;
                    #annotationLayer = null;
                    #boundPointerup = this.pointerup.bind(this);
                    #boundPointerdown = this.pointerdown.bind(this);
                    #editors = new Map();
                    #hadPointerDown = false;
                    #isCleaningUp = false;
                    #isDisabling = false;
                    #uiManager;
                    static _initialized = false;
                    constructor({ uiManager: uiManager11, pageIndex: pageIndex11, div: div11, accessibilityManager: accessibilityManager11, annotationLayer: annotationLayer11, viewport: viewport11, l10n: l10n11 }){
                        const editorTypes11 = [
                            _freetext11.FreeTextEditor,
                            _ink11.InkEditor,
                            _stamp11.StampEditor
                        ];
                        if (!AnnotationEditorLayer11._initialized) {
                            AnnotationEditorLayer11._initialized = true;
                            for (const editorType11 of editorTypes11)editorType11.initialize(l10n11);
                        }
                        uiManager11.registerEditorTypes(editorTypes11);
                        this.#uiManager = uiManager11;
                        this.pageIndex = pageIndex11;
                        this.div = div11;
                        this.#accessibilityManager = accessibilityManager11;
                        this.#annotationLayer = annotationLayer11;
                        this.viewport = viewport11;
                        this.#uiManager.addLayer(this);
                    }
                    get isEmpty() {
                        return this.#editors.size === 0;
                    }
                    updateToolbar(mode11) {
                        this.#uiManager.updateToolbar(mode11);
                    }
                    updateMode(mode11 = this.#uiManager.getMode()) {
                        this.#cleanup();
                        if (mode11 === _util11.AnnotationEditorType.INK) {
                            this.addInkEditorIfNeeded(false);
                            this.disableClick();
                        } else this.enableClick();
                        if (mode11 !== _util11.AnnotationEditorType.NONE) {
                            this.div.classList.toggle("freeTextEditing", mode11 === _util11.AnnotationEditorType.FREETEXT);
                            this.div.classList.toggle("inkEditing", mode11 === _util11.AnnotationEditorType.INK);
                            this.div.classList.toggle("stampEditing", mode11 === _util11.AnnotationEditorType.STAMP);
                            this.div.hidden = false;
                        }
                    }
                    addInkEditorIfNeeded(isCommitting11) {
                        if (!isCommitting11 && this.#uiManager.getMode() !== _util11.AnnotationEditorType.INK) return;
                        if (!isCommitting11) {
                            for (const editor11 of this.#editors.values())if (editor11.isEmpty()) {
                                editor11.setInBackground();
                                return;
                            }
                        }
                        const editor11 = this.#createAndAddNewEditor({
                            offsetX: 0,
                            offsetY: 0
                        }, false);
                        editor11.setInBackground();
                    }
                    setEditingState(isEditing11) {
                        this.#uiManager.setEditingState(isEditing11);
                    }
                    addCommands(params11) {
                        this.#uiManager.addCommands(params11);
                    }
                    enable() {
                        this.div.style.pointerEvents = "auto";
                        const annotationElementIds11 = new Set();
                        for (const editor11 of this.#editors.values()){
                            editor11.enableEditing();
                            if (editor11.annotationElementId) annotationElementIds11.add(editor11.annotationElementId);
                        }
                        if (!this.#annotationLayer) return;
                        const editables11 = this.#annotationLayer.getEditableAnnotations();
                        for (const editable11 of editables11){
                            editable11.hide();
                            if (this.#uiManager.isDeletedAnnotationElement(editable11.data.id)) continue;
                            if (annotationElementIds11.has(editable11.data.id)) continue;
                            const editor11 = this.deserialize(editable11);
                            if (!editor11) continue;
                            this.addOrRebuild(editor11);
                            editor11.enableEditing();
                        }
                    }
                    disable() {
                        this.#isDisabling = true;
                        this.div.style.pointerEvents = "none";
                        const hiddenAnnotationIds11 = new Set();
                        for (const editor11 of this.#editors.values()){
                            editor11.disableEditing();
                            if (!editor11.annotationElementId || editor11.serialize() !== null) {
                                hiddenAnnotationIds11.add(editor11.annotationElementId);
                                continue;
                            }
                            this.getEditableAnnotation(editor11.annotationElementId)?.show();
                            editor11.remove();
                        }
                        if (this.#annotationLayer) {
                            const editables11 = this.#annotationLayer.getEditableAnnotations();
                            for (const editable11 of editables11){
                                const { id: id11 } = editable11.data;
                                if (hiddenAnnotationIds11.has(id11) || this.#uiManager.isDeletedAnnotationElement(id11)) continue;
                                editable11.show();
                            }
                        }
                        this.#cleanup();
                        if (this.isEmpty) this.div.hidden = true;
                        this.#isDisabling = false;
                    }
                    getEditableAnnotation(id11) {
                        return this.#annotationLayer?.getEditableAnnotation(id11) || null;
                    }
                    setActiveEditor(editor11) {
                        const currentActive11 = this.#uiManager.getActive();
                        if (currentActive11 === editor11) return;
                        this.#uiManager.setActiveEditor(editor11);
                    }
                    enableClick() {
                        this.div.addEventListener("pointerdown", this.#boundPointerdown);
                        this.div.addEventListener("pointerup", this.#boundPointerup);
                    }
                    disableClick() {
                        this.div.removeEventListener("pointerdown", this.#boundPointerdown);
                        this.div.removeEventListener("pointerup", this.#boundPointerup);
                    }
                    attach(editor11) {
                        this.#editors.set(editor11.id, editor11);
                        const { annotationElementId: annotationElementId11 } = editor11;
                        if (annotationElementId11 && this.#uiManager.isDeletedAnnotationElement(annotationElementId11)) this.#uiManager.removeDeletedAnnotationElement(editor11);
                    }
                    detach(editor11) {
                        this.#editors.delete(editor11.id);
                        this.#accessibilityManager?.removePointerInTextLayer(editor11.contentDiv);
                        if (!this.#isDisabling && editor11.annotationElementId) this.#uiManager.addDeletedAnnotationElement(editor11);
                    }
                    remove(editor11) {
                        this.detach(editor11);
                        this.#uiManager.removeEditor(editor11);
                        if (editor11.div.contains(document.activeElement)) setTimeout(()=>{
                            this.#uiManager.focusMainContainer();
                        }, 0);
                        editor11.div.remove();
                        editor11.isAttachedToDOM = false;
                        if (!this.#isCleaningUp) this.addInkEditorIfNeeded(false);
                    }
                    changeParent(editor11) {
                        if (editor11.parent === this) return;
                        if (editor11.annotationElementId) {
                            this.#uiManager.addDeletedAnnotationElement(editor11.annotationElementId);
                            _editor11.AnnotationEditor.deleteAnnotationElement(editor11);
                            editor11.annotationElementId = null;
                        }
                        this.attach(editor11);
                        editor11.parent?.detach(editor11);
                        editor11.setParent(this);
                        if (editor11.div && editor11.isAttachedToDOM) {
                            editor11.div.remove();
                            this.div.append(editor11.div);
                        }
                    }
                    add(editor11) {
                        this.changeParent(editor11);
                        this.#uiManager.addEditor(editor11);
                        this.attach(editor11);
                        if (!editor11.isAttachedToDOM) {
                            const div11 = editor11.render();
                            this.div.append(div11);
                            editor11.isAttachedToDOM = true;
                        }
                        editor11.fixAndSetPosition();
                        editor11.onceAdded();
                        this.#uiManager.addToAnnotationStorage(editor11);
                    }
                    moveEditorInDOM(editor11) {
                        if (!editor11.isAttachedToDOM) return;
                        const { activeElement: activeElement11 } = document;
                        if (editor11.div.contains(activeElement11)) {
                            editor11._focusEventsAllowed = false;
                            setTimeout(()=>{
                                if (!editor11.div.contains(document.activeElement)) {
                                    editor11.div.addEventListener("focusin", ()=>{
                                        editor11._focusEventsAllowed = true;
                                    }, {
                                        once: true
                                    });
                                    activeElement11.focus();
                                } else editor11._focusEventsAllowed = true;
                            }, 0);
                        }
                        editor11._structTreeParentId = this.#accessibilityManager?.moveElementInDOM(this.div, editor11.div, editor11.contentDiv, true);
                    }
                    addOrRebuild(editor11) {
                        if (editor11.needsToBeRebuilt()) editor11.rebuild();
                        else this.add(editor11);
                    }
                    addUndoableEditor(editor11) {
                        const cmd11 = ()=>editor11._uiManager.rebuild(editor11);
                        const undo11 = ()=>{
                            editor11.remove();
                        };
                        this.addCommands({
                            cmd: cmd11,
                            undo: undo11,
                            mustExec: false
                        });
                    }
                    getNextId() {
                        return this.#uiManager.getId();
                    }
                    #createNewEditor(params11) {
                        switch(this.#uiManager.getMode()){
                            case _util11.AnnotationEditorType.FREETEXT:
                                return new _freetext11.FreeTextEditor(params11);
                            case _util11.AnnotationEditorType.INK:
                                return new _ink11.InkEditor(params11);
                            case _util11.AnnotationEditorType.STAMP:
                                return new _stamp11.StampEditor(params11);
                        }
                        return null;
                    }
                    pasteEditor(mode11, params11) {
                        this.#uiManager.updateToolbar(mode11);
                        this.#uiManager.updateMode(mode11);
                        const { offsetX: offsetX11, offsetY: offsetY11 } = this.#getCenterPoint();
                        const id11 = this.getNextId();
                        const editor11 = this.#createNewEditor({
                            parent: this,
                            id: id11,
                            x: offsetX11,
                            y: offsetY11,
                            uiManager: this.#uiManager,
                            isCentered: true,
                            ...params11
                        });
                        if (editor11) this.add(editor11);
                    }
                    deserialize(data11) {
                        switch(data11.annotationType ?? data11.annotationEditorType){
                            case _util11.AnnotationEditorType.FREETEXT:
                                return _freetext11.FreeTextEditor.deserialize(data11, this, this.#uiManager);
                            case _util11.AnnotationEditorType.INK:
                                return _ink11.InkEditor.deserialize(data11, this, this.#uiManager);
                            case _util11.AnnotationEditorType.STAMP:
                                return _stamp11.StampEditor.deserialize(data11, this, this.#uiManager);
                        }
                        return null;
                    }
                    #createAndAddNewEditor(event11, isCentered11) {
                        const id11 = this.getNextId();
                        const editor11 = this.#createNewEditor({
                            parent: this,
                            id: id11,
                            x: event11.offsetX,
                            y: event11.offsetY,
                            uiManager: this.#uiManager,
                            isCentered: isCentered11
                        });
                        if (editor11) this.add(editor11);
                        return editor11;
                    }
                    #getCenterPoint() {
                        const { x: x41, y: y41, width: width21, height: height11 } = this.div.getBoundingClientRect();
                        const tlX11 = Math.max(0, x41);
                        const tlY11 = Math.max(0, y41);
                        const brX11 = Math.min(window.innerWidth, x41 + width21);
                        const brY11 = Math.min(window.innerHeight, y41 + height11);
                        const centerX11 = (tlX11 + brX11) / 2 - x41;
                        const centerY11 = (tlY11 + brY11) / 2 - y41;
                        const [offsetX11, offsetY11] = this.viewport.rotation % 180 === 0 ? [
                            centerX11,
                            centerY11
                        ] : [
                            centerY11,
                            centerX11
                        ];
                        return {
                            offsetX: offsetX11,
                            offsetY: offsetY11
                        };
                    }
                    addNewEditor() {
                        this.#createAndAddNewEditor(this.#getCenterPoint(), true);
                    }
                    setSelected(editor11) {
                        this.#uiManager.setSelected(editor11);
                    }
                    toggleSelected(editor11) {
                        this.#uiManager.toggleSelected(editor11);
                    }
                    isSelected(editor11) {
                        return this.#uiManager.isSelected(editor11);
                    }
                    unselect(editor11) {
                        this.#uiManager.unselect(editor11);
                    }
                    pointerup(event11) {
                        const { isMac: isMac11 } = _util11.FeatureTest.platform;
                        if (event11.button !== 0 || event11.ctrlKey && isMac11) return;
                        if (event11.target !== this.div) return;
                        if (!this.#hadPointerDown) return;
                        this.#hadPointerDown = false;
                        if (!this.#allowClick) {
                            this.#allowClick = true;
                            return;
                        }
                        if (this.#uiManager.getMode() === _util11.AnnotationEditorType.STAMP) {
                            this.#uiManager.unselectAll();
                            return;
                        }
                        this.#createAndAddNewEditor(event11, false);
                    }
                    pointerdown(event11) {
                        if (this.#hadPointerDown) {
                            this.#hadPointerDown = false;
                            return;
                        }
                        const { isMac: isMac11 } = _util11.FeatureTest.platform;
                        if (event11.button !== 0 || event11.ctrlKey && isMac11) return;
                        if (event11.target !== this.div) return;
                        this.#hadPointerDown = true;
                        const editor11 = this.#uiManager.getActive();
                        this.#allowClick = !editor11 || editor11.isEmpty();
                    }
                    findNewParent(editor11, x41, y41) {
                        const layer11 = this.#uiManager.findParent(x41, y41);
                        if (layer11 === null || layer11 === this) return false;
                        layer11.changeParent(editor11);
                        return true;
                    }
                    destroy() {
                        if (this.#uiManager.getActive()?.parent === this) {
                            this.#uiManager.commitOrRemove();
                            this.#uiManager.setActiveEditor(null);
                        }
                        for (const editor11 of this.#editors.values()){
                            this.#accessibilityManager?.removePointerInTextLayer(editor11.contentDiv);
                            editor11.setParent(null);
                            editor11.isAttachedToDOM = false;
                            editor11.div.remove();
                        }
                        this.div = null;
                        this.#editors.clear();
                        this.#uiManager.removeLayer(this);
                    }
                    #cleanup() {
                        this.#isCleaningUp = true;
                        for (const editor11 of this.#editors.values())if (editor11.isEmpty()) editor11.remove();
                        this.#isCleaningUp = false;
                    }
                    render({ viewport: viewport11 }) {
                        this.viewport = viewport11;
                        (0, _display_utils11.setLayerDimensions)(this.div, viewport11);
                        for (const editor11 of this.#uiManager.getEditors(this.pageIndex))this.add(editor11);
                        this.updateMode();
                    }
                    update({ viewport: viewport11 }) {
                        this.#uiManager.commitOrRemove();
                        this.viewport = viewport11;
                        (0, _display_utils11.setLayerDimensions)(this.div, {
                            rotation: viewport11.rotation
                        });
                        this.updateMode();
                    }
                    get pageDimensions() {
                        const { pageWidth: pageWidth11, pageHeight: pageHeight11 } = this.viewport.rawDims;
                        return [
                            pageWidth11,
                            pageHeight11
                        ];
                    }
                }
                exports11.AnnotationEditorLayer = AnnotationEditorLayer11;
            /***/ },
            /* 28 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.FreeTextEditor = void 0;
                var _util11 = __w_pdfjs_require__11(1);
                var _tools11 = __w_pdfjs_require__11(5);
                var _editor11 = __w_pdfjs_require__11(4);
                var _annotation_layer11 = __w_pdfjs_require__11(29);
                class FreeTextEditor11 extends _editor11.AnnotationEditor {
                    #boundEditorDivBlur = this.editorDivBlur.bind(this);
                    #boundEditorDivFocus = this.editorDivFocus.bind(this);
                    #boundEditorDivInput = this.editorDivInput.bind(this);
                    #boundEditorDivKeydown = this.editorDivKeydown.bind(this);
                    #color;
                    #content = "";
                    #editorDivId = `${this.id}-editor`;
                    #fontSize;
                    #initialData = null;
                    static _freeTextDefaultContent = "";
                    static _internalPadding = 0;
                    static _defaultColor = null;
                    static _defaultFontSize = 10;
                    static get _keyboardManager() {
                        const proto11 = FreeTextEditor11.prototype;
                        const arrowChecker11 = (self11)=>self11.isEmpty();
                        const small11 = _tools11.AnnotationEditorUIManager.TRANSLATE_SMALL;
                        const big11 = _tools11.AnnotationEditorUIManager.TRANSLATE_BIG;
                        return (0, _util11.shadow)(this, "_keyboardManager", new _tools11.KeyboardManager([
                            [
                                [
                                    "ctrl+s",
                                    "mac+meta+s",
                                    "ctrl+p",
                                    "mac+meta+p"
                                ],
                                proto11.commitOrRemove,
                                {
                                    bubbles: true
                                }
                            ],
                            [
                                [
                                    "ctrl+Enter",
                                    "mac+meta+Enter",
                                    "Escape",
                                    "mac+Escape"
                                ],
                                proto11.commitOrRemove
                            ],
                            [
                                [
                                    "ArrowLeft",
                                    "mac+ArrowLeft"
                                ],
                                proto11._translateEmpty,
                                {
                                    args: [
                                        -small11,
                                        0
                                    ],
                                    checker: arrowChecker11
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowLeft",
                                    "mac+shift+ArrowLeft"
                                ],
                                proto11._translateEmpty,
                                {
                                    args: [
                                        -big11,
                                        0
                                    ],
                                    checker: arrowChecker11
                                }
                            ],
                            [
                                [
                                    "ArrowRight",
                                    "mac+ArrowRight"
                                ],
                                proto11._translateEmpty,
                                {
                                    args: [
                                        small11,
                                        0
                                    ],
                                    checker: arrowChecker11
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowRight",
                                    "mac+shift+ArrowRight"
                                ],
                                proto11._translateEmpty,
                                {
                                    args: [
                                        big11,
                                        0
                                    ],
                                    checker: arrowChecker11
                                }
                            ],
                            [
                                [
                                    "ArrowUp",
                                    "mac+ArrowUp"
                                ],
                                proto11._translateEmpty,
                                {
                                    args: [
                                        0,
                                        -small11
                                    ],
                                    checker: arrowChecker11
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowUp",
                                    "mac+shift+ArrowUp"
                                ],
                                proto11._translateEmpty,
                                {
                                    args: [
                                        0,
                                        -big11
                                    ],
                                    checker: arrowChecker11
                                }
                            ],
                            [
                                [
                                    "ArrowDown",
                                    "mac+ArrowDown"
                                ],
                                proto11._translateEmpty,
                                {
                                    args: [
                                        0,
                                        small11
                                    ],
                                    checker: arrowChecker11
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowDown",
                                    "mac+shift+ArrowDown"
                                ],
                                proto11._translateEmpty,
                                {
                                    args: [
                                        0,
                                        big11
                                    ],
                                    checker: arrowChecker11
                                }
                            ]
                        ]));
                    }
                    static _type = "freetext";
                    constructor(params11){
                        super({
                            ...params11,
                            name: "freeTextEditor"
                        });
                        this.#color = params11.color || FreeTextEditor11._defaultColor || _editor11.AnnotationEditor._defaultLineColor;
                        this.#fontSize = params11.fontSize || FreeTextEditor11._defaultFontSize;
                    }
                    static initialize(l10n11) {
                        _editor11.AnnotationEditor.initialize(l10n11, {
                            strings: [
                                "free_text2_default_content",
                                "editor_free_text2_aria_label"
                            ]
                        });
                        const style11 = getComputedStyle(document.documentElement);
                        this._internalPadding = parseFloat(style11.getPropertyValue("--freetext-padding"));
                    }
                    static updateDefaultParams(type11, value11) {
                        switch(type11){
                            case _util11.AnnotationEditorParamsType.FREETEXT_SIZE:
                                FreeTextEditor11._defaultFontSize = value11;
                                break;
                            case _util11.AnnotationEditorParamsType.FREETEXT_COLOR:
                                FreeTextEditor11._defaultColor = value11;
                                break;
                        }
                    }
                    updateParams(type11, value11) {
                        switch(type11){
                            case _util11.AnnotationEditorParamsType.FREETEXT_SIZE:
                                this.#updateFontSize(value11);
                                break;
                            case _util11.AnnotationEditorParamsType.FREETEXT_COLOR:
                                this.#updateColor(value11);
                                break;
                        }
                    }
                    static get defaultPropertiesToUpdate() {
                        return [
                            [
                                _util11.AnnotationEditorParamsType.FREETEXT_SIZE,
                                FreeTextEditor11._defaultFontSize
                            ],
                            [
                                _util11.AnnotationEditorParamsType.FREETEXT_COLOR,
                                FreeTextEditor11._defaultColor || _editor11.AnnotationEditor._defaultLineColor
                            ]
                        ];
                    }
                    get propertiesToUpdate() {
                        return [
                            [
                                _util11.AnnotationEditorParamsType.FREETEXT_SIZE,
                                this.#fontSize
                            ],
                            [
                                _util11.AnnotationEditorParamsType.FREETEXT_COLOR,
                                this.#color
                            ]
                        ];
                    }
                    #updateFontSize(fontSize11) {
                        const setFontsize11 = (size11)=>{
                            this.editorDiv.style.fontSize = `calc(${size11}px * var(--scale-factor))`;
                            this.translate(0, -(size11 - this.#fontSize) * this.parentScale);
                            this.#fontSize = size11;
                            this.#setEditorDimensions();
                        };
                        const savedFontsize11 = this.#fontSize;
                        this.addCommands({
                            cmd: ()=>{
                                setFontsize11(fontSize11);
                            },
                            undo: ()=>{
                                setFontsize11(savedFontsize11);
                            },
                            mustExec: true,
                            type: _util11.AnnotationEditorParamsType.FREETEXT_SIZE,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    #updateColor(color11) {
                        const savedColor11 = this.#color;
                        this.addCommands({
                            cmd: ()=>{
                                this.#color = this.editorDiv.style.color = color11;
                            },
                            undo: ()=>{
                                this.#color = this.editorDiv.style.color = savedColor11;
                            },
                            mustExec: true,
                            type: _util11.AnnotationEditorParamsType.FREETEXT_COLOR,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    _translateEmpty(x41, y41) {
                        this._uiManager.translateSelectedEditors(x41, y41, true);
                    }
                    getInitialTranslation() {
                        const scale11 = this.parentScale;
                        return [
                            -FreeTextEditor11._internalPadding * scale11,
                            -(FreeTextEditor11._internalPadding + this.#fontSize) * scale11
                        ];
                    }
                    rebuild() {
                        if (!this.parent) return;
                        super.rebuild();
                        if (this.div === null) return;
                        if (!this.isAttachedToDOM) this.parent.add(this);
                    }
                    enableEditMode() {
                        if (this.isInEditMode()) return;
                        this.parent.setEditingState(false);
                        this.parent.updateToolbar(_util11.AnnotationEditorType.FREETEXT);
                        super.enableEditMode();
                        this.overlayDiv.classList.remove("enabled");
                        this.editorDiv.contentEditable = true;
                        this._isDraggable = false;
                        this.div.removeAttribute("aria-activedescendant");
                        this.editorDiv.addEventListener("keydown", this.#boundEditorDivKeydown);
                        this.editorDiv.addEventListener("focus", this.#boundEditorDivFocus);
                        this.editorDiv.addEventListener("blur", this.#boundEditorDivBlur);
                        this.editorDiv.addEventListener("input", this.#boundEditorDivInput);
                    }
                    disableEditMode() {
                        if (!this.isInEditMode()) return;
                        this.parent.setEditingState(true);
                        super.disableEditMode();
                        this.overlayDiv.classList.add("enabled");
                        this.editorDiv.contentEditable = false;
                        this.div.setAttribute("aria-activedescendant", this.#editorDivId);
                        this._isDraggable = true;
                        this.editorDiv.removeEventListener("keydown", this.#boundEditorDivKeydown);
                        this.editorDiv.removeEventListener("focus", this.#boundEditorDivFocus);
                        this.editorDiv.removeEventListener("blur", this.#boundEditorDivBlur);
                        this.editorDiv.removeEventListener("input", this.#boundEditorDivInput);
                        this.div.focus({
                            preventScroll: true
                        });
                        this.isEditing = false;
                        this.parent.div.classList.add("freeTextEditing");
                    }
                    focusin(event11) {
                        if (!this._focusEventsAllowed) return;
                        super.focusin(event11);
                        if (event11.target !== this.editorDiv) this.editorDiv.focus();
                    }
                    onceAdded() {
                        if (this.width) {
                            this.#cheatInitialRect();
                            return;
                        }
                        this.enableEditMode();
                        this.editorDiv.focus();
                        if (this._initialOptions?.isCentered) this.center();
                        this._initialOptions = null;
                    }
                    isEmpty() {
                        return !this.editorDiv || this.editorDiv.innerText.trim() === "";
                    }
                    remove() {
                        this.isEditing = false;
                        if (this.parent) {
                            this.parent.setEditingState(true);
                            this.parent.div.classList.add("freeTextEditing");
                        }
                        super.remove();
                    }
                    #extractText() {
                        const divs11 = this.editorDiv.getElementsByTagName("div");
                        if (divs11.length === 0) return this.editorDiv.innerText;
                        const buffer11 = [];
                        for (const div11 of divs11)buffer11.push(div11.innerText.replace(/\r\n?|\n/, ""));
                        return buffer11.join("\n");
                    }
                    #setEditorDimensions() {
                        const [parentWidth11, parentHeight11] = this.parentDimensions;
                        let rect31;
                        if (this.isAttachedToDOM) rect31 = this.div.getBoundingClientRect();
                        else {
                            const { currentLayer: currentLayer11, div: div11 } = this;
                            const savedDisplay11 = div11.style.display;
                            div11.style.display = "hidden";
                            currentLayer11.div.append(this.div);
                            rect31 = div11.getBoundingClientRect();
                            div11.remove();
                            div11.style.display = savedDisplay11;
                        }
                        if (this.rotation % 180 === this.parentRotation % 180) {
                            this.width = rect31.width / parentWidth11;
                            this.height = rect31.height / parentHeight11;
                        } else {
                            this.width = rect31.height / parentWidth11;
                            this.height = rect31.width / parentHeight11;
                        }
                        this.fixAndSetPosition();
                    }
                    commit() {
                        if (!this.isInEditMode()) return;
                        super.commit();
                        this.disableEditMode();
                        const savedText11 = this.#content;
                        const newText11 = this.#content = this.#extractText().trimEnd();
                        if (savedText11 === newText11) return;
                        const setText11 = (text11)=>{
                            this.#content = text11;
                            if (!text11) {
                                this.remove();
                                return;
                            }
                            this.#setContent();
                            this._uiManager.rebuild(this);
                            this.#setEditorDimensions();
                        };
                        this.addCommands({
                            cmd: ()=>{
                                setText11(newText11);
                            },
                            undo: ()=>{
                                setText11(savedText11);
                            },
                            mustExec: false
                        });
                        this.#setEditorDimensions();
                    }
                    shouldGetKeyboardEvents() {
                        return this.isInEditMode();
                    }
                    enterInEditMode() {
                        this.enableEditMode();
                        this.editorDiv.focus();
                    }
                    dblclick(event11) {
                        this.enterInEditMode();
                    }
                    keydown(event11) {
                        if (event11.target === this.div && event11.key === "Enter") {
                            this.enterInEditMode();
                            event11.preventDefault();
                        }
                    }
                    editorDivKeydown(event11) {
                        FreeTextEditor11._keyboardManager.exec(this, event11);
                    }
                    editorDivFocus(event11) {
                        this.isEditing = true;
                    }
                    editorDivBlur(event11) {
                        this.isEditing = false;
                    }
                    editorDivInput(event11) {
                        this.parent.div.classList.toggle("freeTextEditing", this.isEmpty());
                    }
                    disableEditing() {
                        this.editorDiv.setAttribute("role", "comment");
                        this.editorDiv.removeAttribute("aria-multiline");
                    }
                    enableEditing() {
                        this.editorDiv.setAttribute("role", "textbox");
                        this.editorDiv.setAttribute("aria-multiline", true);
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX11, baseY11;
                        if (this.width) {
                            baseX11 = this.x;
                            baseY11 = this.y;
                        }
                        super.render();
                        this.editorDiv = document.createElement("div");
                        this.editorDiv.className = "internal";
                        this.editorDiv.setAttribute("id", this.#editorDivId);
                        this.enableEditing();
                        _editor11.AnnotationEditor._l10nPromise.get("editor_free_text2_aria_label").then((msg11)=>this.editorDiv?.setAttribute("aria-label", msg11));
                        _editor11.AnnotationEditor._l10nPromise.get("free_text2_default_content").then((msg11)=>this.editorDiv?.setAttribute("default-content", msg11));
                        this.editorDiv.contentEditable = true;
                        const { style: style11 } = this.editorDiv;
                        style11.fontSize = `calc(${this.#fontSize}px * var(--scale-factor))`;
                        style11.color = this.#color;
                        this.div.append(this.editorDiv);
                        this.overlayDiv = document.createElement("div");
                        this.overlayDiv.classList.add("overlay", "enabled");
                        this.div.append(this.overlayDiv);
                        (0, _tools11.bindEvents)(this, this.div, [
                            "dblclick",
                            "keydown"
                        ]);
                        if (this.width) {
                            const [parentWidth11, parentHeight11] = this.parentDimensions;
                            if (this.annotationElementId) {
                                const { position: position11 } = this.#initialData;
                                let [tx21, ty21] = this.getInitialTranslation();
                                [tx21, ty21] = this.pageTranslationToScreen(tx21, ty21);
                                const [pageWidth11, pageHeight11] = this.pageDimensions;
                                const [pageX11, pageY11] = this.pageTranslation;
                                let posX11, posY11;
                                switch(this.rotation){
                                    case 0:
                                        posX11 = baseX11 + (position11[0] - pageX11) / pageWidth11;
                                        posY11 = baseY11 + this.height - (position11[1] - pageY11) / pageHeight11;
                                        break;
                                    case 90:
                                        posX11 = baseX11 + (position11[0] - pageX11) / pageWidth11;
                                        posY11 = baseY11 - (position11[1] - pageY11) / pageHeight11;
                                        [tx21, ty21] = [
                                            ty21,
                                            -tx21
                                        ];
                                        break;
                                    case 180:
                                        posX11 = baseX11 - this.width + (position11[0] - pageX11) / pageWidth11;
                                        posY11 = baseY11 - (position11[1] - pageY11) / pageHeight11;
                                        [tx21, ty21] = [
                                            -tx21,
                                            -ty21
                                        ];
                                        break;
                                    case 270:
                                        posX11 = baseX11 + (position11[0] - pageX11 - this.height * pageHeight11) / pageWidth11;
                                        posY11 = baseY11 + (position11[1] - pageY11 - this.width * pageWidth11) / pageHeight11;
                                        [tx21, ty21] = [
                                            -ty21,
                                            tx21
                                        ];
                                        break;
                                }
                                this.setAt(posX11 * parentWidth11, posY11 * parentHeight11, tx21, ty21);
                            } else this.setAt(baseX11 * parentWidth11, baseY11 * parentHeight11, this.width * parentWidth11, this.height * parentHeight11);
                            this.#setContent();
                            this._isDraggable = true;
                            this.editorDiv.contentEditable = false;
                        } else {
                            this._isDraggable = false;
                            this.editorDiv.contentEditable = true;
                        }
                        return this.div;
                    }
                    #setContent() {
                        this.editorDiv.replaceChildren();
                        if (!this.#content) return;
                        for (const line11 of this.#content.split("\n")){
                            const div11 = document.createElement("div");
                            div11.append(line11 ? document.createTextNode(line11) : document.createElement("br"));
                            this.editorDiv.append(div11);
                        }
                    }
                    get contentDiv() {
                        return this.editorDiv;
                    }
                    static deserialize(data11, parent11, uiManager11) {
                        let initialData11 = null;
                        if (data11 instanceof _annotation_layer11.FreeTextAnnotationElement) {
                            const { data: { defaultAppearanceData: { fontSize: fontSize11, fontColor: fontColor11 }, rect: rect31, rotation: rotation11, id: id11 }, textContent: textContent11, textPosition: textPosition11, parent: { page: { pageNumber: pageNumber11 } } } = data11;
                            if (!textContent11 || textContent11.length === 0) return null;
                            initialData11 = data11 = {
                                annotationType: _util11.AnnotationEditorType.FREETEXT,
                                color: Array.from(fontColor11),
                                fontSize: fontSize11,
                                value: textContent11.join("\n"),
                                position: textPosition11,
                                pageIndex: pageNumber11 - 1,
                                rect: rect31,
                                rotation: rotation11,
                                id: id11,
                                deleted: false
                            };
                        }
                        const editor11 = super.deserialize(data11, parent11, uiManager11);
                        editor11.#fontSize = data11.fontSize;
                        editor11.#color = _util11.Util.makeHexColor(...data11.color);
                        editor11.#content = data11.value;
                        editor11.annotationElementId = data11.id || null;
                        editor11.#initialData = initialData11;
                        return editor11;
                    }
                    serialize(isForCopying11 = false) {
                        if (this.isEmpty()) return null;
                        if (this.deleted) return {
                            pageIndex: this.pageIndex,
                            id: this.annotationElementId,
                            deleted: true
                        };
                        const padding11 = FreeTextEditor11._internalPadding * this.parentScale;
                        const rect31 = this.getRect(padding11, padding11);
                        const color11 = _editor11.AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : this.#color);
                        const serialized11 = {
                            annotationType: _util11.AnnotationEditorType.FREETEXT,
                            color: color11,
                            fontSize: this.#fontSize,
                            value: this.#content,
                            pageIndex: this.pageIndex,
                            rect: rect31,
                            rotation: this.rotation,
                            structTreeParentId: this._structTreeParentId
                        };
                        if (isForCopying11) return serialized11;
                        if (this.annotationElementId && !this.#hasElementChanged(serialized11)) return null;
                        serialized11.id = this.annotationElementId;
                        return serialized11;
                    }
                    #hasElementChanged(serialized11) {
                        const { value: value11, fontSize: fontSize11, color: color11, rect: rect31, pageIndex: pageIndex11 } = this.#initialData;
                        return serialized11.value !== value11 || serialized11.fontSize !== fontSize11 || serialized11.rect.some((x41, i11)=>Math.abs(x41 - rect31[i11]) >= 1) || serialized11.color.some((c41, i11)=>c41 !== color11[i11]) || serialized11.pageIndex !== pageIndex11;
                    }
                    #cheatInitialRect(delayed11 = false) {
                        if (!this.annotationElementId) return;
                        this.#setEditorDimensions();
                        if (!delayed11 && (this.width === 0 || this.height === 0)) {
                            setTimeout(()=>this.#cheatInitialRect(true), 0);
                            return;
                        }
                        const padding11 = FreeTextEditor11._internalPadding * this.parentScale;
                        this.#initialData.rect = this.getRect(padding11, padding11);
                    }
                }
                exports11.FreeTextEditor = FreeTextEditor11;
            /***/ },
            /* 29 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.StampAnnotationElement = exports11.InkAnnotationElement = exports11.FreeTextAnnotationElement = exports11.AnnotationLayer = void 0;
                var _util11 = __w_pdfjs_require__11(1);
                var _display_utils11 = __w_pdfjs_require__11(6);
                var _annotation_storage11 = __w_pdfjs_require__11(3);
                var _scripting_utils11 = __w_pdfjs_require__11(30);
                var _displayL10n_utils11 = __w_pdfjs_require__11(31);
                var _xfa_layer11 = __w_pdfjs_require__11(32);
                const DEFAULT_TAB_INDEX11 = 1000;
                const DEFAULT_FONT_SIZE11 = 9;
                const GetElementsByNameSet11 = new WeakSet();
                function getRectDims11(rect31) {
                    return {
                        width: rect31[2] - rect31[0],
                        height: rect31[3] - rect31[1]
                    };
                }
                class AnnotationElementFactory11 {
                    static create(parameters11) {
                        const subtype11 = parameters11.data.annotationType;
                        switch(subtype11){
                            case _util11.AnnotationType.LINK:
                                return new LinkAnnotationElement11(parameters11);
                            case _util11.AnnotationType.TEXT:
                                return new TextAnnotationElement11(parameters11);
                            case _util11.AnnotationType.WIDGET:
                                const fieldType11 = parameters11.data.fieldType;
                                switch(fieldType11){
                                    case "Tx":
                                        return new TextWidgetAnnotationElement11(parameters11);
                                    case "Btn":
                                        if (parameters11.data.radioButton) return new RadioButtonWidgetAnnotationElement11(parameters11);
                                        else if (parameters11.data.checkBox) return new CheckboxWidgetAnnotationElement11(parameters11);
                                        return new PushButtonWidgetAnnotationElement11(parameters11);
                                    case "Ch":
                                        return new ChoiceWidgetAnnotationElement11(parameters11);
                                    case "Sig":
                                        return new SignatureWidgetAnnotationElement11(parameters11);
                                }
                                return new WidgetAnnotationElement11(parameters11);
                            case _util11.AnnotationType.POPUP:
                                return new PopupAnnotationElement11(parameters11);
                            case _util11.AnnotationType.FREETEXT:
                                return new FreeTextAnnotationElement11(parameters11);
                            case _util11.AnnotationType.LINE:
                                return new LineAnnotationElement11(parameters11);
                            case _util11.AnnotationType.SQUARE:
                                return new SquareAnnotationElement11(parameters11);
                            case _util11.AnnotationType.CIRCLE:
                                return new CircleAnnotationElement11(parameters11);
                            case _util11.AnnotationType.POLYLINE:
                                return new PolylineAnnotationElement11(parameters11);
                            case _util11.AnnotationType.CARET:
                                return new CaretAnnotationElement11(parameters11);
                            case _util11.AnnotationType.INK:
                                return new InkAnnotationElement11(parameters11);
                            case _util11.AnnotationType.POLYGON:
                                return new PolygonAnnotationElement11(parameters11);
                            case _util11.AnnotationType.HIGHLIGHT:
                                return new HighlightAnnotationElement11(parameters11);
                            case _util11.AnnotationType.UNDERLINE:
                                return new UnderlineAnnotationElement11(parameters11);
                            case _util11.AnnotationType.SQUIGGLY:
                                return new SquigglyAnnotationElement11(parameters11);
                            case _util11.AnnotationType.STRIKEOUT:
                                return new StrikeOutAnnotationElement11(parameters11);
                            case _util11.AnnotationType.STAMP:
                                return new StampAnnotationElement11(parameters11);
                            case _util11.AnnotationType.FILEATTACHMENT:
                                return new FileAttachmentAnnotationElement11(parameters11);
                            default:
                                return new AnnotationElement11(parameters11);
                        }
                    }
                }
                class AnnotationElement11 {
                    #hasBorder = false;
                    constructor(parameters11, { isRenderable: isRenderable11 = false, ignoreBorder: ignoreBorder11 = false, createQuadrilaterals: createQuadrilaterals11 = false } = {}){
                        this.isRenderable = isRenderable11;
                        this.data = parameters11.data;
                        this.layer = parameters11.layer;
                        this.linkService = parameters11.linkService;
                        this.downloadManager = parameters11.downloadManager;
                        this.imageResourcesPath = parameters11.imageResourcesPath;
                        this.renderForms = parameters11.renderForms;
                        this.svgFactory = parameters11.svgFactory;
                        this.annotationStorage = parameters11.annotationStorage;
                        this.enableScripting = parameters11.enableScripting;
                        this.hasJSActions = parameters11.hasJSActions;
                        this._fieldObjects = parameters11.fieldObjects;
                        this.parent = parameters11.parent;
                        if (isRenderable11) this.container = this._createContainer(ignoreBorder11);
                        if (createQuadrilaterals11) this._createQuadrilaterals();
                    }
                    static _hasPopupData({ titleObj: titleObj11, contentsObj: contentsObj11, richText: richText11 }) {
                        return !!(titleObj11?.str || contentsObj11?.str || richText11?.str);
                    }
                    get hasPopupData() {
                        return AnnotationElement11._hasPopupData(this.data);
                    }
                    _createContainer(ignoreBorder11) {
                        const { data: data11, parent: { page: page11, viewport: viewport11 } } = this;
                        const container11 = document.createElement("section");
                        container11.setAttribute("data-annotation-id", data11.id);
                        if (!(this instanceof WidgetAnnotationElement11)) container11.tabIndex = DEFAULT_TAB_INDEX11;
                        container11.style.zIndex = this.parent.zIndex++;
                        if (this.data.popupRef) container11.setAttribute("aria-haspopup", "dialog");
                        if (data11.noRotate) container11.classList.add("norotate");
                        const { pageWidth: pageWidth11, pageHeight: pageHeight11, pageX: pageX11, pageY: pageY11 } = viewport11.rawDims;
                        if (!data11.rect || this instanceof PopupAnnotationElement11) {
                            const { rotation: rotation11 } = data11;
                            if (!data11.hasOwnCanvas && rotation11 !== 0) this.setRotation(rotation11, container11);
                            return container11;
                        }
                        const { width: width21, height: height11 } = getRectDims11(data11.rect);
                        const rect31 = _util11.Util.normalizeRect([
                            data11.rect[0],
                            page11.view[3] - data11.rect[1] + page11.view[1],
                            data11.rect[2],
                            page11.view[3] - data11.rect[3] + page11.view[1]
                        ]);
                        if (!ignoreBorder11 && data11.borderStyle.width > 0) {
                            container11.style.borderWidth = `${data11.borderStyle.width}px`;
                            const horizontalRadius11 = data11.borderStyle.horizontalCornerRadius;
                            const verticalRadius11 = data11.borderStyle.verticalCornerRadius;
                            if (horizontalRadius11 > 0 || verticalRadius11 > 0) {
                                const radius11 = `calc(${horizontalRadius11}px * var(--scale-factor)) / calc(${verticalRadius11}px * var(--scale-factor))`;
                                container11.style.borderRadius = radius11;
                            } else if (this instanceof RadioButtonWidgetAnnotationElement11) {
                                const radius11 = `calc(${width21}px * var(--scale-factor)) / calc(${height11}px * var(--scale-factor))`;
                                container11.style.borderRadius = radius11;
                            }
                            switch(data11.borderStyle.style){
                                case _util11.AnnotationBorderStyleType.SOLID:
                                    container11.style.borderStyle = "solid";
                                    break;
                                case _util11.AnnotationBorderStyleType.DASHED:
                                    container11.style.borderStyle = "dashed";
                                    break;
                                case _util11.AnnotationBorderStyleType.BEVELED:
                                    (0, _util11.warn)("Unimplemented border style: beveled");
                                    break;
                                case _util11.AnnotationBorderStyleType.INSET:
                                    (0, _util11.warn)("Unimplemented border style: inset");
                                    break;
                                case _util11.AnnotationBorderStyleType.UNDERLINE:
                                    container11.style.borderBottomStyle = "solid";
                                    break;
                                default:
                                    break;
                            }
                            const borderColor11 = data11.borderColor || null;
                            if (borderColor11) {
                                this.#hasBorder = true;
                                container11.style.borderColor = _util11.Util.makeHexColor(borderColor11[0] | 0, borderColor11[1] | 0, borderColor11[2] | 0);
                            } else container11.style.borderWidth = 0;
                        }
                        container11.style.left = `${100 * (rect31[0] - pageX11) / pageWidth11}%`;
                        container11.style.top = `${100 * (rect31[1] - pageY11) / pageHeight11}%`;
                        const { rotation: rotation11 } = data11;
                        if (data11.hasOwnCanvas || rotation11 === 0) {
                            container11.style.width = `${100 * width21 / pageWidth11}%`;
                            container11.style.height = `${100 * height11 / pageHeight11}%`;
                        } else this.setRotation(rotation11, container11);
                        return container11;
                    }
                    setRotation(angle11, container11 = this.container) {
                        if (!this.data.rect) return;
                        const { pageWidth: pageWidth11, pageHeight: pageHeight11 } = this.parent.viewport.rawDims;
                        const { width: width21, height: height11 } = getRectDims11(this.data.rect);
                        let elementWidth11, elementHeight11;
                        if (angle11 % 180 === 0) {
                            elementWidth11 = 100 * width21 / pageWidth11;
                            elementHeight11 = 100 * height11 / pageHeight11;
                        } else {
                            elementWidth11 = 100 * height11 / pageWidth11;
                            elementHeight11 = 100 * width21 / pageHeight11;
                        }
                        container11.style.width = `${elementWidth11}%`;
                        container11.style.height = `${elementHeight11}%`;
                        container11.setAttribute("data-main-rotation", (360 - angle11) % 360);
                    }
                    get _commonActions() {
                        const setColor11 = (jsName11, styleName11, event11)=>{
                            const color11 = event11.detail[jsName11];
                            const colorType11 = color11[0];
                            const colorArray11 = color11.slice(1);
                            event11.target.style[styleName11] = _scripting_utils11.ColorConverters[`${colorType11}_HTML`](colorArray11);
                            this.annotationStorage.setValue(this.data.id, {
                                [styleName11]: _scripting_utils11.ColorConverters[`${colorType11}_rgb`](colorArray11)
                            });
                        };
                        return (0, _util11.shadow)(this, "_commonActions", {
                            display: (event11)=>{
                                const { display: display11 } = event11.detail;
                                const hidden11 = display11 % 2 === 1;
                                this.container.style.visibility = hidden11 ? "hidden" : "visible";
                                this.annotationStorage.setValue(this.data.id, {
                                    noView: hidden11,
                                    noPrint: display11 === 1 || display11 === 2
                                });
                            },
                            print: (event11)=>{
                                this.annotationStorage.setValue(this.data.id, {
                                    noPrint: !event11.detail.print
                                });
                            },
                            hidden: (event11)=>{
                                const { hidden: hidden11 } = event11.detail;
                                this.container.style.visibility = hidden11 ? "hidden" : "visible";
                                this.annotationStorage.setValue(this.data.id, {
                                    noPrint: hidden11,
                                    noView: hidden11
                                });
                            },
                            focus: (event11)=>{
                                setTimeout(()=>event11.target.focus({
                                        preventScroll: false
                                    }), 0);
                            },
                            userName: (event11)=>{
                                event11.target.title = event11.detail.userName;
                            },
                            readonly: (event11)=>{
                                event11.target.disabled = event11.detail.readonly;
                            },
                            required: (event11)=>{
                                this._setRequired(event11.target, event11.detail.required);
                            },
                            bgColor: (event11)=>{
                                setColor11("bgColor", "backgroundColor", event11);
                            },
                            fillColor: (event11)=>{
                                setColor11("fillColor", "backgroundColor", event11);
                            },
                            fgColor: (event11)=>{
                                setColor11("fgColor", "color", event11);
                            },
                            textColor: (event11)=>{
                                setColor11("textColor", "color", event11);
                            },
                            borderColor: (event11)=>{
                                setColor11("borderColor", "borderColor", event11);
                            },
                            strokeColor: (event11)=>{
                                setColor11("strokeColor", "borderColor", event11);
                            },
                            rotation: (event11)=>{
                                const angle11 = event11.detail.rotation;
                                this.setRotation(angle11);
                                this.annotationStorage.setValue(this.data.id, {
                                    rotation: angle11
                                });
                            }
                        });
                    }
                    _dispatchEventFromSandbox(actions11, jsEvent11) {
                        const commonActions11 = this._commonActions;
                        for (const name11 of Object.keys(jsEvent11.detail)){
                            const action11 = actions11[name11] || commonActions11[name11];
                            action11?.(jsEvent11);
                        }
                    }
                    _setDefaultPropertiesFromJS(element11) {
                        if (!this.enableScripting) return;
                        const storedData11 = this.annotationStorage.getRawValue(this.data.id);
                        if (!storedData11) return;
                        const commonActions11 = this._commonActions;
                        for (const [actionName11, detail11] of Object.entries(storedData11)){
                            const action11 = commonActions11[actionName11];
                            if (action11) {
                                const eventProxy11 = {
                                    detail: {
                                        [actionName11]: detail11
                                    },
                                    target: element11
                                };
                                action11(eventProxy11);
                                delete storedData11[actionName11];
                            }
                        }
                    }
                    _createQuadrilaterals() {
                        if (!this.container) return;
                        const { quadPoints: quadPoints11 } = this.data;
                        if (!quadPoints11) return;
                        const [rectBlX11, rectBlY11, rectTrX11, rectTrY11] = this.data.rect;
                        if (quadPoints11.length === 1) {
                            const [, { x: trX11, y: trY11 }, { x: blX11, y: blY11 }] = quadPoints11[0];
                            if (rectTrX11 === trX11 && rectTrY11 === trY11 && rectBlX11 === blX11 && rectBlY11 === blY11) return;
                        }
                        const { style: style11 } = this.container;
                        let svgBuffer11;
                        if (this.#hasBorder) {
                            const { borderColor: borderColor11, borderWidth: borderWidth11 } = style11;
                            style11.borderWidth = 0;
                            svgBuffer11 = [
                                "url('data:image/svg+xml;utf8,",
                                `<svg xmlns="http://www.w3.org/2000/svg"`,
                                ` preserveAspectRatio="none" viewBox="0 0 1 1">`,
                                `<g fill="transparent" stroke="${borderColor11}" stroke-width="${borderWidth11}">`
                            ];
                            this.container.classList.add("hasBorder");
                        }
                        const width21 = rectTrX11 - rectBlX11;
                        const height11 = rectTrY11 - rectBlY11;
                        const { svgFactory: svgFactory11 } = this;
                        const svg11 = svgFactory11.createElement("svg");
                        svg11.classList.add("quadrilateralsContainer");
                        svg11.setAttribute("width", 0);
                        svg11.setAttribute("height", 0);
                        const defs11 = svgFactory11.createElement("defs");
                        svg11.append(defs11);
                        const clipPath11 = svgFactory11.createElement("clipPath");
                        const id11 = `clippath_${this.data.id}`;
                        clipPath11.setAttribute("id", id11);
                        clipPath11.setAttribute("clipPathUnits", "objectBoundingBox");
                        defs11.append(clipPath11);
                        for (const [, { x: trX11, y: trY11 }, { x: blX11, y: blY11 }] of quadPoints11){
                            const rect31 = svgFactory11.createElement("rect");
                            const x41 = (blX11 - rectBlX11) / width21;
                            const y41 = (rectTrY11 - trY11) / height11;
                            const rectWidth11 = (trX11 - blX11) / width21;
                            const rectHeight11 = (trY11 - blY11) / height11;
                            rect31.setAttribute("x", x41);
                            rect31.setAttribute("y", y41);
                            rect31.setAttribute("width", rectWidth11);
                            rect31.setAttribute("height", rectHeight11);
                            clipPath11.append(rect31);
                            svgBuffer11?.push(`<rect vector-effect="non-scaling-stroke" x="${x41}" y="${y41}" width="${rectWidth11}" height="${rectHeight11}"/>`);
                        }
                        if (this.#hasBorder) {
                            svgBuffer11.push(`</g></svg>')`);
                            style11.backgroundImage = svgBuffer11.join("");
                        }
                        this.container.append(svg11);
                        this.container.style.clipPath = `url(#${id11})`;
                    }
                    _createPopup() {
                        const { container: container11, data: data11 } = this;
                        container11.setAttribute("aria-haspopup", "dialog");
                        const popup11 = new PopupAnnotationElement11({
                            data: {
                                color: data11.color,
                                titleObj: data11.titleObj,
                                modificationDate: data11.modificationDate,
                                contentsObj: data11.contentsObj,
                                richText: data11.richText,
                                parentRect: data11.rect,
                                borderStyle: 0,
                                id: `popup_${data11.id}`,
                                rotation: data11.rotation
                            },
                            parent: this.parent,
                            elements: [
                                this
                            ]
                        });
                        this.parent.div.append(popup11.render());
                    }
                    render() {
                        (0, _util11.unreachable)("Abstract method `AnnotationElement.render` called");
                    }
                    _getElementsByName(name11, skipId11 = null) {
                        const fields11 = [];
                        if (this._fieldObjects) {
                            const fieldObj11 = this._fieldObjects[name11];
                            if (fieldObj11) for (const { page: page11, id: id11, exportValues: exportValues11 } of fieldObj11){
                                if (page11 === -1) continue;
                                if (id11 === skipId11) continue;
                                const exportValue11 = typeof exportValues11 === "string" ? exportValues11 : null;
                                const domElement11 = document.querySelector(`[data-element-id="${id11}"]`);
                                if (domElement11 && !GetElementsByNameSet11.has(domElement11)) {
                                    (0, _util11.warn)(`_getElementsByName - element not allowed: ${id11}`);
                                    continue;
                                }
                                fields11.push({
                                    id: id11,
                                    exportValue: exportValue11,
                                    domElement: domElement11
                                });
                            }
                            return fields11;
                        }
                        for (const domElement11 of document.getElementsByName(name11)){
                            const { exportValue: exportValue11 } = domElement11;
                            const id11 = domElement11.getAttribute("data-element-id");
                            if (id11 === skipId11) continue;
                            if (!GetElementsByNameSet11.has(domElement11)) continue;
                            fields11.push({
                                id: id11,
                                exportValue: exportValue11,
                                domElement: domElement11
                            });
                        }
                        return fields11;
                    }
                    show() {
                        if (this.container) this.container.hidden = false;
                        this.popup?.maybeShow();
                    }
                    hide() {
                        if (this.container) this.container.hidden = true;
                        this.popup?.forceHide();
                    }
                    getElementsToTriggerPopup() {
                        return this.container;
                    }
                    addHighlightArea() {
                        const triggers11 = this.getElementsToTriggerPopup();
                        if (Array.isArray(triggers11)) for (const element11 of triggers11)element11.classList.add("highlightArea");
                        else triggers11.classList.add("highlightArea");
                    }
                    _editOnDoubleClick() {
                        const { annotationEditorType: mode11, data: { id: editId11 } } = this;
                        this.container.addEventListener("dblclick", ()=>{
                            this.linkService.eventBus?.dispatch("switchannotationeditormode", {
                                source: this,
                                mode: mode11,
                                editId: editId11
                            });
                        });
                    }
                }
                class LinkAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11, options11 = null){
                        super(parameters11, {
                            isRenderable: true,
                            ignoreBorder: !!options11?.ignoreBorder,
                            createQuadrilaterals: true
                        });
                        this.isTooltipOnly = parameters11.data.isTooltipOnly;
                    }
                    render() {
                        const { data: data11, linkService: linkService11 } = this;
                        const link11 = document.createElement("a");
                        link11.setAttribute("data-element-id", data11.id);
                        let isBound11 = false;
                        if (data11.url) {
                            linkService11.addLinkAttributes(link11, data11.url, data11.newWindow);
                            isBound11 = true;
                        } else if (data11.action) {
                            this._bindNamedAction(link11, data11.action);
                            isBound11 = true;
                        } else if (data11.attachment) {
                            this._bindAttachment(link11, data11.attachment);
                            isBound11 = true;
                        } else if (data11.setOCGState) {
                            this.#bindSetOCGState(link11, data11.setOCGState);
                            isBound11 = true;
                        } else if (data11.dest) {
                            this._bindLink(link11, data11.dest);
                            isBound11 = true;
                        } else {
                            if (data11.actions && (data11.actions.Action || data11.actions["Mouse Up"] || data11.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                                this._bindJSAction(link11, data11);
                                isBound11 = true;
                            }
                            if (data11.resetForm) {
                                this._bindResetFormAction(link11, data11.resetForm);
                                isBound11 = true;
                            } else if (this.isTooltipOnly && !isBound11) {
                                this._bindLink(link11, "");
                                isBound11 = true;
                            }
                        }
                        this.container.classList.add("linkAnnotation");
                        if (isBound11) this.container.append(link11);
                        return this.container;
                    }
                    #setInternalLink() {
                        this.container.setAttribute("data-internal-link", "");
                    }
                    _bindLink(link11, destination11) {
                        link11.href = this.linkService.getDestinationHash(destination11);
                        link11.onclick = ()=>{
                            if (destination11) this.linkService.goToDestination(destination11);
                            return false;
                        };
                        if (destination11 || destination11 === "") this.#setInternalLink();
                    }
                    _bindNamedAction(link11, action11) {
                        link11.href = this.linkService.getAnchorUrl("");
                        link11.onclick = ()=>{
                            this.linkService.executeNamedAction(action11);
                            return false;
                        };
                        this.#setInternalLink();
                    }
                    _bindAttachment(link11, attachment11) {
                        link11.href = this.linkService.getAnchorUrl("");
                        link11.onclick = ()=>{
                            this.downloadManager?.openOrDownloadData(this.container, attachment11.content, attachment11.filename);
                            return false;
                        };
                        this.#setInternalLink();
                    }
                    #bindSetOCGState(link11, action11) {
                        link11.href = this.linkService.getAnchorUrl("");
                        link11.onclick = ()=>{
                            this.linkService.executeSetOCGState(action11);
                            return false;
                        };
                        this.#setInternalLink();
                    }
                    _bindJSAction(link11, data11) {
                        link11.href = this.linkService.getAnchorUrl("");
                        const map11 = new Map([
                            [
                                "Action",
                                "onclick"
                            ],
                            [
                                "Mouse Up",
                                "onmouseup"
                            ],
                            [
                                "Mouse Down",
                                "onmousedown"
                            ]
                        ]);
                        for (const name11 of Object.keys(data11.actions)){
                            const jsName11 = map11.get(name11);
                            if (!jsName11) continue;
                            link11[jsName11] = ()=>{
                                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                    source: this,
                                    detail: {
                                        id: data11.id,
                                        name: name11
                                    }
                                });
                                return false;
                            };
                        }
                        if (!link11.onclick) link11.onclick = ()=>false;
                        this.#setInternalLink();
                    }
                    _bindResetFormAction(link11, resetForm11) {
                        const otherClickAction11 = link11.onclick;
                        if (!otherClickAction11) link11.href = this.linkService.getAnchorUrl("");
                        this.#setInternalLink();
                        if (!this._fieldObjects) {
                            (0, _util11.warn)(`_bindResetFormAction - "resetForm" action not supported, ` + "ensure that the `fieldObjects` parameter is provided.");
                            if (!otherClickAction11) link11.onclick = ()=>false;
                            return;
                        }
                        link11.onclick = ()=>{
                            otherClickAction11?.();
                            const { fields: resetFormFields11, refs: resetFormRefs11, include: include11 } = resetForm11;
                            const allFields11 = [];
                            if (resetFormFields11.length !== 0 || resetFormRefs11.length !== 0) {
                                const fieldIds11 = new Set(resetFormRefs11);
                                for (const fieldName11 of resetFormFields11){
                                    const fields11 = this._fieldObjects[fieldName11] || [];
                                    for (const { id: id11 } of fields11)fieldIds11.add(id11);
                                }
                                for (const fields11 of Object.values(this._fieldObjects)){
                                    for (const field11 of fields11)if (fieldIds11.has(field11.id) === include11) allFields11.push(field11);
                                }
                            } else for (const fields11 of Object.values(this._fieldObjects))allFields11.push(...fields11);
                            const storage11 = this.annotationStorage;
                            const allIds11 = [];
                            for (const field11 of allFields11){
                                const { id: id11 } = field11;
                                allIds11.push(id11);
                                switch(field11.type){
                                    case "text":
                                        {
                                            const value11 = field11.defaultValue || "";
                                            storage11.setValue(id11, {
                                                value: value11
                                            });
                                            break;
                                        }
                                    case "checkbox":
                                    case "radiobutton":
                                        {
                                            const value11 = field11.defaultValue === field11.exportValues;
                                            storage11.setValue(id11, {
                                                value: value11
                                            });
                                            break;
                                        }
                                    case "combobox":
                                    case "listbox":
                                        {
                                            const value11 = field11.defaultValue || "";
                                            storage11.setValue(id11, {
                                                value: value11
                                            });
                                            break;
                                        }
                                    default:
                                        continue;
                                }
                                const domElement11 = document.querySelector(`[data-element-id="${id11}"]`);
                                if (!domElement11) continue;
                                else if (!GetElementsByNameSet11.has(domElement11)) {
                                    (0, _util11.warn)(`_bindResetFormAction - element not allowed: ${id11}`);
                                    continue;
                                }
                                domElement11.dispatchEvent(new Event("resetform"));
                            }
                            if (this.enableScripting) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: "app",
                                    ids: allIds11,
                                    name: "ResetForm"
                                }
                            });
                            return false;
                        };
                    }
                }
                class TextAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: true
                        });
                    }
                    render() {
                        this.container.classList.add("textAnnotation");
                        const image11 = document.createElement("img");
                        image11.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
                        image11.alt = "[{{type}} Annotation]";
                        image11.dataset.l10nId = "text_annotation_type";
                        image11.dataset.l10nArgs = JSON.stringify({
                            type: this.data.name
                        });
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.append(image11);
                        return this.container;
                    }
                }
                class WidgetAnnotationElement11 extends AnnotationElement11 {
                    render() {
                        if (this.data.alternativeText) this.container.title = this.data.alternativeText;
                        return this.container;
                    }
                    showElementAndHideCanvas(element11) {
                        if (this.data.hasOwnCanvas) {
                            if (element11.previousSibling?.nodeName === "CANVAS") element11.previousSibling.hidden = true;
                            element11.hidden = false;
                        }
                    }
                    _getKeyModifier(event11) {
                        const { isWin: isWin11, isMac: isMac11 } = _util11.FeatureTest.platform;
                        return isWin11 && event11.ctrlKey || isMac11 && event11.metaKey;
                    }
                    _setEventListener(element11, elementData11, baseName11, eventName11, valueGetter11) {
                        if (baseName11.includes("mouse")) element11.addEventListener(baseName11, (event11)=>{
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: this.data.id,
                                    name: eventName11,
                                    value: valueGetter11(event11),
                                    shift: event11.shiftKey,
                                    modifier: this._getKeyModifier(event11)
                                }
                            });
                        });
                        else element11.addEventListener(baseName11, (event11)=>{
                            if (baseName11 === "blur") {
                                if (!elementData11.focused || !event11.relatedTarget) return;
                                elementData11.focused = false;
                            } else if (baseName11 === "focus") {
                                if (elementData11.focused) return;
                                elementData11.focused = true;
                            }
                            if (!valueGetter11) return;
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: this.data.id,
                                    name: eventName11,
                                    value: valueGetter11(event11)
                                }
                            });
                        });
                    }
                    _setEventListeners(element11, elementData11, names11, getter11) {
                        for (const [baseName11, eventName11] of names11)if (eventName11 === "Action" || this.data.actions?.[eventName11]) {
                            if (eventName11 === "Focus" || eventName11 === "Blur") elementData11 ||= {
                                focused: false
                            };
                            this._setEventListener(element11, elementData11, baseName11, eventName11, getter11);
                            if (eventName11 === "Focus" && !this.data.actions?.Blur) this._setEventListener(element11, elementData11, "blur", "Blur", null);
                            else if (eventName11 === "Blur" && !this.data.actions?.Focus) this._setEventListener(element11, elementData11, "focus", "Focus", null);
                        }
                    }
                    _setBackgroundColor(element11) {
                        const color11 = this.data.backgroundColor || null;
                        element11.style.backgroundColor = color11 === null ? "transparent" : _util11.Util.makeHexColor(color11[0], color11[1], color11[2]);
                    }
                    _setTextStyle(element11) {
                        const TEXT_ALIGNMENT11 = [
                            "left",
                            "center",
                            "right"
                        ];
                        const { fontColor: fontColor11 } = this.data.defaultAppearanceData;
                        const fontSize11 = this.data.defaultAppearanceData.fontSize || DEFAULT_FONT_SIZE11;
                        const style11 = element11.style;
                        let computedFontSize11;
                        const BORDER_SIZE11 = 2;
                        const roundToOneDecimal11 = (x41)=>Math.round(10 * x41) / 10;
                        if (this.data.multiLine) {
                            const height11 = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE11);
                            const numberOfLines11 = Math.round(height11 / (_util11.LINE_FACTOR * fontSize11)) || 1;
                            const lineHeight11 = height11 / numberOfLines11;
                            computedFontSize11 = Math.min(fontSize11, roundToOneDecimal11(lineHeight11 / _util11.LINE_FACTOR));
                        } else {
                            const height11 = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE11);
                            computedFontSize11 = Math.min(fontSize11, roundToOneDecimal11(height11 / _util11.LINE_FACTOR));
                        }
                        style11.fontSize = `calc(${computedFontSize11}px * var(--scale-factor))`;
                        style11.color = _util11.Util.makeHexColor(fontColor11[0], fontColor11[1], fontColor11[2]);
                        if (this.data.textAlignment !== null) style11.textAlign = TEXT_ALIGNMENT11[this.data.textAlignment];
                    }
                    _setRequired(element11, isRequired11) {
                        if (isRequired11) element11.setAttribute("required", true);
                        else element11.removeAttribute("required");
                        element11.setAttribute("aria-required", isRequired11);
                    }
                }
                class TextWidgetAnnotationElement11 extends WidgetAnnotationElement11 {
                    constructor(parameters11){
                        const isRenderable11 = parameters11.renderForms || !parameters11.data.hasAppearance && !!parameters11.data.fieldValue;
                        super(parameters11, {
                            isRenderable: isRenderable11
                        });
                    }
                    setPropertyOnSiblings(base11, key11, value11, keyInStorage11) {
                        const storage11 = this.annotationStorage;
                        for (const element11 of this._getElementsByName(base11.name, base11.id)){
                            if (element11.domElement) element11.domElement[key11] = value11;
                            storage11.setValue(element11.id, {
                                [keyInStorage11]: value11
                            });
                        }
                    }
                    render() {
                        const storage11 = this.annotationStorage;
                        const id11 = this.data.id;
                        this.container.classList.add("textWidgetAnnotation");
                        let element11 = null;
                        if (this.renderForms) {
                            const storedData11 = storage11.getValue(id11, {
                                value: this.data.fieldValue
                            });
                            let textContent11 = storedData11.value || "";
                            const maxLen11 = storage11.getValue(id11, {
                                charLimit: this.data.maxLen
                            }).charLimit;
                            if (maxLen11 && textContent11.length > maxLen11) textContent11 = textContent11.slice(0, maxLen11);
                            let fieldFormattedValues11 = storedData11.formattedValue || this.data.textContent?.join("\n") || null;
                            if (fieldFormattedValues11 && this.data.comb) fieldFormattedValues11 = fieldFormattedValues11.replaceAll(/\s+/g, "");
                            const elementData11 = {
                                userValue: textContent11,
                                formattedValue: fieldFormattedValues11,
                                lastCommittedValue: null,
                                commitKey: 1,
                                focused: false
                            };
                            if (this.data.multiLine) {
                                element11 = document.createElement("textarea");
                                element11.textContent = fieldFormattedValues11 ?? textContent11;
                                if (this.data.doNotScroll) element11.style.overflowY = "hidden";
                            } else {
                                element11 = document.createElement("input");
                                element11.type = "text";
                                element11.setAttribute("value", fieldFormattedValues11 ?? textContent11);
                                if (this.data.doNotScroll) element11.style.overflowX = "hidden";
                            }
                            if (this.data.hasOwnCanvas) element11.hidden = true;
                            GetElementsByNameSet11.add(element11);
                            element11.setAttribute("data-element-id", id11);
                            element11.disabled = this.data.readOnly;
                            element11.name = this.data.fieldName;
                            element11.tabIndex = DEFAULT_TAB_INDEX11;
                            this._setRequired(element11, this.data.required);
                            if (maxLen11) element11.maxLength = maxLen11;
                            element11.addEventListener("input", (event11)=>{
                                storage11.setValue(id11, {
                                    value: event11.target.value
                                });
                                this.setPropertyOnSiblings(element11, "value", event11.target.value, "value");
                                elementData11.formattedValue = null;
                            });
                            element11.addEventListener("resetform", (event11)=>{
                                const defaultValue11 = this.data.defaultFieldValue ?? "";
                                element11.value = elementData11.userValue = defaultValue11;
                                elementData11.formattedValue = null;
                            });
                            let blurListener11 = (event11)=>{
                                const { formattedValue: formattedValue11 } = elementData11;
                                if (formattedValue11 !== null && formattedValue11 !== undefined) event11.target.value = formattedValue11;
                                event11.target.scrollLeft = 0;
                            };
                            if (this.enableScripting && this.hasJSActions) {
                                element11.addEventListener("focus", (event11)=>{
                                    if (elementData11.focused) return;
                                    const { target: target11 } = event11;
                                    if (elementData11.userValue) target11.value = elementData11.userValue;
                                    elementData11.lastCommittedValue = target11.value;
                                    elementData11.commitKey = 1;
                                    elementData11.focused = true;
                                });
                                element11.addEventListener("updatefromsandbox", (jsEvent11)=>{
                                    this.showElementAndHideCanvas(jsEvent11.target);
                                    const actions11 = {
                                        value (event11) {
                                            elementData11.userValue = event11.detail.value ?? "";
                                            storage11.setValue(id11, {
                                                value: elementData11.userValue.toString()
                                            });
                                            event11.target.value = elementData11.userValue;
                                        },
                                        formattedValue (event11) {
                                            const { formattedValue: formattedValue11 } = event11.detail;
                                            elementData11.formattedValue = formattedValue11;
                                            if (formattedValue11 !== null && formattedValue11 !== undefined && event11.target !== document.activeElement) event11.target.value = formattedValue11;
                                            storage11.setValue(id11, {
                                                formattedValue: formattedValue11
                                            });
                                        },
                                        selRange (event11) {
                                            event11.target.setSelectionRange(...event11.detail.selRange);
                                        },
                                        charLimit: (event11)=>{
                                            const { charLimit: charLimit11 } = event11.detail;
                                            const { target: target11 } = event11;
                                            if (charLimit11 === 0) {
                                                target11.removeAttribute("maxLength");
                                                return;
                                            }
                                            target11.setAttribute("maxLength", charLimit11);
                                            let value11 = elementData11.userValue;
                                            if (!value11 || value11.length <= charLimit11) return;
                                            value11 = value11.slice(0, charLimit11);
                                            target11.value = elementData11.userValue = value11;
                                            storage11.setValue(id11, {
                                                value: value11
                                            });
                                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                                source: this,
                                                detail: {
                                                    id: id11,
                                                    name: "Keystroke",
                                                    value: value11,
                                                    willCommit: true,
                                                    commitKey: 1,
                                                    selStart: target11.selectionStart,
                                                    selEnd: target11.selectionEnd
                                                }
                                            });
                                        }
                                    };
                                    this._dispatchEventFromSandbox(actions11, jsEvent11);
                                });
                                element11.addEventListener("keydown", (event11)=>{
                                    elementData11.commitKey = 1;
                                    let commitKey11 = -1;
                                    if (event11.key === "Escape") commitKey11 = 0;
                                    else if (event11.key === "Enter" && !this.data.multiLine) commitKey11 = 2;
                                    else if (event11.key === "Tab") elementData11.commitKey = 3;
                                    if (commitKey11 === -1) return;
                                    const { value: value11 } = event11.target;
                                    if (elementData11.lastCommittedValue === value11) return;
                                    elementData11.lastCommittedValue = value11;
                                    elementData11.userValue = value11;
                                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id11,
                                            name: "Keystroke",
                                            value: value11,
                                            willCommit: true,
                                            commitKey: commitKey11,
                                            selStart: event11.target.selectionStart,
                                            selEnd: event11.target.selectionEnd
                                        }
                                    });
                                });
                                const _blurListener11 = blurListener11;
                                blurListener11 = null;
                                element11.addEventListener("blur", (event11)=>{
                                    if (!elementData11.focused || !event11.relatedTarget) return;
                                    elementData11.focused = false;
                                    const { value: value11 } = event11.target;
                                    elementData11.userValue = value11;
                                    if (elementData11.lastCommittedValue !== value11) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id11,
                                            name: "Keystroke",
                                            value: value11,
                                            willCommit: true,
                                            commitKey: elementData11.commitKey,
                                            selStart: event11.target.selectionStart,
                                            selEnd: event11.target.selectionEnd
                                        }
                                    });
                                    _blurListener11(event11);
                                });
                                if (this.data.actions?.Keystroke) element11.addEventListener("beforeinput", (event11)=>{
                                    elementData11.lastCommittedValue = null;
                                    const { data: data11, target: target11 } = event11;
                                    const { value: value11, selectionStart: selectionStart11, selectionEnd: selectionEnd11 } = target11;
                                    let selStart11 = selectionStart11, selEnd11 = selectionEnd11;
                                    switch(event11.inputType){
                                        case "deleteWordBackward":
                                            {
                                                const match11 = value11.substring(0, selectionStart11).match(/\w*[^\w]*$/);
                                                if (match11) selStart11 -= match11[0].length;
                                                break;
                                            }
                                        case "deleteWordForward":
                                            {
                                                const match11 = value11.substring(selectionStart11).match(/^[^\w]*\w*/);
                                                if (match11) selEnd11 += match11[0].length;
                                                break;
                                            }
                                        case "deleteContentBackward":
                                            if (selectionStart11 === selectionEnd11) selStart11 -= 1;
                                            break;
                                        case "deleteContentForward":
                                            if (selectionStart11 === selectionEnd11) selEnd11 += 1;
                                            break;
                                    }
                                    event11.preventDefault();
                                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id11,
                                            name: "Keystroke",
                                            value: value11,
                                            change: data11 || "",
                                            willCommit: false,
                                            selStart: selStart11,
                                            selEnd: selEnd11
                                        }
                                    });
                                });
                                this._setEventListeners(element11, elementData11, [
                                    [
                                        "focus",
                                        "Focus"
                                    ],
                                    [
                                        "blur",
                                        "Blur"
                                    ],
                                    [
                                        "mousedown",
                                        "Mouse Down"
                                    ],
                                    [
                                        "mouseenter",
                                        "Mouse Enter"
                                    ],
                                    [
                                        "mouseleave",
                                        "Mouse Exit"
                                    ],
                                    [
                                        "mouseup",
                                        "Mouse Up"
                                    ]
                                ], (event11)=>event11.target.value);
                            }
                            if (blurListener11) element11.addEventListener("blur", blurListener11);
                            if (this.data.comb) {
                                const fieldWidth11 = this.data.rect[2] - this.data.rect[0];
                                const combWidth11 = fieldWidth11 / maxLen11;
                                element11.classList.add("comb");
                                element11.style.letterSpacing = `calc(${combWidth11}px * var(--scale-factor) - 1ch)`;
                            }
                        } else {
                            element11 = document.createElement("div");
                            element11.textContent = this.data.fieldValue;
                            element11.style.verticalAlign = "middle";
                            element11.style.display = "table-cell";
                        }
                        this._setTextStyle(element11);
                        this._setBackgroundColor(element11);
                        this._setDefaultPropertiesFromJS(element11);
                        this.container.append(element11);
                        return this.container;
                    }
                }
                class SignatureWidgetAnnotationElement11 extends WidgetAnnotationElement11 {
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: !!parameters11.data.hasOwnCanvas
                        });
                    }
                }
                class CheckboxWidgetAnnotationElement11 extends WidgetAnnotationElement11 {
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: parameters11.renderForms
                        });
                    }
                    render() {
                        const storage11 = this.annotationStorage;
                        const data11 = this.data;
                        const id11 = data11.id;
                        let value11 = storage11.getValue(id11, {
                            value: data11.exportValue === data11.fieldValue
                        }).value;
                        if (typeof value11 === "string") {
                            value11 = value11 !== "Off";
                            storage11.setValue(id11, {
                                value: value11
                            });
                        }
                        this.container.classList.add("buttonWidgetAnnotation", "checkBox");
                        const element11 = document.createElement("input");
                        GetElementsByNameSet11.add(element11);
                        element11.setAttribute("data-element-id", id11);
                        element11.disabled = data11.readOnly;
                        this._setRequired(element11, this.data.required);
                        element11.type = "checkbox";
                        element11.name = data11.fieldName;
                        if (value11) element11.setAttribute("checked", true);
                        element11.setAttribute("exportValue", data11.exportValue);
                        element11.tabIndex = DEFAULT_TAB_INDEX11;
                        element11.addEventListener("change", (event11)=>{
                            const { name: name11, checked: checked11 } = event11.target;
                            for (const checkbox11 of this._getElementsByName(name11, id11)){
                                const curChecked11 = checked11 && checkbox11.exportValue === data11.exportValue;
                                if (checkbox11.domElement) checkbox11.domElement.checked = curChecked11;
                                storage11.setValue(checkbox11.id, {
                                    value: curChecked11
                                });
                            }
                            storage11.setValue(id11, {
                                value: checked11
                            });
                        });
                        element11.addEventListener("resetform", (event11)=>{
                            const defaultValue11 = data11.defaultFieldValue || "Off";
                            event11.target.checked = defaultValue11 === data11.exportValue;
                        });
                        if (this.enableScripting && this.hasJSActions) {
                            element11.addEventListener("updatefromsandbox", (jsEvent11)=>{
                                const actions11 = {
                                    value (event11) {
                                        event11.target.checked = event11.detail.value !== "Off";
                                        storage11.setValue(id11, {
                                            value: event11.target.checked
                                        });
                                    }
                                };
                                this._dispatchEventFromSandbox(actions11, jsEvent11);
                            });
                            this._setEventListeners(element11, null, [
                                [
                                    "change",
                                    "Validate"
                                ],
                                [
                                    "change",
                                    "Action"
                                ],
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ]
                            ], (event11)=>event11.target.checked);
                        }
                        this._setBackgroundColor(element11);
                        this._setDefaultPropertiesFromJS(element11);
                        this.container.append(element11);
                        return this.container;
                    }
                }
                class RadioButtonWidgetAnnotationElement11 extends WidgetAnnotationElement11 {
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: parameters11.renderForms
                        });
                    }
                    render() {
                        this.container.classList.add("buttonWidgetAnnotation", "radioButton");
                        const storage11 = this.annotationStorage;
                        const data11 = this.data;
                        const id11 = data11.id;
                        let value11 = storage11.getValue(id11, {
                            value: data11.fieldValue === data11.buttonValue
                        }).value;
                        if (typeof value11 === "string") {
                            value11 = value11 !== data11.buttonValue;
                            storage11.setValue(id11, {
                                value: value11
                            });
                        }
                        const element11 = document.createElement("input");
                        GetElementsByNameSet11.add(element11);
                        element11.setAttribute("data-element-id", id11);
                        element11.disabled = data11.readOnly;
                        this._setRequired(element11, this.data.required);
                        element11.type = "radio";
                        element11.name = data11.fieldName;
                        if (value11) element11.setAttribute("checked", true);
                        element11.tabIndex = DEFAULT_TAB_INDEX11;
                        element11.addEventListener("change", (event11)=>{
                            const { name: name11, checked: checked11 } = event11.target;
                            for (const radio11 of this._getElementsByName(name11, id11))storage11.setValue(radio11.id, {
                                value: false
                            });
                            storage11.setValue(id11, {
                                value: checked11
                            });
                        });
                        element11.addEventListener("resetform", (event11)=>{
                            const defaultValue11 = data11.defaultFieldValue;
                            event11.target.checked = defaultValue11 !== null && defaultValue11 !== undefined && defaultValue11 === data11.buttonValue;
                        });
                        if (this.enableScripting && this.hasJSActions) {
                            const pdfButtonValue11 = data11.buttonValue;
                            element11.addEventListener("updatefromsandbox", (jsEvent11)=>{
                                const actions11 = {
                                    value: (event11)=>{
                                        const checked11 = pdfButtonValue11 === event11.detail.value;
                                        for (const radio11 of this._getElementsByName(event11.target.name)){
                                            const curChecked11 = checked11 && radio11.id === id11;
                                            if (radio11.domElement) radio11.domElement.checked = curChecked11;
                                            storage11.setValue(radio11.id, {
                                                value: curChecked11
                                            });
                                        }
                                    }
                                };
                                this._dispatchEventFromSandbox(actions11, jsEvent11);
                            });
                            this._setEventListeners(element11, null, [
                                [
                                    "change",
                                    "Validate"
                                ],
                                [
                                    "change",
                                    "Action"
                                ],
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ]
                            ], (event11)=>event11.target.checked);
                        }
                        this._setBackgroundColor(element11);
                        this._setDefaultPropertiesFromJS(element11);
                        this.container.append(element11);
                        return this.container;
                    }
                }
                class PushButtonWidgetAnnotationElement11 extends LinkAnnotationElement11 {
                    constructor(parameters11){
                        super(parameters11, {
                            ignoreBorder: parameters11.data.hasAppearance
                        });
                    }
                    render() {
                        const container11 = super.render();
                        container11.classList.add("buttonWidgetAnnotation", "pushButton");
                        if (this.data.alternativeText) container11.title = this.data.alternativeText;
                        const linkElement11 = container11.lastChild;
                        if (this.enableScripting && this.hasJSActions && linkElement11) {
                            this._setDefaultPropertiesFromJS(linkElement11);
                            linkElement11.addEventListener("updatefromsandbox", (jsEvent11)=>{
                                this._dispatchEventFromSandbox({}, jsEvent11);
                            });
                        }
                        return container11;
                    }
                }
                class ChoiceWidgetAnnotationElement11 extends WidgetAnnotationElement11 {
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: parameters11.renderForms
                        });
                    }
                    render() {
                        this.container.classList.add("choiceWidgetAnnotation");
                        const storage11 = this.annotationStorage;
                        const id11 = this.data.id;
                        const storedData11 = storage11.getValue(id11, {
                            value: this.data.fieldValue
                        });
                        const selectElement11 = document.createElement("select");
                        GetElementsByNameSet11.add(selectElement11);
                        selectElement11.setAttribute("data-element-id", id11);
                        selectElement11.disabled = this.data.readOnly;
                        this._setRequired(selectElement11, this.data.required);
                        selectElement11.name = this.data.fieldName;
                        selectElement11.tabIndex = DEFAULT_TAB_INDEX11;
                        let addAnEmptyEntry11 = this.data.combo && this.data.options.length > 0;
                        if (!this.data.combo) {
                            selectElement11.size = this.data.options.length;
                            if (this.data.multiSelect) selectElement11.multiple = true;
                        }
                        selectElement11.addEventListener("resetform", (event11)=>{
                            const defaultValue11 = this.data.defaultFieldValue;
                            for (const option11 of selectElement11.options)option11.selected = option11.value === defaultValue11;
                        });
                        for (const option11 of this.data.options){
                            const optionElement11 = document.createElement("option");
                            optionElement11.textContent = option11.displayValue;
                            optionElement11.value = option11.exportValue;
                            if (storedData11.value.includes(option11.exportValue)) {
                                optionElement11.setAttribute("selected", true);
                                addAnEmptyEntry11 = false;
                            }
                            selectElement11.append(optionElement11);
                        }
                        let removeEmptyEntry11 = null;
                        if (addAnEmptyEntry11) {
                            const noneOptionElement11 = document.createElement("option");
                            noneOptionElement11.value = " ";
                            noneOptionElement11.setAttribute("hidden", true);
                            noneOptionElement11.setAttribute("selected", true);
                            selectElement11.prepend(noneOptionElement11);
                            removeEmptyEntry11 = ()=>{
                                noneOptionElement11.remove();
                                selectElement11.removeEventListener("input", removeEmptyEntry11);
                                removeEmptyEntry11 = null;
                            };
                            selectElement11.addEventListener("input", removeEmptyEntry11);
                        }
                        const getValue11 = (isExport11)=>{
                            const name11 = isExport11 ? "value" : "textContent";
                            const { options: options11, multiple: multiple11 } = selectElement11;
                            if (!multiple11) return options11.selectedIndex === -1 ? null : options11[options11.selectedIndex][name11];
                            return Array.prototype.filter.call(options11, (option11)=>option11.selected).map((option11)=>option11[name11]);
                        };
                        let selectedValues11 = getValue11(false);
                        const getItems11 = (event11)=>{
                            const options11 = event11.target.options;
                            return Array.prototype.map.call(options11, (option11)=>{
                                return {
                                    displayValue: option11.textContent,
                                    exportValue: option11.value
                                };
                            });
                        };
                        if (this.enableScripting && this.hasJSActions) {
                            selectElement11.addEventListener("updatefromsandbox", (jsEvent11)=>{
                                const actions11 = {
                                    value (event11) {
                                        removeEmptyEntry11?.();
                                        const value11 = event11.detail.value;
                                        const values11 = new Set(Array.isArray(value11) ? value11 : [
                                            value11
                                        ]);
                                        for (const option11 of selectElement11.options)option11.selected = values11.has(option11.value);
                                        storage11.setValue(id11, {
                                            value: getValue11(true)
                                        });
                                        selectedValues11 = getValue11(false);
                                    },
                                    multipleSelection (event11) {
                                        selectElement11.multiple = true;
                                    },
                                    remove (event11) {
                                        const options11 = selectElement11.options;
                                        const index11 = event11.detail.remove;
                                        options11[index11].selected = false;
                                        selectElement11.remove(index11);
                                        if (options11.length > 0) {
                                            const i11 = Array.prototype.findIndex.call(options11, (option11)=>option11.selected);
                                            if (i11 === -1) options11[0].selected = true;
                                        }
                                        storage11.setValue(id11, {
                                            value: getValue11(true),
                                            items: getItems11(event11)
                                        });
                                        selectedValues11 = getValue11(false);
                                    },
                                    clear (event11) {
                                        while(selectElement11.length !== 0)selectElement11.remove(0);
                                        storage11.setValue(id11, {
                                            value: null,
                                            items: []
                                        });
                                        selectedValues11 = getValue11(false);
                                    },
                                    insert (event11) {
                                        const { index: index11, displayValue: displayValue11, exportValue: exportValue11 } = event11.detail.insert;
                                        const selectChild11 = selectElement11.children[index11];
                                        const optionElement11 = document.createElement("option");
                                        optionElement11.textContent = displayValue11;
                                        optionElement11.value = exportValue11;
                                        if (selectChild11) selectChild11.before(optionElement11);
                                        else selectElement11.append(optionElement11);
                                        storage11.setValue(id11, {
                                            value: getValue11(true),
                                            items: getItems11(event11)
                                        });
                                        selectedValues11 = getValue11(false);
                                    },
                                    items (event11) {
                                        const { items: items11 } = event11.detail;
                                        while(selectElement11.length !== 0)selectElement11.remove(0);
                                        for (const item11 of items11){
                                            const { displayValue: displayValue11, exportValue: exportValue11 } = item11;
                                            const optionElement11 = document.createElement("option");
                                            optionElement11.textContent = displayValue11;
                                            optionElement11.value = exportValue11;
                                            selectElement11.append(optionElement11);
                                        }
                                        if (selectElement11.options.length > 0) selectElement11.options[0].selected = true;
                                        storage11.setValue(id11, {
                                            value: getValue11(true),
                                            items: getItems11(event11)
                                        });
                                        selectedValues11 = getValue11(false);
                                    },
                                    indices (event11) {
                                        const indices11 = new Set(event11.detail.indices);
                                        for (const option11 of event11.target.options)option11.selected = indices11.has(option11.index);
                                        storage11.setValue(id11, {
                                            value: getValue11(true)
                                        });
                                        selectedValues11 = getValue11(false);
                                    },
                                    editable (event11) {
                                        event11.target.disabled = !event11.detail.editable;
                                    }
                                };
                                this._dispatchEventFromSandbox(actions11, jsEvent11);
                            });
                            selectElement11.addEventListener("input", (event11)=>{
                                const exportValue11 = getValue11(true);
                                storage11.setValue(id11, {
                                    value: exportValue11
                                });
                                event11.preventDefault();
                                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                    source: this,
                                    detail: {
                                        id: id11,
                                        name: "Keystroke",
                                        value: selectedValues11,
                                        changeEx: exportValue11,
                                        willCommit: false,
                                        commitKey: 1,
                                        keyDown: false
                                    }
                                });
                            });
                            this._setEventListeners(selectElement11, null, [
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ],
                                [
                                    "input",
                                    "Action"
                                ],
                                [
                                    "input",
                                    "Validate"
                                ]
                            ], (event11)=>event11.target.value);
                        } else selectElement11.addEventListener("input", function(event11) {
                            storage11.setValue(id11, {
                                value: getValue11(true)
                            });
                        });
                        if (this.data.combo) this._setTextStyle(selectElement11);
                        this._setBackgroundColor(selectElement11);
                        this._setDefaultPropertiesFromJS(selectElement11);
                        this.container.append(selectElement11);
                        return this.container;
                    }
                }
                class PopupAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        const { data: data11, elements: elements11 } = parameters11;
                        super(parameters11, {
                            isRenderable: AnnotationElement11._hasPopupData(data11)
                        });
                        this.elements = elements11;
                    }
                    render() {
                        this.container.classList.add("popupAnnotation");
                        const popup11 = new PopupElement11({
                            container: this.container,
                            color: this.data.color,
                            titleObj: this.data.titleObj,
                            modificationDate: this.data.modificationDate,
                            contentsObj: this.data.contentsObj,
                            richText: this.data.richText,
                            rect: this.data.rect,
                            parentRect: this.data.parentRect || null,
                            parent: this.parent,
                            elements: this.elements,
                            open: this.data.open
                        });
                        const elementIds11 = [];
                        for (const element11 of this.elements){
                            element11.popup = popup11;
                            elementIds11.push(element11.data.id);
                            element11.addHighlightArea();
                        }
                        this.container.setAttribute("aria-controls", elementIds11.map((id11)=>`${_util11.AnnotationPrefix}${id11}`).join(","));
                        return this.container;
                    }
                }
                class PopupElement11 {
                    #dateTimePromise = null;
                    #boundKeyDown = this.#keyDown.bind(this);
                    #boundHide = this.#hide.bind(this);
                    #boundShow = this.#show.bind(this);
                    #boundToggle = this.#toggle.bind(this);
                    #color = null;
                    #container = null;
                    #contentsObj = null;
                    #elements = null;
                    #parent = null;
                    #parentRect = null;
                    #pinned = false;
                    #popup = null;
                    #rect = null;
                    #richText = null;
                    #titleObj = null;
                    #wasVisible = false;
                    constructor({ container: container11, color: color11, elements: elements11, titleObj: titleObj11, modificationDate: modificationDate11, contentsObj: contentsObj11, richText: richText11, parent: parent11, rect: rect31, parentRect: parentRect11, open: open11 }){
                        this.#container = container11;
                        this.#titleObj = titleObj11;
                        this.#contentsObj = contentsObj11;
                        this.#richText = richText11;
                        this.#parent = parent11;
                        this.#color = color11;
                        this.#rect = rect31;
                        this.#parentRect = parentRect11;
                        this.#elements = elements11;
                        const dateObject11 = _display_utils11.PDFDateString.toDateObject(modificationDate11);
                        if (dateObject11) this.#dateTimePromise = parent11.l10n.get("annotation_date_string", {
                            date: dateObject11.toLocaleDateString(),
                            time: dateObject11.toLocaleTimeString()
                        });
                        this.trigger = elements11.flatMap((e11)=>e11.getElementsToTriggerPopup());
                        for (const element11 of this.trigger){
                            element11.addEventListener("click", this.#boundToggle);
                            element11.addEventListener("mouseenter", this.#boundShow);
                            element11.addEventListener("mouseleave", this.#boundHide);
                            element11.classList.add("popupTriggerArea");
                        }
                        for (const element11 of elements11)element11.container?.addEventListener("keydown", this.#boundKeyDown);
                        this.#container.hidden = true;
                        if (open11) this.#toggle();
                    }
                    render() {
                        if (this.#popup) return;
                        const { page: { view: view11 }, viewport: { rawDims: { pageWidth: pageWidth11, pageHeight: pageHeight11, pageX: pageX11, pageY: pageY11 } } } = this.#parent;
                        const popup11 = this.#popup = document.createElement("div");
                        popup11.className = "popup";
                        if (this.#color) {
                            const baseColor11 = popup11.style.outlineColor = _util11.Util.makeHexColor(...this.#color);
                            if (CSS.supports("background-color", "color-mix(in srgb, red 30%, white)")) popup11.style.backgroundColor = `color-mix(in srgb, ${baseColor11} 30%, white)`;
                            else {
                                const BACKGROUND_ENLIGHT11 = 0.7;
                                popup11.style.backgroundColor = _util11.Util.makeHexColor(...this.#color.map((c41)=>Math.floor(BACKGROUND_ENLIGHT11 * (255 - c41) + c41)));
                            }
                        }
                        const header11 = document.createElement("span");
                        header11.className = "header";
                        const title11 = document.createElement("h1");
                        header11.append(title11);
                        ({ dir: title11.dir, str: title11.textContent } = this.#titleObj);
                        popup11.append(header11);
                        if (this.#dateTimePromise) {
                            const modificationDate11 = document.createElement("span");
                            modificationDate11.classList.add("popupDate");
                            this.#dateTimePromise.then((localized11)=>{
                                modificationDate11.textContent = localized11;
                            });
                            header11.append(modificationDate11);
                        }
                        const contentsObj11 = this.#contentsObj;
                        const richText11 = this.#richText;
                        if (richText11?.str && (!contentsObj11?.str || contentsObj11.str === richText11.str)) {
                            _xfa_layer11.XfaLayer.render({
                                xfaHtml: richText11.html,
                                intent: "richText",
                                div: popup11
                            });
                            popup11.lastChild.classList.add("richText", "popupContent");
                        } else {
                            const contents11 = this._formatContents(contentsObj11);
                            popup11.append(contents11);
                        }
                        let useParentRect11 = !!this.#parentRect;
                        let rect31 = useParentRect11 ? this.#parentRect : this.#rect;
                        for (const element11 of this.#elements)if (!rect31 || _util11.Util.intersect(element11.data.rect, rect31) !== null) {
                            rect31 = element11.data.rect;
                            useParentRect11 = true;
                            break;
                        }
                        const normalizedRect11 = _util11.Util.normalizeRect([
                            rect31[0],
                            view11[3] - rect31[1] + view11[1],
                            rect31[2],
                            view11[3] - rect31[3] + view11[1]
                        ]);
                        const HORIZONTAL_SPACE_AFTER_ANNOTATION11 = 5;
                        const parentWidth11 = useParentRect11 ? rect31[2] - rect31[0] + HORIZONTAL_SPACE_AFTER_ANNOTATION11 : 0;
                        const popupLeft11 = normalizedRect11[0] + parentWidth11;
                        const popupTop11 = normalizedRect11[1];
                        const { style: style11 } = this.#container;
                        style11.left = `${100 * (popupLeft11 - pageX11) / pageWidth11}%`;
                        style11.top = `${100 * (popupTop11 - pageY11) / pageHeight11}%`;
                        this.#container.append(popup11);
                    }
                    _formatContents({ str: str11, dir: dir11 }) {
                        const p51 = document.createElement("p");
                        p51.classList.add("popupContent");
                        p51.dir = dir11;
                        const lines11 = str11.split(/(?:\r\n?|\n)/);
                        for(let i11 = 0, ii11 = lines11.length; i11 < ii11; ++i11){
                            const line11 = lines11[i11];
                            p51.append(document.createTextNode(line11));
                            if (i11 < ii11 - 1) p51.append(document.createElement("br"));
                        }
                        return p51;
                    }
                    #keyDown(event11) {
                        if (event11.altKey || event11.shiftKey || event11.ctrlKey || event11.metaKey) return;
                        if (event11.key === "Enter" || event11.key === "Escape" && this.#pinned) this.#toggle();
                    }
                    #toggle() {
                        this.#pinned = !this.#pinned;
                        if (this.#pinned) {
                            this.#show();
                            this.#container.addEventListener("click", this.#boundToggle);
                            this.#container.addEventListener("keydown", this.#boundKeyDown);
                        } else {
                            this.#hide();
                            this.#container.removeEventListener("click", this.#boundToggle);
                            this.#container.removeEventListener("keydown", this.#boundKeyDown);
                        }
                    }
                    #show() {
                        if (!this.#popup) this.render();
                        if (!this.isVisible) {
                            this.#container.hidden = false;
                            this.#container.style.zIndex = parseInt(this.#container.style.zIndex) + 1000;
                        } else if (this.#pinned) this.#container.classList.add("focused");
                    }
                    #hide() {
                        this.#container.classList.remove("focused");
                        if (this.#pinned || !this.isVisible) return;
                        this.#container.hidden = true;
                        this.#container.style.zIndex = parseInt(this.#container.style.zIndex) - 1000;
                    }
                    forceHide() {
                        this.#wasVisible = this.isVisible;
                        if (!this.#wasVisible) return;
                        this.#container.hidden = true;
                    }
                    maybeShow() {
                        if (!this.#wasVisible) return;
                        this.#wasVisible = false;
                        this.#container.hidden = false;
                    }
                    get isVisible() {
                        return this.#container.hidden === false;
                    }
                }
                class FreeTextAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        this.textContent = parameters11.data.textContent;
                        this.textPosition = parameters11.data.textPosition;
                        this.annotationEditorType = _util11.AnnotationEditorType.FREETEXT;
                    }
                    render() {
                        this.container.classList.add("freeTextAnnotation");
                        if (this.textContent) {
                            const content11 = document.createElement("div");
                            content11.classList.add("annotationTextContent");
                            content11.setAttribute("role", "comment");
                            for (const line11 of this.textContent){
                                const lineSpan11 = document.createElement("span");
                                lineSpan11.textContent = line11;
                                content11.append(lineSpan11);
                            }
                            this.container.append(content11);
                        }
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this._editOnDoubleClick();
                        return this.container;
                    }
                }
                exports11.FreeTextAnnotationElement = FreeTextAnnotationElement11;
                class LineAnnotationElement11 extends AnnotationElement11 {
                    #line = null;
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("lineAnnotation");
                        const data11 = this.data;
                        const { width: width21, height: height11 } = getRectDims11(data11.rect);
                        const svg11 = this.svgFactory.create(width21, height11, true);
                        const line11 = this.#line = this.svgFactory.createElement("svg:line");
                        line11.setAttribute("x1", data11.rect[2] - data11.lineCoordinates[0]);
                        line11.setAttribute("y1", data11.rect[3] - data11.lineCoordinates[1]);
                        line11.setAttribute("x2", data11.rect[2] - data11.lineCoordinates[2]);
                        line11.setAttribute("y2", data11.rect[3] - data11.lineCoordinates[3]);
                        line11.setAttribute("stroke-width", data11.borderStyle.width || 1);
                        line11.setAttribute("stroke", "transparent");
                        line11.setAttribute("fill", "transparent");
                        svg11.append(line11);
                        this.container.append(svg11);
                        if (!data11.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#line;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class SquareAnnotationElement11 extends AnnotationElement11 {
                    #square = null;
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("squareAnnotation");
                        const data11 = this.data;
                        const { width: width21, height: height11 } = getRectDims11(data11.rect);
                        const svg11 = this.svgFactory.create(width21, height11, true);
                        const borderWidth11 = data11.borderStyle.width;
                        const square11 = this.#square = this.svgFactory.createElement("svg:rect");
                        square11.setAttribute("x", borderWidth11 / 2);
                        square11.setAttribute("y", borderWidth11 / 2);
                        square11.setAttribute("width", width21 - borderWidth11);
                        square11.setAttribute("height", height11 - borderWidth11);
                        square11.setAttribute("stroke-width", borderWidth11 || 1);
                        square11.setAttribute("stroke", "transparent");
                        square11.setAttribute("fill", "transparent");
                        svg11.append(square11);
                        this.container.append(svg11);
                        if (!data11.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#square;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class CircleAnnotationElement11 extends AnnotationElement11 {
                    #circle = null;
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("circleAnnotation");
                        const data11 = this.data;
                        const { width: width21, height: height11 } = getRectDims11(data11.rect);
                        const svg11 = this.svgFactory.create(width21, height11, true);
                        const borderWidth11 = data11.borderStyle.width;
                        const circle11 = this.#circle = this.svgFactory.createElement("svg:ellipse");
                        circle11.setAttribute("cx", width21 / 2);
                        circle11.setAttribute("cy", height11 / 2);
                        circle11.setAttribute("rx", width21 / 2 - borderWidth11 / 2);
                        circle11.setAttribute("ry", height11 / 2 - borderWidth11 / 2);
                        circle11.setAttribute("stroke-width", borderWidth11 || 1);
                        circle11.setAttribute("stroke", "transparent");
                        circle11.setAttribute("fill", "transparent");
                        svg11.append(circle11);
                        this.container.append(svg11);
                        if (!data11.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#circle;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class PolylineAnnotationElement11 extends AnnotationElement11 {
                    #polyline = null;
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        this.containerClassName = "polylineAnnotation";
                        this.svgElementName = "svg:polyline";
                    }
                    render() {
                        this.container.classList.add(this.containerClassName);
                        const data11 = this.data;
                        const { width: width21, height: height11 } = getRectDims11(data11.rect);
                        const svg11 = this.svgFactory.create(width21, height11, true);
                        let points11 = [];
                        for (const coordinate11 of data11.vertices){
                            const x41 = coordinate11.x - data11.rect[0];
                            const y41 = data11.rect[3] - coordinate11.y;
                            points11.push(x41 + "," + y41);
                        }
                        points11 = points11.join(" ");
                        const polyline11 = this.#polyline = this.svgFactory.createElement(this.svgElementName);
                        polyline11.setAttribute("points", points11);
                        polyline11.setAttribute("stroke-width", data11.borderStyle.width || 1);
                        polyline11.setAttribute("stroke", "transparent");
                        polyline11.setAttribute("fill", "transparent");
                        svg11.append(polyline11);
                        this.container.append(svg11);
                        if (!data11.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#polyline;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class PolygonAnnotationElement11 extends PolylineAnnotationElement11 {
                    constructor(parameters11){
                        super(parameters11);
                        this.containerClassName = "polygonAnnotation";
                        this.svgElementName = "svg:polygon";
                    }
                }
                class CaretAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("caretAnnotation");
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                }
                class InkAnnotationElement11 extends AnnotationElement11 {
                    #polylines = [];
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        this.containerClassName = "inkAnnotation";
                        this.svgElementName = "svg:polyline";
                        this.annotationEditorType = _util11.AnnotationEditorType.INK;
                    }
                    render() {
                        this.container.classList.add(this.containerClassName);
                        const data11 = this.data;
                        const { width: width21, height: height11 } = getRectDims11(data11.rect);
                        const svg11 = this.svgFactory.create(width21, height11, true);
                        for (const inkList11 of data11.inkLists){
                            let points11 = [];
                            for (const coordinate11 of inkList11){
                                const x41 = coordinate11.x - data11.rect[0];
                                const y41 = data11.rect[3] - coordinate11.y;
                                points11.push(`${x41},${y41}`);
                            }
                            points11 = points11.join(" ");
                            const polyline11 = this.svgFactory.createElement(this.svgElementName);
                            this.#polylines.push(polyline11);
                            polyline11.setAttribute("points", points11);
                            polyline11.setAttribute("stroke-width", data11.borderStyle.width || 1);
                            polyline11.setAttribute("stroke", "transparent");
                            polyline11.setAttribute("fill", "transparent");
                            if (!data11.popupRef && this.hasPopupData) this._createPopup();
                            svg11.append(polyline11);
                        }
                        this.container.append(svg11);
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#polylines;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                exports11.InkAnnotationElement = InkAnnotationElement11;
                class HighlightAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("highlightAnnotation");
                        return this.container;
                    }
                }
                class UnderlineAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("underlineAnnotation");
                        return this.container;
                    }
                }
                class SquigglyAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("squigglyAnnotation");
                        return this.container;
                    }
                }
                class StrikeOutAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("strikeoutAnnotation");
                        return this.container;
                    }
                }
                class StampAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("stampAnnotation");
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                }
                exports11.StampAnnotationElement = StampAnnotationElement11;
                class FileAttachmentAnnotationElement11 extends AnnotationElement11 {
                    #trigger = null;
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: true
                        });
                        const { filename: filename11, content: content11 } = this.data.file;
                        this.filename = (0, _display_utils11.getFilenameFromUrl)(filename11, true);
                        this.content = content11;
                        this.linkService.eventBus?.dispatch("fileattachmentannotation", {
                            source: this,
                            filename: filename11,
                            content: content11
                        });
                    }
                    render() {
                        this.container.classList.add("fileAttachmentAnnotation");
                        const { container: container11, data: data11 } = this;
                        let trigger11;
                        if (data11.hasAppearance || data11.fillAlpha === 0) trigger11 = document.createElement("div");
                        else {
                            trigger11 = document.createElement("img");
                            trigger11.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(data11.name) ? "paperclip" : "pushpin"}.svg`;
                            if (data11.fillAlpha && data11.fillAlpha < 1) trigger11.style = `filter: opacity(${Math.round(data11.fillAlpha * 100)}%);`;
                        }
                        trigger11.addEventListener("dblclick", this.#download.bind(this));
                        this.#trigger = trigger11;
                        const { isMac: isMac11 } = _util11.FeatureTest.platform;
                        container11.addEventListener("keydown", (evt11)=>{
                            if (evt11.key === "Enter" && (isMac11 ? evt11.metaKey : evt11.ctrlKey)) this.#download();
                        });
                        if (!data11.popupRef && this.hasPopupData) this._createPopup();
                        else trigger11.classList.add("popupTriggerArea");
                        container11.append(trigger11);
                        return container11;
                    }
                    getElementsToTriggerPopup() {
                        return this.#trigger;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                    #download() {
                        this.downloadManager?.openOrDownloadData(this.container, this.content, this.filename);
                    }
                }
                class AnnotationLayer11 {
                    #accessibilityManager = null;
                    #annotationCanvasMap = null;
                    #editableAnnotations = new Map();
                    constructor({ div: div11, accessibilityManager: accessibilityManager11, annotationCanvasMap: annotationCanvasMap11, l10n: l10n11, page: page11, viewport: viewport11 }){
                        this.div = div11;
                        this.#accessibilityManager = accessibilityManager11;
                        this.#annotationCanvasMap = annotationCanvasMap11;
                        this.l10n = l10n11;
                        this.page = page11;
                        this.viewport = viewport11;
                        this.zIndex = 0;
                        this.l10n ||= _displayL10n_utils11.NullL10n;
                    }
                    #appendElement(element11, id11) {
                        const contentElement11 = element11.firstChild || element11;
                        contentElement11.id = `${_util11.AnnotationPrefix}${id11}`;
                        this.div.append(element11);
                        this.#accessibilityManager?.moveElementInDOM(this.div, element11, contentElement11, false);
                    }
                    async render(params11) {
                        const { annotations: annotations11 } = params11;
                        const layer11 = this.div;
                        (0, _display_utils11.setLayerDimensions)(layer11, this.viewport);
                        const popupToElements11 = new Map();
                        const elementParams11 = {
                            data: null,
                            layer: layer11,
                            linkService: params11.linkService,
                            downloadManager: params11.downloadManager,
                            imageResourcesPath: params11.imageResourcesPath || "",
                            renderForms: params11.renderForms !== false,
                            svgFactory: new _display_utils11.DOMSVGFactory(),
                            annotationStorage: params11.annotationStorage || new _annotation_storage11.AnnotationStorage(),
                            enableScripting: params11.enableScripting === true,
                            hasJSActions: params11.hasJSActions,
                            fieldObjects: params11.fieldObjects,
                            parent: this,
                            elements: null
                        };
                        for (const data11 of annotations11){
                            if (data11.noHTML) continue;
                            const isPopupAnnotation11 = data11.annotationType === _util11.AnnotationType.POPUP;
                            if (!isPopupAnnotation11) {
                                const { width: width21, height: height11 } = getRectDims11(data11.rect);
                                if (width21 <= 0 || height11 <= 0) continue;
                            } else {
                                const elements11 = popupToElements11.get(data11.id);
                                if (!elements11) continue;
                                elementParams11.elements = elements11;
                            }
                            elementParams11.data = data11;
                            const element11 = AnnotationElementFactory11.create(elementParams11);
                            if (!element11.isRenderable) continue;
                            if (!isPopupAnnotation11 && data11.popupRef) {
                                const elements11 = popupToElements11.get(data11.popupRef);
                                if (!elements11) popupToElements11.set(data11.popupRef, [
                                    element11
                                ]);
                                else elements11.push(element11);
                            }
                            if (element11.annotationEditorType > 0) this.#editableAnnotations.set(element11.data.id, element11);
                            const rendered11 = element11.render();
                            if (data11.hidden) rendered11.style.visibility = "hidden";
                            this.#appendElement(rendered11, data11.id);
                        }
                        this.#setAnnotationCanvasMap();
                        await this.l10n.translate(layer11);
                    }
                    update({ viewport: viewport11 }) {
                        const layer11 = this.div;
                        this.viewport = viewport11;
                        (0, _display_utils11.setLayerDimensions)(layer11, {
                            rotation: viewport11.rotation
                        });
                        this.#setAnnotationCanvasMap();
                        layer11.hidden = false;
                    }
                    #setAnnotationCanvasMap() {
                        if (!this.#annotationCanvasMap) return;
                        const layer11 = this.div;
                        for (const [id11, canvas11] of this.#annotationCanvasMap){
                            const element11 = layer11.querySelector(`[data-annotation-id="${id11}"]`);
                            if (!element11) continue;
                            const { firstChild: firstChild11 } = element11;
                            if (!firstChild11) element11.append(canvas11);
                            else if (firstChild11.nodeName === "CANVAS") firstChild11.replaceWith(canvas11);
                            else firstChild11.before(canvas11);
                        }
                        this.#annotationCanvasMap.clear();
                    }
                    getEditableAnnotations() {
                        return Array.from(this.#editableAnnotations.values());
                    }
                    getEditableAnnotation(id11) {
                        return this.#editableAnnotations.get(id11);
                    }
                }
                exports11.AnnotationLayer = AnnotationLayer11;
            /***/ },
            /* 30 */ /***/ (__unused_webpack_module11, exports11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.ColorConverters = void 0;
                function makeColorComp11(n11) {
                    return Math.floor(Math.max(0, Math.min(1, n11)) * 255).toString(16).padStart(2, "0");
                }
                function scaleAndClamp11(x41) {
                    return Math.max(0, Math.min(255, 255 * x41));
                }
                class ColorConverters11 {
                    static CMYK_G([c41, y41, m31, k31]) {
                        return [
                            "G",
                            1 - Math.min(1, 0.3 * c41 + 0.59 * m31 + 0.11 * y41 + k31)
                        ];
                    }
                    static G_CMYK([g11]) {
                        return [
                            "CMYK",
                            0,
                            0,
                            0,
                            1 - g11
                        ];
                    }
                    static G_RGB([g11]) {
                        return [
                            "RGB",
                            g11,
                            g11,
                            g11
                        ];
                    }
                    static G_rgb([g11]) {
                        g11 = scaleAndClamp11(g11);
                        return [
                            g11,
                            g11,
                            g11
                        ];
                    }
                    static G_HTML([g11]) {
                        const G11 = makeColorComp11(g11);
                        return `#${G11}${G11}${G11}`;
                    }
                    static RGB_G([r11, g11, b41]) {
                        return [
                            "G",
                            0.3 * r11 + 0.59 * g11 + 0.11 * b41
                        ];
                    }
                    static RGB_rgb(color11) {
                        return color11.map(scaleAndClamp11);
                    }
                    static RGB_HTML(color11) {
                        return `#${color11.map(makeColorComp11).join("")}`;
                    }
                    static T_HTML() {
                        return "#00000000";
                    }
                    static T_rgb() {
                        return [
                            null
                        ];
                    }
                    static CMYK_RGB([c41, y41, m31, k31]) {
                        return [
                            "RGB",
                            1 - Math.min(1, c41 + k31),
                            1 - Math.min(1, m31 + k31),
                            1 - Math.min(1, y41 + k31)
                        ];
                    }
                    static CMYK_rgb([c41, y41, m31, k31]) {
                        return [
                            scaleAndClamp11(1 - Math.min(1, c41 + k31)),
                            scaleAndClamp11(1 - Math.min(1, m31 + k31)),
                            scaleAndClamp11(1 - Math.min(1, y41 + k31))
                        ];
                    }
                    static CMYK_HTML(components11) {
                        const rgb11 = this.CMYK_RGB(components11).slice(1);
                        return this.RGB_HTML(rgb11);
                    }
                    static RGB_CMYK([r11, g11, b41]) {
                        const c41 = 1 - r11;
                        const m31 = 1 - g11;
                        const y41 = 1 - b41;
                        const k31 = Math.min(c41, m31, y41);
                        return [
                            "CMYK",
                            c41,
                            m31,
                            y41,
                            k31
                        ];
                    }
                }
                exports11.ColorConverters = ColorConverters11;
            /***/ },
            /* 31 */ /***/ (__unused_webpack_module11, exports11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.NullL10n = void 0;
                exports11.getL10nFallback = getL10nFallback11;
                const DEFAULT_L10N_STRINGS11 = {
                    of_pages: "of {{pagesCount}}",
                    page_of_pages: "({{pageNumber}} of {{pagesCount}})",
                    document_properties_kb: "{{size_kb}} KB ({{size_b}} bytes)",
                    document_properties_mb: "{{size_mb}} MB ({{size_b}} bytes)",
                    document_properties_date_string: "{{date}}, {{time}}",
                    document_properties_page_size_unit_inches: "in",
                    document_properties_page_size_unit_millimeters: "mm",
                    document_properties_page_size_orientation_portrait: "portrait",
                    document_properties_page_size_orientation_landscape: "landscape",
                    document_properties_page_size_name_a3: "A3",
                    document_properties_page_size_name_a4: "A4",
                    document_properties_page_size_name_letter: "Letter",
                    document_properties_page_size_name_legal: "Legal",
                    document_properties_page_size_dimension_string: "{{width}} \xd7 {{height}} {{unit}} ({{orientation}})",
                    document_properties_page_size_dimension_name_string: "{{width}} \xd7 {{height}} {{unit}} ({{name}}, {{orientation}})",
                    document_properties_linearized_yes: "Yes",
                    document_properties_linearized_no: "No",
                    additional_layers: "Additional Layers",
                    page_landmark: "Page {{page}}",
                    thumb_page_title: "Page {{page}}",
                    thumb_page_canvas: "Thumbnail of Page {{page}}",
                    find_reached_top: "Reached top of document, continued from bottom",
                    find_reached_bottom: "Reached end of document, continued from top",
                    "find_match_count[one]": "{{current}} of {{total}} match",
                    "find_match_count[other]": "{{current}} of {{total}} matches",
                    "find_match_count_limit[one]": "More than {{limit}} match",
                    "find_match_count_limit[other]": "More than {{limit}} matches",
                    find_not_found: "Phrase not found",
                    page_scale_width: "Page Width",
                    page_scale_fit: "Page Fit",
                    page_scale_auto: "Automatic Zoom",
                    page_scale_actual: "Actual Size",
                    page_scale_percent: "{{scale}}%",
                    loading_error: "An error occurred while loading the PDF.",
                    invalid_file_error: "Invalid or corrupted PDF file.",
                    missing_file_error: "Missing PDF file.",
                    unexpected_response_error: "Unexpected server response.",
                    rendering_error: "An error occurred while rendering the page.",
                    annotation_date_string: "{{date}}, {{time}}",
                    printing_not_supported: "Warning: Printing is not fully supported by this browser.",
                    printing_not_ready: "Warning: The PDF is not fully loaded for printing.",
                    web_fonts_disabled: "Web fonts are disabled: unable to use embedded PDF fonts.",
                    free_text2_default_content: "Start typing\u2026",
                    editor_free_text2_aria_label: "Text Editor",
                    editor_ink2_aria_label: "Draw Editor",
                    editor_ink_canvas_aria_label: "User-created image",
                    editor_alt_text_button_label: "Alt text",
                    editor_alt_text_edit_button_label: "Edit alt text",
                    editor_alt_text_decorative_tooltip: "Marked as decorative"
                };
                DEFAULT_L10N_STRINGS11.print_progress_percent = "{{progress}}%";
                function getL10nFallback11(key11, args11) {
                    switch(key11){
                        case "find_match_count":
                            key11 = `find_match_count[${args11.total === 1 ? "one" : "other"}]`;
                            break;
                        case "find_match_count_limit":
                            key11 = `find_match_count_limit[${args11.limit === 1 ? "one" : "other"}]`;
                            break;
                    }
                    return DEFAULT_L10N_STRINGS11[key11] || "";
                }
                function formatL10nValue11(text11, args11) {
                    if (!args11) return text11;
                    return text11.replaceAll(/\{\{\s*(\w+)\s*\}\}/g, (all11, name11)=>{
                        return name11 in args11 ? args11[name11] : "{{" + name11 + "}}";
                    });
                }
                const NullL10n11 = {
                    async getLanguage () {
                        return "en-us";
                    },
                    async getDirection () {
                        return "ltr";
                    },
                    async get (key11, args11 = null, fallback11 = getL10nFallback11(key11, args11)) {
                        return formatL10nValue11(fallback11, args11);
                    },
                    async translate (element11) {}
                };
                exports11.NullL10n = NullL10n11;
            /***/ },
            /* 32 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.XfaLayer = void 0;
                var _xfa_text11 = __w_pdfjs_require__11(25);
                class XfaLayer11 {
                    static setupStorage(html11, id11, element11, storage11, intent11) {
                        const storedData11 = storage11.getValue(id11, {
                            value: null
                        });
                        switch(element11.name){
                            case "textarea":
                                if (storedData11.value !== null) html11.textContent = storedData11.value;
                                if (intent11 === "print") break;
                                html11.addEventListener("input", (event11)=>{
                                    storage11.setValue(id11, {
                                        value: event11.target.value
                                    });
                                });
                                break;
                            case "input":
                                if (element11.attributes.type === "radio" || element11.attributes.type === "checkbox") {
                                    if (storedData11.value === element11.attributes.xfaOn) html11.setAttribute("checked", true);
                                    else if (storedData11.value === element11.attributes.xfaOff) html11.removeAttribute("checked");
                                    if (intent11 === "print") break;
                                    html11.addEventListener("change", (event11)=>{
                                        storage11.setValue(id11, {
                                            value: event11.target.checked ? event11.target.getAttribute("xfaOn") : event11.target.getAttribute("xfaOff")
                                        });
                                    });
                                } else {
                                    if (storedData11.value !== null) html11.setAttribute("value", storedData11.value);
                                    if (intent11 === "print") break;
                                    html11.addEventListener("input", (event11)=>{
                                        storage11.setValue(id11, {
                                            value: event11.target.value
                                        });
                                    });
                                }
                                break;
                            case "select":
                                if (storedData11.value !== null) {
                                    html11.setAttribute("value", storedData11.value);
                                    for (const option11 of element11.children){
                                        if (option11.attributes.value === storedData11.value) option11.attributes.selected = true;
                                        else if (option11.attributes.hasOwnProperty("selected")) delete option11.attributes.selected;
                                    }
                                }
                                html11.addEventListener("input", (event11)=>{
                                    const options11 = event11.target.options;
                                    const value11 = options11.selectedIndex === -1 ? "" : options11[options11.selectedIndex].value;
                                    storage11.setValue(id11, {
                                        value: value11
                                    });
                                });
                                break;
                        }
                    }
                    static setAttributes({ html: html11, element: element11, storage: storage11 = null, intent: intent11, linkService: linkService11 }) {
                        const { attributes: attributes11 } = element11;
                        const isHTMLAnchorElement11 = html11 instanceof HTMLAnchorElement;
                        if (attributes11.type === "radio") attributes11.name = `${attributes11.name}-${intent11}`;
                        for (const [key11, value11] of Object.entries(attributes11)){
                            if (value11 === null || value11 === undefined) continue;
                            switch(key11){
                                case "class":
                                    if (value11.length) html11.setAttribute(key11, value11.join(" "));
                                    break;
                                case "dataId":
                                    break;
                                case "id":
                                    html11.setAttribute("data-element-id", value11);
                                    break;
                                case "style":
                                    Object.assign(html11.style, value11);
                                    break;
                                case "textContent":
                                    html11.textContent = value11;
                                    break;
                                default:
                                    if (!isHTMLAnchorElement11 || key11 !== "href" && key11 !== "newWindow") html11.setAttribute(key11, value11);
                            }
                        }
                        if (isHTMLAnchorElement11) linkService11.addLinkAttributes(html11, attributes11.href, attributes11.newWindow);
                        if (storage11 && attributes11.dataId) this.setupStorage(html11, attributes11.dataId, element11, storage11);
                    }
                    static render(parameters11) {
                        const storage11 = parameters11.annotationStorage;
                        const linkService11 = parameters11.linkService;
                        const root11 = parameters11.xfaHtml;
                        const intent11 = parameters11.intent || "display";
                        const rootHtml11 = document.createElement(root11.name);
                        if (root11.attributes) this.setAttributes({
                            html: rootHtml11,
                            element: root11,
                            intent: intent11,
                            linkService: linkService11
                        });
                        const stack11 = [
                            [
                                root11,
                                -1,
                                rootHtml11
                            ]
                        ];
                        const rootDiv11 = parameters11.div;
                        rootDiv11.append(rootHtml11);
                        if (parameters11.viewport) {
                            const transform11 = `matrix(${parameters11.viewport.transform.join(",")})`;
                            rootDiv11.style.transform = transform11;
                        }
                        if (intent11 !== "richText") rootDiv11.setAttribute("class", "xfaLayer xfaFont");
                        const textDivs11 = [];
                        while(stack11.length > 0){
                            const [parent11, i11, html11] = stack11.at(-1);
                            if (i11 + 1 === parent11.children.length) {
                                stack11.pop();
                                continue;
                            }
                            const child11 = parent11.children[++stack11.at(-1)[1]];
                            if (child11 === null) continue;
                            const { name: name11 } = child11;
                            if (name11 === "#text") {
                                const node11 = document.createTextNode(child11.value);
                                textDivs11.push(node11);
                                html11.append(node11);
                                continue;
                            }
                            const childHtml11 = child11?.attributes?.xmlns ? document.createElementNS(child11.attributes.xmlns, name11) : document.createElement(name11);
                            html11.append(childHtml11);
                            if (child11.attributes) this.setAttributes({
                                html: childHtml11,
                                element: child11,
                                storage: storage11,
                                intent: intent11,
                                linkService: linkService11
                            });
                            if (child11.children && child11.children.length > 0) stack11.push([
                                child11,
                                -1,
                                childHtml11
                            ]);
                            else if (child11.value) {
                                const node11 = document.createTextNode(child11.value);
                                if (_xfa_text11.XfaText.shouldBuildText(name11)) textDivs11.push(node11);
                                childHtml11.append(node11);
                            }
                        }
                        for (const el11 of rootDiv11.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))el11.setAttribute("readOnly", true);
                        return {
                            textDivs: textDivs11
                        };
                    }
                    static update(parameters11) {
                        const transform11 = `matrix(${parameters11.viewport.transform.join(",")})`;
                        parameters11.div.style.transform = transform11;
                        parameters11.div.hidden = false;
                    }
                }
                exports11.XfaLayer = XfaLayer11;
            /***/ },
            /* 33 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.InkEditor = void 0;
                var _util11 = __w_pdfjs_require__11(1);
                var _editor11 = __w_pdfjs_require__11(4);
                var _annotation_layer11 = __w_pdfjs_require__11(29);
                var _display_utils11 = __w_pdfjs_require__11(6);
                var _tools11 = __w_pdfjs_require__11(5);
                class InkEditor11 extends _editor11.AnnotationEditor {
                    #baseHeight = 0;
                    #baseWidth = 0;
                    #boundCanvasPointermove = this.canvasPointermove.bind(this);
                    #boundCanvasPointerleave = this.canvasPointerleave.bind(this);
                    #boundCanvasPointerup = this.canvasPointerup.bind(this);
                    #boundCanvasPointerdown = this.canvasPointerdown.bind(this);
                    #currentPath2D = new Path2D();
                    #disableEditing = false;
                    #hasSomethingToDraw = false;
                    #isCanvasInitialized = false;
                    #observer = null;
                    #realWidth = 0;
                    #realHeight = 0;
                    #requestFrameCallback = null;
                    static _defaultColor = null;
                    static _defaultOpacity = 1;
                    static _defaultThickness = 1;
                    static _type = "ink";
                    constructor(params11){
                        super({
                            ...params11,
                            name: "inkEditor"
                        });
                        this.color = params11.color || null;
                        this.thickness = params11.thickness || null;
                        this.opacity = params11.opacity || null;
                        this.paths = [];
                        this.bezierPath2D = [];
                        this.allRawPaths = [];
                        this.currentPath = [];
                        this.scaleFactor = 1;
                        this.translationX = this.translationY = 0;
                        this.x = 0;
                        this.y = 0;
                        this._willKeepAspectRatio = true;
                    }
                    static initialize(l10n11) {
                        _editor11.AnnotationEditor.initialize(l10n11, {
                            strings: [
                                "editor_ink_canvas_aria_label",
                                "editor_ink2_aria_label"
                            ]
                        });
                    }
                    static updateDefaultParams(type11, value11) {
                        switch(type11){
                            case _util11.AnnotationEditorParamsType.INK_THICKNESS:
                                InkEditor11._defaultThickness = value11;
                                break;
                            case _util11.AnnotationEditorParamsType.INK_COLOR:
                                InkEditor11._defaultColor = value11;
                                break;
                            case _util11.AnnotationEditorParamsType.INK_OPACITY:
                                InkEditor11._defaultOpacity = value11 / 100;
                                break;
                        }
                    }
                    updateParams(type11, value11) {
                        switch(type11){
                            case _util11.AnnotationEditorParamsType.INK_THICKNESS:
                                this.#updateThickness(value11);
                                break;
                            case _util11.AnnotationEditorParamsType.INK_COLOR:
                                this.#updateColor(value11);
                                break;
                            case _util11.AnnotationEditorParamsType.INK_OPACITY:
                                this.#updateOpacity(value11);
                                break;
                        }
                    }
                    static get defaultPropertiesToUpdate() {
                        return [
                            [
                                _util11.AnnotationEditorParamsType.INK_THICKNESS,
                                InkEditor11._defaultThickness
                            ],
                            [
                                _util11.AnnotationEditorParamsType.INK_COLOR,
                                InkEditor11._defaultColor || _editor11.AnnotationEditor._defaultLineColor
                            ],
                            [
                                _util11.AnnotationEditorParamsType.INK_OPACITY,
                                Math.round(InkEditor11._defaultOpacity * 100)
                            ]
                        ];
                    }
                    get propertiesToUpdate() {
                        return [
                            [
                                _util11.AnnotationEditorParamsType.INK_THICKNESS,
                                this.thickness || InkEditor11._defaultThickness
                            ],
                            [
                                _util11.AnnotationEditorParamsType.INK_COLOR,
                                this.color || InkEditor11._defaultColor || _editor11.AnnotationEditor._defaultLineColor
                            ],
                            [
                                _util11.AnnotationEditorParamsType.INK_OPACITY,
                                Math.round(100 * (this.opacity ?? InkEditor11._defaultOpacity))
                            ]
                        ];
                    }
                    #updateThickness(thickness11) {
                        const savedThickness11 = this.thickness;
                        this.addCommands({
                            cmd: ()=>{
                                this.thickness = thickness11;
                                this.#fitToContent();
                            },
                            undo: ()=>{
                                this.thickness = savedThickness11;
                                this.#fitToContent();
                            },
                            mustExec: true,
                            type: _util11.AnnotationEditorParamsType.INK_THICKNESS,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    #updateColor(color11) {
                        const savedColor11 = this.color;
                        this.addCommands({
                            cmd: ()=>{
                                this.color = color11;
                                this.#redraw();
                            },
                            undo: ()=>{
                                this.color = savedColor11;
                                this.#redraw();
                            },
                            mustExec: true,
                            type: _util11.AnnotationEditorParamsType.INK_COLOR,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    #updateOpacity(opacity11) {
                        opacity11 /= 100;
                        const savedOpacity11 = this.opacity;
                        this.addCommands({
                            cmd: ()=>{
                                this.opacity = opacity11;
                                this.#redraw();
                            },
                            undo: ()=>{
                                this.opacity = savedOpacity11;
                                this.#redraw();
                            },
                            mustExec: true,
                            type: _util11.AnnotationEditorParamsType.INK_OPACITY,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    rebuild() {
                        if (!this.parent) return;
                        super.rebuild();
                        if (this.div === null) return;
                        if (!this.canvas) {
                            this.#createCanvas();
                            this.#createObserver();
                        }
                        if (!this.isAttachedToDOM) {
                            this.parent.add(this);
                            this.#setCanvasDims();
                        }
                        this.#fitToContent();
                    }
                    remove() {
                        if (this.canvas === null) return;
                        if (!this.isEmpty()) this.commit();
                        this.canvas.width = this.canvas.height = 0;
                        this.canvas.remove();
                        this.canvas = null;
                        this.#observer.disconnect();
                        this.#observer = null;
                        super.remove();
                    }
                    setParent(parent11) {
                        if (!this.parent && parent11) this._uiManager.removeShouldRescale(this);
                        else if (this.parent && parent11 === null) this._uiManager.addShouldRescale(this);
                        super.setParent(parent11);
                    }
                    onScaleChanging() {
                        const [parentWidth11, parentHeight11] = this.parentDimensions;
                        const width21 = this.width * parentWidth11;
                        const height11 = this.height * parentHeight11;
                        this.setDimensions(width21, height11);
                    }
                    enableEditMode() {
                        if (this.#disableEditing || this.canvas === null) return;
                        super.enableEditMode();
                        this._isDraggable = false;
                        this.canvas.addEventListener("pointerdown", this.#boundCanvasPointerdown);
                    }
                    disableEditMode() {
                        if (!this.isInEditMode() || this.canvas === null) return;
                        super.disableEditMode();
                        this._isDraggable = !this.isEmpty();
                        this.div.classList.remove("editing");
                        this.canvas.removeEventListener("pointerdown", this.#boundCanvasPointerdown);
                    }
                    onceAdded() {
                        this._isDraggable = !this.isEmpty();
                    }
                    isEmpty() {
                        return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
                    }
                    #getInitialBBox() {
                        const { parentRotation: parentRotation11, parentDimensions: [width21, height11] } = this;
                        switch(parentRotation11){
                            case 90:
                                return [
                                    0,
                                    height11,
                                    height11,
                                    width21
                                ];
                            case 180:
                                return [
                                    width21,
                                    height11,
                                    width21,
                                    height11
                                ];
                            case 270:
                                return [
                                    width21,
                                    0,
                                    height11,
                                    width21
                                ];
                            default:
                                return [
                                    0,
                                    0,
                                    width21,
                                    height11
                                ];
                        }
                    }
                    #setStroke() {
                        const { ctx: ctx11, color: color11, opacity: opacity11, thickness: thickness11, parentScale: parentScale11, scaleFactor: scaleFactor11 } = this;
                        ctx11.lineWidth = thickness11 * parentScale11 / scaleFactor11;
                        ctx11.lineCap = "round";
                        ctx11.lineJoin = "round";
                        ctx11.miterLimit = 10;
                        ctx11.strokeStyle = `${color11}${(0, _tools11.opacityToHex)(opacity11)}`;
                    }
                    #startDrawing(x41, y41) {
                        this.canvas.addEventListener("contextmenu", _display_utils11.noContextMenu);
                        this.canvas.addEventListener("pointerleave", this.#boundCanvasPointerleave);
                        this.canvas.addEventListener("pointermove", this.#boundCanvasPointermove);
                        this.canvas.addEventListener("pointerup", this.#boundCanvasPointerup);
                        this.canvas.removeEventListener("pointerdown", this.#boundCanvasPointerdown);
                        this.isEditing = true;
                        if (!this.#isCanvasInitialized) {
                            this.#isCanvasInitialized = true;
                            this.#setCanvasDims();
                            this.thickness ||= InkEditor11._defaultThickness;
                            this.color ||= InkEditor11._defaultColor || _editor11.AnnotationEditor._defaultLineColor;
                            this.opacity ??= InkEditor11._defaultOpacity;
                        }
                        this.currentPath.push([
                            x41,
                            y41
                        ]);
                        this.#hasSomethingToDraw = false;
                        this.#setStroke();
                        this.#requestFrameCallback = ()=>{
                            this.#drawPoints();
                            if (this.#requestFrameCallback) window.requestAnimationFrame(this.#requestFrameCallback);
                        };
                        window.requestAnimationFrame(this.#requestFrameCallback);
                    }
                    #draw(x41, y41) {
                        const [lastX11, lastY11] = this.currentPath.at(-1);
                        if (this.currentPath.length > 1 && x41 === lastX11 && y41 === lastY11) return;
                        const currentPath11 = this.currentPath;
                        let path2D11 = this.#currentPath2D;
                        currentPath11.push([
                            x41,
                            y41
                        ]);
                        this.#hasSomethingToDraw = true;
                        if (currentPath11.length <= 2) {
                            path2D11.moveTo(...currentPath11[0]);
                            path2D11.lineTo(x41, y41);
                            return;
                        }
                        if (currentPath11.length === 3) {
                            this.#currentPath2D = path2D11 = new Path2D();
                            path2D11.moveTo(...currentPath11[0]);
                        }
                        this.#makeBezierCurve(path2D11, ...currentPath11.at(-3), ...currentPath11.at(-2), x41, y41);
                    }
                    #endPath() {
                        if (this.currentPath.length === 0) return;
                        const lastPoint11 = this.currentPath.at(-1);
                        this.#currentPath2D.lineTo(...lastPoint11);
                    }
                    #stopDrawing(x41, y41) {
                        this.#requestFrameCallback = null;
                        x41 = Math.min(Math.max(x41, 0), this.canvas.width);
                        y41 = Math.min(Math.max(y41, 0), this.canvas.height);
                        this.#draw(x41, y41);
                        this.#endPath();
                        let bezier11;
                        if (this.currentPath.length !== 1) bezier11 = this.#generateBezierPoints();
                        else {
                            const xy11 = [
                                x41,
                                y41
                            ];
                            bezier11 = [
                                [
                                    xy11,
                                    xy11.slice(),
                                    xy11.slice(),
                                    xy11
                                ]
                            ];
                        }
                        const path2D11 = this.#currentPath2D;
                        const currentPath11 = this.currentPath;
                        this.currentPath = [];
                        this.#currentPath2D = new Path2D();
                        const cmd11 = ()=>{
                            this.allRawPaths.push(currentPath11);
                            this.paths.push(bezier11);
                            this.bezierPath2D.push(path2D11);
                            this.rebuild();
                        };
                        const undo11 = ()=>{
                            this.allRawPaths.pop();
                            this.paths.pop();
                            this.bezierPath2D.pop();
                            if (this.paths.length === 0) this.remove();
                            else {
                                if (!this.canvas) {
                                    this.#createCanvas();
                                    this.#createObserver();
                                }
                                this.#fitToContent();
                            }
                        };
                        this.addCommands({
                            cmd: cmd11,
                            undo: undo11,
                            mustExec: true
                        });
                    }
                    #drawPoints() {
                        if (!this.#hasSomethingToDraw) return;
                        this.#hasSomethingToDraw = false;
                        const thickness11 = Math.ceil(this.thickness * this.parentScale);
                        const lastPoints11 = this.currentPath.slice(-3);
                        const x41 = lastPoints11.map((xy11)=>xy11[0]);
                        const y41 = lastPoints11.map((xy11)=>xy11[1]);
                        const xMin11 = Math.min(...x41) - thickness11;
                        const xMax11 = Math.max(...x41) + thickness11;
                        const yMin11 = Math.min(...y41) - thickness11;
                        const yMax11 = Math.max(...y41) + thickness11;
                        const { ctx: ctx11 } = this;
                        ctx11.save();
                        ctx11.clearRect(0, 0, this.canvas.width, this.canvas.height);
                        for (const path11 of this.bezierPath2D)ctx11.stroke(path11);
                        ctx11.stroke(this.#currentPath2D);
                        ctx11.restore();
                    }
                    #makeBezierCurve(path2D11, x011, y011, x111, y111, x211, y211) {
                        const prevX11 = (x011 + x111) / 2;
                        const prevY11 = (y011 + y111) / 2;
                        const x311 = (x111 + x211) / 2;
                        const y311 = (y111 + y211) / 2;
                        path2D11.bezierCurveTo(prevX11 + 2 * (x111 - prevX11) / 3, prevY11 + 2 * (y111 - prevY11) / 3, x311 + 2 * (x111 - x311) / 3, y311 + 2 * (y111 - y311) / 3, x311, y311);
                    }
                    #generateBezierPoints() {
                        const path11 = this.currentPath;
                        if (path11.length <= 2) return [
                            [
                                path11[0],
                                path11[0],
                                path11.at(-1),
                                path11.at(-1)
                            ]
                        ];
                        const bezierPoints11 = [];
                        let i11;
                        let [x011, y011] = path11[0];
                        for(i11 = 1; i11 < path11.length - 2; i11++){
                            const [x111, y111] = path11[i11];
                            const [x211, y211] = path11[i11 + 1];
                            const x311 = (x111 + x211) / 2;
                            const y311 = (y111 + y211) / 2;
                            const control111 = [
                                x011 + 2 * (x111 - x011) / 3,
                                y011 + 2 * (y111 - y011) / 3
                            ];
                            const control211 = [
                                x311 + 2 * (x111 - x311) / 3,
                                y311 + 2 * (y111 - y311) / 3
                            ];
                            bezierPoints11.push([
                                [
                                    x011,
                                    y011
                                ],
                                control111,
                                control211,
                                [
                                    x311,
                                    y311
                                ]
                            ]);
                            [x011, y011] = [
                                x311,
                                y311
                            ];
                        }
                        const [x111, y111] = path11[i11];
                        const [x211, y211] = path11[i11 + 1];
                        const control111 = [
                            x011 + 2 * (x111 - x011) / 3,
                            y011 + 2 * (y111 - y011) / 3
                        ];
                        const control211 = [
                            x211 + 2 * (x111 - x211) / 3,
                            y211 + 2 * (y111 - y211) / 3
                        ];
                        bezierPoints11.push([
                            [
                                x011,
                                y011
                            ],
                            control111,
                            control211,
                            [
                                x211,
                                y211
                            ]
                        ]);
                        return bezierPoints11;
                    }
                    #redraw() {
                        if (this.isEmpty()) {
                            this.#updateTransform();
                            return;
                        }
                        this.#setStroke();
                        const { canvas: canvas11, ctx: ctx11 } = this;
                        ctx11.setTransform(1, 0, 0, 1, 0, 0);
                        ctx11.clearRect(0, 0, canvas11.width, canvas11.height);
                        this.#updateTransform();
                        for (const path11 of this.bezierPath2D)ctx11.stroke(path11);
                    }
                    commit() {
                        if (this.#disableEditing) return;
                        super.commit();
                        this.isEditing = false;
                        this.disableEditMode();
                        this.setInForeground();
                        this.#disableEditing = true;
                        this.div.classList.add("disabled");
                        this.#fitToContent(true);
                        this.makeResizable();
                        this.parent.addInkEditorIfNeeded(true);
                        this.moveInDOM();
                        this.div.focus({
                            preventScroll: true
                        });
                    }
                    focusin(event11) {
                        if (!this._focusEventsAllowed) return;
                        super.focusin(event11);
                        this.enableEditMode();
                    }
                    canvasPointerdown(event11) {
                        if (event11.button !== 0 || !this.isInEditMode() || this.#disableEditing) return;
                        this.setInForeground();
                        event11.preventDefault();
                        if (event11.type !== "mouse") this.div.focus();
                        this.#startDrawing(event11.offsetX, event11.offsetY);
                    }
                    canvasPointermove(event11) {
                        event11.preventDefault();
                        this.#draw(event11.offsetX, event11.offsetY);
                    }
                    canvasPointerup(event11) {
                        event11.preventDefault();
                        this.#endDrawing(event11);
                    }
                    canvasPointerleave(event11) {
                        this.#endDrawing(event11);
                    }
                    #endDrawing(event11) {
                        this.canvas.removeEventListener("pointerleave", this.#boundCanvasPointerleave);
                        this.canvas.removeEventListener("pointermove", this.#boundCanvasPointermove);
                        this.canvas.removeEventListener("pointerup", this.#boundCanvasPointerup);
                        this.canvas.addEventListener("pointerdown", this.#boundCanvasPointerdown);
                        setTimeout(()=>{
                            this.canvas.removeEventListener("contextmenu", _display_utils11.noContextMenu);
                        }, 10);
                        this.#stopDrawing(event11.offsetX, event11.offsetY);
                        this.addToAnnotationStorage();
                        this.setInBackground();
                    }
                    #createCanvas() {
                        this.canvas = document.createElement("canvas");
                        this.canvas.width = this.canvas.height = 0;
                        this.canvas.className = "inkEditorCanvas";
                        _editor11.AnnotationEditor._l10nPromise.get("editor_ink_canvas_aria_label").then((msg11)=>this.canvas?.setAttribute("aria-label", msg11));
                        this.div.append(this.canvas);
                        this.ctx = this.canvas.getContext("2d");
                    }
                    #createObserver() {
                        this.#observer = new ResizeObserver((entries11)=>{
                            const rect31 = entries11[0].contentRect;
                            if (rect31.width && rect31.height) this.setDimensions(rect31.width, rect31.height);
                        });
                        this.#observer.observe(this.div);
                    }
                    get isResizable() {
                        return !this.isEmpty() && this.#disableEditing;
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX11, baseY11;
                        if (this.width) {
                            baseX11 = this.x;
                            baseY11 = this.y;
                        }
                        super.render();
                        _editor11.AnnotationEditor._l10nPromise.get("editor_ink2_aria_label").then((msg11)=>this.div?.setAttribute("aria-label", msg11));
                        const [x41, y41, w11, h31] = this.#getInitialBBox();
                        this.setAt(x41, y41, 0, 0);
                        this.setDims(w11, h31);
                        this.#createCanvas();
                        if (this.width) {
                            const [parentWidth11, parentHeight11] = this.parentDimensions;
                            this.setAspectRatio(this.width * parentWidth11, this.height * parentHeight11);
                            this.setAt(baseX11 * parentWidth11, baseY11 * parentHeight11, this.width * parentWidth11, this.height * parentHeight11);
                            this.#isCanvasInitialized = true;
                            this.#setCanvasDims();
                            this.setDims(this.width * parentWidth11, this.height * parentHeight11);
                            this.#redraw();
                            this.div.classList.add("disabled");
                        } else {
                            this.div.classList.add("editing");
                            this.enableEditMode();
                        }
                        this.#createObserver();
                        return this.div;
                    }
                    #setCanvasDims() {
                        if (!this.#isCanvasInitialized) return;
                        const [parentWidth11, parentHeight11] = this.parentDimensions;
                        this.canvas.width = Math.ceil(this.width * parentWidth11);
                        this.canvas.height = Math.ceil(this.height * parentHeight11);
                        this.#updateTransform();
                    }
                    setDimensions(width21, height11) {
                        const roundedWidth11 = Math.round(width21);
                        const roundedHeight11 = Math.round(height11);
                        if (this.#realWidth === roundedWidth11 && this.#realHeight === roundedHeight11) return;
                        this.#realWidth = roundedWidth11;
                        this.#realHeight = roundedHeight11;
                        this.canvas.style.visibility = "hidden";
                        const [parentWidth11, parentHeight11] = this.parentDimensions;
                        this.width = width21 / parentWidth11;
                        this.height = height11 / parentHeight11;
                        this.fixAndSetPosition();
                        if (this.#disableEditing) this.#setScaleFactor(width21, height11);
                        this.#setCanvasDims();
                        this.#redraw();
                        this.canvas.style.visibility = "visible";
                        this.fixDims();
                    }
                    #setScaleFactor(width21, height11) {
                        const padding11 = this.#getPadding();
                        const scaleFactorW11 = (width21 - padding11) / this.#baseWidth;
                        const scaleFactorH11 = (height11 - padding11) / this.#baseHeight;
                        this.scaleFactor = Math.min(scaleFactorW11, scaleFactorH11);
                    }
                    #updateTransform() {
                        const padding11 = this.#getPadding() / 2;
                        this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + padding11, this.translationY * this.scaleFactor + padding11);
                    }
                    static #buildPath2D(bezier11) {
                        const path2D11 = new Path2D();
                        for(let i11 = 0, ii11 = bezier11.length; i11 < ii11; i11++){
                            const [first11, control111, control211, second11] = bezier11[i11];
                            if (i11 === 0) path2D11.moveTo(...first11);
                            path2D11.bezierCurveTo(control111[0], control111[1], control211[0], control211[1], second11[0], second11[1]);
                        }
                        return path2D11;
                    }
                    static #toPDFCoordinates(points11, rect31, rotation11) {
                        const [blX11, blY11, trX11, trY11] = rect31;
                        switch(rotation11){
                            case 0:
                                for(let i11 = 0, ii11 = points11.length; i11 < ii11; i11 += 2){
                                    points11[i11] += blX11;
                                    points11[i11 + 1] = trY11 - points11[i11 + 1];
                                }
                                break;
                            case 90:
                                for(let i11 = 0, ii11 = points11.length; i11 < ii11; i11 += 2){
                                    const x41 = points11[i11];
                                    points11[i11] = points11[i11 + 1] + blX11;
                                    points11[i11 + 1] = x41 + blY11;
                                }
                                break;
                            case 180:
                                for(let i11 = 0, ii11 = points11.length; i11 < ii11; i11 += 2){
                                    points11[i11] = trX11 - points11[i11];
                                    points11[i11 + 1] += blY11;
                                }
                                break;
                            case 270:
                                for(let i11 = 0, ii11 = points11.length; i11 < ii11; i11 += 2){
                                    const x41 = points11[i11];
                                    points11[i11] = trX11 - points11[i11 + 1];
                                    points11[i11 + 1] = trY11 - x41;
                                }
                                break;
                            default:
                                throw new Error("Invalid rotation");
                        }
                        return points11;
                    }
                    static #fromPDFCoordinates(points11, rect31, rotation11) {
                        const [blX11, blY11, trX11, trY11] = rect31;
                        switch(rotation11){
                            case 0:
                                for(let i11 = 0, ii11 = points11.length; i11 < ii11; i11 += 2){
                                    points11[i11] -= blX11;
                                    points11[i11 + 1] = trY11 - points11[i11 + 1];
                                }
                                break;
                            case 90:
                                for(let i11 = 0, ii11 = points11.length; i11 < ii11; i11 += 2){
                                    const x41 = points11[i11];
                                    points11[i11] = points11[i11 + 1] - blY11;
                                    points11[i11 + 1] = x41 - blX11;
                                }
                                break;
                            case 180:
                                for(let i11 = 0, ii11 = points11.length; i11 < ii11; i11 += 2){
                                    points11[i11] = trX11 - points11[i11];
                                    points11[i11 + 1] -= blY11;
                                }
                                break;
                            case 270:
                                for(let i11 = 0, ii11 = points11.length; i11 < ii11; i11 += 2){
                                    const x41 = points11[i11];
                                    points11[i11] = trY11 - points11[i11 + 1];
                                    points11[i11 + 1] = trX11 - x41;
                                }
                                break;
                            default:
                                throw new Error("Invalid rotation");
                        }
                        return points11;
                    }
                    #serializePaths(s41, tx21, ty21, rect31) {
                        const paths11 = [];
                        const padding11 = this.thickness / 2;
                        const shiftX11 = s41 * tx21 + padding11;
                        const shiftY11 = s41 * ty21 + padding11;
                        for (const bezier11 of this.paths){
                            const buffer11 = [];
                            const points11 = [];
                            for(let j11 = 0, jj11 = bezier11.length; j11 < jj11; j11++){
                                const [first11, control111, control211, second11] = bezier11[j11];
                                const p1011 = s41 * first11[0] + shiftX11;
                                const p1111 = s41 * first11[1] + shiftY11;
                                const p2011 = s41 * control111[0] + shiftX11;
                                const p2111 = s41 * control111[1] + shiftY11;
                                const p3011 = s41 * control211[0] + shiftX11;
                                const p3111 = s41 * control211[1] + shiftY11;
                                const p4011 = s41 * second11[0] + shiftX11;
                                const p4111 = s41 * second11[1] + shiftY11;
                                if (j11 === 0) {
                                    buffer11.push(p1011, p1111);
                                    points11.push(p1011, p1111);
                                }
                                buffer11.push(p2011, p2111, p3011, p3111, p4011, p4111);
                                points11.push(p2011, p2111);
                                if (j11 === jj11 - 1) points11.push(p4011, p4111);
                            }
                            paths11.push({
                                bezier: InkEditor11.#toPDFCoordinates(buffer11, rect31, this.rotation),
                                points: InkEditor11.#toPDFCoordinates(points11, rect31, this.rotation)
                            });
                        }
                        return paths11;
                    }
                    #getBbox() {
                        let xMin11 = Infinity;
                        let xMax11 = -Infinity;
                        let yMin11 = Infinity;
                        let yMax11 = -Infinity;
                        for (const path11 of this.paths)for (const [first11, control111, control211, second11] of path11){
                            const bbox11 = _util11.Util.bezierBoundingBox(...first11, ...control111, ...control211, ...second11);
                            xMin11 = Math.min(xMin11, bbox11[0]);
                            yMin11 = Math.min(yMin11, bbox11[1]);
                            xMax11 = Math.max(xMax11, bbox11[2]);
                            yMax11 = Math.max(yMax11, bbox11[3]);
                        }
                        return [
                            xMin11,
                            yMin11,
                            xMax11,
                            yMax11
                        ];
                    }
                    #getPadding() {
                        return this.#disableEditing ? Math.ceil(this.thickness * this.parentScale) : 0;
                    }
                    #fitToContent(firstTime11 = false) {
                        if (this.isEmpty()) return;
                        if (!this.#disableEditing) {
                            this.#redraw();
                            return;
                        }
                        const bbox11 = this.#getBbox();
                        const padding11 = this.#getPadding();
                        this.#baseWidth = Math.max(_editor11.AnnotationEditor.MIN_SIZE, bbox11[2] - bbox11[0]);
                        this.#baseHeight = Math.max(_editor11.AnnotationEditor.MIN_SIZE, bbox11[3] - bbox11[1]);
                        const width21 = Math.ceil(padding11 + this.#baseWidth * this.scaleFactor);
                        const height11 = Math.ceil(padding11 + this.#baseHeight * this.scaleFactor);
                        const [parentWidth11, parentHeight11] = this.parentDimensions;
                        this.width = width21 / parentWidth11;
                        this.height = height11 / parentHeight11;
                        this.setAspectRatio(width21, height11);
                        const prevTranslationX11 = this.translationX;
                        const prevTranslationY11 = this.translationY;
                        this.translationX = -bbox11[0];
                        this.translationY = -bbox11[1];
                        this.#setCanvasDims();
                        this.#redraw();
                        this.#realWidth = width21;
                        this.#realHeight = height11;
                        this.setDims(width21, height11);
                        const unscaledPadding11 = firstTime11 ? padding11 / this.scaleFactor / 2 : 0;
                        this.translate(prevTranslationX11 - this.translationX - unscaledPadding11, prevTranslationY11 - this.translationY - unscaledPadding11);
                    }
                    static deserialize(data11, parent11, uiManager11) {
                        if (data11 instanceof _annotation_layer11.InkAnnotationElement) return null;
                        const editor11 = super.deserialize(data11, parent11, uiManager11);
                        editor11.thickness = data11.thickness;
                        editor11.color = _util11.Util.makeHexColor(...data11.color);
                        editor11.opacity = data11.opacity;
                        const [pageWidth11, pageHeight11] = editor11.pageDimensions;
                        const width21 = editor11.width * pageWidth11;
                        const height11 = editor11.height * pageHeight11;
                        const scaleFactor11 = editor11.parentScale;
                        const padding11 = data11.thickness / 2;
                        editor11.#disableEditing = true;
                        editor11.#realWidth = Math.round(width21);
                        editor11.#realHeight = Math.round(height11);
                        const { paths: paths11, rect: rect31, rotation: rotation11 } = data11;
                        for (let { bezier: bezier11 } of paths11){
                            bezier11 = InkEditor11.#fromPDFCoordinates(bezier11, rect31, rotation11);
                            const path11 = [];
                            editor11.paths.push(path11);
                            let p011 = scaleFactor11 * (bezier11[0] - padding11);
                            let p121 = scaleFactor11 * (bezier11[1] - padding11);
                            for(let i11 = 2, ii11 = bezier11.length; i11 < ii11; i11 += 6){
                                const p1011 = scaleFactor11 * (bezier11[i11] - padding11);
                                const p1111 = scaleFactor11 * (bezier11[i11 + 1] - padding11);
                                const p2011 = scaleFactor11 * (bezier11[i11 + 2] - padding11);
                                const p2111 = scaleFactor11 * (bezier11[i11 + 3] - padding11);
                                const p3011 = scaleFactor11 * (bezier11[i11 + 4] - padding11);
                                const p3111 = scaleFactor11 * (bezier11[i11 + 5] - padding11);
                                path11.push([
                                    [
                                        p011,
                                        p121
                                    ],
                                    [
                                        p1011,
                                        p1111
                                    ],
                                    [
                                        p2011,
                                        p2111
                                    ],
                                    [
                                        p3011,
                                        p3111
                                    ]
                                ]);
                                p011 = p3011;
                                p121 = p3111;
                            }
                            const path2D11 = this.#buildPath2D(path11);
                            editor11.bezierPath2D.push(path2D11);
                        }
                        const bbox11 = editor11.#getBbox();
                        editor11.#baseWidth = Math.max(_editor11.AnnotationEditor.MIN_SIZE, bbox11[2] - bbox11[0]);
                        editor11.#baseHeight = Math.max(_editor11.AnnotationEditor.MIN_SIZE, bbox11[3] - bbox11[1]);
                        editor11.#setScaleFactor(width21, height11);
                        return editor11;
                    }
                    serialize() {
                        if (this.isEmpty()) return null;
                        const rect31 = this.getRect(0, 0);
                        const color11 = _editor11.AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
                        return {
                            annotationType: _util11.AnnotationEditorType.INK,
                            color: color11,
                            thickness: this.thickness,
                            opacity: this.opacity,
                            paths: this.#serializePaths(this.scaleFactor / this.parentScale, this.translationX, this.translationY, rect31),
                            pageIndex: this.pageIndex,
                            rect: rect31,
                            rotation: this.rotation,
                            structTreeParentId: this._structTreeParentId
                        };
                    }
                }
                exports11.InkEditor = InkEditor11;
            /***/ },
            /* 34 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.StampEditor = void 0;
                var _util11 = __w_pdfjs_require__11(1);
                var _editor11 = __w_pdfjs_require__11(4);
                var _display_utils11 = __w_pdfjs_require__11(6);
                var _annotation_layer11 = __w_pdfjs_require__11(29);
                class StampEditor11 extends _editor11.AnnotationEditor {
                    #bitmap = null;
                    #bitmapId = null;
                    #bitmapPromise = null;
                    #bitmapUrl = null;
                    #bitmapFile = null;
                    #canvas = null;
                    #observer = null;
                    #resizeTimeoutId = null;
                    #isSvg = false;
                    #hasBeenAddedInUndoStack = false;
                    static _type = "stamp";
                    constructor(params11){
                        super({
                            ...params11,
                            name: "stampEditor"
                        });
                        this.#bitmapUrl = params11.bitmapUrl;
                        this.#bitmapFile = params11.bitmapFile;
                    }
                    static initialize(l10n11) {
                        _editor11.AnnotationEditor.initialize(l10n11);
                    }
                    static get supportedTypes() {
                        const types11 = [
                            "apng",
                            "avif",
                            "bmp",
                            "gif",
                            "jpeg",
                            "png",
                            "svg+xml",
                            "webp",
                            "x-icon"
                        ];
                        return (0, _util11.shadow)(this, "supportedTypes", types11.map((type11)=>`image/${type11}`));
                    }
                    static get supportedTypesStr() {
                        return (0, _util11.shadow)(this, "supportedTypesStr", this.supportedTypes.join(","));
                    }
                    static isHandlingMimeForPasting(mime11) {
                        return this.supportedTypes.includes(mime11);
                    }
                    static paste(item11, parent11) {
                        parent11.pasteEditor(_util11.AnnotationEditorType.STAMP, {
                            bitmapFile: item11.getAsFile()
                        });
                    }
                    #getBitmapFetched(data11, fromId11 = false) {
                        if (!data11) {
                            this.remove();
                            return;
                        }
                        this.#bitmap = data11.bitmap;
                        if (!fromId11) {
                            this.#bitmapId = data11.id;
                            this.#isSvg = data11.isSvg;
                        }
                        this.#createCanvas();
                    }
                    #getBitmapDone() {
                        this.#bitmapPromise = null;
                        this._uiManager.enableWaiting(false);
                        if (this.#canvas) this.div.focus();
                    }
                    #getBitmap() {
                        if (this.#bitmapId) {
                            this._uiManager.enableWaiting(true);
                            this._uiManager.imageManager.getFromId(this.#bitmapId).then((data11)=>this.#getBitmapFetched(data11, true)).finally(()=>this.#getBitmapDone());
                            return;
                        }
                        if (this.#bitmapUrl) {
                            const url11 = this.#bitmapUrl;
                            this.#bitmapUrl = null;
                            this._uiManager.enableWaiting(true);
                            this.#bitmapPromise = this._uiManager.imageManager.getFromUrl(url11).then((data11)=>this.#getBitmapFetched(data11)).finally(()=>this.#getBitmapDone());
                            return;
                        }
                        if (this.#bitmapFile) {
                            const file11 = this.#bitmapFile;
                            this.#bitmapFile = null;
                            this._uiManager.enableWaiting(true);
                            this.#bitmapPromise = this._uiManager.imageManager.getFromFile(file11).then((data11)=>this.#getBitmapFetched(data11)).finally(()=>this.#getBitmapDone());
                            return;
                        }
                        const input11 = document.createElement("input");
                        input11.type = "file";
                        input11.accept = StampEditor11.supportedTypesStr;
                        this.#bitmapPromise = new Promise((resolve11)=>{
                            input11.addEventListener("change", async ()=>{
                                if (!input11.files || input11.files.length === 0) this.remove();
                                else {
                                    this._uiManager.enableWaiting(true);
                                    const data11 = await this._uiManager.imageManager.getFromFile(input11.files[0]);
                                    this.#getBitmapFetched(data11);
                                }
                                resolve11();
                            });
                            input11.addEventListener("cancel", ()=>{
                                this.remove();
                                resolve11();
                            });
                        }).finally(()=>this.#getBitmapDone());
                        input11.click();
                    }
                    remove() {
                        if (this.#bitmapId) {
                            this.#bitmap = null;
                            this._uiManager.imageManager.deleteId(this.#bitmapId);
                            this.#canvas?.remove();
                            this.#canvas = null;
                            this.#observer?.disconnect();
                            this.#observer = null;
                        }
                        super.remove();
                    }
                    rebuild() {
                        if (!this.parent) {
                            if (this.#bitmapId) this.#getBitmap();
                            return;
                        }
                        super.rebuild();
                        if (this.div === null) return;
                        if (this.#bitmapId) this.#getBitmap();
                        if (!this.isAttachedToDOM) this.parent.add(this);
                    }
                    onceAdded() {
                        this._isDraggable = true;
                        this.div.focus();
                    }
                    isEmpty() {
                        return !(this.#bitmapPromise || this.#bitmap || this.#bitmapUrl || this.#bitmapFile);
                    }
                    get isResizable() {
                        return true;
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX11, baseY11;
                        if (this.width) {
                            baseX11 = this.x;
                            baseY11 = this.y;
                        }
                        super.render();
                        this.div.hidden = true;
                        if (this.#bitmap) this.#createCanvas();
                        else this.#getBitmap();
                        if (this.width) {
                            const [parentWidth11, parentHeight11] = this.parentDimensions;
                            this.setAt(baseX11 * parentWidth11, baseY11 * parentHeight11, this.width * parentWidth11, this.height * parentHeight11);
                        }
                        return this.div;
                    }
                    #createCanvas() {
                        const { div: div11 } = this;
                        let { width: width21, height: height11 } = this.#bitmap;
                        const [pageWidth11, pageHeight11] = this.pageDimensions;
                        const MAX_RATIO11 = 0.75;
                        if (this.width) {
                            width21 = this.width * pageWidth11;
                            height11 = this.height * pageHeight11;
                        } else if (width21 > MAX_RATIO11 * pageWidth11 || height11 > MAX_RATIO11 * pageHeight11) {
                            const factor11 = Math.min(MAX_RATIO11 * pageWidth11 / width21, MAX_RATIO11 * pageHeight11 / height11);
                            width21 *= factor11;
                            height11 *= factor11;
                        }
                        const [parentWidth11, parentHeight11] = this.parentDimensions;
                        this.setDims(width21 * parentWidth11 / pageWidth11, height11 * parentHeight11 / pageHeight11);
                        this._uiManager.enableWaiting(false);
                        const canvas11 = this.#canvas = document.createElement("canvas");
                        div11.append(canvas11);
                        div11.hidden = false;
                        this.#drawBitmap(width21, height11);
                        this.#createObserver();
                        if (!this.#hasBeenAddedInUndoStack) {
                            this.parent.addUndoableEditor(this);
                            this.#hasBeenAddedInUndoStack = true;
                        }
                        this._uiManager._eventBus.dispatch("reporttelemetry", {
                            source: this,
                            details: {
                                type: "editing",
                                subtype: this.editorType,
                                data: {
                                    action: "inserted_image"
                                }
                            }
                        });
                        this.addAltTextButton();
                    }
                    #setDimensions(width21, height11) {
                        const [parentWidth11, parentHeight11] = this.parentDimensions;
                        this.width = width21 / parentWidth11;
                        this.height = height11 / parentHeight11;
                        this.setDims(width21, height11);
                        if (this._initialOptions?.isCentered) this.center();
                        else this.fixAndSetPosition();
                        this._initialOptions = null;
                        if (this.#resizeTimeoutId !== null) clearTimeout(this.#resizeTimeoutId);
                        const TIME_TO_WAIT11 = 200;
                        this.#resizeTimeoutId = setTimeout(()=>{
                            this.#resizeTimeoutId = null;
                            this.#drawBitmap(width21, height11);
                        }, TIME_TO_WAIT11);
                    }
                    #scaleBitmap(width21, height11) {
                        const { width: bitmapWidth11, height: bitmapHeight11 } = this.#bitmap;
                        let newWidth11 = bitmapWidth11;
                        let newHeight11 = bitmapHeight11;
                        let bitmap11 = this.#bitmap;
                        while(newWidth11 > 2 * width21 || newHeight11 > 2 * height11){
                            const prevWidth11 = newWidth11;
                            const prevHeight11 = newHeight11;
                            if (newWidth11 > 2 * width21) newWidth11 = newWidth11 >= 16384 ? Math.floor(newWidth11 / 2) - 1 : Math.ceil(newWidth11 / 2);
                            if (newHeight11 > 2 * height11) newHeight11 = newHeight11 >= 16384 ? Math.floor(newHeight11 / 2) - 1 : Math.ceil(newHeight11 / 2);
                            const offscreen11 = new OffscreenCanvas(newWidth11, newHeight11);
                            const ctx11 = offscreen11.getContext("2d");
                            ctx11.drawImage(bitmap11, 0, 0, prevWidth11, prevHeight11, 0, 0, newWidth11, newHeight11);
                            bitmap11 = offscreen11.transferToImageBitmap();
                        }
                        return bitmap11;
                    }
                    #drawBitmap(width21, height11) {
                        width21 = Math.ceil(width21);
                        height11 = Math.ceil(height11);
                        const canvas11 = this.#canvas;
                        if (!canvas11 || canvas11.width === width21 && canvas11.height === height11) return;
                        canvas11.width = width21;
                        canvas11.height = height11;
                        const bitmap11 = this.#isSvg ? this.#bitmap : this.#scaleBitmap(width21, height11);
                        const ctx11 = canvas11.getContext("2d");
                        ctx11.filter = this._uiManager.hcmFilter;
                        ctx11.drawImage(bitmap11, 0, 0, bitmap11.width, bitmap11.height, 0, 0, width21, height11);
                    }
                    #serializeBitmap(toUrl11) {
                        if (toUrl11) {
                            if (this.#isSvg) {
                                const url11 = this._uiManager.imageManager.getSvgUrl(this.#bitmapId);
                                if (url11) return url11;
                            }
                            const canvas11 = document.createElement("canvas");
                            ({ width: canvas11.width, height: canvas11.height } = this.#bitmap);
                            const ctx11 = canvas11.getContext("2d");
                            ctx11.drawImage(this.#bitmap, 0, 0);
                            return canvas11.toDataURL();
                        }
                        if (this.#isSvg) {
                            const [pageWidth11, pageHeight11] = this.pageDimensions;
                            const width21 = Math.round(this.width * pageWidth11 * _display_utils11.PixelsPerInch.PDF_TO_CSS_UNITS);
                            const height11 = Math.round(this.height * pageHeight11 * _display_utils11.PixelsPerInch.PDF_TO_CSS_UNITS);
                            const offscreen11 = new OffscreenCanvas(width21, height11);
                            const ctx11 = offscreen11.getContext("2d");
                            ctx11.drawImage(this.#bitmap, 0, 0, this.#bitmap.width, this.#bitmap.height, 0, 0, width21, height11);
                            return offscreen11.transferToImageBitmap();
                        }
                        return structuredClone(this.#bitmap);
                    }
                    #createObserver() {
                        this.#observer = new ResizeObserver((entries11)=>{
                            const rect31 = entries11[0].contentRect;
                            if (rect31.width && rect31.height) this.#setDimensions(rect31.width, rect31.height);
                        });
                        this.#observer.observe(this.div);
                    }
                    static deserialize(data11, parent11, uiManager11) {
                        if (data11 instanceof _annotation_layer11.StampAnnotationElement) return null;
                        const editor11 = super.deserialize(data11, parent11, uiManager11);
                        const { rect: rect31, bitmapUrl: bitmapUrl11, bitmapId: bitmapId11, isSvg: isSvg11, accessibilityData: accessibilityData11 } = data11;
                        if (bitmapId11 && uiManager11.imageManager.isValidId(bitmapId11)) editor11.#bitmapId = bitmapId11;
                        else editor11.#bitmapUrl = bitmapUrl11;
                        editor11.#isSvg = isSvg11;
                        const [parentWidth11, parentHeight11] = editor11.pageDimensions;
                        editor11.width = (rect31[2] - rect31[0]) / parentWidth11;
                        editor11.height = (rect31[3] - rect31[1]) / parentHeight11;
                        if (accessibilityData11) editor11.altTextData = accessibilityData11;
                        return editor11;
                    }
                    serialize(isForCopying11 = false, context11 = null) {
                        if (this.isEmpty()) return null;
                        const serialized11 = {
                            annotationType: _util11.AnnotationEditorType.STAMP,
                            bitmapId: this.#bitmapId,
                            pageIndex: this.pageIndex,
                            rect: this.getRect(0, 0),
                            rotation: this.rotation,
                            isSvg: this.#isSvg,
                            structTreeParentId: this._structTreeParentId
                        };
                        if (isForCopying11) {
                            serialized11.bitmapUrl = this.#serializeBitmap(true);
                            serialized11.accessibilityData = this.altTextData;
                            return serialized11;
                        }
                        const { decorative: decorative11, altText: altText11 } = this.altTextData;
                        if (!decorative11 && altText11) serialized11.accessibilityData = {
                            type: "Figure",
                            alt: altText11
                        };
                        if (context11 === null) return serialized11;
                        context11.stamps ||= new Map();
                        const area11 = this.#isSvg ? (serialized11.rect[2] - serialized11.rect[0]) * (serialized11.rect[3] - serialized11.rect[1]) : null;
                        if (!context11.stamps.has(this.#bitmapId)) {
                            context11.stamps.set(this.#bitmapId, {
                                area: area11,
                                serialized: serialized11
                            });
                            serialized11.bitmap = this.#serializeBitmap(false);
                        } else if (this.#isSvg) {
                            const prevData11 = context11.stamps.get(this.#bitmapId);
                            if (area11 > prevData11.area) {
                                prevData11.area = area11;
                                prevData11.serialized.bitmap.close();
                                prevData11.serialized.bitmap = this.#serializeBitmap(false);
                            }
                        }
                        return serialized11;
                    }
                }
                exports11.StampEditor = StampEditor11;
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __w_pdfjs_require__(moduleId11) {
            /******/ // Check if module is in cache
            /******/ var cachedModule11 = __webpack_module_cache__[moduleId11];
            /******/ if (cachedModule11 !== undefined) /******/ return cachedModule11.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module11 = __webpack_module_cache__[moduleId11] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId11](module11, module11.exports, __w_pdfjs_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module11.exports;
        /******/ }
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        (()=>{
            var exports11 = __webpack_exports__;
            Object.defineProperty(exports11, "__esModule", {
                value: true
            });
            Object.defineProperty(exports11, "AbortException", {
                enumerable: true,
                get: function() {
                    return _util11.AbortException;
                }
            });
            Object.defineProperty(exports11, "AnnotationEditorLayer", {
                enumerable: true,
                get: function() {
                    return _annotation_editor_layer11.AnnotationEditorLayer;
                }
            });
            Object.defineProperty(exports11, "AnnotationEditorParamsType", {
                enumerable: true,
                get: function() {
                    return _util11.AnnotationEditorParamsType;
                }
            });
            Object.defineProperty(exports11, "AnnotationEditorType", {
                enumerable: true,
                get: function() {
                    return _util11.AnnotationEditorType;
                }
            });
            Object.defineProperty(exports11, "AnnotationEditorUIManager", {
                enumerable: true,
                get: function() {
                    return _tools11.AnnotationEditorUIManager;
                }
            });
            Object.defineProperty(exports11, "AnnotationLayer", {
                enumerable: true,
                get: function() {
                    return _annotation_layer11.AnnotationLayer;
                }
            });
            Object.defineProperty(exports11, "AnnotationMode", {
                enumerable: true,
                get: function() {
                    return _util11.AnnotationMode;
                }
            });
            Object.defineProperty(exports11, "CMapCompressionType", {
                enumerable: true,
                get: function() {
                    return _util11.CMapCompressionType;
                }
            });
            Object.defineProperty(exports11, "DOMSVGFactory", {
                enumerable: true,
                get: function() {
                    return _display_utils11.DOMSVGFactory;
                }
            });
            Object.defineProperty(exports11, "FeatureTest", {
                enumerable: true,
                get: function() {
                    return _util11.FeatureTest;
                }
            });
            Object.defineProperty(exports11, "GlobalWorkerOptions", {
                enumerable: true,
                get: function() {
                    return _worker_options11.GlobalWorkerOptions;
                }
            });
            Object.defineProperty(exports11, "ImageKind", {
                enumerable: true,
                get: function() {
                    return _util11.ImageKind;
                }
            });
            Object.defineProperty(exports11, "InvalidPDFException", {
                enumerable: true,
                get: function() {
                    return _util11.InvalidPDFException;
                }
            });
            Object.defineProperty(exports11, "MissingPDFException", {
                enumerable: true,
                get: function() {
                    return _util11.MissingPDFException;
                }
            });
            Object.defineProperty(exports11, "OPS", {
                enumerable: true,
                get: function() {
                    return _util11.OPS;
                }
            });
            Object.defineProperty(exports11, "PDFDataRangeTransport", {
                enumerable: true,
                get: function() {
                    return _api11.PDFDataRangeTransport;
                }
            });
            Object.defineProperty(exports11, "PDFDateString", {
                enumerable: true,
                get: function() {
                    return _display_utils11.PDFDateString;
                }
            });
            Object.defineProperty(exports11, "PDFWorker", {
                enumerable: true,
                get: function() {
                    return _api11.PDFWorker;
                }
            });
            Object.defineProperty(exports11, "PasswordResponses", {
                enumerable: true,
                get: function() {
                    return _util11.PasswordResponses;
                }
            });
            Object.defineProperty(exports11, "PermissionFlag", {
                enumerable: true,
                get: function() {
                    return _util11.PermissionFlag;
                }
            });
            Object.defineProperty(exports11, "PixelsPerInch", {
                enumerable: true,
                get: function() {
                    return _display_utils11.PixelsPerInch;
                }
            });
            Object.defineProperty(exports11, "PromiseCapability", {
                enumerable: true,
                get: function() {
                    return _util11.PromiseCapability;
                }
            });
            Object.defineProperty(exports11, "RenderingCancelledException", {
                enumerable: true,
                get: function() {
                    return _display_utils11.RenderingCancelledException;
                }
            });
            Object.defineProperty(exports11, "SVGGraphics", {
                enumerable: true,
                get: function() {
                    return _api11.SVGGraphics;
                }
            });
            Object.defineProperty(exports11, "UnexpectedResponseException", {
                enumerable: true,
                get: function() {
                    return _util11.UnexpectedResponseException;
                }
            });
            Object.defineProperty(exports11, "Util", {
                enumerable: true,
                get: function() {
                    return _util11.Util;
                }
            });
            Object.defineProperty(exports11, "VerbosityLevel", {
                enumerable: true,
                get: function() {
                    return _util11.VerbosityLevel;
                }
            });
            Object.defineProperty(exports11, "XfaLayer", {
                enumerable: true,
                get: function() {
                    return _xfa_layer11.XfaLayer;
                }
            });
            Object.defineProperty(exports11, "build", {
                enumerable: true,
                get: function() {
                    return _api11.build;
                }
            });
            Object.defineProperty(exports11, "createValidAbsoluteUrl", {
                enumerable: true,
                get: function() {
                    return _util11.createValidAbsoluteUrl;
                }
            });
            Object.defineProperty(exports11, "getDocument", {
                enumerable: true,
                get: function() {
                    return _api11.getDocument;
                }
            });
            Object.defineProperty(exports11, "getFilenameFromUrl", {
                enumerable: true,
                get: function() {
                    return _display_utils11.getFilenameFromUrl;
                }
            });
            Object.defineProperty(exports11, "getPdfFilenameFromUrl", {
                enumerable: true,
                get: function() {
                    return _display_utils11.getPdfFilenameFromUrl;
                }
            });
            Object.defineProperty(exports11, "getXfaPageViewport", {
                enumerable: true,
                get: function() {
                    return _display_utils11.getXfaPageViewport;
                }
            });
            Object.defineProperty(exports11, "isDataScheme", {
                enumerable: true,
                get: function() {
                    return _display_utils11.isDataScheme;
                }
            });
            Object.defineProperty(exports11, "isPdfFile", {
                enumerable: true,
                get: function() {
                    return _display_utils11.isPdfFile;
                }
            });
            Object.defineProperty(exports11, "loadScript", {
                enumerable: true,
                get: function() {
                    return _display_utils11.loadScript;
                }
            });
            Object.defineProperty(exports11, "noContextMenu", {
                enumerable: true,
                get: function() {
                    return _display_utils11.noContextMenu;
                }
            });
            Object.defineProperty(exports11, "normalizeUnicode", {
                enumerable: true,
                get: function() {
                    return _util11.normalizeUnicode;
                }
            });
            Object.defineProperty(exports11, "renderTextLayer", {
                enumerable: true,
                get: function() {
                    return _text_layer11.renderTextLayer;
                }
            });
            Object.defineProperty(exports11, "setLayerDimensions", {
                enumerable: true,
                get: function() {
                    return _display_utils11.setLayerDimensions;
                }
            });
            Object.defineProperty(exports11, "shadow", {
                enumerable: true,
                get: function() {
                    return _util11.shadow;
                }
            });
            Object.defineProperty(exports11, "updateTextLayer", {
                enumerable: true,
                get: function() {
                    return _text_layer11.updateTextLayer;
                }
            });
            Object.defineProperty(exports11, "version", {
                enumerable: true,
                get: function() {
                    return _api11.version;
                }
            });
            var _util11 = __w_pdfjs_require__(1);
            var _api11 = __w_pdfjs_require__(2);
            var _display_utils11 = __w_pdfjs_require__(6);
            var _text_layer11 = __w_pdfjs_require__(26);
            var _annotation_editor_layer11 = __w_pdfjs_require__(27);
            var _tools11 = __w_pdfjs_require__(5);
            var _annotation_layer11 = __w_pdfjs_require__(29);
            var _worker_options11 = __w_pdfjs_require__(14);
            var _xfa_layer11 = __w_pdfjs_require__(32);
            const pdfjsVersion11 = "3.11.174";
            const pdfjsBuild11 = "ce8716743";
        })();
        /******/ return __webpack_exports__;
    /******/ })();
});

});
parcelRegister("17tgv", function(module, exports) {
// shim for using process in browser
var $0d0d255e14f785b6$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $0d0d255e14f785b6$var$cachedSetTimeout;
var $0d0d255e14f785b6$var$cachedClearTimeout;
function $0d0d255e14f785b6$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $0d0d255e14f785b6$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $0d0d255e14f785b6$var$cachedSetTimeout = setTimeout;
        else $0d0d255e14f785b6$var$cachedSetTimeout = $0d0d255e14f785b6$var$defaultSetTimout;
    } catch (e) {
        $0d0d255e14f785b6$var$cachedSetTimeout = $0d0d255e14f785b6$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $0d0d255e14f785b6$var$cachedClearTimeout = clearTimeout;
        else $0d0d255e14f785b6$var$cachedClearTimeout = $0d0d255e14f785b6$var$defaultClearTimeout;
    } catch (e) {
        $0d0d255e14f785b6$var$cachedClearTimeout = $0d0d255e14f785b6$var$defaultClearTimeout;
    }
})();
function $0d0d255e14f785b6$var$runTimeout(fun) {
    if ($0d0d255e14f785b6$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($0d0d255e14f785b6$var$cachedSetTimeout === $0d0d255e14f785b6$var$defaultSetTimout || !$0d0d255e14f785b6$var$cachedSetTimeout) && setTimeout) {
        $0d0d255e14f785b6$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $0d0d255e14f785b6$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $0d0d255e14f785b6$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $0d0d255e14f785b6$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $0d0d255e14f785b6$var$runClearTimeout(marker) {
    if ($0d0d255e14f785b6$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($0d0d255e14f785b6$var$cachedClearTimeout === $0d0d255e14f785b6$var$defaultClearTimeout || !$0d0d255e14f785b6$var$cachedClearTimeout) && clearTimeout) {
        $0d0d255e14f785b6$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $0d0d255e14f785b6$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $0d0d255e14f785b6$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $0d0d255e14f785b6$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $0d0d255e14f785b6$var$queue = [];
var $0d0d255e14f785b6$var$draining = false;
var $0d0d255e14f785b6$var$currentQueue;
var $0d0d255e14f785b6$var$queueIndex = -1;
function $0d0d255e14f785b6$var$cleanUpNextTick() {
    if (!$0d0d255e14f785b6$var$draining || !$0d0d255e14f785b6$var$currentQueue) return;
    $0d0d255e14f785b6$var$draining = false;
    if ($0d0d255e14f785b6$var$currentQueue.length) $0d0d255e14f785b6$var$queue = $0d0d255e14f785b6$var$currentQueue.concat($0d0d255e14f785b6$var$queue);
    else $0d0d255e14f785b6$var$queueIndex = -1;
    if ($0d0d255e14f785b6$var$queue.length) $0d0d255e14f785b6$var$drainQueue();
}
function $0d0d255e14f785b6$var$drainQueue() {
    if ($0d0d255e14f785b6$var$draining) return;
    var timeout = $0d0d255e14f785b6$var$runTimeout($0d0d255e14f785b6$var$cleanUpNextTick);
    $0d0d255e14f785b6$var$draining = true;
    var len = $0d0d255e14f785b6$var$queue.length;
    while(len){
        $0d0d255e14f785b6$var$currentQueue = $0d0d255e14f785b6$var$queue;
        $0d0d255e14f785b6$var$queue = [];
        while(++$0d0d255e14f785b6$var$queueIndex < len)if ($0d0d255e14f785b6$var$currentQueue) $0d0d255e14f785b6$var$currentQueue[$0d0d255e14f785b6$var$queueIndex].run();
        $0d0d255e14f785b6$var$queueIndex = -1;
        len = $0d0d255e14f785b6$var$queue.length;
    }
    $0d0d255e14f785b6$var$currentQueue = null;
    $0d0d255e14f785b6$var$draining = false;
    $0d0d255e14f785b6$var$runClearTimeout(timeout);
}
$0d0d255e14f785b6$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $0d0d255e14f785b6$var$queue.push(new $0d0d255e14f785b6$var$Item(fun, args));
    if ($0d0d255e14f785b6$var$queue.length === 1 && !$0d0d255e14f785b6$var$draining) $0d0d255e14f785b6$var$runTimeout($0d0d255e14f785b6$var$drainQueue);
};
// v8 likes predictible objects
function $0d0d255e14f785b6$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$0d0d255e14f785b6$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$0d0d255e14f785b6$var$process.title = "browser";
$0d0d255e14f785b6$var$process.browser = true;
$0d0d255e14f785b6$var$process.env = {};
$0d0d255e14f785b6$var$process.argv = [];
$0d0d255e14f785b6$var$process.version = ""; // empty string to avoid regexp issues
$0d0d255e14f785b6$var$process.versions = {};
function $0d0d255e14f785b6$var$noop() {}
$0d0d255e14f785b6$var$process.on = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.addListener = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.once = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.off = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.removeListener = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.removeAllListeners = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.emit = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.prependListener = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.prependOnceListener = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.listeners = function(name) {
    return [];
};
$0d0d255e14f785b6$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$0d0d255e14f785b6$var$process.cwd = function() {
    return "/";
};
$0d0d255e14f785b6$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$0d0d255e14f785b6$var$process.umask = function() {
    return 0;
};

});

parcelRegister("98IaM", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $6a772037c784145c$export$a143d493d941bafc; }, function (v) { return $6a772037c784145c$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $6a772037c784145c$export$f99ded8fe4b79145; }, function (v) { return $6a772037c784145c$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $6a772037c784145c$export$a143d493d941bafc;
var $6a772037c784145c$export$e4cf37d7f6fb9e0a;
var $6a772037c784145c$export$f99ded8fe4b79145;
var $6a772037c784145c$export$599f31c3813fae4d;
"use strict";

var $71dnm = parcelRequire("71dnm");

var $7VnKB = parcelRequire("7VnKB");
const $6a772037c784145c$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$6a772037c784145c$export$a143d493d941bafc = $6a772037c784145c$var$Buffer;
$6a772037c784145c$export$e4cf37d7f6fb9e0a = $6a772037c784145c$var$SlowBuffer;
$6a772037c784145c$export$f99ded8fe4b79145 = 50;
const $6a772037c784145c$var$K_MAX_LENGTH = 0x7fffffff;
$6a772037c784145c$export$599f31c3813fae4d = $6a772037c784145c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $6a772037c784145c$var$Buffer.TYPED_ARRAY_SUPPORT = $6a772037c784145c$var$typedArraySupport();
if (!$6a772037c784145c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $6a772037c784145c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($6a772037c784145c$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$6a772037c784145c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($6a772037c784145c$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$6a772037c784145c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $6a772037c784145c$var$createBuffer(length) {
    if (length > $6a772037c784145c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $6a772037c784145c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $6a772037c784145c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $6a772037c784145c$var$allocUnsafe(arg);
    }
    return $6a772037c784145c$var$from(arg, encodingOrOffset, length);
}
$6a772037c784145c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $6a772037c784145c$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $6a772037c784145c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $6a772037c784145c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($6a772037c784145c$var$isInstance(value, ArrayBuffer) || value && $6a772037c784145c$var$isInstance(value.buffer, ArrayBuffer)) return $6a772037c784145c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($6a772037c784145c$var$isInstance(value, SharedArrayBuffer) || value && $6a772037c784145c$var$isInstance(value.buffer, SharedArrayBuffer))) return $6a772037c784145c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $6a772037c784145c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $6a772037c784145c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $6a772037c784145c$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $6a772037c784145c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $6a772037c784145c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($6a772037c784145c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($6a772037c784145c$var$Buffer, Uint8Array);
function $6a772037c784145c$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $6a772037c784145c$var$alloc(size, fill, encoding) {
    $6a772037c784145c$var$assertSize(size);
    if (size <= 0) return $6a772037c784145c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $6a772037c784145c$var$createBuffer(size).fill(fill, encoding) : $6a772037c784145c$var$createBuffer(size).fill(fill);
    return $6a772037c784145c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $6a772037c784145c$var$Buffer.alloc = function(size, fill, encoding) {
    return $6a772037c784145c$var$alloc(size, fill, encoding);
};
function $6a772037c784145c$var$allocUnsafe(size) {
    $6a772037c784145c$var$assertSize(size);
    return $6a772037c784145c$var$createBuffer(size < 0 ? 0 : $6a772037c784145c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $6a772037c784145c$var$Buffer.allocUnsafe = function(size) {
    return $6a772037c784145c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $6a772037c784145c$var$Buffer.allocUnsafeSlow = function(size) {
    return $6a772037c784145c$var$allocUnsafe(size);
};
function $6a772037c784145c$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$6a772037c784145c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $6a772037c784145c$var$byteLength(string, encoding) | 0;
    let buf = $6a772037c784145c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $6a772037c784145c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $6a772037c784145c$var$checked(array.length) | 0;
    const buf = $6a772037c784145c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $6a772037c784145c$var$fromArrayView(arrayView) {
    if ($6a772037c784145c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $6a772037c784145c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $6a772037c784145c$var$fromArrayLike(arrayView);
}
function $6a772037c784145c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $6a772037c784145c$var$Buffer.prototype);
    return buf;
}
function $6a772037c784145c$var$fromObject(obj) {
    if ($6a772037c784145c$var$Buffer.isBuffer(obj)) {
        const len = $6a772037c784145c$var$checked(obj.length) | 0;
        const buf = $6a772037c784145c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $6a772037c784145c$var$numberIsNaN(obj.length)) return $6a772037c784145c$var$createBuffer(0);
        return $6a772037c784145c$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $6a772037c784145c$var$fromArrayLike(obj.data);
}
function $6a772037c784145c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $6a772037c784145c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $6a772037c784145c$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $6a772037c784145c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $6a772037c784145c$var$Buffer.alloc(+length);
}
$6a772037c784145c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $6a772037c784145c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$6a772037c784145c$var$Buffer.compare = function compare(a, b) {
    if ($6a772037c784145c$var$isInstance(a, Uint8Array)) a = $6a772037c784145c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($6a772037c784145c$var$isInstance(b, Uint8Array)) b = $6a772037c784145c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$6a772037c784145c$var$Buffer.isBuffer(a) || !$6a772037c784145c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$6a772037c784145c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$6a772037c784145c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $6a772037c784145c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $6a772037c784145c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($6a772037c784145c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$6a772037c784145c$var$Buffer.isBuffer(buf)) buf = $6a772037c784145c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$6a772037c784145c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $6a772037c784145c$var$byteLength(string, encoding) {
    if ($6a772037c784145c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $6a772037c784145c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $6a772037c784145c$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $6a772037c784145c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $6a772037c784145c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$6a772037c784145c$var$Buffer.byteLength = $6a772037c784145c$var$byteLength;
function $6a772037c784145c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $6a772037c784145c$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $6a772037c784145c$var$utf8Slice(this, start, end);
        case "ascii":
            return $6a772037c784145c$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $6a772037c784145c$var$latin1Slice(this, start, end);
        case "base64":
            return $6a772037c784145c$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $6a772037c784145c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$6a772037c784145c$var$Buffer.prototype._isBuffer = true;
function $6a772037c784145c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$6a772037c784145c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$6a772037c784145c$var$swap(this, i, i + 1);
    return this;
};
$6a772037c784145c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $6a772037c784145c$var$swap(this, i, i + 3);
        $6a772037c784145c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$6a772037c784145c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $6a772037c784145c$var$swap(this, i, i + 7);
        $6a772037c784145c$var$swap(this, i + 1, i + 6);
        $6a772037c784145c$var$swap(this, i + 2, i + 5);
        $6a772037c784145c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$6a772037c784145c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $6a772037c784145c$var$utf8Slice(this, 0, length);
    return $6a772037c784145c$var$slowToString.apply(this, arguments);
};
$6a772037c784145c$var$Buffer.prototype.toLocaleString = $6a772037c784145c$var$Buffer.prototype.toString;
$6a772037c784145c$var$Buffer.prototype.equals = function equals(b) {
    if (!$6a772037c784145c$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $6a772037c784145c$var$Buffer.compare(this, b) === 0;
};
$6a772037c784145c$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $6a772037c784145c$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($6a772037c784145c$var$customInspectSymbol) $6a772037c784145c$var$Buffer.prototype[$6a772037c784145c$var$customInspectSymbol] = $6a772037c784145c$var$Buffer.prototype.inspect;
$6a772037c784145c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($6a772037c784145c$var$isInstance(target, Uint8Array)) target = $6a772037c784145c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$6a772037c784145c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $6a772037c784145c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($6a772037c784145c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $6a772037c784145c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($6a772037c784145c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $6a772037c784145c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $6a772037c784145c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $6a772037c784145c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$6a772037c784145c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$6a772037c784145c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $6a772037c784145c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$6a772037c784145c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $6a772037c784145c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $6a772037c784145c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($6a772037c784145c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $6a772037c784145c$var$utf8Write(buf, string, offset, length) {
    return $6a772037c784145c$var$blitBuffer($6a772037c784145c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $6a772037c784145c$var$asciiWrite(buf, string, offset, length) {
    return $6a772037c784145c$var$blitBuffer($6a772037c784145c$var$asciiToBytes(string), buf, offset, length);
}
function $6a772037c784145c$var$base64Write(buf, string, offset, length) {
    return $6a772037c784145c$var$blitBuffer($6a772037c784145c$var$base64ToBytes(string), buf, offset, length);
}
function $6a772037c784145c$var$ucs2Write(buf, string, offset, length) {
    return $6a772037c784145c$var$blitBuffer($6a772037c784145c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$6a772037c784145c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $6a772037c784145c$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $6a772037c784145c$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $6a772037c784145c$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $6a772037c784145c$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $6a772037c784145c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$6a772037c784145c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $6a772037c784145c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $71dnm.fromByteArray(buf);
    else return $71dnm.fromByteArray(buf.slice(start, end));
}
function $6a772037c784145c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $6a772037c784145c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $6a772037c784145c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $6a772037c784145c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $6a772037c784145c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $6a772037c784145c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $6a772037c784145c$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $6a772037c784145c$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $6a772037c784145c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $6a772037c784145c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $6a772037c784145c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$6a772037c784145c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $6a772037c784145c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $6a772037c784145c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$6a772037c784145c$var$Buffer.prototype.readUintLE = $6a772037c784145c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$6a772037c784145c$var$Buffer.prototype.readUintBE = $6a772037c784145c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$6a772037c784145c$var$Buffer.prototype.readUint8 = $6a772037c784145c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$6a772037c784145c$var$Buffer.prototype.readUint16LE = $6a772037c784145c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$6a772037c784145c$var$Buffer.prototype.readUint16BE = $6a772037c784145c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$6a772037c784145c$var$Buffer.prototype.readUint32LE = $6a772037c784145c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$6a772037c784145c$var$Buffer.prototype.readUint32BE = $6a772037c784145c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$6a772037c784145c$var$Buffer.prototype.readBigUInt64LE = $6a772037c784145c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $6a772037c784145c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6a772037c784145c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$6a772037c784145c$var$Buffer.prototype.readBigUInt64BE = $6a772037c784145c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $6a772037c784145c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6a772037c784145c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$6a772037c784145c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6a772037c784145c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6a772037c784145c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$6a772037c784145c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6a772037c784145c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6a772037c784145c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$6a772037c784145c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$6a772037c784145c$var$Buffer.prototype.readBigInt64LE = $6a772037c784145c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $6a772037c784145c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6a772037c784145c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$6a772037c784145c$var$Buffer.prototype.readBigInt64BE = $6a772037c784145c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $6a772037c784145c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6a772037c784145c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$6a772037c784145c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 4, this.length);
    return $7VnKB.read(this, offset, true, 23, 4);
};
$6a772037c784145c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 4, this.length);
    return $7VnKB.read(this, offset, false, 23, 4);
};
$6a772037c784145c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 8, this.length);
    return $7VnKB.read(this, offset, true, 52, 8);
};
$6a772037c784145c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 8, this.length);
    return $7VnKB.read(this, offset, false, 52, 8);
};
function $6a772037c784145c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$6a772037c784145c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$6a772037c784145c$var$Buffer.prototype.writeUintLE = $6a772037c784145c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6a772037c784145c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6a772037c784145c$var$Buffer.prototype.writeUintBE = $6a772037c784145c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6a772037c784145c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6a772037c784145c$var$Buffer.prototype.writeUint8 = $6a772037c784145c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$6a772037c784145c$var$Buffer.prototype.writeUint16LE = $6a772037c784145c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6a772037c784145c$var$Buffer.prototype.writeUint16BE = $6a772037c784145c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6a772037c784145c$var$Buffer.prototype.writeUint32LE = $6a772037c784145c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$6a772037c784145c$var$Buffer.prototype.writeUint32BE = $6a772037c784145c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $6a772037c784145c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $6a772037c784145c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $6a772037c784145c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $6a772037c784145c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$6a772037c784145c$var$Buffer.prototype.writeBigUInt64LE = $6a772037c784145c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $6a772037c784145c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$6a772037c784145c$var$Buffer.prototype.writeBigUInt64BE = $6a772037c784145c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $6a772037c784145c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$6a772037c784145c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $6a772037c784145c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6a772037c784145c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $6a772037c784145c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6a772037c784145c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$6a772037c784145c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6a772037c784145c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6a772037c784145c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$6a772037c784145c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$6a772037c784145c$var$Buffer.prototype.writeBigInt64LE = $6a772037c784145c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $6a772037c784145c$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$6a772037c784145c$var$Buffer.prototype.writeBigInt64BE = $6a772037c784145c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $6a772037c784145c$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $6a772037c784145c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $6a772037c784145c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7VnKB.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$6a772037c784145c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $6a772037c784145c$var$writeFloat(this, value, offset, true, noAssert);
};
$6a772037c784145c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $6a772037c784145c$var$writeFloat(this, value, offset, false, noAssert);
};
function $6a772037c784145c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7VnKB.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$6a772037c784145c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $6a772037c784145c$var$writeDouble(this, value, offset, true, noAssert);
};
$6a772037c784145c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $6a772037c784145c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$6a772037c784145c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$6a772037c784145c$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$6a772037c784145c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$6a772037c784145c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $6a772037c784145c$var$Buffer.isBuffer(val) ? val : $6a772037c784145c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $6a772037c784145c$var$errors = {};
function $6a772037c784145c$var$E(sym, getMessage, Base) {
    $6a772037c784145c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$6a772037c784145c$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$6a772037c784145c$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$6a772037c784145c$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $6a772037c784145c$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $6a772037c784145c$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $6a772037c784145c$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $6a772037c784145c$var$checkBounds(buf, offset, byteLength) {
    $6a772037c784145c$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $6a772037c784145c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $6a772037c784145c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $6a772037c784145c$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $6a772037c784145c$var$checkBounds(buf, offset, byteLength);
}
function $6a772037c784145c$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $6a772037c784145c$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $6a772037c784145c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $6a772037c784145c$var$validateNumber(value, type);
        throw new $6a772037c784145c$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $6a772037c784145c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $6a772037c784145c$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $6a772037c784145c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $6a772037c784145c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($6a772037c784145c$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $6a772037c784145c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $6a772037c784145c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $6a772037c784145c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $6a772037c784145c$var$base64ToBytes(str) {
    return $71dnm.toByteArray($6a772037c784145c$var$base64clean(str));
}
function $6a772037c784145c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $6a772037c784145c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $6a772037c784145c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $6a772037c784145c$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $6a772037c784145c$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $6a772037c784145c$var$BufferBigIntNotDefined : fn;
}
function $6a772037c784145c$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("71dnm", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $51c300904a140497$export$d622b2ad8d90c771; }, function (v) { return $51c300904a140497$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $51c300904a140497$export$6100ba28696e12de; }, function (v) { return $51c300904a140497$export$6100ba28696e12de = v; });
var $51c300904a140497$export$a48f0734ac7c2329;
var $51c300904a140497$export$d622b2ad8d90c771;
var $51c300904a140497$export$6100ba28696e12de;
"use strict";
$51c300904a140497$export$a48f0734ac7c2329 = $51c300904a140497$var$byteLength;
$51c300904a140497$export$d622b2ad8d90c771 = $51c300904a140497$var$toByteArray;
$51c300904a140497$export$6100ba28696e12de = $51c300904a140497$var$fromByteArray;
var $51c300904a140497$var$lookup = [];
var $51c300904a140497$var$revLookup = [];
var $51c300904a140497$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $51c300904a140497$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $51c300904a140497$var$i = 0, $51c300904a140497$var$len = $51c300904a140497$var$code.length; $51c300904a140497$var$i < $51c300904a140497$var$len; ++$51c300904a140497$var$i){
    $51c300904a140497$var$lookup[$51c300904a140497$var$i] = $51c300904a140497$var$code[$51c300904a140497$var$i];
    $51c300904a140497$var$revLookup[$51c300904a140497$var$code.charCodeAt($51c300904a140497$var$i)] = $51c300904a140497$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$51c300904a140497$var$revLookup["-".charCodeAt(0)] = 62;
$51c300904a140497$var$revLookup["_".charCodeAt(0)] = 63;
function $51c300904a140497$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $51c300904a140497$var$byteLength(b64) {
    var lens = $51c300904a140497$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $51c300904a140497$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $51c300904a140497$var$toByteArray(b64) {
    var tmp;
    var lens = $51c300904a140497$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $51c300904a140497$var$Arr($51c300904a140497$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $51c300904a140497$var$revLookup[b64.charCodeAt(i)] << 18 | $51c300904a140497$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $51c300904a140497$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $51c300904a140497$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $51c300904a140497$var$revLookup[b64.charCodeAt(i)] << 2 | $51c300904a140497$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $51c300904a140497$var$revLookup[b64.charCodeAt(i)] << 10 | $51c300904a140497$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $51c300904a140497$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $51c300904a140497$var$tripletToBase64(num) {
    return $51c300904a140497$var$lookup[num >> 18 & 0x3F] + $51c300904a140497$var$lookup[num >> 12 & 0x3F] + $51c300904a140497$var$lookup[num >> 6 & 0x3F] + $51c300904a140497$var$lookup[num & 0x3F];
}
function $51c300904a140497$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($51c300904a140497$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $51c300904a140497$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($51c300904a140497$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($51c300904a140497$var$lookup[tmp >> 2] + $51c300904a140497$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($51c300904a140497$var$lookup[tmp >> 10] + $51c300904a140497$var$lookup[tmp >> 4 & 0x3F] + $51c300904a140497$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("7VnKB", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $5c5047a9af555f4a$export$aafa59e2e03f2942; }, function (v) { return $5c5047a9af555f4a$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $5c5047a9af555f4a$export$68d8715fc104d294; }, function (v) { return $5c5047a9af555f4a$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $5c5047a9af555f4a$export$aafa59e2e03f2942;
var $5c5047a9af555f4a$export$68d8715fc104d294;
$5c5047a9af555f4a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$5c5047a9af555f4a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("gFNhN", function(module, exports) {
"use strict";

});


// import another component
"use strict";
var $6eaaaed532023352$exports = {};
"use strict";
var $6eaaaed532023352$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$6eaaaed532023352$exports = // eslint-disable-next-line es/no-global-this -- safe
$6eaaaed532023352$var$check(typeof globalThis == "object" && globalThis) || $6eaaaed532023352$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$6eaaaed532023352$var$check(typeof self == "object" && self) || $6eaaaed532023352$var$check(typeof $parcel$global == "object" && $parcel$global) || $6eaaaed532023352$var$check(typeof $6eaaaed532023352$exports == "object" && $6eaaaed532023352$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


var $4dea53c988ff8146$exports = {};
"use strict";
var $03967c5c58b0637b$exports = {};
"use strict";
$03967c5c58b0637b$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$4dea53c988ff8146$exports = !$03967c5c58b0637b$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $c63f92c1035948fe$exports = {};
"use strict";
var $533e3f271af67a1e$exports = {};
"use strict";
var $2098731ff14c1b28$exports = {};
"use strict";
var $18d9aeab60ea26ad$exports = {};
"use strict";

$18d9aeab60ea26ad$exports = !$03967c5c58b0637b$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $2098731ff14c1b28$var$FunctionPrototype = Function.prototype;
var $2098731ff14c1b28$var$call = $2098731ff14c1b28$var$FunctionPrototype.call;
var $2098731ff14c1b28$var$uncurryThisWithBind = $18d9aeab60ea26ad$exports && $2098731ff14c1b28$var$FunctionPrototype.bind.bind($2098731ff14c1b28$var$call, $2098731ff14c1b28$var$call);
$2098731ff14c1b28$exports = $18d9aeab60ea26ad$exports ? $2098731ff14c1b28$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $2098731ff14c1b28$var$call.apply(fn, arguments);
    };
};



var $fa64b91b5990a54e$exports = {};
"use strict";
var $c9a494556ce53911$exports = {};
"use strict";
var $c9a494556ce53911$var$documentAll = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $c9a494556ce53911$var$IS_HTMLDDA = typeof $c9a494556ce53911$var$documentAll == "undefined" && $c9a494556ce53911$var$documentAll !== undefined;
$c9a494556ce53911$exports = {
    all: $c9a494556ce53911$var$documentAll,
    IS_HTMLDDA: $c9a494556ce53911$var$IS_HTMLDDA
};


var $fa64b91b5990a54e$var$documentAll = $c9a494556ce53911$exports.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
$fa64b91b5990a54e$exports = $c9a494556ce53911$exports.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === $fa64b91b5990a54e$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


var $cc844053de03f4cb$exports = {};
"use strict";

var $c935e8e6600f2e7c$exports = {};
"use strict";
var $27cd7a1a0cbe9d9e$exports = {};
"use strict";
var $0948cee6bccbdbb6$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$0948cee6bccbdbb6$exports = function(it) {
    return it === null || it === undefined;
};


var $27cd7a1a0cbe9d9e$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$27cd7a1a0cbe9d9e$exports = function(it) {
    if ($0948cee6bccbdbb6$exports(it)) throw new $27cd7a1a0cbe9d9e$var$$TypeError("Can't call method on " + it);
    return it;
};


var $c935e8e6600f2e7c$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$c935e8e6600f2e7c$exports = function(argument) {
    return $c935e8e6600f2e7c$var$$Object($27cd7a1a0cbe9d9e$exports(argument));
};


var $cc844053de03f4cb$var$hasOwnProperty = $2098731ff14c1b28$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$cc844053de03f4cb$exports = Object.hasOwn || function hasOwn(it, key) {
    return $cc844053de03f4cb$var$hasOwnProperty($c935e8e6600f2e7c$exports(it), key);
};



var $c29db39a85a3af77$exports = {};
"use strict";


var $c29db39a85a3af77$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $c29db39a85a3af77$var$getDescriptor = $4dea53c988ff8146$exports && Object.getOwnPropertyDescriptor;
var $c29db39a85a3af77$var$EXISTS = $cc844053de03f4cb$exports($c29db39a85a3af77$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $c29db39a85a3af77$var$PROPER = $c29db39a85a3af77$var$EXISTS && (function something() {}).name === "something";
var $c29db39a85a3af77$var$CONFIGURABLE = $c29db39a85a3af77$var$EXISTS && (!$4dea53c988ff8146$exports || $4dea53c988ff8146$exports && $c29db39a85a3af77$var$getDescriptor($c29db39a85a3af77$var$FunctionPrototype, "name").configurable);
$c29db39a85a3af77$exports = {
    EXISTS: $c29db39a85a3af77$var$EXISTS,
    PROPER: $c29db39a85a3af77$var$PROPER,
    CONFIGURABLE: $c29db39a85a3af77$var$CONFIGURABLE
};


var $533e3f271af67a1e$require$CONFIGURABLE_FUNCTION_NAME = $c29db39a85a3af77$exports.CONFIGURABLE;
var $3c54076c781f9072$exports = {};
"use strict";


var $6a765d72fd88a69a$exports = {};
"use strict";

var $9419ce30c21734c9$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $9419ce30c21734c9$var$defineProperty = Object.defineProperty;
$9419ce30c21734c9$exports = function(key, value) {
    try {
        $9419ce30c21734c9$var$defineProperty($6eaaaed532023352$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $6eaaaed532023352$exports[key] = value;
    }
    return value;
};


var $6a765d72fd88a69a$var$SHARED = "__core-js_shared__";
var $6a765d72fd88a69a$var$store = $6eaaaed532023352$exports[$6a765d72fd88a69a$var$SHARED] || $9419ce30c21734c9$exports($6a765d72fd88a69a$var$SHARED, {});
$6a765d72fd88a69a$exports = $6a765d72fd88a69a$var$store;


var $3c54076c781f9072$var$functionToString = $2098731ff14c1b28$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$fa64b91b5990a54e$exports($6a765d72fd88a69a$exports.inspectSource)) $6a765d72fd88a69a$exports.inspectSource = function(it) {
    return $3c54076c781f9072$var$functionToString(it);
};
$3c54076c781f9072$exports = $6a765d72fd88a69a$exports.inspectSource;


var $9e1e01125ce84891$exports = {};
"use strict";
var $ac802f0b591b1f5a$exports = {};
"use strict";


var $ac802f0b591b1f5a$var$WeakMap = $6eaaaed532023352$exports.WeakMap;
$ac802f0b591b1f5a$exports = $fa64b91b5990a54e$exports($ac802f0b591b1f5a$var$WeakMap) && /native code/.test(String($ac802f0b591b1f5a$var$WeakMap));



var $79b55cb30ab000ec$exports = {};
"use strict";


var $79b55cb30ab000ec$var$documentAll = $c9a494556ce53911$exports.all;
$79b55cb30ab000ec$exports = $c9a494556ce53911$exports.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : $fa64b91b5990a54e$exports(it) || it === $79b55cb30ab000ec$var$documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : $fa64b91b5990a54e$exports(it);
};


var $3927cb72a9744350$exports = {};
"use strict";

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $28aaf61ac32ff41d$export$2d1720544b23b823;
"use strict";

var $2165eb0d44536de3$exports = {};
"use strict";


var $28ae8aecb54c8b5b$exports = {};
"use strict";


var $28ae8aecb54c8b5b$var$document = $6eaaaed532023352$exports.document;
// typeof document.createElement is 'object' in old IE
var $28ae8aecb54c8b5b$var$EXISTS = $79b55cb30ab000ec$exports($28ae8aecb54c8b5b$var$document) && $79b55cb30ab000ec$exports($28ae8aecb54c8b5b$var$document.createElement);
$28ae8aecb54c8b5b$exports = function(it) {
    return $28ae8aecb54c8b5b$var$EXISTS ? $28ae8aecb54c8b5b$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$2165eb0d44536de3$exports = !$4dea53c988ff8146$exports && !$03967c5c58b0637b$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($28ae8aecb54c8b5b$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


var $bcaf2a862bc67bc8$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$bcaf2a862bc67bc8$exports = $4dea53c988ff8146$exports && $03967c5c58b0637b$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $d8eb1c0d5fd2deb8$exports = {};
"use strict";

var $d8eb1c0d5fd2deb8$var$$String = String;
var $d8eb1c0d5fd2deb8$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$d8eb1c0d5fd2deb8$exports = function(argument) {
    if ($79b55cb30ab000ec$exports(argument)) return argument;
    throw new $d8eb1c0d5fd2deb8$var$$TypeError($d8eb1c0d5fd2deb8$var$$String(argument) + " is not an object");
};


var $a026e48acb0f9691$exports = {};
"use strict";
var $f8fb772bbd319356$exports = {};
"use strict";
var $97bce1c6dc77a53b$exports = {};
"use strict";

var $97bce1c6dc77a53b$var$call = Function.prototype.call;
$97bce1c6dc77a53b$exports = $18d9aeab60ea26ad$exports ? $97bce1c6dc77a53b$var$call.bind($97bce1c6dc77a53b$var$call) : function() {
    return $97bce1c6dc77a53b$var$call.apply($97bce1c6dc77a53b$var$call, arguments);
};



var $de3f97323bb1e14d$exports = {};
"use strict";
var $a86b7d926328b4a8$exports = {};
"use strict";


var $a86b7d926328b4a8$var$aFunction = function(argument) {
    return $fa64b91b5990a54e$exports(argument) ? argument : undefined;
};
$a86b7d926328b4a8$exports = function(namespace, method) {
    return arguments.length < 2 ? $a86b7d926328b4a8$var$aFunction($6eaaaed532023352$exports[namespace]) : $6eaaaed532023352$exports[namespace] && $6eaaaed532023352$exports[namespace][method];
};



var $8ea9bc2a79eb2dd1$exports = {};
"use strict";

$8ea9bc2a79eb2dd1$exports = $2098731ff14c1b28$exports({}.isPrototypeOf);


var $cdf737228986799b$exports = {};
"use strict";
var $a118894a579b43ef$exports = {};
"use strict";
var $4184abdd02c1c55e$exports = {};
"use strict";

var $dee6150af074c33b$exports = {};
"use strict";
$dee6150af074c33b$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $4184abdd02c1c55e$var$process = $6eaaaed532023352$exports.process;
var $4184abdd02c1c55e$var$Deno = $6eaaaed532023352$exports.Deno;
var $4184abdd02c1c55e$var$versions = $4184abdd02c1c55e$var$process && $4184abdd02c1c55e$var$process.versions || $4184abdd02c1c55e$var$Deno && $4184abdd02c1c55e$var$Deno.version;
var $4184abdd02c1c55e$var$v8 = $4184abdd02c1c55e$var$versions && $4184abdd02c1c55e$var$versions.v8;
var $4184abdd02c1c55e$var$match, $4184abdd02c1c55e$var$version;
if ($4184abdd02c1c55e$var$v8) {
    $4184abdd02c1c55e$var$match = $4184abdd02c1c55e$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $4184abdd02c1c55e$var$version = $4184abdd02c1c55e$var$match[0] > 0 && $4184abdd02c1c55e$var$match[0] < 4 ? 1 : +($4184abdd02c1c55e$var$match[0] + $4184abdd02c1c55e$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$4184abdd02c1c55e$var$version && $dee6150af074c33b$exports) {
    $4184abdd02c1c55e$var$match = $dee6150af074c33b$exports.match(/Edge\/(\d+)/);
    if (!$4184abdd02c1c55e$var$match || $4184abdd02c1c55e$var$match[1] >= 74) {
        $4184abdd02c1c55e$var$match = $dee6150af074c33b$exports.match(/Chrome\/(\d+)/);
        if ($4184abdd02c1c55e$var$match) $4184abdd02c1c55e$var$version = +$4184abdd02c1c55e$var$match[1];
    }
}
$4184abdd02c1c55e$exports = $4184abdd02c1c55e$var$version;




var $a118894a579b43ef$var$$String = $6eaaaed532023352$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$a118894a579b43ef$exports = !!Object.getOwnPropertySymbols && !$03967c5c58b0637b$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$a118894a579b43ef$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $4184abdd02c1c55e$exports && $4184abdd02c1c55e$exports < 41;
});


$cdf737228986799b$exports = $a118894a579b43ef$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $de3f97323bb1e14d$var$$Object = Object;
$de3f97323bb1e14d$exports = $cdf737228986799b$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $a86b7d926328b4a8$exports("Symbol");
    return $fa64b91b5990a54e$exports($Symbol) && $8ea9bc2a79eb2dd1$exports($Symbol.prototype, $de3f97323bb1e14d$var$$Object(it));
};


var $a313ad37d47c05ba$exports = {};
"use strict";
var $b036d6e8e8a1e730$exports = {};
"use strict";

var $89fbca0f38ee4901$exports = {};
"use strict";
var $89fbca0f38ee4901$var$$String = String;
$89fbca0f38ee4901$exports = function(argument) {
    try {
        return $89fbca0f38ee4901$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $b036d6e8e8a1e730$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$b036d6e8e8a1e730$exports = function(argument) {
    if ($fa64b91b5990a54e$exports(argument)) return argument;
    throw new $b036d6e8e8a1e730$var$$TypeError($89fbca0f38ee4901$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$a313ad37d47c05ba$exports = function(V, P) {
    var func = V[P];
    return $0948cee6bccbdbb6$exports(func) ? undefined : $b036d6e8e8a1e730$exports(func);
};


var $8a7b54c36a2f24f7$exports = {};
"use strict";



var $8a7b54c36a2f24f7$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$8a7b54c36a2f24f7$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $fa64b91b5990a54e$exports(fn = input.toString) && !$79b55cb30ab000ec$exports(val = $97bce1c6dc77a53b$exports(fn, input))) return val;
    if ($fa64b91b5990a54e$exports(fn = input.valueOf) && !$79b55cb30ab000ec$exports(val = $97bce1c6dc77a53b$exports(fn, input))) return val;
    if (pref !== "string" && $fa64b91b5990a54e$exports(fn = input.toString) && !$79b55cb30ab000ec$exports(val = $97bce1c6dc77a53b$exports(fn, input))) return val;
    throw new $8a7b54c36a2f24f7$var$$TypeError("Can't convert object to primitive value");
};


var $cb598f706b77edff$exports = {};
"use strict";

var $de387bee9c871371$exports = {};
"use strict";
var $0f1181f19eff16c7$exports = {};
"use strict";
$0f1181f19eff16c7$exports = false;



($de387bee9c871371$exports = function(key, value) {
    return $6a765d72fd88a69a$exports[key] || ($6a765d72fd88a69a$exports[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.34.0",
    mode: $0f1181f19eff16c7$exports ? "pure" : "global",
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.34.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});



var $eccb9536514100e8$exports = {};
"use strict";

var $eccb9536514100e8$var$id = 0;
var $eccb9536514100e8$var$postfix = Math.random();
var $eccb9536514100e8$var$toString = $2098731ff14c1b28$exports(1.0.toString);
$eccb9536514100e8$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $eccb9536514100e8$var$toString(++$eccb9536514100e8$var$id + $eccb9536514100e8$var$postfix, 36);
};




var $cb598f706b77edff$var$Symbol = $6eaaaed532023352$exports.Symbol;
var $cb598f706b77edff$var$WellKnownSymbolsStore = $de387bee9c871371$exports("wks");
var $cb598f706b77edff$var$createWellKnownSymbol = $cdf737228986799b$exports ? $cb598f706b77edff$var$Symbol["for"] || $cb598f706b77edff$var$Symbol : $cb598f706b77edff$var$Symbol && $cb598f706b77edff$var$Symbol.withoutSetter || $eccb9536514100e8$exports;
$cb598f706b77edff$exports = function(name) {
    if (!$cc844053de03f4cb$exports($cb598f706b77edff$var$WellKnownSymbolsStore, name)) $cb598f706b77edff$var$WellKnownSymbolsStore[name] = $a118894a579b43ef$exports && $cc844053de03f4cb$exports($cb598f706b77edff$var$Symbol, name) ? $cb598f706b77edff$var$Symbol[name] : $cb598f706b77edff$var$createWellKnownSymbol("Symbol." + name);
    return $cb598f706b77edff$var$WellKnownSymbolsStore[name];
};


var $f8fb772bbd319356$var$$TypeError = TypeError;
var $f8fb772bbd319356$var$TO_PRIMITIVE = $cb598f706b77edff$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$f8fb772bbd319356$exports = function(input, pref) {
    if (!$79b55cb30ab000ec$exports(input) || $de3f97323bb1e14d$exports(input)) return input;
    var exoticToPrim = $a313ad37d47c05ba$exports(input, $f8fb772bbd319356$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $97bce1c6dc77a53b$exports(exoticToPrim, input, pref);
        if (!$79b55cb30ab000ec$exports(result) || $de3f97323bb1e14d$exports(result)) return result;
        throw new $f8fb772bbd319356$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $8a7b54c36a2f24f7$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$a026e48acb0f9691$exports = function(argument) {
    var key = $f8fb772bbd319356$exports(argument, "string");
    return $de3f97323bb1e14d$exports(key) ? key : key + "";
};


var $28aaf61ac32ff41d$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $28aaf61ac32ff41d$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $28aaf61ac32ff41d$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $28aaf61ac32ff41d$var$ENUMERABLE = "enumerable";
var $28aaf61ac32ff41d$var$CONFIGURABLE = "configurable";
var $28aaf61ac32ff41d$var$WRITABLE = "writable";
$28aaf61ac32ff41d$export$2d1720544b23b823 = $4dea53c988ff8146$exports ? $bcaf2a862bc67bc8$exports ? function defineProperty(O, P, Attributes) {
    $d8eb1c0d5fd2deb8$exports(O);
    P = $a026e48acb0f9691$exports(P);
    $d8eb1c0d5fd2deb8$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $28aaf61ac32ff41d$var$WRITABLE in Attributes && !Attributes[$28aaf61ac32ff41d$var$WRITABLE]) {
        var current = $28aaf61ac32ff41d$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$28aaf61ac32ff41d$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $28aaf61ac32ff41d$var$CONFIGURABLE in Attributes ? Attributes[$28aaf61ac32ff41d$var$CONFIGURABLE] : current[$28aaf61ac32ff41d$var$CONFIGURABLE],
                enumerable: $28aaf61ac32ff41d$var$ENUMERABLE in Attributes ? Attributes[$28aaf61ac32ff41d$var$ENUMERABLE] : current[$28aaf61ac32ff41d$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $28aaf61ac32ff41d$var$$defineProperty(O, P, Attributes);
} : $28aaf61ac32ff41d$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $d8eb1c0d5fd2deb8$exports(O);
    P = $a026e48acb0f9691$exports(P);
    $d8eb1c0d5fd2deb8$exports(Attributes);
    if ($2165eb0d44536de3$exports) try {
        return $28aaf61ac32ff41d$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $28aaf61ac32ff41d$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};


var $2abcd2194b45431b$exports = {};
"use strict";
$2abcd2194b45431b$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


$3927cb72a9744350$exports = $4dea53c988ff8146$exports ? function(object, key, value) {
    return $28aaf61ac32ff41d$export$2d1720544b23b823(object, key, $2abcd2194b45431b$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};




var $c1fb8cbb3737e99f$exports = {};
"use strict";


var $c1fb8cbb3737e99f$var$keys = $de387bee9c871371$exports("keys");
$c1fb8cbb3737e99f$exports = function(key) {
    return $c1fb8cbb3737e99f$var$keys[key] || ($c1fb8cbb3737e99f$var$keys[key] = $eccb9536514100e8$exports(key));
};


var $5f6c4e9e26626326$exports = {};
"use strict";
$5f6c4e9e26626326$exports = {};


var $9e1e01125ce84891$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $9e1e01125ce84891$var$TypeError = $6eaaaed532023352$exports.TypeError;
var $9e1e01125ce84891$var$WeakMap = $6eaaaed532023352$exports.WeakMap;
var $9e1e01125ce84891$var$set, $9e1e01125ce84891$var$get, $9e1e01125ce84891$var$has;
var $9e1e01125ce84891$var$enforce = function(it) {
    return $9e1e01125ce84891$var$has(it) ? $9e1e01125ce84891$var$get(it) : $9e1e01125ce84891$var$set(it, {});
};
var $9e1e01125ce84891$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$79b55cb30ab000ec$exports(it) || (state = $9e1e01125ce84891$var$get(it)).type !== TYPE) throw new $9e1e01125ce84891$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($ac802f0b591b1f5a$exports || $6a765d72fd88a69a$exports.state) {
    var $9e1e01125ce84891$var$store = $6a765d72fd88a69a$exports.state || ($6a765d72fd88a69a$exports.state = new $9e1e01125ce84891$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $9e1e01125ce84891$var$store.get = $9e1e01125ce84891$var$store.get;
    $9e1e01125ce84891$var$store.has = $9e1e01125ce84891$var$store.has;
    $9e1e01125ce84891$var$store.set = $9e1e01125ce84891$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $9e1e01125ce84891$var$set = function(it, metadata) {
        if ($9e1e01125ce84891$var$store.has(it)) throw new $9e1e01125ce84891$var$TypeError($9e1e01125ce84891$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $9e1e01125ce84891$var$store.set(it, metadata);
        return metadata;
    };
    $9e1e01125ce84891$var$get = function(it) {
        return $9e1e01125ce84891$var$store.get(it) || {};
    };
    $9e1e01125ce84891$var$has = function(it) {
        return $9e1e01125ce84891$var$store.has(it);
    };
} else {
    var $9e1e01125ce84891$var$STATE = $c1fb8cbb3737e99f$exports("state");
    $5f6c4e9e26626326$exports[$9e1e01125ce84891$var$STATE] = true;
    $9e1e01125ce84891$var$set = function(it, metadata) {
        if ($cc844053de03f4cb$exports(it, $9e1e01125ce84891$var$STATE)) throw new $9e1e01125ce84891$var$TypeError($9e1e01125ce84891$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $3927cb72a9744350$exports(it, $9e1e01125ce84891$var$STATE, metadata);
        return metadata;
    };
    $9e1e01125ce84891$var$get = function(it) {
        return $cc844053de03f4cb$exports(it, $9e1e01125ce84891$var$STATE) ? it[$9e1e01125ce84891$var$STATE] : {};
    };
    $9e1e01125ce84891$var$has = function(it) {
        return $cc844053de03f4cb$exports(it, $9e1e01125ce84891$var$STATE);
    };
}
$9e1e01125ce84891$exports = {
    set: $9e1e01125ce84891$var$set,
    get: $9e1e01125ce84891$var$get,
    has: $9e1e01125ce84891$var$has,
    enforce: $9e1e01125ce84891$var$enforce,
    getterFor: $9e1e01125ce84891$var$getterFor
};


var $533e3f271af67a1e$var$enforceInternalState = $9e1e01125ce84891$exports.enforce;
var $533e3f271af67a1e$var$getInternalState = $9e1e01125ce84891$exports.get;
var $533e3f271af67a1e$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $533e3f271af67a1e$var$defineProperty = Object.defineProperty;
var $533e3f271af67a1e$var$stringSlice = $2098731ff14c1b28$exports("".slice);
var $533e3f271af67a1e$var$replace = $2098731ff14c1b28$exports("".replace);
var $533e3f271af67a1e$var$join = $2098731ff14c1b28$exports([].join);
var $533e3f271af67a1e$var$CONFIGURABLE_LENGTH = $4dea53c988ff8146$exports && !$03967c5c58b0637b$exports(function() {
    return $533e3f271af67a1e$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $533e3f271af67a1e$var$TEMPLATE = String(String).split("String");
var $533e3f271af67a1e$var$makeBuiltIn = $533e3f271af67a1e$exports = function(value, name, options) {
    if ($533e3f271af67a1e$var$stringSlice($533e3f271af67a1e$var$$String(name), 0, 7) === "Symbol(") name = "[" + $533e3f271af67a1e$var$replace($533e3f271af67a1e$var$$String(name), /^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$cc844053de03f4cb$exports(value, "name") || $533e3f271af67a1e$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($4dea53c988ff8146$exports) $533e3f271af67a1e$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($533e3f271af67a1e$var$CONFIGURABLE_LENGTH && options && $cc844053de03f4cb$exports(options, "arity") && value.length !== options.arity) $533e3f271af67a1e$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $cc844053de03f4cb$exports(options, "constructor") && options.constructor) {
            if ($4dea53c988ff8146$exports) $533e3f271af67a1e$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $533e3f271af67a1e$var$enforceInternalState(value);
    if (!$cc844053de03f4cb$exports(state, "source")) state.source = $533e3f271af67a1e$var$join($533e3f271af67a1e$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $533e3f271af67a1e$var$makeBuiltIn(function toString() {
    return $fa64b91b5990a54e$exports(this) && $533e3f271af67a1e$var$getInternalState(this).source || $3c54076c781f9072$exports(this);
}, "toString");



$c63f92c1035948fe$exports = function(target, name, descriptor) {
    if (descriptor.get) $533e3f271af67a1e$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $533e3f271af67a1e$exports(descriptor.set, name, {
        setter: true
    });
    return $28aaf61ac32ff41d$export$2d1720544b23b823(target, name, descriptor);
};


var $7ba0612ea7aa26fa$exports = {};
"use strict";

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$7ba0612ea7aa26fa$exports = function() {
    var that = $d8eb1c0d5fd2deb8$exports(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};



// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var $6fcbcd33fe19a3f2$var$RegExp = $6eaaaed532023352$exports.RegExp;
var $6fcbcd33fe19a3f2$var$RegExpPrototype = $6fcbcd33fe19a3f2$var$RegExp.prototype;
var $6fcbcd33fe19a3f2$var$FORCED = $4dea53c988ff8146$exports && $03967c5c58b0637b$exports(function() {
    var INDICES_SUPPORT = true;
    try {
        $6fcbcd33fe19a3f2$var$RegExp(".", "d");
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = "";
    var expected = INDICES_SUPPORT ? "dgimsy" : "gimsy";
    var addGetter = function(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: "s",
        global: "g",
        ignoreCase: "i",
        multiline: "m",
        sticky: "y"
    };
    if (INDICES_SUPPORT) pairs.hasIndices = "d";
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor($6fcbcd33fe19a3f2$var$RegExpPrototype, "flags").get.call(O);
    return result !== expected || calls !== expected;
});
// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if ($6fcbcd33fe19a3f2$var$FORCED) $c63f92c1035948fe$exports($6fcbcd33fe19a3f2$var$RegExpPrototype, "flags", {
    configurable: true,
    get: $7ba0612ea7aa26fa$exports
});


"use strict";

var $7b0347005a7283b3$exports = {};
"use strict";

var $b77147d4c97a1d55$exports = {};
"use strict";

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $dc1694f5fe9651e3$export$2d1720544b23b823;
"use strict";




var $6532fb5f186833fb$exports = {};
"use strict";
var $4e0cffadaedf9f6b$exports = {};
"use strict";


var $6d25cd027215e59b$exports = {};
"use strict";

var $6d25cd027215e59b$var$toString = $2098731ff14c1b28$exports({}.toString);
var $6d25cd027215e59b$var$stringSlice = $2098731ff14c1b28$exports("".slice);
$6d25cd027215e59b$exports = function(it) {
    return $6d25cd027215e59b$var$stringSlice($6d25cd027215e59b$var$toString(it), 8, -1);
};


var $4e0cffadaedf9f6b$var$$Object = Object;
var $4e0cffadaedf9f6b$var$split = $2098731ff14c1b28$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$4e0cffadaedf9f6b$exports = $03967c5c58b0637b$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$4e0cffadaedf9f6b$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $6d25cd027215e59b$exports(it) === "String" ? $4e0cffadaedf9f6b$var$split(it, "") : $4e0cffadaedf9f6b$var$$Object(it);
} : $4e0cffadaedf9f6b$var$$Object;



$6532fb5f186833fb$exports = function(it) {
    return $4e0cffadaedf9f6b$exports($27cd7a1a0cbe9d9e$exports(it));
};


var $80ee0d0172cd31f5$exports = {};
"use strict";
var $eb556d91195b2704$exports = {};
"use strict";



var $1f5cebf1bf67dcee$exports = {};
"use strict";

var $f60dcf685adc9c16$exports = {};
"use strict";
var $cdf3b3f376b00406$exports = {};
"use strict";
var $c912f32c739b4bdf$exports = {};
"use strict";
var $c912f32c739b4bdf$var$ceil = Math.ceil;
var $c912f32c739b4bdf$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$c912f32c739b4bdf$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $c912f32c739b4bdf$var$floor : $c912f32c739b4bdf$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$cdf3b3f376b00406$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $c912f32c739b4bdf$exports(number);
};


var $f60dcf685adc9c16$var$max = Math.max;
var $f60dcf685adc9c16$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$f60dcf685adc9c16$exports = function(index, length) {
    var integer = $cdf3b3f376b00406$exports(index);
    return integer < 0 ? $f60dcf685adc9c16$var$max(integer + length, 0) : $f60dcf685adc9c16$var$min(integer, length);
};


var $3032eb0255f70567$exports = {};
"use strict";
var $eeb9fe75caa2decf$exports = {};
"use strict";

var $eeb9fe75caa2decf$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$eeb9fe75caa2decf$exports = function(argument) {
    return argument > 0 ? $eeb9fe75caa2decf$var$min($cdf3b3f376b00406$exports(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$3032eb0255f70567$exports = function(obj) {
    return $eeb9fe75caa2decf$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $1f5cebf1bf67dcee$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $6532fb5f186833fb$exports($this);
        var length = $3032eb0255f70567$exports(O);
        var index = $f60dcf685adc9c16$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$1f5cebf1bf67dcee$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $1f5cebf1bf67dcee$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $1f5cebf1bf67dcee$var$createMethod(false)
};


var $eb556d91195b2704$require$indexOf = $1f5cebf1bf67dcee$exports.indexOf;

var $eb556d91195b2704$var$push = $2098731ff14c1b28$exports([].push);
$eb556d91195b2704$exports = function(object, names) {
    var O = $6532fb5f186833fb$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$cc844053de03f4cb$exports($5f6c4e9e26626326$exports, key) && $cc844053de03f4cb$exports(O, key) && $eb556d91195b2704$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($cc844053de03f4cb$exports(O, key = names[i++])) ~$eb556d91195b2704$require$indexOf(result, key) || $eb556d91195b2704$var$push(result, key);
    return result;
};


var $2ab025accaef34b4$exports = {};
"use strict";
// IE8- don't enum bug keys
$2ab025accaef34b4$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$80ee0d0172cd31f5$exports = Object.keys || function keys(O) {
    return $eb556d91195b2704$exports(O, $2ab025accaef34b4$exports);
};


$dc1694f5fe9651e3$export$2d1720544b23b823 = $4dea53c988ff8146$exports && !$bcaf2a862bc67bc8$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $d8eb1c0d5fd2deb8$exports(O);
    var props = $6532fb5f186833fb$exports(Properties);
    var keys = $80ee0d0172cd31f5$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$28aaf61ac32ff41d$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $878c9c54b4611e60$exports = {};
"use strict";

$878c9c54b4611e60$exports = $a86b7d926328b4a8$exports("document", "documentElement");




var $b77147d4c97a1d55$var$GT = ">";
var $b77147d4c97a1d55$var$LT = "<";
var $b77147d4c97a1d55$var$PROTOTYPE = "prototype";
var $b77147d4c97a1d55$var$SCRIPT = "script";
var $b77147d4c97a1d55$var$IE_PROTO = $c1fb8cbb3737e99f$exports("IE_PROTO");
var $b77147d4c97a1d55$var$EmptyConstructor = function() {};
var $b77147d4c97a1d55$var$scriptTag = function(content) {
    return $b77147d4c97a1d55$var$LT + $b77147d4c97a1d55$var$SCRIPT + $b77147d4c97a1d55$var$GT + content + $b77147d4c97a1d55$var$LT + "/" + $b77147d4c97a1d55$var$SCRIPT + $b77147d4c97a1d55$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $b77147d4c97a1d55$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($b77147d4c97a1d55$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $b77147d4c97a1d55$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $28ae8aecb54c8b5b$exports("iframe");
    var JS = "java" + $b77147d4c97a1d55$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $878c9c54b4611e60$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($b77147d4c97a1d55$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $b77147d4c97a1d55$var$activeXDocument;
var $b77147d4c97a1d55$var$NullProtoObject = function() {
    try {
        $b77147d4c97a1d55$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $b77147d4c97a1d55$var$NullProtoObject = typeof document != "undefined" ? document.domain && $b77147d4c97a1d55$var$activeXDocument ? $b77147d4c97a1d55$var$NullProtoObjectViaActiveX($b77147d4c97a1d55$var$activeXDocument) // old IE
     : $b77147d4c97a1d55$var$NullProtoObjectViaIFrame() : $b77147d4c97a1d55$var$NullProtoObjectViaActiveX($b77147d4c97a1d55$var$activeXDocument); // WSH
    var length = $2ab025accaef34b4$exports.length;
    while(length--)delete $b77147d4c97a1d55$var$NullProtoObject[$b77147d4c97a1d55$var$PROTOTYPE][$2ab025accaef34b4$exports[length]];
    return $b77147d4c97a1d55$var$NullProtoObject();
};
$5f6c4e9e26626326$exports[$b77147d4c97a1d55$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$b77147d4c97a1d55$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $b77147d4c97a1d55$var$EmptyConstructor[$b77147d4c97a1d55$var$PROTOTYPE] = $d8eb1c0d5fd2deb8$exports(O);
        result = new $b77147d4c97a1d55$var$EmptyConstructor();
        $b77147d4c97a1d55$var$EmptyConstructor[$b77147d4c97a1d55$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$b77147d4c97a1d55$var$IE_PROTO] = O;
    } else result = $b77147d4c97a1d55$var$NullProtoObject();
    return Properties === undefined ? result : $dc1694f5fe9651e3$export$2d1720544b23b823(result, Properties);
};



var $7b0347005a7283b3$require$defineProperty = $28aaf61ac32ff41d$export$2d1720544b23b823;
var $7b0347005a7283b3$var$UNSCOPABLES = $cb598f706b77edff$exports("unscopables");
var $7b0347005a7283b3$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($7b0347005a7283b3$var$ArrayPrototype[$7b0347005a7283b3$var$UNSCOPABLES] === undefined) $7b0347005a7283b3$require$defineProperty($7b0347005a7283b3$var$ArrayPrototype, $7b0347005a7283b3$var$UNSCOPABLES, {
    configurable: true,
    value: $b77147d4c97a1d55$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$7b0347005a7283b3$exports = function(key) {
    $7b0347005a7283b3$var$ArrayPrototype[$7b0347005a7283b3$var$UNSCOPABLES][key] = true;
};





// `Array.prototype.lastIndex` getter
// https://github.com/keithamus/proposal-array-last
if ($4dea53c988ff8146$exports) {
    $c63f92c1035948fe$exports(Array.prototype, "lastIndex", {
        configurable: true,
        get: function lastIndex() {
            var O = $c935e8e6600f2e7c$exports(this);
            var len = $3032eb0255f70567$exports(O);
            return len === 0 ? 0 : len - 1;
        }
    });
    $7b0347005a7283b3$exports("lastIndex");
}


"use strict";





// `Array.prototype.lastIndex` accessor
// https://github.com/keithamus/proposal-array-last
if ($4dea53c988ff8146$exports) {
    $c63f92c1035948fe$exports(Array.prototype, "lastItem", {
        configurable: true,
        get: function lastItem() {
            var O = $c935e8e6600f2e7c$exports(this);
            var len = $3032eb0255f70567$exports(O);
            return len === 0 ? undefined : O[len - 1];
        },
        set: function lastItem(value) {
            var O = $c935e8e6600f2e7c$exports(this);
            var len = $3032eb0255f70567$exports(O);
            return O[len === 0 ? 0 : len - 1] = value;
        }
    });
    $7b0347005a7283b3$exports("lastItem");
}


"use strict";
var $95f391e8d3de298b$exports = {};
"use strict";

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $a1de5a78f57d3b17$export$2d1720544b23b823;
"use strict";


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $60dbd2d73b8dc4a5$export$2d1720544b23b823;
"use strict";
var $60dbd2d73b8dc4a5$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $60dbd2d73b8dc4a5$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $60dbd2d73b8dc4a5$var$NASHORN_BUG = $60dbd2d73b8dc4a5$var$getOwnPropertyDescriptor && !$60dbd2d73b8dc4a5$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$60dbd2d73b8dc4a5$export$2d1720544b23b823 = $60dbd2d73b8dc4a5$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $60dbd2d73b8dc4a5$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $60dbd2d73b8dc4a5$var$$propertyIsEnumerable;







// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $a1de5a78f57d3b17$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$a1de5a78f57d3b17$export$2d1720544b23b823 = $4dea53c988ff8146$exports ? $a1de5a78f57d3b17$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $6532fb5f186833fb$exports(O);
    P = $a026e48acb0f9691$exports(P);
    if ($2165eb0d44536de3$exports) try {
        return $a1de5a78f57d3b17$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($cc844053de03f4cb$exports(O, P)) return $2abcd2194b45431b$exports(!$97bce1c6dc77a53b$exports($60dbd2d73b8dc4a5$export$2d1720544b23b823, O, P), O[P]);
};


var $95f391e8d3de298b$require$getOwnPropertyDescriptor = $a1de5a78f57d3b17$export$2d1720544b23b823;

var $dadfa6c3f61baeea$exports = {};
"use strict";




$dadfa6c3f61baeea$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($fa64b91b5990a54e$exports(value)) $533e3f271af67a1e$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $9419ce30c21734c9$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $28aaf61ac32ff41d$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $8fa4dd9e478ac007$exports = {};
"use strict";

var $04f5b8e15b7d171d$exports = {};
"use strict";


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $00d6ee0ab5603b6c$export$2d1720544b23b823;
"use strict";


var $00d6ee0ab5603b6c$var$hiddenKeys = $2ab025accaef34b4$exports.concat("length", "prototype");
$00d6ee0ab5603b6c$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $eb556d91195b2704$exports(O, $00d6ee0ab5603b6c$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $a57dad57173d7c05$export$2d1720544b23b823;
"use strict";
$a57dad57173d7c05$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $04f5b8e15b7d171d$var$concat = $2098731ff14c1b28$exports([].concat);
// all object keys, includes non-enumerable and symbols
$04f5b8e15b7d171d$exports = $a86b7d926328b4a8$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $00d6ee0ab5603b6c$export$2d1720544b23b823($d8eb1c0d5fd2deb8$exports(it));
    var getOwnPropertySymbols = $a57dad57173d7c05$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $04f5b8e15b7d171d$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$8fa4dd9e478ac007$exports = function(target, source, exceptions) {
    var keys = $04f5b8e15b7d171d$exports(source);
    var defineProperty = $28aaf61ac32ff41d$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $a1de5a78f57d3b17$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$cc844053de03f4cb$exports(target, key) && !(exceptions && $cc844053de03f4cb$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $8eca8ab128546278$exports = {};
"use strict";


var $8eca8ab128546278$var$replacement = /#|\.prototype\./;
var $8eca8ab128546278$var$isForced = function(feature, detection) {
    var value = $8eca8ab128546278$var$data[$8eca8ab128546278$var$normalize(feature)];
    return value === $8eca8ab128546278$var$POLYFILL ? true : value === $8eca8ab128546278$var$NATIVE ? false : $fa64b91b5990a54e$exports(detection) ? $03967c5c58b0637b$exports(detection) : !!detection;
};
var $8eca8ab128546278$var$normalize = $8eca8ab128546278$var$isForced.normalize = function(string) {
    return String(string).replace($8eca8ab128546278$var$replacement, ".").toLowerCase();
};
var $8eca8ab128546278$var$data = $8eca8ab128546278$var$isForced.data = {};
var $8eca8ab128546278$var$NATIVE = $8eca8ab128546278$var$isForced.NATIVE = "N";
var $8eca8ab128546278$var$POLYFILL = $8eca8ab128546278$var$isForced.POLYFILL = "P";
$8eca8ab128546278$exports = $8eca8ab128546278$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $95f391e8d3de298b$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $6eaaaed532023352$exports;
    else if (STATIC) target = $6eaaaed532023352$exports[TARGET] || $9419ce30c21734c9$exports(TARGET, {});
    else target = ($6eaaaed532023352$exports[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $95f391e8d3de298b$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $8eca8ab128546278$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $8fa4dd9e478ac007$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $3927cb72a9744350$exports(sourceProperty, "sham", true);
        $dadfa6c3f61baeea$exports(target, key, sourceProperty, options);
    }
};


var $6e1bcf3cbc68d00e$exports = {};
"use strict";

var $6e1bcf3cbc68d00e$var$FunctionPrototype = Function.prototype;
var $6e1bcf3cbc68d00e$var$apply = $6e1bcf3cbc68d00e$var$FunctionPrototype.apply;
var $6e1bcf3cbc68d00e$var$call = $6e1bcf3cbc68d00e$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$6e1bcf3cbc68d00e$exports = typeof Reflect == "object" && Reflect.apply || ($18d9aeab60ea26ad$exports ? $6e1bcf3cbc68d00e$var$call.bind($6e1bcf3cbc68d00e$var$apply) : function() {
    return $6e1bcf3cbc68d00e$var$call.apply($6e1bcf3cbc68d00e$var$apply, arguments);
});


var $38602732df117c75$exports = {};
"use strict";
"use strict";
"use strict";
var $cd9b97bcefb67cac$exports = {};
"use strict";





var $6829c7fbfd89d4f2$exports = {};
"use strict";






var $6829c7fbfd89d4f2$require$defineProperty = $28aaf61ac32ff41d$export$2d1720544b23b823;

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $e7a097f6a8ed4cd9$export$2d1720544b23b823;
"use strict";



var $e7a097f6a8ed4cd9$require$$getOwnPropertyNames = $00d6ee0ab5603b6c$export$2d1720544b23b823;
var $c3aefe0455ed7ab6$exports = {};
"use strict";


var $a55d674529a59daa$exports = {};
"use strict";



$a55d674529a59daa$exports = function(object, key, value) {
    var propertyKey = $a026e48acb0f9691$exports(key);
    if (propertyKey in object) $28aaf61ac32ff41d$export$2d1720544b23b823(object, propertyKey, $2abcd2194b45431b$exports(0, value));
    else object[propertyKey] = value;
};


var $c3aefe0455ed7ab6$var$$Array = Array;
var $c3aefe0455ed7ab6$var$max = Math.max;
$c3aefe0455ed7ab6$exports = function(O, start, end) {
    var length = $3032eb0255f70567$exports(O);
    var k = $f60dcf685adc9c16$exports(start, length);
    var fin = $f60dcf685adc9c16$exports(end === undefined ? length : end, length);
    var result = $c3aefe0455ed7ab6$var$$Array($c3aefe0455ed7ab6$var$max(fin - k, 0));
    var n = 0;
    for(; k < fin; k++, n++)$a55d674529a59daa$exports(result, n, O[k]);
    result.length = n;
    return result;
};


var $e7a097f6a8ed4cd9$var$windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $e7a097f6a8ed4cd9$var$getWindowNames = function(it) {
    try {
        return $e7a097f6a8ed4cd9$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $c3aefe0455ed7ab6$exports($e7a097f6a8ed4cd9$var$windowNames);
    }
};
$e7a097f6a8ed4cd9$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $e7a097f6a8ed4cd9$var$windowNames && $6d25cd027215e59b$exports(it) === "Window" ? $e7a097f6a8ed4cd9$var$getWindowNames(it) : $e7a097f6a8ed4cd9$require$$getOwnPropertyNames($6532fb5f186833fb$exports(it));
};


var $d3fbbfeaca289f9d$exports = {};
"use strict";



var $fbab2bcaf727369b$exports = {};
"use strict";

$fbab2bcaf727369b$exports = $03967c5c58b0637b$exports(function() {
    if (typeof ArrayBuffer == "function") {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, "a", {
            value: 8
        });
    }
});


// eslint-disable-next-line es/no-object-isextensible -- safe
var $d3fbbfeaca289f9d$var$$isExtensible = Object.isExtensible;
var $d3fbbfeaca289f9d$var$FAILS_ON_PRIMITIVES = $03967c5c58b0637b$exports(function() {
    $d3fbbfeaca289f9d$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
$d3fbbfeaca289f9d$exports = $d3fbbfeaca289f9d$var$FAILS_ON_PRIMITIVES || $fbab2bcaf727369b$exports ? function isExtensible(it) {
    if (!$79b55cb30ab000ec$exports(it)) return false;
    if ($fbab2bcaf727369b$exports && $6d25cd027215e59b$exports(it) === "ArrayBuffer") return false;
    return $d3fbbfeaca289f9d$var$$isExtensible ? $d3fbbfeaca289f9d$var$$isExtensible(it) : true;
} : $d3fbbfeaca289f9d$var$$isExtensible;



var $ca6c4312b29ad26f$exports = {};
"use strict";

$ca6c4312b29ad26f$exports = !$03967c5c58b0637b$exports(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});


var $6829c7fbfd89d4f2$var$REQUIRED = false;
var $6829c7fbfd89d4f2$var$METADATA = $eccb9536514100e8$exports("meta");
var $6829c7fbfd89d4f2$var$id = 0;
var $6829c7fbfd89d4f2$var$setMetadata = function(it) {
    $6829c7fbfd89d4f2$require$defineProperty(it, $6829c7fbfd89d4f2$var$METADATA, {
        value: {
            objectID: "O" + $6829c7fbfd89d4f2$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $6829c7fbfd89d4f2$var$fastKey = function(it, create) {
    // return a primitive with prefix
    if (!$79b55cb30ab000ec$exports(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!$cc844053de03f4cb$exports(it, $6829c7fbfd89d4f2$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$d3fbbfeaca289f9d$exports(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        $6829c7fbfd89d4f2$var$setMetadata(it);
    // return object ID
    }
    return it[$6829c7fbfd89d4f2$var$METADATA].objectID;
};
var $6829c7fbfd89d4f2$var$getWeakData = function(it, create) {
    if (!$cc844053de03f4cb$exports(it, $6829c7fbfd89d4f2$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$d3fbbfeaca289f9d$exports(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $6829c7fbfd89d4f2$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$6829c7fbfd89d4f2$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $6829c7fbfd89d4f2$var$onFreeze = function(it) {
    if ($ca6c4312b29ad26f$exports && $6829c7fbfd89d4f2$var$REQUIRED && $d3fbbfeaca289f9d$exports(it) && !$cc844053de03f4cb$exports(it, $6829c7fbfd89d4f2$var$METADATA)) $6829c7fbfd89d4f2$var$setMetadata(it);
    return it;
};
var $6829c7fbfd89d4f2$var$enable = function() {
    $6829c7fbfd89d4f2$var$meta.enable = function() {};
    $6829c7fbfd89d4f2$var$REQUIRED = true;
    var getOwnPropertyNames = $00d6ee0ab5603b6c$export$2d1720544b23b823;
    var splice = $2098731ff14c1b28$exports([].splice);
    var test = {};
    test[$6829c7fbfd89d4f2$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $00d6ee0ab5603b6c$export$2d1720544b23b823 = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $6829c7fbfd89d4f2$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $95f391e8d3de298b$exports({
            target: "Object",
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $e7a097f6a8ed4cd9$export$2d1720544b23b823
        });
    }
};
var $6829c7fbfd89d4f2$var$meta = $6829c7fbfd89d4f2$exports = {
    enable: $6829c7fbfd89d4f2$var$enable,
    fastKey: $6829c7fbfd89d4f2$var$fastKey,
    getWeakData: $6829c7fbfd89d4f2$var$getWeakData,
    onFreeze: $6829c7fbfd89d4f2$var$onFreeze
};
$5f6c4e9e26626326$exports[$6829c7fbfd89d4f2$var$METADATA] = true;


var $b3f339154d5ed3ac$exports = {};
"use strict";
var $b4fa206c62a6dcdd$exports = {};
"use strict";
var $45cf0144d669549b$exports = {};
"use strict";


$45cf0144d669549b$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($6d25cd027215e59b$exports(fn) === "Function") return $2098731ff14c1b28$exports(fn);
};




var $b4fa206c62a6dcdd$var$bind = $45cf0144d669549b$exports($45cf0144d669549b$exports.bind);
// optional / simple context binding
$b4fa206c62a6dcdd$exports = function(fn, that) {
    $b036d6e8e8a1e730$exports(fn);
    return that === undefined ? fn : $18d9aeab60ea26ad$exports ? $b4fa206c62a6dcdd$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $04be2b77cd233c0b$exports = {};
"use strict";

var $f50f2c649b76428d$exports = {};
"use strict";
$f50f2c649b76428d$exports = {};


var $04be2b77cd233c0b$var$ITERATOR = $cb598f706b77edff$exports("iterator");
var $04be2b77cd233c0b$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$04be2b77cd233c0b$exports = function(it) {
    return it !== undefined && ($f50f2c649b76428d$exports.Array === it || $04be2b77cd233c0b$var$ArrayPrototype[$04be2b77cd233c0b$var$ITERATOR] === it);
};




var $620af53cd726e10d$exports = {};
"use strict";




var $98285677a43c0830$exports = {};
"use strict";
var $57a4f5441e1bbe20$exports = {};
"use strict";
var $d47f0ac88e2fd2a7$exports = {};
"use strict";

var $d47f0ac88e2fd2a7$var$TO_STRING_TAG = $cb598f706b77edff$exports("toStringTag");
var $d47f0ac88e2fd2a7$var$test = {};
$d47f0ac88e2fd2a7$var$test[$d47f0ac88e2fd2a7$var$TO_STRING_TAG] = "z";
$d47f0ac88e2fd2a7$exports = String($d47f0ac88e2fd2a7$var$test) === "[object z]";





var $57a4f5441e1bbe20$var$TO_STRING_TAG = $cb598f706b77edff$exports("toStringTag");
var $57a4f5441e1bbe20$var$$Object = Object;
// ES3 wrong here
var $57a4f5441e1bbe20$var$CORRECT_ARGUMENTS = $6d25cd027215e59b$exports(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var $57a4f5441e1bbe20$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$57a4f5441e1bbe20$exports = $d47f0ac88e2fd2a7$exports ? $6d25cd027215e59b$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $57a4f5441e1bbe20$var$tryGet(O = $57a4f5441e1bbe20$var$$Object(it), $57a4f5441e1bbe20$var$TO_STRING_TAG)) == "string" ? tag : $57a4f5441e1bbe20$var$CORRECT_ARGUMENTS ? $6d25cd027215e59b$exports(O) : (result = $6d25cd027215e59b$exports(O)) === "Object" && $fa64b91b5990a54e$exports(O.callee) ? "Arguments" : result;
};






var $98285677a43c0830$var$ITERATOR = $cb598f706b77edff$exports("iterator");
$98285677a43c0830$exports = function(it) {
    if (!$0948cee6bccbdbb6$exports(it)) return $a313ad37d47c05ba$exports(it, $98285677a43c0830$var$ITERATOR) || $a313ad37d47c05ba$exports(it, "@@iterator") || $f50f2c649b76428d$exports[$57a4f5441e1bbe20$exports(it)];
};


var $620af53cd726e10d$var$$TypeError = TypeError;
$620af53cd726e10d$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $98285677a43c0830$exports(argument) : usingIterator;
    if ($b036d6e8e8a1e730$exports(iteratorMethod)) return $d8eb1c0d5fd2deb8$exports($97bce1c6dc77a53b$exports(iteratorMethod, argument));
    throw new $620af53cd726e10d$var$$TypeError($89fbca0f38ee4901$exports(argument) + " is not iterable");
};



var $950ee1b8659bce7b$exports = {};
"use strict";



$950ee1b8659bce7b$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $d8eb1c0d5fd2deb8$exports(iterator);
    try {
        innerResult = $a313ad37d47c05ba$exports(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $97bce1c6dc77a53b$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $d8eb1c0d5fd2deb8$exports(innerResult);
    return value;
};


var $b3f339154d5ed3ac$var$$TypeError = TypeError;
var $b3f339154d5ed3ac$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $b3f339154d5ed3ac$var$ResultPrototype = $b3f339154d5ed3ac$var$Result.prototype;
$b3f339154d5ed3ac$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $b4fa206c62a6dcdd$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $950ee1b8659bce7b$exports(iterator, "normal", condition);
        return new $b3f339154d5ed3ac$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $d8eb1c0d5fd2deb8$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $98285677a43c0830$exports(iterable);
        if (!iterFn) throw new $b3f339154d5ed3ac$var$$TypeError($89fbca0f38ee4901$exports(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($04be2b77cd233c0b$exports(iterFn)) {
            for(index = 0, length = $3032eb0255f70567$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $8ea9bc2a79eb2dd1$exports($b3f339154d5ed3ac$var$ResultPrototype, result)) return result;
            }
            return new $b3f339154d5ed3ac$var$Result(false);
        }
        iterator = $620af53cd726e10d$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $97bce1c6dc77a53b$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $950ee1b8659bce7b$exports(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $8ea9bc2a79eb2dd1$exports($b3f339154d5ed3ac$var$ResultPrototype, result)) return result;
    }
    return new $b3f339154d5ed3ac$var$Result(false);
};


var $847a5ea3931ac091$exports = {};
"use strict";

var $847a5ea3931ac091$var$$TypeError = TypeError;
$847a5ea3931ac091$exports = function(it, Prototype) {
    if ($8ea9bc2a79eb2dd1$exports(Prototype, it)) return it;
    throw new $847a5ea3931ac091$var$$TypeError("Incorrect invocation");
};






var $25b4d877de737efe$exports = {};
"use strict";

var $25b4d877de737efe$var$ITERATOR = $cb598f706b77edff$exports("iterator");
var $25b4d877de737efe$var$SAFE_CLOSING = false;
try {
    var $25b4d877de737efe$var$called = 0;
    var $25b4d877de737efe$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$25b4d877de737efe$var$called++
            };
        },
        "return": function() {
            $25b4d877de737efe$var$SAFE_CLOSING = true;
        }
    };
    $25b4d877de737efe$var$iteratorWithReturn[$25b4d877de737efe$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($25b4d877de737efe$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$25b4d877de737efe$exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$25b4d877de737efe$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$25b4d877de737efe$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};


var $26e0139d004fb028$exports = {};
"use strict";

var $26e0139d004fb028$require$defineProperty = $28aaf61ac32ff41d$export$2d1720544b23b823;


var $26e0139d004fb028$var$TO_STRING_TAG = $cb598f706b77edff$exports("toStringTag");
$26e0139d004fb028$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$cc844053de03f4cb$exports(target, $26e0139d004fb028$var$TO_STRING_TAG)) $26e0139d004fb028$require$defineProperty(target, $26e0139d004fb028$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};


var $db29dd9861f444f0$exports = {};
"use strict";


var $18e9dd0d52d1e060$exports = {};
"use strict";
var $343410f26483b7ff$exports = {};
"use strict";


$343410f26483b7ff$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $2098731ff14c1b28$exports($b036d6e8e8a1e730$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};



var $9e69459ffc1187eb$exports = {};
"use strict";

var $9e69459ffc1187eb$var$$String = String;
var $9e69459ffc1187eb$var$$TypeError = TypeError;
$9e69459ffc1187eb$exports = function(argument) {
    if (typeof argument == "object" || $fa64b91b5990a54e$exports(argument)) return argument;
    throw new $9e69459ffc1187eb$var$$TypeError("Can't set " + $9e69459ffc1187eb$var$$String(argument) + " as a prototype");
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$18e9dd0d52d1e060$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $343410f26483b7ff$exports(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $d8eb1c0d5fd2deb8$exports(O);
        $9e69459ffc1187eb$exports(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);


// makes subclassing work correct for wrapped built-ins
$db29dd9861f444f0$exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    $18e9dd0d52d1e060$exports && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    $fa64b91b5990a54e$exports(NewTarget = dummy.constructor) && NewTarget !== Wrapper && $79b55cb30ab000ec$exports(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) $18e9dd0d52d1e060$exports($this, NewTargetPrototype);
    return $this;
};


$cd9b97bcefb67cac$exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
    var ADDER = IS_MAP ? "set" : "add";
    var NativeConstructor = $6eaaaed532023352$exports[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function(KEY) {
        var uncurriedNativeMethod = $2098731ff14c1b28$exports(NativePrototype[KEY]);
        $dadfa6c3f61baeea$exports(NativePrototype, KEY, KEY === "add" ? function add(value) {
            uncurriedNativeMethod(this, value === 0 ? 0 : value);
            return this;
        } : KEY === "delete" ? function(key) {
            return IS_WEAK && !$79b55cb30ab000ec$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === "get" ? function get(key) {
            return IS_WEAK && !$79b55cb30ab000ec$exports(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === "has" ? function has(key) {
            return IS_WEAK && !$79b55cb30ab000ec$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    var REPLACE = $8eca8ab128546278$exports(CONSTRUCTOR_NAME, !$fa64b91b5990a54e$exports(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$03967c5c58b0637b$exports(function() {
        new NativeConstructor().entries().next();
    })));
    if (REPLACE) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $6829c7fbfd89d4f2$exports.enable();
    } else if ($8eca8ab128546278$exports(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $03967c5c58b0637b$exports(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new -- required for testing
        var ACCEPT_ITERABLES = $25b4d877de737efe$exports(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $03967c5c58b0637b$exports(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                $847a5ea3931ac091$exports(dummy, NativePrototype);
                var that = $db29dd9861f444f0$exports(new NativeConstructor(), dummy, Constructor);
                if (!$0948cee6bccbdbb6$exports(iterable)) $b3f339154d5ed3ac$exports(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod("delete");
            fixMethod("has");
            IS_MAP && fixMethod("get");
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $95f391e8d3de298b$exports({
        global: true,
        constructor: true,
        forced: Constructor !== NativeConstructor
    }, exported);
    $26e0139d004fb028$exports(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};


var $17f861defa709f47$exports = {};
"use strict";


var $b2eaa13f327d4d54$exports = {};
"use strict";

$b2eaa13f327d4d54$exports = function(target, src, options) {
    for(var key in src)$dadfa6c3f61baeea$exports(target, key, src[key], options);
    return target;
};






var $3a0eb43773faf92c$exports = {};
"use strict";





var $2763c7c7e2bb8835$exports = {};
"use strict";
var $82dcf1c649b28ef8$exports = {};
"use strict";




var $f973d2f7bb2b70b9$exports = {};
"use strict";




var $a2a1e2dc04e0a20c$exports = {};
"use strict";

$a2a1e2dc04e0a20c$exports = !$03967c5c58b0637b$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $f973d2f7bb2b70b9$var$IE_PROTO = $c1fb8cbb3737e99f$exports("IE_PROTO");
var $f973d2f7bb2b70b9$var$$Object = Object;
var $f973d2f7bb2b70b9$var$ObjectPrototype = $f973d2f7bb2b70b9$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$f973d2f7bb2b70b9$exports = $a2a1e2dc04e0a20c$exports ? $f973d2f7bb2b70b9$var$$Object.getPrototypeOf : function(O) {
    var object = $c935e8e6600f2e7c$exports(O);
    if ($cc844053de03f4cb$exports(object, $f973d2f7bb2b70b9$var$IE_PROTO)) return object[$f973d2f7bb2b70b9$var$IE_PROTO];
    var constructor = object.constructor;
    if ($fa64b91b5990a54e$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $f973d2f7bb2b70b9$var$$Object ? $f973d2f7bb2b70b9$var$ObjectPrototype : null;
};





var $82dcf1c649b28ef8$var$ITERATOR = $cb598f706b77edff$exports("iterator");
var $82dcf1c649b28ef8$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $82dcf1c649b28ef8$var$IteratorPrototype, $82dcf1c649b28ef8$var$PrototypeOfArrayIteratorPrototype, $82dcf1c649b28ef8$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $82dcf1c649b28ef8$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $82dcf1c649b28ef8$var$arrayIterator)) $82dcf1c649b28ef8$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $82dcf1c649b28ef8$var$PrototypeOfArrayIteratorPrototype = $f973d2f7bb2b70b9$exports($f973d2f7bb2b70b9$exports($82dcf1c649b28ef8$var$arrayIterator));
        if ($82dcf1c649b28ef8$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $82dcf1c649b28ef8$var$IteratorPrototype = $82dcf1c649b28ef8$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $82dcf1c649b28ef8$var$NEW_ITERATOR_PROTOTYPE = !$79b55cb30ab000ec$exports($82dcf1c649b28ef8$var$IteratorPrototype) || $03967c5c58b0637b$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $82dcf1c649b28ef8$var$IteratorPrototype[$82dcf1c649b28ef8$var$ITERATOR].call(test) !== test;
});
if ($82dcf1c649b28ef8$var$NEW_ITERATOR_PROTOTYPE) $82dcf1c649b28ef8$var$IteratorPrototype = {};
else if ($0f1181f19eff16c7$exports) $82dcf1c649b28ef8$var$IteratorPrototype = $b77147d4c97a1d55$exports($82dcf1c649b28ef8$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$fa64b91b5990a54e$exports($82dcf1c649b28ef8$var$IteratorPrototype[$82dcf1c649b28ef8$var$ITERATOR])) $dadfa6c3f61baeea$exports($82dcf1c649b28ef8$var$IteratorPrototype, $82dcf1c649b28ef8$var$ITERATOR, function() {
    return this;
});
$82dcf1c649b28ef8$exports = {
    IteratorPrototype: $82dcf1c649b28ef8$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $82dcf1c649b28ef8$var$BUGGY_SAFARI_ITERATORS
};


var $2763c7c7e2bb8835$require$IteratorPrototype = $82dcf1c649b28ef8$exports.IteratorPrototype;




var $2763c7c7e2bb8835$var$returnThis = function() {
    return this;
};
$2763c7c7e2bb8835$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $b77147d4c97a1d55$exports($2763c7c7e2bb8835$require$IteratorPrototype, {
        next: $2abcd2194b45431b$exports(+!ENUMERABLE_NEXT, next)
    });
    $26e0139d004fb028$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $f50f2c649b76428d$exports[TO_STRING_TAG] = $2763c7c7e2bb8835$var$returnThis;
    return IteratorConstructor;
};










var $3a0eb43773faf92c$var$PROPER_FUNCTION_NAME = $c29db39a85a3af77$exports.PROPER;
var $3a0eb43773faf92c$var$CONFIGURABLE_FUNCTION_NAME = $c29db39a85a3af77$exports.CONFIGURABLE;
var $3a0eb43773faf92c$var$IteratorPrototype = $82dcf1c649b28ef8$exports.IteratorPrototype;
var $3a0eb43773faf92c$var$BUGGY_SAFARI_ITERATORS = $82dcf1c649b28ef8$exports.BUGGY_SAFARI_ITERATORS;
var $3a0eb43773faf92c$var$ITERATOR = $cb598f706b77edff$exports("iterator");
var $3a0eb43773faf92c$var$KEYS = "keys";
var $3a0eb43773faf92c$var$VALUES = "values";
var $3a0eb43773faf92c$var$ENTRIES = "entries";
var $3a0eb43773faf92c$var$returnThis = function() {
    return this;
};
$3a0eb43773faf92c$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $2763c7c7e2bb8835$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$3a0eb43773faf92c$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $3a0eb43773faf92c$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $3a0eb43773faf92c$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $3a0eb43773faf92c$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$3a0eb43773faf92c$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$3a0eb43773faf92c$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $f973d2f7bb2b70b9$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$0f1181f19eff16c7$exports && $f973d2f7bb2b70b9$exports(CurrentIteratorPrototype) !== $3a0eb43773faf92c$var$IteratorPrototype) {
                if ($18e9dd0d52d1e060$exports) $18e9dd0d52d1e060$exports(CurrentIteratorPrototype, $3a0eb43773faf92c$var$IteratorPrototype);
                else if (!$fa64b91b5990a54e$exports(CurrentIteratorPrototype[$3a0eb43773faf92c$var$ITERATOR])) $dadfa6c3f61baeea$exports(CurrentIteratorPrototype, $3a0eb43773faf92c$var$ITERATOR, $3a0eb43773faf92c$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $26e0139d004fb028$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($0f1181f19eff16c7$exports) $f50f2c649b76428d$exports[TO_STRING_TAG] = $3a0eb43773faf92c$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($3a0eb43773faf92c$var$PROPER_FUNCTION_NAME && DEFAULT === $3a0eb43773faf92c$var$VALUES && nativeIterator && nativeIterator.name !== $3a0eb43773faf92c$var$VALUES) {
        if (!$0f1181f19eff16c7$exports && $3a0eb43773faf92c$var$CONFIGURABLE_FUNCTION_NAME) $3927cb72a9744350$exports(IterablePrototype, "name", $3a0eb43773faf92c$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $97bce1c6dc77a53b$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($3a0eb43773faf92c$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($3a0eb43773faf92c$var$KEYS),
            entries: getIterationMethod($3a0eb43773faf92c$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($3a0eb43773faf92c$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $dadfa6c3f61baeea$exports(IterablePrototype, KEY, methods[KEY]);
        } else $95f391e8d3de298b$exports({
            target: NAME,
            proto: true,
            forced: $3a0eb43773faf92c$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$0f1181f19eff16c7$exports || FORCED) && IterablePrototype[$3a0eb43773faf92c$var$ITERATOR] !== defaultIterator) $dadfa6c3f61baeea$exports(IterablePrototype, $3a0eb43773faf92c$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $f50f2c649b76428d$exports[NAME] = defaultIterator;
    return methods;
};


var $26563010b7960a80$exports = {};
"use strict";
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$26563010b7960a80$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};


var $41081d30d2b52804$exports = {};
"use strict";




var $41081d30d2b52804$var$SPECIES = $cb598f706b77edff$exports("species");
$41081d30d2b52804$exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $a86b7d926328b4a8$exports(CONSTRUCTOR_NAME);
    if ($4dea53c988ff8146$exports && Constructor && !Constructor[$41081d30d2b52804$var$SPECIES]) $c63f92c1035948fe$exports(Constructor, $41081d30d2b52804$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};




var $17f861defa709f47$require$fastKey = $6829c7fbfd89d4f2$exports.fastKey;

var $17f861defa709f47$var$setInternalState = $9e1e01125ce84891$exports.set;
var $17f861defa709f47$var$internalStateGetterFor = $9e1e01125ce84891$exports.getterFor;
$17f861defa709f47$exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $847a5ea3931ac091$exports(that, Prototype);
            $17f861defa709f47$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                index: $b77147d4c97a1d55$exports(null),
                first: undefined,
                last: undefined,
                size: 0
            });
            if (!$4dea53c988ff8146$exports) that.size = 0;
            if (!$0948cee6bccbdbb6$exports(iterable)) $b3f339154d5ed3ac$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $17f861defa709f47$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var entry = getEntry(that, key);
            var previous, index;
            // change existing entry
            if (entry) entry.value = value;
            else {
                state.last = entry = {
                    index: index = $17f861defa709f47$require$fastKey(key, true),
                    key: key,
                    value: value,
                    previous: previous = state.last,
                    next: undefined,
                    removed: false
                };
                if (!state.first) state.first = entry;
                if (previous) previous.next = entry;
                if ($4dea53c988ff8146$exports) state.size++;
                else that.size++;
                // add to index
                if (index !== "F") state.index[index] = entry;
            }
            return that;
        };
        var getEntry = function(that, key) {
            var state = getInternalState(that);
            // fast case
            var index = $17f861defa709f47$require$fastKey(key);
            var entry;
            if (index !== "F") return state.index[index];
            // frozen object case
            for(entry = state.first; entry; entry = entry.next){
                if (entry.key === key) return entry;
            }
        };
        $b2eaa13f327d4d54$exports(Prototype, {
            // `{ Map, Set }.prototype.clear()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.clear
            // https://tc39.es/ecma262/#sec-set.prototype.clear
            clear: function clear() {
                var that = this;
                var state = getInternalState(that);
                var data = state.index;
                var entry = state.first;
                while(entry){
                    entry.removed = true;
                    if (entry.previous) entry.previous = entry.previous.next = undefined;
                    delete data[entry.index];
                    entry = entry.next;
                }
                state.first = state.last = undefined;
                if ($4dea53c988ff8146$exports) state.size = 0;
                else that.size = 0;
            },
            // `{ Map, Set }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.delete
            // https://tc39.es/ecma262/#sec-set.prototype.delete
            "delete": function(key) {
                var that = this;
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                if (entry) {
                    var next = entry.next;
                    var prev = entry.previous;
                    delete state.index[entry.index];
                    entry.removed = true;
                    if (prev) prev.next = next;
                    if (next) next.previous = prev;
                    if (state.first === entry) state.first = next;
                    if (state.last === entry) state.last = prev;
                    if ($4dea53c988ff8146$exports) state.size--;
                    else that.size--;
                }
                return !!entry;
            },
            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.foreach
            // https://tc39.es/ecma262/#sec-set.prototype.foreach
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                var state = getInternalState(this);
                var boundFunction = $b4fa206c62a6dcdd$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                var entry;
                while(entry = entry ? entry.next : state.first){
                    boundFunction(entry.value, entry.key, this);
                    // revert to the last existing entry
                    while(entry && entry.removed)entry = entry.previous;
                }
            },
            // `{ Map, Set}.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.has
            // https://tc39.es/ecma262/#sec-set.prototype.has
            has: function has(key) {
                return !!getEntry(this, key);
            }
        });
        $b2eaa13f327d4d54$exports(Prototype, IS_MAP ? {
            // `Map.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-map.prototype.get
            get: function get(key) {
                var entry = getEntry(this, key);
                return entry && entry.value;
            },
            // `Map.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-map.prototype.set
            set: function set(key, value) {
                return define(this, key === 0 ? 0 : key, value);
            }
        } : {
            // `Set.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-set.prototype.add
            add: function add(value) {
                return define(this, value = value === 0 ? 0 : value, value);
            }
        });
        if ($4dea53c988ff8146$exports) $c63f92c1035948fe$exports(Prototype, "size", {
            configurable: true,
            get: function() {
                return getInternalState(this).size;
            }
        });
        return Constructor;
    },
    setStrong: function(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
        var ITERATOR_NAME = CONSTRUCTOR_NAME + " Iterator";
        var getInternalCollectionState = $17f861defa709f47$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var getInternalIteratorState = $17f861defa709f47$var$internalStateGetterFor(ITERATOR_NAME);
        // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
        // https://tc39.es/ecma262/#sec-map.prototype.entries
        // https://tc39.es/ecma262/#sec-map.prototype.keys
        // https://tc39.es/ecma262/#sec-map.prototype.values
        // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
        // https://tc39.es/ecma262/#sec-set.prototype.entries
        // https://tc39.es/ecma262/#sec-set.prototype.keys
        // https://tc39.es/ecma262/#sec-set.prototype.values
        // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
        $3a0eb43773faf92c$exports(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
            $17f861defa709f47$var$setInternalState(this, {
                type: ITERATOR_NAME,
                target: iterated,
                state: getInternalCollectionState(iterated),
                kind: kind,
                last: undefined
            });
        }, function() {
            var state = getInternalIteratorState(this);
            var kind = state.kind;
            var entry = state.last;
            // revert to the last existing entry
            while(entry && entry.removed)entry = entry.previous;
            // get next entry
            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                // or finish the iteration
                state.target = undefined;
                return $26563010b7960a80$exports(undefined, true);
            }
            // return step by kind
            if (kind === "keys") return $26563010b7960a80$exports(entry.key, false);
            if (kind === "values") return $26563010b7960a80$exports(entry.value, false);
            return $26563010b7960a80$exports([
                entry.key,
                entry.value
            ], false);
        }, IS_MAP ? "entries" : "values", !IS_MAP, true);
        // `{ Map, Set }.prototype[@@species]` accessors
        // https://tc39.es/ecma262/#sec-get-map-@@species
        // https://tc39.es/ecma262/#sec-get-set-@@species
        $41081d30d2b52804$exports(CONSTRUCTOR_NAME);
    }
};


// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
$cd9b97bcefb67cac$exports("Map", function(init) {
    return function Map() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $17f861defa709f47$exports);




"use strict";
"use strict";






var $ae96090e6522dcce$exports = {};
"use strict";



var $ae96090e6522dcce$require$getWeakData = $6829c7fbfd89d4f2$exports.getWeakData;





var $f793d099fb5cae51$exports = {};
"use strict";





var $fe87e738cda9fbe8$exports = {};
"use strict";
var $b92790cd4c8279e0$exports = {};
"use strict";
var $2c70361c54527a3c$exports = {};
"use strict";

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
$2c70361c54527a3c$exports = Array.isArray || function isArray(argument) {
    return $6d25cd027215e59b$exports(argument) === "Array";
};


var $c4cbaf47a62f8816$exports = {};
"use strict";






var $c4cbaf47a62f8816$var$noop = function() {};
var $c4cbaf47a62f8816$var$empty = [];
var $c4cbaf47a62f8816$var$construct = $a86b7d926328b4a8$exports("Reflect", "construct");
var $c4cbaf47a62f8816$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $c4cbaf47a62f8816$var$exec = $2098731ff14c1b28$exports($c4cbaf47a62f8816$var$constructorRegExp.exec);
var $c4cbaf47a62f8816$var$INCORRECT_TO_STRING = !$c4cbaf47a62f8816$var$constructorRegExp.test($c4cbaf47a62f8816$var$noop);
var $c4cbaf47a62f8816$var$isConstructorModern = function isConstructor(argument) {
    if (!$fa64b91b5990a54e$exports(argument)) return false;
    try {
        $c4cbaf47a62f8816$var$construct($c4cbaf47a62f8816$var$noop, $c4cbaf47a62f8816$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $c4cbaf47a62f8816$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$fa64b91b5990a54e$exports(argument)) return false;
    switch($57a4f5441e1bbe20$exports(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $c4cbaf47a62f8816$var$INCORRECT_TO_STRING || !!$c4cbaf47a62f8816$var$exec($c4cbaf47a62f8816$var$constructorRegExp, $3c54076c781f9072$exports(argument));
    } catch (error) {
        return true;
    }
};
$c4cbaf47a62f8816$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$c4cbaf47a62f8816$exports = !$c4cbaf47a62f8816$var$construct || $03967c5c58b0637b$exports(function() {
    var called;
    return $c4cbaf47a62f8816$var$isConstructorModern($c4cbaf47a62f8816$var$isConstructorModern.call) || !$c4cbaf47a62f8816$var$isConstructorModern(Object) || !$c4cbaf47a62f8816$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $c4cbaf47a62f8816$var$isConstructorLegacy : $c4cbaf47a62f8816$var$isConstructorModern;




var $b92790cd4c8279e0$var$SPECIES = $cb598f706b77edff$exports("species");
var $b92790cd4c8279e0$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$b92790cd4c8279e0$exports = function(originalArray) {
    var C;
    if ($2c70361c54527a3c$exports(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($c4cbaf47a62f8816$exports(C) && (C === $b92790cd4c8279e0$var$$Array || $2c70361c54527a3c$exports(C.prototype))) C = undefined;
        else if ($79b55cb30ab000ec$exports(C)) {
            C = C[$b92790cd4c8279e0$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $b92790cd4c8279e0$var$$Array : C;
};


// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$fe87e738cda9fbe8$exports = function(originalArray, length) {
    return new ($b92790cd4c8279e0$exports(originalArray))(length === 0 ? 0 : length);
};


var $f793d099fb5cae51$var$push = $2098731ff14c1b28$exports([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $f793d099fb5cae51$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $c935e8e6600f2e7c$exports($this);
        var self = $4e0cffadaedf9f6b$exports(O);
        var length = $3032eb0255f70567$exports(self);
        var boundFunction = $b4fa206c62a6dcdd$exports(callbackfn, that);
        var index = 0;
        var create = specificCreate || $fe87e738cda9fbe8$exports;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $f793d099fb5cae51$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $f793d099fb5cae51$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
$f793d099fb5cae51$exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $f793d099fb5cae51$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $f793d099fb5cae51$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $f793d099fb5cae51$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $f793d099fb5cae51$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $f793d099fb5cae51$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $f793d099fb5cae51$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $f793d099fb5cae51$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $f793d099fb5cae51$var$createMethod(7)
};




var $ae96090e6522dcce$var$setInternalState = $9e1e01125ce84891$exports.set;
var $ae96090e6522dcce$var$internalStateGetterFor = $9e1e01125ce84891$exports.getterFor;
var $ae96090e6522dcce$var$find = $f793d099fb5cae51$exports.find;
var $ae96090e6522dcce$var$findIndex = $f793d099fb5cae51$exports.findIndex;
var $ae96090e6522dcce$var$splice = $2098731ff14c1b28$exports([].splice);
var $ae96090e6522dcce$var$id = 0;
// fallback for uncaught frozen keys
var $ae96090e6522dcce$var$uncaughtFrozenStore = function(state) {
    return state.frozen || (state.frozen = new $ae96090e6522dcce$var$UncaughtFrozenStore());
};
var $ae96090e6522dcce$var$UncaughtFrozenStore = function() {
    this.entries = [];
};
var $ae96090e6522dcce$var$findUncaughtFrozen = function(store, key) {
    return $ae96090e6522dcce$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$ae96090e6522dcce$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $ae96090e6522dcce$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$ae96090e6522dcce$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $ae96090e6522dcce$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    "delete": function(key) {
        var index = $ae96090e6522dcce$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $ae96090e6522dcce$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
$ae96090e6522dcce$exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $847a5ea3931ac091$exports(that, Prototype);
            $ae96090e6522dcce$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $ae96090e6522dcce$var$id++,
                frozen: undefined
            });
            if (!$0948cee6bccbdbb6$exports(iterable)) $b3f339154d5ed3ac$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $ae96090e6522dcce$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var data = $ae96090e6522dcce$require$getWeakData($d8eb1c0d5fd2deb8$exports(key), true);
            if (data === true) $ae96090e6522dcce$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $b2eaa13f327d4d54$exports(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            "delete": function(key) {
                var state = getInternalState(this);
                if (!$79b55cb30ab000ec$exports(key)) return false;
                var data = $ae96090e6522dcce$require$getWeakData(key);
                if (data === true) return $ae96090e6522dcce$var$uncaughtFrozenStore(state)["delete"](key);
                return data && $cc844053de03f4cb$exports(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$79b55cb30ab000ec$exports(key)) return false;
                var data = $ae96090e6522dcce$require$getWeakData(key);
                if (data === true) return $ae96090e6522dcce$var$uncaughtFrozenStore(state).has(key);
                return data && $cc844053de03f4cb$exports(data, state.id);
            }
        });
        $b2eaa13f327d4d54$exports(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($79b55cb30ab000ec$exports(key)) {
                    var data = $ae96090e6522dcce$require$getWeakData(key);
                    if (data === true) return $ae96090e6522dcce$var$uncaughtFrozenStore(state).get(key);
                    return data ? data[state.id] : undefined;
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};




var $d247c0d8b77d5cd9$require$enforceInternalState = $9e1e01125ce84891$exports.enforce;


var $d247c0d8b77d5cd9$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $d247c0d8b77d5cd9$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $d247c0d8b77d5cd9$var$isExtensible = $d247c0d8b77d5cd9$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $d247c0d8b77d5cd9$var$isFrozen = $d247c0d8b77d5cd9$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $d247c0d8b77d5cd9$var$isSealed = $d247c0d8b77d5cd9$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $d247c0d8b77d5cd9$var$freeze = $d247c0d8b77d5cd9$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $d247c0d8b77d5cd9$var$seal = $d247c0d8b77d5cd9$var$$Object.seal;
var $d247c0d8b77d5cd9$var$FROZEN = {};
var $d247c0d8b77d5cd9$var$SEALED = {};
var $d247c0d8b77d5cd9$var$IS_IE11 = !$6eaaaed532023352$exports.ActiveXObject && "ActiveXObject" in $6eaaaed532023352$exports;
var $d247c0d8b77d5cd9$var$InternalWeakMap;
var $d247c0d8b77d5cd9$var$wrapper = function(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $d247c0d8b77d5cd9$var$$WeakMap = $cd9b97bcefb67cac$exports("WeakMap", $d247c0d8b77d5cd9$var$wrapper, $ae96090e6522dcce$exports);
var $d247c0d8b77d5cd9$var$WeakMapPrototype = $d247c0d8b77d5cd9$var$$WeakMap.prototype;
var $d247c0d8b77d5cd9$var$nativeSet = $2098731ff14c1b28$exports($d247c0d8b77d5cd9$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $d247c0d8b77d5cd9$var$hasMSEdgeFreezingBug = function() {
    return $ca6c4312b29ad26f$exports && $03967c5c58b0637b$exports(function() {
        var frozenArray = $d247c0d8b77d5cd9$var$freeze([]);
        $d247c0d8b77d5cd9$var$nativeSet(new $d247c0d8b77d5cd9$var$$WeakMap(), frozenArray, 1);
        return !$d247c0d8b77d5cd9$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($ac802f0b591b1f5a$exports) {
    if ($d247c0d8b77d5cd9$var$IS_IE11) {
        $d247c0d8b77d5cd9$var$InternalWeakMap = $ae96090e6522dcce$exports.getConstructor($d247c0d8b77d5cd9$var$wrapper, "WeakMap", true);
        $6829c7fbfd89d4f2$exports.enable();
        var $d247c0d8b77d5cd9$var$nativeDelete = $2098731ff14c1b28$exports($d247c0d8b77d5cd9$var$WeakMapPrototype["delete"]);
        var $d247c0d8b77d5cd9$var$nativeHas = $2098731ff14c1b28$exports($d247c0d8b77d5cd9$var$WeakMapPrototype.has);
        var $d247c0d8b77d5cd9$var$nativeGet = $2098731ff14c1b28$exports($d247c0d8b77d5cd9$var$WeakMapPrototype.get);
        $b2eaa13f327d4d54$exports($d247c0d8b77d5cd9$var$WeakMapPrototype, {
            "delete": function(key) {
                if ($79b55cb30ab000ec$exports(key) && !$d247c0d8b77d5cd9$var$isExtensible(key)) {
                    var state = $d247c0d8b77d5cd9$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $d247c0d8b77d5cd9$var$InternalWeakMap();
                    return $d247c0d8b77d5cd9$var$nativeDelete(this, key) || state.frozen["delete"](key);
                }
                return $d247c0d8b77d5cd9$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($79b55cb30ab000ec$exports(key) && !$d247c0d8b77d5cd9$var$isExtensible(key)) {
                    var state = $d247c0d8b77d5cd9$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $d247c0d8b77d5cd9$var$InternalWeakMap();
                    return $d247c0d8b77d5cd9$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $d247c0d8b77d5cd9$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($79b55cb30ab000ec$exports(key) && !$d247c0d8b77d5cd9$var$isExtensible(key)) {
                    var state = $d247c0d8b77d5cd9$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $d247c0d8b77d5cd9$var$InternalWeakMap();
                    return $d247c0d8b77d5cd9$var$nativeHas(this, key) ? $d247c0d8b77d5cd9$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $d247c0d8b77d5cd9$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($79b55cb30ab000ec$exports(key) && !$d247c0d8b77d5cd9$var$isExtensible(key)) {
                    var state = $d247c0d8b77d5cd9$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $d247c0d8b77d5cd9$var$InternalWeakMap();
                    $d247c0d8b77d5cd9$var$nativeHas(this, key) ? $d247c0d8b77d5cd9$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $d247c0d8b77d5cd9$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($d247c0d8b77d5cd9$var$hasMSEdgeFreezingBug()) $b2eaa13f327d4d54$exports($d247c0d8b77d5cd9$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($d247c0d8b77d5cd9$var$isArray(key)) {
                if ($d247c0d8b77d5cd9$var$isFrozen(key)) arrayIntegrityLevel = $d247c0d8b77d5cd9$var$FROZEN;
                else if ($d247c0d8b77d5cd9$var$isSealed(key)) arrayIntegrityLevel = $d247c0d8b77d5cd9$var$SEALED;
            }
            $d247c0d8b77d5cd9$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel === $d247c0d8b77d5cd9$var$FROZEN) $d247c0d8b77d5cd9$var$freeze(key);
            if (arrayIntegrityLevel === $d247c0d8b77d5cd9$var$SEALED) $d247c0d8b77d5cd9$var$seal(key);
            return this;
        }
    });
}







var $38602732df117c75$var$$Object = Object;
var $38602732df117c75$var$$TypeError = TypeError;
var $38602732df117c75$var$Map = $a86b7d926328b4a8$exports("Map");
var $38602732df117c75$var$WeakMap = $a86b7d926328b4a8$exports("WeakMap");
var $38602732df117c75$var$Node = function() {
    // keys
    this.object = null;
    this.symbol = null;
    // child nodes
    this.primitives = null;
    this.objectsByIndex = $b77147d4c97a1d55$exports(null);
};
$38602732df117c75$var$Node.prototype.get = function(key, initializer) {
    return this[key] || (this[key] = initializer());
};
$38602732df117c75$var$Node.prototype.next = function(i, it, IS_OBJECT) {
    var store = IS_OBJECT ? this.objectsByIndex[i] || (this.objectsByIndex[i] = new $38602732df117c75$var$WeakMap()) : this.primitives || (this.primitives = new $38602732df117c75$var$Map());
    var entry = store.get(it);
    if (!entry) store.set(it, entry = new $38602732df117c75$var$Node());
    return entry;
};
var $38602732df117c75$var$root = new $38602732df117c75$var$Node();
$38602732df117c75$exports = function() {
    var active = $38602732df117c75$var$root;
    var length = arguments.length;
    var i, it;
    // for prevent leaking, start from objects
    for(i = 0; i < length; i++)if ($79b55cb30ab000ec$exports(it = arguments[i])) active = active.next(i, it, true);
    if (this === $38602732df117c75$var$$Object && active === $38602732df117c75$var$root) throw new $38602732df117c75$var$$TypeError("Composite keys must contain a non-primitive component");
    for(i = 0; i < length; i++)if (!$79b55cb30ab000ec$exports(it = arguments[i])) active = active.next(i, it, false);
    return active;
};




var $6a90a0eb0833d8c7$var$$Object = Object;
var $6a90a0eb0833d8c7$var$initializer = function() {
    var freeze = $a86b7d926328b4a8$exports("Object", "freeze");
    return freeze ? freeze($b77147d4c97a1d55$exports(null)) : $b77147d4c97a1d55$exports(null);
};
// https://github.com/tc39/proposal-richer-keys/tree/master/compositeKey
$95f391e8d3de298b$exports({
    global: true,
    forced: true
}, {
    compositeKey: function compositeKey() {
        return $6e1bcf3cbc68d00e$exports($38602732df117c75$exports, $6a90a0eb0833d8c7$var$$Object, arguments).get("object", $6a90a0eb0833d8c7$var$initializer);
    }
});


"use strict";




// https://github.com/tc39/proposal-richer-keys/tree/master/compositeKey
$95f391e8d3de298b$exports({
    global: true,
    forced: true
}, {
    compositeSymbol: function compositeSymbol() {
        if (arguments.length === 1 && typeof arguments[0] == "string") return $a86b7d926328b4a8$exports("Symbol")["for"](arguments[0]);
        return $6e1bcf3cbc68d00e$exports($38602732df117c75$exports, null, arguments).get("symbol", $a86b7d926328b4a8$exports("Symbol"));
    }
});


"use strict";

var $ccf9944475928659$exports = {};
"use strict";
var $c35f70d4799c833d$exports = {};
"use strict";

// eslint-disable-next-line es/no-map -- safe
var $c35f70d4799c833d$var$MapPrototype = Map.prototype;
$c35f70d4799c833d$exports = {
    // eslint-disable-next-line es/no-map -- safe
    Map: Map,
    set: $2098731ff14c1b28$exports($c35f70d4799c833d$var$MapPrototype.set),
    get: $2098731ff14c1b28$exports($c35f70d4799c833d$var$MapPrototype.get),
    has: $2098731ff14c1b28$exports($c35f70d4799c833d$var$MapPrototype.has),
    remove: $2098731ff14c1b28$exports($c35f70d4799c833d$var$MapPrototype["delete"]),
    proto: $c35f70d4799c833d$var$MapPrototype
};


var $ccf9944475928659$require$has = $c35f70d4799c833d$exports.has;
// Perform ? RequireInternalSlot(M, [[MapData]])
$ccf9944475928659$exports = function(it) {
    $ccf9944475928659$require$has(it);
    return it;
};



var $afd789a5352bd486$require$remove = $c35f70d4799c833d$exports.remove;
// `Map.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    deleteAll: function deleteAll() {
        var collection = $ccf9944475928659$exports(this);
        var allDeleted = true;
        var wasDeleted;
        for(var k = 0, len = arguments.length; k < len; k++){
            wasDeleted = $afd789a5352bd486$require$remove(collection, arguments[k]);
            allDeleted = allDeleted && wasDeleted;
        }
        return !!allDeleted;
    }
});


"use strict";



var $af38299ad37577dd$exports = {};
"use strict";

var $64a3adaebb98edf6$exports = {};
"use strict";

$64a3adaebb98edf6$exports = function(record, fn, ITERATOR_INSTEAD_OF_RECORD) {
    var iterator = ITERATOR_INSTEAD_OF_RECORD ? record : record.iterator;
    var next = record.next;
    var step, result;
    while(!(step = $97bce1c6dc77a53b$exports(next, iterator)).done){
        result = fn(step.value);
        if (result !== undefined) return result;
    }
};



var $af38299ad37577dd$var$Map = $c35f70d4799c833d$exports.Map;
var $af38299ad37577dd$var$MapPrototype = $c35f70d4799c833d$exports.proto;
var $af38299ad37577dd$var$forEach = $2098731ff14c1b28$exports($af38299ad37577dd$var$MapPrototype.forEach);
var $af38299ad37577dd$var$entries = $2098731ff14c1b28$exports($af38299ad37577dd$var$MapPrototype.entries);
var $af38299ad37577dd$var$next = $af38299ad37577dd$var$entries(new $af38299ad37577dd$var$Map()).next;
$af38299ad37577dd$exports = function(map, fn, interruptible) {
    return interruptible ? $64a3adaebb98edf6$exports({
        iterator: $af38299ad37577dd$var$entries(map),
        next: $af38299ad37577dd$var$next
    }, function(entry) {
        return fn(entry[1], entry[0]);
    }) : $af38299ad37577dd$var$forEach(map, fn);
};


// `Map.prototype.every` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    every: function every(callbackfn /* , thisArg */ ) {
        var map = $ccf9944475928659$exports(this);
        var boundFunction = $b4fa206c62a6dcdd$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return $af38299ad37577dd$exports(map, function(value, key) {
            if (!boundFunction(value, key, map)) return false;
        }, true) !== false;
    }
});


"use strict";





var $18c81714ddc07f03$var$Map = $c35f70d4799c833d$exports.Map;
var $18c81714ddc07f03$var$set = $c35f70d4799c833d$exports.set;
// `Map.prototype.filter` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        var map = $ccf9944475928659$exports(this);
        var boundFunction = $b4fa206c62a6dcdd$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newMap = new $18c81714ddc07f03$var$Map();
        $af38299ad37577dd$exports(map, function(value, key) {
            if (boundFunction(value, key, map)) $18c81714ddc07f03$var$set(newMap, key, value);
        });
        return newMap;
    }
});


"use strict";




// `Map.prototype.find` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    find: function find(callbackfn /* , thisArg */ ) {
        var map = $ccf9944475928659$exports(this);
        var boundFunction = $b4fa206c62a6dcdd$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var result = $af38299ad37577dd$exports(map, function(value, key) {
            if (boundFunction(value, key, map)) return {
                value: value
            };
        }, true);
        return result && result.value;
    }
});


"use strict";




// `Map.prototype.findKey` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    findKey: function findKey(callbackfn /* , thisArg */ ) {
        var map = $ccf9944475928659$exports(this);
        var boundFunction = $b4fa206c62a6dcdd$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var result = $af38299ad37577dd$exports(map, function(value, key) {
            if (boundFunction(value, key, map)) return {
                key: key
            };
        }, true);
        return result && result.key;
    }
});


"use strict";

var $59e9c5bffa4c565d$exports = {};
"use strict";



var $31b1a2cd72f9d765$exports = {};
"use strict";


var $31b1a2cd72f9d765$var$$TypeError = TypeError;
// `Assert: IsConstructor(argument) is true`
$31b1a2cd72f9d765$exports = function(argument) {
    if ($c4cbaf47a62f8816$exports(argument)) return argument;
    throw new $31b1a2cd72f9d765$var$$TypeError($89fbca0f38ee4901$exports(argument) + " is not a constructor");
};




var $59e9c5bffa4c565d$var$push = [].push;
$59e9c5bffa4c565d$exports = function from(source /* , mapFn, thisArg */ ) {
    var length = arguments.length;
    var mapFn = length > 1 ? arguments[1] : undefined;
    var mapping, array, n, boundFunction;
    $31b1a2cd72f9d765$exports(this);
    mapping = mapFn !== undefined;
    if (mapping) $b036d6e8e8a1e730$exports(mapFn);
    if ($0948cee6bccbdbb6$exports(source)) return new this();
    array = [];
    if (mapping) {
        n = 0;
        boundFunction = $b4fa206c62a6dcdd$exports(mapFn, length > 2 ? arguments[2] : undefined);
        $b3f339154d5ed3ac$exports(source, function(nextItem) {
            $97bce1c6dc77a53b$exports($59e9c5bffa4c565d$var$push, array, boundFunction(nextItem, n++));
        });
    } else $b3f339154d5ed3ac$exports(source, $59e9c5bffa4c565d$var$push, {
        that: array
    });
    return new this(array);
};


// `Map.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
$95f391e8d3de298b$exports({
    target: "Map",
    stat: true,
    forced: true
}, {
    from: $59e9c5bffa4c565d$exports
});


"use strict";
"use strict";







var $316a0703a5b548ab$var$Map = $c35f70d4799c833d$exports.Map;
var $316a0703a5b548ab$var$has = $c35f70d4799c833d$exports.has;
var $316a0703a5b548ab$var$get = $c35f70d4799c833d$exports.get;
var $316a0703a5b548ab$var$set = $c35f70d4799c833d$exports.set;
var $316a0703a5b548ab$var$push = $2098731ff14c1b28$exports([].push);
// `Map.groupBy` method
// https://github.com/tc39/proposal-array-grouping
$95f391e8d3de298b$exports({
    target: "Map",
    stat: true,
    forced: $0f1181f19eff16c7$exports
}, {
    groupBy: function groupBy(items, callbackfn) {
        $27cd7a1a0cbe9d9e$exports(items);
        $b036d6e8e8a1e730$exports(callbackfn);
        var map = new $316a0703a5b548ab$var$Map();
        var k = 0;
        $b3f339154d5ed3ac$exports(items, function(value) {
            var key = callbackfn(value, k++);
            if (!$316a0703a5b548ab$var$has(map, key)) $316a0703a5b548ab$var$set(map, key, [
                value
            ]);
            else $316a0703a5b548ab$var$push($316a0703a5b548ab$var$get(map, key), value);
        });
        return map;
    }
});




"use strict";

var $e5867a76730309dc$exports = {};
"use strict";
// `SameValueZero` abstract operation
// https://tc39.es/ecma262/#sec-samevaluezero
$e5867a76730309dc$exports = function(x, y) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return x === y || x !== x && y !== y;
};




// `Map.prototype.includes` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    includes: function includes(searchElement) {
        return $af38299ad37577dd$exports($ccf9944475928659$exports(this), function(value) {
            if ($e5867a76730309dc$exports(value, searchElement)) return true;
        }, true) === true;
    }
});


"use strict";






var $f063521c90dab623$require$Map = $c35f70d4799c833d$exports.Map;
// `Map.keyBy` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Map",
    stat: true,
    forced: true
}, {
    keyBy: function keyBy(iterable, keyDerivative) {
        var C = $fa64b91b5990a54e$exports(this) ? this : $f063521c90dab623$require$Map;
        var newMap = new C();
        $b036d6e8e8a1e730$exports(keyDerivative);
        var setter = $b036d6e8e8a1e730$exports(newMap.set);
        $b3f339154d5ed3ac$exports(iterable, function(element) {
            $97bce1c6dc77a53b$exports(setter, newMap, keyDerivative(element), element);
        });
        return newMap;
    }
});


"use strict";



// `Map.prototype.keyOf` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    keyOf: function keyOf(searchElement) {
        var result = $af38299ad37577dd$exports($ccf9944475928659$exports(this), function(value, key) {
            if (value === searchElement) return {
                key: key
            };
        }, true);
        return result && result.key;
    }
});


"use strict";





var $66505c00ba1e1d1f$var$Map = $c35f70d4799c833d$exports.Map;
var $66505c00ba1e1d1f$var$set = $c35f70d4799c833d$exports.set;
// `Map.prototype.mapKeys` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    mapKeys: function mapKeys(callbackfn /* , thisArg */ ) {
        var map = $ccf9944475928659$exports(this);
        var boundFunction = $b4fa206c62a6dcdd$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newMap = new $66505c00ba1e1d1f$var$Map();
        $af38299ad37577dd$exports(map, function(value, key) {
            $66505c00ba1e1d1f$var$set(newMap, boundFunction(value, key, map), value);
        });
        return newMap;
    }
});


"use strict";





var $1a615b2a3a455b91$var$Map = $c35f70d4799c833d$exports.Map;
var $1a615b2a3a455b91$var$set = $c35f70d4799c833d$exports.set;
// `Map.prototype.mapValues` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    mapValues: function mapValues(callbackfn /* , thisArg */ ) {
        var map = $ccf9944475928659$exports(this);
        var boundFunction = $b4fa206c62a6dcdd$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newMap = new $1a615b2a3a455b91$var$Map();
        $af38299ad37577dd$exports(map, function(value, key) {
            $1a615b2a3a455b91$var$set(newMap, key, boundFunction(value, key, map));
        });
        return newMap;
    }
});


"use strict";




var $5184beceb65286c6$require$set = $c35f70d4799c833d$exports.set;
// `Map.prototype.merge` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Map",
    proto: true,
    real: true,
    arity: 1,
    forced: true
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    merge: function merge(iterable /* ...iterables */ ) {
        var map = $ccf9944475928659$exports(this);
        var argumentsLength = arguments.length;
        var i = 0;
        while(i < argumentsLength)$b3f339154d5ed3ac$exports(arguments[i++], function(key, value) {
            $5184beceb65286c6$require$set(map, key, value);
        }, {
            AS_ENTRIES: true
        });
        return map;
    }
});


"use strict";

var $07a6b5ee07d29197$exports = {};
"use strict";
var $75c73594f840af83$exports = {};
"use strict";

$75c73594f840af83$exports = $2098731ff14c1b28$exports([].slice);


// https://tc39.github.io/proposal-setmap-offrom/
$07a6b5ee07d29197$exports = function of() {
    return new this($75c73594f840af83$exports(arguments));
};


// `Map.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
$95f391e8d3de298b$exports({
    target: "Map",
    stat: true,
    forced: true
}, {
    of: $07a6b5ee07d29197$exports
});


"use strict";




var $88bc391553e1b56d$var$$TypeError = TypeError;
// `Map.prototype.reduce` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var map = $ccf9944475928659$exports(this);
        var noInitial = arguments.length < 2;
        var accumulator = noInitial ? undefined : arguments[1];
        $b036d6e8e8a1e730$exports(callbackfn);
        $af38299ad37577dd$exports(map, function(value, key) {
            if (noInitial) {
                noInitial = false;
                accumulator = value;
            } else accumulator = callbackfn(accumulator, value, key, map);
        });
        if (noInitial) throw new $88bc391553e1b56d$var$$TypeError("Reduce of empty map with no initial value");
        return accumulator;
    }
});


"use strict";




// `Map.prototype.some` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    some: function some(callbackfn /* , thisArg */ ) {
        var map = $ccf9944475928659$exports(this);
        var boundFunction = $b4fa206c62a6dcdd$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return $af38299ad37577dd$exports(map, function(value, key) {
            if (boundFunction(value, key, map)) return true;
        }, true) === true;
    }
});


"use strict";




var $15fb778a65db264a$var$$TypeError = TypeError;
var $15fb778a65db264a$var$get = $c35f70d4799c833d$exports.get;
var $15fb778a65db264a$var$has = $c35f70d4799c833d$exports.has;
var $15fb778a65db264a$var$set = $c35f70d4799c833d$exports.set;
// `Map.prototype.update` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    update: function update(key, callback /* , thunk */ ) {
        var map = $ccf9944475928659$exports(this);
        var length = arguments.length;
        $b036d6e8e8a1e730$exports(callback);
        var isPresentInMap = $15fb778a65db264a$var$has(map, key);
        if (!isPresentInMap && length < 3) throw new $15fb778a65db264a$var$$TypeError("Updating absent value");
        var value = isPresentInMap ? $15fb778a65db264a$var$get(map, key) : $b036d6e8e8a1e730$exports(length > 2 ? arguments[2] : undefined)(key, map);
        $15fb778a65db264a$var$set(map, key, callback(value, key, map));
        return map;
    }
});


"use strict";

var $cb72bbfdd8dd6423$var$min = Math.min;
var $cb72bbfdd8dd6423$var$max = Math.max;
// `Math.clamp` method
// https://rwaldron.github.io/proposal-math-extensions/
$95f391e8d3de298b$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    clamp: function clamp(x, lower, upper) {
        return $cb72bbfdd8dd6423$var$min(upper, $cb72bbfdd8dd6423$var$max(lower, x));
    }
});


"use strict";

// `Math.DEG_PER_RAD` constant
// https://rwaldron.github.io/proposal-math-extensions/
$95f391e8d3de298b$exports({
    target: "Math",
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    DEG_PER_RAD: Math.PI / 180
});


"use strict";

var $598d0ba3b9607f4b$var$RAD_PER_DEG = 180 / Math.PI;
// `Math.degrees` method
// https://rwaldron.github.io/proposal-math-extensions/
$95f391e8d3de298b$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    degrees: function degrees(radians) {
        return radians * $598d0ba3b9607f4b$var$RAD_PER_DEG;
    }
});


"use strict";

var $7cbb6f1a74c14c97$exports = {};
"use strict";
// `Math.scale` method implementation
// https://rwaldron.github.io/proposal-math-extensions/
$7cbb6f1a74c14c97$exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
    var nx = +x;
    var nInLow = +inLow;
    var nInHigh = +inHigh;
    var nOutLow = +outLow;
    var nOutHigh = +outHigh;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (nx !== nx || nInLow !== nInLow || nInHigh !== nInHigh || nOutLow !== nOutLow || nOutHigh !== nOutHigh) return NaN;
    if (nx === Infinity || nx === -Infinity) return nx;
    return (nx - nInLow) * (nOutHigh - nOutLow) / (nInHigh - nInLow) + nOutLow;
};


var $b9f7144be8349f9d$exports = {};
"use strict";
var $a72b07e468dd3c0d$exports = {};
"use strict";
var $fa4b6974d152b886$exports = {};
"use strict";
// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
$fa4b6974d152b886$exports = Math.sign || function sign(x) {
    var n = +x;
    // eslint-disable-next-line no-self-compare -- NaN check
    return n === 0 || n !== n ? n : n < 0 ? -1 : 1;
};


var $a72b07e468dd3c0d$var$abs = Math.abs;
var $a72b07e468dd3c0d$var$EPSILON = 2.220446049250313e-16; // Number.EPSILON
var $a72b07e468dd3c0d$var$INVERSE_EPSILON = 1 / $a72b07e468dd3c0d$var$EPSILON;
var $a72b07e468dd3c0d$var$roundTiesToEven = function(n) {
    return n + $a72b07e468dd3c0d$var$INVERSE_EPSILON - $a72b07e468dd3c0d$var$INVERSE_EPSILON;
};
$a72b07e468dd3c0d$exports = function(x, FLOAT_EPSILON, FLOAT_MAX_VALUE, FLOAT_MIN_VALUE) {
    var n = +x;
    var absolute = $a72b07e468dd3c0d$var$abs(n);
    var s = $fa4b6974d152b886$exports(n);
    if (absolute < FLOAT_MIN_VALUE) return s * $a72b07e468dd3c0d$var$roundTiesToEven(absolute / FLOAT_MIN_VALUE / FLOAT_EPSILON) * FLOAT_MIN_VALUE * FLOAT_EPSILON;
    var a = (1 + FLOAT_EPSILON / $a72b07e468dd3c0d$var$EPSILON) * absolute;
    var result = a - (a - absolute);
    // eslint-disable-next-line no-self-compare -- NaN check
    if (result > FLOAT_MAX_VALUE || result !== result) return s * Infinity;
    return s * result;
};


var $b9f7144be8349f9d$var$FLOAT32_EPSILON = 1.1920928955078125e-7; // 2 ** -23;
var $b9f7144be8349f9d$var$FLOAT32_MAX_VALUE = 3.4028234663852886e+38; // 2 ** 128 - 2 ** 104
var $b9f7144be8349f9d$var$FLOAT32_MIN_VALUE = 1.1754943508222875e-38; // 2 ** -126;
// `Math.fround` method implementation
// https://tc39.es/ecma262/#sec-math.fround
// eslint-disable-next-line es/no-math-fround -- safe
$b9f7144be8349f9d$exports = Math.fround || function fround(x) {
    return $a72b07e468dd3c0d$exports(x, $b9f7144be8349f9d$var$FLOAT32_EPSILON, $b9f7144be8349f9d$var$FLOAT32_MAX_VALUE, $b9f7144be8349f9d$var$FLOAT32_MIN_VALUE);
};


// `Math.fscale` method
// https://rwaldron.github.io/proposal-math-extensions/
$95f391e8d3de298b$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
        return $b9f7144be8349f9d$exports($7cbb6f1a74c14c97$exports(x, inLow, inHigh, outLow, outHigh));
    }
});


"use strict";

// `Math.iaddh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`
$95f391e8d3de298b$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    iaddh: function iaddh(x0, x1, y0, y1) {
        var $x0 = x0 >>> 0;
        var $x1 = x1 >>> 0;
        var $y0 = y0 >>> 0;
        return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
    }
});


"use strict";

// `Math.imulh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`
$95f391e8d3de298b$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    imulh: function imulh(u, v) {
        var UINT16 = 0xFFFF;
        var $u = +u;
        var $v = +v;
        var u0 = $u & UINT16;
        var v0 = $v & UINT16;
        var u1 = $u >> 16;
        var v1 = $v >> 16;
        var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
        return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
    }
});


"use strict";

// `Math.isubh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`
$95f391e8d3de298b$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    isubh: function isubh(x0, x1, y0, y1) {
        var $x0 = x0 >>> 0;
        var $x1 = x1 >>> 0;
        var $y0 = y0 >>> 0;
        return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
    }
});


"use strict";

// `Math.RAD_PER_DEG` constant
// https://rwaldron.github.io/proposal-math-extensions/
$95f391e8d3de298b$exports({
    target: "Math",
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    RAD_PER_DEG: 180 / Math.PI
});


"use strict";

var $2794243c38ee892a$var$DEG_PER_RAD = Math.PI / 180;
// `Math.radians` method
// https://rwaldron.github.io/proposal-math-extensions/
$95f391e8d3de298b$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    radians: function radians(degrees) {
        return degrees * $2794243c38ee892a$var$DEG_PER_RAD;
    }
});


"use strict";


// `Math.scale` method
// https://rwaldron.github.io/proposal-math-extensions/
$95f391e8d3de298b$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    scale: $7cbb6f1a74c14c97$exports
});


"use strict";


var $c85ef463ef5246cc$exports = {};
"use strict";

var $c85ef463ef5246cc$var$globalIsFinite = $6eaaaed532023352$exports.isFinite;
// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
// eslint-disable-next-line es/no-number-isfinite -- safe
$c85ef463ef5246cc$exports = Number.isFinite || function isFinite(it) {
    return typeof it == "number" && $c85ef463ef5246cc$var$globalIsFinite(it);
};





var $7471cd5378fcde83$var$SEEDED_RANDOM = "Seeded Random";
var $7471cd5378fcde83$var$SEEDED_RANDOM_GENERATOR = $7471cd5378fcde83$var$SEEDED_RANDOM + " Generator";
var $7471cd5378fcde83$var$SEED_TYPE_ERROR = 'Math.seededPRNG() argument should have a "seed" field with a finite value.';
var $7471cd5378fcde83$var$setInternalState = $9e1e01125ce84891$exports.set;
var $7471cd5378fcde83$var$getInternalState = $9e1e01125ce84891$exports.getterFor($7471cd5378fcde83$var$SEEDED_RANDOM_GENERATOR);
var $7471cd5378fcde83$var$$TypeError = TypeError;
var $7471cd5378fcde83$var$$SeededRandomGenerator = $2763c7c7e2bb8835$exports(function SeededRandomGenerator(seed) {
    $7471cd5378fcde83$var$setInternalState(this, {
        type: $7471cd5378fcde83$var$SEEDED_RANDOM_GENERATOR,
        seed: seed % 2147483647
    });
}, $7471cd5378fcde83$var$SEEDED_RANDOM, function next() {
    var state = $7471cd5378fcde83$var$getInternalState(this);
    var seed = state.seed = (state.seed * 1103515245 + 12345) % 2147483647;
    return $26563010b7960a80$exports((seed & 1073741823) / 1073741823, false);
});
// `Math.seededPRNG` method
// https://github.com/tc39/proposal-seeded-random
// based on https://github.com/tc39/proposal-seeded-random/blob/78b8258835b57fc2100d076151ab506bc3202ae6/demo.html
$95f391e8d3de298b$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    seededPRNG: function seededPRNG(it) {
        var seed = $d8eb1c0d5fd2deb8$exports(it).seed;
        if (!$c85ef463ef5246cc$exports(seed)) throw new $7471cd5378fcde83$var$$TypeError($7471cd5378fcde83$var$SEED_TYPE_ERROR);
        return new $7471cd5378fcde83$var$$SeededRandomGenerator(seed);
    }
});


"use strict";

// `Math.signbit` method
// https://github.com/tc39/proposal-Math.signbit
$95f391e8d3de298b$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    signbit: function signbit(x) {
        var n = +x;
        // eslint-disable-next-line no-self-compare -- NaN check
        return n === n && n === 0 ? 1 / n === -Infinity : n < 0;
    }
});


"use strict";

// `Math.umulh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`
$95f391e8d3de298b$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    umulh: function umulh(u, v) {
        var UINT16 = 0xFFFF;
        var $u = +u;
        var $v = +v;
        var u0 = $u & UINT16;
        var v0 = $v & UINT16;
        var u1 = $u >>> 16;
        var v1 = $v >>> 16;
        var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
        return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
    }
});


"use strict";



var $bb44eb9dd85175dd$var$INVALID_NUMBER_REPRESENTATION = "Invalid number representation";
var $bb44eb9dd85175dd$var$INVALID_RADIX = "Invalid radix";
var $bb44eb9dd85175dd$var$$RangeError = RangeError;
var $bb44eb9dd85175dd$var$$SyntaxError = SyntaxError;
var $bb44eb9dd85175dd$var$$TypeError = TypeError;
var $bb44eb9dd85175dd$var$$parseInt = parseInt;
var $bb44eb9dd85175dd$var$pow = Math.pow;
var $bb44eb9dd85175dd$var$valid = /^[\d.a-z]+$/;
var $bb44eb9dd85175dd$var$charAt = $2098731ff14c1b28$exports("".charAt);
var $bb44eb9dd85175dd$var$exec = $2098731ff14c1b28$exports($bb44eb9dd85175dd$var$valid.exec);
var $bb44eb9dd85175dd$var$numberToString = $2098731ff14c1b28$exports(1.0.toString);
var $bb44eb9dd85175dd$var$stringSlice = $2098731ff14c1b28$exports("".slice);
var $bb44eb9dd85175dd$var$split = $2098731ff14c1b28$exports("".split);
// `Number.fromString` method
// https://github.com/tc39/proposal-number-fromstring
$95f391e8d3de298b$exports({
    target: "Number",
    stat: true,
    forced: true
}, {
    fromString: function fromString(string, radix) {
        var sign = 1;
        if (typeof string != "string") throw new $bb44eb9dd85175dd$var$$TypeError($bb44eb9dd85175dd$var$INVALID_NUMBER_REPRESENTATION);
        if (!string.length) throw new $bb44eb9dd85175dd$var$$SyntaxError($bb44eb9dd85175dd$var$INVALID_NUMBER_REPRESENTATION);
        if ($bb44eb9dd85175dd$var$charAt(string, 0) === "-") {
            sign = -1;
            string = $bb44eb9dd85175dd$var$stringSlice(string, 1);
            if (!string.length) throw new $bb44eb9dd85175dd$var$$SyntaxError($bb44eb9dd85175dd$var$INVALID_NUMBER_REPRESENTATION);
        }
        var R = radix === undefined ? 10 : $cdf3b3f376b00406$exports(radix);
        if (R < 2 || R > 36) throw new $bb44eb9dd85175dd$var$$RangeError($bb44eb9dd85175dd$var$INVALID_RADIX);
        if (!$bb44eb9dd85175dd$var$exec($bb44eb9dd85175dd$var$valid, string)) throw new $bb44eb9dd85175dd$var$$SyntaxError($bb44eb9dd85175dd$var$INVALID_NUMBER_REPRESENTATION);
        var parts = $bb44eb9dd85175dd$var$split(string, ".");
        var mathNum = $bb44eb9dd85175dd$var$$parseInt(parts[0], R);
        if (parts.length > 1) mathNum += $bb44eb9dd85175dd$var$$parseInt(parts[1], R) / $bb44eb9dd85175dd$var$pow(R, parts[1].length);
        if (R === 10 && $bb44eb9dd85175dd$var$numberToString(mathNum, R) !== string) throw new $bb44eb9dd85175dd$var$$SyntaxError($bb44eb9dd85175dd$var$INVALID_NUMBER_REPRESENTATION);
        return sign * mathNum;
    }
});


"use strict";
"use strict";














var $ed314e734d95c8f6$exports = {};
"use strict";
$ed314e734d95c8f6$exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length === 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};




var $cfcb786f96cd3107$var$$$OBSERVABLE = $cb598f706b77edff$exports("observable");
var $cfcb786f96cd3107$var$OBSERVABLE = "Observable";
var $cfcb786f96cd3107$var$SUBSCRIPTION = "Subscription";
var $cfcb786f96cd3107$var$SUBSCRIPTION_OBSERVER = "SubscriptionObserver";
var $cfcb786f96cd3107$var$getterFor = $9e1e01125ce84891$exports.getterFor;
var $cfcb786f96cd3107$var$setInternalState = $9e1e01125ce84891$exports.set;
var $cfcb786f96cd3107$var$getObservableInternalState = $cfcb786f96cd3107$var$getterFor($cfcb786f96cd3107$var$OBSERVABLE);
var $cfcb786f96cd3107$var$getSubscriptionInternalState = $cfcb786f96cd3107$var$getterFor($cfcb786f96cd3107$var$SUBSCRIPTION);
var $cfcb786f96cd3107$var$getSubscriptionObserverInternalState = $cfcb786f96cd3107$var$getterFor($cfcb786f96cd3107$var$SUBSCRIPTION_OBSERVER);
var $cfcb786f96cd3107$var$SubscriptionState = function(observer) {
    this.observer = $d8eb1c0d5fd2deb8$exports(observer);
    this.cleanup = undefined;
    this.subscriptionObserver = undefined;
};
$cfcb786f96cd3107$var$SubscriptionState.prototype = {
    type: $cfcb786f96cd3107$var$SUBSCRIPTION,
    clean: function() {
        var cleanup = this.cleanup;
        if (cleanup) {
            this.cleanup = undefined;
            try {
                cleanup();
            } catch (error) {
                $ed314e734d95c8f6$exports(error);
            }
        }
    },
    close: function() {
        if (!$4dea53c988ff8146$exports) {
            var subscription = this.facade;
            var subscriptionObserver = this.subscriptionObserver;
            subscription.closed = true;
            if (subscriptionObserver) subscriptionObserver.closed = true;
        }
        this.observer = undefined;
    },
    isClosed: function() {
        return this.observer === undefined;
    }
};
var $cfcb786f96cd3107$var$Subscription = function(observer, subscriber) {
    var subscriptionState = $cfcb786f96cd3107$var$setInternalState(this, new $cfcb786f96cd3107$var$SubscriptionState(observer));
    var start;
    if (!$4dea53c988ff8146$exports) this.closed = false;
    try {
        if (start = $a313ad37d47c05ba$exports(observer, "start")) $97bce1c6dc77a53b$exports(start, observer, this);
    } catch (error) {
        $ed314e734d95c8f6$exports(error);
    }
    if (subscriptionState.isClosed()) return;
    var subscriptionObserver = subscriptionState.subscriptionObserver = new $cfcb786f96cd3107$var$SubscriptionObserver(subscriptionState);
    try {
        var cleanup = subscriber(subscriptionObserver);
        var subscription = cleanup;
        if (!$0948cee6bccbdbb6$exports(cleanup)) subscriptionState.cleanup = $fa64b91b5990a54e$exports(cleanup.unsubscribe) ? function() {
            subscription.unsubscribe();
        } : $b036d6e8e8a1e730$exports(cleanup);
    } catch (error) {
        subscriptionObserver.error(error);
        return;
    }
    if (subscriptionState.isClosed()) subscriptionState.clean();
};
$cfcb786f96cd3107$var$Subscription.prototype = $b2eaa13f327d4d54$exports({}, {
    unsubscribe: function unsubscribe() {
        var subscriptionState = $cfcb786f96cd3107$var$getSubscriptionInternalState(this);
        if (!subscriptionState.isClosed()) {
            subscriptionState.close();
            subscriptionState.clean();
        }
    }
});
if ($4dea53c988ff8146$exports) $c63f92c1035948fe$exports($cfcb786f96cd3107$var$Subscription.prototype, "closed", {
    configurable: true,
    get: function closed() {
        return $cfcb786f96cd3107$var$getSubscriptionInternalState(this).isClosed();
    }
});
var $cfcb786f96cd3107$var$SubscriptionObserver = function(subscriptionState) {
    $cfcb786f96cd3107$var$setInternalState(this, {
        type: $cfcb786f96cd3107$var$SUBSCRIPTION_OBSERVER,
        subscriptionState: subscriptionState
    });
    if (!$4dea53c988ff8146$exports) this.closed = false;
};
$cfcb786f96cd3107$var$SubscriptionObserver.prototype = $b2eaa13f327d4d54$exports({}, {
    next: function next(value) {
        var subscriptionState = $cfcb786f96cd3107$var$getSubscriptionObserverInternalState(this).subscriptionState;
        if (!subscriptionState.isClosed()) {
            var observer = subscriptionState.observer;
            try {
                var nextMethod = $a313ad37d47c05ba$exports(observer, "next");
                if (nextMethod) $97bce1c6dc77a53b$exports(nextMethod, observer, value);
            } catch (error) {
                $ed314e734d95c8f6$exports(error);
            }
        }
    },
    error: function error(value) {
        var subscriptionState = $cfcb786f96cd3107$var$getSubscriptionObserverInternalState(this).subscriptionState;
        if (!subscriptionState.isClosed()) {
            var observer = subscriptionState.observer;
            subscriptionState.close();
            try {
                var errorMethod = $a313ad37d47c05ba$exports(observer, "error");
                if (errorMethod) $97bce1c6dc77a53b$exports(errorMethod, observer, value);
                else $ed314e734d95c8f6$exports(value);
            } catch (err) {
                $ed314e734d95c8f6$exports(err);
            }
            subscriptionState.clean();
        }
    },
    complete: function complete() {
        var subscriptionState = $cfcb786f96cd3107$var$getSubscriptionObserverInternalState(this).subscriptionState;
        if (!subscriptionState.isClosed()) {
            var observer = subscriptionState.observer;
            subscriptionState.close();
            try {
                var completeMethod = $a313ad37d47c05ba$exports(observer, "complete");
                if (completeMethod) $97bce1c6dc77a53b$exports(completeMethod, observer);
            } catch (error) {
                $ed314e734d95c8f6$exports(error);
            }
            subscriptionState.clean();
        }
    }
});
if ($4dea53c988ff8146$exports) $c63f92c1035948fe$exports($cfcb786f96cd3107$var$SubscriptionObserver.prototype, "closed", {
    configurable: true,
    get: function closed() {
        return $cfcb786f96cd3107$var$getSubscriptionObserverInternalState(this).subscriptionState.isClosed();
    }
});
var $cfcb786f96cd3107$var$$Observable = function Observable(subscriber) {
    $847a5ea3931ac091$exports(this, $cfcb786f96cd3107$var$ObservablePrototype);
    $cfcb786f96cd3107$var$setInternalState(this, {
        type: $cfcb786f96cd3107$var$OBSERVABLE,
        subscriber: $b036d6e8e8a1e730$exports(subscriber)
    });
};
var $cfcb786f96cd3107$var$ObservablePrototype = $cfcb786f96cd3107$var$$Observable.prototype;
$b2eaa13f327d4d54$exports($cfcb786f96cd3107$var$ObservablePrototype, {
    subscribe: function subscribe(observer) {
        var length = arguments.length;
        return new $cfcb786f96cd3107$var$Subscription($fa64b91b5990a54e$exports(observer) ? {
            next: observer,
            error: length > 1 ? arguments[1] : undefined,
            complete: length > 2 ? arguments[2] : undefined
        } : $79b55cb30ab000ec$exports(observer) ? observer : {}, $cfcb786f96cd3107$var$getObservableInternalState(this).subscriber);
    }
});
$dadfa6c3f61baeea$exports($cfcb786f96cd3107$var$ObservablePrototype, $cfcb786f96cd3107$var$$$OBSERVABLE, function() {
    return this;
});
$95f391e8d3de298b$exports({
    global: true,
    constructor: true,
    forced: true
}, {
    Observable: $cfcb786f96cd3107$var$$Observable
});
$41081d30d2b52804$exports($cfcb786f96cd3107$var$OBSERVABLE);


"use strict";









var $41bf387f6ce262e6$var$$$OBSERVABLE = $cb598f706b77edff$exports("observable");
// `Observable.from` method
// https://github.com/tc39/proposal-observable
$95f391e8d3de298b$exports({
    target: "Observable",
    stat: true,
    forced: true
}, {
    from: function from(x) {
        var C = $c4cbaf47a62f8816$exports(this) ? this : $a86b7d926328b4a8$exports("Observable");
        var observableMethod = $a313ad37d47c05ba$exports($d8eb1c0d5fd2deb8$exports(x), $41bf387f6ce262e6$var$$$OBSERVABLE);
        if (observableMethod) {
            var observable = $d8eb1c0d5fd2deb8$exports($97bce1c6dc77a53b$exports(observableMethod, x));
            return observable.constructor === C ? observable : new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        var iterator = $620af53cd726e10d$exports(x);
        return new C(function(observer) {
            $b3f339154d5ed3ac$exports(iterator, function(it, stop) {
                observer.next(it);
                if (observer.closed) return stop();
            }, {
                IS_ITERATOR: true,
                INTERRUPTED: true
            });
            observer.complete();
        });
    }
});


"use strict";



var $4498db8249376ddd$var$Array = $a86b7d926328b4a8$exports("Array");
// `Observable.of` method
// https://github.com/tc39/proposal-observable
$95f391e8d3de298b$exports({
    target: "Observable",
    stat: true,
    forced: true
}, {
    of: function of() {
        var C = $c4cbaf47a62f8816$exports(this) ? this : $a86b7d926328b4a8$exports("Observable");
        var length = arguments.length;
        var items = $4498db8249376ddd$var$Array(length);
        var index = 0;
        while(index < length)items[index] = arguments[index++];
        return new C(function(observer) {
            for(var i = 0; i < length; i++){
                observer.next(items[i]);
                if (observer.closed) return;
            }
            observer.complete();
        });
    }
});




"use strict";

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $61dc754d5ae3a31f$export$2d1720544b23b823;
"use strict";

var $61dc754d5ae3a31f$var$$TypeError = TypeError;
var $61dc754d5ae3a31f$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $61dc754d5ae3a31f$var$$TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $b036d6e8e8a1e730$exports(resolve);
    this.reject = $b036d6e8e8a1e730$exports(reject);
};
$61dc754d5ae3a31f$export$2d1720544b23b823 = function(C) {
    return new $61dc754d5ae3a31f$var$PromiseCapability(C);
};


var $72b6d3896ef61ab7$exports = {};
"use strict";
$72b6d3896ef61ab7$exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};


// `Promise.try` method
// https://github.com/tc39/proposal-promise-try
$95f391e8d3de298b$exports({
    target: "Promise",
    stat: true,
    forced: true
}, {
    "try": function(callbackfn) {
        var promiseCapability = $61dc754d5ae3a31f$export$2d1720544b23b823(this);
        var result = $72b6d3896ef61ab7$exports(callbackfn);
        (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
        return promiseCapability.promise;
    }
});


"use strict";

var $5991c3b9cc20c2ea$exports = {};
"use strict";





var $5991c3b9cc20c2ea$var$Map = $a86b7d926328b4a8$exports("Map");
var $5991c3b9cc20c2ea$var$WeakMap = $a86b7d926328b4a8$exports("WeakMap");
var $5991c3b9cc20c2ea$var$push = $2098731ff14c1b28$exports([].push);
var $5991c3b9cc20c2ea$var$metadata = $de387bee9c871371$exports("metadata");
var $5991c3b9cc20c2ea$var$store = $5991c3b9cc20c2ea$var$metadata.store || ($5991c3b9cc20c2ea$var$metadata.store = new $5991c3b9cc20c2ea$var$WeakMap());
var $5991c3b9cc20c2ea$var$getOrCreateMetadataMap = function(target, targetKey, create) {
    var targetMetadata = $5991c3b9cc20c2ea$var$store.get(target);
    if (!targetMetadata) {
        if (!create) return;
        $5991c3b9cc20c2ea$var$store.set(target, targetMetadata = new $5991c3b9cc20c2ea$var$Map());
    }
    var keyMetadata = targetMetadata.get(targetKey);
    if (!keyMetadata) {
        if (!create) return;
        targetMetadata.set(targetKey, keyMetadata = new $5991c3b9cc20c2ea$var$Map());
    }
    return keyMetadata;
};
var $5991c3b9cc20c2ea$var$ordinaryHasOwnMetadata = function(MetadataKey, O, P) {
    var metadataMap = $5991c3b9cc20c2ea$var$getOrCreateMetadataMap(O, P, false);
    return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var $5991c3b9cc20c2ea$var$ordinaryGetOwnMetadata = function(MetadataKey, O, P) {
    var metadataMap = $5991c3b9cc20c2ea$var$getOrCreateMetadataMap(O, P, false);
    return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var $5991c3b9cc20c2ea$var$ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P) {
    $5991c3b9cc20c2ea$var$getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var $5991c3b9cc20c2ea$var$ordinaryOwnMetadataKeys = function(target, targetKey) {
    var metadataMap = $5991c3b9cc20c2ea$var$getOrCreateMetadataMap(target, targetKey, false);
    var keys = [];
    if (metadataMap) metadataMap.forEach(function(_, key) {
        $5991c3b9cc20c2ea$var$push(keys, key);
    });
    return keys;
};
var $5991c3b9cc20c2ea$var$toMetadataKey = function(it) {
    return it === undefined || typeof it == "symbol" ? it : String(it);
};
$5991c3b9cc20c2ea$exports = {
    store: $5991c3b9cc20c2ea$var$store,
    getMap: $5991c3b9cc20c2ea$var$getOrCreateMetadataMap,
    has: $5991c3b9cc20c2ea$var$ordinaryHasOwnMetadata,
    get: $5991c3b9cc20c2ea$var$ordinaryGetOwnMetadata,
    set: $5991c3b9cc20c2ea$var$ordinaryDefineOwnMetadata,
    keys: $5991c3b9cc20c2ea$var$ordinaryOwnMetadataKeys,
    toKey: $5991c3b9cc20c2ea$var$toMetadataKey
};



var $ca6b2674dc0e49d6$var$toMetadataKey = $5991c3b9cc20c2ea$exports.toKey;
var $ca6b2674dc0e49d6$var$ordinaryDefineOwnMetadata = $5991c3b9cc20c2ea$exports.set;
// `Reflect.defineMetadata` method
// https://github.com/rbuckton/reflect-metadata
$95f391e8d3de298b$exports({
    target: "Reflect",
    stat: true
}, {
    defineMetadata: function defineMetadata(metadataKey, metadataValue, target /* , targetKey */ ) {
        var targetKey = arguments.length < 4 ? undefined : $ca6b2674dc0e49d6$var$toMetadataKey(arguments[3]);
        $ca6b2674dc0e49d6$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, $d8eb1c0d5fd2deb8$exports(target), targetKey);
    }
});


"use strict";



var $9c6c8a73bb6d545d$var$toMetadataKey = $5991c3b9cc20c2ea$exports.toKey;
var $9c6c8a73bb6d545d$var$getOrCreateMetadataMap = $5991c3b9cc20c2ea$exports.getMap;
var $9c6c8a73bb6d545d$var$store = $5991c3b9cc20c2ea$exports.store;
// `Reflect.deleteMetadata` method
// https://github.com/rbuckton/reflect-metadata
$95f391e8d3de298b$exports({
    target: "Reflect",
    stat: true
}, {
    deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $9c6c8a73bb6d545d$var$toMetadataKey(arguments[2]);
        var metadataMap = $9c6c8a73bb6d545d$var$getOrCreateMetadataMap($d8eb1c0d5fd2deb8$exports(target), targetKey, false);
        if (metadataMap === undefined || !metadataMap["delete"](metadataKey)) return false;
        if (metadataMap.size) return true;
        var targetMetadata = $9c6c8a73bb6d545d$var$store.get(target);
        targetMetadata["delete"](targetKey);
        return !!targetMetadata.size || $9c6c8a73bb6d545d$var$store["delete"](target);
    }
});


"use strict";




var $880cacd862cc0396$var$ordinaryHasOwnMetadata = $5991c3b9cc20c2ea$exports.has;
var $880cacd862cc0396$var$ordinaryGetOwnMetadata = $5991c3b9cc20c2ea$exports.get;
var $880cacd862cc0396$var$toMetadataKey = $5991c3b9cc20c2ea$exports.toKey;
var $880cacd862cc0396$var$ordinaryGetMetadata = function(MetadataKey, O, P) {
    var hasOwn = $880cacd862cc0396$var$ordinaryHasOwnMetadata(MetadataKey, O, P);
    if (hasOwn) return $880cacd862cc0396$var$ordinaryGetOwnMetadata(MetadataKey, O, P);
    var parent = $f973d2f7bb2b70b9$exports(O);
    return parent !== null ? $880cacd862cc0396$var$ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};
// `Reflect.getMetadata` method
// https://github.com/rbuckton/reflect-metadata
$95f391e8d3de298b$exports({
    target: "Reflect",
    stat: true
}, {
    getMetadata: function getMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $880cacd862cc0396$var$toMetadataKey(arguments[2]);
        return $880cacd862cc0396$var$ordinaryGetMetadata(metadataKey, $d8eb1c0d5fd2deb8$exports(target), targetKey);
    }
});


"use strict";





var $897661d597a2c2fa$exports = {};
"use strict";







var $897661d597a2c2fa$var$Map = $c35f70d4799c833d$exports.Map;
var $897661d597a2c2fa$var$mapHas = $c35f70d4799c833d$exports.has;
var $897661d597a2c2fa$var$mapSet = $c35f70d4799c833d$exports.set;
var $897661d597a2c2fa$var$push = $2098731ff14c1b28$exports([].push);
// `Array.prototype.uniqueBy` method
// https://github.com/tc39/proposal-array-unique
$897661d597a2c2fa$exports = function uniqueBy(resolver) {
    var that = $c935e8e6600f2e7c$exports(this);
    var length = $3032eb0255f70567$exports(that);
    var result = [];
    var map = new $897661d597a2c2fa$var$Map();
    var resolverFunction = !$0948cee6bccbdbb6$exports(resolver) ? $b036d6e8e8a1e730$exports(resolver) : function(value) {
        return value;
    };
    var index, item, key;
    for(index = 0; index < length; index++){
        item = that[index];
        key = resolverFunction(item);
        if (!$897661d597a2c2fa$var$mapHas(map, key)) $897661d597a2c2fa$var$mapSet(map, key, item);
    }
    $af38299ad37577dd$exports(map, function(value) {
        $897661d597a2c2fa$var$push(result, value);
    });
    return result;
};


var $5a6d7f0526fbafd5$var$arrayUniqueBy = $2098731ff14c1b28$exports($897661d597a2c2fa$exports);
var $5a6d7f0526fbafd5$var$concat = $2098731ff14c1b28$exports([].concat);
var $5a6d7f0526fbafd5$var$ordinaryOwnMetadataKeys = $5991c3b9cc20c2ea$exports.keys;
var $5a6d7f0526fbafd5$var$toMetadataKey = $5991c3b9cc20c2ea$exports.toKey;
var $5a6d7f0526fbafd5$var$ordinaryMetadataKeys = function(O, P) {
    var oKeys = $5a6d7f0526fbafd5$var$ordinaryOwnMetadataKeys(O, P);
    var parent = $f973d2f7bb2b70b9$exports(O);
    if (parent === null) return oKeys;
    var pKeys = $5a6d7f0526fbafd5$var$ordinaryMetadataKeys(parent, P);
    return pKeys.length ? oKeys.length ? $5a6d7f0526fbafd5$var$arrayUniqueBy($5a6d7f0526fbafd5$var$concat(oKeys, pKeys)) : pKeys : oKeys;
};
// `Reflect.getMetadataKeys` method
// https://github.com/rbuckton/reflect-metadata
$95f391e8d3de298b$exports({
    target: "Reflect",
    stat: true
}, {
    getMetadataKeys: function getMetadataKeys(target /* , targetKey */ ) {
        var targetKey = arguments.length < 2 ? undefined : $5a6d7f0526fbafd5$var$toMetadataKey(arguments[1]);
        return $5a6d7f0526fbafd5$var$ordinaryMetadataKeys($d8eb1c0d5fd2deb8$exports(target), targetKey);
    }
});


"use strict";



var $819db4f5fd9e2cdc$var$ordinaryGetOwnMetadata = $5991c3b9cc20c2ea$exports.get;
var $819db4f5fd9e2cdc$var$toMetadataKey = $5991c3b9cc20c2ea$exports.toKey;
// `Reflect.getOwnMetadata` method
// https://github.com/rbuckton/reflect-metadata
$95f391e8d3de298b$exports({
    target: "Reflect",
    stat: true
}, {
    getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $819db4f5fd9e2cdc$var$toMetadataKey(arguments[2]);
        return $819db4f5fd9e2cdc$var$ordinaryGetOwnMetadata(metadataKey, $d8eb1c0d5fd2deb8$exports(target), targetKey);
    }
});


"use strict";



var $e40905ab1a05b2ff$var$ordinaryOwnMetadataKeys = $5991c3b9cc20c2ea$exports.keys;
var $e40905ab1a05b2ff$var$toMetadataKey = $5991c3b9cc20c2ea$exports.toKey;
// `Reflect.getOwnMetadataKeys` method
// https://github.com/rbuckton/reflect-metadata
$95f391e8d3de298b$exports({
    target: "Reflect",
    stat: true
}, {
    getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */ ) {
        var targetKey = arguments.length < 2 ? undefined : $e40905ab1a05b2ff$var$toMetadataKey(arguments[1]);
        return $e40905ab1a05b2ff$var$ordinaryOwnMetadataKeys($d8eb1c0d5fd2deb8$exports(target), targetKey);
    }
});


"use strict";




var $73bd41a58cf5cf70$var$ordinaryHasOwnMetadata = $5991c3b9cc20c2ea$exports.has;
var $73bd41a58cf5cf70$var$toMetadataKey = $5991c3b9cc20c2ea$exports.toKey;
var $73bd41a58cf5cf70$var$ordinaryHasMetadata = function(MetadataKey, O, P) {
    var hasOwn = $73bd41a58cf5cf70$var$ordinaryHasOwnMetadata(MetadataKey, O, P);
    if (hasOwn) return true;
    var parent = $f973d2f7bb2b70b9$exports(O);
    return parent !== null ? $73bd41a58cf5cf70$var$ordinaryHasMetadata(MetadataKey, parent, P) : false;
};
// `Reflect.hasMetadata` method
// https://github.com/rbuckton/reflect-metadata
$95f391e8d3de298b$exports({
    target: "Reflect",
    stat: true
}, {
    hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $73bd41a58cf5cf70$var$toMetadataKey(arguments[2]);
        return $73bd41a58cf5cf70$var$ordinaryHasMetadata(metadataKey, $d8eb1c0d5fd2deb8$exports(target), targetKey);
    }
});


"use strict";



var $9b0e1ec9f2b4ceca$var$ordinaryHasOwnMetadata = $5991c3b9cc20c2ea$exports.has;
var $9b0e1ec9f2b4ceca$var$toMetadataKey = $5991c3b9cc20c2ea$exports.toKey;
// `Reflect.hasOwnMetadata` method
// https://github.com/rbuckton/reflect-metadata
$95f391e8d3de298b$exports({
    target: "Reflect",
    stat: true
}, {
    hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $9b0e1ec9f2b4ceca$var$toMetadataKey(arguments[2]);
        return $9b0e1ec9f2b4ceca$var$ordinaryHasOwnMetadata(metadataKey, $d8eb1c0d5fd2deb8$exports(target), targetKey);
    }
});


"use strict";



var $f1864c9d9647bf4c$var$toMetadataKey = $5991c3b9cc20c2ea$exports.toKey;
var $f1864c9d9647bf4c$var$ordinaryDefineOwnMetadata = $5991c3b9cc20c2ea$exports.set;
// `Reflect.metadata` method
// https://github.com/rbuckton/reflect-metadata
$95f391e8d3de298b$exports({
    target: "Reflect",
    stat: true
}, {
    metadata: function metadata(metadataKey, metadataValue) {
        return function decorator(target, key) {
            $f1864c9d9647bf4c$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, $d8eb1c0d5fd2deb8$exports(target), $f1864c9d9647bf4c$var$toMetadataKey(key));
        };
    }
});


"use strict";

var $c8060503340d681e$exports = {};
"use strict";
var $6ca939b42bcd5712$exports = {};
"use strict";

// eslint-disable-next-line es/no-set -- safe
var $6ca939b42bcd5712$var$SetPrototype = Set.prototype;
$6ca939b42bcd5712$exports = {
    // eslint-disable-next-line es/no-set -- safe
    Set: Set,
    add: $2098731ff14c1b28$exports($6ca939b42bcd5712$var$SetPrototype.add),
    has: $2098731ff14c1b28$exports($6ca939b42bcd5712$var$SetPrototype.has),
    remove: $2098731ff14c1b28$exports($6ca939b42bcd5712$var$SetPrototype["delete"]),
    proto: $6ca939b42bcd5712$var$SetPrototype
};


var $c8060503340d681e$require$has = $6ca939b42bcd5712$exports.has;
// Perform ? RequireInternalSlot(M, [[SetData]])
$c8060503340d681e$exports = function(it) {
    $c8060503340d681e$require$has(it);
    return it;
};



var $5e311b49f7b17ffc$require$add = $6ca939b42bcd5712$exports.add;
// `Set.prototype.addAll` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    addAll: function addAll() {
        var set = $c8060503340d681e$exports(this);
        for(var k = 0, len = arguments.length; k < len; k++)$5e311b49f7b17ffc$require$add(set, arguments[k]);
        return set;
    }
});


"use strict";



var $a6666f8b16f572a0$require$remove = $6ca939b42bcd5712$exports.remove;
// `Set.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    deleteAll: function deleteAll() {
        var collection = $c8060503340d681e$exports(this);
        var allDeleted = true;
        var wasDeleted;
        for(var k = 0, len = arguments.length; k < len; k++){
            wasDeleted = $a6666f8b16f572a0$require$remove(collection, arguments[k]);
            allDeleted = allDeleted && wasDeleted;
        }
        return !!allDeleted;
    }
});


"use strict";


var $84df159ee1379d37$exports = {};
"use strict";


var $d2c632cfac98ab76$exports = {};
"use strict";





var $d2c632cfac98ab76$var$ITERATOR = $cb598f706b77edff$exports("iterator");
var $d2c632cfac98ab76$var$$Object = Object;
$d2c632cfac98ab76$exports = function(it) {
    if ($0948cee6bccbdbb6$exports(it)) return false;
    var O = $d2c632cfac98ab76$var$$Object(it);
    return O[$d2c632cfac98ab76$var$ITERATOR] !== undefined || "@@iterator" in O || $cc844053de03f4cb$exports($f50f2c649b76428d$exports, $57a4f5441e1bbe20$exports(O));
};



var $84df159ee1379d37$var$Set = $a86b7d926328b4a8$exports("Set");
var $84df159ee1379d37$var$isSetLike = function(it) {
    return $79b55cb30ab000ec$exports(it) && typeof it.size == "number" && $fa64b91b5990a54e$exports(it.has) && $fa64b91b5990a54e$exports(it.keys);
};
// fallback old -> new set methods proposal arguments
$84df159ee1379d37$exports = function(it) {
    if ($84df159ee1379d37$var$isSetLike(it)) return it;
    return $d2c632cfac98ab76$exports(it) ? new $84df159ee1379d37$var$Set(it) : it;
};


var $d17f70790854df84$exports = {};
"use strict";


var $c57539c8b1887a2a$exports = {};
"use strict";

var $47a179a10aaa4191$exports = {};
"use strict";



var $47a179a10aaa4191$var$Set = $6ca939b42bcd5712$exports.Set;
var $47a179a10aaa4191$var$SetPrototype = $6ca939b42bcd5712$exports.proto;
var $47a179a10aaa4191$var$forEach = $2098731ff14c1b28$exports($47a179a10aaa4191$var$SetPrototype.forEach);
var $47a179a10aaa4191$var$keys = $2098731ff14c1b28$exports($47a179a10aaa4191$var$SetPrototype.keys);
var $47a179a10aaa4191$var$next = $47a179a10aaa4191$var$keys(new $47a179a10aaa4191$var$Set()).next;
$47a179a10aaa4191$exports = function(set, fn, interruptible) {
    return interruptible ? $64a3adaebb98edf6$exports({
        iterator: $47a179a10aaa4191$var$keys(set),
        next: $47a179a10aaa4191$var$next
    }, fn) : $47a179a10aaa4191$var$forEach(set, fn);
};


var $c57539c8b1887a2a$var$Set = $6ca939b42bcd5712$exports.Set;
var $c57539c8b1887a2a$var$add = $6ca939b42bcd5712$exports.add;
$c57539c8b1887a2a$exports = function(set) {
    var result = new $c57539c8b1887a2a$var$Set();
    $47a179a10aaa4191$exports(set, function(it) {
        $c57539c8b1887a2a$var$add(result, it);
    });
    return result;
};


var $6d92a57c55b1aa74$exports = {};
"use strict";


$6d92a57c55b1aa74$exports = $343410f26483b7ff$exports($6ca939b42bcd5712$exports.proto, "size", "get") || function(set) {
    return set.size;
};


var $abbf0db6d1fc5668$exports = {};
"use strict";




var $c1b66bcbbc07f73f$exports = {};
"use strict";
// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
$c1b66bcbbc07f73f$exports = function(obj) {
    return {
        iterator: obj,
        next: obj.next,
        done: false
    };
};


var $abbf0db6d1fc5668$var$INVALID_SIZE = "Invalid size";
var $abbf0db6d1fc5668$var$$RangeError = RangeError;
var $abbf0db6d1fc5668$var$$TypeError = TypeError;
var $abbf0db6d1fc5668$var$max = Math.max;
var $abbf0db6d1fc5668$var$SetRecord = function(set, size, has, keys) {
    this.set = set;
    this.size = size;
    this.has = has;
    this.keys = keys;
};
$abbf0db6d1fc5668$var$SetRecord.prototype = {
    getIterator: function() {
        return $c1b66bcbbc07f73f$exports($d8eb1c0d5fd2deb8$exports($97bce1c6dc77a53b$exports(this.keys, this.set)));
    },
    includes: function(it) {
        return $97bce1c6dc77a53b$exports(this.has, this.set, it);
    }
};
// `GetSetRecord` abstract operation
// https://tc39.es/proposal-set-methods/#sec-getsetrecord
$abbf0db6d1fc5668$exports = function(obj) {
    $d8eb1c0d5fd2deb8$exports(obj);
    var numSize = +obj.size;
    // NOTE: If size is undefined, then numSize will be NaN
    // eslint-disable-next-line no-self-compare -- NaN check
    if (numSize !== numSize) throw new $abbf0db6d1fc5668$var$$TypeError($abbf0db6d1fc5668$var$INVALID_SIZE);
    var intSize = $cdf3b3f376b00406$exports(numSize);
    if (intSize < 0) throw new $abbf0db6d1fc5668$var$$RangeError($abbf0db6d1fc5668$var$INVALID_SIZE);
    return new $abbf0db6d1fc5668$var$SetRecord(obj, $abbf0db6d1fc5668$var$max(intSize, 0), $b036d6e8e8a1e730$exports(obj.has), $b036d6e8e8a1e730$exports(obj.keys));
};




var $d17f70790854df84$var$has = $6ca939b42bcd5712$exports.has;
var $d17f70790854df84$var$remove = $6ca939b42bcd5712$exports.remove;
// `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods
$d17f70790854df84$exports = function difference(other) {
    var O = $c8060503340d681e$exports(this);
    var otherRec = $abbf0db6d1fc5668$exports(other);
    var result = $c57539c8b1887a2a$exports(O);
    if ($6d92a57c55b1aa74$exports(O) <= otherRec.size) $47a179a10aaa4191$exports(O, function(e) {
        if (otherRec.includes(e)) $d17f70790854df84$var$remove(result, e);
    });
    else $64a3adaebb98edf6$exports(otherRec.getIterator(), function(e) {
        if ($d17f70790854df84$var$has(O, e)) $d17f70790854df84$var$remove(result, e);
    });
    return result;
};


// `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$95f391e8d3de298b$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    difference: function difference(other) {
        return $97bce1c6dc77a53b$exports($d17f70790854df84$exports, this, $84df159ee1379d37$exports(other));
    }
});


"use strict";




// `Set.prototype.every` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    every: function every(callbackfn /* , thisArg */ ) {
        var set = $c8060503340d681e$exports(this);
        var boundFunction = $b4fa206c62a6dcdd$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return $47a179a10aaa4191$exports(set, function(value) {
            if (!boundFunction(value, value, set)) return false;
        }, true) !== false;
    }
});


"use strict";





var $c071248e15159c82$var$Set = $6ca939b42bcd5712$exports.Set;
var $c071248e15159c82$var$add = $6ca939b42bcd5712$exports.add;
// `Set.prototype.filter` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        var set = $c8060503340d681e$exports(this);
        var boundFunction = $b4fa206c62a6dcdd$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newSet = new $c071248e15159c82$var$Set();
        $47a179a10aaa4191$exports(set, function(value) {
            if (boundFunction(value, value, set)) $c071248e15159c82$var$add(newSet, value);
        });
        return newSet;
    }
});


"use strict";




// `Set.prototype.find` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    find: function find(callbackfn /* , thisArg */ ) {
        var set = $c8060503340d681e$exports(this);
        var boundFunction = $b4fa206c62a6dcdd$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var result = $47a179a10aaa4191$exports(set, function(value) {
            if (boundFunction(value, value, set)) return {
                value: value
            };
        }, true);
        return result && result.value;
    }
});


"use strict";


// `Set.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
$95f391e8d3de298b$exports({
    target: "Set",
    stat: true,
    forced: true
}, {
    from: $59e9c5bffa4c565d$exports
});


"use strict";



var $8fb1fad544ffad5b$exports = {};
"use strict";






var $8fb1fad544ffad5b$var$Set = $6ca939b42bcd5712$exports.Set;
var $8fb1fad544ffad5b$var$add = $6ca939b42bcd5712$exports.add;
var $8fb1fad544ffad5b$var$has = $6ca939b42bcd5712$exports.has;
// `Set.prototype.intersection` method
// https://github.com/tc39/proposal-set-methods
$8fb1fad544ffad5b$exports = function intersection(other) {
    var O = $c8060503340d681e$exports(this);
    var otherRec = $abbf0db6d1fc5668$exports(other);
    var result = new $8fb1fad544ffad5b$var$Set();
    if ($6d92a57c55b1aa74$exports(O) > otherRec.size) $64a3adaebb98edf6$exports(otherRec.getIterator(), function(e) {
        if ($8fb1fad544ffad5b$var$has(O, e)) $8fb1fad544ffad5b$var$add(result, e);
    });
    else $47a179a10aaa4191$exports(O, function(e) {
        if (otherRec.includes(e)) $8fb1fad544ffad5b$var$add(result, e);
    });
    return result;
};


// `Set.prototype.intersection` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$95f391e8d3de298b$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    intersection: function intersection(other) {
        return $97bce1c6dc77a53b$exports($8fb1fad544ffad5b$exports, this, $84df159ee1379d37$exports(other));
    }
});


"use strict";



var $14f8442f5e107f8e$exports = {};
"use strict";


var $14f8442f5e107f8e$require$has = $6ca939b42bcd5712$exports.has;





// `Set.prototype.isDisjointFrom` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isDisjointFrom
$14f8442f5e107f8e$exports = function isDisjointFrom(other) {
    var O = $c8060503340d681e$exports(this);
    var otherRec = $abbf0db6d1fc5668$exports(other);
    if ($6d92a57c55b1aa74$exports(O) <= otherRec.size) return $47a179a10aaa4191$exports(O, function(e) {
        if (otherRec.includes(e)) return false;
    }, true) !== false;
    var iterator = otherRec.getIterator();
    return $64a3adaebb98edf6$exports(iterator, function(e) {
        if ($14f8442f5e107f8e$require$has(O, e)) return $950ee1b8659bce7b$exports(iterator, "normal", false);
    }) !== false;
};


// `Set.prototype.isDisjointFrom` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$95f391e8d3de298b$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    isDisjointFrom: function isDisjointFrom(other) {
        return $97bce1c6dc77a53b$exports($14f8442f5e107f8e$exports, this, $84df159ee1379d37$exports(other));
    }
});


"use strict";



var $84b4927e227c7dd4$exports = {};
"use strict";




// `Set.prototype.isSubsetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSubsetOf
$84b4927e227c7dd4$exports = function isSubsetOf(other) {
    var O = $c8060503340d681e$exports(this);
    var otherRec = $abbf0db6d1fc5668$exports(other);
    if ($6d92a57c55b1aa74$exports(O) > otherRec.size) return false;
    return $47a179a10aaa4191$exports(O, function(e) {
        if (!otherRec.includes(e)) return false;
    }, true) !== false;
};


// `Set.prototype.isSubsetOf` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$95f391e8d3de298b$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    isSubsetOf: function isSubsetOf(other) {
        return $97bce1c6dc77a53b$exports($84b4927e227c7dd4$exports, this, $84df159ee1379d37$exports(other));
    }
});


"use strict";



var $7711c1cf3d8c0b64$exports = {};
"use strict";


var $7711c1cf3d8c0b64$require$has = $6ca939b42bcd5712$exports.has;




// `Set.prototype.isSupersetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSupersetOf
$7711c1cf3d8c0b64$exports = function isSupersetOf(other) {
    var O = $c8060503340d681e$exports(this);
    var otherRec = $abbf0db6d1fc5668$exports(other);
    if ($6d92a57c55b1aa74$exports(O) < otherRec.size) return false;
    var iterator = otherRec.getIterator();
    return $64a3adaebb98edf6$exports(iterator, function(e) {
        if (!$7711c1cf3d8c0b64$require$has(O, e)) return $950ee1b8659bce7b$exports(iterator, "normal", false);
    }) !== false;
};


// `Set.prototype.isSupersetOf` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$95f391e8d3de298b$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    isSupersetOf: function isSupersetOf(other) {
        return $97bce1c6dc77a53b$exports($7711c1cf3d8c0b64$exports, this, $84df159ee1379d37$exports(other));
    }
});


"use strict";




var $95945a7ecec6d8d5$exports = {};
"use strict";

var $95945a7ecec6d8d5$var$$String = String;
$95945a7ecec6d8d5$exports = function(argument) {
    if ($57a4f5441e1bbe20$exports(argument) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return $95945a7ecec6d8d5$var$$String(argument);
};


var $241082ee59d6a0d4$var$arrayJoin = $2098731ff14c1b28$exports([].join);
var $241082ee59d6a0d4$var$push = $2098731ff14c1b28$exports([].push);
// `Set.prototype.join` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    join: function join(separator) {
        var set = $c8060503340d681e$exports(this);
        var sep = separator === undefined ? "," : $95945a7ecec6d8d5$exports(separator);
        var array = [];
        $47a179a10aaa4191$exports(set, function(value) {
            $241082ee59d6a0d4$var$push(array, value);
        });
        return $241082ee59d6a0d4$var$arrayJoin(array, sep);
    }
});


"use strict";





var $16d3e1f6b6251f4e$var$Set = $6ca939b42bcd5712$exports.Set;
var $16d3e1f6b6251f4e$var$add = $6ca939b42bcd5712$exports.add;
// `Set.prototype.map` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    map: function map(callbackfn /* , thisArg */ ) {
        var set = $c8060503340d681e$exports(this);
        var boundFunction = $b4fa206c62a6dcdd$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newSet = new $16d3e1f6b6251f4e$var$Set();
        $47a179a10aaa4191$exports(set, function(value) {
            $16d3e1f6b6251f4e$var$add(newSet, boundFunction(value, value, set));
        });
        return newSet;
    }
});


"use strict";


// `Set.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
$95f391e8d3de298b$exports({
    target: "Set",
    stat: true,
    forced: true
}, {
    of: $07a6b5ee07d29197$exports
});


"use strict";




var $b60b394aea867b5e$var$$TypeError = TypeError;
// `Set.prototype.reduce` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var set = $c8060503340d681e$exports(this);
        var noInitial = arguments.length < 2;
        var accumulator = noInitial ? undefined : arguments[1];
        $b036d6e8e8a1e730$exports(callbackfn);
        $47a179a10aaa4191$exports(set, function(value) {
            if (noInitial) {
                noInitial = false;
                accumulator = value;
            } else accumulator = callbackfn(accumulator, value, value, set);
        });
        if (noInitial) throw new $b60b394aea867b5e$var$$TypeError("Reduce of empty set with no initial value");
        return accumulator;
    }
});


"use strict";




// `Set.prototype.some` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    some: function some(callbackfn /* , thisArg */ ) {
        var set = $c8060503340d681e$exports(this);
        var boundFunction = $b4fa206c62a6dcdd$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return $47a179a10aaa4191$exports(set, function(value) {
            if (boundFunction(value, value, set)) return true;
        }, true) === true;
    }
});


"use strict";



var $d55957ba663cb9f0$exports = {};
"use strict";





var $d55957ba663cb9f0$var$add = $6ca939b42bcd5712$exports.add;
var $d55957ba663cb9f0$var$has = $6ca939b42bcd5712$exports.has;
var $d55957ba663cb9f0$var$remove = $6ca939b42bcd5712$exports.remove;
// `Set.prototype.symmetricDifference` method
// https://github.com/tc39/proposal-set-methods
$d55957ba663cb9f0$exports = function symmetricDifference(other) {
    var O = $c8060503340d681e$exports(this);
    var keysIter = $abbf0db6d1fc5668$exports(other).getIterator();
    var result = $c57539c8b1887a2a$exports(O);
    $64a3adaebb98edf6$exports(keysIter, function(e) {
        if ($d55957ba663cb9f0$var$has(O, e)) $d55957ba663cb9f0$var$remove(result, e);
        else $d55957ba663cb9f0$var$add(result, e);
    });
    return result;
};


// `Set.prototype.symmetricDifference` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$95f391e8d3de298b$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    symmetricDifference: function symmetricDifference(other) {
        return $97bce1c6dc77a53b$exports($d55957ba663cb9f0$exports, this, $84df159ee1379d37$exports(other));
    }
});


"use strict";



var $3763b66b3694f881$exports = {};
"use strict";


var $3763b66b3694f881$require$add = $6ca939b42bcd5712$exports.add;



// `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods
$3763b66b3694f881$exports = function union(other) {
    var O = $c8060503340d681e$exports(this);
    var keysIter = $abbf0db6d1fc5668$exports(other).getIterator();
    var result = $c57539c8b1887a2a$exports(O);
    $64a3adaebb98edf6$exports(keysIter, function(it) {
        $3763b66b3694f881$require$add(result, it);
    });
    return result;
};


// `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$95f391e8d3de298b$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    union: function union(other) {
        return $97bce1c6dc77a53b$exports($3763b66b3694f881$exports, this, $84df159ee1379d37$exports(other));
    }
});


"use strict";

var $5a14bbfbe36baa35$exports = {};
"use strict";




var $5a14bbfbe36baa35$var$charAt = $2098731ff14c1b28$exports("".charAt);
var $5a14bbfbe36baa35$var$charCodeAt = $2098731ff14c1b28$exports("".charCodeAt);
var $5a14bbfbe36baa35$var$stringSlice = $2098731ff14c1b28$exports("".slice);
var $5a14bbfbe36baa35$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $95945a7ecec6d8d5$exports($27cd7a1a0cbe9d9e$exports($this));
        var position = $cdf3b3f376b00406$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $5a14bbfbe36baa35$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $5a14bbfbe36baa35$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $5a14bbfbe36baa35$var$charAt(S, position) : first : CONVERT_TO_STRING ? $5a14bbfbe36baa35$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$5a14bbfbe36baa35$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $5a14bbfbe36baa35$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $5a14bbfbe36baa35$var$createMethod(true)
};


var $3c14540f03dc5ffe$require$charAt = $5a14bbfbe36baa35$exports.charAt;



// `String.prototype.at` method
// https://github.com/mathiasbynens/String.prototype.at
$95f391e8d3de298b$exports({
    target: "String",
    proto: true,
    forced: true
}, {
    at: function at(index) {
        var S = $95945a7ecec6d8d5$exports($27cd7a1a0cbe9d9e$exports(this));
        var len = S.length;
        var relativeIndex = $cdf3b3f376b00406$exports(index);
        var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
        return k < 0 || k >= len ? undefined : $3c14540f03dc5ffe$require$charAt(S, k);
    }
});


"use strict";







var $5661167156d6e6f7$var$codeAt = $5a14bbfbe36baa35$exports.codeAt;
var $5661167156d6e6f7$var$charAt = $5a14bbfbe36baa35$exports.charAt;
var $5661167156d6e6f7$var$STRING_ITERATOR = "String Iterator";
var $5661167156d6e6f7$var$setInternalState = $9e1e01125ce84891$exports.set;
var $5661167156d6e6f7$var$getInternalState = $9e1e01125ce84891$exports.getterFor($5661167156d6e6f7$var$STRING_ITERATOR);
// TODO: unify with String#@@iterator
var $5661167156d6e6f7$var$$StringIterator = $2763c7c7e2bb8835$exports(function StringIterator(string) {
    $5661167156d6e6f7$var$setInternalState(this, {
        type: $5661167156d6e6f7$var$STRING_ITERATOR,
        string: string,
        index: 0
    });
}, "String", function next() {
    var state = $5661167156d6e6f7$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $26563010b7960a80$exports(undefined, true);
    point = $5661167156d6e6f7$var$charAt(string, index);
    state.index += point.length;
    return $26563010b7960a80$exports({
        codePoint: $5661167156d6e6f7$var$codeAt(point, 0),
        position: index
    }, false);
});
// `String.prototype.codePoints` method
// https://github.com/tc39/proposal-string-prototype-codepoints
$95f391e8d3de298b$exports({
    target: "String",
    proto: true,
    forced: true
}, {
    codePoints: function codePoints() {
        return new $5661167156d6e6f7$var$$StringIterator($95945a7ecec6d8d5$exports($27cd7a1a0cbe9d9e$exports(this)));
    }
});


"use strict";

var $b8bfbfe4a89a2666$exports = {};
"use strict";
var $0cd242abcb0ab356$exports = {};
"use strict";

$0cd242abcb0ab356$exports = $6eaaaed532023352$exports;



var $59eb5753dfe33fe0$export$2d1720544b23b823;
"use strict";

$59eb5753dfe33fe0$export$2d1720544b23b823 = $cb598f706b77edff$exports;



var $b8bfbfe4a89a2666$require$defineProperty = $28aaf61ac32ff41d$export$2d1720544b23b823;
$b8bfbfe4a89a2666$exports = function(NAME) {
    var Symbol = $0cd242abcb0ab356$exports.Symbol || ($0cd242abcb0ab356$exports.Symbol = {});
    if (!$cc844053de03f4cb$exports(Symbol, NAME)) $b8bfbfe4a89a2666$require$defineProperty(Symbol, NAME, {
        value: $59eb5753dfe33fe0$export$2d1720544b23b823(NAME)
    });
};



var $8de554bf9a879b5a$require$defineProperty = $28aaf61ac32ff41d$export$2d1720544b23b823;

var $8de554bf9a879b5a$require$getOwnPropertyDescriptor = $a1de5a78f57d3b17$export$2d1720544b23b823;
var $8de554bf9a879b5a$var$Symbol = $6eaaaed532023352$exports.Symbol;
// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
$b8bfbfe4a89a2666$exports("dispose");
if ($8de554bf9a879b5a$var$Symbol) {
    var $8de554bf9a879b5a$var$descriptor = $8de554bf9a879b5a$require$getOwnPropertyDescriptor($8de554bf9a879b5a$var$Symbol, "dispose");
    // workaround of NodeJS 20.4 bug
    // https://github.com/nodejs/node/issues/48699
    // and incorrect descriptor from some transpilers and userland helpers
    if ($8de554bf9a879b5a$var$descriptor.enumerable && $8de554bf9a879b5a$var$descriptor.configurable && $8de554bf9a879b5a$var$descriptor.writable) $8de554bf9a879b5a$require$defineProperty($8de554bf9a879b5a$var$Symbol, "dispose", {
        value: $8de554bf9a879b5a$var$descriptor.value,
        enumerable: false,
        configurable: false,
        writable: false
    });
}


"use strict";

// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
$b8bfbfe4a89a2666$exports("observable");


"use strict";

// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$b8bfbfe4a89a2666$exports("patternMatch");


"use strict";

var $96ad22e8e612c100$exports = {};
"use strict";
var $a0af75e64737a51f$exports = {};
"use strict";

// eslint-disable-next-line es/no-weak-map -- safe
var $a0af75e64737a51f$var$WeakMapPrototype = WeakMap.prototype;
$a0af75e64737a51f$exports = {
    // eslint-disable-next-line es/no-weak-map -- safe
    WeakMap: WeakMap,
    set: $2098731ff14c1b28$exports($a0af75e64737a51f$var$WeakMapPrototype.set),
    get: $2098731ff14c1b28$exports($a0af75e64737a51f$var$WeakMapPrototype.get),
    has: $2098731ff14c1b28$exports($a0af75e64737a51f$var$WeakMapPrototype.has),
    remove: $2098731ff14c1b28$exports($a0af75e64737a51f$var$WeakMapPrototype["delete"])
};


var $96ad22e8e612c100$require$has = $a0af75e64737a51f$exports.has;
// Perform ? RequireInternalSlot(M, [[WeakMapData]])
$96ad22e8e612c100$exports = function(it) {
    $96ad22e8e612c100$require$has(it);
    return it;
};



var $71982ada43af72b4$require$remove = $a0af75e64737a51f$exports.remove;
// `WeakMap.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "WeakMap",
    proto: true,
    real: true,
    forced: true
}, {
    deleteAll: function deleteAll() {
        var collection = $96ad22e8e612c100$exports(this);
        var allDeleted = true;
        var wasDeleted;
        for(var k = 0, len = arguments.length; k < len; k++){
            wasDeleted = $71982ada43af72b4$require$remove(collection, arguments[k]);
            allDeleted = allDeleted && wasDeleted;
        }
        return !!allDeleted;
    }
});


"use strict";


// `WeakMap.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
$95f391e8d3de298b$exports({
    target: "WeakMap",
    stat: true,
    forced: true
}, {
    from: $59e9c5bffa4c565d$exports
});


"use strict";


// `WeakMap.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
$95f391e8d3de298b$exports({
    target: "WeakMap",
    stat: true,
    forced: true
}, {
    of: $07a6b5ee07d29197$exports
});


"use strict";

var $074ad7d76d7e750b$exports = {};
"use strict";
var $23e4996687f43920$exports = {};
"use strict";

// eslint-disable-next-line es/no-weak-set -- safe
var $23e4996687f43920$var$WeakSetPrototype = WeakSet.prototype;
$23e4996687f43920$exports = {
    // eslint-disable-next-line es/no-weak-set -- safe
    WeakSet: WeakSet,
    add: $2098731ff14c1b28$exports($23e4996687f43920$var$WeakSetPrototype.add),
    has: $2098731ff14c1b28$exports($23e4996687f43920$var$WeakSetPrototype.has),
    remove: $2098731ff14c1b28$exports($23e4996687f43920$var$WeakSetPrototype["delete"])
};


var $074ad7d76d7e750b$require$has = $23e4996687f43920$exports.has;
// Perform ? RequireInternalSlot(M, [[WeakSetData]])
$074ad7d76d7e750b$exports = function(it) {
    $074ad7d76d7e750b$require$has(it);
    return it;
};



var $c12db49a055f4c3c$require$add = $23e4996687f43920$exports.add;
// `WeakSet.prototype.addAll` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "WeakSet",
    proto: true,
    real: true,
    forced: true
}, {
    addAll: function addAll() {
        var set = $074ad7d76d7e750b$exports(this);
        for(var k = 0, len = arguments.length; k < len; k++)$c12db49a055f4c3c$require$add(set, arguments[k]);
        return set;
    }
});


"use strict";



var $12ce0573606e88d9$require$remove = $23e4996687f43920$exports.remove;
// `WeakSet.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$95f391e8d3de298b$exports({
    target: "WeakSet",
    proto: true,
    real: true,
    forced: true
}, {
    deleteAll: function deleteAll() {
        var collection = $074ad7d76d7e750b$exports(this);
        var allDeleted = true;
        var wasDeleted;
        for(var k = 0, len = arguments.length; k < len; k++){
            wasDeleted = $12ce0573606e88d9$require$remove(collection, arguments[k]);
            allDeleted = allDeleted && wasDeleted;
        }
        return !!allDeleted;
    }
});


"use strict";


// `WeakSet.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
$95f391e8d3de298b$exports({
    target: "WeakSet",
    stat: true,
    forced: true
}, {
    from: $59e9c5bffa4c565d$exports
});


"use strict";


// `WeakSet.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
$95f391e8d3de298b$exports({
    target: "WeakSet",
    stat: true,
    forced: true
}, {
    of: $07a6b5ee07d29197$exports
});


"use strict";
"use strict";


var $df0dba6565cf3e21$exports = {};
"use strict";









var $23bb2a2009a3983b$exports = {};
"use strict";
var $23bb2a2009a3983b$var$$TypeError = TypeError;
$23bb2a2009a3983b$exports = function(passed, required) {
    if (passed < required) throw new $23bb2a2009a3983b$var$$TypeError("Not enough arguments");
    return passed;
};


var $b55858a7d1a5865e$exports = {};
"use strict";

// eslint-disable-next-line redos/no-vulnerable -- safe
$b55858a7d1a5865e$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($dee6150af074c33b$exports);


var $5b868cfcb5de28c4$exports = {};
"use strict";


$5b868cfcb5de28c4$exports = $6d25cd027215e59b$exports($6eaaaed532023352$exports.process) === "process";


var $df0dba6565cf3e21$var$set = $6eaaaed532023352$exports.setImmediate;
var $df0dba6565cf3e21$var$clear = $6eaaaed532023352$exports.clearImmediate;
var $df0dba6565cf3e21$var$process = $6eaaaed532023352$exports.process;
var $df0dba6565cf3e21$var$Dispatch = $6eaaaed532023352$exports.Dispatch;
var $df0dba6565cf3e21$var$Function = $6eaaaed532023352$exports.Function;
var $df0dba6565cf3e21$var$MessageChannel = $6eaaaed532023352$exports.MessageChannel;
var $df0dba6565cf3e21$var$String = $6eaaaed532023352$exports.String;
var $df0dba6565cf3e21$var$counter = 0;
var $df0dba6565cf3e21$var$queue = {};
var $df0dba6565cf3e21$var$ONREADYSTATECHANGE = "onreadystatechange";
var $df0dba6565cf3e21$var$$location, $df0dba6565cf3e21$var$defer, $df0dba6565cf3e21$var$channel, $df0dba6565cf3e21$var$port;
$03967c5c58b0637b$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $df0dba6565cf3e21$var$$location = $6eaaaed532023352$exports.location;
});
var $df0dba6565cf3e21$var$run = function(id) {
    if ($cc844053de03f4cb$exports($df0dba6565cf3e21$var$queue, id)) {
        var fn = $df0dba6565cf3e21$var$queue[id];
        delete $df0dba6565cf3e21$var$queue[id];
        fn();
    }
};
var $df0dba6565cf3e21$var$runner = function(id) {
    return function() {
        $df0dba6565cf3e21$var$run(id);
    };
};
var $df0dba6565cf3e21$var$eventListener = function(event) {
    $df0dba6565cf3e21$var$run(event.data);
};
var $df0dba6565cf3e21$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $6eaaaed532023352$exports.postMessage($df0dba6565cf3e21$var$String(id), $df0dba6565cf3e21$var$$location.protocol + "//" + $df0dba6565cf3e21$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$df0dba6565cf3e21$var$set || !$df0dba6565cf3e21$var$clear) {
    $df0dba6565cf3e21$var$set = function setImmediate(handler) {
        $23bb2a2009a3983b$exports(arguments.length, 1);
        var fn = $fa64b91b5990a54e$exports(handler) ? handler : $df0dba6565cf3e21$var$Function(handler);
        var args = $75c73594f840af83$exports(arguments, 1);
        $df0dba6565cf3e21$var$queue[++$df0dba6565cf3e21$var$counter] = function() {
            $6e1bcf3cbc68d00e$exports(fn, undefined, args);
        };
        $df0dba6565cf3e21$var$defer($df0dba6565cf3e21$var$counter);
        return $df0dba6565cf3e21$var$counter;
    };
    $df0dba6565cf3e21$var$clear = function clearImmediate(id) {
        delete $df0dba6565cf3e21$var$queue[id];
    };
    // Node.js 0.8-
    if ($5b868cfcb5de28c4$exports) $df0dba6565cf3e21$var$defer = function(id) {
        $df0dba6565cf3e21$var$process.nextTick($df0dba6565cf3e21$var$runner(id));
    };
    else if ($df0dba6565cf3e21$var$Dispatch && $df0dba6565cf3e21$var$Dispatch.now) $df0dba6565cf3e21$var$defer = function(id) {
        $df0dba6565cf3e21$var$Dispatch.now($df0dba6565cf3e21$var$runner(id));
    };
    else if ($df0dba6565cf3e21$var$MessageChannel && !$b55858a7d1a5865e$exports) {
        $df0dba6565cf3e21$var$channel = new $df0dba6565cf3e21$var$MessageChannel();
        $df0dba6565cf3e21$var$port = $df0dba6565cf3e21$var$channel.port2;
        $df0dba6565cf3e21$var$channel.port1.onmessage = $df0dba6565cf3e21$var$eventListener;
        $df0dba6565cf3e21$var$defer = $b4fa206c62a6dcdd$exports($df0dba6565cf3e21$var$port.postMessage, $df0dba6565cf3e21$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($6eaaaed532023352$exports.addEventListener && $fa64b91b5990a54e$exports($6eaaaed532023352$exports.postMessage) && !$6eaaaed532023352$exports.importScripts && $df0dba6565cf3e21$var$$location && $df0dba6565cf3e21$var$$location.protocol !== "file:" && !$03967c5c58b0637b$exports($df0dba6565cf3e21$var$globalPostMessageDefer)) {
        $df0dba6565cf3e21$var$defer = $df0dba6565cf3e21$var$globalPostMessageDefer;
        $6eaaaed532023352$exports.addEventListener("message", $df0dba6565cf3e21$var$eventListener, false);
    // IE8-
    } else if ($df0dba6565cf3e21$var$ONREADYSTATECHANGE in $28ae8aecb54c8b5b$exports("script")) $df0dba6565cf3e21$var$defer = function(id) {
        $878c9c54b4611e60$exports.appendChild($28ae8aecb54c8b5b$exports("script"))[$df0dba6565cf3e21$var$ONREADYSTATECHANGE] = function() {
            $878c9c54b4611e60$exports.removeChild(this);
            $df0dba6565cf3e21$var$run(id);
        };
    };
    else $df0dba6565cf3e21$var$defer = function(id) {
        setTimeout($df0dba6565cf3e21$var$runner(id), 0);
    };
}
$df0dba6565cf3e21$exports = {
    set: $df0dba6565cf3e21$var$set,
    clear: $df0dba6565cf3e21$var$clear
};


var $33d23ee91c8dd8fc$require$clearImmediate = $df0dba6565cf3e21$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$95f391e8d3de298b$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $6eaaaed532023352$exports.clearImmediate !== $33d23ee91c8dd8fc$require$clearImmediate
}, {
    clearImmediate: $33d23ee91c8dd8fc$require$clearImmediate
});


"use strict";



var $0177ad9487c07f67$require$setTask = $df0dba6565cf3e21$exports.set;
var $721efdaded8e0674$exports = {};
"use strict";



var $1b59020702dd0d7a$exports = {};
"use strict";
/* global Bun -- Bun case */ $1b59020702dd0d7a$exports = typeof Bun == "function" && Bun && typeof Bun.version == "string";





var $721efdaded8e0674$var$Function = $6eaaaed532023352$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $721efdaded8e0674$var$WRAP = /MSIE .\./.test($dee6150af074c33b$exports) || $1b59020702dd0d7a$exports && function() {
    var version = $6eaaaed532023352$exports.Bun.version.split(".");
    return version.length < 3 || version[0] === "0" && (version[1] < 3 || version[1] === "3" && version[2] === "0");
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$721efdaded8e0674$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $721efdaded8e0674$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $23bb2a2009a3983b$exports(arguments.length, 1) > firstParamIndex;
        var fn = $fa64b91b5990a54e$exports(handler) ? handler : $721efdaded8e0674$var$Function(handler);
        var params = boundArgs ? $75c73594f840af83$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $6e1bcf3cbc68d00e$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $0177ad9487c07f67$var$setImmediate = $6eaaaed532023352$exports.setImmediate ? $721efdaded8e0674$exports($0177ad9487c07f67$require$setTask, false) : $0177ad9487c07f67$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$95f391e8d3de298b$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $6eaaaed532023352$exports.setImmediate !== $0177ad9487c07f67$var$setImmediate
}, {
    setImmediate: $0177ad9487c07f67$var$setImmediate
});




var $14fc2f3a09df08ae$exports = {};
"use strict";

$14fc2f3a09df08ae$exports = (parcelRequire("2Qwp0"));


parcelRequire("gIfym");
var $c4a08725a78d51bf$exports = {};
"use strict";
function $c4a08725a78d51bf$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($c4a08725a78d51bf$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$c4a08725a78d51bf$var$checkDCE();

$c4a08725a78d51bf$exports = (parcelRequire("eN6q3"));




var $gIfym = parcelRequire("gIfym");

var $gIfym = parcelRequire("gIfym");
var $c65bfe520546a474$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c65bfe520546a474$var$ReactIs, $c65bfe520546a474$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$c65bfe520546a474$exports = (parcelRequire("kh2Rv"))();


var $78c4fc952655f552$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $78c4fc952655f552$export$84fe03429ed1b6d6 = [
    "onCopy",
    "onCut",
    "onPaste"
];
var $78c4fc952655f552$export$dbc46161504615f7 = [
    "onCompositionEnd",
    "onCompositionStart",
    "onCompositionUpdate"
];
var $78c4fc952655f552$export$fb6351c2666f0875 = [
    "onFocus",
    "onBlur"
];
var $78c4fc952655f552$export$4e58c1a9761ed81a = [
    "onInput",
    "onInvalid",
    "onReset",
    "onSubmit"
];
var $78c4fc952655f552$export$3bf7402f2a4eb3af = [
    "onLoad",
    "onError"
];
var $78c4fc952655f552$export$409c4891d97f97cf = [
    "onKeyDown",
    "onKeyPress",
    "onKeyUp"
];
var $78c4fc952655f552$export$6be5aa2386088264 = [
    "onAbort",
    "onCanPlay",
    "onCanPlayThrough",
    "onDurationChange",
    "onEmptied",
    "onEncrypted",
    "onEnded",
    "onError",
    "onLoadedData",
    "onLoadedMetadata",
    "onLoadStart",
    "onPause",
    "onPlay",
    "onPlaying",
    "onProgress",
    "onRateChange",
    "onSeeked",
    "onSeeking",
    "onStalled",
    "onSuspend",
    "onTimeUpdate",
    "onVolumeChange",
    "onWaiting"
];
var $78c4fc952655f552$export$3a6e2b8954613992 = [
    "onClick",
    "onContextMenu",
    "onDoubleClick",
    "onMouseDown",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseOut",
    "onMouseOver",
    "onMouseUp"
];
var $78c4fc952655f552$export$6c96379d5b8a2df7 = [
    "onDrag",
    "onDragEnd",
    "onDragEnter",
    "onDragExit",
    "onDragLeave",
    "onDragOver",
    "onDragStart",
    "onDrop"
];
var $78c4fc952655f552$export$d93346aa7735a637 = [
    "onSelect"
];
var $78c4fc952655f552$export$fa367689c659e65c = [
    "onTouchCancel",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart"
];
var $78c4fc952655f552$export$c731eab7619e00a0 = [
    "onPointerDown",
    "onPointerMove",
    "onPointerUp",
    "onPointerCancel",
    "onGotPointerCapture",
    "onLostPointerCapture",
    "onPointerEnter",
    "onPointerLeave",
    "onPointerOver",
    "onPointerOut"
];
var $78c4fc952655f552$export$bac3087b5cb826f6 = [
    "onScroll"
];
var $78c4fc952655f552$export$28298837799e00e8 = [
    "onWheel"
];
var $78c4fc952655f552$export$6ff45424014e7407 = [
    "onAnimationStart",
    "onAnimationEnd",
    "onAnimationIteration"
];
var $78c4fc952655f552$export$78878fc7bd50dc3e = [
    "onTransitionEnd"
];
var $78c4fc952655f552$export$477a88c5b93a108d = [
    "onToggle"
];
var $78c4fc952655f552$export$7212b61f9f58bd1 = [
    "onChange"
];
var $78c4fc952655f552$export$59ef7197c4d7b9dc = $78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray($78c4fc952655f552$var$__spreadArray([], $78c4fc952655f552$export$84fe03429ed1b6d6, true), $78c4fc952655f552$export$dbc46161504615f7, true), $78c4fc952655f552$export$fb6351c2666f0875, true), $78c4fc952655f552$export$4e58c1a9761ed81a, true), $78c4fc952655f552$export$3bf7402f2a4eb3af, true), $78c4fc952655f552$export$409c4891d97f97cf, true), $78c4fc952655f552$export$6be5aa2386088264, true), $78c4fc952655f552$export$3a6e2b8954613992, true), $78c4fc952655f552$export$6c96379d5b8a2df7, true), $78c4fc952655f552$export$d93346aa7735a637, true), $78c4fc952655f552$export$fa367689c659e65c, true), $78c4fc952655f552$export$c731eab7619e00a0, true), $78c4fc952655f552$export$bac3087b5cb826f6, true), $78c4fc952655f552$export$28298837799e00e8, true), $78c4fc952655f552$export$6ff45424014e7407, true), $78c4fc952655f552$export$78878fc7bd50dc3e, true), $78c4fc952655f552$export$7212b61f9f58bd1, true), $78c4fc952655f552$export$477a88c5b93a108d, true);
function $78c4fc952655f552$export$2e2bcd8739ae039(props, getArgs) {
    var eventProps = {};
    $78c4fc952655f552$export$59ef7197c4d7b9dc.forEach(function(eventName) {
        var eventHandler = props[eventName];
        if (!eventHandler) return;
        if (getArgs) eventProps[eventName] = function(event) {
            return eventHandler(event, getArgs(eventName));
        };
        else eventProps[eventName] = eventHandler;
    });
    return eventProps;
}


function $a2d1e3f291c1aac8$export$2e2bcd8739ae039(promise) {
    var isCancelled = false;
    var wrappedPromise = new Promise(function(resolve, reject) {
        promise.then(function(value) {
            return !isCancelled && resolve(value);
        }).catch(function(error) {
            return !isCancelled && reject(error);
        });
    });
    return {
        promise: wrappedPromise,
        cancel: function() {
            isCancelled = true;
        }
    };
}


function $8e4f30b640e1a870$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $8e4f30b640e1a870$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $8e4f30b640e1a870$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $8e4f30b640e1a870$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $8e4f30b640e1a870$export$2e2bcd8739ae039 = $8e4f30b640e1a870$export$4f5d2d50c9deca37;


var $51137fdf63eaf269$var$isProduction = true;
var $51137fdf63eaf269$var$prefix = "Invariant failed";
function $51137fdf63eaf269$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($51137fdf63eaf269$var$isProduction) throw new Error($51137fdf63eaf269$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($51137fdf63eaf269$var$prefix, ": ").concat(provided) : $51137fdf63eaf269$var$prefix;
    throw new Error(value);
}


var $f4f9b01701245dfa$var$isProduction = true;
function $f4f9b01701245dfa$var$warning(condition, message) {
    if (!$f4f9b01701245dfa$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $f4f9b01701245dfa$export$2e2bcd8739ae039 = $f4f9b01701245dfa$var$warning;



var $kFpAu = parcelRequire("kFpAu");
const $e63b29bf95759acf$var$pdfjs = "default" in $kFpAu ? $kFpAu["default"] : $kFpAu;
var $e63b29bf95759acf$export$2e2bcd8739ae039 = $e63b29bf95759acf$var$pdfjs;



var $gIfym = parcelRequire("gIfym");
"use client";
var $b7406b9166257ba4$export$2e2bcd8739ae039 = (0, $gIfym.createContext)(null);



var $gIfym = parcelRequire("gIfym");
function $876b96cc01b44bec$export$2e2bcd8739ae039({ children: children, type: type }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: `react-pdf__message react-pdf__message--${type}`
    }, children);
}


/* Copyright 2015 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
const $30dc112643bd7525$var$DEFAULT_LINK_REL = "noopener noreferrer nofollow";
class $30dc112643bd7525$export$2e2bcd8739ae039 {
    constructor(){
        this.externalLinkEnabled = true;
        this.externalLinkRel = undefined;
        this.externalLinkTarget = undefined;
        this.isInPresentationMode = false;
        this.pdfDocument = undefined;
        this.pdfViewer = undefined;
    }
    setDocument(pdfDocument) {
        this.pdfDocument = pdfDocument;
    }
    setViewer(pdfViewer) {
        this.pdfViewer = pdfViewer;
    }
    setExternalLinkRel(externalLinkRel) {
        this.externalLinkRel = externalLinkRel;
    }
    setExternalLinkTarget(externalLinkTarget) {
        this.externalLinkTarget = externalLinkTarget;
    }
    setHistory() {
    // Intentionally empty
    }
    get pagesCount() {
        return this.pdfDocument ? this.pdfDocument.numPages : 0;
    }
    get page() {
        (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(this.pdfViewer, "PDF viewer is not initialized.");
        return this.pdfViewer.currentPageNumber || 0;
    }
    set page(value) {
        (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(this.pdfViewer, "PDF viewer is not initialized.");
        this.pdfViewer.currentPageNumber = value;
    }
    // eslint-disable-next-line @typescript-eslint/class-literal-property-style
    get rotation() {
        return 0;
    }
    set rotation(value) {
    // Intentionally empty
    }
    goToDestination(dest) {
        return new Promise((resolve)=>{
            (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(this.pdfDocument, "PDF document not loaded.");
            (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(dest, "Destination is not specified.");
            if (typeof dest === "string") this.pdfDocument.getDestination(dest).then(resolve);
            else if (Array.isArray(dest)) resolve(dest);
            else dest.then(resolve);
        }).then((explicitDest)=>{
            (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(Array.isArray(explicitDest), `"${explicitDest}" is not a valid destination array.`);
            const destRef = explicitDest[0];
            new Promise((resolve)=>{
                (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(this.pdfDocument, "PDF document not loaded.");
                if (destRef instanceof Object) this.pdfDocument.getPageIndex(destRef).then((pageIndex)=>{
                    resolve(pageIndex);
                }).catch(()=>{
                    (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false, `"${destRef}" is not a valid page reference.`);
                });
                else if (typeof destRef === "number") resolve(destRef);
                else (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false, `"${destRef}" is not a valid destination reference.`);
            }).then((pageIndex)=>{
                const pageNumber = pageIndex + 1;
                (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(this.pdfViewer, "PDF viewer is not initialized.");
                (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(pageNumber >= 1 && pageNumber <= this.pagesCount, `"${pageNumber}" is not a valid page number.`);
                this.pdfViewer.scrollPageIntoView({
                    dest: explicitDest,
                    pageIndex: pageIndex,
                    pageNumber: pageNumber
                });
            });
        });
    }
    navigateTo(dest) {
        this.goToDestination(dest);
    }
    goToPage(pageNumber) {
        const pageIndex = pageNumber - 1;
        (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(this.pdfViewer, "PDF viewer is not initialized.");
        (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(pageNumber >= 1 && pageNumber <= this.pagesCount, `"${pageNumber}" is not a valid page number.`);
        this.pdfViewer.scrollPageIntoView({
            pageIndex: pageIndex,
            pageNumber: pageNumber
        });
    }
    addLinkAttributes(link, url, newWindow) {
        link.href = url;
        link.rel = this.externalLinkRel || $30dc112643bd7525$var$DEFAULT_LINK_REL;
        link.target = newWindow ? "_blank" : this.externalLinkTarget || "";
    }
    getDestinationHash() {
        return "#";
    }
    getAnchorUrl() {
        return "#";
    }
    setHash() {
    // Intentionally empty
    }
    executeNamedAction() {
    // Intentionally empty
    }
    cachePageRef() {
    // Intentionally empty
    }
    isPageVisible() {
        return true;
    }
    isPageCached() {
        return true;
    }
    executeSetOCGState() {
    // Intentionally empty
    }
}


// As defined in https://github.com/mozilla/pdf.js/blob/d9fac3459609a807be6506fb3441b5da4b154d14/src/shared/util.js#L371-L374
const $c47f90cf820d9305$var$PasswordResponses = {
    NEED_PASSWORD: 1,
    INCORRECT_PASSWORD: 2
};
var $c47f90cf820d9305$export$2e2bcd8739ae039 = $c47f90cf820d9305$var$PasswordResponses;




const $02e2df2893cf0bcc$export$4e09c449d6c407f7 = typeof document !== "undefined";
const $02e2df2893cf0bcc$export$d528e4159a0e221e = $02e2df2893cf0bcc$export$4e09c449d6c407f7 && window.location.protocol === "file:";
function $02e2df2893cf0bcc$export$4e62c701997796c1(variable) {
    return typeof variable !== "undefined";
}
function $02e2df2893cf0bcc$export$ef8866826b0b1f6d(variable) {
    return $02e2df2893cf0bcc$export$4e62c701997796c1(variable) && variable !== null;
}
function $02e2df2893cf0bcc$export$844ec244b1367d54(variable) {
    return typeof variable === "string";
}
function $02e2df2893cf0bcc$export$9dd3754ae86f0017(variable) {
    return variable instanceof ArrayBuffer;
}
function $02e2df2893cf0bcc$export$5bcd6e94ed871c88(variable) {
    (0, $51137fdf63eaf269$export$2e2bcd8739ae039)($02e2df2893cf0bcc$export$4e09c449d6c407f7, "isBlob can only be used in a browser environment");
    return variable instanceof Blob;
}
function $02e2df2893cf0bcc$export$4d82193ef6a8d75c(variable) {
    return $02e2df2893cf0bcc$export$844ec244b1367d54(variable) && /^data:/.test(variable);
}
function $02e2df2893cf0bcc$export$c1553384119518c3(dataURI) {
    (0, $51137fdf63eaf269$export$2e2bcd8739ae039)($02e2df2893cf0bcc$export$4d82193ef6a8d75c(dataURI), "Invalid data URI.");
    const [headersString = "", dataString = ""] = dataURI.split(",");
    const headers = headersString.split(";");
    if (headers.indexOf("base64") !== -1) return atob(dataString);
    return unescape(dataString);
}
function $02e2df2893cf0bcc$export$cf4a949e5ad681d() {
    return $02e2df2893cf0bcc$export$4e09c449d6c407f7 && window.devicePixelRatio || 1;
}
const $02e2df2893cf0bcc$var$allowFileAccessFromFilesTip = "On Chromium based browsers, you can use --allow-file-access-from-files flag for debugging purposes.";
function $02e2df2893cf0bcc$export$84884c3182d1bdda() {
    (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(!$02e2df2893cf0bcc$export$d528e4159a0e221e, `Loading PDF as base64 strings/URLs may not work on protocols other than HTTP/HTTPS. ${$02e2df2893cf0bcc$var$allowFileAccessFromFilesTip}`);
}
function $02e2df2893cf0bcc$export$e7ec4a9e2d586a77() {
    (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(!$02e2df2893cf0bcc$export$d528e4159a0e221e, `Loading PDF.js worker may not work on protocols other than HTTP/HTTPS. ${$02e2df2893cf0bcc$var$allowFileAccessFromFilesTip}`);
}
function $02e2df2893cf0bcc$export$b8c3f1dffc289352(runningTask) {
    if (runningTask && runningTask.cancel) runningTask.cancel();
}
function $02e2df2893cf0bcc$export$8cc3f6b8d58bdda0(page, scale) {
    Object.defineProperty(page, "width", {
        get () {
            return this.view[2] * scale;
        },
        configurable: true
    });
    Object.defineProperty(page, "height", {
        get () {
            return this.view[3] * scale;
        },
        configurable: true
    });
    Object.defineProperty(page, "originalWidth", {
        get () {
            return this.view[2];
        },
        configurable: true
    });
    Object.defineProperty(page, "originalHeight", {
        get () {
            return this.view[3];
        },
        configurable: true
    });
    return page;
}
function $02e2df2893cf0bcc$export$99075c4d008e6ab1(error) {
    return error.name === "RenderingCancelledException";
}
function $02e2df2893cf0bcc$export$21fedb3a7a137f3d(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>{
            if (!reader.result) return reject(new Error("Error while reading a file."));
            resolve(reader.result);
        };
        reader.onerror = (event)=>{
            if (!event.target) return reject(new Error("Error while reading a file."));
            const { error: error } = event.target;
            if (!error) return reject(new Error("Error while reading a file."));
            switch(error.code){
                case error.NOT_FOUND_ERR:
                    return reject(new Error("Error while reading a file: File not found."));
                case error.SECURITY_ERR:
                    return reject(new Error("Error while reading a file: Security error."));
                case error.ABORT_ERR:
                    return reject(new Error("Error while reading a file: Aborted."));
                default:
                    return reject(new Error("Error while reading a file."));
            }
        };
        reader.readAsArrayBuffer(file);
    });
}



var $gIfym = parcelRequire("gIfym");
function $678156ec10aa3f30$var$reducer(state, action) {
    switch(action.type){
        case "RESOLVE":
            return {
                value: action.value,
                error: undefined
            };
        case "REJECT":
            return {
                value: false,
                error: action.error
            };
        case "RESET":
            return {
                value: undefined,
                error: undefined
            };
        default:
            return state;
    }
}
function $678156ec10aa3f30$export$2e2bcd8739ae039() {
    return (0, $gIfym.useReducer)($678156ec10aa3f30$var$reducer, {
        value: undefined,
        error: undefined
    });
}







const { PDFDataRangeTransport: $46a785ad40348064$var$PDFDataRangeTransport } = (0, $e63b29bf95759acf$export$2e2bcd8739ae039);
const $46a785ad40348064$export$1e08905474334888 = (()=>{
    const result = {};
    (0, $78c4fc952655f552$export$59ef7197c4d7b9dc).forEach((eventName)=>{
        result[eventName] = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func;
    });
    return result;
})();
const $46a785ad40348064$var$isTypedArray = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).instanceOf(Int8Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).instanceOf(Uint8Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).instanceOf(Uint8ClampedArray),
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).instanceOf(Int16Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).instanceOf(Uint16Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).instanceOf(Int32Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).instanceOf(Uint32Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).instanceOf(Float32Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).instanceOf(Float64Array)
]);
const $46a785ad40348064$var$fileTypes = [
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).instanceOf(ArrayBuffer),
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
        data: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).instanceOf(ArrayBuffer),
            (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number.isRequired),
            $46a785ad40348064$var$isTypedArray
        ]).isRequired
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
        range: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).instanceOf($46a785ad40348064$var$PDFDataRangeTransport).isRequired
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
        url: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string.isRequired
    })
];
if (typeof Blob !== "undefined") $46a785ad40348064$var$fileTypes.push((0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).instanceOf(Blob));
const $46a785ad40348064$export$d53f3db2f43345df = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string)
]);
const $46a785ad40348064$export$be78b3111c50efdd = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType($46a785ad40348064$var$fileTypes);
const $46a785ad40348064$export$836c1083c8eb7ae = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).instanceOf((0, $30dc112643bd7525$export$2e2bcd8739ae039));
const $46a785ad40348064$export$4d23df922dd97db8 = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOf([
    "_self",
    "_blank",
    "_parent",
    "_top"
]);
const $46a785ad40348064$export$61d82a1ff85c609a = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
    commonObjs: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({}).isRequired,
    getAnnotations: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired,
    getTextContent: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired,
    getViewport: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired,
    render: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired
});
const $46a785ad40348064$export$7b4c8bd6e6871332 = function isPageIndex(props, propName, componentName) {
    const { [propName]: pageIndex, pageNumber: pageNumber, pdf: pdf } = props;
    if (!(0, $02e2df2893cf0bcc$export$4e62c701997796c1)(pdf)) return null;
    if ((0, $02e2df2893cf0bcc$export$4e62c701997796c1)(pageIndex)) {
        if (typeof pageIndex !== "number") return new Error(`\`${propName}\` of type \`${typeof pageIndex}\` supplied to \`${componentName}\`, expected \`number\`.`);
        if (pageIndex < 0) return new Error(`Expected \`${propName}\` to be greater or equal to 0.`);
        const { numPages: numPages } = pdf;
        if (pageIndex + 1 > numPages) return new Error(`Expected \`${propName}\` to be less or equal to ${numPages - 1}.`);
    } else if (!(0, $02e2df2893cf0bcc$export$4e62c701997796c1)(pageNumber)) return new Error(`\`${propName}\` not supplied. Either pageIndex or pageNumber must be supplied to \`${componentName}\`.`);
    // Everything is fine
    return null;
};
const $46a785ad40348064$export$973e710208ddd50f = function isPageNumber(props, propName, componentName) {
    const { [propName]: pageNumber, pageIndex: pageIndex, pdf: pdf } = props;
    if (!(0, $02e2df2893cf0bcc$export$4e62c701997796c1)(pdf)) return null;
    if ((0, $02e2df2893cf0bcc$export$4e62c701997796c1)(pageNumber)) {
        if (typeof pageNumber !== "number") return new Error(`\`${propName}\` of type \`${typeof pageNumber}\` supplied to \`${componentName}\`, expected \`number\`.`);
        if (pageNumber < 1) return new Error(`Expected \`${propName}\` to be greater or equal to 1.`);
        const { numPages: numPages } = pdf;
        if (pageNumber > numPages) return new Error(`Expected \`${propName}\` to be less or equal to ${numPages}.`);
    } else if (!(0, $02e2df2893cf0bcc$export$4e62c701997796c1)(pageIndex)) return new Error(`\`${propName}\` not supplied. Either pageIndex or pageNumber must be supplied to \`${componentName}\`.`);
    // Everything is fine
    return null;
};
const $46a785ad40348064$export$d22001c6ab8dd37 = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
    // Ideally, this would be `PropTypes.instanceOf(PDFDocumentProxy)`, but it can't be imported.
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).any,
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOf([
        false
    ])
]);
const $46a785ad40348064$export$4f9f5282de18fc69 = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).exact({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).any
    })
]);
const $46a785ad40348064$export$70f0c3edbd58f82c = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOf([
    "canvas",
    "custom",
    "none",
    "svg"
]);
const $46a785ad40348064$export$10b2580337f7e7c1 = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOf([
    0,
    90,
    180,
    270
]);


"use client";
var $97a1f05fb7e6099a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $97a1f05fb7e6099a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const { PDFDataRangeTransport: $97a1f05fb7e6099a$var$PDFDataRangeTransport } = (0, $e63b29bf95759acf$export$2e2bcd8739ae039);
const $97a1f05fb7e6099a$var$defaultOnPassword = (callback, reason)=>{
    switch(reason){
        case (0, $c47f90cf820d9305$export$2e2bcd8739ae039).NEED_PASSWORD:
            {
                // eslint-disable-next-line no-alert
                const password = prompt("Enter the password to open this PDF file.");
                callback(password);
                break;
            }
        case (0, $c47f90cf820d9305$export$2e2bcd8739ae039).INCORRECT_PASSWORD:
            {
                // eslint-disable-next-line no-alert
                const password = prompt("Invalid password. Please try again.");
                callback(password);
                break;
            }
        default:
    }
};
/**
 * Loads a document passed using `file` prop.
 */ const $97a1f05fb7e6099a$var$Document = (0, $gIfym.forwardRef)(function Document(_a, ref) {
    var { children: children, className: className, error: error = "Failed to load PDF file.", externalLinkRel: externalLinkRel, externalLinkTarget: externalLinkTarget, file: file, inputRef: inputRef, imageResourcesPath: imageResourcesPath, loading: loading = "Loading PDF\u2026", noData: noData = "No PDF file specified.", onItemClick: onItemClick, onLoadError: onLoadErrorProps, onLoadProgress: onLoadProgress, onLoadSuccess: onLoadSuccessProps, onPassword: onPassword = $97a1f05fb7e6099a$var$defaultOnPassword, onSourceError: onSourceErrorProps, onSourceSuccess: onSourceSuccessProps, options: options, renderMode: renderMode, rotate: rotate } = _a, otherProps = $97a1f05fb7e6099a$var$__rest(_a, [
        "children",
        "className",
        "error",
        "externalLinkRel",
        "externalLinkTarget",
        "file",
        "inputRef",
        "imageResourcesPath",
        "loading",
        "noData",
        "onItemClick",
        "onLoadError",
        "onLoadProgress",
        "onLoadSuccess",
        "onPassword",
        "onSourceError",
        "onSourceSuccess",
        "options",
        "renderMode",
        "rotate"
    ]);
    const [sourceState, sourceDispatch] = (0, $678156ec10aa3f30$export$2e2bcd8739ae039)();
    const { value: source, error: sourceError } = sourceState;
    const [pdfState, pdfDispatch] = (0, $678156ec10aa3f30$export$2e2bcd8739ae039)();
    const { value: pdf, error: pdfError } = pdfState;
    const linkService = (0, $gIfym.useRef)(new (0, $30dc112643bd7525$export$2e2bcd8739ae039)());
    const pages = (0, $gIfym.useRef)([]);
    const viewer = (0, $gIfym.useRef)({
        // Handling jumping to internal links target
        scrollPageIntoView: (args)=>{
            const { dest: dest, pageNumber: pageNumber, pageIndex: pageIndex = pageNumber - 1 } = args;
            // First, check if custom handling of onItemClick was provided
            if (onItemClick) {
                onItemClick({
                    dest: dest,
                    pageIndex: pageIndex,
                    pageNumber: pageNumber
                });
                return;
            }
            // If not, try to look for target page within the <Document>.
            const page = pages.current[pageIndex];
            if (page) {
                // Scroll to the page automatically
                page.scrollIntoView();
                return;
            }
            (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(false, `An internal link leading to page ${pageNumber} was clicked, but neither <Document> was provided with onItemClick nor it was able to find the page within itself. Either provide onItemClick to <Document> and handle navigating by yourself or ensure that all pages are rendered within <Document>.`);
        }
    });
    (0, $gIfym.useImperativeHandle)(ref, ()=>({
            linkService: linkService,
            pages: pages,
            viewer: viewer
        }), []);
    /**
     * Called when a document source is resolved correctly
     */ function onSourceSuccess() {
        if (onSourceSuccessProps) onSourceSuccessProps();
    }
    /**
     * Called when a document source failed to be resolved correctly
     */ function onSourceError() {
        if (!sourceError) // Impossible, but TypeScript doesn't know that
        return;
        (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(false, sourceError.toString());
        if (onSourceErrorProps) onSourceErrorProps(sourceError);
    }
    function resetSource() {
        sourceDispatch({
            type: "RESET"
        });
    }
    (0, $gIfym.useEffect)(resetSource, [
        file,
        sourceDispatch
    ]);
    const findDocumentSource = (0, $gIfym.useCallback)(()=>$97a1f05fb7e6099a$var$__awaiter(this, void 0, void 0, function*() {
            if (!file) return null;
            // File is a string
            if (typeof file === "string") {
                if ((0, $02e2df2893cf0bcc$export$4d82193ef6a8d75c)(file)) {
                    const fileByteString = (0, $02e2df2893cf0bcc$export$c1553384119518c3)(file);
                    return {
                        data: fileByteString
                    };
                }
                (0, $02e2df2893cf0bcc$export$84884c3182d1bdda)();
                return {
                    url: file
                };
            }
            // File is PDFDataRangeTransport
            if (file instanceof $97a1f05fb7e6099a$var$PDFDataRangeTransport) return {
                range: file
            };
            // File is an ArrayBuffer
            if ((0, $02e2df2893cf0bcc$export$9dd3754ae86f0017)(file)) return {
                data: file
            };
            /**
         * The cases below are browser-only.
         * If you're running on a non-browser environment, these cases will be of no use.
         */ if (0, $02e2df2893cf0bcc$export$4e09c449d6c407f7) // File is a Blob
            {
                if ((0, $02e2df2893cf0bcc$export$5bcd6e94ed871c88)(file)) {
                    const data = yield (0, $02e2df2893cf0bcc$export$21fedb3a7a137f3d)(file);
                    return {
                        data: data
                    };
                }
            }
            // At this point, file must be an object
            (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(typeof file === "object", "Invalid parameter in file, need either Uint8Array, string or a parameter object");
            (0, $51137fdf63eaf269$export$2e2bcd8739ae039)("data" in file || "range" in file || "url" in file, "Invalid parameter object: need either .data, .range or .url");
            // File .url is a string
            if ("url" in file && typeof file.url === "string") {
                if ((0, $02e2df2893cf0bcc$export$4d82193ef6a8d75c)(file.url)) {
                    const { url: url } = file, otherParams = $97a1f05fb7e6099a$var$__rest(file, [
                        "url"
                    ]);
                    const fileByteString = (0, $02e2df2893cf0bcc$export$c1553384119518c3)(url);
                    return Object.assign({
                        data: fileByteString
                    }, otherParams);
                }
                (0, $02e2df2893cf0bcc$export$84884c3182d1bdda)();
            }
            return file;
        }), [
        file
    ]);
    (0, $gIfym.useEffect)(()=>{
        const cancellable = (0, $a2d1e3f291c1aac8$export$2e2bcd8739ae039)(findDocumentSource());
        cancellable.promise.then((nextSource)=>{
            sourceDispatch({
                type: "RESOLVE",
                value: nextSource
            });
        }).catch((error)=>{
            sourceDispatch({
                type: "REJECT",
                error: error
            });
        });
        return ()=>{
            (0, $02e2df2893cf0bcc$export$b8c3f1dffc289352)(cancellable);
        };
    }, [
        findDocumentSource,
        sourceDispatch
    ]);
    (0, $gIfym.useEffect)(()=>{
        if (typeof source === "undefined") return;
        if (source === false) {
            onSourceError();
            return;
        }
        onSourceSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        source
    ]);
    /**
     * Called when a document is read successfully
     */ function onLoadSuccess() {
        if (!pdf) // Impossible, but TypeScript doesn't know that
        return;
        if (onLoadSuccessProps) onLoadSuccessProps(pdf);
        pages.current = new Array(pdf.numPages);
        linkService.current.setDocument(pdf);
    }
    /**
     * Called when a document failed to read successfully
     */ function onLoadError() {
        if (!pdfError) // Impossible, but TypeScript doesn't know that
        return;
        (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(false, pdfError.toString());
        if (onLoadErrorProps) onLoadErrorProps(pdfError);
    }
    function resetDocument() {
        pdfDispatch({
            type: "RESET"
        });
    }
    (0, $gIfym.useEffect)(resetDocument, [
        pdfDispatch,
        source
    ]);
    function loadDocument() {
        if (!source) return;
        const documentInitParams = options ? Object.assign(Object.assign({}, source), options) : source;
        const destroyable = (0, $e63b29bf95759acf$export$2e2bcd8739ae039).getDocument(documentInitParams);
        if (onLoadProgress) destroyable.onProgress = onLoadProgress;
        if (onPassword) destroyable.onPassword = onPassword;
        const loadingTask = destroyable;
        loadingTask.promise.then((nextPdf)=>{
            pdfDispatch({
                type: "RESOLVE",
                value: nextPdf
            });
        }).catch((error)=>{
            if (loadingTask.destroyed) return;
            pdfDispatch({
                type: "REJECT",
                error: error
            });
        });
        return ()=>{
            loadingTask.destroy();
        };
    }
    (0, $gIfym.useEffect)(loadDocument, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        options,
        pdfDispatch,
        source
    ]);
    (0, $gIfym.useEffect)(()=>{
        if (typeof pdf === "undefined") return;
        if (pdf === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        pdf
    ]);
    function setupLinkService() {
        linkService.current.setViewer(viewer.current);
        linkService.current.setExternalLinkRel(externalLinkRel);
        linkService.current.setExternalLinkTarget(externalLinkTarget);
    }
    (0, $gIfym.useEffect)(setupLinkService, [
        externalLinkRel,
        externalLinkTarget
    ]);
    function registerPage(pageIndex, ref) {
        pages.current[pageIndex] = ref;
    }
    function unregisterPage(pageIndex) {
        delete pages.current[pageIndex];
    }
    const childContext = (0, $gIfym.useMemo)(()=>({
            imageResourcesPath: imageResourcesPath,
            linkService: linkService.current,
            onItemClick: onItemClick,
            pdf: pdf,
            registerPage: registerPage,
            renderMode: renderMode,
            rotate: rotate,
            unregisterPage: unregisterPage
        }), [
        imageResourcesPath,
        onItemClick,
        pdf,
        renderMode,
        rotate
    ]);
    const eventProps = (0, $gIfym.useMemo)(()=>(0, $78c4fc952655f552$export$2e2bcd8739ae039)(otherProps, ()=>pdf), [
        otherProps,
        pdf
    ]);
    function renderChildren() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $b7406b9166257ba4$export$2e2bcd8739ae039).Provider, {
            value: childContext
        }, children);
    }
    function renderContent() {
        if (!file) return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $876b96cc01b44bec$export$2e2bcd8739ae039), {
            type: "no-data"
        }, typeof noData === "function" ? noData() : noData);
        if (pdf === undefined || pdf === null) return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $876b96cc01b44bec$export$2e2bcd8739ae039), {
            type: "loading"
        }, typeof loading === "function" ? loading() : loading);
        if (pdf === false) return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $876b96cc01b44bec$export$2e2bcd8739ae039), {
            type: "error"
        }, typeof error === "function" ? error() : error);
        return renderChildren();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", Object.assign({
        className: (0, $8e4f30b640e1a870$export$2e2bcd8739ae039)("react-pdf__Document", className),
        ref: inputRef,
        style: {
            ["--scale-factor"]: "1"
        }
    }, eventProps), renderContent());
});
const $97a1f05fb7e6099a$var$isFunctionOrNode = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).node
]);
$97a1f05fb7e6099a$var$Document.propTypes = Object.assign(Object.assign({}, (0, $46a785ad40348064$export$1e08905474334888)), {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).node,
    className: (0, $46a785ad40348064$export$d53f3db2f43345df),
    error: $97a1f05fb7e6099a$var$isFunctionOrNode,
    externalLinkRel: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    externalLinkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOf([
        "_self",
        "_blank",
        "_parent",
        "_top"
    ]),
    file: (0, $46a785ad40348064$export$be78b3111c50efdd),
    imageResourcesPath: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    inputRef: (0, $46a785ad40348064$export$4f9f5282de18fc69),
    loading: $97a1f05fb7e6099a$var$isFunctionOrNode,
    noData: $97a1f05fb7e6099a$var$isFunctionOrNode,
    onItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onLoadError: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onLoadProgress: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onLoadSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onPassword: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onSourceError: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onSourceSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
        canvasFactory: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).any,
        canvasMaxAreaInBytes: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number,
        cMapPacked: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
        CMapReaderFactory: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).any,
        cMapUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
        disableAutoFetch: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
        disableFontFace: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
        disableRange: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
        disableStream: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
        docBaseUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
        enableXfa: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
        filterFactory: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).any,
        fontExtraProperties: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
        httpHeaders: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object,
        isEvalSupported: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
        isOffscreenCanvasSupported: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
        length: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number,
        maxImageSize: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number,
        ownerDocument: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).any,
        password: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
        pdfBug: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
        rangeChunkSize: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number,
        StandardFontDataFactory: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).any,
        standardFontDataUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
        stopAtErrors: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
        useSystemFonts: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
        useWorkerFetch: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
        verbosity: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number,
        withCredentials: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
        worker: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).any
    }),
    rotate: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number
});
var $97a1f05fb7e6099a$export$2e2bcd8739ae039 = $97a1f05fb7e6099a$var$Document;


var $gIfym = parcelRequire("gIfym");




/**
 * A function that merges React refs into one.
 * Supports both functions and ref objects created using createRef() and useRef().
 *
 * Usage:
 * ```tsx
 * <div ref={mergeRefs(ref1, ref2, ref3)} />
 * ```
 *
 * @param {(React.Ref<T> | undefined)[]} inputRefs Array of refs
 * @returns {React.Ref<T> | React.RefCallback<T>} Merged refs
 */ function $2a61e75d1cb1bae8$export$2e2bcd8739ae039() {
    var inputRefs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputRefs[_i] = arguments[_i];
    var filteredInputRefs = inputRefs.filter(Boolean);
    if (filteredInputRefs.length <= 1) {
        var firstRef = filteredInputRefs[0];
        return firstRef || null;
    }
    return function mergedRefs(ref) {
        filteredInputRefs.forEach(function(inputRef) {
            if (typeof inputRef === "function") inputRef(ref);
            else if (inputRef) inputRef.current = ref;
        });
    };
}





var $gIfym = parcelRequire("gIfym");
"use client";
var $299b34594af8ece3$export$2e2bcd8739ae039 = (0, $gIfym.createContext)(null);




var $gIfym = parcelRequire("gIfym");





var $gIfym = parcelRequire("gIfym");




var $gIfym = parcelRequire("gIfym");
// From pdfjs-dist/lib/web/struct_tree_layer_builder.js
const $6662392b0ff5cbb4$export$789cd800273ee71a = {
    // Document level structure types
    Document: null,
    DocumentFragment: null,
    // Grouping level structure types
    Part: "group",
    Sect: "group",
    Div: "group",
    Aside: "note",
    NonStruct: "none",
    // Block level structure types
    P: null,
    // H<n>,
    H: "heading",
    Title: null,
    FENote: "note",
    // Sub-block level structure type
    Sub: "group",
    // General inline level structure types
    Lbl: null,
    Span: null,
    Em: null,
    Strong: null,
    Link: "link",
    Annot: "note",
    Form: "form",
    // Ruby and Warichu structure types
    Ruby: null,
    RB: null,
    RT: null,
    RP: null,
    Warichu: null,
    WT: null,
    WP: null,
    // List standard structure types
    L: "list",
    LI: "listitem",
    LBody: null,
    // Table standard structure types
    Table: "table",
    TR: "row",
    TH: "columnheader",
    TD: "cell",
    THead: "columnheader",
    TBody: null,
    TFoot: null,
    // Standard structure type Caption
    Caption: null,
    // Standard structure type Figure
    Figure: "figure",
    // Standard structure type Formula
    Formula: null,
    // standard structure type Artifact
    Artifact: null
};
const $6662392b0ff5cbb4$export$4921bbe0701579e4 = /^H(\d+)$/;


function $5b59af26aae68e9e$export$80a007e7cc9dad0d(role) {
    return role in (0, $6662392b0ff5cbb4$export$789cd800273ee71a);
}
function $5b59af26aae68e9e$export$9eeaf208d22fae4f(node) {
    return "children" in node;
}
function $5b59af26aae68e9e$export$3b7840712ba182f3(node) {
    if (!$5b59af26aae68e9e$export$9eeaf208d22fae4f(node)) return false;
    return node.children.length === 1 && 0 in node.children && "id" in node.children[0];
}
function $5b59af26aae68e9e$export$aa440a09c67191c2(node) {
    const attributes = {};
    if ($5b59af26aae68e9e$export$9eeaf208d22fae4f(node)) {
        const { role: role } = node;
        const matches = role.match((0, $6662392b0ff5cbb4$export$4921bbe0701579e4));
        if (matches) {
            attributes.role = "heading";
            attributes["aria-level"] = Number(matches[1]);
        } else if ($5b59af26aae68e9e$export$80a007e7cc9dad0d(role)) {
            const htmlRole = (0, $6662392b0ff5cbb4$export$789cd800273ee71a)[role];
            if (htmlRole) attributes.role = htmlRole;
        }
    }
    return attributes;
}
function $5b59af26aae68e9e$export$e86e6c9c68c5154c(node) {
    const attributes = {};
    if ($5b59af26aae68e9e$export$9eeaf208d22fae4f(node)) {
        if (node.alt !== undefined) attributes["aria-label"] = node.alt;
        if (node.lang !== undefined) attributes.lang = node.lang;
        if ($5b59af26aae68e9e$export$3b7840712ba182f3(node)) {
            const [child] = node.children;
            if (child) {
                const childAttributes = $5b59af26aae68e9e$export$e86e6c9c68c5154c(child);
                return Object.assign(Object.assign({}, attributes), childAttributes);
            }
        }
    } else if ("id" in node) attributes["aria-owns"] = node.id;
    return attributes;
}
function $5b59af26aae68e9e$export$fe94072fee8a6976(node) {
    if (!node) return null;
    return Object.assign(Object.assign({}, $5b59af26aae68e9e$export$aa440a09c67191c2(node)), $5b59af26aae68e9e$export$e86e6c9c68c5154c(node));
}


function $7f5effeb8a373d96$export$2e2bcd8739ae039({ className: className, node: node }) {
    const attributes = (0, $gIfym.useMemo)(()=>(0, $5b59af26aae68e9e$export$fe94072fee8a6976)(node), [
        node
    ]);
    const children = (0, $gIfym.useMemo)(()=>{
        if (!(0, $5b59af26aae68e9e$export$9eeaf208d22fae4f)(node)) return null;
        if ((0, $5b59af26aae68e9e$export$3b7840712ba182f3)(node)) return null;
        return node.children.map((child, index)=>{
            return(// eslint-disable-next-line react/no-array-index-key
            (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($7f5effeb8a373d96$export$2e2bcd8739ae039, {
                key: index,
                node: child
            }));
        });
    }, [
        node
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", Object.assign({
        className: className
    }, attributes), children);
}



var $gIfym = parcelRequire("gIfym");

function $01f745f560df89fe$export$2e2bcd8739ae039() {
    return (0, $gIfym.useContext)((0, $299b34594af8ece3$export$2e2bcd8739ae039));
}




function $abbdf6bc82df105e$export$2e2bcd8739ae039() {
    const pageContext = (0, $01f745f560df89fe$export$2e2bcd8739ae039)();
    (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(pageContext, "Unable to find Page context.");
    const { onGetStructTreeError: onGetStructTreeErrorProps, onGetStructTreeSuccess: onGetStructTreeSuccessProps } = pageContext;
    const [structTreeState, structTreeDispatch] = (0, $678156ec10aa3f30$export$2e2bcd8739ae039)();
    const { value: structTree, error: structTreeError } = structTreeState;
    const { customTextRenderer: customTextRenderer, page: page } = pageContext;
    function onLoadSuccess() {
        if (!structTree) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetStructTreeSuccessProps) onGetStructTreeSuccessProps(structTree);
    }
    function onLoadError() {
        if (!structTreeError) // Impossible, but TypeScript doesn't know that
        return;
        (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(false, structTreeError.toString());
        if (onGetStructTreeErrorProps) onGetStructTreeErrorProps(structTreeError);
    }
    function resetAnnotations() {
        structTreeDispatch({
            type: "RESET"
        });
    }
    (0, $gIfym.useEffect)(resetAnnotations, [
        structTreeDispatch,
        page
    ]);
    function loadStructTree() {
        if (customTextRenderer) // TODO: Document why this is necessary
        return;
        if (!page) return;
        const cancellable = (0, $a2d1e3f291c1aac8$export$2e2bcd8739ae039)(page.getStructTree());
        const runningTask = cancellable;
        cancellable.promise.then((nextStructTree)=>{
            structTreeDispatch({
                type: "RESOLVE",
                value: nextStructTree
            });
        }).catch((error)=>{
            structTreeDispatch({
                type: "REJECT",
                error: error
            });
        });
        return ()=>(0, $02e2df2893cf0bcc$export$b8c3f1dffc289352)(runningTask);
    }
    (0, $gIfym.useEffect)(loadStructTree, [
        customTextRenderer,
        page,
        structTreeDispatch
    ]);
    (0, $gIfym.useEffect)(()=>{
        if (structTree === undefined) return;
        if (structTree === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        structTree
    ]);
    if (!structTree) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $7f5effeb8a373d96$export$2e2bcd8739ae039), {
        className: "react-pdf__Page__structTree structTree",
        node: structTree
    });
}




"use client";
const $3000d697993296cc$var$ANNOTATION_MODE = (0, $e63b29bf95759acf$export$2e2bcd8739ae039).AnnotationMode;
function $3000d697993296cc$export$2e2bcd8739ae039(props) {
    const pageContext = (0, $01f745f560df89fe$export$2e2bcd8739ae039)();
    (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(pageContext, "Unable to find Page context.");
    const mergedProps = Object.assign(Object.assign({}, pageContext), props);
    const { _className: _className, canvasBackground: canvasBackground, devicePixelRatio: devicePixelRatio = (0, $02e2df2893cf0bcc$export$cf4a949e5ad681d)(), onRenderError: onRenderErrorProps, onRenderSuccess: onRenderSuccessProps, page: page, renderForms: renderForms, renderTextLayer: renderTextLayer, rotate: rotate, scale: scale } = mergedProps;
    const { canvasRef: canvasRef } = props;
    (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(page, "Attempted to render page canvas, but no page was specified.");
    const canvasElement = (0, $gIfym.useRef)(null);
    /**
     * Called when a page is rendered successfully.
     */ function onRenderSuccess() {
        if (!page) // Impossible, but TypeScript doesn't know that
        return;
        if (onRenderSuccessProps) onRenderSuccessProps((0, $02e2df2893cf0bcc$export$8cc3f6b8d58bdda0)(page, scale));
    }
    /**
     * Called when a page fails to render.
     */ function onRenderError(error) {
        if ((0, $02e2df2893cf0bcc$export$99075c4d008e6ab1)(error)) return;
        (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(false, error.toString());
        if (onRenderErrorProps) onRenderErrorProps(error);
    }
    const renderViewport = (0, $gIfym.useMemo)(()=>page.getViewport({
            scale: scale * devicePixelRatio,
            rotation: rotate
        }), [
        devicePixelRatio,
        page,
        rotate,
        scale
    ]);
    const viewport = (0, $gIfym.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    function drawPageOnCanvas() {
        if (!page) return;
        // Ensures the canvas will be re-rendered from scratch. Otherwise all form data will stay.
        page.cleanup();
        const { current: canvas } = canvasElement;
        if (!canvas) return;
        canvas.width = renderViewport.width;
        canvas.height = renderViewport.height;
        canvas.style.width = `${Math.floor(viewport.width)}px`;
        canvas.style.height = `${Math.floor(viewport.height)}px`;
        canvas.style.visibility = "hidden";
        const renderContext = {
            annotationMode: renderForms ? $3000d697993296cc$var$ANNOTATION_MODE.ENABLE_FORMS : $3000d697993296cc$var$ANNOTATION_MODE.ENABLE,
            canvasContext: canvas.getContext("2d", {
                alpha: false
            }),
            viewport: renderViewport
        };
        if (canvasBackground) renderContext.background = canvasBackground;
        const cancellable = page.render(renderContext);
        const runningTask = cancellable;
        cancellable.promise.then(()=>{
            canvas.style.visibility = "";
            onRenderSuccess();
        }).catch(onRenderError);
        return ()=>(0, $02e2df2893cf0bcc$export$b8c3f1dffc289352)(runningTask);
    }
    (0, $gIfym.useEffect)(drawPageOnCanvas, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        canvasBackground,
        canvasElement,
        devicePixelRatio,
        page,
        renderForms,
        renderViewport,
        viewport
    ]);
    const cleanup = (0, $gIfym.useCallback)(()=>{
        const { current: canvas } = canvasElement;
        /**
         * Zeroing the width and height cause most browsers to release graphics
         * resources immediately, which can greatly reduce memory consumption.
         */ if (canvas) {
            canvas.width = 0;
            canvas.height = 0;
        }
    }, [
        canvasElement
    ]);
    (0, $gIfym.useEffect)(()=>cleanup, [
        cleanup
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("canvas", {
        className: `${_className}__canvas`,
        dir: "ltr",
        ref: (0, $2a61e75d1cb1bae8$export$2e2bcd8739ae039)(canvasRef, canvasElement),
        style: {
            display: "block",
            userSelect: "none"
        }
    }, renderTextLayer ? (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $abbdf6bc82df105e$export$2e2bcd8739ae039), null) : null);
}



var $gIfym = parcelRequire("gIfym");







function $d7d9f5bed76bb2cd$export$2e2bcd8739ae039() {
    const pageContext = (0, $01f745f560df89fe$export$2e2bcd8739ae039)();
    (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(pageContext, "Unable to find Page context.");
    const { _className: _className, onRenderSuccess: onRenderSuccessProps, onRenderError: onRenderErrorProps, page: page, rotate: rotate, scale: scale } = pageContext;
    (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(page, "Attempted to render page SVG, but no page was specified.");
    const [svgState, svgDispatch] = (0, $678156ec10aa3f30$export$2e2bcd8739ae039)();
    const { value: svg, error: svgError } = svgState;
    /**
     * Called when a page is rendered successfully
     */ function onRenderSuccess() {
        if (!page) // Impossible, but TypeScript doesn't know that
        return;
        if (onRenderSuccessProps) onRenderSuccessProps((0, $02e2df2893cf0bcc$export$8cc3f6b8d58bdda0)(page, scale));
    }
    /**
     * Called when a page fails to render
     */ function onRenderError() {
        if (!svgError) // Impossible, but TypeScript doesn't know that
        return;
        if ((0, $02e2df2893cf0bcc$export$99075c4d008e6ab1)(svgError)) return;
        (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(false, svgError.toString());
        if (onRenderErrorProps) onRenderErrorProps(svgError);
    }
    const viewport = (0, $gIfym.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    function resetSVG() {
        svgDispatch({
            type: "RESET"
        });
    }
    (0, $gIfym.useEffect)(resetSVG, [
        page,
        svgDispatch,
        viewport
    ]);
    function renderSVG() {
        if (!page) return;
        const cancellable = (0, $a2d1e3f291c1aac8$export$2e2bcd8739ae039)(page.getOperatorList());
        cancellable.promise.then((operatorList)=>{
            const svgGfx = new (0, $e63b29bf95759acf$export$2e2bcd8739ae039).SVGGraphics(page.commonObjs, page.objs);
            svgGfx.getSVG(operatorList, viewport).then((nextSvg)=>{
                // See https://github.com/mozilla/pdf.js/issues/16745
                if (!(nextSvg instanceof SVGElement)) throw new Error("getSVG returned unexpected result.");
                svgDispatch({
                    type: "RESOLVE",
                    value: nextSvg
                });
            }).catch((error)=>{
                svgDispatch({
                    type: "REJECT",
                    error: error
                });
            });
        }).catch((error)=>{
            svgDispatch({
                type: "REJECT",
                error: error
            });
        });
        return ()=>(0, $02e2df2893cf0bcc$export$b8c3f1dffc289352)(cancellable);
    }
    (0, $gIfym.useEffect)(renderSVG, [
        page,
        svgDispatch,
        viewport
    ]);
    (0, $gIfym.useEffect)(()=>{
        if (svg === undefined) return;
        if (svg === false) {
            onRenderError();
            return;
        }
        onRenderSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        svg
    ]);
    function drawPageOnContainer(element) {
        if (!element || !svg) return;
        // Append SVG element to the main container, if this hasn't been done already
        if (!element.firstElementChild) element.appendChild(svg);
        const { width: width, height: height } = viewport;
        svg.setAttribute("width", `${width}`);
        svg.setAttribute("height", `${height}`);
    }
    const { width: width, height: height } = viewport;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: `${_className}__svg`,
        // Note: This cannot be shortened, as we need this function to be called with each render.
        ref: (ref)=>drawPageOnContainer(ref),
        style: {
            display: "block",
            backgroundColor: "white",
            overflow: "hidden",
            width: width,
            height: height,
            userSelect: "none"
        }
    });
}



var $gIfym = parcelRequire("gIfym");








"use client";
function $2a42932eb47a5fc8$var$isTextItem(item) {
    return "str" in item;
}
function $2a42932eb47a5fc8$export$2e2bcd8739ae039() {
    const pageContext = (0, $01f745f560df89fe$export$2e2bcd8739ae039)();
    (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(pageContext, "Unable to find Page context.");
    const { customTextRenderer: customTextRenderer, onGetTextError: onGetTextError, onGetTextSuccess: onGetTextSuccess, onRenderTextLayerError: onRenderTextLayerError, onRenderTextLayerSuccess: onRenderTextLayerSuccess, page: page, pageIndex: pageIndex, pageNumber: pageNumber, rotate: rotate, scale: scale } = pageContext;
    (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(page, "Attempted to load page text content, but no page was specified.");
    const [textContentState, textContentDispatch] = (0, $678156ec10aa3f30$export$2e2bcd8739ae039)();
    const { value: textContent, error: textContentError } = textContentState;
    const layerElement = (0, $gIfym.useRef)(null);
    const endElement = (0, $gIfym.useRef)();
    (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(parseInt(window.getComputedStyle(document.body).getPropertyValue("--react-pdf-text-layer"), 10) === 1, "TextLayer styles not found. Read more: https://github.com/wojtekmaj/react-pdf#support-for-text-layer");
    /**
     * Called when a page text content is read successfully
     */ function onLoadSuccess() {
        if (!textContent) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetTextSuccess) onGetTextSuccess(textContent);
    }
    /**
     * Called when a page text content failed to read successfully
     */ function onLoadError() {
        if (!textContentError) // Impossible, but TypeScript doesn't know that
        return;
        (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(false, textContentError.toString());
        if (onGetTextError) onGetTextError(textContentError);
    }
    function resetTextContent() {
        textContentDispatch({
            type: "RESET"
        });
    }
    (0, $gIfym.useEffect)(resetTextContent, [
        page,
        textContentDispatch
    ]);
    function loadTextContent() {
        if (!page) return;
        const cancellable = (0, $a2d1e3f291c1aac8$export$2e2bcd8739ae039)(page.getTextContent());
        const runningTask = cancellable;
        cancellable.promise.then((nextTextContent)=>{
            textContentDispatch({
                type: "RESOLVE",
                value: nextTextContent
            });
        }).catch((error)=>{
            textContentDispatch({
                type: "REJECT",
                error: error
            });
        });
        return ()=>(0, $02e2df2893cf0bcc$export$b8c3f1dffc289352)(runningTask);
    }
    (0, $gIfym.useEffect)(loadTextContent, [
        page,
        textContentDispatch
    ]);
    (0, $gIfym.useEffect)(()=>{
        if (textContent === undefined) return;
        if (textContent === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        textContent
    ]);
    /**
     * Called when a text layer is rendered successfully
     */ const onRenderSuccess = (0, $gIfym.useCallback)(()=>{
        if (onRenderTextLayerSuccess) onRenderTextLayerSuccess();
    }, [
        onRenderTextLayerSuccess
    ]);
    /**
     * Called when a text layer failed to render successfully
     */ const onRenderError = (0, $gIfym.useCallback)((error)=>{
        (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(false, error.toString());
        if (onRenderTextLayerError) onRenderTextLayerError(error);
    }, [
        onRenderTextLayerError
    ]);
    function onMouseDown() {
        const end = endElement.current;
        if (!end) return;
        end.classList.add("active");
    }
    function onMouseUp() {
        const end = endElement.current;
        if (!end) return;
        end.classList.remove("active");
    }
    const viewport = (0, $gIfym.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    function renderTextLayer() {
        if (!page || !textContent) return;
        const { current: layer } = layerElement;
        if (!layer) return;
        layer.innerHTML = "";
        const textContentSource = page.streamTextContent({
            includeMarkedContent: true
        });
        const parameters = {
            container: layer,
            textContentSource: textContentSource,
            viewport: viewport
        };
        const cancellable = (0, $e63b29bf95759acf$export$2e2bcd8739ae039).renderTextLayer(parameters);
        const runningTask = cancellable;
        cancellable.promise.then(()=>{
            const end = document.createElement("div");
            end.className = "endOfContent";
            layer.append(end);
            endElement.current = end;
            const layerChildren = layer.querySelectorAll('[role="presentation"]');
            if (customTextRenderer) {
                let index = 0;
                textContent.items.forEach((item, itemIndex)=>{
                    if (!$2a42932eb47a5fc8$var$isTextItem(item)) return;
                    const child = layerChildren[index];
                    if (!child) return;
                    const content = customTextRenderer(Object.assign({
                        pageIndex: pageIndex,
                        pageNumber: pageNumber,
                        itemIndex: itemIndex
                    }, item));
                    child.innerHTML = content;
                    index += item.str && item.hasEOL ? 2 : 1;
                });
            }
            // Intentional immediate callback
            onRenderSuccess();
        }).catch(onRenderError);
        return ()=>(0, $02e2df2893cf0bcc$export$b8c3f1dffc289352)(runningTask);
    }
    (0, $gIfym.useLayoutEffect)(renderTextLayer, [
        customTextRenderer,
        onRenderError,
        onRenderSuccess,
        page,
        pageIndex,
        pageNumber,
        textContent,
        viewport
    ]);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: (0, $8e4f30b640e1a870$export$2e2bcd8739ae039)("react-pdf__Page__textContent", "textLayer"),
        onMouseUp: onMouseUp,
        onMouseDown: onMouseDown,
        ref: layerElement
    }));
}



var $gIfym = parcelRequire("gIfym");






var $gIfym = parcelRequire("gIfym");

function $2b0c5f5ab5a8d6ea$export$2e2bcd8739ae039() {
    return (0, $gIfym.useContext)((0, $b7406b9166257ba4$export$2e2bcd8739ae039));
}





"use client";
function $e4a09319bfcd7f5b$export$2e2bcd8739ae039() {
    const documentContext = (0, $2b0c5f5ab5a8d6ea$export$2e2bcd8739ae039)();
    (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(documentContext, "Unable to find Document context. Did you wrap <Page /> in <Document />?");
    const pageContext = (0, $01f745f560df89fe$export$2e2bcd8739ae039)();
    (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(pageContext, "Unable to find Page context.");
    const mergedProps = Object.assign(Object.assign({}, documentContext), pageContext);
    const { imageResourcesPath: imageResourcesPath, linkService: linkService, onGetAnnotationsError: onGetAnnotationsErrorProps, onGetAnnotationsSuccess: onGetAnnotationsSuccessProps, onRenderAnnotationLayerError: onRenderAnnotationLayerErrorProps, onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccessProps, page: page, pdf: pdf, renderForms: renderForms, rotate: rotate, scale: scale = 1 } = mergedProps;
    (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(page, "Attempted to load page annotations, but no page was specified.");
    const [annotationsState, annotationsDispatch] = (0, $678156ec10aa3f30$export$2e2bcd8739ae039)();
    const { value: annotations, error: annotationsError } = annotationsState;
    const layerElement = (0, $gIfym.useRef)(null);
    (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(parseInt(window.getComputedStyle(document.body).getPropertyValue("--react-pdf-annotation-layer"), 10) === 1, "AnnotationLayer styles not found. Read more: https://github.com/wojtekmaj/react-pdf#support-for-annotations");
    function onLoadSuccess() {
        if (!annotations) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetAnnotationsSuccessProps) onGetAnnotationsSuccessProps(annotations);
    }
    function onLoadError() {
        if (!annotationsError) // Impossible, but TypeScript doesn't know that
        return;
        (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(false, annotationsError.toString());
        if (onGetAnnotationsErrorProps) onGetAnnotationsErrorProps(annotationsError);
    }
    function resetAnnotations() {
        annotationsDispatch({
            type: "RESET"
        });
    }
    (0, $gIfym.useEffect)(resetAnnotations, [
        annotationsDispatch,
        page
    ]);
    function loadAnnotations() {
        if (!page) return;
        const cancellable = (0, $a2d1e3f291c1aac8$export$2e2bcd8739ae039)(page.getAnnotations());
        const runningTask = cancellable;
        cancellable.promise.then((nextAnnotations)=>{
            annotationsDispatch({
                type: "RESOLVE",
                value: nextAnnotations
            });
        }).catch((error)=>{
            annotationsDispatch({
                type: "REJECT",
                error: error
            });
        });
        return ()=>{
            (0, $02e2df2893cf0bcc$export$b8c3f1dffc289352)(runningTask);
        };
    }
    (0, $gIfym.useEffect)(loadAnnotations, [
        annotationsDispatch,
        page,
        renderForms
    ]);
    (0, $gIfym.useEffect)(()=>{
        if (annotations === undefined) return;
        if (annotations === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        annotations
    ]);
    function onRenderSuccess() {
        if (onRenderAnnotationLayerSuccessProps) onRenderAnnotationLayerSuccessProps();
    }
    function onRenderError(error) {
        (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(false, `${error}`);
        if (onRenderAnnotationLayerErrorProps) onRenderAnnotationLayerErrorProps(error);
    }
    const viewport = (0, $gIfym.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    function renderAnnotationLayer() {
        if (!pdf || !page || !annotations) return;
        const { current: layer } = layerElement;
        if (!layer) return;
        const clonedViewport = viewport.clone({
            dontFlip: true
        });
        const annotationLayerParameters = {
            accessibilityManager: null,
            annotationCanvasMap: null,
            div: layer,
            l10n: null,
            page: page,
            viewport: clonedViewport
        };
        const renderParameters = {
            annotations: annotations,
            annotationStorage: pdf.annotationStorage,
            div: layer,
            // See https://github.com/mozilla/pdf.js/issues/17029
            downloadManager: null,
            imageResourcesPath: imageResourcesPath,
            linkService: linkService,
            page: page,
            renderForms: renderForms,
            viewport: clonedViewport
        };
        layer.innerHTML = "";
        try {
            new (0, $e63b29bf95759acf$export$2e2bcd8739ae039).AnnotationLayer(annotationLayerParameters).render(renderParameters);
            // Intentional immediate callback
            onRenderSuccess();
        } catch (error) {
            onRenderError(error);
        }
        return ()=>{
        // TODO: Cancel running task?
        };
    }
    (0, $gIfym.useEffect)(renderAnnotationLayer, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        annotations,
        imageResourcesPath,
        linkService,
        page,
        renderForms,
        viewport
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: (0, $8e4f30b640e1a870$export$2e2bcd8739ae039)("react-pdf__Page__annotations", "annotationLayer"),
        ref: layerElement
    });
}






"use client";
var $f6292e99e22e05e6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $f6292e99e22e05e6$var$defaultScale = 1;
/**
 * Displays a page.
 *
 * Should be placed inside `<Document />`. Alternatively, it can have `pdf` prop passed, which can be obtained from `<Document />`'s `onLoadSuccess` callback function, however some advanced functions like linking between pages inside a document may not be working correctly.
 */ const $f6292e99e22e05e6$var$Page = function Page(props) {
    const documentContext = (0, $2b0c5f5ab5a8d6ea$export$2e2bcd8739ae039)();
    (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(documentContext, "Unable to find Document context. Did you wrap <Page /> in <Document />?");
    const mergedProps = Object.assign(Object.assign({}, documentContext), props);
    const { _className: _className = "react-pdf__Page", _enableRegisterUnregisterPage: _enableRegisterUnregisterPage = true, canvasBackground: canvasBackground, canvasRef: canvasRef, children: children, className: className, customRenderer: CustomRenderer, customTextRenderer: customTextRenderer, devicePixelRatio: devicePixelRatio, error: error = "Failed to load the page.", height: height, inputRef: inputRef, loading: loading = "Loading page\u2026", noData: noData = "No page specified.", onGetAnnotationsError: onGetAnnotationsErrorProps, onGetAnnotationsSuccess: onGetAnnotationsSuccessProps, onGetStructTreeError: onGetStructTreeErrorProps, onGetStructTreeSuccess: onGetStructTreeSuccessProps, onGetTextError: onGetTextErrorProps, onGetTextSuccess: onGetTextSuccessProps, onLoadError: onLoadErrorProps, onLoadSuccess: onLoadSuccessProps, onRenderAnnotationLayerError: onRenderAnnotationLayerErrorProps, onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccessProps, onRenderError: onRenderErrorProps, onRenderSuccess: onRenderSuccessProps, onRenderTextLayerError: onRenderTextLayerErrorProps, onRenderTextLayerSuccess: onRenderTextLayerSuccessProps, pageIndex: pageIndexProps, pageNumber: pageNumberProps, pdf: pdf, registerPage: registerPage, renderAnnotationLayer: renderAnnotationLayerProps = true, renderForms: renderForms = false, renderMode: renderMode = "canvas", renderTextLayer: renderTextLayerProps = true, rotate: rotateProps, scale: scaleProps = $f6292e99e22e05e6$var$defaultScale, unregisterPage: unregisterPage, width: width } = mergedProps, otherProps = $f6292e99e22e05e6$var$__rest(mergedProps, [
        "_className",
        "_enableRegisterUnregisterPage",
        "canvasBackground",
        "canvasRef",
        "children",
        "className",
        "customRenderer",
        "customTextRenderer",
        "devicePixelRatio",
        "error",
        "height",
        "inputRef",
        "loading",
        "noData",
        "onGetAnnotationsError",
        "onGetAnnotationsSuccess",
        "onGetStructTreeError",
        "onGetStructTreeSuccess",
        "onGetTextError",
        "onGetTextSuccess",
        "onLoadError",
        "onLoadSuccess",
        "onRenderAnnotationLayerError",
        "onRenderAnnotationLayerSuccess",
        "onRenderError",
        "onRenderSuccess",
        "onRenderTextLayerError",
        "onRenderTextLayerSuccess",
        "pageIndex",
        "pageNumber",
        "pdf",
        "registerPage",
        "renderAnnotationLayer",
        "renderForms",
        "renderMode",
        "renderTextLayer",
        "rotate",
        "scale",
        "unregisterPage",
        "width"
    ]);
    const [pageState, pageDispatch] = (0, $678156ec10aa3f30$export$2e2bcd8739ae039)();
    const { value: page, error: pageError } = pageState;
    const pageElement = (0, $gIfym.useRef)(null);
    (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(pdf, "Attempted to load a page, but no document was specified.");
    const pageIndex = (0, $02e2df2893cf0bcc$export$ef8866826b0b1f6d)(pageNumberProps) ? pageNumberProps - 1 : pageIndexProps !== null && pageIndexProps !== void 0 ? pageIndexProps : null;
    const pageNumber = pageNumberProps !== null && pageNumberProps !== void 0 ? pageNumberProps : (0, $02e2df2893cf0bcc$export$ef8866826b0b1f6d)(pageIndexProps) ? pageIndexProps + 1 : null;
    const rotate = rotateProps !== null && rotateProps !== void 0 ? rotateProps : page ? page.rotate : null;
    const scale = (0, $gIfym.useMemo)(()=>{
        if (!page) return null;
        // Be default, we'll render page at 100% * scale width.
        let pageScale = 1;
        // Passing scale explicitly null would cause the page not to render
        const scaleWithDefault = scaleProps !== null && scaleProps !== void 0 ? scaleProps : $f6292e99e22e05e6$var$defaultScale;
        // If width/height is defined, calculate the scale of the page so it could be of desired width.
        if (width || height) {
            const viewport = page.getViewport({
                scale: 1,
                rotation: rotate
            });
            if (width) pageScale = width / viewport.width;
            else if (height) pageScale = height / viewport.height;
        }
        return scaleWithDefault * pageScale;
    }, [
        height,
        page,
        rotate,
        scaleProps,
        width
    ]);
    function hook() {
        return ()=>{
            if (!(0, $02e2df2893cf0bcc$export$ef8866826b0b1f6d)(pageIndex)) // Impossible, but TypeScript doesn't know that
            return;
            if (_enableRegisterUnregisterPage && unregisterPage) unregisterPage(pageIndex);
        };
    }
    (0, $gIfym.useEffect)(hook, [
        _enableRegisterUnregisterPage,
        pdf,
        pageIndex,
        unregisterPage
    ]);
    /**
     * Called when a page is loaded successfully
     */ function onLoadSuccess() {
        if (onLoadSuccessProps) {
            if (!page || !scale) // Impossible, but TypeScript doesn't know that
            return;
            onLoadSuccessProps((0, $02e2df2893cf0bcc$export$8cc3f6b8d58bdda0)(page, scale));
        }
        if (_enableRegisterUnregisterPage && registerPage) {
            if (!(0, $02e2df2893cf0bcc$export$ef8866826b0b1f6d)(pageIndex) || !pageElement.current) // Impossible, but TypeScript doesn't know that
            return;
            registerPage(pageIndex, pageElement.current);
        }
    }
    /**
     * Called when a page failed to load
     */ function onLoadError() {
        if (!pageError) // Impossible, but TypeScript doesn't know that
        return;
        (0, $f4f9b01701245dfa$export$2e2bcd8739ae039)(false, pageError.toString());
        if (onLoadErrorProps) onLoadErrorProps(pageError);
    }
    function resetPage() {
        pageDispatch({
            type: "RESET"
        });
    }
    (0, $gIfym.useEffect)(resetPage, [
        pageDispatch,
        pdf,
        pageIndex
    ]);
    function loadPage() {
        if (!pdf || !pageNumber) return;
        const cancellable = (0, $a2d1e3f291c1aac8$export$2e2bcd8739ae039)(pdf.getPage(pageNumber));
        const runningTask = cancellable;
        cancellable.promise.then((nextPage)=>{
            pageDispatch({
                type: "RESOLVE",
                value: nextPage
            });
        }).catch((error)=>{
            pageDispatch({
                type: "REJECT",
                error: error
            });
        });
        return ()=>(0, $02e2df2893cf0bcc$export$b8c3f1dffc289352)(runningTask);
    }
    (0, $gIfym.useEffect)(loadPage, [
        pageDispatch,
        pdf,
        pageIndex,
        pageNumber,
        registerPage
    ]);
    (0, $gIfym.useEffect)(()=>{
        if (page === undefined) return;
        if (page === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        page,
        scale
    ]);
    const childContext = (0, $gIfym.useMemo)(()=>// Technically there cannot be page without pageIndex, pageNumber, rotate and scale, but TypeScript doesn't know that
        page && (0, $02e2df2893cf0bcc$export$ef8866826b0b1f6d)(pageIndex) && pageNumber && (0, $02e2df2893cf0bcc$export$ef8866826b0b1f6d)(rotate) && (0, $02e2df2893cf0bcc$export$ef8866826b0b1f6d)(scale) ? {
            _className: _className,
            canvasBackground: canvasBackground,
            customTextRenderer: customTextRenderer,
            devicePixelRatio: devicePixelRatio,
            onGetAnnotationsError: onGetAnnotationsErrorProps,
            onGetAnnotationsSuccess: onGetAnnotationsSuccessProps,
            onGetStructTreeError: onGetStructTreeErrorProps,
            onGetStructTreeSuccess: onGetStructTreeSuccessProps,
            onGetTextError: onGetTextErrorProps,
            onGetTextSuccess: onGetTextSuccessProps,
            onRenderAnnotationLayerError: onRenderAnnotationLayerErrorProps,
            onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccessProps,
            onRenderError: onRenderErrorProps,
            onRenderSuccess: onRenderSuccessProps,
            onRenderTextLayerError: onRenderTextLayerErrorProps,
            onRenderTextLayerSuccess: onRenderTextLayerSuccessProps,
            page: page,
            pageIndex: pageIndex,
            pageNumber: pageNumber,
            renderForms: renderForms,
            renderTextLayer: renderTextLayerProps,
            rotate: rotate,
            scale: scale
        } : null, [
        _className,
        canvasBackground,
        customTextRenderer,
        devicePixelRatio,
        onGetAnnotationsErrorProps,
        onGetAnnotationsSuccessProps,
        onGetStructTreeErrorProps,
        onGetStructTreeSuccessProps,
        onGetTextErrorProps,
        onGetTextSuccessProps,
        onRenderAnnotationLayerErrorProps,
        onRenderAnnotationLayerSuccessProps,
        onRenderErrorProps,
        onRenderSuccessProps,
        onRenderTextLayerErrorProps,
        onRenderTextLayerSuccessProps,
        page,
        pageIndex,
        pageNumber,
        renderForms,
        renderTextLayerProps,
        rotate,
        scale
    ]);
    const eventProps = (0, $gIfym.useMemo)(()=>(0, $78c4fc952655f552$export$2e2bcd8739ae039)(otherProps, ()=>page ? scale ? (0, $02e2df2893cf0bcc$export$8cc3f6b8d58bdda0)(page, scale) : undefined : page), [
        otherProps,
        page,
        scale
    ]);
    const pageKey = `${pageIndex}@${scale}/${rotate}`;
    const pageKeyNoScale = `${pageIndex}/${rotate}`;
    function renderMainLayer() {
        switch(renderMode){
            case "custom":
                (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(CustomRenderer, `renderMode was set to "custom", but no customRenderer was passed.`);
                return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement(CustomRenderer, {
                    key: `${pageKey}_custom`
                });
            case "none":
                return null;
            case "svg":
                return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $d7d9f5bed76bb2cd$export$2e2bcd8739ae039), {
                    key: `${pageKeyNoScale}_svg`
                });
            case "canvas":
            default:
                return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $3000d697993296cc$export$2e2bcd8739ae039), {
                    key: `${pageKey}_canvas`,
                    canvasRef: canvasRef
                });
        }
    }
    function renderTextLayer() {
        if (!renderTextLayerProps) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $2a42932eb47a5fc8$export$2e2bcd8739ae039), {
            key: `${pageKey}_text`
        });
    }
    function renderAnnotationLayer() {
        if (!renderAnnotationLayerProps) return null;
        /**
         * As of now, PDF.js 2.0.943 returns warnings on unimplemented annotations in SVG mode.
         * Therefore, as a fallback, we render "traditional" AnnotationLayer component.
         */ return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $e4a09319bfcd7f5b$export$2e2bcd8739ae039), {
            key: `${pageKey}_annotations`
        });
    }
    function renderChildren() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $299b34594af8ece3$export$2e2bcd8739ae039).Provider, {
            value: childContext
        }, renderMainLayer(), renderTextLayer(), renderAnnotationLayer(), children);
    }
    function renderContent() {
        if (!pageNumber) return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $876b96cc01b44bec$export$2e2bcd8739ae039), {
            type: "no-data"
        }, typeof noData === "function" ? noData() : noData);
        if (pdf === null || page === undefined || page === null) return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $876b96cc01b44bec$export$2e2bcd8739ae039), {
            type: "loading"
        }, typeof loading === "function" ? loading() : loading);
        if (pdf === false || page === false) return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $876b96cc01b44bec$export$2e2bcd8739ae039), {
            type: "error"
        }, typeof error === "function" ? error() : error);
        return renderChildren();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", Object.assign({
        className: (0, $8e4f30b640e1a870$export$2e2bcd8739ae039)(_className, className),
        "data-page-number": pageNumber,
        ref: (0, $2a61e75d1cb1bae8$export$2e2bcd8739ae039)(inputRef, pageElement),
        style: {
            ["--scale-factor"]: `${scale}`,
            backgroundColor: canvasBackground || "white",
            position: "relative",
            minWidth: "min-content",
            minHeight: "min-content"
        }
    }, eventProps), renderContent());
};
const $f6292e99e22e05e6$var$isFunctionOrNode = (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).node
]);
$f6292e99e22e05e6$var$Page.propTypes = Object.assign(Object.assign({}, (0, $46a785ad40348064$export$1e08905474334888)), {
    canvasBackground: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    canvasRef: (0, $46a785ad40348064$export$4f9f5282de18fc69),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).node,
    className: (0, $46a785ad40348064$export$d53f3db2f43345df),
    customRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    customTextRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    devicePixelRatio: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number,
    error: $f6292e99e22e05e6$var$isFunctionOrNode,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number,
    imageResourcesPath: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    inputRef: (0, $46a785ad40348064$export$4f9f5282de18fc69),
    loading: $f6292e99e22e05e6$var$isFunctionOrNode,
    noData: $f6292e99e22e05e6$var$isFunctionOrNode,
    onGetTextError: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onGetTextSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onLoadError: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onLoadSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onRenderError: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onRenderSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onRenderTextLayerError: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    onRenderTextLayerSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    pageIndex: (0, $46a785ad40348064$export$7b4c8bd6e6871332),
    pageNumber: (0, $46a785ad40348064$export$973e710208ddd50f),
    pdf: (0, $46a785ad40348064$export$d22001c6ab8dd37),
    renderAnnotationLayer: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    renderForms: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    renderMode: (0, $46a785ad40348064$export$70f0c3edbd58f82c),
    renderTextLayer: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    rotate: (0, $46a785ad40348064$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number
});
var $f6292e99e22e05e6$export$2e2bcd8739ae039 = $f6292e99e22e05e6$var$Page;











(0, $02e2df2893cf0bcc$export$e7ec4a9e2d586a77)();
(0, $e63b29bf95759acf$export$2e2bcd8739ae039).GlobalWorkerOptions.workerSrc = "pdf.worker.js";


var $9087f9aa01653f30$exports = {};
// THIS FILE IS GENERATED - DO NOT EDIT!
/*!mobile-detect v1.4.5 2021-03-13*/ /*global module:false, define:false*/ /*jshint latedef:false*/ /*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/ (function(define1, undefined) {
    define1(function() {
        "use strict";
        var impl = {};
        impl.mobileDetectRules = {
            "phones": {
                "iPhone": "\\biPhone\\b|\\biPod\\b",
                "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+|\\b(BBA100|BBB100|BBD100|BBE100|BBF100|STH100)\\b-[0-9]+",
                "Pixel": "; \\bPixel\\b",
                "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m|Android [0-9.]+; Pixel",
                "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 5X|Nexus 6",
                "Dell": "Dell[;]? (Streak|Aero|Venue|Venue Pro|Flash|Smoke|Mini 3iX)|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
                "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b|XT1068|XT1092|XT1052",
                "Samsung": "\\bSamsung\\b|SM-G950F|SM-G955F|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C|SM-A310F|GT-I9190|SM-J500FN|SM-G903F|SM-J330F|SM-G610F|SM-G981B|SM-G892A|SM-A530F",
                "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323|M257)|LM-G710",
                "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533|SOV34|601SO|F8332",
                "Asus": "Asus.*Galaxy|PadFone.*Mobile",
                "Xiaomi": "^(?!.*\\bx11\\b).*xiaomi.*$|POCOPHONE F1|MI 8|Redmi Note 9S|Redmi Note 5A Prime|N2G47H|M2001J2G|M2001J2I|M1805E10A|M2004J11G|M1902F1G|M2002J9G|M2004J19G|M2003J6A1G",
                "NokiaLumia": "Lumia [0-9]{3,4}",
                "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
                "Palm": "PalmSource|Palm",
                "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
                "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
                "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
                "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
                "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
                "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
                "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
                "Alcatel": "Alcatel",
                "Nintendo": "Nintendo (3DS|Switch)",
                "Amoi": "Amoi",
                "INQ": "INQ",
                "OnePlus": "ONEPLUS",
                "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
            },
            "tablets": {
                "iPad": "iPad|iPad.*Mobile",
                "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
                "GoogleTablet": "Android.*Pixel C",
                "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-T116BU|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y?|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587|SM-P350|SM-P555M|SM-P355M|SM-T113NU|SM-T815Y|SM-T585|SM-T285|SM-T825|SM-W708|SM-T835|SM-T830|SM-T837V|SM-T720|SM-T510|SM-T387V|SM-P610|SM-T290|SM-T515|SM-T590|SM-T595|SM-T725|SM-T817P|SM-P585N0|SM-T395|SM-T295|SM-T865|SM-P610N|SM-P615|SM-T970|SM-T380|SM-T5950|SM-T905|SM-T231|SM-T500|SM-T860",
                "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk/[0-9.]+ like Chrome/[0-9.]+ (?!Mobile)",
                "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
                "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
                "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z|\\bP027\\b|\\bP024\\b|\\bP00C\\b",
                "BlackBerryTablet": "PlayBook|RIM Tablet",
                "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
                "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
                "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
                "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30|A3-A40",
                "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
                "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
                "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
                "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
                "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-850M|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)|TB-X103F|TB-X304X|TB-X304F|TB-X304L|TB-X505F|TB-X505L|TB-X505X|TB-X605F|TB-X605L|TB-8703F|TB-8703X|TB-8703N|TB-8704N|TB-8704F|TB-8704X|TB-8704V|TB-7304F|TB-7304I|TB-7304X|Tab2A7-10F|Tab2A7-20F|TB2-X30L|YT3-X50L|YT3-X50F|YT3-X50M|YT-X705F|YT-X703F|YT-X703L|YT-X705L|YT-X705X|TB2-X30F|TB2-X30L|TB2-X30M|A2107A-F|A2107A-H|TB3-730F|TB3-730M|TB3-730X|TB-7504F|TB-7504X|TB-X704F|TB-X104F|TB3-X70F|TB-X705F|TB-8504F|TB3-X70L|TB3-710F|TB-X704L",
                "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
                "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
                "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
                "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
                "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
                "IRUTablet": "M702pro",
                "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
                "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
                "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
                "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
                "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
                "NokiaLumiaTablet": "Lumia 2520",
                "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP641|SGP612|SOT31|SGP771|SGP611|SGP612|SGP712",
                "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
                "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
                "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
                "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
                "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
                "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
                "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
                "FlyTablet": "IQ310|Fly Vision",
                "bqTablet": "Android.*(bq)?.*\\b(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris ([E|M]10|M8))\\b|Maxwell.*Lite|Maxwell.*Plus",
                "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim|M2-A01L|BAH-L09|BAH-W09|AGS-L09|CMR-AL19",
                "NecTablet": "\\bN-06D|\\bN-08D",
                "PantechTablet": "Pantech.*P4100",
                "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
                "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
                "ZyncTablet": "z1000|Z99 2G|z930|z990|z909|Z919|z900",
                "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
                "NabiTablet": "Android.*\\bNabi",
                "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
                "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
                "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
                "PlaystationTablet": "Playstation.*(Portable|Vita)",
                "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
                "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
                "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
                "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
                "GalapadTablet": "Android [0-9.]+; [a-z-]+; \\bG1\\b",
                "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
                "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
                "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
                "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
                "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
                "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
                "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
                "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
                "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)|Qualcore 1027",
                "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
                "DPSTablet": "DPS Dream 9|DPS Dual 7",
                "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
                "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
                "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
                "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
                "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
                "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
                "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
                "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
                "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
                "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497|VFD 1400",
                "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
                "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
                "iMobileTablet": "i-mobile i-note",
                "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
                "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
                "AMPETablet": "Android.* A78 ",
                "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
                "TecnoTablet": "TECNO P9|TECNO DP8D",
                "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
                "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
                "FX2Tablet": "FX2 PAD7|FX2 PAD10",
                "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
                "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
                "VerizonTablet": "QTAQZ3|QTAIR7|QTAQTZ3|QTASUN1|QTASUN2|QTAXIA1",
                "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
                "CaptivaTablet": "CAPTIVA PAD",
                "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
                "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
                "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+|V10 \\b4G\\b",
                "JaytechTablet": "TPC-PA762",
                "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
                "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
                "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
                "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
                "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
                "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
                "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
                "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
                "MediacomTablet": "M-MPI10C3G|M-SP10EG|M-SP10EGP|M-SP10HXAH|M-SP7HXAH|M-SP10HXBH|M-SP8HXAH|M-SP8MXA",
                "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
                "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
                "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
                "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
                "UbislateTablet": "UbiSlate[\\s]?7C",
                "PocketBookTablet": "Pocketbook",
                "KocasoTablet": "\\b(TB-1207)\\b",
                "HisenseTablet": "\\b(F5281|E2371)\\b",
                "Hudl": "Hudl HT7S3|Hudl 2",
                "TelstraTablet": "T-Hub2",
                "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b|\\bQTAQZ3\\b|WVT101|TM1088|KT107"
            },
            "oss": {
                "AndroidOS": "Android",
                "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
                "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
                "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
                "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Windows Mobile|Windows Phone [0-9.]+|WCE;",
                "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
                "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia",
                "iPadOS": "CPU OS 13",
                "SailfishOS": "Sailfish",
                "MeeGoOS": "MeeGo",
                "MaemoOS": "Maemo",
                "JavaOS": "J2ME/|\\bMIDP\\b|\\bCLDC\\b",
                "webOS": "webOS|hpwOS",
                "badaOS": "\\bBada\\b",
                "BREWOS": "BREW"
            },
            "uas": {
                "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome/[.0-9]* (Mobile)?",
                "Dolfin": "\\bDolfin\\b",
                "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR/[0-9.]+$|Coast/[0-9.]+",
                "Skyfire": "Skyfire",
                "Edge": "\\bEdgiOS\\b|Mobile Safari/[.0-9]* Edge",
                "IE": "IEMobile|MSIEMobile",
                "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
                "Bolt": "bolt",
                "TeaShark": "teashark",
                "Blazer": "Blazer",
                "Safari": "Version((?!\\bEdgiOS\\b).)*Mobile.*Safari|Safari.*Mobile|MobileSafari",
                "WeChat": "\\bMicroMessenger\\b",
                "UCBrowser": "UC.*Browser|UCWEB",
                "baiduboxapp": "baiduboxapp",
                "baidubrowser": "baidubrowser",
                "DiigoBrowser": "DiigoBrowser",
                "Mercury": "\\bMercury\\b",
                "ObigoBrowser": "Obigo",
                "NetFront": "NF-Browser",
                "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
                "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
            },
            "props": {
                "Mobile": "Mobile/[VER]",
                "Build": "Build/[VER]",
                "Version": "Version/[VER]",
                "VendorID": "VendorID/[VER]",
                "iPad": "iPad.*CPU[a-z ]+[VER]",
                "iPhone": "iPhone.*CPU[a-z ]+[VER]",
                "iPod": "iPod.*CPU[a-z ]+[VER]",
                "Kindle": "Kindle/[VER]",
                "Chrome": [
                    "Chrome/[VER]",
                    "CriOS/[VER]",
                    "CrMo/[VER]"
                ],
                "Coast": [
                    "Coast/[VER]"
                ],
                "Dolfin": "Dolfin/[VER]",
                "Firefox": [
                    "Firefox/[VER]",
                    "FxiOS/[VER]"
                ],
                "Fennec": "Fennec/[VER]",
                "Edge": "Edge/[VER]",
                "IE": [
                    "IEMobile/[VER];",
                    "IEMobile [VER]",
                    "MSIE [VER];",
                    "Trident/[0-9.]+;.*rv:[VER]"
                ],
                "NetFront": "NetFront/[VER]",
                "NokiaBrowser": "NokiaBrowser/[VER]",
                "Opera": [
                    " OPR/[VER]",
                    "Opera Mini/[VER]",
                    "Version/[VER]"
                ],
                "Opera Mini": "Opera Mini/[VER]",
                "Opera Mobi": "Version/[VER]",
                "UCBrowser": [
                    "UCWEB[VER]",
                    "UC.*Browser/[VER]"
                ],
                "MQQBrowser": "MQQBrowser/[VER]",
                "MicroMessenger": "MicroMessenger/[VER]",
                "baiduboxapp": "baiduboxapp/[VER]",
                "baidubrowser": "baidubrowser/[VER]",
                "SamsungBrowser": "SamsungBrowser/[VER]",
                "Iron": "Iron/[VER]",
                "Safari": [
                    "Version/[VER]",
                    "Safari/[VER]"
                ],
                "Skyfire": "Skyfire/[VER]",
                "Tizen": "Tizen/[VER]",
                "Webkit": "webkit[ /][VER]",
                "PaleMoon": "PaleMoon/[VER]",
                "SailfishBrowser": "SailfishBrowser/[VER]",
                "Gecko": "Gecko/[VER]",
                "Trident": "Trident/[VER]",
                "Presto": "Presto/[VER]",
                "Goanna": "Goanna/[VER]",
                "iOS": " \\bi?OS\\b [VER][ ;]{1}",
                "Android": "Android [VER]",
                "Sailfish": "Sailfish [VER]",
                "BlackBerry": [
                    "BlackBerry[\\w]+/[VER]",
                    "BlackBerry.*Version/[VER]",
                    "Version/[VER]"
                ],
                "BREW": "BREW [VER]",
                "Java": "Java/[VER]",
                "Windows Phone OS": [
                    "Windows Phone OS [VER]",
                    "Windows Phone [VER]"
                ],
                "Windows Phone": "Windows Phone [VER]",
                "Windows CE": "Windows CE/[VER]",
                "Windows NT": "Windows NT [VER]",
                "Symbian": [
                    "SymbianOS/[VER]",
                    "Symbian/[VER]"
                ],
                "webOS": [
                    "webOS/[VER]",
                    "hpwOS/[VER];"
                ]
            },
            "utils": {
                "Bot": "Googlebot|facebookexternalhit|Google-AMPHTML|s~amp-validator|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom|contentkingapp|AspiegelBot",
                "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker/M1A1-R2D2",
                "DesktopMode": "WPDesktop",
                "TV": "SonyDTV|HbbTV",
                "WebKit": "(webkit)[ /]([\\w.]+)",
                "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|Nintendo Switch|PLAYSTATION|Xbox)\\b",
                "Watch": "SM-V700"
            }
        };
        // following patterns come from http://detectmobilebrowsers.com/
        impl.detectMobileBrowsers = {
            fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
            shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
            tabletPattern: /android|ipad|playbook|silk/i
        };
        var hasOwnProp = Object.prototype.hasOwnProperty, isArray;
        impl.FALLBACK_PHONE = "UnknownPhone";
        impl.FALLBACK_TABLET = "UnknownTablet";
        impl.FALLBACK_MOBILE = "UnknownMobile";
        isArray = "isArray" in Array ? Array.isArray : function(value) {
            return Object.prototype.toString.call(value) === "[object Array]";
        };
        function equalIC(a, b) {
            return a != null && b != null && a.toLowerCase() === b.toLowerCase();
        }
        function containsIC(array, value) {
            var valueLC, i, len = array.length;
            if (!len || !value) return false;
            valueLC = value.toLowerCase();
            for(i = 0; i < len; ++i){
                if (valueLC === array[i].toLowerCase()) return true;
            }
            return false;
        }
        function convertPropsToRegExp(object) {
            for(var key in object)if (hasOwnProp.call(object, key)) object[key] = new RegExp(object[key], "i");
        }
        function prepareUserAgent(userAgent) {
            return (userAgent || "").substr(0, 500); // mitigate vulnerable to ReDoS
        }
        (function init() {
            var key, values, value, i, len, verPos, mobileDetectRules = impl.mobileDetectRules;
            for(key in mobileDetectRules.props)if (hasOwnProp.call(mobileDetectRules.props, key)) {
                values = mobileDetectRules.props[key];
                if (!isArray(values)) values = [
                    values
                ];
                len = values.length;
                for(i = 0; i < len; ++i){
                    value = values[i];
                    verPos = value.indexOf("[VER]");
                    if (verPos >= 0) value = value.substring(0, verPos) + "([\\w._\\+]+)" + value.substring(verPos + 5);
                    values[i] = new RegExp(value, "i");
                }
                mobileDetectRules.props[key] = values;
            }
            convertPropsToRegExp(mobileDetectRules.oss);
            convertPropsToRegExp(mobileDetectRules.phones);
            convertPropsToRegExp(mobileDetectRules.tablets);
            convertPropsToRegExp(mobileDetectRules.uas);
            convertPropsToRegExp(mobileDetectRules.utils);
            // copy some patterns to oss0 which are tested first (see issue#15)
            mobileDetectRules.oss0 = {
                WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
                WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
            };
        })();
        /**
     * Test userAgent string against a set of rules and find the first matched key.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
     * @private
     */ impl.findMatch = function(rules, userAgent) {
            for(var key in rules)if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) return key;
            }
            return null;
        };
        /**
     * Test userAgent string against a set of rules and return an array of matched keys.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
     * @private
     */ impl.findMatches = function(rules, userAgent) {
            var result = [];
            for(var key in rules){
                if (hasOwnProp.call(rules, key)) {
                    if (rules[key].test(userAgent)) result.push(key);
                }
            }
            return result;
        };
        /**
     * Check the version of the given property in the User-Agent.
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {String} version or <tt>null</tt> if version not found
     * @private
     */ impl.getVersionStr = function(propertyName, userAgent) {
            var props = impl.mobileDetectRules.props, patterns, i, len, match;
            if (hasOwnProp.call(props, propertyName)) {
                patterns = props[propertyName];
                len = patterns.length;
                for(i = 0; i < len; ++i){
                    match = patterns[i].exec(userAgent);
                    if (match !== null) return match[1];
                }
            }
            return null;
        };
        /**
     * Check the version of the given property in the User-Agent.
     * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {Number} version or <tt>NaN</tt> if version not found
     * @private
     */ impl.getVersion = function(propertyName, userAgent) {
            var version = impl.getVersionStr(propertyName, userAgent);
            return version ? impl.prepareVersionNo(version) : NaN;
        };
        /**
     * Prepare the version number.
     *
     * @param {String} version
     * @return {Number} the version number as a floating number
     * @private
     */ impl.prepareVersionNo = function(version) {
            var numbers;
            numbers = version.split(/[a-z._ \/\-]/i);
            if (numbers.length === 1) version = numbers[0];
            if (numbers.length > 1) {
                version = numbers[0] + ".";
                numbers.shift();
                version += numbers.join("");
            }
            return Number(version);
        };
        impl.isMobileFallback = function(userAgent) {
            return impl.detectMobileBrowsers.fullPattern.test(userAgent) || impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0, 4));
        };
        impl.isTabletFallback = function(userAgent) {
            return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
        };
        impl.prepareDetectionCache = function(cache, userAgent, maxPhoneWidth) {
            if (cache.mobile !== undefined) return;
            var phone, tablet, phoneSized;
            // first check for stronger tablet rules, then phone (see issue#5)
            tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
            if (tablet) {
                cache.mobile = cache.tablet = tablet;
                cache.phone = null;
                return; // unambiguously identified as tablet
            }
            phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
            if (phone) {
                cache.mobile = cache.phone = phone;
                cache.tablet = null;
                return; // unambiguously identified as phone
            }
            // our rules haven't found a match -> try more general fallback rules
            if (impl.isMobileFallback(userAgent)) {
                phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
                if (phoneSized === undefined) {
                    cache.mobile = impl.FALLBACK_MOBILE;
                    cache.tablet = cache.phone = null;
                } else if (phoneSized) {
                    cache.mobile = cache.phone = impl.FALLBACK_PHONE;
                    cache.tablet = null;
                } else {
                    cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
                    cache.phone = null;
                }
            } else if (impl.isTabletFallback(userAgent)) {
                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
                cache.phone = null;
            } else // not mobile at all!
            cache.mobile = cache.tablet = cache.phone = null;
        };
        // t is a reference to a MobileDetect instance
        impl.mobileGrade = function(t) {
            // impl note:
            // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
            // When changes are made in Mobile_Detect.php, copy this method and replace:
            //     $this-> / t.
            //     self::MOBILE_GRADE_(.) / '$1'
            //     , self::VERSION_TYPE_FLOAT / (nothing)
            //     isIOS() / os('iOS')
            //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
            var $isMobile = t.mobile() !== null;
            if (// Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
            t.os("iOS") && t.version("iPad") >= 4.3 || t.os("iOS") && t.version("iPhone") >= 3.1 || t.os("iOS") && t.version("iPod") >= 3.1 || // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
            t.version("Android") > 2.1 && t.is("Webkit") || // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
            t.version("Windows Phone OS") >= 7.0 || // Blackberry 7 - Tested on BlackBerry Torch 9810
            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
            t.is("BlackBerry") && t.version("BlackBerry") >= 6.0 || // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
            t.match("Playbook.*Tablet") || // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
            t.version("webOS") >= 1.4 && t.match("Palm|Pre|Pixi") || // Palm WebOS 3.0  - Tested on HP TouchPad
            t.match("hp.*TouchPad") || // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
            t.is("Firefox") && t.version("Firefox") >= 12 || // Chrome for Android - Tested on Android 4.0, 4.1 device
            t.is("Chrome") && t.is("AndroidOS") && t.version("Android") >= 4.0 || // Skyfire 4.1 - Tested on Android 2.3 device
            t.is("Skyfire") && t.version("Skyfire") >= 4.1 && t.is("AndroidOS") && t.version("Android") >= 2.3 || // Opera Mobile 11.5-12: Tested on Android 2.3
            t.is("Opera") && t.version("Opera Mobi") > 11 && t.is("AndroidOS") || // Meego 1.2 - Tested on Nokia 950 and N9
            t.is("MeeGoOS") || // Tizen (pre-release) - Tested on early hardware
            t.is("Tizen") || // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
            // @todo: more tests here!
            t.is("Dolfin") && t.version("Bada") >= 2.0 || // UC Browser - Tested on Android 2.3 device
            (t.is("UC Browser") || t.is("Dolfin")) && t.version("Android") >= 2.3 || // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
            t.match("Kindle Fire") || t.is("Kindle") && t.version("Kindle") >= 3.0 || // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
            t.is("AndroidOS") && t.is("NookTablet") || // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
            t.version("Chrome") >= 11 && !$isMobile || // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
            t.version("Safari") >= 5.0 && !$isMobile || // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
            t.version("Firefox") >= 4.0 && !$isMobile || // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
            t.version("MSIE") >= 7.0 && !$isMobile || // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
            // @reference: http://my.opera.com/community/openweb/idopera/
            t.version("Opera") >= 10 && !$isMobile) return "A";
            if (t.os("iOS") && t.version("iPad") < 4.3 || t.os("iOS") && t.version("iPhone") < 3.1 || t.os("iOS") && t.version("iPod") < 3.1 || // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
            t.is("Blackberry") && t.version("BlackBerry") >= 5 && t.version("BlackBerry") < 6 || //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
            t.version("Opera Mini") >= 5.0 && t.version("Opera Mini") <= 6.5 && (t.version("Android") >= 2.3 || t.is("iOS")) || // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
            t.match("NokiaN8|NokiaC7|N97.*Series60|Symbian/3") || // @todo: report this (tested on Nokia N71)
            t.version("Opera Mobi") >= 11 && t.is("SymbianOS")) return "B";
            if (// Blackberry 4.x - Tested on the Curve 8330
            t.version("BlackBerry") < 5.0 || // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
            t.match("MSIEMobile|Windows CE.*Mobile") || t.version("Windows Mobile") <= 5.2) return "C";
            //All older smartphone platforms and featurephones - Any device that doesn't support media queries
            //will receive the basic, C grade experience.
            return "C";
        };
        impl.detectOS = function(ua) {
            return impl.findMatch(impl.mobileDetectRules.oss0, ua) || impl.findMatch(impl.mobileDetectRules.oss, ua);
        };
        impl.getDeviceSmallerSide = function() {
            return window.screen.width < window.screen.height ? window.screen.width : window.screen.height;
        };
        /**
     * Constructor for MobileDetect object.
     * <br>
     * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
     * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
     *     <strong>Find information how to download and install:</strong>
     *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
     * </div>
     *
     * @example <pre>
     *     var md = new MobileDetect(window.navigator.userAgent);
     *     if (md.mobile()) {
     *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
     *     }
     * </pre>
     *
     * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
     * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
     *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
     *        as phone.
     *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
     *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
     *        for Android</a>.<br>
     *        If you provide a value < 0, then this "fuzzy" check is disabled.
     * @constructor
     * @global
     */ function MobileDetect(userAgent, maxPhoneWidth) {
            this.ua = prepareUserAgent(userAgent);
            this._cache = {};
            //600dp is typical 7" tablet minimum width
            this.maxPhoneWidth = maxPhoneWidth || 600;
        }
        MobileDetect.prototype = {
            constructor: MobileDetect,
            /**
         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
         * <br>
         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
         * <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
         * @function MobileDetect#mobile
         */ mobile: function() {
                impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
                return this._cache.mobile;
            },
            /**
         * Returns the detected phone type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPhone, BlackBerry, Pixel, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
         * Xiaomi, NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile,
         * SimValley, Wolfgang, Alcatel, Nintendo, Amoi, INQ, OnePlus, GenericPhone</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
         * @function MobileDetect#phone
         */ phone: function() {
                impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
                return this._cache.phone;
            },
            /**
         * Returns the detected tablet type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPad, NexusTablet, GoogleTablet, SamsungTablet, Kindle, SurfaceTablet,
         * HPTablet, AsusTablet, BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet,
         * AcerTablet, ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet,
         * LenovoTablet, DellTablet, YarvikTablet, MedionTablet, ArnovaTablet,
         * IntensoTablet, IRUTablet, MegafonTablet, EbodaTablet, AllViewTablet,
         * ArchosTablet, AinolTablet, NokiaLumiaTablet, SonyTablet, PhilipsTablet,
         * CubeTablet, CobyTablet, MIDTablet, MSITablet, SMiTTablet, RockChipTablet,
         * FlyTablet, bqTablet, HuaweiTablet, NecTablet, PantechTablet, BronchoTablet,
         * VersusTablet, ZyncTablet, PositivoTablet, NabiTablet, KoboTablet, DanewTablet,
         * TexetTablet, PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
         * VerizonTablet, OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet,
         * OndaTablet, JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet,
         * LavaTablet, AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MediacomTablet,
         * MiTablet, NibiruTablet, NexoTablet, LeaderTablet, UbislateTablet,
         * PocketBookTablet, KocasoTablet, HisenseTablet, Hudl, TelstraTablet,
         * GenericTablet</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
         * @function MobileDetect#tablet
         */ tablet: function() {
                impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
                return this._cache.tablet;
            },
            /**
         * Returns the (first) detected user-agent string or <tt>null</tt>.
         * <br>
         * The returned user-agent is one of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {String} the key for the detected user-agent or <tt>null</tt>
         * @function MobileDetect#userAgent
         */ userAgent: function() {
                if (this._cache.userAgent === undefined) this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
                return this._cache.userAgent;
            },
            /**
         * Returns all detected user-agent strings.
         * <br>
         * The array is empty or contains one or more of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
         * @function MobileDetect#userAgents
         */ userAgents: function() {
                if (this._cache.userAgents === undefined) this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
                return this._cache.userAgents;
            },
            /**
         * Returns the detected operating system string or <tt>null</tt>.
         * <br>
         * The operating system is one of following keys:<br>
         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
         * iOS, iPadOS, SailfishOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
         *
         * @returns {String} the key for the detected operating system.
         * @function MobileDetect#os
         */ os: function() {
                if (this._cache.os === undefined) this._cache.os = impl.detectOS(this.ua);
                return this._cache.os;
            },
            /**
         * Get the version (as Number) of the given property in the User-Agent.
         * <br>
         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon,
         * SailfishBrowser, Gecko, Trident, Presto, Goanna, iOS, Android, Sailfish,
         * BlackBerry, BREW, Java, Windows Phone OS, Windows Phone, Windows CE, Windows
         * NT, Symbian, webOS</tt><br>
         *
         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
         *          Be careful when comparing this value with '==' operator!
         * @function MobileDetect#version
         */ version: function(key) {
                return impl.getVersion(key, this.ua);
            },
            /**
         * Get the version (as String) of the given property in the User-Agent.
         * <br>
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon,
         * SailfishBrowser, Gecko, Trident, Presto, Goanna, iOS, Android, Sailfish,
         * BlackBerry, BREW, Java, Windows Phone OS, Windows Phone, Windows CE, Windows
         * NT, Symbian, webOS</tt><br>
         *
         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
         *
         * @function MobileDetect#versionStr
         */ versionStr: function(key) {
                return impl.getVersionStr(key, this.ua);
            },
            /**
         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
         *
         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
         *        tablet family.<br>
         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
         *        Additionally you have following keys:<br>
         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
         *
         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
         * @function MobileDetect#is
         */ is: function(key) {
                return containsIC(this.userAgents(), key) || equalIC(key, this.os()) || equalIC(key, this.phone()) || equalIC(key, this.tablet()) || containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
            },
            /**
         * Do a quick test against navigator::userAgent.
         *
         * @param {String|RegExp} pattern the pattern, either as String or RegExp
         *                        (a string will be converted to a case-insensitive RegExp).
         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
         * @function MobileDetect#match
         */ match: function(pattern) {
                if (!(pattern instanceof RegExp)) pattern = new RegExp(pattern, "i");
                return pattern.test(this.ua);
            },
            /**
         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
         * <br>
         * Obviously this method makes sense in browser environments only (not for Node.js)!
         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
         *          Will always return <code>undefined</code> server-side.
         */ isPhoneSized: function(maxPhoneWidth) {
                return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
            },
            /**
         * Returns the mobile grade ('A', 'B', 'C').
         *
         * @returns {String} one of the mobile grades ('A', 'B', 'C').
         * @function MobileDetect#mobileGrade
         */ mobileGrade: function() {
                if (this._cache.grade === undefined) this._cache.grade = impl.mobileGrade(this);
                return this._cache.grade;
            }
        };
        // environment-dependent
        if (typeof window !== "undefined" && window.screen) MobileDetect.isPhoneSized = function(maxPhoneWidth) {
            return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
        };
        else MobileDetect.isPhoneSized = function() {};
        // should not be replaced by a completely new object - just overwrite existing methods
        MobileDetect._impl = impl;
        MobileDetect.version = "1.4.5 2021-03-13";
        return MobileDetect;
    }); // end of call of define()
})(function(undefined) {
    if (0, $9087f9aa01653f30$exports) return function(factory) {
        $9087f9aa01653f30$exports = factory();
    };
    else if (typeof define === "function" && define.amd) return define;
    else if (typeof window !== "undefined") return function(factory) {
        window.MobileDetect = factory();
    };
    else // please file a bug if you get this error!
    throw new Error("unknown environment");
}());


var $c78618457328c948$exports = {};
$c78618457328c948$exports = new URL("funnelPup.ca202fc2.svg", import.meta.url).toString();






// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
(0, $e63b29bf95759acf$export$2e2bcd8739ae039).GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${(0, $e63b29bf95759acf$export$2e2bcd8739ae039).version}/build/pdf.worker.min.js`;
const $6bb563e121d81d97$var$appURLs = {
    dev: [
        "local.chatfunnels.dev:12345"
    ],
    beta: [
        "beta.chatfunnels.com",
        "beta.getsignals.ai"
    ],
    prod: [
        "app.chatfunnels.com",
        "app.getsignals.ai"
    ]
};
const $6bb563e121d81d97$var$url = new URL(window.location.href);
const $6bb563e121d81d97$var$subdomain = $6bb563e121d81d97$var$url.hostname.split(".")[0];
const $6bb563e121d81d97$var$betaSubdomains = [
    "content",
    "beta_content"
];
let $6bb563e121d81d97$var$env = "prod";
let $6bb563e121d81d97$var$pathname = $6bb563e121d81d97$var$url.pathname;
if ($6bb563e121d81d97$var$url.hostname === "local.chatfunnels.dev") $6bb563e121d81d97$var$env = "dev";
else if ($6bb563e121d81d97$var$betaSubdomains.includes($6bb563e121d81d97$var$subdomain) || $6bb563e121d81d97$var$pathname.startsWith("/0/")) {
    // The hard-coded list of betaSubdomains is for backwards compatilibity. Moving forward, the
    // generated beta URLs will include a /0/ prefix, but just in case URLs without that
    // prefix have been distributed, this will allow the old urls to work
    $6bb563e121d81d97$var$env = "beta";
    if ($6bb563e121d81d97$var$pathname.startsWith("/0/")) $6bb563e121d81d97$var$pathname = $6bb563e121d81d97$var$pathname.substring(2);
}
const $6bb563e121d81d97$var$isPreview = $6bb563e121d81d97$var$pathname === "/__preview";
const $6bb563e121d81d97$var$chatService = $6bb563e121d81d97$var$appURLs[$6bb563e121d81d97$var$env][0] + "/api/chat-service/a";
const $6bb563e121d81d97$var$allowedOrigins = $6bb563e121d81d97$var$appURLs[$6bb563e121d81d97$var$env];
function $6bb563e121d81d97$var$BotSidebar(props) {
    if (props.logoImage) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: "sidebar",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "sidebar-header",
                style: {
                    cursor: props.useLogoUrl ? "pointer" : "default"
                },
                onClick: ()=>{
                    if (props.useLogoUrl && props.logoUrl) window.location.href = props.logoUrl;
                },
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                    src: props.logoImage,
                    className: "logo",
                    style: {
                        maxHeight: 100,
                        maxWidth: 420
                    }
                })
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                ref: props.chatClientRef
            })
        ]
    });
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
        className: "sidebar-no-header",
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            ref: props.chatClientRef
        })
    });
}
function $6bb563e121d81d97$var$determineBackgroundColor(content) {
    if (content?.background_type === "solid") {
        document.body.style.backgroundColor = content?.background_color;
        return;
    }
    document.body.style.backgroundImage = `linear-gradient(to bottom right, ${content?.background_color}, ${content?.secondary_color})`;
    document.body.style.backgroundAttachment = "fixed";
}
function $6bb563e121d81d97$var$App(props) {
    const [logoImage, setLogoImage] = (0, $gIfym.useState)("");
    const [pdfContent, setPdfContent] = (0, $gIfym.useState)(null);
    const [loading, setLoading] = (0, $gIfym.useState)(true);
    const [contentPageId, setContentPageId] = (0, $gIfym.useState)(null);
    const [errorState, setErrorState] = (0, $gIfym.useState)(false);
    const [content, setContent] = (0, $gIfym.useState)();
    const chatClientRef = (0, $gIfym.useRef)();
    const logoImageRef = (0, $gIfym.useRef)();
    const [maxPages, setMaxPages] = (0, $gIfym.useState)(1);
    const [botOnly, setBotOnly] = (0, $gIfym.useState)(false);
    const [logoUrl, setLogoUrl] = (0, $gIfym.useState)("");
    const [useLogoUrl, setUseLogoUrl] = (0, $gIfym.useState)(false);
    const md = new (0, (/*@__PURE__*/$parcel$interopDefault($9087f9aa01653f30$exports)))(window.navigator.userAgent);
    const phone = !!md.phone();
    const width = window.screen.width - 20 > 900 ? 900 : window.screen.width - 20;
    const numPagesRef = (0, $gIfym.useRef)();
    numPagesRef.current = maxPages;
    logoImageRef.current = logoImage;
    (0, $gIfym.useEffect)(()=>{
        if (!$6bb563e121d81d97$var$isPreview) {
            const lookupUrl = `https://${$6bb563e121d81d97$var$chatService}/content_pages/quick_lookup`;
            fetch(lookupUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                    Pragma: "no-cache"
                },
                body: JSON.stringify({
                    subdomain: $6bb563e121d81d97$var$subdomain,
                    page: $6bb563e121d81d97$var$pathname.replace(/^\//, "")
                })
            }).then((response)=>response.json()).then((response)=>{
                if (response.errors) setErrorState(true);
                else if (response.data) {
                    setLoading(false);
                    $6bb563e121d81d97$var$determineBackgroundColor(response.data.attributes);
                    setLogoImage(response.data.attributes.logo_image);
                    setLogoUrl(response.data.attributes.logo_url);
                    setUseLogoUrl(response.data.attributes.use_logo_url);
                    setPdfContent(response.data.attributes.pdf_content_url);
                    setBotOnly(response.data.attributes.bot_only);
                    window.document.title = response?.data?.attributes?.title;
                    setContent({
                        ...response.data.attributes,
                        pdf_content_dataurl: "data:application/pdf;base64," + response.data.attributes.pdf_content
                    });
                }
            });
        } else setLoading(false);
    }, []);
    (0, $gIfym.useEffect)(()=>{
        if ($6bb563e121d81d97$var$isPreview && contentPageId) {
            const lookupUrl = `https://${$6bb563e121d81d97$var$chatService}/content_pages/quick_lookup`;
            fetch(lookupUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                    Pragma: "no-cache"
                },
                body: JSON.stringify({
                    subdomain: $6bb563e121d81d97$var$subdomain,
                    page: contentPageId
                })
            }).then((response)=>response.json()).then((response)=>{
                if (response.errors) setErrorState(true);
                else {
                    window.document.title = response?.data?.attributes?.title;
                    setContent(response.data.attributes);
                }
            });
        }
    }, [
        contentPageId
    ]);
    (0, $gIfym.useEffect)(()=>{
        window.addEventListener("message", (message)=>{
            const origin = message.origin.split("//")[1];
            if (!$6bb563e121d81d97$var$allowedOrigins.includes(origin)) return;
            const data = message.data;
            if (data.command === "update_iframe") {
                const values = data.params;
                if (values.background_color) document.body.style.backgroundColor = values.background_color;
                if (values.pdf_content) setPdfContent(values.pdf_content);
                if (values.content_page_id) setContentPageId(values.content_page_id);
                if (values.logo_image !== logoImageRef.current) window.location.reload();
            } else if (data.command === "initialize_iframe") {
                const values = data.params;
                document.body.style.backgroundColor = values.background_color;
                setPdfContent(values.pdf_content);
                setContentPageId(values.content_page_id);
                setLogoImage(values.logo_image);
                logoImageRef.current = values.logo_image;
            } else if (data.command === "refresh") window.location.reload();
        });
        window.parent.postMessage({
            command: "ready"
        }, "*");
    }, []);
    (0, $gIfym.useEffect)(()=>{
        if (content) {
            const packetCode = content?.packet_code;
            const loadPath = content?.load_path;
            const servicePath = content?.service_path;
            let logo;
            if ($6bb563e121d81d97$var$isPreview) logo = logoImage;
            else logo = content.logo_image;
            if (packetCode) {
                let mode = "content";
                if (logo && !botOnly) mode = "content-with-header";
                else if (phone && !botOnly) mode = "content-phone";
                else if (phone && botOnly) mode = "landing-page";
                else if (botOnly) mode = "landing-page";
                window.cf_chat_loader = ()=>{
                    return {
                        mode: mode,
                        parentElement: chatClientRef.current,
                        chatInitReady: (chatEl)=>{
                            if (phone) return;
                            if (logo && !botOnly) {
                                chatEl.style.height = "calc(100vh - 100px)";
                                chatEl.style.width = "calc(100% + 2px)";
                            } else if (botOnly) {
                                chatEl.style.height = "100%";
                                chatEl.style.width = "100%";
                            } else {
                                chatEl.style.height = "calc(100vh)";
                                chatEl.style.width = "calc(100% + 2px)";
                            }
                        },
                        bot_id: content?.bot_id,
                        packet_code: packetCode,
                        app_url: `https://${loadPath}/chat-client/index.html`,
                        service_address: servicePath
                    };
                };
                const el = document.createElement("script");
                el.async = true;
                el.src = `https://${loadPath}/chat-client/chat-loader.js`;
                if (window.document.body) window.document.body.appendChild(el);
            }
        }
    }, [
        content
    ]) //eslint-disable-line
    ;
    if (errorState) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
        style: {
            height: "100%",
            display: "flex",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            style: {
                alignSelf: "center"
            },
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c78618457328c948$exports))),
                        style: {
                            height: 350
                        }
                    })
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    style: {
                        textAlign: "center",
                        fontSize: 50,
                        color: "#b38cf7"
                    },
                    children: "Sorry!"
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    style: {
                        textAlign: "center",
                        fontSize: 22,
                        color: "#333"
                    },
                    children: "We couldn't find the page you were looking for."
                })
            ]
        })
    });
    if (botOnly) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
        className: "main",
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: phone ? "landing-container-phone" : "landing-container",
            children: [
                logoImage && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "landing-page-header",
                    style: {
                        cursor: useLogoUrl ? "pointer" : "default"
                    },
                    onClick: ()=>{
                        if (useLogoUrl && logoUrl) window.location.href = logoUrl;
                    },
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                        src: logoImage,
                        className: "logo",
                        style: {
                            maxHeight: 200,
                            maxWidth: 420
                        }
                    })
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    ref: chatClientRef,
                    style: {
                        width: phone ? "100%" : 600,
                        height: "100%"
                    }
                })
            ]
        })
    });
    if (loading) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $14fc2f3a09df08ae$exports.Fragment), {});
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: "main",
        style: {
            marginRight: phone ? 0 : 420
        },
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "pdfdoc",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "pdfdoc__container",
                    style: {
                        padding: phone ? 0 : null,
                        margin: phone ? 0 : null
                    },
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "pdfdoc__container__document",
                        style: {
                            padding: phone ? 0 : null,
                            margin: phone ? 0 : null
                        },
                        children: pdfContent ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("i", {
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $97a1f05fb7e6099a$export$2e2bcd8739ae039), {
                                file: pdfContent,
                                onLoadSuccess: ({ numPages: numPages })=>{
                                    setMaxPages(numPages);
                                },
                                children: Array.from(new Array(maxPages), (_, index)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $f6292e99e22e05e6$export$2e2bcd8739ae039), {
                                        renderTextLayer: true,
                                        width: width,
                                        pageNumber: index + 1
                                    }, `page_${index + 1}`))
                            })
                        }) : /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $14fc2f3a09df08ae$exports.Fragment), {
                            children: $6bb563e121d81d97$var$isPreview ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $14fc2f3a09df08ae$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                    style: {
                                        backgroundColor: "white",
                                        height: 700,
                                        width: 600,
                                        boxShadow: "0 0 8px rgba(0, 0, 0, 0.5)",
                                        padding: 20
                                    },
                                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                        style: {
                                            height: "100%",
                                            display: "flex",
                                            justifyContent: "center"
                                        },
                                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                            style: {
                                                display: "block",
                                                marginTop: "auto",
                                                marginBottom: "auto"
                                            },
                                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("h1", {
                                                children: [
                                                    "[",
                                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("i", {
                                                        children: " Upload your PDF "
                                                    }),
                                                    "]"
                                                ]
                                            })
                                        })
                                    })
                                })
                            }) : /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $14fc2f3a09df08ae$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                    style: {
                                        backgroundColor: "white",
                                        height: 1164,
                                        width: 900,
                                        boxShadow: "0 0 8px rgba(0, 0, 0, 0.5)",
                                        padding: 20
                                    },
                                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                        style: {
                                            height: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            border: "3px dotted #B3B3B3",
                                            borderRadius: 10
                                        },
                                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                            style: {
                                                display: "block",
                                                marginTop: "auto",
                                                marginBottom: "auto"
                                            },
                                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h1", {
                                                children: "[ No PDF Found ]"
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            }),
            !phone ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)($6bb563e121d81d97$var$BotSidebar, {
                chatClientRef: chatClientRef,
                logoImage: logoImage,
                useLogoUrl: useLogoUrl,
                logoUrl: logoUrl
            }) : /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $14fc2f3a09df08ae$exports.Fragment), {})
        ]
    });
}
var $6bb563e121d81d97$export$2e2bcd8739ae039 = $6bb563e121d81d97$var$App;


/*
import * as Sentry from '@sentry/browser'
let env = 'dev'
if (window.location.hostname === 'beta.chatfunnels.com') {
    env = 'beta'
} else if (window.location.hostname === 'app.chatfunnels.com') {
    env = 'prod'
}

Sentry.init({
    dsn: 'https://583456986bf54409aa75b2535277bfa9@o265885.ingest.sentry.io/5219986',
    environment: env,
    release: 'v1.4.11'
})
*/ (0, (/*@__PURE__*/$parcel$interopDefault($c4a08725a78d51bf$exports))).render(/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $6bb563e121d81d97$export$2e2bcd8739ae039), {}), document.getElementById("root")) // eslint-disable-line
;


//# sourceMappingURL=index.f79a0af1.js.map
